
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gXOst", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $eOaGc = parcelRequire("eOaGc");


var $aPdNQ = parcelRequire("aPdNQ");


var $5aU9U = parcelRequire("5aU9U");




class $002ebcda48d3a1ac$export$7ee2d944cdf187e1 extends (0, $5aU9U.Step) {
    invert(doc) {
        return new $002ebcda48d3a1ac$export$7ee2d944cdf187e1({
            inverted: true,
            from: this.from,
            to: this.to,
            mark: this.mark
        });
    }
    apply(doc) {
        return (0, $eOaGc.StepResult).ok(doc);
    }
    merge() {
        return null;
    }
    map(mapping) {
        const mappedFrom = mapping.mapResult(this.from, 1);
        const mappedTo = mapping.mapResult(this.to, 1);
        if (mappedFrom.deleted || mappedTo.deleted) return null;
        return new $002ebcda48d3a1ac$export$7ee2d944cdf187e1({
            inverted: this.inverted,
            from: mappedFrom.pos,
            to: mappedTo.pos
        });
    }
    getMap() {
        return new (0, $eOaGc.StepMap)([
            0,
            0,
            0
        ]);
    }
    toJSON() {
        // When serialized we should create a noop Replace step
        return {
            stepType: 'replace',
            from: 0,
            to: 0
        };
    }
    static fromJSON() {
        // This is a "local custom step" once serialized
        // we need to transform it in a no-operation action
        return new (0, $eOaGc.ReplaceStep)(0, 0, (0, $aPdNQ.Slice).empty);
    }
    static from(step) {
        const { mark: mark, from: from, to: to } = step;
        return new $002ebcda48d3a1ac$export$7ee2d944cdf187e1({
            mark: mark,
            from: from,
            to: to
        });
    }
    constructor({ inverted: inverted, from: from, to: to, mark: mark }){
        super();
        this.inverted = void 0;
        this.from = void 0;
        this.to = void 0;
        this.mark = void 0;
        this.inverted = Boolean(inverted);
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
}
class $002ebcda48d3a1ac$export$2a0a7f94dceaed30 extends (0, $5aU9U.Step) {
    invert(doc) {
        return new $002ebcda48d3a1ac$export$2a0a7f94dceaed30({
            inverted: true,
            pos: this.pos,
            mark: this.mark
        });
    }
    apply(doc) {
        return (0, $eOaGc.StepResult).ok(doc);
    }
    merge() {
        return null;
    }
    map(mapping) {
        const mappedPos = mapping.mapResult(this.pos, 1);
        if (mappedPos.deleted) return null;
        return new $002ebcda48d3a1ac$export$2a0a7f94dceaed30({
            inverted: this.inverted,
            pos: mappedPos.pos
        });
    }
    getMap() {
        return new (0, $eOaGc.StepMap)([
            0,
            0,
            0
        ]);
    }
    toJSON() {
        // When serialized we should create a noop Replace step
        return {
            stepType: 'replace',
            from: 0,
            to: 0
        };
    }
    static fromJSON() {
        // This is a "local custom step" once serialized
        // we need to transform it in a no-operation action
        return new (0, $eOaGc.ReplaceStep)(0, 0, (0, $aPdNQ.Slice).empty);
    }
    static from(step) {
        const { mark: mark, pos: pos } = step;
        return new $002ebcda48d3a1ac$export$2a0a7f94dceaed30({
            mark: mark,
            pos: pos
        });
    }
    constructor({ inverted: inverted, pos: pos, mark: mark }){
        super();
        this.inverted = void 0;
        this.pos = void 0;
        this.mark = void 0;
        this.inverted = Boolean(inverted);
        this.pos = pos;
        this.mark = mark;
    }
}


const $ac8be7093d42d0e1$var$createFilterStepsPlugin = (api)=>()=>new (0, $kpCD8.SafePlugin)({
            filterTransaction: (tr)=>{
                const mode = api?.editorViewMode?.sharedState.currentState()?.mode;
                if (mode !== 'view') return true;
                if (tr.getMeta('isRemote') || tr.getMeta('replaceDocument') || tr.getMeta('allowViewModeTransaction')) return true;
                const viewModeSteps = tr.steps.reduce((acc, s)=>{
                    if (s instanceof (0, $002ebcda48d3a1ac$export$2a0a7f94dceaed30) || s instanceof (0, $002ebcda48d3a1ac$export$7ee2d944cdf187e1)) acc.push(s);
                    return acc;
                }, []);
                if (viewModeSteps.length === 0 || !api) {
                    if (tr.docChanged && // Check if the transaction contains any steps that modify the document (view mode steps do not)
                    tr.steps.filter((s)=>s instanceof (0, $eOaGc.ReplaceAroundStep) || s instanceof (0, $eOaGc.ReplaceStep) || s instanceof (0, $eOaGc.AddMarkStep) || s instanceof (0, $eOaGc.AddNodeMarkStep) || s instanceof (0, $eOaGc.RemoveMarkStep) || s instanceof (0, $eOaGc.RemoveNodeMarkStep)).length) return false;
                    return true;
                }
                viewModeSteps.forEach((step)=>{
                    if (step.inverted || !step.mark) return;
                    if (step.mark.type.name === 'annotation') {
                        if (step instanceof (0, $002ebcda48d3a1ac$export$2a0a7f94dceaed30)) api.collabEdit?.actions.addInlineCommentNodeMark({
                            mark: step.mark,
                            pos: step.pos
                        });
                        else if (step instanceof (0, $002ebcda48d3a1ac$export$7ee2d944cdf187e1)) api.collabEdit?.actions.addInlineCommentMark({
                            mark: step.mark,
                            from: step.from,
                            to: step.to
                        });
                    }
                });
                // Ignored via go/ees007
                // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                // TODO: Follow-up and improve annotation logic so we can filter out transactions here
                return true;
            }
        });
const $ac8be7093d42d0e1$var$createReplaceDocumentTransactionPlugin = (api)=>()=>new (0, $kpCD8.SafePlugin)({
            // Shouldn't need explicit types but sometimes TS can't infer them so 🤷
            appendTransaction: (transactions, _oldState, newState)=>{
                if (!api) return;
                const isViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                if (!isViewMode) return;
                const remoteReplaceDocumentTransaction = transactions.find((tr)=>api.collabEdit?.actions?.isRemoteReplaceDocumentTransaction(tr));
                if (!remoteReplaceDocumentTransaction || !remoteReplaceDocumentTransaction.selectionSet) return;
                const doc = newState.doc;
                const nextTr = newState.tr;
                const emptySelection = new (0, $kCECX.TextSelection)(doc.resolve(0));
                nextTr.setSelection(emptySelection);
                return nextTr;
            }
        });
const $ac8be7093d42d0e1$export$d510e4d48c393847 = ({ api: api })=>({
        name: 'editorViewModeEffects',
        actions: {
            allowViewModeTransaction: (tr)=>{
                tr.setMeta('allowViewModeTransaction', true);
                return tr;
            },
            applyViewModeStepAt: (tr)=>{
                const marksSteps = tr.steps.reduce((acc, s)=>{
                    // Ignored via go/ees007
                    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                    // TODO: We probably want to check the RemoveMarkStep flow too.
                    if (s instanceof (0, $eOaGc.AddMarkStep) || s instanceof (0, $eOaGc.AddNodeMarkStep)) acc.push(s);
                    return acc;
                }, []);
                if (marksSteps.length === 0) return false;
                marksSteps.reverse().map((s)=>s instanceof (0, $eOaGc.AddNodeMarkStep) ? tr.step((0, $002ebcda48d3a1ac$export$2a0a7f94dceaed30).from(s)) : tr.step((0, $002ebcda48d3a1ac$export$7ee2d944cdf187e1).from(s)));
                return true;
            }
        },
        pmPlugins () {
            return [
                {
                    name: 'editorViewModeEffectsFilterSteps',
                    plugin: $ac8be7093d42d0e1$var$createFilterStepsPlugin(api)
                },
                {
                    name: 'editorViewModeEffectsReplaceDocumentTransaction',
                    plugin: $ac8be7093d42d0e1$var$createReplaceDocumentTransactionPlugin(api)
                }
            ];
        }
    });
module.exports["editorViewModeEffectsPlugin"] = $ac8be7093d42d0e1$export$d510e4d48c393847;

});

parcelRegister("e1OCV", function(module, exports) {

var $4RpM6 = parcelRequire("4RpM6");


var $1KOhB = parcelRequire("1KOhB");


var $ieeJu = parcelRequire("ieeJu");


var $kCECX = parcelRequire("kCECX");

const $275245620839e5f9$export$4d696a2f56515a41 = new (0, $kCECX.PluginKey)('limitedModePlugin');



var $krYZG = parcelRequire("krYZG");


var $kpCD8 = parcelRequire("kpCD8");


var $ac2Ms = parcelRequire("ac2Ms");


var $4o0zT = parcelRequire("4o0zT");


var $cha5E = parcelRequire("cha5E");



var $gMweA = parcelRequire("gMweA");

const $b4ae4caf75b00d26$export$4b4648e48515d3 = ({ onLatchCriteriaMet: onLatchCriteriaMet, policy: policy })=>{
    // One clock for the whole subsystem, so measured durations and the policy's windows agree.
    const now = policy.now;
    let observer;
    let destroyed = false;
    const handleEvaluation = (evaluation)=>{
        if (evaluation !== 'latched') return;
        // One-way latch: the policy will never evaluate again, so stop paying for the observers.
        teardownObservers();
        const details = policy.getLatchDetails();
        if (details) onLatchCriteriaMet(details);
    };
    function teardownObservers() {
        observer?.disconnect();
        observer = undefined;
    }
    if ((0, $gMweA.isPerformanceObserverLongTaskAvailable)()) try {
        observer = new PerformanceObserver((list)=>{
            for (const entry of list.getEntries()){
                if (policy.isLatched()) return;
                handleEvaluation(policy.recordLongTask(entry.duration));
            }
        });
        observer.observe({
            entryTypes: [
                'longtask'
            ]
        });
    } catch  {
        // `longtask` is unsupported in some browsers even when PerformanceObserver exists. The
        // latency criterion alone is still a valid trigger, so carry on without freeze detection.
        observer = undefined;
    }
    return {
        noteDocumentChange: ({ nodeSizeDelta: nodeSizeDelta, isDocumentReplaced: isDocumentReplaced })=>{
            if (destroyed || policy.isLatched()) return;
            if (isDocumentReplaced || policy.isBulkChange(nodeSizeDelta)) policy.suppress();
        },
        measureInput: ()=>{
            if (destroyed || policy.isLatched() || !(0, $gMweA.isPerformanceAPIAvailable)()) return;
            const start = now();
            // Runs after every handleTextInput and all resulting plugin work, but before paint — the
            // same measurement point frozen-editor uses, so the numbers are comparable to existing
            // SLOW_INPUT telemetry.
            requestAnimationFrame(()=>{
                if (destroyed || policy.isLatched()) return;
                handleEvaluation(policy.recordInputLatency(now() - start));
            });
        },
        destroy: ()=>{
            destroyed = true;
            teardownObservers();
        }
    };
};


function $1cd43be554c8be23$export$9c490b34b2f16a34(array) {
    const middle = Math.floor(array.length / 2);
    const sortedArray = [
        ...array
    ].sort((a, b)=>a - b);
    return array.length % 2 !== 0 ? sortedArray[middle] : (sortedArray[middle - 1] + sortedArray[middle]) / 2;
}





const $b07bae5e8193ad06$export$99f816f5d068516b = {
    warmUpMs: 10000,
    slowInputMs: 100,
    latencyWindowSize: 12,
    latencySlowSamplesRequired: 6,
    freezeTaskMs: 600,
    freezeTasksRequired: 3,
    freezeWindowMs: 30000,
    requiredConfirmations: 2,
    confirmationGapMs: 30000,
    bulkChangeNodeSize: 100,
    bulkChangeSuppressionMs: 2000,
    docSizeThreshold: 750000,
    nodeCountThreshold: 5000
};
class $b07bae5e8193ad06$export$288fa2e391880242 {
    /**
   * Whether limited mode should be on, for either reason. This is the verdict consumers act on.
   */ isBreached() {
        return this.documentBreached || this.latched;
    }
    /**
   * What the latch was based on, or `undefined` while un-latched. Intended for telemetry — nothing in
   * the decision reads it back.
   */ getLatchDetails() {
        return this.latchDetails;
    }
    /** Whether the runtime (device) criteria have latched. One-way, and never cleared. */ isLatched() {
        return this.latched;
    }
    /**
   * Latch the runtime reason directly, without accumulating evidence for it.
   *
   * The policy latches itself when its own criteria are met, so this exists for callers that have
   * already decided: the plugin replaying the detector's latch transaction, and dev tooling forcing
   * the state by hand. Idempotent, and one-way like every other route to `latched`.
   */ latch() {
        if (this.latched) return;
        this.latched = true;
        this.latchDetails = this.buildDetails('forced', undefined);
    }
    /** Whether the document currently breaches the thresholds. Can go back to false. */ isDocumentBreached() {
        return this.documentBreached;
    }
    /**
   * Evaluate the document reason against the size / node-count / legacy-content-macro thresholds.
   *
   * Walks the whole document, so the caller decides when it is worth paying for: `pm-plugins/main.ts`
   * calls this on load and on `replaceDocument` (e.g. live-to-live page navigation) only, never per
   * transaction. Editing therefore cannot turn the document reason on — a page that grows past the
   * thresholds mid-session is only re-judged the next time it loads — but replacement can still turn
   * it back off.
   */ evaluateDocument(doc) {
        this.documentBreached = (0, $ac2Ms.shouldEnableLimitedModeForDocument)(doc, {
            docSizeThreshold: this.config.docSizeThreshold,
            nodeCountThreshold: this.config.nodeCountThreshold
        });
    }
    /**
   * Whether a `doc.nodeSize` delta is large enough to be bulk work rather than typing. A keystroke
   * moves this by 1; a paste, a bulk replace or a document load moves it far more.
   */ isBulkChange(nodeSizeDelta) {
        return Math.abs(nodeSizeDelta) >= this.config.bulkChangeNodeSize;
    }
    /**
   * Discard signals for a window. Called for bulk work, which is expensive but transient and
   * self-limiting, so its cost must not be attributed to the device struggling.
   */ suppress() {
        if (this.latched) return;
        this.suppressedUntil = this.now() + this.config.bulkChangeSuppressionMs;
    }
    /**
   * Feed one keystroke's input latency (dispatch through to the next animation frame).
   */ recordInputLatency(durationMs) {
        if (!this.canRecord()) return 'ignored';
        const { slowInputMs: slowInputMs, latencyWindowSize: latencyWindowSize, latencySlowSamplesRequired: latencySlowSamplesRequired } = this.config;
        this.totalInputSamples += 1;
        if (durationMs > slowInputMs) {
            this.totalSlowInputs += 1;
            // Remembered even once the window rolls over, so the freeze criterion below can check that
            // the jank actually coincided with editing.
            this.lastSlowInputAt = this.now();
        }
        this.latencySamples.push(durationMs);
        if (this.latencySamples.length > latencyWindowSize) this.latencySamples.shift();
        if (this.latencySamples.length < latencyWindowSize) return 'recorded';
        const slowSamples = this.latencySamples.filter((sample)=>sample > slowInputMs).length;
        if (slowSamples < latencySlowSamplesRequired) return 'recorded';
        // Median rather than mean: a mean is dragged over the threshold by one or two outliers, which
        // is exactly the transient jank this policy is meant to ignore.
        const windowMedian = (0, $1cd43be554c8be23$export$9c490b34b2f16a34)(this.latencySamples);
        if (windowMedian <= slowInputMs) return 'recorded';
        return this.qualify('inputLatency', windowMedian);
    }
    /**
   * Feed one `longtask` PerformanceObserver entry.
   */ recordLongTask(durationMs) {
        if (!this.canRecord()) return 'ignored';
        const { freezeTaskMs: freezeTaskMs, freezeWindowMs: freezeWindowMs, freezeTasksRequired: freezeTasksRequired } = this.config;
        if (durationMs <= freezeTaskMs) return 'recorded';
        const now = this.now();
        this.totalFreezes += 1;
        this.freezeTimes.push(now);
        this.freezeTimes = this.freezeTimes.filter((time)=>now - time <= freezeWindowMs);
        if (this.freezeTimes.length < freezeTasksRequired) return 'recorded';
        // Corroboration. `longtask` is process-wide, so without this a busy background tab or an
        // unrelated app could latch an editor the user is typing in perfectly happily.
        if (this.lastSlowInputAt === undefined || now - this.lastSlowInputAt > freezeWindowMs) return 'recorded';
        return this.qualify('freeze');
    }
    canRecord() {
        if (this.latched) return false;
        const now = this.now();
        if (now - this.startedAt < this.config.warmUpMs) return false;
        return now >= this.suppressedUntil;
    }
    /** Snapshot of what the latch was based on. Called before the evidence buffers are cleared. */ buildDetails(reason, latencyMedianMs) {
        const now = this.now();
        return {
            reason: reason,
            firstWindowReason: this.firstWindowReason ?? reason,
            requiredConfirmations: this.config.requiredConfirmations,
            documentAlreadyBreached: this.documentBreached,
            msFromFirstWindow: this.firstQualifiedAt === undefined ? undefined : Math.round(now - this.firstQualifiedAt),
            latencyMedianMs: latencyMedianMs === undefined ? undefined : Math.round(latencyMedianMs),
            timeToLatchMs: Math.round(now - this.startedAt),
            totalInputSamples: this.totalInputSamples,
            totalSlowInputs: this.totalSlowInputs,
            totalFreezes: this.totalFreezes
        };
    }
    qualify(reason, latencyMedianMs) {
        const now = this.now();
        // Each qualifying window must be independent evidence, so the buffers are cleared rather than
        // left to re-trigger off the same samples on the very next keystroke.
        this.latencySamples = [];
        this.freezeTimes = [];
        // Too soon after the last counted window to be independent of it, so it earns no credit. The
        // buffers above are still cleared, which is what makes the run rebuild from scratch.
        if (this.lastQualifiedAt !== undefined && now - this.lastQualifiedAt < this.config.confirmationGapMs) return 'qualified';
        this.qualifiedWindows += 1;
        this.lastQualifiedAt = now;
        if (this.firstQualifiedAt === undefined) {
            this.firstQualifiedAt = now;
            this.firstWindowReason = reason;
        }
        if (this.qualifiedWindows < this.config.requiredConfirmations) return 'qualified';
        this.latched = true;
        this.latchDetails = this.buildDetails(reason, latencyMedianMs);
        return 'latched';
    }
    constructor({ now: now, config: config }){
        /** Public so the detector can read the tunables it needs rather than duplicating them. */ this.config = void 0;
        /** Public so the detector shares one clock with the policy. */ this.now = void 0;
        this.startedAt = void 0;
        this.latencySamples = [];
        this.freezeTimes = [];
        this.lastSlowInputAt = void 0;
        this.firstQualifiedAt = void 0;
        this.lastQualifiedAt = void 0;
        this.qualifiedWindows = 0;
        this.suppressedUntil = 0;
        this.latched = false;
        this.documentBreached = false;
        this.firstWindowReason = void 0;
        this.latchDetails = void 0;
        /** Cumulative for the session and never cleared, unlike the evidence buffers. */ this.totalInputSamples = 0;
        this.totalSlowInputs = 0;
        this.totalFreezes = 0;
        this.now = now;
        this.config = {
            ...$b07bae5e8193ad06$export$99f816f5d068516b,
            ...config
        };
        this.startedAt = now();
    }
}


/**
 * Hardware hints, reported with a latch so it can be correlated with device class.
 *
 * Telemetry only — the policy no longer takes the hardware into account when deciding, so this
 * exists to answer "which devices are latching" from the data rather than by assumption. Both hints
 * are optional (`deviceMemory` is Chromium-only) and are simply absent where unsupported.
 */ const $500762a81161d637$var$getDeviceHints = ()=>{
    if (typeof navigator === 'undefined') return {};
    const { hardwareConcurrency: hardwareConcurrency, deviceMemory: deviceMemory } = navigator;
    return {
        hardwareConcurrency: hardwareConcurrency,
        deviceMemoryGb: deviceMemory
    };
};
/** Control-arm state: the document decision alone, exactly as before the experiment. */ const $500762a81161d637$var$documentOnlyState = (doc)=>{
    const documentSizeBreachesThreshold = (0, $ac2Ms.shouldEnableLimitedModeForDocument)(doc);
    return {
        documentSizeBreachesThreshold: documentSizeBreachesThreshold,
        latchPolicyBreached: false,
        enabled: documentSizeBreachesThreshold
    };
};
/** Treatment-arm state: whatever the policy says, for both of its reasons. */ const $500762a81161d637$var$policyState = (policy)=>({
        documentSizeBreachesThreshold: policy.isDocumentBreached(),
        latchPolicyBreached: policy.isBreached(),
        enabled: policy.isBreached()
    });
const $500762a81161d637$export$ae829ec7b2625219 = (api, injectedPolicy)=>{
    let detector;
    let policy;
    if (injectedPolicy) policy = injectedPolicy;
    else if ((0, $4o0zT.isExperimentEnabled)('platform_editor_dynamic_limited_mode')) {
        const config = (0, $cha5E.expVal)('platform_editor_dynamic_limited_mode', 'policyConfig', {
            warmUpMs: 10000,
            slowInputMs: 100,
            latencyWindowSize: 12,
            latencySlowSamplesRequired: 6,
            freezeTaskMs: 600,
            freezeTasksRequired: 3,
            freezeWindowMs: 30000,
            requiredConfirmations: 2,
            confirmationGapMs: 30000,
            bulkChangeNodeSize: 100,
            bulkChangeSuppressionMs: 2000,
            docSizeThreshold: 750000,
            nodeCountThreshold: 5000
        });
        // Resolved once per editor rather than per transaction. When off, no policy is built and the
        // document decision runs inline exactly as it did before this experiment.
        policy = new (0, $b07bae5e8193ad06$export$288fa2e391880242)({
            now: ()=>performance.now(),
            config: config
        });
    }
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $275245620839e5f9$export$4d696a2f56515a41),
        props: {
            handleTextInput () {
                detector?.measureInput();
                // Never handle the input — this is measurement only.
                return false;
            }
        },
        view: (editorView)=>{
            // No policy means the experiment is off: no observers, no per-keystroke measurement.
            if (!policy) return {};
            const startedAt = performance.now();
            detector = (0, $b4ae4caf75b00d26$export$4b4648e48515d3)({
                policy: policy,
                onLatchCriteriaMet: (details)=>{
                    // Treatment arm only — the detector does not exist in control. See LimitedModeLatchedAEP.
                    //
                    // `details` is the policy's own snapshot of what it latched on, taken before it cleared
                    // its evidence buffers, so it reports the closing window rather than an empty one.
                    api?.analytics?.actions.fireAnalyticsEvent({
                        action: (0, $krYZG.ACTION).LIMITED_MODE_LATCHED,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
                        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                        attributes: {
                            latched: true,
                            reason: details.reason,
                            firstWindowReason: details.firstWindowReason,
                            requiredConfirmations: details.requiredConfirmations,
                            documentAlreadyBreached: details.documentAlreadyBreached,
                            msFromFirstWindow: details.msFromFirstWindow,
                            latencyMedianMs: details.latencyMedianMs,
                            totalInputSamples: details.totalInputSamples,
                            totalSlowInputs: details.totalSlowInputs,
                            totalFreezes: details.totalFreezes,
                            nodeSize: editorView.state.doc.nodeSize,
                            // Read at latch time rather than at construction: the hints are static, and this
                            // keeps every device fact in one place next to the decision it is compared against.
                            ...$500762a81161d637$var$getDeviceHints(),
                            // Measured from the plugin view starting, which is a little later than the policy's
                            // own `timeToLatchMs` (it starts at plugin construction).
                            timeToLatch: performance.now() - startedAt
                        }
                    });
                    // The policy already holds the latch; this transaction only prompts the plugin to
                    // re-read it, which is what notifies every consumer through shared state.
                    editorView.dispatch(editorView.state.tr.setMeta((0, $275245620839e5f9$export$4d696a2f56515a41), {
                        latchPolicyBreached: true
                    }));
                }
            });
            return {
                destroy: ()=>{
                    detector?.destroy();
                    detector = undefined;
                }
            };
        },
        state: {
            init (_config, editorState) {
                if (!policy) return $500762a81161d637$var$documentOnlyState(editorState.doc);
                policy.evaluateDocument(editorState.doc);
                return $500762a81161d637$var$policyState(policy);
            },
            apply: (tr, currentPluginState, oldState, _newState)=>{
                const documentReplaced = Boolean(tr.getMeta('replaceDocument'));
                if (!policy) {
                    // Control arm, unchanged: skip the traversal once already breached, but always re-check
                    // when the document is replaced (e.g. live-to-live page navigation).
                    if (currentPluginState.documentSizeBreachesThreshold && !documentReplaced) return currentPluginState;
                    return $500762a81161d637$var$documentOnlyState(tr.doc);
                }
                // The detector's latch arrives as a transaction so that plugin state stays a function of
                // the transaction stream rather than of when `apply` happens to read the policy. Dev
                // tooling dispatches the same meta to force limited mode by hand.
                if (tr.getMeta((0, $275245620839e5f9$export$4d696a2f56515a41))?.latchPolicyBreached) policy.latch();
                // Only on replacement, never on an ordinary edit: the check walks the whole document, so
                // running it per transaction is a full-document scan on every keystroke. The trade-off is
                // that a document editing its way past the thresholds is not noticed until it next loads.
                //
                // Deliberately not skipped when limited mode is already on. Replacement is the one moment
                // the document verdict can go *down* — live-to-live navigation onto a smaller page — so
                // skipping it there is what would strand limited mode on forever. It costs one walk per
                // page navigation, which is nothing next to the navigation itself.
                if (documentReplaced) policy.evaluateDocument(tr.doc);
                // Report bulk work so the policy can discount it. The policy decides what counts as bulk;
                // this only supplies the facts.
                //
                // Known gap: operations that are expensive but barely change document size — table
                // resize, drag-and-drop moves (delete + insert nets to ~0), type-ahead — are not
                // suppressed. `@atlaskit/insm` already tracks exactly these via `startHeavyTask`, but its
                // public facade does not expose `runningHeavyTasks`, so there is no way to read them from
                // here today. Closing that gap needs an accessor on the insm package.
                if (tr.docChanged) detector?.noteDocumentChange({
                    nodeSizeDelta: tr.doc.nodeSize - oldState.doc.nodeSize,
                    isDocumentReplaced: documentReplaced
                });
                const next = $500762a81161d637$var$policyState(policy);
                // Keep the previous object when nothing changed, so shared-state diffing stays cheap and
                // consumers are not notified for no reason.
                return next.enabled === currentPluginState.enabled && next.documentSizeBreachesThreshold === currentPluginState.documentSizeBreachesThreshold ? currentPluginState : next;
            }
        }
    });
};


const $637489692354cf19$export$9f825df6a9c9b35b = ({ api: api })=>{
    return {
        name: 'limitedMode',
        pmPlugins () {
            return [
                {
                    name: 'limitedModePlugin',
                    plugin: ()=>(0, $500762a81161d637$export$ae829ec7b2625219)(api)
                }
            ];
        },
        getSharedState (editorState) {
            if (editorState) return {
                get enabled () {
                    return (0, $275245620839e5f9$export$4d696a2f56515a41).getState(editorState)?.enabled ?? false;
                },
                limitedModePluginKey: $275245620839e5f9$export$4d696a2f56515a41
            };
            return {
                enabled: false,
                limitedModePluginKey: $275245620839e5f9$export$4d696a2f56515a41
            };
        },
        usePluginHook: ({ editorView: editorView })=>{
            (0, $1KOhB.usePluginStateEffect)(api, [
                'limitedMode'
            ], ({ limitedModeState: limitedModeState })=>{
                if ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) {
                    const isEnabled = limitedModeState?.enabled ?? false;
                    const nodeIdProvider = (0, $4RpM6.getNodeIdProvider)(editorView);
                    // When limited mode is enabled first time,
                    // We need to remove all existing data-node-anchor attributes
                    // And nodeIdProvider to limited mode to prevent adding data-node-anchor on new nodes
                    if (isEnabled && nodeIdProvider && !nodeIdProvider.isLimitedMode()) nodeIdProvider.setLimitedMode();
                }
            });
        }
    };
};
module.exports["limitedModePlugin"] = $637489692354cf19$export$9f825df6a9c9b35b;

});

parcelRegister("93ZX6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kpCD8 = parcelRequire("kpCD8");


var $hjuSl = parcelRequire("hjuSl");


var $kCECX = parcelRequire("kCECX");

const $e608c7972031ca0a$export$ef2bd08fc1b88107 = new (0, $kCECX.PluginKey)('aiSpeechToText');






var $3k5Tv = parcelRequire("3k5Tv");

// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Deprecated legacy public API.
/**
 * @deprecated
 */ var $4382e40fbdeb0b2c$export$1684d4fa8efc3301 = /*#__PURE__*/ function(VoiceDictationState) {
    VoiceDictationState["Initializing"] = "Initializing";
    VoiceDictationState["Uninitialized"] = "Uninitialized";
    VoiceDictationState["Unsupported"] = "Unsupported";
    VoiceDictationState["Recording"] = "Recording";
    VoiceDictationState["Stopped"] = "Stopped";
    VoiceDictationState["Error"] = "Error";
    return VoiceDictationState;
}({});
var $4382e40fbdeb0b2c$export$1ba6d610c872ae71 = /*#__PURE__*/ function(VoiceDictationStopReason) {
    VoiceDictationStopReason["StoppedAccepted"] = "STOPPED_ACCEPTED";
    VoiceDictationStopReason["StoppedRejected"] = "STOPPED_REJECTED";
    VoiceDictationStopReason["TimeoutAccepted"] = "TIMEOUT_ACCEPTED";
    return VoiceDictationStopReason;
}({});








class $258c7589868d87a6$export$9090fb60710493e4 {
    insertText(transcript, tr) {
        if (!transcript) return tr;
        const { selection: selection } = tr;
        let pos = selection.$head.pos;
        // set the initial position of the interim text and cache it
        if (this.interimTextFrom === null) this.interimTextFrom = pos;
        else pos = this.interimTextFrom;
        // Replace previous interim text atomically (or insert if none exists).
        // Using insertText(text, from, to) ensures ProseMirror places the cursor
        // at the end of the new text, avoiding dangling cursor positions.
        const replaceTo = this.interimTextFrom !== null && this.interimTextTo !== null ? this.interimTextTo : pos;
        tr.insertText(transcript, pos, replaceTo);
        this.interimTextTo = pos + transcript.length;
        tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, this.interimTextTo));
        return tr;
    }
    rejectTranscriptedText(tr) {
        const from = this.interimTextFrom;
        const to = this.interimTextTo;
        if (from === null || to === null) return tr;
        tr.delete(from, to);
        tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, from));
        this.disposeTranscriptedText();
        return tr;
    }
    disposeTranscriptedText() {
        this.interimTextFrom = null;
        this.interimTextTo = null;
    }
    constructor(interimTextFrom = null, interimTextTo = null){
        this.interimTextFrom = interimTextFrom;
        this.interimTextTo = interimTextTo;
    }
}


const $a991831695a51a72$export$5bd0207bc8bc9737 = ()=>{
    const prosemirrorInsertTextManager = (0, $cozmU.useRef)(new (0, $258c7589868d87a6$export$9090fb60710493e4)());
    const handleTranscriptUpdate = (0, $cozmU.useCallback)((transcript, tr)=>{
        return prosemirrorInsertTextManager.current.insertText(transcript, tr);
    }, []);
    const rejectTranscriptedText = (0, $cozmU.useCallback)((tr)=>{
        return prosemirrorInsertTextManager.current.rejectTranscriptedText(tr);
    }, []);
    const disposeTranscriptedText = (0, $cozmU.useCallback)(()=>{
        prosemirrorInsertTextManager.current.disposeTranscriptedText();
    }, []);
    return {
        handleTranscriptUpdate: handleTranscriptUpdate,
        rejectTranscriptedText: rejectTranscriptedText,
        disposeTranscriptedText: disposeTranscriptedText
    };
};






var $3U8XR = parcelRequire("3U8XR");


var $cFVPs = parcelRequire("cFVPs");


var $89QZA = parcelRequire("89QZA");


var $04429 = parcelRequire("04429");


const $734cc50e90d9d65a$export$35a6f2c29539ef8f = (result, action)=>{
    switch(action.type){
        case 'SET_INITIALIZING':
            return {
                state: (0, $4382e40fbdeb0b2c$export$1684d4fa8efc3301).Initializing,
                transcription: null
            };
        case 'SET_RECORDING':
            return {
                state: (0, $4382e40fbdeb0b2c$export$1684d4fa8efc3301).Recording,
                transcription: action.payload.transcription,
                chunkIndex: action.payload.chunkIndex
            };
        case 'SET_STOPPED':
            return {
                ...result,
                state: (0, $4382e40fbdeb0b2c$export$1684d4fa8efc3301).Stopped,
                stopReason: action.payload.stopReason
            };
        case 'SET_ERROR':
            return {
                ...result,
                state: (0, $4382e40fbdeb0b2c$export$1684d4fa8efc3301).Error,
                error: action.payload.error
            };
        default:
            return result;
    }
};



var $bLDEV = parcelRequire("bLDEV");

var $ba53528647b1cd0c$export$b1a2c42ac49f689c = /*#__PURE__*/ function(ConvoAIWebSocketServerMessageType) {
    ConvoAIWebSocketServerMessageType["TranscriptionResponseDelta"] = "transcription.response.delta";
    ConvoAIWebSocketServerMessageType["TranscriptionResponseCompleted"] = "transcription.response.completed";
    ConvoAIWebSocketServerMessageType["TranscriptionItemCreated"] = "transcription.item.created";
    ConvoAIWebSocketServerMessageType["TranscriptionSessionCreated"] = "transcription.session.created";
    return ConvoAIWebSocketServerMessageType;
}({});
var $ba53528647b1cd0c$export$533906f021c29dcb = /*#__PURE__*/ function(ConvoAIWebSocketClientMessageType) {
    ConvoAIWebSocketClientMessageType["AudioBufferAppend"] = "audio.buffer.append";
    ConvoAIWebSocketClientMessageType["AudioBufferCommit"] = "audio.buffer.commit";
    ConvoAIWebSocketClientMessageType["AudioSessionUpdate"] = "audio.session.update";
    return ConvoAIWebSocketClientMessageType;
}({});
class $ba53528647b1cd0c$export$843496a58dc19cce {
    updateTranscriptionConfig(instructions = `Transcribe speech to text. You may get wake words like 'Hey Rovo!' or 'Hey Atlassian!' or 'Rovo, '. Do not include the waking phrase at the beginning of transcription`, noise_detection = 'near_field', vad_type = 'semantic_vad', eagerness = 'medium', model = 'gpt-4o-transcribe', include = [
        'item.input_audio_transcription.logprobs'
    ]) {
        // `gpt-realtime-whisper` runs in OpenAI's GA Realtime API as a streaming
        // transcription-only session. Per the OpenAI Realtime VAD guide
        // (https://developers.openai.com/api/docs/guides/realtime-vad), whisper
        // requires `turn_detection` to be omitted or `null` — server VAD is
        // incompatible. Additionally, the `prompt` / `instructions` field is
        // not supported for whisper in GA Realtime, and the BE's gateway has
        // been verified to reject session updates that include those fields.
        //
        // `noise_detection` is also dropped because it implicitly relies on a
        // VAD pipeline. `include` is preserved so future consumers can opt in
        // to logprobs without re-plumbing.
        if (model === 'gpt-realtime-whisper') {
            this.socket.send(JSON.stringify({
                type: 'audio.session.update',
                model: model,
                include: include
            }));
            return;
        }
        this.socket.send(JSON.stringify({
            type: 'audio.session.update',
            model: model,
            include: include,
            vad_type: vad_type,
            eagerness: eagerness,
            instructions: instructions,
            noise_detection: noise_detection
        }));
    }
    sendAudio(audio) {
        this.socket.send(JSON.stringify({
            audio: audio,
            type: "audio.buffer.append"
        }));
    }
    commitAudio() {
        this.socket.send(JSON.stringify({
            type: "audio.buffer.commit"
        }));
    }
    connect() {
        return new Promise((resolve, reject)=>{
            this.socket.onopen = ()=>resolve(this);
            this.socket.onerror = (event)=>reject(event);
        });
    }
    disconnect() {
        this.socket?.close();
    }
    static create(cloudID, product, experience, onMessage) {
        const api = new $ba53528647b1cd0c$export$843496a58dc19cce(cloudID, product, experience, onMessage);
        return api.connect();
    }
    constructor(cloudID, product, experience, onMessage, websocketURI = (0, $bLDEV.getWebsocketURI)()){
        this.onMessage = onMessage;
        this.websocketURI = websocketURI;
        this.socket = void 0;
        this.onServerMessage = (event)=>{
            const data = JSON.parse(event.data);
            this.onMessage(data);
        };
        this.socket = new WebSocket(`${this.websocketURI}/wss/${cloudID}/ai-feature/audio/realtime-transcriptions?product=${product}&experience=${experience}`);
        this.socket.addEventListener('message', this.onServerMessage);
    }
}



var $78ai4 = parcelRequire("78ai4");


const $d562e193a34f1a02$var$getSupportedMimeType = ()=>{
    // Order of preference: webm (best for streaming), then mp4/aac (Safari)
    const mimeTypes = [
        'audio/webm;codecs=opus',
        'audio/webm',
        'audio/mp4',
        'audio/aac',
        'audio/ogg;codecs=opus'
    ];
    // Access MediaRecorder via window to avoid lint errors for unsupported browsers
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const MediaRecorderAPI = window.MediaRecorder;
    // Check if MediaRecorder.isTypeSupported exists (not available in older browsers)
    if (!MediaRecorderAPI || typeof MediaRecorderAPI.isTypeSupported !== 'function') return undefined;
    return mimeTypes.find((mimeType)=>MediaRecorderAPI.isTypeSupported(mimeType)) ?? undefined;
};
class $d562e193a34f1a02$export$b5efe1d364105d67 {
    async startRecording() {
        this.resetInMemoryState();
        this.onTranscription({
            type: 'SET_INITIALIZING'
        });
        await this.connectWebSocketConvoAIAPI();
        this.mediaStream = await navigator.mediaDevices.getUserMedia({
            audio: {
                sampleRate: this.sampleRate,
                echoCancellation: true,
                noiseSuppression: true,
                autoGainControl: true
            }
        });
        const mimeType = $d562e193a34f1a02$var$getSupportedMimeType();
        const mediaRecorderOptions = {
            audioBitsPerSecond: this.audioBitsPerSecond
        };
        if (mimeType) mediaRecorderOptions.mimeType = mimeType;
        // eslint-disable-next-line compat/compat
        this.mediaRecorder = new MediaRecorder(this.mediaStream, mediaRecorderOptions);
        this.mediaRecorder.start(this.timeSlice);
        this.mediaRecorder.addEventListener('dataavailable', this.onMediaRecorderDataAvailable);
        this.mediaRecorder.addEventListener('stop', this.onMediaRecorderStop);
        this.mediaRecorder.addEventListener('error', this.onMediaRecorderError);
        this.recordingTimeout = setTimeout(()=>{
            this.stopRecording((0, $4382e40fbdeb0b2c$export$1ba6d610c872ae71).TimeoutAccepted);
        }, this.maxRecordingDurationMs);
    }
    stopRecording(stopReason = (0, $4382e40fbdeb0b2c$export$1ba6d610c872ae71).StoppedAccepted) {
        this.insertEmptySpaceIntoTranscription();
        this.clearRecordingTimeout();
        this.onTrace?.({
            type: 'STOP_RECORDING',
            payload: {
                stopReason: stopReason
            }
        });
        this.isStopped = true;
        this.onTranscription({
            type: 'SET_STOPPED',
            payload: {
                stopReason: stopReason
            }
        });
        this.mediaRecorder?.stop();
    }
    async connectWebSocketConvoAIAPI() {
        try {
            this.onTrace?.({
                type: 'START_WEBSOCKET_CONNECTION'
            });
            this.convoAIWebSocketAPI = await (0, $ba53528647b1cd0c$export$843496a58dc19cce).create(this.cloudID, this.product, this.experience, this.onMessage);
            this.onTrace?.({
                type: 'WEBSOCKET_CONNECTION_SUCCESS'
            });
            if (!this.skipSessionUpdate) this.convoAIWebSocketAPI.updateTranscriptionConfig(undefined, undefined, this.vadType, this.eagerness, this.model);
        } catch (error) {
            this.onTranscription({
                type: 'SET_ERROR',
                payload: {
                    error: error instanceof Error ? error.message : 'Unknown error'
                }
            });
            this.onTrace?.({
                type: 'ERROR',
                payload: {
                    error: error instanceof Error ? error.message : 'Unknown error'
                }
            });
        }
    }
    insertEmptySpaceIntoTranscription() {
        if (this.transcription) {
            this.transcription = this.transcription + ' ';
            this.onTranscription({
                type: 'SET_RECORDING',
                payload: {
                    transcription: this.transcription,
                    chunkIndex: this.chunkIndex
                }
            });
        }
    }
    clearRecordingTimeout() {
        if (this.recordingTimeout) {
            clearTimeout(this.recordingTimeout);
            this.recordingTimeout = null;
        }
    }
    resetInMemoryState() {
        this.isStopped = false;
        this.chunkIndex = 0;
        this.createdItemChunkIndex = 0;
        this.sessionReadyDispatched = false;
        this.finalResponseListener = null;
        this.lastProcessedPosition = 0;
        this.processedChunksCountAfterLastCommit = 0;
        this.lastAudioChunkWasProcessed = false;
        this.transcription = null;
        this.audioChunks = [];
        this.clearRecordingTimeout();
    }
    constructor(options){
        this.audioChunks = [];
        this.lastProcessedPosition = 0;
        this.processedChunksCountAfterLastCommit = 0;
        this.convoAIWebSocketAPI = null;
        this.mediaStream = null;
        this.mediaRecorder = null;
        this.lastAudioChunkWasProcessed = false;
        this.recordingTimeout = null;
        this.transcription = null;
        this.chunkIndex = 0;
        this.createdItemChunkIndex = 0;
        this.sessionReadyDispatched = false;
        this.finalResponseListener = null;
        this.isStopped = false;
        this.cloudID = void 0;
        this.sampleRate = void 0;
        this.audioBitsPerSecond = void 0;
        this.timeSlice = void 0;
        this.maxRecordingDurationMs = void 0;
        this.product = void 0;
        this.experience = void 0;
        this.vadType = void 0;
        this.eagerness = void 0;
        this.model = void 0;
        this.skipSessionUpdate = void 0;
        this.onTrace = void 0;
        this.onTranscription = void 0;
        this.onMessage = (event)=>{
            switch(event.type){
                case (0, $ba53528647b1cd0c$export$b1a2c42ac49f689c).TranscriptionSessionCreated:
                    // Server has set up the transcription session and is ready to receive
                    // audio. Flip out of `Initializing` immediately so the loading state
                    // clears in ~hundreds of ms (vs waiting for the first delta which may
                    // not arrive for several seconds depending on server VAD silence
                    // thresholds and whether the user has started speaking yet).
                    if (!this.sessionReadyDispatched) {
                        this.sessionReadyDispatched = true;
                        this.onTranscription({
                            type: 'SET_RECORDING',
                            payload: {
                                transcription: '',
                                chunkIndex: 0
                            }
                        });
                    }
                    break;
                case (0, $ba53528647b1cd0c$export$b1a2c42ac49f689c).TranscriptionResponseDelta:
                    this.transcription = this.transcription !== null ? this.transcription + event.delta : event.delta;
                    this.chunkIndex++;
                    this.onTranscription({
                        type: 'SET_RECORDING',
                        payload: {
                            transcription: this.transcription,
                            chunkIndex: this.chunkIndex
                        }
                    });
                    break;
                case (0, $ba53528647b1cd0c$export$b1a2c42ac49f689c).TranscriptionResponseCompleted:
                    // Server has finalized an utterance. Insert a separator (single
                    // space) before the next utterance starts so that consecutive
                    // utterances don't visually fuse together in the rendered
                    // transcript (e.g. "EnglishOh." → "English Oh."). This is the
                    // only signal the gateway emits between utterances for
                    // gpt-realtime-whisper, where TranscriptionItemCreated does not
                    // fire.
                    // Only insert space if the session has not been stopped.
                    // If isStopped is true, stopRecording() has already been called and
                    // dispatching SET_RECORDING here would flip the UI back to listening
                    // after the user has explicitly stopped — causing the auto-resume bug.
                    if (!this.isStopped) this.insertEmptySpaceIntoTranscription();
                    // If we are in the middle of a graceful shutdown (`stopRecording`
                    // flushed remaining audio and is waiting for the server to
                    // finalize before closing), this signals "the server is done."
                    if (this.finalResponseListener) {
                        const listener = this.finalResponseListener;
                        this.finalResponseListener = null;
                        listener();
                    }
                    break;
                case (0, $ba53528647b1cd0c$export$b1a2c42ac49f689c).TranscriptionItemCreated:
                    this.createdItemChunkIndex++;
                    this.onTrace?.({
                        type: 'TRANSCRIPTION_ITEM_CREATED',
                        payload: {
                            createdItemChunkIndex: this.createdItemChunkIndex
                        }
                    });
                    this.insertEmptySpaceIntoTranscription();
                    break;
            }
        };
        this.onMediaRecorderStop = ()=>{
            this.mediaStream?.getTracks().forEach((track)=>track.stop());
            // Flush any in-flight audio bytes the data-available pipeline hadn't
            // yet committed, then give the server a brief window to finalize the
            // current utterance (emit response.completed) before tearing down the
            // WebSocket. Without this, the trailing N hundred milliseconds of
            // audio reach the server but get dropped because we close before the
            // final transcription.response.delta / response.completed are emitted.
            const api = this.convoAIWebSocketAPI;
            if (!api) return;
            try {
                api.commitAudio();
            } catch  {
                // commitAudio may throw if the socket has already closed; in that
                // case there is nothing more to wait for.
                api.disconnect();
                return;
            }
            const FINAL_RESPONSE_WAIT_MS = 2000;
            let settled = false;
            const finish = ()=>{
                if (settled) return;
                settled = true;
                this.finalResponseListener = null;
                api.disconnect();
            };
            this.finalResponseListener = finish;
            setTimeout(finish, FINAL_RESPONSE_WAIT_MS);
        };
        this.onMediaRecorderError = (event)=>{
            this.onTranscription({
                type: 'SET_ERROR',
                payload: {
                    error: event.message
                }
            });
            this.onTrace?.({
                type: 'ERROR',
                payload: {
                    error: event.message
                }
            });
        };
        this.onMediaRecorderDataAvailable = async (event)=>{
            this.audioChunks.push(event.data);
            try {
                const { audioString: audioString, newAudioEndPosition: newAudioEndPosition } = await (0, $78ai4.processAudioToTextWithPCM16)(this.audioChunks, this.lastProcessedPosition, this.sampleRate);
                this.lastProcessedPosition = newAudioEndPosition;
                if (audioString) {
                    this.lastAudioChunkWasProcessed = true;
                    this.processedChunksCountAfterLastCommit++;
                    this.convoAIWebSocketAPI?.sendAudio(audioString);
                } else if (audioString === null && this.lastAudioChunkWasProcessed) {
                    this.convoAIWebSocketAPI?.commitAudio();
                    this.processedChunksCountAfterLastCommit = 0;
                    this.lastAudioChunkWasProcessed = false;
                }
            } catch (error) {
                this.onTranscription({
                    type: 'SET_ERROR',
                    payload: {
                        error: error instanceof Error ? error.message : 'Unknown error'
                    }
                });
                this.onTrace?.({
                    type: 'ERROR',
                    payload: {
                        error: error instanceof Error ? error.message : 'Unknown error'
                    }
                });
            }
        };
        const { onTranscription: onTranscription, cloudID: cloudID, sampleRate: sampleRate = 24000, audioBitsPerSecond: audioBitsPerSecond = 16000, timeSlice: timeSlice = 1000, maxRecordingDurationMs: maxRecordingDurationMs = 60000, onTrace: onTrace, product: product = 'confluence', experience: experience = 'confluence-ai-first-creation', vadType: vadType, eagerness: eagerness, model: model, skipSessionUpdate: skipSessionUpdate = false } = options;
        this.onTranscription = onTranscription;
        this.cloudID = cloudID;
        this.sampleRate = sampleRate;
        this.audioBitsPerSecond = audioBitsPerSecond;
        this.timeSlice = timeSlice;
        this.maxRecordingDurationMs = maxRecordingDurationMs;
        this.onTrace = onTrace;
        this.product = product;
        this.experience = experience;
        this.vadType = vadType;
        this.eagerness = eagerness;
        this.model = model;
        this.skipSessionUpdate = skipSessionUpdate;
    }
}



const $d5990454569ae605$export$ba4cb2752281b87f = (onVoiceDictationUpdate, cloudID, { audioBitsPerSecond: audioBitsPerSecond = 16000, sampleRate: sampleRate = 24000, timeSlice: timeSlice = 1000, maxRecordingDurationMs: maxRecordingDurationMs = 60000, enableGhostText: enableGhostTextOption, product: product, experience: experience, vadType: vadType, eagerness: eagerness, model: model, skipSessionUpdate: skipSessionUpdate } = {})=>{
    const { sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId, isInSmartCreateFlow: isInSmartCreateFlow } = (0, $cozmU.useContext)((0, $89QZA.SharedFeaturesInstrumentationIdContext));
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultError: trackAIResultError, trackAIInteractionDismiss: trackAIInteractionDismiss, trackAIResultAction: trackAIResultAction, trackAIResultDiscarded: trackAIResultDiscarded } = (0, $cFVPs.useAIEventsInstrumentation)({
        product: 'platform',
        subproduct: 'platform',
        aiFeatureName: 'aiVoiceDictation',
        proactiveGeneratedAI: 0,
        userGeneratedAI: 1,
        enablePlatformEvents: true,
        additionalAttributes: {
            isLegacyVersion: true,
            productAttributionOverride: product ?? 'confluence',
            sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId,
            isInSmartCreateFlow: isInSmartCreateFlow
        }
    });
    const { start: start, success: success, startConnectionAttempt: startConnectionAttempt, successConnectionEstablished: successConnectionEstablished, reportTTFB: reportTTFB, reportRTT: reportRTT, failure: failure } = (0, $04429.useUFOStreamingExperience)('streaming-stt', 'ai-speech-to-text');
    const [result, dispatch] = (0, $cozmU.useReducer)((0, $734cc50e90d9d65a$export$35a6f2c29539ef8f), {
        state: (0, $4382e40fbdeb0b2c$export$1684d4fa8efc3301).Uninitialized,
        transcription: null
    });
    const trace = (0, $cozmU.useCallback)((action)=>{
        (0, $3U8XR.match)(action).with({
            type: 'START_WEBSOCKET_CONNECTION'
        }, ()=>{
            start();
            startConnectionAttempt();
        }).with({
            type: 'WEBSOCKET_CONNECTION_SUCCESS'
        }, ()=>{
            successConnectionEstablished();
        }).with({
            type: 'TRANSCRIPTION_ITEM_CREATED',
            payload: {
                createdItemChunkIndex: 1
            }
        }, ()=>{
            // Time to First Byte for first chunk
            reportTTFB();
        }).with({
            type: 'TRANSCRIPTION_ITEM_CREATED',
            payload: {
                createdItemChunkIndex: (0, $3U8XR.P).number
            }
        }, ({ payload: { createdItemChunkIndex: createdItemChunkIndex } })=>{
            // Round-trip time between received server messages
            reportRTT(createdItemChunkIndex);
        }).with({
            type: 'STOP_RECORDING'
        }, (stopAction)=>{
            success({
                metadata: {
                    stopReason: stopAction.payload.stopReason
                }
            });
        }).with({
            type: 'ERROR'
        }, (errorAction)=>{
            failure({
                metadata: {
                    error: errorAction.payload.error
                }
            });
        }).exhaustive();
    }, [
        reportRTT,
        reportTTFB,
        start,
        startConnectionAttempt,
        successConnectionEstablished,
        failure,
        success
    ]);
    const speechToTextManager = (0, $cozmU.useRef)(new (0, $d562e193a34f1a02$export$b5efe1d364105d67)({
        onTranscription: (action)=>dispatch(action),
        onTrace: (action)=>trace(action),
        cloudID: cloudID,
        sampleRate: sampleRate,
        audioBitsPerSecond: audioBitsPerSecond,
        timeSlice: timeSlice,
        maxRecordingDurationMs: maxRecordingDurationMs,
        product: product,
        experience: experience,
        vadType: vadType,
        eagerness: eagerness,
        model: model,
        skipSessionUpdate: skipSessionUpdate
    }));
    (0, $cozmU.useEffect)(()=>{
        onVoiceDictationUpdate(result);
    }, [
        result,
        onVoiceDictationUpdate
    ]);
    (0, $cozmU.useEffect)(()=>{
        (0, $3U8XR.match)(result).with({
            state: (0, $4382e40fbdeb0b2c$export$1684d4fa8efc3301).Initializing
        }, ()=>trackAIInteractionInit()).with({
            state: (0, $4382e40fbdeb0b2c$export$1684d4fa8efc3301).Recording,
            chunkIndex: 1
        }, ()=>trackAIResultView()).with({
            state: (0, $4382e40fbdeb0b2c$export$1684d4fa8efc3301).Stopped,
            stopReason: (0, $4382e40fbdeb0b2c$export$1ba6d610c872ae71).StoppedAccepted
        }, ()=>trackAIResultAction('STTAcceptedByUser')).with({
            state: (0, $4382e40fbdeb0b2c$export$1684d4fa8efc3301).Stopped,
            stopReason: (0, $4382e40fbdeb0b2c$export$1ba6d610c872ae71).StoppedRejected
        }, ()=>trackAIResultDiscarded('STTRejectedByUser')).with({
            state: (0, $4382e40fbdeb0b2c$export$1684d4fa8efc3301).Stopped,
            stopReason: (0, $4382e40fbdeb0b2c$export$1ba6d610c872ae71).TimeoutAccepted
        }, ()=>trackAIResultAction('STTAcceptedDueToTimeout')).with({
            state: (0, $4382e40fbdeb0b2c$export$1684d4fa8efc3301).Error
        }, (errorResult)=>trackAIResultError({
                aiErrorMessage: errorResult.error
            })).with((0, $3U8XR.P)._, ()=>{}).exhaustive();
    }, [
        result,
        trackAIInteractionInit,
        trackAIInteractionDismiss,
        trackAIResultView,
        trackAIResultError,
        trackAIResultAction,
        trackAIResultDiscarded
    ]);
    const startRecording = (0, $cozmU.useCallback)(()=>{
        speechToTextManager.current.startRecording();
    }, []);
    const stopRecording = (0, $cozmU.useCallback)((stopReason = (0, $4382e40fbdeb0b2c$export$1ba6d610c872ae71).StoppedAccepted)=>{
        speechToTextManager.current.stopRecording(stopReason);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        return ()=>stopRecording();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return [
        result,
        {
            startRecording: startRecording,
            stopRecording: stopRecording
        }
    ];
};






var $1sCHt = parcelRequire("1sCHt");


var $eh6Ml = parcelRequire("eh6Ml");

const $47e91d0d524ca808$export$7abe5c0eca305a26 = ({ onClick: onClick })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        shape: "circle",
        isTooltipDisabled: false,
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
                ...iconProps,
                label: ''
            }),
        appearance: "primary",
        label: "Accept",
        onClick: onClick
    });
};









var $l3wuH = parcelRequire("l3wuH");

const $aec5babce2cfe750$export$a27af6ac3487f513 = ({ onClick: onClick })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        shape: "circle",
        isTooltipDisabled: false,
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                ...iconProps,
                label: ''
            }),
        appearance: "subtle",
        onClick: onClick,
        label: "Reject"
    });
};



const $c9d69eeb89d1ca61$export$27e3d771cf5f0905 = ({ api: api, cloudId: cloudId })=>{
    const { isListening: isListening } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiSpeechToText'
    ], (states)=>({
            isListening: states.aiSpeechToTextState?.isListening ?? false
        }));
    const { handleTranscriptUpdate: handleTranscriptUpdate, rejectTranscriptedText: rejectTranscriptedText, disposeTranscriptedText: disposeTranscriptedText } = (0, $a991831695a51a72$export$5bd0207bc8bc9737)();
    const onVoiceDictationUpdate = (0, $cozmU.useCallback)((result)=>{
        switch(result.state){
            case (0, $4382e40fbdeb0b2c$export$1684d4fa8efc3301).Recording:
                if (!api?.core?.actions?.execute) return;
                api.core.actions.execute(({ tr: tr })=>handleTranscriptUpdate(result.transcription, tr));
                break;
            case (0, $4382e40fbdeb0b2c$export$1684d4fa8efc3301).Stopped:
                if (result.stopReason === (0, $4382e40fbdeb0b2c$export$1ba6d610c872ae71).TimeoutAccepted) {
                    disposeTranscriptedText();
                    api?.core.actions.execute(({ tr: tr })=>{
                        tr.setMeta((0, $e608c7972031ca0a$export$ef2bd08fc1b88107), {
                            isListening: false
                        });
                        return tr;
                    });
                }
                break;
            default:
                break;
        }
    }, [
        handleTranscriptUpdate,
        api,
        disposeTranscriptedText
    ]);
    const [, { startRecording: startRecording, stopRecording: stopRecording }] = (0, $d5990454569ae605$export$ba4cb2752281b87f)(onVoiceDictationUpdate, cloudId);
    const handleAccept = (0, $cozmU.useCallback)(()=>{
        disposeTranscriptedText();
        stopRecording((0, $4382e40fbdeb0b2c$export$1ba6d610c872ae71).StoppedAccepted);
        api?.core.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $e608c7972031ca0a$export$ef2bd08fc1b88107), {
                isListening: false
            });
            return tr;
        });
    }, [
        stopRecording,
        disposeTranscriptedText,
        api
    ]);
    const handleReject = (0, $cozmU.useCallback)(()=>{
        stopRecording((0, $4382e40fbdeb0b2c$export$1ba6d610c872ae71).StoppedRejected);
        api?.core.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $e608c7972031ca0a$export$ef2bd08fc1b88107), {
                isListening: false
            });
            return rejectTranscriptedText(tr);
        });
    }, [
        stopRecording,
        rejectTranscriptedText,
        api
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isListening) startRecording();
        else stopRecording();
    }, [
        isListening,
        startRecording,
        stopRecording
    ]);
    if (!isListening) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $47e91d0d524ca808$export$7abe5c0eca305a26), {
        onClick: handleAccept
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aec5babce2cfe750$export$a27af6ac3487f513), {
        onClick: handleReject
    }));
};


// This CLOUD_ID works only for internal usage and POC purposes. Do not use it in production or share it externally.
// TODO: We need to implement here a logic to get the current user's cloudId.
const $e314379a347b848a$var$CLOUD_ID_INTERNAL_USE_ONLY = 'a436116f-02ce-4520-8fbb-7301462a1674';
const $e314379a347b848a$var$EMPTY_STATE = {
    isListening: false,
    error: null
};
const $e314379a347b848a$export$8fc6b5430a555c3d = ({ api: api })=>{
    return {
        name: 'aiSpeechToText',
        getSharedState (editorState) {
            if (!editorState) return $e314379a347b848a$var$EMPTY_STATE;
            return (0, $e608c7972031ca0a$export$ef2bd08fc1b88107).getState(editorState) ?? $e314379a347b848a$var$EMPTY_STATE;
        },
        pmPlugins () {
            return [
                {
                    name: 'speechToText',
                    plugin: ()=>new (0, $kpCD8.SafePlugin)({
                            key: (0, $e608c7972031ca0a$export$ef2bd08fc1b88107),
                            state: {
                                init () {
                                    return $e314379a347b848a$var$EMPTY_STATE;
                                },
                                apply (tr, oldPluginState) {
                                    const meta = tr.getMeta((0, $e608c7972031ca0a$export$ef2bd08fc1b88107));
                                    if (meta) return {
                                        ...oldPluginState,
                                        ...meta
                                    };
                                    return oldPluginState;
                                }
                            }
                        })
                }
            ];
        },
        pluginsOptions: {
            quickInsert: ()=>[
                    {
                        id: 'aiSpeechToText',
                        title: 'Speech to text',
                        description: 'Dictate text using your voice',
                        priority: 600,
                        keywords: [
                            'speech',
                            'voice',
                            'dictation',
                            'microphone',
                            'audio',
                            'speak',
                            'stt'
                        ],
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hjuSl))), {
                                label: "AI Speech to Text"
                            }),
                        action: (insert)=>{
                            const tr = insert('');
                            return tr.setMeta((0, $e608c7972031ca0a$export$ef2bd08fc1b88107), {
                                isListening: true
                            });
                        }
                    }
                ]
        },
        contentComponent () {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c9d69eeb89d1ca61$export$27e3d771cf5f0905), {
                cloudId: $e314379a347b848a$var$CLOUD_ID_INTERNAL_USE_ONLY,
                api: api
            });
        }
    };
};
module.exports["aiSpeechToTextPlugin"] = $e314379a347b848a$export$8fc6b5430a555c3d;

});

parcelRegister("1sOYw", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $krYZG = parcelRequire("krYZG");


var $kRWx3 = parcelRequire("kRWx3");


var $4OhxS = parcelRequire("4OhxS");

var $gx3UZ = parcelRequire("gx3UZ");


var $4w5V7 = parcelRequire("4w5V7");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $kCECX = parcelRequire("kCECX");

const $7442d50be4fdd143$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('aiImageGenerationPlugin');


const $cb5f0a8f70a8cd87$export$f766031ad28e12e3 = 'OPEN_POPUP';
const $cb5f0a8f70a8cd87$export$1be3e111c71a5c61 = 'CLOSE_POPUP';
const $cb5f0a8f70a8cd87$var$setPopupMeta = ({ type: type, tr: tr })=>tr.setMeta((0, $7442d50be4fdd143$export$18d4026d1ea86bb1), {
        type: type
    });
const $cb5f0a8f70a8cd87$export$32885d2e40b7f4e1 = (tr)=>{
    return $cb5f0a8f70a8cd87$var$setPopupMeta({
        type: $cb5f0a8f70a8cd87$export$f766031ad28e12e3,
        tr: tr
    });
};
const $cb5f0a8f70a8cd87$export$ce1e1e9445fb8c72 = (tr)=>{
    return $cb5f0a8f70a8cd87$var$setPopupMeta({
        type: $cb5f0a8f70a8cd87$export$1be3e111c71a5c61,
        tr: tr
    });
};



var $kpCD8 = parcelRequire("kpCD8");


var $8nvEM = parcelRequire("8nvEM");



const $f7fd7856568eef65$export$330c1774242547b5 = 'data-ai-image-generation-anchor';
const $f7fd7856568eef65$var$ANCHOR_DECORATION_KEY = 'ai-image-generation-anchor';
const $f7fd7856568eef65$var$createAnchorWidget = (pos)=>(0, $8nvEM.Decoration).widget(pos, ()=>{
        const el = document.createElement('span');
        el.setAttribute($f7fd7856568eef65$export$330c1774242547b5, 'true');
        el.contentEditable = 'false';
        el.style.cssText = 'display: inline-block; width: 0; height: 0; vertical-align: baseline; pointer-events: none;';
        return el;
    }, {
        side: -1,
        key: $f7fd7856568eef65$var$ANCHOR_DECORATION_KEY
    });
const $f7fd7856568eef65$export$f99f3880a7ce1ed9 = ()=>{
    return new (0, $kpCD8.SafePlugin)({
        state: {
            init () {
                return {
                    isOpen: false,
                    decorations: (0, $8nvEM.DecorationSet).empty
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta((0, $7442d50be4fdd143$export$18d4026d1ea86bb1));
                const mappedDecorations = pluginState.decorations.map(tr.mapping, tr.doc);
                switch(meta?.type){
                    case 0, $cb5f0a8f70a8cd87$export$f766031ad28e12e3:
                        return {
                            isOpen: true,
                            decorations: (0, $8nvEM.DecorationSet).create(tr.doc, [
                                $f7fd7856568eef65$var$createAnchorWidget(tr.selection.from)
                            ])
                        };
                    case 0, $cb5f0a8f70a8cd87$export$1be3e111c71a5c61:
                        return {
                            isOpen: false,
                            decorations: (0, $8nvEM.DecorationSet).empty
                        };
                    default:
                        // If a doc edit destroyed the anchor position, auto-close so the
                        // popup can't render against a missing target.
                        if (pluginState.isOpen && mappedDecorations.find().length === 0) return {
                            isOpen: false,
                            decorations: (0, $8nvEM.DecorationSet).empty
                        };
                        return {
                            isOpen: pluginState.isOpen,
                            decorations: mappedDecorations
                        };
                }
            }
        },
        key: (0, $7442d50be4fdd143$export$18d4026d1ea86bb1),
        props: {
            decorations (state) {
                return (0, $7442d50be4fdd143$export$18d4026d1ea86bb1).getState(state)?.decorations;
            }
        }
    });
};



/* AIImageGenerationPopup.tsx generated by @compiled/babel-plugin v3.0.1 */ 



var $cozmU = parcelRequire("cozmU");





var $3k5Tv = parcelRequire("3k5Tv");





var $dfEnC = parcelRequire("dfEnC");

var $7XIuB = parcelRequire("7XIuB");

var $1nt6a = parcelRequire("1nt6a");


var $7Y8M5 = parcelRequire("7Y8M5");


var $iMnC5 = parcelRequire("iMnC5");

/* index.tsx generated by @compiled/babel-plugin v3.0.1 */ 






var $ad7Ou = parcelRequire("ad7Ou");


var $1sCHt = parcelRequire("1sCHt");


var $3vgx3 = parcelRequire("3vgx3");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");


var $jlRK6 = parcelRequire("jlRK6");


var $d7j1D = parcelRequire("d7j1D");


var $dVPAB = parcelRequire("dVPAB");


var $7Upsh = parcelRequire("7Upsh");


var $lK9Pz = parcelRequire("lK9Pz");


var $fKdaf = parcelRequire("fKdaf");


var $ifkCZ = parcelRequire("ifkCZ");


var $e6Dq9 = parcelRequire("e6Dq9");


var $4Kyof = parcelRequire("4Kyof");


var $hYOOW = parcelRequire("hYOOW");


var $f3DNZ = parcelRequire("f3DNZ");


var $jNalm = parcelRequire("jNalm");


var $d1HsG = parcelRequire("d1HsG");


var $aqPDM = parcelRequire("aqPDM");


var $BQuz7 = parcelRequire("BQuz7");


var $9OqiZ = parcelRequire("9OqiZ");


var $hGZx0 = parcelRequire("hGZx0");


var $4P0HA = parcelRequire("4P0HA");


var $21wWN = parcelRequire("21wWN");


var $f6cdQ = parcelRequire("f6cdQ");


var $a1ZzW = parcelRequire("a1ZzW");


var $i1t43 = parcelRequire("i1t43");


var $etoPX = parcelRequire("etoPX");




var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");





var $at1wf = parcelRequire("at1wf");


var $gH7sg = parcelRequire("gH7sg");

const $cfd34b07a7919a27$var$i18n = (0, $kSwu1.defineMessages)({
    createImageLabel: {
        id: "ai-image-generation.image-from-ai-generation.create-image-label",
        defaultMessage: "Create an image with Rovo"
    },
    rovoIconAlt: {
        id: "ai-image-generation.image-from-ai-generation.rovo-icon-alt",
        defaultMessage: "Rovo icon"
    },
    describeImagePrompt: {
        id: "ai-image-generation.image-from-ai-generation.describe-image-prompt",
        defaultMessage: "Describe an image to create"
    },
    describeImagePlaceholder: {
        id: "ai-image-generation.image-from-ai-generation.describe-image-placeholder",
        defaultMessage: "Describe what you'd like to see..."
    },
    generateImage: {
        id: "ai-image-generation.image-from-ai-generation.generate-image",
        defaultMessage: "Generate image"
    },
    pickStyleLabel: {
        id: "ai-image-generation.image-from-ai-generation.pick-style-label",
        defaultMessage: "Pick a style"
    },
    styleButtonLabel: {
        id: "ai-image-generation.image-from-ai-generation.styleButtonLabel",
        defaultMessage: "Style"
    },
    pickRatioLabel: {
        id: "ai-image-generation.image-from-ai-generation.pick-ratio-label",
        defaultMessage: "Ratio"
    },
    styleWatercolors: {
        id: "ai-image-generation.image-from-ai-generation.style-watercolors",
        defaultMessage: "Watercolors"
    },
    stylePhotoAuto: {
        id: "ai-image-generation.image-from-ai-generation.stylePhotoAuto",
        defaultMessage: "Photo (Auto)"
    },
    stylePhotoButton: {
        id: "ai-image-generation.image-from-ai-generation.stylePhotoButton",
        defaultMessage: "Photo"
    },
    styleSketch: {
        id: "ai-image-generation.image-from-ai-generation.style-sketch",
        defaultMessage: "Sketch"
    },
    styleThreeD: {
        id: "ai-image-generation.image-from-ai-generation.style-3d",
        defaultMessage: "3D"
    },
    aspectRatioLabel: {
        id: "ai-image-generation.image-from-ai-generation.aspect-ratio-label",
        defaultMessage: "Select a ratio"
    },
    aspectRatioAuto: {
        id: "ai-image-generation.image-from-ai-generation.aspect-ratio-auto-16-9",
        defaultMessage: "Auto 16:9"
    },
    aspectRatioLandscape: {
        id: "ai-image-generation.image-from-ai-generation.aspect-ratio-landscape",
        defaultMessage: "Landscape 3:2"
    },
    aspectRatioSquare: {
        id: "ai-image-generation.image-from-ai-generation.aspect-ratio-square",
        defaultMessage: "Square 1:1"
    },
    aspectRatioPortrait: {
        id: "ai-image-generation.image-from-ai-generation.aspect-ratio-portrait",
        defaultMessage: "Portrait 2:3"
    },
    aspectRatioNarrow: {
        id: "ai-image-generation.image-from-ai-generation.aspect-ratio-narrow",
        defaultMessage: "Narrow 9:16"
    },
    footerMessage: {
        id: "ai-image-generation.image-from-ai-generation.footer-message",
        defaultMessage: "Uses AI. Verify results."
    }
});
const $cfd34b07a7919a27$var$styles = {
    rovoIcon: "_39xV02ey7F _0jFU0Vey7F _2XsHFMFQfX _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    imagePromptContainer: "_0bjKvD8fU6 _3hxITi6wH8 _3vBAKH9r67 _2V7sgONvrM _2Y7lL45zaO _39xV02N91d _3iDTPbQ4SZ _0hPCNLDIqT _4xdlr0FlnN _37wbyuDIqT _0KLXrulfZc _46hvQm5zaO _0xmtko8HPE _43nrzT8HPE _2OUyjtETSP",
    stack: "_39xV02N91d _0aFT5vbt8w",
    actionsRow: "_39xV02N91d _3iDTPbQ4SZ _0hPCNLDIqT _17lj8pFQfX",
    styleButtonContainer: "_0GTcwR4F84",
    submitButtonContainer: "_0GTcwRIZbP",
    footer: "_1UtDYzKGUX _46hvQm2ADO _3iDTPbQ4SZ _37wbyuDIqT _43nrzTTUhv _0rIjykB0rP"
};
function $cfd34b07a7919a27$export$1d338a5d45615a0b({ mediaUploadCollection: mediaUploadCollection, closePopup: closePopup, onSubmit: onSubmit, insertMedia: insertMedia }) {
    const intl = (0, $kSwu1.useIntl)();
    const [selectedTheme, setSelectedTheme] = (0, $cozmU.useState)(null);
    const [selectedAspectRatio, setSelectedAspectRatio] = (0, $cozmU.useState)(null);
    const [isSubmitDisabled, setIsSubmitDisabled] = (0, $cozmU.useState)(true);
    const themeOptions = [
        {
            buttonLabel: intl.formatMessage($cfd34b07a7919a27$var$i18n.stylePhotoButton),
            label: intl.formatMessage($cfd34b07a7919a27$var$i18n.stylePhotoAuto),
            value: null
        },
        {
            buttonLabel: intl.formatMessage($cfd34b07a7919a27$var$i18n.styleThreeD),
            label: intl.formatMessage($cfd34b07a7919a27$var$i18n.styleThreeD),
            value: (0, $gH7sg.IMAGE_GENERATION_THEMES).threeD
        },
        {
            buttonLabel: intl.formatMessage($cfd34b07a7919a27$var$i18n.styleSketch),
            label: intl.formatMessage($cfd34b07a7919a27$var$i18n.styleSketch),
            value: (0, $gH7sg.IMAGE_GENERATION_THEMES).sketch
        },
        {
            buttonLabel: intl.formatMessage($cfd34b07a7919a27$var$i18n.styleWatercolors),
            label: intl.formatMessage($cfd34b07a7919a27$var$i18n.styleWatercolors),
            value: (0, $gH7sg.IMAGE_GENERATION_THEMES).watercolors
        }
    ];
    const aspectRatioOptions = [
        {
            label: intl.formatMessage($cfd34b07a7919a27$var$i18n.aspectRatioAuto),
            value: '16:9',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($BQuz7)))
        },
        {
            label: intl.formatMessage($cfd34b07a7919a27$var$i18n.aspectRatioLandscape),
            value: '3:2',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($aqPDM)))
        },
        {
            label: intl.formatMessage($cfd34b07a7919a27$var$i18n.aspectRatioSquare),
            value: '1:1',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($21wWN)))
        },
        {
            label: intl.formatMessage($cfd34b07a7919a27$var$i18n.aspectRatioPortrait),
            value: '2:3',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hGZx0)))
        },
        {
            label: intl.formatMessage($cfd34b07a7919a27$var$i18n.aspectRatioNarrow),
            value: '9:16',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($9OqiZ)))
        }
    ];
    const selectedAspectRatioOption = aspectRatioOptions.find((option)=>option.value === selectedAspectRatio?.value);
    const SelectedAspectRatioIcon = selectedAspectRatioOption?.icon ?? (0, (/*@__PURE__*/$parcel$interopDefault($BQuz7)));
    const aspectRatioButtonLabel = selectedAspectRatio?.value ?? intl.formatMessage($cfd34b07a7919a27$var$i18n.pickRatioLabel);
    const styleButtonLabel = selectedTheme?.buttonLabel ?? intl.formatMessage($cfd34b07a7919a27$var$i18n.styleButtonLabel);
    const textRef = (0, $cozmU.useRef)('');
    const textSerializerRef = (0, $cozmU.useRef)(null);
    const handleSubmit = (0, $cozmU.useCallback)((prompt)=>{
        if (!prompt.trim()) return;
        const aspectRatioToSend = selectedAspectRatio?.value ?? null;
        const imageStyleToSend = selectedTheme?.value ?? null;
        onSubmit(prompt, aspectRatioToSend, imageStyleToSend);
    }, [
        onSubmit,
        selectedAspectRatio,
        selectedTheme
    ]);
    const handleSubmitRef = (0, $cozmU.useRef)(handleSubmit);
    (0, $cozmU.useEffect)(()=>{
        handleSubmitRef.current = handleSubmit;
    }, [
        handleSubmit
    ]);
    const getTextSerializer = (0, $cozmU.useCallback)((editorView)=>{
        if (!textSerializerRef.current) textSerializerRef.current = (0, $at1wf.default).fromSchema(editorView.state.schema);
        return textSerializerRef.current;
    }, []);
    const onSave = (0, $cozmU.useCallback)((editorView)=>{
        const text = getTextSerializer(editorView).serializeFragment(editorView.state.doc.content);
        handleSubmitRef.current(text);
    }, [
        getTextSerializer
    ]);
    const handleEditorChange = (0, $cozmU.useCallback)((editorView)=>{
        const text = getTextSerializer(editorView).serializeFragment(editorView.state.doc.content);
        textRef.current = text;
        setIsSubmitDisabled(!text.trim());
    }, [
        getTextSerializer
    ]);
    const handleSubmitClick = (0, $cozmU.useCallback)(()=>{
        handleSubmit(textRef.current);
    }, [
        handleSubmit
    ]);
    const { preset: preset } = (0, $dVPAB.usePreset)((builder)=>builder.add([
            (0, $7Upsh.default),
            {}
        ]).add((0, $e6Dq9.compositionPlugin)).add((0, $4Kyof.focusPlugin)).add((0, $lK9Pz.betterTypeHistoryPlugin)).add([
            (0, $hYOOW.pastePlugin),
            {}
        ]).add((0, $ifkCZ.default)).add((0, $d1HsG.typeAheadPlugin)).add([
            (0, $f3DNZ.placeholderPlugin),
            {
                placeholder: intl.formatMessage($cfd34b07a7919a27$var$i18n.describeImagePlaceholder)
            }
        ]).add([
            (0, $fKdaf.blockTypePlugin),
            {
                allowBlockType: {
                    exclude: [
                        'heading',
                        'blockquote'
                    ]
                }
            }
        ]).add([
            (0, $jNalm.saveOnEnterPlugin),
            onSave
        ]), [
        onSave,
        intl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d7j1D.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cfd34b07a7919a27$var$styles.rovoIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
        appearance: "brand",
        size: "xsmall",
        label: intl.formatMessage($cfd34b07a7919a27$var$i18n.rovoIconAlt)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "bold"
    }, intl.formatMessage($cfd34b07a7919a27$var$i18n.createImageLabel)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cfd34b07a7919a27$var$styles.imagePromptContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cfd34b07a7919a27$var$styles.stack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jlRK6.ComposableEditor), {
        appearance: "chromeless",
        preset: preset,
        shouldFocus: true,
        onChange: handleEditorChange,
        assistiveLabel: intl.formatMessage($cfd34b07a7919a27$var$i18n.describeImagePlaceholder)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cfd34b07a7919a27$var$styles.actionsRow
    }, (0, $4o0zT.isExperimentEnabled)('editor-image-generation-styles-and-aspect-ratios') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cfd34b07a7919a27$var$styles.styleButtonContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        placement: "bottom-start",
        shouldRenderToParent: true,
        strategy: "absolute",
        zIndex: 9999,
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                ref: triggerRef,
                ...triggerProps,
                appearance: "subtle",
                spacing: "compact",
                "aria-label": intl.formatMessage($cfd34b07a7919a27$var$i18n.pickStyleLabel),
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($4P0HA))),
                testId: "image-generation-style-trigger"
            }, styleButtonLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, themeOptions.map((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            key: option.value,
            isSelected: selectedTheme?.value === option.value,
            onClick: ()=>setSelectedTheme((currentTheme)=>currentTheme?.value === option.value ? null : option)
        }, option.label))))), (0, $4o0zT.isExperimentEnabled)('editor-image-generation-styles-and-aspect-ratios') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        placement: "bottom-start",
        shouldRenderToParent: true,
        strategy: "absolute",
        zIndex: 9999,
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                ref: triggerRef,
                ...triggerProps,
                appearance: "subtle",
                spacing: "compact",
                "aria-label": intl.formatMessage($cfd34b07a7919a27$var$i18n.aspectRatioLabel),
                iconBefore: SelectedAspectRatioIcon,
                testId: "image-generation-aspect-ratio-trigger"
            }, aspectRatioButtonLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, aspectRatioOptions.map((option)=>{
        const OptionIcon = option.icon;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            key: option.value,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(OptionIcon, {
                label: "",
                size: "small"
            }),
            isSelected: selectedAspectRatio?.value === option.value,
            onClick: ()=>setSelectedAspectRatio((currentAspectRatio)=>currentAspectRatio?.value === option.value ? null : {
                        label: option.label,
                        value: option.value
                    })
        }, option.label);
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cfd34b07a7919a27$var$styles.submitButtonContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        testId: "image-generation-submit",
        appearance: "primary",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f6cdQ))),
        label: intl.formatMessage($cfd34b07a7919a27$var$i18n.generateImage),
        isDisabled: isSubmitDisabled,
        onClick: handleSubmitClick
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cfd34b07a7919a27$var$styles.footer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1ZzW))), {
        color: "currentColor",
        label: "",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        appearance: "subtle",
        href: "https://www.atlassian.com/trust/atlassian-intelligence",
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, intl.formatMessage($cfd34b07a7919a27$var$i18n.footerMessage)))))));
}




const $7bdf65bfe463f129$var$PopupWithListeners = (0, $1nt6a.default)((0, $7XIuB.default));
const $7bdf65bfe463f129$var$GENERATE_IMAGE_ENTRYPOINT = 'GenerateImageEntrypoint'; // Reuse the existing image-generation Remix upload/insert route; `aiFeatureName`
// and `remixSource` below distinguish this quick-insert entrypoint in analytics.
const $7bdf65bfe463f129$var$IMAGE_GENERATION_INTERACTION_SOURCE = 'remixModalFromMediaInserts';
const $7bdf65bfe463f129$var$styles = {
    wrapper: "_0bjKvDKxmn _1ANEUSzUZr _2fwxA5yL8i _2OUyjtFYNq _39xV02e9dk _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _0KLXruoI2d"
};
function $7bdf65bfe463f129$export$63fb1df4e3d7b0a7({ api: api, editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { mediaProvider: mediaProvider, isOpen: isOpen } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'media',
        'aiImageGeneration'
    ], (states)=>({
            mediaProvider: states.mediaState?.mediaProvider,
            isOpen: states.aiImageGenerationState?.isOpen
        }));
    const closePopup = (0, $cozmU.useCallback)(()=>{
        editorView.dispatch((0, $cb5f0a8f70a8cd87$export$ce1e1e9445fb8c72)(editorView.state.tr));
        editorView.focus();
    }, [
        editorView
    ]);
    const handleClickOutside = (0, $cozmU.useCallback)((event)=>{
        // When clicking a Select option, react-select removes the clicked
        // element from the DOM before this handler fires. The detached node
        // is no longer contained in the popup wrapper, so withOuterListeners
        // incorrectly treats it as an outside click. Skip closing when the
        // target has been disconnected from the document.
        const target = event.target;
        if (target && !target.isConnected) return;
        event.preventDefault();
        closePopup();
    }, [
        closePopup
    ]);
    const handleEscapeKeydown = (0, $cozmU.useCallback)((event)=>{
        event.preventDefault();
        closePopup();
    }, [
        closePopup
    ]);
    const handleSubmit = (0, $cozmU.useCallback)((prompt, aspectRatio, imageStyle)=>{
        closePopup();
        const cmd = api?.malleableUi?.commands.startRemixThinking({
            remixModalMetadata: {
                interactionSource: $7bdf65bfe463f129$var$IMAGE_GENERATION_INTERACTION_SOURCE,
                aiFeatureName: $7bdf65bfe463f129$var$GENERATE_IMAGE_ENTRYPOINT,
                userPrompt: prompt,
                aspectRatio: aspectRatio,
                imageStyle: imageStyle,
                dynamicUiType: 'image',
                remixSource: $7bdf65bfe463f129$var$GENERATE_IMAGE_ENTRYPOINT
            }
        });
        if (!cmd) return;
        api?.core.actions.execute(cmd);
    }, [
        api,
        closePopup
    ]);
    if (!isOpen || !mediaProvider) return null;
     // Anchor to the decoration widget that the PM plugin mounts at the caret
    // when the popup opens. The widget is an inline zero-width DOM node, so its
    // bounding rect is aligned with the caret even in center/right-aligned
    // paragraphs, layout columns, table cells, etc.
    const targetRef = editorView.dom.querySelector(`[${(0, $f7fd7856568eef65$export$330c1774242547b5)}]`); // Without a real anchor element Popper would position against the viewport
    // origin. Bail out instead of rendering a mis-placed popup — the next
    // transaction that mounts the widget (or closes the plugin) will re-render.
    if (!targetRef) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)($7bdf65bfe463f129$var$PopupWithListeners, {
        ariaLabel: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).aiImageGenerationPopupAriaLabel),
        offset: [
            0,
            12
        ],
        target: targetRef,
        zIndex: (0, $7Y8M5.akEditorFloatingDialogZIndex),
        fitHeight: 390,
        fitWidth: 340,
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        handleClickOutside: handleClickOutside,
        handleEscapeKeydown: handleEscapeKeydown,
        scrollableElement: popupsScrollableElement,
        preventOverflow: true,
        focusTrap: true,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dfEnC.PlainOutsideClickTargetRefContext).Consumer, {
            children: (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    ref: setOutsideClickTargetRef,
                    xcss: $7bdf65bfe463f129$var$styles.wrapper,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cfd34b07a7919a27$export$1d338a5d45615a0b), {
                        mediaUploadCollection: mediaProvider.uploadParams?.collection,
                        closePopup: closePopup,
                        onSubmit: handleSubmit
                    })
                })
        })
    });
}





parcelRequire("cozmU");





var $7SMXM = parcelRequire("7SMXM");


var $dCkbP = parcelRequire("dCkbP");


var $dXqu3 = parcelRequire("dXqu3");














var $I2MTF = parcelRequire("I2MTF");


var $9wgTc = parcelRequire("9wgTc");




const $e0a2848c152b66e4$export$1e00734580dbc90 = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { isOffline: isOffline } = (0, $9wgTc.useQuickInsertContext)();
    const title = formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).aiImageGeneration);
    const onSelect = (0, $cozmU.useCallback)(({ insert: insert })=>{
        const tr = insert('');
        api?.aiImageGeneration.commands.showAIImageGenerationPopup()({
            tr: tr
        });
        return tr;
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I2MTF.QuickInsertMenuItem), {
        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4w5V7))), {
            label: title,
            color: "currentColor"
        }),
        isDisabled: isOffline,
        onSelect: onSelect,
        title: title
    });
};


const $9ca4b0f3933bc21c$export$a46fb6731991a73b = ({ api: api, isImageGenerationEnabled: isImageGenerationEnabled })=>[
        {
            key: (0, $dCkbP.AI_IMAGE_GENERATION_MENU_ITEM).key,
            type: (0, $dCkbP.AI_IMAGE_GENERATION_MENU_ITEM).type,
            parents: [
                {
                    key: (0, $dCkbP.MEDIA_SECTION).key,
                    type: (0, $dCkbP.MEDIA_SECTION).type,
                    rank: (0, $dXqu3.MEDIA_SECTION_RANK)[(0, $dCkbP.AI_IMAGE_GENERATION_MENU_ITEM).key]
                }
            ],
            match: (0, $7SMXM.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).aiImageGenerationDescription),
                    keywords: [
                        'ai',
                        'generate',
                        'image',
                        'create',
                        'picture'
                    ],
                    title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).aiImageGeneration)
                })),
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $e0a2848c152b66e4$export$1e00734580dbc90), {
                    api: api
                }),
            isHidden: ()=>!isImageGenerationEnabled || !api?.malleableUi || !api?.media?.sharedState.currentState()?.mediaProvider
        }
    ];












const $05f8ceed867ab768$var$DEFAULT_ASPECT_RATIO = '16:9';
const $05f8ceed867ab768$var$PHOTO_AUTO_IMAGE_STYLE = 'Photo (Auto)';
function $05f8ceed867ab768$export$e25ea543915fb1a5({ closeMediaInsertPicker: closeMediaInsertPicker, dispatchAnalyticsEvent: dispatchAnalyticsEvent, mediaProvider: mediaProvider, api: api }) {
    const handleSubmit = (0, $cozmU.useCallback)((prompt, aspectRatio, imageStyle)=>{
        closeMediaInsertPicker();
        if (dispatchAnalyticsEvent) {
            const payload = {
                action: (0, $krYZG.ACTION).SUBMITTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).PICKER,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).PICKER_MEDIA,
                eventType: (0, $krYZG.EVENT_TYPE).UI,
                attributes: {
                    aiFeatureName: 'imageGenerationMediaInsert',
                    aspectRatio: aspectRatio?.trim() || $05f8ceed867ab768$var$DEFAULT_ASPECT_RATIO,
                    imageStyle: imageStyle ?? $05f8ceed867ab768$var$PHOTO_AUTO_IMAGE_STYLE
                }
            };
            dispatchAnalyticsEvent(payload);
        }
        const remixModalMetadata = {
            interactionSource: 'remixModalFromMediaInserts',
            aiFeatureName: 'imageGenerationMediaInsert',
            userPrompt: prompt,
            aspectRatio: aspectRatio,
            imageStyle: imageStyle,
            dynamicUiType: 'image',
            remixSource: 'mediaInsert',
            onCancel: ()=>{
                const cmd = api?.mediaInsert?.commands.showMediaInsertPopup();
                if (cmd) api?.core.actions.execute(cmd);
            }
        };
        const cmd = api?.malleableUi?.commands.startRemixThinking({
            remixModalMetadata: remixModalMetadata
        });
        if (!cmd) return;
        api?.core.actions.execute(cmd);
    }, [
        api,
        closeMediaInsertPicker,
        dispatchAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cfd34b07a7919a27$export$1d338a5d45615a0b), {
        mediaUploadCollection: mediaProvider.uploadParams?.collection,
        closePopup: closeMediaInsertPicker,
        onSubmit: handleSubmit
    });
}


/**
 * Renders the "Create" tab label using the same
 * `intl.formatMessage(...)` pattern that `MediaInsertPicker` uses for its
 * built-in `fileTabTitle` and `linkTabTitle` tabs. Defined at module scope so
 * the component reference is stable across renders.
 */ const $aab8c39652c434bb$var$GenerateTabLabel = ()=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: intl.formatMessage((0, $4OhxS.mediaInsertMessages).generateTabTitle)
    });
};
const $aab8c39652c434bb$export$961e3fbb53954d8c = ({ api: api, config: config })=>{
    // Register a "Create" tab on the media insert picker. This keeps
    // the public `editor-plugin-media-insert` package free of `@atlassian/*`
    // dependencies — it only knows about the registry interface, not about
    // AI image generation.
    const { isRemixHidden: isRemixHidden, isRovoLLMEnabled: isRovoLLMEnabled } = config ?? {
        isRemixHidden: true,
        isRovoLLMEnabled: false
    };
    const isRemixEnabled = isRovoLLMEnabled && (0, $anBbz.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true);
    const isRegisteredSlashCommandEnabled = (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command');
    if (isRegisteredSlashCommandEnabled) api?.uiControlRegistry?.actions.register((0, $9ca4b0f3933bc21c$export$a46fb6731991a73b)({
        api: api,
        isImageGenerationEnabled: (0, $ieeJu.expValEquals)('cc_page_experiences_editor_image_generation', 'isEnabled', true) && (0, $iDrrr.fg)('m0_editor_image_generation_exclusion')
    }));
    if ((0, $ieeJu.expValEquals)('cc_page_experiences_editor_image_generation', 'isEnabled', true) && api && !isRemixHidden && isRemixEnabled) api?.mediaInsert?.actions.registerInsertTab({
        key: 'ai-image-generation',
        label: /*#__PURE__*/ (0, $8aG6j.jsx)($aab8c39652c434bb$var$GenerateTabLabel, {}),
        ...(0, $4o0zT.isExperimentEnabled)('platform_editor_ai_image_generation_improvement_ex') && {
            rank: (0, $kRWx3.MEDIA_INSERT_TAB_RANK)[(0, $krYZG.MEDIA_INSERT_TAB).CREATE]
        },
        component: (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $05f8ceed867ab768$export$e25ea543915fb1a5), {
                closeMediaInsertPicker: props.closeMediaInsertPicker,
                dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
                insertMediaSingle: props.insertMediaSingle,
                mediaProvider: props.mediaProvider,
                api: api
            })
    });
    return {
        name: 'aiImageGeneration',
        pmPlugins () {
            return [
                {
                    name: 'aiImageGeneration',
                    plugin: ()=>(0, $f7fd7856568eef65$export$f99f3880a7ce1ed9)()
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return {
                isOpen: false
            };
            const state = (0, $7442d50be4fdd143$export$18d4026d1ea86bb1).getState(editorState);
            if (!state) return {
                isOpen: false
            };
            return {
                isOpen: state.isOpen
            };
        },
        commands: {
            showAIImageGenerationPopup: ()=>({ tr: tr })=>(0, $cb5f0a8f70a8cd87$export$32885d2e40b7f4e1)(tr)
        },
        contentComponent: ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement })=>{
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7bdf65bfe463f129$export$63fb1df4e3d7b0a7), {
                api: api,
                editorView: editorView,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement
            });
        },
        pluginsOptions: isRegisteredSlashCommandEnabled ? {} : {
            quickInsert: ({ formatMessage: formatMessage })=>{
                /**
         * expValEquals('cc_page_experiences_editor_image_generation', 'isEnabled', true) is for overall experiment
         *
         * fg('m0_editor_image_generation_exclusion') for features that's been hidden in M0. If this is not on
         * it should not show up in the quick insert.
         */ if (!(0, $ieeJu.expValEquals)('cc_page_experiences_editor_image_generation', 'isEnabled', true)) return [];
                if (!(0, $iDrrr.fg)('m0_editor_image_generation_exclusion')) return [];
                const title = formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).aiImageGeneration);
                return [
                    {
                        id: 'aiImageGeneration',
                        title: title,
                        description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).aiImageGenerationDescription),
                        priority: 500,
                        keywords: [
                            'ai',
                            'generate',
                            'image',
                            'create',
                            'picture'
                        ],
                        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4w5V7))), {
                                label: title,
                                color: "currentColor"
                            }),
                        isDisabledOffline: true,
                        action (insert) {
                            const tr = insert('');
                            api?.aiImageGeneration.commands.showAIImageGenerationPopup()({
                                tr: tr
                            });
                            return tr;
                        }
                    }
                ];
            }
        }
    };
};
module.exports["aiImageGenerationPlugin"] = $aab8c39652c434bb$export$961e3fbb53954d8c;

});

parcelRegister("axCbT", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $jbxiN = parcelRequire("jbxiN");


var $eRJEr = parcelRequire("eRJEr");


var $4o0zT = parcelRequire("4o0zT");




parcelRequire("cozmU");


var $8Dx7s = parcelRequire("8Dx7s");


var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $8nvEM = parcelRequire("8nvEM");





var $2pQiO = parcelRequire("2pQiO");

/* RemixPlaceholder.tsx generated by @compiled/babel-plugin v3.0.1 */ 


parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iHsYL = parcelRequire("iHsYL");


var $9ivsj = parcelRequire("9ivsj");

var $64ff43be3a1ab908$exports = {};
$64ff43be3a1ab908$exports = new URL("remix-animation-card-purple.8816882c.png", import.meta.url).toString();


var $d1e5fcd73aeb6479$exports = {};
$d1e5fcd73aeb6479$exports = JSON.parse("{\"layers\":[{\"nm\":\"title text\",\"ddd\":0,\"ty\":4,\"ind\":0,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[752,81.89]},{\"t\":11.81,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[752,81.89]},{\"t\":42.55,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[752,114.68]},{\"t\":330.01,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[752,111.89]},{\"t\":360,\"s\":[752,111.89]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":11.81,\"i\":{\"x\":[0.5],\"y\":[1]},\"o\":{\"x\":[0.5],\"y\":[0]},\"s\":[0]},{\"t\":42.55,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"nm\":\"Create an infographic\",\"ty\":\"gr\",\"it\":[{\"ty\":\"gr\",\"it\":[{\"nm\":\"C\",\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[2,-1.52],[3.07,0],[2.45,2.6],[0,4.51],[-2.46,2.64],[-4.01,0],[-2.19,-2.07],[-0.651,-2.29],[0,0],[1.07,0.8594],[1.54,0],[1.32,-1.52],[0,-3.41],[-1.3,-1.54],[-2.08,0],[-1.11,0.9766],[-0.4818,2.1]],\"o\":[[0,0],[-0.8594,3.12],[-2,1.52],[-3.8,0],[-2.45,-2.6],[0,-4.77],[2.46,-2.64],[3.5,0],[1.3,1.22],[0,0],[-0.3385,-1.48],[-1.07,-0.8594],[-2.12,0],[-1.32,1.52],[0,3.62],[1.3,1.54],[1.54,0],[1.11,-0.9766],[0,0]],\"v\":[[21.23,-10.53],[26.84,-8.75],[22.55,-1.79],[14.94,0.4883],[5.57,-3.41],[1.89,-14.06],[5.59,-25.17],[15.29,-29.12],[23.83,-26.02],[26.76,-20.74],[21.04,-19.38],[18.92,-22.89],[15,-24.18],[9.83,-21.89],[7.85,-14.49],[9.8,-6.76],[14.88,-4.45],[18.85,-5.92],[21.23,-10.53]]},\"a\":0}},{\"nm\":\"r\",\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[-0.6966,0.4427],[-0.8854,0],[-1.16,-0.6901],[0,0],[0.7943,0],[0.5339,-0.4232],[0.306,-1.11],[0,-3.53]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0.8724,-1.39],[0.6966,-0.4427],[1.25,0],[0,0],[-0.9245,-0.599],[-0.7682,0],[-0.5339,0.4232],[-0.306,1.11],[0,0]],\"v\":[[34.96,0],[29.47,0],[29.47,-20.74],[34.57,-20.74],[34.57,-17.79],[36.92,-20.55],[39.3,-21.21],[42.91,-20.18],[41.21,-15.39],[38.63,-16.29],[36.68,-15.65],[35.42,-13.36],[34.96,-6.41]]},\"a\":0}},{\"nm\":\"e\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[1.52,-1.05],[2.28,0],[1.73,2.36],[0,2.88],[-1.8,1.95],[-2.75,0],[-1.78,-2.04],[0.0781,-4.21],[0,0],[-0.8464,-0.9049],[-1.26,0],[-0.5859,0.4688],[-0.2995,1.04]],\"o\":[[0,0],[-0.7031,2.01],[-1.52,1.05],[-3.61,0],[-1.37,-1.89],[0,-3.44],[1.8,-1.95],[3.09,0],[1.78,2.04],[0,0],[0.0391,1.63],[0.8464,0.9049],[0.8594,0],[0.5859,-0.4688],[0,0]],\"v\":[[57.79,-6.6],[63.26,-5.68],[59.93,-1.1],[54.24,0.4688],[46.23,-3.07],[44.18,-10.21],[46.88,-18.29],[53.69,-21.21],[61,-18.15],[63.55,-8.79],[49.8,-8.79],[51.13,-4.99],[54.3,-3.63],[56.46,-4.34],[57.79,-6.6]]},\"a\":0}},{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0.7812,0.8268],[1.12,0],[0.7812,-0.8724],[-0.013,-1.5]],\"o\":[[-0.0391,-1.59],[-0.7812,-0.8268],[-1.2,0],[-0.7812,0.8724],[0,0]],\"v\":[[58.11,-12.15],[56.88,-15.77],[54.02,-17.01],[51.05,-15.7],[49.9,-12.15]]},\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"nm\":\"a\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[-1.37,0.9635],[-2.7,0],[-1.2,-0.5794],[-0.4883,-0.8919],[0,-2.38],[0,0],[-0.1758,-0.8659],[-0.4818,-0.9896],[0,0],[0.2083,0.7161],[0.0391,0.1042],[1.07,-0.4557],[1.21,0],[1.23,1.16],[0,1.77],[-0.5599,0.918],[-1.01,0.4883],[-1.9,0.3646],[-0.9896,0.4167],[0,0],[0.5208,0.4492],[1.45,0],[0.5469,-0.3841],[0.3385,-0.9635]],\"o\":[[0,0],[0.5599,-2.01],[1.37,-0.9635],[2.45,0],[1.2,0.5794],[0.4883,0.8919],[0,0],[0,1.82],[0.1758,0.8659],[0,0],[-0.1432,-0.3646],[-0.0911,-0.3255],[-0.9375,0.9115],[-1.07,0.4557],[-2.14,0],[-1.23,-1.16],[0,-1.17],[0.5599,-0.918],[1.01,-0.4883],[2.57,-0.4818],[0,0],[0,-1.05],[-0.5208,-0.4492],[-0.9766,0],[-0.5469,0.3841],[0,0]],\"v\":[[70.64,-14.41],[65.66,-15.31],[68.55,-19.77],[74.65,-21.21],[80.12,-20.34],[82.65,-18.13],[83.38,-13.22],[83.32,-6.82],[83.58,-2.78],[84.57,0],[79.14,0],[78.61,-1.62],[78.42,-2.27],[75.41,-0.2148],[71.99,0.4688],[66.94,-1.27],[65.1,-5.66],[65.94,-8.8],[68.29,-10.91],[72.66,-12.19],[77.99,-13.54],[77.99,-14.08],[77.21,-16.34],[74.26,-17.01],[71.97,-16.44],[70.64,-14.41]]},\"a\":0}},{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[1.52,-0.3255],[0.4688,-0.3125],[0,-0.7812],[-0.5729,-0.5599],[-0.8854,0],[-0.8984,0.651],[-0.2083,0.7161],[0,1.32]],\"o\":[[-0.7031,0.2344],[-1.52,0.3255],[-0.7161,0.5078],[0,0.7682],[0.5729,0.5599],[0.9896,0],[0.6641,-0.4948],[0.1432,-0.4688],[0,0]],\"v\":[[77.99,-9.96],[74.65,-9.12],[71.66,-8.16],[70.59,-6.23],[71.45,-4.24],[73.63,-3.4],[76.46,-4.38],[77.77,-6.19],[77.99,-8.87]]},\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"nm\":\"t\",\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[-0.0716,-0.2799],[-0.2539,-0.1823],[-0.3646,0],[-0.9635,0.3516],[0,0],[1.61,0],[0.7943,0.332],[0.3711,0.5273],[0.1432,0.8984],[0,1.94],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,1.69],[0.0716,0.2799],[0.2539,0.1823],[0.5078,0],[0,0],[-1.28,0.5469],[-0.9896,0],[-0.7943,-0.332],[-0.3711,-0.5273],[-0.1172,-0.638],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[96.95,-20.74],[96.95,-16.37],[93.2,-16.37],[93.2,-8.01],[93.31,-5.05],[93.8,-4.36],[94.73,-4.08],[96.93,-4.61],[97.4,-0.3516],[93.07,0.4688],[90.39,-0.0293],[88.64,-1.32],[87.87,-3.46],[87.7,-7.32],[87.7,-16.37],[85.18,-16.37],[85.18,-20.74],[87.7,-20.74],[87.7,-24.86],[93.2,-28.07],[93.2,-20.74]]},\"a\":0}},{\"nm\":\"e\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[1.52,-1.05],[2.28,0],[1.73,2.36],[0,2.88],[-1.8,1.95],[-2.75,0],[-1.78,-2.04],[0.0781,-4.21],[0,0],[-0.8464,-0.9049],[-1.26,0],[-0.5859,0.4688],[-0.2995,1.04]],\"o\":[[0,0],[-0.7031,2.01],[-1.52,1.05],[-3.61,0],[-1.37,-1.89],[0,-3.44],[1.8,-1.95],[3.09,0],[1.78,2.04],[0,0],[0.0391,1.63],[0.8464,0.9049],[0.8594,0],[0.5859,-0.4688],[0,0]],\"v\":[[112.29,-6.6],[117.75,-5.68],[114.42,-1.1],[108.73,0.4688],[100.72,-3.07],[98.67,-10.21],[101.37,-18.29],[108.18,-21.21],[115.49,-18.15],[118.05,-8.79],[104.3,-8.79],[105.62,-4.99],[108.79,-3.63],[110.96,-4.34],[112.29,-6.6]]},\"a\":0}},{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0.7812,0.8268],[1.12,0],[0.7812,-0.8724],[-0.013,-1.5]],\"o\":[[-0.0391,-1.59],[-0.7812,-0.8268],[-1.2,0],[-0.7812,0.8724],[0,0]],\"v\":[[112.6,-12.15],[111.37,-15.77],[108.52,-17.01],[105.55,-15.7],[104.39,-12.15]]},\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"nm\":\"a\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[-1.37,0.9635],[-2.7,0],[-1.2,-0.5794],[-0.4883,-0.8919],[0,-2.38],[0,0],[-0.1758,-0.8659],[-0.4818,-0.9896],[0,0],[0.2083,0.7161],[0.0391,0.1042],[1.07,-0.4557],[1.21,0],[1.23,1.16],[0,1.77],[-0.5599,0.918],[-1.01,0.4883],[-1.9,0.3646],[-0.9896,0.4167],[0,0],[0.5208,0.4492],[1.45,0],[0.5469,-0.3841],[0.3385,-0.9635]],\"o\":[[0,0],[0.5599,-2.01],[1.37,-0.9635],[2.45,0],[1.2,0.5794],[0.4883,0.8919],[0,0],[0,1.82],[0.1758,0.8659],[0,0],[-0.1432,-0.3646],[-0.0911,-0.3255],[-0.9375,0.9115],[-1.07,0.4557],[-2.14,0],[-1.23,-1.16],[0,-1.17],[0.5599,-0.918],[1.01,-0.4883],[2.57,-0.4818],[0,0],[0,-1.05],[-0.5208,-0.4492],[-0.9766,0],[-0.5469,0.3841],[0,0]],\"v\":[[136.25,-14.41],[131.27,-15.31],[134.16,-19.77],[140.25,-21.21],[145.72,-20.34],[148.25,-18.13],[148.98,-13.22],[148.93,-6.82],[149.19,-2.78],[150.18,0],[144.75,0],[144.22,-1.62],[144.02,-2.27],[141.02,-0.2148],[137.6,0.4688],[132.55,-1.27],[130.7,-5.66],[131.54,-8.8],[133.9,-10.91],[138.26,-12.19],[143.59,-13.54],[143.59,-14.08],[142.81,-16.34],[139.86,-17.01],[137.58,-16.44],[136.25,-14.41]]},\"a\":0}},{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[1.52,-0.3255],[0.4688,-0.3125],[0,-0.7812],[-0.5729,-0.5599],[-0.8854,0],[-0.8984,0.651],[-0.2083,0.7161],[0,1.32]],\"o\":[[-0.7031,0.2344],[-1.52,0.3255],[-0.7161,0.5078],[0,0.7682],[0.5729,0.5599],[0.9896,0],[0.6641,-0.4948],[0.1432,-0.4688],[0,0]],\"v\":[[143.59,-9.96],[140.25,-9.12],[137.27,-8.16],[136.19,-6.23],[137.05,-4.24],[139.24,-3.4],[142.07,-4.38],[143.38,-6.19],[143.59,-8.87]]},\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"nm\":\"n\",\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0.2344,0.6576],[0.5273,0.3646],[0.7422,0],[0.7552,-0.5208],[0.2799,-0.8594],[0,-2.32],[0,0],[0,0],[0,0],[0,0],[0,0],[-2.75,0],[-1,-0.4362],[-0.5143,-0.6771],[-0.2018,-0.8594],[0,-1.6]],\"o\":[[0,0],[0,0],[0,-2.24],[-0.2344,-0.6576],[-0.5273,-0.3646],[-0.9505,0],[-0.7552,0.5208],[-0.2799,0.8594],[0,0],[0,0],[0,0],[0,0],[0,0],[1.81,-2.34],[1.21,0],[1,0.4362],[0.5143,0.6771],[0.2018,0.8594],[0,0]],\"v\":[[171.91,0],[166.43,0],[166.43,-10.59],[166.07,-14.93],[164.93,-16.46],[163.03,-17.01],[160.47,-16.23],[158.92,-14.16],[158.5,-9.39],[158.5,0],[153.01,0],[153.01,-20.74],[158.11,-20.74],[158.11,-17.7],[164.94,-21.21],[168.26,-20.56],[170.54,-18.89],[171.61,-16.58],[171.91,-12.89]]},\"a\":0}},{\"nm\":\"i\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[185.9,-23.55],[185.9,-28.63],[191.39,-28.63],[191.39,-23.55]]},\"a\":0}},{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[185.9,0],[185.9,-20.74],[191.39,-20.74],[191.39,0]]},\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"nm\":\"n\",\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0.2344,0.6576],[0.5273,0.3646],[0.7422,0],[0.7552,-0.5208],[0.2799,-0.8594],[0,-2.32],[0,0],[0,0],[0,0],[0,0],[0,0],[-2.75,0],[-1,-0.4362],[-0.5143,-0.6771],[-0.2018,-0.8594],[0,-1.6]],\"o\":[[0,0],[0,0],[0,-2.24],[-0.2344,-0.6576],[-0.5273,-0.3646],[-0.9505,0],[-0.7552,0.5208],[-0.2799,0.8594],[0,0],[0,0],[0,0],[0,0],[0,0],[1.81,-2.34],[1.21,0],[1,0.4362],[0.5143,0.6771],[0.2018,0.8594],[0,0]],\"v\":[[213.12,0],[207.64,0],[207.64,-10.59],[207.29,-14.93],[206.14,-16.46],[204.24,-17.01],[201.68,-16.23],[200.13,-14.16],[199.71,-9.39],[199.71,0],[194.22,0],[194.22,-20.74],[199.32,-20.74],[199.32,-17.7],[206.15,-21.21],[209.47,-20.56],[211.75,-18.89],[212.82,-16.58],[213.12,-12.89]]},\"a\":0}},{\"nm\":\"f\",\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[-0.3711,0.8594],[-0.9961,0.5404],[-1.52,0],[-1.5,-0.4688],[0,0],[0.8073,0],[0.3451,-0.3711],[0,-1.05],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,-1.74],[0.3711,-0.8594],[0.9961,-0.5404],[1.56,0],[0,0],[-0.8724,-0.2083],[-0.7943,0],[-0.3451,0.3711],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[213.59,-20.74],[216.64,-20.74],[216.64,-22.3],[217.2,-26.21],[219.25,-28.31],[223.03,-29.12],[227.62,-28.42],[226.88,-24.59],[224.36,-24.9],[222.65,-24.35],[222.13,-22.21],[222.13,-20.74],[226.23,-20.74],[226.23,-16.43],[222.13,-16.43],[222.13,0],[216.64,0],[216.64,-16.43],[213.59,-16.43]]},\"a\":0}},{\"nm\":\"o\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[-0.8984,1.71],[-1.65,0.8984],[-2.03,0],[-2.01,-2.04],[0,-3.11],[2.02,-2.06],[3.07,0],[1.73,0.8594],[0.8984,1.66],[0,2.38]],\"o\":[[0,-1.82],[0.8984,-1.71],[1.65,-0.8984],[3.14,0],[2.01,2.04],[0,3.14],[-2.02,2.06],[-1.9,0],[-1.73,-0.8594],[-0.8984,-1.66],[0,0]],\"v\":[[229.22,-10.66],[230.57,-15.96],[234.38,-19.86],[239.9,-21.21],[247.62,-18.15],[250.62,-10.43],[247.59,-2.63],[239.94,0.4688],[234.5,-0.8203],[230.57,-4.6],[229.22,-10.66]]},\"a\":0}},{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[-0.9766,-1.09],[-1.43,0],[-0.9701,1.09],[0,2.08],[0.9701,1.09],[1.43,0],[0.9766,-1.09],[0,-2.06]],\"o\":[[0,2.06],[0.9766,1.09],[1.43,0],[0.9701,-1.09],[0,-2.03],[-0.9701,-1.09],[-1.43,0],[-0.9766,1.09],[0,0]],\"v\":[[234.84,-10.37],[236.31,-5.64],[239.92,-4],[243.53,-5.64],[244.98,-10.41],[243.53,-15.1],[239.92,-16.74],[236.31,-15.1],[234.84,-10.37]]},\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"nm\":\"g\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[-0.3776,-0.2734],[-1.12,0],[-0.7161,0.4297],[-0.2474,0.638],[0,1.22],[0,0],[2.5,0],[1.63,2.36],[0,2.77],[-1.67,1.84],[-2.49,0],[-1.67,-2.25],[0,0],[0,0],[0,0],[0.4036,-1.21],[0.7292,-0.6901],[1.22,-0.3906],[1.86,0],[1.47,1.2],[0,1.85],[-0.013,0.2604]],\"o\":[[0,0],[0.1042,0.7292],[0.5208,0.3906],[1.43,0],[0.4818,-0.2865],[0.1693,-0.4557],[0,0],[-1.64,2.24],[-2.79,0],[-1.28,-1.86],[0,-3.48],[1.67,-1.84],[2.57,0],[0,0],[0,0],[0,0],[0,2.45],[-0.4036,1.21],[-0.7292,0.6901],[-1.22,0.3906],[-3.52,0],[-1.47,-1.2],[0,-0.1823],[0,0]],\"v\":[[252.99,1.37],[259.26,2.13],[259.98,3.63],[262.44,4.22],[265.66,3.57],[266.76,2.19],[267.01,-0.332],[267.01,-3.36],[260.8,0],[254.18,-3.54],[252.27,-10.49],[254.78,-18.46],[261.02,-21.21],[267.36,-17.83],[267.36,-20.74],[272.5,-20.74],[272.5,-2.13],[271.89,3.36],[270.2,6.21],[267.28,7.83],[262.66,8.42],[255.18,6.61],[252.97,2.03],[252.99,1.37]]},\"a\":0}},{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[-0.8529,-1.02],[-1.25,0],[-0.9245,1.05],[0,2.06],[0.8854,1.04],[1.35,0],[0.8529,-1.02],[0,-2.1]],\"o\":[[0,2.2],[0.8529,1.02],[1.34,0],[0.9245,-1.05],[0,-2.15],[-0.8854,-1.04],[-1.32,0],[-0.8529,1.02],[0,0]],\"v\":[[257.89,-10.8],[259.17,-5.97],[262.32,-4.43],[265.72,-6.01],[267.11,-10.66],[265.78,-15.45],[262.42,-17.01],[259.17,-15.48],[257.89,-10.8]]},\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"nm\":\"r\",\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[-0.6966,0.4427],[-0.8854,0],[-1.16,-0.6901],[0,0],[0.7943,0],[0.5339,-0.4232],[0.306,-1.11],[0,-3.53]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0.8724,-1.39],[0.6966,-0.4427],[1.25,0],[0,0],[-0.9245,-0.599],[-0.7682,0],[-0.5339,0.4232],[-0.306,1.11],[0,0]],\"v\":[[280.62,0],[275.14,0],[275.14,-20.74],[280.23,-20.74],[280.23,-17.79],[282.59,-20.55],[284.96,-21.21],[288.57,-20.18],[286.88,-15.39],[284.3,-16.29],[282.34,-15.65],[281.08,-13.36],[280.62,-6.41]]},\"a\":0}},{\"nm\":\"a\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[-1.37,0.9635],[-2.7,0],[-1.2,-0.5794],[-0.4883,-0.8919],[0,-2.38],[0,0],[-0.1758,-0.8659],[-0.4818,-0.9896],[0,0],[0.2083,0.7161],[0.0391,0.1042],[1.07,-0.4557],[1.21,0],[1.23,1.16],[0,1.77],[-0.5599,0.918],[-1.01,0.4883],[-1.9,0.3646],[-0.9896,0.4167],[0,0],[0.5208,0.4492],[1.45,0],[0.5469,-0.3841],[0.3385,-0.9635]],\"o\":[[0,0],[0.5599,-2.01],[1.37,-0.9635],[2.45,0],[1.2,0.5794],[0.4883,0.8919],[0,0],[0,1.82],[0.1758,0.8659],[0,0],[-0.1432,-0.3646],[-0.0911,-0.3255],[-0.9375,0.9115],[-1.07,0.4557],[-2.14,0],[-1.23,-1.16],[0,-1.17],[0.5599,-0.918],[1.01,-0.4883],[2.57,-0.4818],[0,0],[0,-1.05],[-0.5208,-0.4492],[-0.9766,0],[-0.5469,0.3841],[0,0]],\"v\":[[295.55,-14.41],[290.57,-15.31],[293.46,-19.77],[299.55,-21.21],[305.02,-20.34],[307.55,-18.13],[308.28,-13.22],[308.22,-6.82],[308.49,-2.78],[309.47,0],[304.04,0],[303.52,-1.62],[303.32,-2.27],[300.31,-0.2148],[296.89,0.4688],[291.85,-1.27],[290,-5.66],[290.84,-8.8],[293.19,-10.91],[297.56,-12.19],[302.89,-13.54],[302.89,-14.08],[302.11,-16.34],[299.16,-17.01],[296.88,-16.44],[295.55,-14.41]]},\"a\":0}},{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[1.52,-0.3255],[0.4688,-0.3125],[0,-0.7812],[-0.5729,-0.5599],[-0.8854,0],[-0.8984,0.651],[-0.2083,0.7161],[0,1.32]],\"o\":[[-0.7031,0.2344],[-1.52,0.3255],[-0.7161,0.5078],[0,0.7682],[0.5729,0.5599],[0.9896,0],[0.6641,-0.4948],[0.1432,-0.4688],[0,0]],\"v\":[[302.89,-9.96],[299.55,-9.12],[296.56,-8.16],[295.49,-6.23],[296.35,-4.24],[298.54,-3.4],[301.37,-4.38],[302.68,-6.19],[302.89,-8.87]]},\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"nm\":\"p\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[-1.13,0.651],[-1.38,0],[-1.68,-1.89],[0,-3.37],[1.69,-1.92],[2.41,0],[0.931,0.4557],[1.03,1.11],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0.6641,-1.04],[1.13,-0.651],[2.41,0],[1.68,1.89],[0,3.46],[-1.69,1.92],[-1.15,0],[-0.931,-0.4557],[0,0],[0,0],[0,0]],\"v\":[[312.19,-20.74],[317.3,-20.74],[317.3,-17.7],[320,-20.23],[323.77,-21.21],[329.9,-18.38],[332.42,-10.49],[329.88,-2.41],[323.73,0.4688],[320.62,-0.2148],[317.68,-2.56],[317.68,7.89],[312.19,7.89]]},\"a\":0}},{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[-0.9245,-1.11],[-1.33,0],[-0.8464,1.02],[0,2.33],[0.8724,1.05],[1.29,0],[0.8854,-1.04],[0,-2.03]],\"o\":[[0,2.33],[0.9245,1.11],[1.28,0],[0.8464,-1.02],[0,-2.17],[-0.8724,-1.05],[-1.34,0],[-0.8854,1.04],[0,0]],\"v\":[[317.62,-10.72],[319,-5.56],[322.38,-3.89],[325.57,-5.42],[326.84,-10.45],[325.53,-15.29],[322.29,-16.88],[318.95,-15.32],[317.62,-10.72]]},\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"nm\":\"h\",\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[-2.46,0],[-1.02,-0.4688],[-0.5143,-0.7292],[-0.1888,-0.8854],[0,-1.86],[0,0],[0,0],[0,0],[0.2083,0.5859],[0.5273,0.3451],[0.7943,0],[0.7161,-0.4427],[0.332,-0.8919],[0,-1.74],[0,0],[0,0],[0,0]],\"o\":[[0,0],[1.77,-2.07],[1.26,0],[1.02,0.4688],[0.5143,0.7292],[0.1888,0.8854],[0,0],[0,0],[0,0],[0,-2.17],[-0.2083,-0.5859],[-0.5273,-0.3451],[-0.9115,0],[-0.7161,0.4427],[-0.332,0.8919],[0,0],[0,0],[0,0],[0,0]],\"v\":[[340.76,-28.63],[340.76,-18.11],[347.11,-21.21],[350.53,-20.51],[352.82,-18.71],[353.88,-16.29],[354.16,-12.17],[354.16,0],[348.67,0],[348.67,-10.96],[348.36,-15.1],[347.26,-16.49],[345.27,-17.01],[342.83,-16.35],[341.26,-14.35],[340.76,-10.39],[340.76,0],[335.27,0],[335.27,-28.63]]},\"a\":0}},{\"nm\":\"i\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[357.03,-23.55],[357.03,-28.63],[362.52,-28.63],[362.52,-23.55]]},\"a\":0}},{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[357.03,0],[357.03,-20.74],[362.52,-20.74],[362.52,0]]},\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"nm\":\"c\",\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0.6445,0.5469],[1.03,0],[0.8138,-0.944],[0,-2.21],[-0.8268,-1.02],[-1.39,0],[-0.6641,0.5924],[-0.2734,1.45],[0,0],[1.59,-1.26],[2.67,0],[1.8,1.91],[0,3.39],[-1.81,1.91],[-3.09,0],[-1.49,-1.09],[-0.651,-2.23]],\"o\":[[0,0],[-0.1823,-1.08],[-0.6445,-0.5469],[-1.37,0],[-0.8138,0.944],[0,2.46],[0.8268,1.02],[1.04,0],[0.6641,-0.5924],[0,0],[-0.5599,2.47],[-1.59,1.26],[-3.03,0],[-1.8,-1.91],[0,-3.42],[1.81,-1.91],[2.53,0],[1.49,1.09],[0,0]],\"v\":[[383.48,-14.61],[378.07,-13.63],[376.83,-16.07],[374.32,-16.89],[371.04,-15.48],[369.82,-10.74],[371.06,-5.53],[374.39,-4],[376.95,-4.89],[378.36,-7.95],[383.75,-7.03],[380.53,-1.43],[374.14,0.4688],[366.88,-2.4],[364.18,-10.35],[366.89,-18.35],[374.24,-21.21],[380.26,-19.58],[383.48,-14.61]]},\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}],\"__pyclass\":\"lottie.utils.font.FontShape\",\"_query\":\"/System/Library/Fonts/Supplemental/Arial Bold.ttf\",\"_size\":40,\"_justify\":0,\"_text\":\"Create an infographic\",\"_position\":[0,0]},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.1608,0.1647,0.1804,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"title icon\",\"ddd\":0,\"ty\":4,\"ind\":1,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[692,47.89]},{\"t\":11.81,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[692,47.89]},{\"t\":42.55,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[692,80.68]},{\"t\":330.01,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[692,77.89]},{\"t\":360,\"s\":[692,77.89]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":11.81,\"i\":{\"x\":[0.5],\"y\":[1]},\"o\":{\"x\":[0.5],\"y\":[0]},\"s\":[0]},{\"t\":42.55,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"nm\":\"Icon\",\"ty\":\"gr\",\"it\":[{\"nm\":\"Glyph\",\"ty\":\"gr\",\"it\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0.8884,-0.3241],[0,0],[0.1517,-0.4158],[0,0],[0.946,0],[0.3241,0.8884],[0,0],[0.4158,0.1516],[0,0],[0.1251,0.7995],[0,0],[0,0],[-0.7775,0.2836],[0,0],[-0.1517,0.4158],[0,0],[0,0],[-0.8263,0.0011],[0,0],[-0.3365,-0.6077],[0,0],[0,0],[-0.4158,-0.1517],[0,0],[0,-0.9451]],\"o\":[[0,0.9457],[0,0],[-0.4158,0.1516],[0,0],[-0.3239,0.8881],[-0.9457,0],[0,0],[-0.1517,-0.4158],[0,0],[-0.7779,-0.2838],[0,0],[0,0],[0.1251,-0.7999],[0,0],[0.4158,-0.1517],[0,0],[0,0],[0.3913,-0.7068],[0,0],[0.6865,0.1065],[0,0],[0,0],[0.1517,0.4158],[0,0],[0.8889,0.3242],[0,0]],\"v\":[[18,9.09],[16.52,11.21],[13.22,12.41],[12.32,13.31],[11.12,16.61],[9,18.09],[6.88,16.61],[5.68,13.31],[4.78,12.41],[1.48,11.21],[0.0264,9.44],[0,9.09],[0.0264,8.74],[1.48,6.98],[4.78,5.77],[5.68,4.88],[6.88,1.57],[7.03,1.25],[9,0.0908],[9.35,0.1172],[10.97,1.25],[11.12,1.57],[12.32,4.88],[13.22,5.77],[16.52,6.98],[18,9.09]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.1608,0.1647,0.1804,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0.8787,-0.8786],[0,0],[0,0],[0,0],[0,0],[0.2847,-0.3501],[0,0],[1.81,-0.0002],[0,0],[0,0],[0,0],[-0.2847,0.3501],[0,0],[-1.81,0.0002],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0.8787,0.8787],[0,0],[0,0],[0,0],[0,0],[-0.4513,0.0002],[0,0],[-1.14,1.4],[0,0],[0,0],[0,0],[0.4512,-0.0002],[0,0],[1.14,-1.4],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[47.34,7.5],[47.34,10.68],[39.84,18.18],[36.66,15],[40.32,11.34],[31.78,11.34],[30.62,11.89],[13.37,33.12],[8.72,35.34],[0,35.34],[0,30.84],[8.72,30.84],[9.88,30.29],[27.13,9.06],[31.78,6.84],[40.32,6.84],[36.66,3.18],[39.84,0],[47.34,7.5]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.1608,0.1647,0.1804,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,-0.5967],[0.422,-0.4219],[0,0],[0,0],[0,0],[0,0],[1.14,1.4],[0,0],[0,0],[0,0],[-0.4513,-0.0002],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0.422,0.422],[0,0.5968],[0,0],[0,0],[0,0],[0,0],[-1.81,-0.0002],[0,0],[0,0],[0,0],[0.2847,0.3501],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[47.34,30],[48,31.59],[47.34,33.18],[39.84,40.68],[36.66,37.5],[40.32,33.84],[31.78,33.84],[27.13,31.62],[23.76,27.47],[26.66,23.91],[30.62,28.79],[31.78,29.34],[40.32,29.34],[36.66,25.68],[39.84,22.5],[47.34,30]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.1608,0.1647,0.1804,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"Rectangle 1\",\"ddd\":0,\"ty\":4,\"ind\":2,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[471,53]},{\"t\":251.93,\"i\":{\"x\":[0.4],\"y\":[1.4]},\"o\":{\"x\":[0.7],\"y\":[-0.4]},\"s\":[471,53]},{\"t\":307.15,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1237,53]},{\"t\":326.7,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1177,53]},{\"t\":360,\"s\":[1177,53]}]},\"s\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100,100]},{\"t\":309.02,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[155.31,100]},{\"t\":326.7,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[129.7,100]},{\"t\":360,\"s\":[129.7,100]}]},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"nm\":\"Rectangle 1\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[22.18,0],[202,0],[183.12,89],[0,89],[22.18,0]]},\"a\":0}},{\"ty\":\"gf\",\"s\":{\"k\":[16.99,0],\"a\":0},\"e\":{\"k\":[190.59,20.8],\"a\":0},\"t\":1,\"h\":{\"k\":0,\"a\":0},\"a\":{\"k\":0,\"a\":0},\"g\":{\"k\":{\"k\":[0,1,1,1,0.3317,1,1,1,0.6875,1,1,1,1,1,1,1,0,0,0.3317,1,0.6875,1,1,0],\"a\":0},\"p\":4},\"o\":{\"k\":60,\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"h1 Header\",\"ddd\":0,\"ty\":4,\"ind\":3,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100,159.89]},{\"t\":94.21,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100,159.89]},{\"t\":117.36,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100,187.8]},{\"t\":330.01,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100,189.89]},{\"t\":360,\"s\":[100,189.89]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":94.21,\"i\":{\"x\":[0.275],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":117.36,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"nm\":\"h1 Header\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0.645,0.8906],[0.7371,0.6757],[1.41,-0.0922],[0.8292,-2.3],[-0.2457,-1.93],[-1.84,-2.36],[-4.39,-0.5528],[-3.26,0.6757],[-5.53,2.49],[-2.76,1.29],[-1.32,0.6449],[0,0],[0,0],[-0.1229,0.0614],[0,0],[0,0],[0,0],[-1.01,-0.1536],[-0.4607,-0.4606],[-0.4607,-0.6449],[-0.4606,-1.32],[-0.7064,-2.06],[-0.5221,-1.17],[-0.8292,-0.8906],[0,0],[-0.43,-0.3993],[-0.952,-0.5835],[-1.01,-0.3071],[-1.01,-0.1536],[-1.93,0.6142],[-0.7678,0.2764],[-0.6757,0.2764],[-3.9,2.46],[-2,1.35],[-2.3,1.54],[-4.33,3.04],[-4.51,3.26],[-0.369,-0.0614],[0,0],[0,0],[-0.584,0],[-1.01,-0.1535],[-0.921,-0.1843],[-2.4,-3.62],[-1.41,-2.49],[-2.7,-2.76],[-3.96,-0.9213],[-1.6,0.0921],[-0.798,0.0308],[-0.737,0.0922],[-3.35,1.35],[-1.87,0.86],[-2.03,1.23],[-7.83,5.99],[-0.522,0.3993],[0,0.0614],[-0.767,0.3072],[-1.32,0.0921],[-0.277,0.0307],[-0.092,-0.1228],[-0.185,-0.0922],[-0.215,-0.0615],[-2.12,-2.83],[-4.33,-3.01],[-1.17,-0.645],[-1.26,-0.4606],[-1.26,-0.1843],[0,0],[0,0],[-0.184,0],[0,0],[-4.02,0.8906],[-1.78,0.215],[-1.78,0.2457],[-14.62,-0.6757],[-13.48,-0.7064],[-6.91,-0.1536],[-13.27,1.72],[-3.16,0.5836],[-3.04,0.9521],[-5.68,2.46],[12.22,-2.58],[5.8,-0.9521],[3.04,-0.3071],[3.13,-0.1842],[15.82,0.3992],[12.53,1.38],[18.67,0.8906],[6.05,-0.2764],[3.41,-0.2764],[1.69,-0.1229],[1.75,-0.215],[3.47,-0.5221],[3.47,-0.5835],[3.38,-0.7678],[1.6,-0.3992],[-0.031,0],[0,0],[0.123,0.0307],[0,0],[1.47,1.32],[1.75,2.33],[3.07,2.58],[0.829,0.5528],[0.982,0.3378],[0.952,0.3071],[0.922,0.1536],[0.83,0],[0.768,-0.0307],[0.737,-0.0307],[0.645,-0.1228],[1.17,-0.2764],[0.952,-0.3378],[1.08,-0.3993],[0.829,-0.5835],[0.767,-0.5528],[0,0],[2.24,-1.54],[4.05,-2.52],[5.25,-2.03],[2.09,-0.1229],[0,0],[0.215,0],[0.338,0.0614],[0.738,0.7371],[2.12,3.47],[4.27,3.35],[4.91,0.5221],[2.27,-0.215],[1.07,-0.1843],[1.53,-0.215],[0.645,-0.4914],[0,0],[0,0],[1.41,-1.07],[2.67,-1.97],[4.24,-2.73],[4.33,-1.69],[0.4299,-0.1843],[0.1843,-0.0614],[0.3378,0.0307],[0.2457,0.5221],[0.0614,0.2457],[0.1842,0.6142],[0.7678,1.9],[3.22,2.18],[1.23,0.6449],[1.23,0.3685],[1.17,0.1535],[1.08,0.0614],[2,-0.1228],[0.9214,-0.1535],[0,0],[0.6757,-0.215],[0,0],[0,0],[0,0],[1.38,-0.7371],[2.52,-1.38],[4.36,-1.44],[1.38,0],[1.01,0.8293],[0,0]],\"o\":[[-0.6757,-0.645],[-0.7063,-0.8293],[-1.32,-1.44],[-1.41,0.0921],[-0.3378,1.2],[0.1536,1.84],[2.64,3.41],[4.24,0.5528],[6.39,-1.41],[2.67,-1.26],[1.32,-0.6142],[0,0],[0,0],[0.2457,-0.0921],[0,0],[0,0],[0,0],[1.2,0],[2.36,0],[0.3378,0.215],[0.43,0.7678],[0.4607,1.23],[0.3992,1.07],[0.6756,1.11],[0,0],[0.3992,0.43],[0.7985,0.8292],[0.9828,0.4914],[1.04,0.1535],[2.09,0],[0.9214,-0.2457],[0.6756,-0.2764],[5.16,-2.21],[1.9,-1.2],[2.06,-1.32],[3.9,-2.61],[4.24,-3.04],[0.307,-0.215],[0,0],[0,0],[0.615,-0.0921],[1.17,-0.0307],[1.1,0.0307],[3.69,1.01],[1.2,1.81],[1.41,2.46],[2.64,2.79],[1.84,0.3379],[0.829,0],[0.737,-0.0921],[5.71,-0.8599],[3.41,-1.32],[2.15,-1.07],[3.47,-2.3],[0.491,-0.3686],[0,0],[0.737,-0.2764],[1.9,-0.6756],[0.43,-0.1229],[0.215,0.0307],[0.123,0.0921],[0.153,0.1535],[0.952,0.6449],[2.15,2.76],[1.14,0.6757],[1.2,0.6142],[1.26,0.4914],[0,0],[0,0],[0.215,0],[0,0],[3.93,-0.8599],[1.69,-0.43],[1.78,-0.2457],[14.31,-1.81],[20.64,0.5528],[13.51,0.7678],[16.34,0.3378],[3.32,-0.4607],[3.16,-0.6449],[6.08,-1.78],[12.65,-4.94],[-5.56,1.41],[-2.89,0.5221],[-3.04,0.2457],[-12.62,0.6143],[-6.17,-0.1536],[-12.53,-1.32],[-6.05,-0.3378],[-3.29,0.2457],[-1.69,0.1229],[-1.72,0.1843],[-3.47,0.43],[-3.47,0.5835],[-3.47,0.4607],[-1.63,0.3992],[0,0],[0,0],[0,0],[0,0],[-1.96,-0.43],[-1.54,-1.23],[-1.81,-2.27],[-0.645,-0.6449],[-0.891,-0.5221],[-0.953,-0.3685],[-0.952,-0.3378],[-0.89,-0.1228],[-0.798,0.0307],[-0.767,0.0614],[-0.707,0.0921],[-1.26,0.3071],[-1.04,0.3685],[-1.2,0.43],[-0.952,0.6757],[-1.11,0.7678],[-1.54,1.07],[0,0],[-2.24,1.57],[-4.05,2.43],[-2.61,1.07],[0,0],[-0.215,-0.0307],[-0.461,0],[-0.614,-0.2457],[-1.47,-1.29],[-2.09,-3.44],[-4.24,-3.44],[-2.43,-0.215],[-1.14,0.0614],[-1.57,0.215],[-0.891,-0.0614],[0,0],[0,0],[-1.47,1.11],[-2.89,2.12],[-5.38,3.84],[-6.3,4.12],[-0.4607,0.1843],[-0.3379,0.1228],[-0.3685,0.0922],[-0.7064,-0.0307],[-0.1228,-0.2764],[-0.215,-0.6756],[-0.5221,-1.81],[-1.5,-3.87],[-1.17,-0.8599],[-1.23,-0.4607],[-1.17,-0.215],[-1.14,-0.1229],[-2.21,-0.1228],[-0.9214,0.1536],[0,0],[-0.5836,0.1229],[0,0],[0,0],[0,0],[-1.41,0.7371],[-2.64,1.44],[-4.94,2.67],[-2.12,0.7064],[-1.29,0.1228],[0,0],[0,0]],\"v\":[[12.29,28.56],[10.35,26.5],[8.29,24.11],[4.06,21.93],[0.4625,25.37],[0.0939,29.94],[3.04,36.89],[14.28,43.12],[25.12,42.54],[42.6,36.3],[50.74,32.46],[54.7,30.59],[56.6,29.76],[57.53,29.39],[57.71,29.33],[58.02,29.33],[58.94,29.18],[60.93,28.87],[64.56,28.75],[68.95,29.73],[70.09,30.93],[71.47,33.97],[73.07,38.73],[74.54,42.38],[76.51,45.61],[77.61,47.02],[78.9,48.22],[81.67,50.18],[84.71,51.32],[87.81,51.81],[93.83,51.1],[96.59,50.4],[98.65,49.57],[111.09,42.69],[116.95,38.88],[123.43,34.61],[135.78,26.07],[148.99,16.62],[150.06,16.22],[150.31,16.22],[151.17,16.12],[152.92,16.06],[156.23,16.15],[159.21,16.65],[167.41,23.13],[171.16,29.58],[176.96,37.62],[187.59,43.73],[193.06,44.35],[195.54,44.32],[197.76,44.04],[210.99,40.29],[218.73,36.82],[224.91,33.32],[242.6,20.82],[244.1,19.69],[244.1,19.62],[246.4,18.73],[251.59,17.54],[252.42,17.57],[253.04,17.63],[253.53,17.75],[254.08,18.06],[258.75,23.49],[268.12,32.92],[271.59,34.92],[275.3,36.36],[279.08,37.28],[281.6,37.68],[282.89,37.9],[283.5,37.99],[284.12,37.87],[296.04,35.23],[301.26,34.31],[306.57,33.57],[350.55,31.97],[401.68,34.52],[432.18,35.78],[476.25,33.48],[485.99,31.76],[495.32,29.73],[513.05,24.14],[509.98,13.48],[492.81,16.28],[483.87,17.2],[474.66,18],[432.55,18.55],[404.42,16.09],[357.67,11.98],[339.4,12.1],[329.36,12.9],[324.26,13.27],[319.07,13.88],[308.66,15.11],[298.25,16.86],[288.02,19.1],[283.17,20.27],[283.23,20.27],[283.07,20.27],[282.77,20.33],[281.94,20.21],[276.96,17.91],[272.23,12.59],[265.6,5.07],[263.2,3.32],[260.56,1.84],[257.71,0.7985],[254.94,0.2764],[252.27,0],[249.91,0.1228],[247.63,0.2764],[245.67,0.6757],[242.01,1.54],[239,2.58],[235.59,3.81],[232.89,5.71],[230.07,7.71],[227.7,9.37],[224.2,11.76],[214.65,17.97],[200.43,25.21],[193.03,27.03],[192.26,27.09],[191.65,27],[190.57,26.78],[188.7,25.55],[183.32,17.75],[174.08,6.73],[159.4,0.7985],[152.24,0.645],[148.86,0.9214],[144.19,1.57],[142.08,2.64],[140.11,4.12],[137.62,5.99],[133.29,9.28],[124.97,15.42],[110.41,25.43],[93.86,34.61],[92.48,35.13],[91.86,35.32],[90.79,35.41],[89.28,34.34],[88.97,33.54],[88.39,31.57],[86.46,25.8],[78.96,15.88],[75.28,13.76],[71.56,12.5],[68.03,11.92],[64.77,11.76],[58.75,12.13],[56.02,12.62],[54.61,12.87],[52.7,13.27],[50.86,14.04],[49.63,14.59],[47.33,15.69],[43.12,17.94],[35.38,22.17],[21.38,28.68],[15.7,29.82],[12.19,28.68],[12.29,28.56]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.4235,0.4353,0.4667,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"h1 description\",\"ddd\":0,\"ty\":4,\"ind\":4,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100,277.7]},{\"t\":105.3,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100,277.7]},{\"t\":129.02,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100,255.61]},{\"t\":330.01,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100,257.7]},{\"t\":360,\"s\":[100,257.7]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":105.3,\"i\":{\"x\":[0.275],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":129.02,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"nm\":\"h1 description\",\"ty\":\"gr\",\"it\":[{\"nm\":\"Vector_2\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0.332,0.4587],[0.379,0.348],[0.727,-0.0474],[0.427,-1.19],[-0.127,-0.9966],[-0.95,-1.22],[-2.26,-0.2847],[-1.68,0.348],[-2.85,1.28],[-1.42,0.6644],[-0.68,0.3322],[0,0],[0,0],[-0.064,0.0317],[0,0],[0,0],[0,0],[-0.522,-0.0791],[-0.237,-0.2373],[-0.238,-0.3322],[-0.238,-0.6802],[-0.364,-1.06],[-0.269,-0.6012],[-0.427,-0.4588],[0,0],[-0.222,-0.2057],[-0.491,-0.3005],[-0.522,-0.1582],[-0.522,-0.0791],[-0.997,0.3164],[-0.396,0.1423],[-0.348,0.1424],[-2.01,1.27],[-1.03,0.696],[-1.19,0.791],[-2.23,1.57],[-2.32,1.68],[-0.19,-0.0317],[0,0],[0,0],[-0.301,0],[-0.522,-0.0791],[-0.475,-0.0949],[-1.23,-1.87],[-0.728,-1.28],[-1.39,-1.42],[-2.04,-0.4746],[-0.823,0.0474],[-0.411,0.0158],[-0.38,0.0475],[-1.72,0.696],[-0.965,0.4429],[-1.04,0.6328],[-4.03,3.08],[-0.269,0.2057],[0,0.0316],[-0.395,0.1582],[-0.68,0.0474],[-0.142,0.0158],[-0.047,-0.0632],[-0.094,-0.0474],[-0.111,-0.0316],[-1.09,-1.46],[-2.23,-1.55],[-0.601,-0.3322],[-0.648,-0.2373],[-0.649,-0.0949],[0,0],[0,0],[-0.095,0],[0,0],[-2.07,0.4588],[-0.917,0.1108],[-0.917,0.1265],[-7.53,-0.348],[-6.95,-0.3639],[-3.56,-0.0791],[-6.83,0.8859],[-1.63,0.3006],[-1.57,0.4904],[-2.93,1.27],[6.3,-1.33],[2.99,-0.4904],[1.57,-0.1582],[1.61,-0.095],[8.15,0.2057],[6.45,0.7118],[9.62,0.4588],[3.12,-0.1424],[1.76,-0.1424],[0.87,-0.0633],[0.901,-0.1107],[1.79,-0.269],[1.79,-0.3006],[1.74,-0.3955],[0.823,-0.2057],[-0.016,0],[0,0],[0.064,0.0158],[0,0],[0.76,0.6802],[0.902,1.2],[1.58,1.33],[0.427,0.2848],[0.506,0.174],[0.49,0.1582],[0.475,0.0791],[0.427,0],[0.395,-0.0158],[0.38,-0.0158],[0.332,-0.0633],[0.601,-0.1424],[0.49,-0.1741],[0.554,-0.2056],[0.427,-0.3006],[0.395,-0.2848],[0,0],[1.16,-0.791],[2.09,-1.3],[2.7,-1.04],[1.07,-0.0633],[0,0],[0.111,0],[0.174,0.0317],[0.38,0.3796],[1.09,1.79],[2.2,1.72],[2.53,0.2689],[1.17,-0.1107],[0.554,-0.0949],[0.791,-0.1107],[0.332,-0.2531],[0,0],[0,0],[0.727,-0.5536],[1.38,-1.01],[2.18,-1.41],[2.23,-0.87],[0.221,-0.0949],[0.094,-0.0317],[0.174,0.0158],[0.126,0.269],[0.031,0.1266],[0.095,0.3164],[0.396,0.9808],[1.66,1.12],[0.633,0.3322],[0.633,0.1899],[0.601,0.0791],[0.554,0.0316],[1.03,-0.0633],[0.474,-0.0791],[0,0],[0.348,-0.1107],[0,0],[0,0],[0,0],[0.711,-0.3796],[1.3,-0.7119],[2.25,-0.7435],[0.712,0],[0.522,0.4271],[0,0]],\"o\":[[-0.348,-0.3322],[-0.364,-0.4272],[-0.681,-0.7435],[-0.728,0.0475],[-0.174,0.6169],[0.079,0.9492],[1.36,1.76],[2.18,0.2848],[3.29,-0.7277],[1.38,-0.6486],[0.68,-0.3164],[0,0],[0,0],[0.126,-0.0475],[0,0],[0,0],[0,0],[0.617,0],[1.22,0],[0.174,0.1107],[0.221,0.3955],[0.237,0.6328],[0.206,0.5537],[0.348,0.5694],[0,0],[0.206,0.2215],[0.411,0.4271],[0.506,0.2531],[0.538,0.0791],[1.08,0],[0.475,-0.1266],[0.348,-0.1424],[2.66,-1.14],[0.981,-0.617],[1.06,-0.6802],[2.01,-1.34],[2.18,-1.57],[0.158,-0.1107],[0,0],[0,0],[0.317,-0.0475],[0.601,-0.0159],[0.57,0.0158],[1.9,0.5221],[0.617,0.9333],[0.727,1.27],[1.36,1.44],[0.949,0.174],[0.427,0],[0.38,-0.0475],[2.94,-0.4429],[1.76,-0.6803],[1.11,-0.5537],[1.79,-1.19],[0.253,-0.1898],[0,0],[0.38,-0.1424],[0.981,-0.348],[0.221,-0.0633],[0.111,0.0158],[0.064,0.0475],[0.08,0.0791],[0.491,0.3322],[1.11,1.42],[0.585,0.348],[0.617,0.3164],[0.649,0.2531],[0,0],[0,0],[0.11,0],[0,0],[2.02,-0.4429],[0.87,-0.2215],[0.918,-0.1265],[7.37,-0.9334],[10.63,0.2847],[6.96,0.3954],[8.42,0.1741],[1.71,-0.2373],[1.63,-0.3322],[3.13,-0.9175],[6.52,-2.55],[-2.86,0.7277],[-1.49,0.2689],[-1.57,0.1265],[-6.5,0.3163],[-3.18,-0.0791],[-6.45,-0.6802],[-3.12,-0.174],[-1.69,0.1265],[-0.87,0.0633],[-0.886,0.0949],[-1.79,0.2215],[-1.79,0.3005],[-1.79,0.2372],[-0.838,0.2056],[0,0],[0,0],[0,0],[0,0],[-1.01,-0.2214],[-0.79,-0.6328],[-0.933,-1.17],[-0.332,-0.3322],[-0.459,-0.2689],[-0.49,-0.1898],[-0.491,-0.174],[-0.459,-0.0633],[-0.411,0.0158],[-0.396,0.0316],[-0.364,0.0475],[-0.649,0.1582],[-0.538,0.1898],[-0.617,0.2214],[-0.49,0.348],[-0.569,0.3955],[-0.791,0.5536],[0,0],[-1.15,0.8068],[-2.09,1.25],[-1.34,0.5536],[0,0],[-0.11,-0.0158],[-0.237,0],[-0.316,-0.1265],[-0.759,-0.6644],[-1.08,-1.77],[-2.18,-1.77],[-1.25,-0.1107],[-0.585,0.0316],[-0.807,0.1107],[-0.458,-0.0316],[0,0],[0,0],[-0.759,0.5695],[-1.49,1.09],[-2.77,1.98],[-3.24,2.12],[-0.238,0.0949],[-0.174,0.0633],[-0.19,0.0474],[-0.364,-0.0158],[-0.064,-0.1423],[-0.111,-0.348],[-0.269,-0.9333],[-0.775,-1.99],[-0.601,-0.4429],[-0.633,-0.2373],[-0.601,-0.1107],[-0.585,-0.0633],[-1.14,-0.0633],[-0.474,0.0791],[0,0],[-0.301,0.0632],[0,0],[0,0],[0,0],[-0.728,0.3797],[-1.36,0.7435],[-2.55,1.38],[-1.09,0.3639],[-0.664,0.0633],[0,0],[0,0]],\"v\":[[400.42,23.57],[399.42,22.51],[398.36,21.28],[396.18,20.15],[394.33,21.92],[394.14,24.28],[395.66,27.86],[401.45,31.07],[407.03,30.77],[416.03,27.56],[420.22,25.58],[422.26,24.61],[423.25,24.19],[423.72,24],[423.81,23.96],[423.97,23.96],[424.45,23.89],[425.48,23.73],[427.34,23.66],[429.6,24.17],[430.19,24.79],[430.9,26.35],[431.72,28.81],[432.48,30.69],[433.5,32.35],[434.06,33.08],[434.73,33.69],[436.15,34.71],[437.72,35.29],[439.32,35.54],[442.42,35.18],[443.84,34.82],[444.9,34.39],[451.31,30.85],[454.33,28.88],[457.67,26.69],[464.03,22.29],[470.83,17.42],[471.38,17.21],[471.51,17.21],[471.95,17.16],[472.85,17.13],[474.56,17.18],[476.1,17.43],[480.32,20.77],[482.25,24.09],[485.24,28.24],[490.71,31.38],[493.53,31.7],[494.81,31.68],[495.95,31.54],[502.77,29.61],[506.75,27.82],[509.93,26.02],[519.05,19.58],[519.82,19],[519.82,18.97],[521.01,18.51],[523.68,17.89],[524.11,17.91],[524.42,17.94],[524.68,18],[524.96,18.16],[527.37,20.96],[532.19,25.82],[533.98,26.84],[535.89,27.59],[537.84,28.06],[539.14,28.27],[539.8,28.38],[540.12,28.43],[540.43,28.36],[546.57,27],[549.26,26.53],[552,26.15],[574.65,25.33],[600.99,26.64],[616.7,27.29],[639.4,26.1],[644.41,25.21],[649.22,24.17],[658.35,21.29],[656.77,15.8],[647.92,17.24],[643.32,17.72],[638.58,18.13],[616.89,18.41],[602.4,17.15],[578.32,15.03],[568.91,15.09],[563.74,15.5],[561.11,15.69],[558.44,16.01],[553.07,16.64],[547.71,17.54],[542.44,18.7],[539.94,19.3],[539.98,19.3],[539.89,19.3],[539.74,19.33],[539.31,19.27],[536.75,18.08],[534.31,15.34],[530.89,11.47],[529.66,10.57],[528.3,9.81],[526.83,9.27],[525.4,9],[524.03,8.86],[522.81,8.92],[521.64,9],[520.63,9.21],[518.75,9.65],[517.2,10.19],[515.44,10.82],[514.05,11.8],[512.59,12.83],[511.37,13.68],[509.57,14.92],[504.65,18.11],[497.33,21.85],[493.51,22.78],[493.12,22.81],[492.8,22.76],[492.25,22.65],[491.28,22.02],[488.51,18],[483.75,12.32],[476.19,9.27],[472.51,9.19],[470.77,9.33],[468.36,9.66],[467.27,10.22],[466.26,10.98],[464.98,11.94],[462.75,13.63],[458.46,16.8],[450.96,21.96],[442.43,26.69],[441.72,26.95],[441.41,27.05],[440.85,27.1],[440.08,26.54],[439.92,26.13],[439.62,25.12],[438.62,22.15],[434.76,17.04],[432.86,15.94],[430.95,15.3],[429.13,15],[427.45,14.92],[424.35,15.11],[422.94,15.36],[422.22,15.49],[421.24,15.69],[420.29,16.09],[419.65,16.37],[418.47,16.94],[416.3,18.1],[412.31,20.28],[405.1,23.63],[402.17,24.22],[400.37,23.63],[400.42,23.57]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.549,0.5608,0.5922,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"nm\":\"Vector\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[-1.04,0.5536],[-0.585,0.5853],[0.332,0.6644],[1.52,-0.0632],[2.69,-0.6485],[4.16,0],[4.54,0.5853],[11.52,1.99],[7.5,-1.22],[0.917,-0.1898],[0.886,-0.2689],[0.886,-0.269],[0.902,-0.3481],[3.86,-2.83],[0.395,-0.2847],[0.379,-0.3164],[0.791,-0.6644],[0.744,-0.7593],[0.411,-0.4113],[0,0],[0.095,-0.0949],[0.111,0.1266],[0.016,-0.0316],[0.016,-0.0158],[0,0],[-0.095,0.0475],[0.015,0.0158],[-0.111,0.7435],[0,0],[0,0],[0.19,3.7],[2.47,4.26],[2.74,0.7277],[2.03,-0.4588],[2.91,-1.58],[3.89,-2.61],[1.9,-1.19],[1.46,-0.9017],[2.25,-1.04],[1.22,-0.3322],[0.696,0.1265],[0,0.1108],[0,0],[-0.016,0.443],[-0.095,1.11],[-0.284,2.67],[0.38,3.5],[1.19,2.06],[2.15,0.8542],[1.85,0.0633],[1.66,-0.2689],[0.791,-0.1898],[0,0],[0,0],[0,0],[0.87,-0.2373],[1.61,-0.6802],[0.775,-0.3797],[0,0],[4.59,-4.4],[4.32,-3.53],[1.47,-0.8384],[0,0],[0,0],[0,0],[0.095,-0.0316],[0.221,0.0633],[0.19,0.4271],[0.364,0.8384],[0.205,0.4588],[0.237,0.443],[3.34,2.42],[3.61,-0.0791],[2.64,-0.965],[1.08,-0.617],[0.9491,-0.6011],[1.39,-1.15],[1.11,-0.965],[0,0],[0.1424,-0.0633],[0,0],[0,0],[1.25,-0.174],[2.61,0.3164],[5.11,1.31],[5.3,0.5379],[2.69,-0.2373],[2.55,-1.01],[0.9175,-0.6328],[0.4429,-0.6328],[-0.3955,-0.5062],[-1.3,0.3006],[-0.8384,0.3005],[-1.15,0.2689],[-4.56,-0.8384],[-5.01,-1.57],[-6.2,-0.9333],[-3.5,0.3796],[-1.77,0.5695],[0,0],[0,0],[0,0],[-0.2373,0.269],[0,0],[-1.23,0.8701],[-0.6644,0.5062],[-0.7593,0.4904],[-0.8226,0.4587],[-0.8859,0.3797],[-1.85,0.1265],[-1.58,-0.9175],[-1.33,-2.25],[-0.332,-0.5853],[-0.253,-0.7119],[-0.301,-0.6803],[-0.348,-0.6486],[-0.507,-0.6169],[-3.39,-0.1582],[-1.58,0.6486],[-0.316,0.174],[0,0],[0,0],[-3.35,3.59],[-3.81,3.46],[-4.4,1.66],[-1.11,0.2848],[-1.12,0.1582],[0,0],[-0.142,0.0316],[0,0],[0,0],[-0.586,0.0949],[-1.08,0.0949],[-0.632,-0.5537],[-0.253,-0.6012],[-0.079,-0.9175],[0.19,-2.04],[0.238,-1.99],[0.063,-1.9],[0,-0.4745],[0,-0.3164],[-0.032,-0.3322],[-0.127,-0.6012],[-0.127,-0.5853],[-0.886,-0.6011],[-0.917,-0.2848],[-1.06,-0.0158],[-0.522,0.0633],[0,0],[-3.31,1.84],[-2.96,2.06],[-5.77,3.69],[-2.77,0.9491],[-0.87,-0.0949],[-0.253,-0.174],[-0.285,-0.3481],[-0.348,-1.39],[-0.111,-1.61],[0.222,-3.42],[0,0],[-0.997,-2.23],[-0.443,-0.5062],[-0.538,-0.4113],[-0.601,-0.2848],[-0.601,-0.0791],[-1.65,0.9808],[-0.664,0.6486],[0,0],[0.048,-0.0791],[0,0],[-0.823,0.7435],[-0.918,0.6169],[0,0],[0,0],[-4.46,0.6327],[-3.45,-0.1423],[-3.69,-0.5853],[-9.71,-0.8385],[-4.62,0.3322],[-4.27,1.46],[0,0]],\"o\":[[1.53,-0.4271],[1.06,-0.5537],[1.17,-1.19],[-0.332,-0.6644],[-1.52,0.095],[-3.83,0.9176],[-4.16,0.0158],[-9.06,-1.19],[-13.1,-2.14],[-0.933,0.1582],[-0.918,0.174],[-0.886,0.2531],[-0.87,0.3322],[-3.51,1.42],[-0.396,0.269],[-0.364,0.3164],[-0.76,0.6328],[-0.728,0.7277],[-0.395,0.4113],[0,0],[-0.079,0.1266],[-0.696,0.9017],[0,-0.0632],[0,0.0316],[0,0],[-0.048,0.0633],[0.126,-0.0632],[-0.048,-0.1266],[0,0],[0,0],[0.269,-3.42],[-0.284,-3.7],[-1.2,-2.1],[-2.7,-0.7277],[-4.07,0.9966],[-5.71,3.26],[-3.86,2.63],[-1.44,0.9017],[-1.27,0.7751],[-1.11,0.5379],[-1.19,0.348],[0,0.0316],[0,0],[-0.032,-0.2373],[0.016,-0.9808],[0.205,-2.25],[0.253,-2.69],[-0.237,-1.76],[-1.14,-2.06],[-2.13,-0.9017],[-1.85,-0.0158],[-0.806,0.1582],[0,0],[0,0],[0,0],[-0.885,0.0791],[-1.72,0.3797],[-0.823,0.3164],[0,0],[-6.2,3.23],[-4.57,4.45],[-1.5,1.23],[0,0],[0,0],[0,0],[-0.111,0.0632],[-0.205,0.0475],[-0.443,-0.1266],[-0.38,-0.8542],[-0.206,-0.4588],[-0.238,-0.4429],[-1.82,-3.5],[-3.31,-2.45],[-3.69,-0.0158],[-1.23,0.5853],[-1.06,0.6169],[-1.85,1.25],[-1.47,1.11],[0,0],[-0.0474,0.0474],[0,0],[0,0],[-1.2,0.4113],[-2.53,0.3164],[-5.24,-0.6485],[-5.13,-1.31],[-2.64,-0.2689],[-2.71,0.2373],[-1.41,0.522],[-0.8701,0.7276],[-0.8859,1.27],[0.3955,0.5062],[0.6486,-0.1582],[0.9017,-0.2215],[4.13,-1.2],[4.57,0.8226],[5.03,1.55],[3.08,0.443],[1.74,-0.2057],[0,0],[0,0],[0,0],[0.3164,-0.1265],[0,0],[0.9175,-0.7909],[0.6011,-0.4429],[0.6961,-0.4429],[0.7435,-0.522],[0.8226,-0.4904],[1.79,-0.7593],[1.88,-0.174],[1.55,0.965],[0.38,0.4904],[0.316,0.6169],[0.285,0.6802],[0.079,0.174],[0.363,0.696],[2.02,2.47],[1.68,0.0791],[0.38,-0.174],[0,0],[0,0],[4.83,-3.05],[3.61,-3.91],[3.78,-3.48],[1.08,-0.4904],[1.11,-0.3638],[0,0],[0.142,0],[0,0],[0,0],[0.585,-0.1266],[1.17,-0.2373],[2.12,-0.1582],[0.348,0.2689],[0.254,0.5853],[0.174,1.83],[-0.222,2.06],[-0.237,1.99],[0,0.4746],[0,0.3164],[0,0.348],[0.079,0.6644],[0.127,0.6011],[0.917,0.7751],[0.933,0.5379],[2.01,0.6327],[1.06,0],[0.506,-0.0632],[4.32,-0.8701],[3.28,-1.87],[5.93,-4.13],[2.86,-1.82],[1.38,-0.4746],[0.443,0.0475],[0.269,0.1266],[0.553,0.696],[0.364,1.39],[0.269,3.23],[0,0],[-0.174,1.69],[0.253,0.5537],[0.38,0.522],[0.522,0.443],[0.601,0.2056],[2.41,0.2689],[0.839,-0.4904],[0,0],[0.253,-0.3322],[0,0],[0.759,-0.8542],[0.823,-0.7593],[0,0],[0,0],[5.03,-2.88],[4.48,-0.617],[6.91,0.3797],[11.15,1.88],[4.86,0.4271],[4.62,-0.3164],[0,0],[0,0]],\"v\":[[370.55,29.03],[374.36,27.34],[376.78,25.52],[377.97,22.72],[375.11,21.78],[368.81,22.86],[356.82,24.16],[343.8,23.24],[313.38,17.73],[283.94,16.98],[281.17,17.54],[278.48,18.21],[275.83,18.98],[273.18,19.98],[262.11,25.99],[260.94,26.83],[259.82,27.78],[257.51,29.73],[255.31,31.94],[254.09,33.16],[253.47,34],[253.2,34.33],[251.12,35.42],[251.04,35.63],[250.96,35.75],[250.97,35.74],[251.16,35.58],[251.26,35.47],[251.26,34.01],[251.26,33.89],[251.29,33.74],[251.54,23.08],[248.54,11.22],[242.15,6.28],[234.97,6.3],[224.9,10.55],[210.67,19.73],[201.89,25.53],[197.55,28.25],[192.22,31.2],[188.68,32.54],[185.53,32.89],[185.29,32.78],[185.29,32.68],[185.28,31.37],[185.47,28.21],[186.29,20.87],[186.46,11.8],[184.61,6],[179.2,1.22],[173.16,0.0011],[167.92,0.4124],[165.47,0.8711],[164.28,1.16],[163.73,1.28],[161.53,1.47],[158.91,1.87],[153.81,3.31],[151.36,4.27],[149.02,5.44],[133.31,17.66],[120.26,30.12],[115.8,33.32],[115.26,33.65],[114.99,33.82],[114.9,33.87],[114.58,33.98],[113.93,33.96],[112.94,33.09],[111.83,30.58],[111.23,29.22],[110.5,27.89],[102.86,18.68],[91.77,15.14],[82.5,17.18],[78.94,18.91],[75.89,20.71],[70.97,24.27],[67.2,27.43],[66.76,27.83],[66.55,27.92],[65.68,28.3],[64.78,28.59],[61.08,29.39],[53.33,29.31],[37.81,25.93],[22.29,22.76],[14.26,22.65],[6.3,24.54],[2.85,26.43],[0.8416,28.41],[0.2088,31.09],[2.85,31.42],[5.14,30.82],[8.17,29.95],[21.31,29.76],[35.6,33.66],[52.19,37.9],[62.11,38.17],[67.41,37.08],[68.74,36.67],[70.03,36.13],[70.94,35.75],[71.84,35.25],[73.14,34.11],[76.31,31.51],[78.23,30.09],[80.4,28.7],[82.78,27.35],[85.38,26.15],[90.95,24.79],[96.06,26.01],[100.52,30.74],[101.48,32.49],[102.4,34.39],[103.25,36.43],[104.05,38.17],[105.36,40.13],[113.87,44.39],[118.87,43.52],[119.99,42.98],[120.69,42.57],[122.09,41.72],[133.91,31.34],[144.83,20],[157.1,11.9],[160.43,10.88],[163.81,10.38],[165.25,10.24],[165.68,10.14],[166.04,10.06],[166.48,9.95],[168.26,9.54],[171.62,9.05],[176.23,9.78],[177.1,10.98],[177.6,13.32],[177.41,19.3],[176.67,25.39],[176.16,31.21],[176.13,32.62],[176.13,33.57],[176.21,34.58],[176.43,36.51],[176.83,38.28],[179.52,40.36],[182.27,41.65],[186.54,42.29],[188.87,42.11],[189.63,41.99],[200.72,37.51],[210,31.54],[227.34,19.38],[235.93,14.93],[239.47,14.35],[240.49,14.65],[241.29,15.36],[242.73,18.67],[243.44,23.24],[243.41,33.3],[243.44,33],[244.17,38.88],[245.17,40.48],[246.61,41.86],[248.35,42.81],[250.17,43.25],[256.26,41.83],[258.47,40.09],[259.39,39.07],[259.94,38.28],[262.11,36.07],[264.61,33.84],[267.27,31.83],[268.63,30.86],[270.07,30.04],[284.53,25.19],[296.44,24.76],[311.88,26.58],[342.87,31.47],[357.09,31.67],[370.52,29.09],[370.55,29.03]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.549,0.5608,0.5922,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"Header white 1\",\"ddd\":0,\"ty\":4,\"ind\":5,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[142,418]},{\"t\":165.06,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[142,418]},{\"t\":194.69,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[142,436.43]},{\"t\":330.01,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[142,438]},{\"t\":360,\"s\":[142,438]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":165.06,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[0]},{\"t\":194.87,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"nm\":\"Layer_1-2\",\"ty\":\"gr\",\"it\":[{\"nm\":\"Vector\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[-5.45,4.7],[-4.32,3.57],[-5.45,3.54],[-2.18,-0.285],[-0.915,-1.19],[-0.555,-2.37],[-0.36,-2.5],[-0.615,-2.96],[-0.75,-1.66],[-0.3,-0.48],[-0.375,-0.465],[-1.09,-0.51],[-1.2,-0.03],[-0.57,0.105],[-0.405,0.135],[-1.35,0.78],[-0.615,0.405],[0,0],[-0.24,0.225],[0,0],[-0.885,0.795],[-1.55,1.25],[-1.44,0.9],[-0.81,0.57],[-3.67,1.36],[-1.7,-0.21],[-1.29,-1.8],[-0.48,-1.27],[-0.27,-0.87],[-0.945,-1.09],[-2.9,-0.465],[-1.45,0.285],[-1.19,0.75],[-6.75,0.525],[-4.03,-0.285],[-3.24,-0.45],[-3.3,-0.495],[-6.69,0.3],[-5.73,2.31],[-0.6,0.75],[0.24,0.57],[0.9,0.18],[1.51,-0.27],[15.41,2.28],[6.18,1.23],[3.93,0.51],[4.86,-0.165],[3.11,-0.81],[3.28,-1.57],[0.81,-0.405],[0.765,-0.495],[0,0],[0.345,-0.12],[0.69,1.3],[0.045,0.195],[0,0],[0,0],[0.36,0.825],[0.99,1.48],[1.53,0.99],[1.55,0.315],[1.98,-0.39],[0.975,-0.375],[0,0],[1.35,-0.66],[2.19,-1.39],[5.43,-5.31],[0.69,-0.675],[0.015,0.06],[1.19,-0.405],[0.285,0],[0.195,0.18],[0.075,0.105],[0.135,0.315],[0.225,0.75],[0.54,3.3],[0.96,2.8],[1.53,1.82],[2.13,0.555],[1.59,-0.225],[1.22,-0.405],[2.05,-1.28],[4.23,-3.97],[3.42,-3.9],[0,0]],\"o\":[[-4.8,5.53],[3.88,-3.3],[4.32,-3.54],[6.04,-4.09],[1.06,0.105],[0.885,1.2],[0.51,2],[0.375,2.52],[0.33,1.48],[0.18,0.405],[0.24,0.45],[0.78,0.9],[1.07,0.555],[0.6,0],[0.585,-0.09],[1.86,-0.54],[0.69,-0.39],[0,0],[0.225,-0.195],[0,0],[0.9,-0.87],[1.75,-1.59],[3.12,-2.47],[0.855,-0.54],[1.45,-0.96],[1.8,-0.645],[1.71,0.165],[0.645,0.855],[0.27,0.855],[0.48,1.32],[1.85,2.23],[1.45,0.225],[1.44,-0.315],[5.61,-3.58],[4.77,-0.45],[4.03,0.3],[6.54,0.975],[7.91,1.12],[6.68,-0.315],[1.59,-0.585],[0.6,-0.75],[-0.24,-0.57],[-0.915,-0.195],[-10.86,2.39],[-3.01,-0.42],[-3.09,-0.615],[-3.94,-0.495],[-3.16,0.135],[-3.33,0.9],[-0.84,0.36],[-0.81,0.405],[0,0],[-0.315,0.24],[-1.44,0.405],[-0.075,-0.18],[0,0],[0,0],[-0.255,-0.84],[-0.585,-1.65],[-1.09,-1.46],[-1.5,-0.975],[-3.12,-0.705],[-2,0.42],[-0.99,0.375],[0,0],[-1.35,0.66],[-4.38,2.79],[-0.675,0.675],[-0.63,0.63],[-1.28,0.93],[-0.69,0.24],[-0.255,0],[-0.09,-0.09],[-0.075,-0.165],[-0.285,-0.54],[-0.885,-3.07],[-0.54,-3.33],[-0.75,-2.1],[-1.52,-1.81],[-2.15,-0.585],[-1.62,0.225],[-4.7,1.77],[-6.11,4],[-4.21,3.99],[0,0],[0,0]],\"v\":[[2.24,30.04],[6.5,34.36],[18.68,24.12],[33.15,13.23],[45.56,7.93],[48.39,9.69],[50.6,15.04],[51.84,21.87],[53.15,30.06],[54.62,34.75],[55.31,36.07],[56.3,37.48],[59.1,39.72],[62.58,40.56],[64.38,40.45],[65.97,40.11],[70.67,38.04],[72.6,36.84],[73.31,36.36],[73.97,35.73],[74.69,35.04],[77.37,32.55],[82.38,28.3],[89.51,23.22],[92.01,21.57],[99.95,17.37],[105.52,16.44],[109.78,19.06],[111.41,22.42],[112.2,25],[114.32,28.71],[121.73,32.91],[126.14,32.8],[130.19,31.12],[149.22,25],[162.47,25],[173.38,26.22],[188.01,28.39],[209.76,29.8],[228.4,26.02],[231.62,23.83],[232.12,21.81],[230.36,20.64],[226.78,20.83],[189.2,20.04],[175.43,17.34],[164.9,15.6],[151.72,14.91],[142.26,16.26],[132.22,19.86],[129.78,21.1],[127.42,22.47],[125.28,23.8],[124.28,24.27],[120.42,22.59],[120.2,22.06],[120.09,21.76],[119.9,21.13],[119.06,18.64],[116.6,13.92],[112.73,10.11],[108.06,8.1],[100.36,8.11],[95.9,9.4],[94.38,9.99],[92.25,10.98],[86.85,14.07],[71.55,26.53],[69.51,28.56],[67.95,30.15],[63.95,32.43],[62.84,32.67],[62.13,32.38],[61.88,32.1],[61.53,31.48],[60.78,29.47],[58.92,19.51],[56.81,10.21],[53.58,4.23],[47.76,0.4339],[42.12,0.1789],[37.97,1.23],[28.61,6.06],[13.55,18.19],[2.25,29.95],[2.24,30.04]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[1,1,1,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"Party\",\"ddd\":0,\"ty\":4,\"ind\":6,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[43.75,46.88],\"a\":0},\"p\":{\"k\":[195,750],\"a\":0},\"s\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[60.66,60.66]},{\"t\":118.62,\"i\":{\"x\":[0.685],\"y\":[1.53]},\"o\":{\"x\":[0.422],\"y\":[0]},\"s\":[60.66,60.66]},{\"t\":147.13,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100,100]},{\"t\":360,\"s\":[100,100]}]},\"r\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":29.99,\"i\":{\"x\":[0.5],\"y\":[1]},\"o\":{\"x\":[0.5],\"y\":[0]},\"s\":[0]},{\"t\":118.62,\"i\":{\"x\":[0.5],\"y\":[1]},\"o\":{\"x\":[0.5],\"y\":[0]},\"s\":[-15]},{\"t\":118.73,\"i\":{\"x\":[0.5],\"y\":[1]},\"o\":{\"x\":[0.5],\"y\":[0]},\"s\":[-8]},{\"t\":147.17,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":360,\"s\":[0]}]},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":118.62,\"i\":{\"x\":[0.685],\"y\":[1.53]},\"o\":{\"x\":[0.422],\"y\":[0]},\"s\":[0]},{\"t\":147.13,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"nm\":\"vector\",\"ty\":\"gr\",\"it\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[3.45,0],[0,3.45],[-3.45,0],[0,-3.45]],\"o\":[[0,3.45],[-3.45,0],[0,-3.45],[3.45,0],[0,0]],\"v\":[[87.5,15.62],[81.25,21.88],[75,15.62],[81.25,9.38],[87.5,15.62]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[1,1,1,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,6.9],[6.9,0],[0,-6.9],[-6.9,0]],\"o\":[[6.9,0],[0,-6.9],[-6.9,0],[0,6.9],[0,0]],\"v\":[[73.44,56.25],[85.94,43.75],[73.44,31.25],[60.94,43.75],[73.44,56.25]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[1,1,1,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,93.75],[73.56,72.44],[20.5,19.38],[0,93.75]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[1,1,1,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[54.69,23.44],[68.75,18.75],[54.69,14.06],[50,0],[45.31,14.06],[31.25,18.75],[45.31,23.44],[50,37.5],[54.69,23.44]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[1,1,1,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"header c1\",\"ddd\":0,\"ty\":4,\"ind\":7,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[125,824]},{\"t\":174.71,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[125,824]},{\"t\":204.19,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[145,824]},{\"t\":360,\"s\":[145,824]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":174.71,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[0]},{\"t\":204.19,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"nm\":\"header\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0.3955,-0.0317],[0.3638,-0.1108],[0.4271,-0.5853],[-0.2531,-0.8543],[-0.3638,-0.4113],[-0.6486,-0.348],[-2.09,-0.1266],[-2.01,0.4271],[-3.94,1.83],[-2.12,0.9808],[-0.9649,0.1898],[-0.9491,-0.2847],[-0.791,-0.9333],[-0.1898,-0.2847],[-0.1582,-0.3638],[-0.1898,-0.3481],[-0.2373,-0.5378],[-1.85,-0.9492],[-1.99,0.522],[-0.9017,0.6011],[0,0],[0,0],[0,0],[0,0],[-0.8859,0.4271],[-1.44,0.2373],[-0.5537,0.1898],[-2.61,0.3638],[-3.83,-0.2215],[-8.78,-2.34],[-4.33,-0.4113],[-4.24,0.6011],[-3.53,1.65],[3.62,-0.7118],[9.32,1.09],[10.76,2.91],[1.82,0.2373],[4.19,0.5853],[3.69,0.2215],[2.29,-0.1265],[0.6169,-0.0633],[0,0],[4.95,-2.67],[1.15,-0.8068],[0,0],[0.1424,-0.079],[0.1582,0.6961],[0,0],[0.1582,0.2689],[0,0],[1.06,0.965],[2.85,0.2215],[2.01,-0.5695],[1.3,-0.5853],[1.3,-0.6011],[4.89,1.03],[0,0]],\"o\":[[-0.4271,-0.1265],[-0.3955,0],[-0.7277,0.2373],[-0.4271,0.5853],[0.1266,0.4113],[0.3955,0.3955],[1.87,0.8701],[2.09,0.1265],[4.05,-0.8226],[4.37,-2.23],[1.04,-0.4588],[0.9966,-0.2373],[0.8543,0.2215],[0.2056,0.1898],[0.1898,0.2847],[0.174,0.3322],[0.2215,0.522],[0.7435,1.95],[1.8,0.9491],[0.9966,-0.269],[0,0],[0,0],[0,0],[0,0],[0.8859,-0.5695],[3.54,-1.63],[0.5853,-0.0949],[1.03,-0.2531],[2.63,-0.3322],[7.64,0.348],[12.48,3.1],[5.13,0.5536],[4.25,-0.617],[3.91,-1.98],[-6.79,1.08],[-3.67,-0.3638],[-1.77,-0.4588],[-3.94,-0.4904],[-4.19,-0.5853],[-3.69,-0.2215],[-1.15,0.0316],[-0.6328,0.0633],[-5.51,0.696],[-1.2,0.7119],[0,0],[-0.0949,0.0633],[-0.6328,0.3639],[0,0],[-0.1424,-0.2689],[0,0],[-0.7277,-1.06],[-1.99,-1.98],[-3.35,-0.3006],[-1.98,0.6328],[-2.63,1.15],[-7.66,3.72],[0,0],[0,0]],\"v\":[[4.66,10.68],[3.42,10.57],[2.28,10.75],[0.4655,12.01],[0.1175,14.21],[0.8452,15.51],[2.4,16.65],[8.44,18.25],[14.64,17.79],[26.46,13.5],[35.35,8.88],[38.32,7.84],[41.22,7.9],[43.67,9.51],[44.25,10.26],[44.82,11.13],[45.36,12.14],[46.06,13.74],[49.96,18.25],[55.94,18.91],[58.79,17.61],[59.5,17.17],[59.85,16.95],[60.02,16.85],[60.72,16.44],[63.44,15.04],[71.49,12.42],[73.2,12],[78.72,10.84],[88.5,10.48],[114.32,15.21],[139.37,20.16],[153.39,20.08],[165,16.63],[163.24,11.21],[140.37,11.33],[118.7,5.56],[113.32,4.52],[100.97,2.76],[88.94,1.49],[79.72,1.46],[77.03,1.68],[76.07,1.78],[60.1,6.81],[56.48,8.96],[54.93,10.04],[54.52,10.31],[52.89,9.55],[52.73,9.2],[52.34,8.39],[51.37,6.78],[48.81,3.68],[40.96,0.0702],[33.15,1.07],[28.29,2.92],[22.71,5.5],[4.71,10.68],[4.66,10.68]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[1,1,1,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"description c1\",\"ddd\":0,\"ty\":4,\"ind\":8,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[145,904.56]},{\"t\":185.76,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[145,904.56]},{\"t\":219.13,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[145,884.56]},{\"t\":360,\"s\":[145,884.56]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":185.76,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[0]},{\"t\":219.13,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"nm\":\"Vector\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0.242,0.3341],[0.2765,0.2535],[0.53,-0.0346],[0.3111,-0.8642],[-0.0922,-0.7259],[-0.6913,-0.8872],[-1.65,-0.2074],[-1.22,0.2535],[-2.07,0.9333],[-1.04,0.4839],[-0.4955,0.242],[0,0],[0,0],[-0.046,0.0231],[0,0],[0,0],[0,0],[-0.3802,-0.0576],[-0.1729,-0.1728],[-0.1728,-0.242],[-0.1728,-0.4955],[-0.2651,-0.772],[-0.1959,-0.4379],[-0.3111,-0.3341],[0,0],[-0.1613,-0.1498],[-0.3572,-0.2189],[-0.3802,-0.1153],[-0.3802,-0.0576],[-0.7259,0.2304],[-0.2881,0.1037],[-0.2535,0.1037],[-1.46,0.9218],[-0.7489,0.507],[-0.8641,0.5761],[-1.62,1.14],[-1.69,1.22],[-0.1383,-0.023],[0,0],[0,0],[-0.219,0],[-0.3803,-0.0576],[-0.3456,-0.0691],[-0.8988,-1.36],[-0.53,-0.9333],[-1.01,-1.04],[-1.49,-0.3457],[-0.5991,0.0346],[-0.2996,0.0115],[-0.2765,0.0345],[-1.26,0.5069],[-0.7028,0.3226],[-0.7605,0.4609],[-2.94,2.25],[-0.1959,0.1498],[0,0.023],[-0.288,0.1152],[-0.4955,0.0346],[-0.1037,0.0115],[-0.0345,-0.0461],[-0.0691,-0.0346],[-0.0807,-0.023],[-0.795,-1.06],[-1.62,-1.13],[-0.438,-0.242],[-0.472,-0.1728],[-0.472,-0.0691],[0,0],[0,0],[-0.069,0],[0,0],[-1.51,0.3341],[-0.668,0.0807],[-0.669,0.0922],[-5.48,-0.2534],[-5.06,-0.265],[-2.59,-0.0576],[-4.98,0.6453],[-1.19,0.2189],[-1.14,0.3572],[-2.13,0.9218],[4.59,-0.9679],[2.18,-0.3572],[1.14,-0.1152],[1.18,-0.0691],[5.93,0.1498],[4.7,0.5185],[7,0.3342],[2.27,-0.1037],[1.28,-0.1037],[0.634,-0.0461],[0.657,-0.0807],[1.3,-0.1959],[1.3,-0.2189],[1.27,-0.2881],[0.599,-0.1498],[-0.012,0],[0,0],[0.046,0.0115],[0,0],[0.553,0.4955],[0.657,0.8757],[1.15,0.9679],[0.3111,0.2074],[0.3687,0.1267],[0.3572,0.1152],[0.3457,0.0576],[0.3111,0],[0.288,-0.0115],[0.2766,-0.0115],[0.242,-0.0461],[0.4378,-0.1037],[0.3572,-0.1267],[0.4033,-0.1498],[0.3111,-0.2189],[0.2881,-0.2074],[0,0],[0.8411,-0.5761],[1.52,-0.9448],[1.97,-0.7605],[0.7835,-0.0461],[0,0],[0.0807,0],[0.1268,0.023],[0.2765,0.2765],[0.795,1.3],[1.6,1.26],[1.84,0.1959],[0.8526,-0.0807],[0.4033,-0.0691],[0.5761,-0.0807],[0.242,-0.1844],[0,0],[0,0],[0.53,-0.4033],[1,-0.7374],[1.59,-1.03],[1.62,-0.6338],[0.1613,-0.0691],[0.0691,-0.0231],[0.1267,0.0116],[0.0922,0.1958],[0.023,0.0922],[0.0691,0.2304],[0.288,0.7144],[1.21,0.8181],[0.4608,0.242],[0.4609,0.1383],[0.4379,0.0576],[0.4032,0.023],[0.7489,-0.0461],[0.3457,-0.0576],[0,0],[0.2535,-0.0807],[0,0],[0,0],[0,0],[0.5185,-0.2765],[0.9448,-0.5185],[1.64,-0.5416],[0.5185,0],[0.3802,0.3111],[0,0]],\"o\":[[-0.2535,-0.242],[-0.265,-0.3111],[-0.4955,-0.5415],[-0.53,0.0346],[-0.1267,0.4494],[0.0576,0.6913],[0.9909,1.28],[1.59,0.2074],[2.4,-0.53],[1,-0.4724],[0.4955,-0.2304],[0,0],[0,0],[0.0922,-0.0346],[0,0],[0,0],[0,0],[0.4493,0],[0.8872,0],[0.1267,0.0807],[0.1613,0.288],[0.1728,0.4609],[0.1497,0.4033],[0.2535,0.4148],[0,0],[0.1497,0.1614],[0.2996,0.3111],[0.3687,0.1844],[0.3917,0.0576],[0.7835,0],[0.3457,-0.0922],[0.2535,-0.1037],[1.94,-0.8296],[0.7144,-0.4494],[0.772,-0.4954],[1.46,-0.9794],[1.59,-1.14],[0.1152,-0.0807],[0,0],[0,0],[0.2304,-0.0346],[0.4378,-0.0115],[0.4148,0.0115],[1.38,0.3802],[0.4493,0.6798],[0.53,0.9218],[0.9909,1.05],[0.6913,0.1267],[0.3111,0],[0.2766,-0.0346],[2.14,-0.3226],[1.28,-0.4955],[0.8066,-0.4033],[1.3,-0.8641],[0.1843,-0.1383],[0,0],[0.2765,-0.1037],[0.7144,-0.2535],[0.1613,-0.0461],[0.0807,0.0115],[0.0461,0.0346],[0.0576,0.0576],[0.3572,0.242],[0.8065,1.04],[0.426,0.2535],[0.449,0.2304],[0.472,0.1844],[0,0],[0,0],[0.081,0],[0,0],[1.47,-0.3226],[0.634,-0.1613],[0.669,-0.0921],[5.37,-0.6798],[7.74,0.2074],[5.07,0.288],[6.13,0.1267],[1.24,-0.1728],[1.19,-0.242],[2.28,-0.6683],[4.75,-1.86],[-2.09,0.53],[-1.08,0.1959],[-1.14,0.0922],[-4.74,0.2304],[-2.32,-0.0576],[-4.7,-0.4955],[-2.27,-0.1267],[-1.23,0.0922],[-0.634,0.0461],[-0.645,0.0691],[-1.3,0.1613],[-1.3,0.2189],[-1.3,0.1728],[-0.611,0.1498],[0,0],[0,0],[0,0],[0,0],[-0.738,-0.1613],[-0.576,-0.4609],[-0.68,-0.8527],[-0.2419,-0.242],[-0.3341,-0.1959],[-0.3572,-0.1383],[-0.3572,-0.1267],[-0.3341,-0.0461],[-0.2996,0.0115],[-0.2881,0.023],[-0.265,0.0346],[-0.4724,0.1152],[-0.3918,0.1383],[-0.4494,0.1613],[-0.3572,0.2535],[-0.4148,0.2881],[-0.5761,0.4033],[0,0],[-0.8412,0.5876],[-1.52,0.9103],[-0.9794,0.4033],[0,0],[-0.0806,-0.0115],[-0.1728,0],[-0.2304,-0.0922],[-0.5531,-0.4839],[-0.7835,-1.29],[-1.59,-1.29],[-0.9103,-0.0807],[-0.4263,0.023],[-0.5876,0.0807],[-0.3342,-0.023],[0,0],[0,0],[-0.5531,0.4148],[-1.08,0.795],[-2.02,1.44],[-2.36,1.54],[-0.1728,0.0691],[-0.1267,0.0461],[-0.1383,0.0345],[-0.265,-0.0115],[-0.0461,-0.1037],[-0.0807,-0.2535],[-0.1959,-0.6799],[-0.5646,-1.45],[-0.4378,-0.3226],[-0.4609,-0.1728],[-0.4379,-0.0807],[-0.4263,-0.0461],[-0.8296,-0.0461],[-0.3457,0.0576],[0,0],[-0.2189,0.0461],[0,0],[0,0],[0,0],[-0.53,0.2765],[-0.9909,0.5415],[-1.86,1],[-0.795,0.265],[-0.4839,0.0461],[0,0],[0,0]],\"v\":[[4.61,10.72],[3.88,9.94],[3.11,9.04],[1.52,8.23],[0.1735,9.52],[0.0352,11.23],[1.14,13.84],[5.36,16.18],[9.43,15.96],[15.98,13.62],[19.04,12.18],[20.52,11.48],[21.24,11.16],[21.58,11.03],[21.65,11],[21.77,11],[22.11,10.95],[22.86,10.83],[24.22,10.78],[25.87,11.15],[26.29,11.6],[26.81,12.74],[27.41,14.53],[27.97,15.9],[28.7,17.11],[29.12,17.64],[29.6,18.09],[30.64,18.83],[31.78,19.25],[32.94,19.44],[35.2,19.17],[36.24,18.91],[37.01,18.6],[41.68,16.02],[43.88,14.59],[46.31,12.99],[50.94,9.78],[55.9,6.23],[56.3,6.08],[56.39,6.08],[56.71,6.05],[57.37,6.03],[58.61,6.06],[59.73,6.25],[62.81,8.68],[64.21,11.1],[66.39,14.11],[70.38,16.41],[72.43,16.64],[73.36,16.63],[74.19,16.52],[79.16,15.12],[82.06,13.82],[84.38,12.5],[91.01,7.81],[91.58,7.39],[91.58,7.36],[92.44,7.03],[94.39,6.58],[94.7,6.59],[94.93,6.61],[95.12,6.66],[95.32,6.78],[97.08,8.81],[100.59,12.35],[101.89,13.1],[103.29,13.64],[104.7,13.99],[105.65,14.14],[106.13,14.22],[106.36,14.25],[106.59,14.21],[111.06,13.22],[113.02,12.87],[115.02,12.59],[131.51,11.99],[150.7,12.95],[162.14,13.42],[178.68,12.56],[182.33,11.91],[185.83,11.15],[192.48,9.06],[191.33,5.06],[184.89,6.11],[181.53,6.45],[178.08,6.75],[162.28,6.96],[151.72,6.04],[134.19,4.49],[127.33,4.54],[123.56,4.84],[121.65,4.98],[119.7,5.21],[115.8,5.67],[111.89,6.33],[108.06,7.17],[106.24,7.6],[106.26,7.6],[106.2,7.6],[106.09,7.63],[105.78,7.58],[103.91,6.72],[102.13,4.72],[99.64,1.9],[98.75,1.24],[97.76,0.6913],[96.68,0.2996],[95.65,0.1037],[94.64,0],[93.76,0.0461],[92.9,0.1037],[92.17,0.2535],[90.8,0.5761],[89.67,0.9679],[88.39,1.43],[87.37,2.14],[86.31,2.89],[85.43,3.51],[84.11,4.41],[80.53,6.74],[75.19,9.46],[72.42,10.14],[72.13,10.16],[71.9,10.13],[71.5,10.05],[70.79,9.59],[68.78,6.66],[65.31,2.52],[59.8,0.2996],[57.12,0.242],[55.85,0.3457],[54.1,0.5876],[53.3,0.9909],[52.57,1.54],[51.63,2.25],[50.01,3.48],[46.88,5.78],[41.42,9.54],[35.21,12.99],[34.69,13.18],[34.46,13.25],[34.06,13.29],[33.5,12.88],[33.38,12.58],[33.16,11.84],[32.44,9.68],[29.62,5.96],[28.24,5.16],[26.85,4.69],[25.52,4.47],[24.3,4.41],[22.04,4.55],[21.02,4.74],[20.49,4.83],[19.77,4.98],[19.08,5.27],[18.62,5.47],[17.76,5.89],[16.18,6.73],[13.27,8.32],[8.02,10.76],[5.89,11.19],[4.57,10.76],[4.61,10.72]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[1,1,1,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"gr\",\"it\":[{\"nm\":\"Vector\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0.288,-0.0231],[0.265,-0.0807],[0.3111,-0.4263],[-0.1844,-0.6222],[-0.265,-0.2996],[-0.4724,-0.2535],[-1.52,-0.0922],[-1.46,0.3111],[-2.87,1.34],[-1.54,0.7144],[-0.7029,0.1383],[-0.6913,-0.2074],[-0.5761,-0.6798],[-0.1383,-0.2074],[-0.1152,-0.265],[-0.1383,-0.2535],[-0.1728,-0.3917],[-1.35,-0.6914],[-1.45,0.3802],[-0.6567,0.4378],[0,0],[0,0],[0,0],[0,0],[-0.6453,0.3111],[-1.05,0.1728],[-0.4033,0.1383],[-1.9,0.265],[-2.79,-0.1613],[-6.39,-1.71],[-3.16,-0.2995],[-3.09,0.4379],[-2.57,1.2],[2.64,-0.5185],[6.79,0.795],[7.84,2.12],[1.32,0.1728],[3.05,0.4263],[2.68,0.1613],[1.67,-0.0922],[0.4494,-0.0461],[0,0],[3.61,-1.95],[0.8411,-0.5876],[0,0],[0.1037,-0.0576],[0.1153,0.507],[0,0],[0.1152,0.1959],[0,0],[0.772,0.7029],[2.07,0.1613],[1.46,-0.4148],[0.9448,-0.4263],[0.9448,-0.4378],[3.56,0.749],[0,0]],\"o\":[[-0.3111,-0.0922],[-0.2881,0],[-0.53,0.1728],[-0.3111,0.4263],[0.0922,0.2996],[0.2881,0.2881],[1.36,0.6337],[1.52,0.0921],[2.95,-0.5991],[3.18,-1.62],[0.7605,-0.3341],[0.7259,-0.1728],[0.6222,0.1613],[0.1498,0.1383],[0.1383,0.2074],[0.1268,0.242],[0.1613,0.3802],[0.5416,1.42],[1.31,0.6913],[0.7259,-0.1959],[0,0],[0,0],[0,0],[0,0],[0.6453,-0.4148],[2.58,-1.19],[0.4263,-0.0691],[0.7489,-0.1844],[1.91,-0.242],[5.57,0.2535],[9.09,2.26],[3.73,0.4033],[3.1,-0.4493],[2.85,-1.44],[-4.94,0.7835],[-2.67,-0.265],[-1.29,-0.3341],[-2.87,-0.3572],[-3.05,-0.4263],[-2.68,-0.1613],[-0.8412,0.0231],[-0.4609,0.0461],[-4.01,0.507],[-0.8757,0.5185],[0,0],[-0.0691,0.0461],[-0.4609,0.265],[0,0],[-0.1037,-0.1959],[0,0],[-0.53,-0.772],[-1.45,-1.44],[-2.44,-0.2189],[-1.44,0.4609],[-1.91,0.8411],[-5.58,2.71],[0,0],[0,0]],\"v\":[[3.39,7.78],[2.49,7.7],[1.66,7.83],[0.3391,8.75],[0.0856,10.35],[0.6156,11.3],[1.74,12.13],[6.15,13.29],[10.66,12.96],[19.27,9.83],[25.75,6.47],[27.91,5.71],[30.02,5.75],[31.81,6.93],[32.23,7.47],[32.65,8.11],[33.04,8.84],[33.55,10.01],[36.39,13.29],[40.75,13.77],[42.82,12.83],[43.34,12.51],[43.59,12.35],[43.72,12.28],[44.23,11.98],[46.21,10.95],[52.07,9.05],[53.32,8.74],[57.34,7.9],[64.46,7.63],[83.26,11.08],[101.52,14.68],[111.72,14.63],[120.18,12.11],[118.9,8.16],[102.24,8.25],[86.46,4.05],[82.54,3.29],[73.54,2.01],[64.78,1.09],[58.07,1.07],[56.11,1.23],[55.4,1.3],[43.78,4.96],[41.14,6.53],[40.01,7.31],[39.71,7.51],[38.52,6.95],[38.41,6.7],[38.12,6.11],[37.42,4.94],[35.55,2.68],[29.84,0.0511],[24.14,0.777],[20.61,2.13],[16.54,4],[3.43,7.78],[3.39,7.78]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[1,1,1,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[211.46,2.23],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"gr\",\"it\":[{\"nm\":\"Vector\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[-0.76,0.4033],[-0.426,0.4264],[0.242,0.484],[1.11,-0.0461],[1.96,-0.4724],[3.03,0],[3.31,0.4264],[8.39,1.45],[5.46,-0.8872],[0.669,-0.1382],[0.645,-0.1959],[0.645,-0.1959],[0.657,-0.2535],[2.81,-2.06],[0.288,-0.2074],[0.277,-0.2304],[0.576,-0.484],[0.541,-0.5531],[0.3,-0.2996],[0,0],[0.069,-0.0691],[0.081,0.0921],[0.011,-0.0231],[0.012,-0.0115],[0,0],[-0.069,0.0346],[0.011,0.0116],[-0.081,0.5415],[0,0],[0,0],[0.139,2.7],[1.8,3.1],[1.99,0.53],[1.47,-0.3342],[2.12,-1.15],[2.83,-1.9],[1.38,-0.8642],[1.06,-0.6568],[1.64,-0.7604],[0.887,-0.2419],[0.507,0.0922],[0,0.0806],[0,0],[-0.012,0.3226],[-0.069,0.8066],[-0.207,1.95],[0.276,2.55],[0.864,1.5],[1.57,0.6222],[1.35,0.0461],[1.21,-0.1959],[0.576,-0.1383],[0,0],[0,0],[0,0],[0.634,-0.1728],[1.17,-0.4954],[0.565,-0.2765],[0,0],[3.34,-3.2],[3.15,-2.57],[1.07,-0.6107],[0,0],[0,0],[0,0],[0.0692,-0.023],[0.1613,0.0461],[0.1383,0.3111],[0.265,0.6106],[0.1498,0.3341],[0.1728,0.3226],[2.43,1.76],[2.63,-0.0576],[1.92,-0.7028],[0.7835,-0.4494],[0.6913,-0.4379],[1.01,-0.8411],[0.8065,-0.7028],[0,0],[0.1037,-0.0461],[0,0],[0,0],[0.9102,-0.1267],[1.9,0.2304],[3.72,0.9564],[3.86,0.3917],[1.96,-0.1728],[1.86,-0.7375],[0.6683,-0.4608],[0.3226,-0.4609],[-0.2881,-0.3687],[-0.9448,0.219],[-0.6107,0.2189],[-0.8411,0.1959],[-3.32,-0.6107],[-3.65,-1.14],[-4.52,-0.6799],[-2.55,0.2766],[-1.29,0.4148],[0,0],[0,0],[0,0],[-0.1729,0.1959],[0,0],[-0.8988,0.6337],[-0.484,0.3687],[-0.5531,0.3572],[-0.5992,0.3342],[-0.6452,0.2766],[-1.35,0.0922],[-1.15,-0.6683],[-0.9679,-1.64],[-0.2419,-0.4264],[-0.1843,-0.5185],[-0.2189,-0.4955],[-0.2535,-0.4724],[-0.3687,-0.4494],[-2.47,-0.1152],[-1.15,0.4724],[-0.2305,0.1267],[0,0],[0,0],[-2.44,2.62],[-2.78,2.52],[-3.2,1.21],[-0.806,0.2074],[-0.818,0.1152],[0,0],[-0.104,0.023],[0,0],[0,0],[-0.427,0.0691],[-0.784,0.0691],[-0.461,-0.4033],[-0.185,-0.4379],[-0.057,-0.6683],[0.138,-1.49],[0.172,-1.45],[0.046,-1.38],[0,-0.3456],[0,-0.2305],[-0.023,-0.242],[-0.092,-0.4378],[-0.092,-0.4263],[-0.646,-0.4378],[-0.668,-0.2074],[-0.772,-0.0115],[-0.38,0.0461],[0,0],[-2.41,1.34],[-2.16,1.5],[-4.2,2.68],[-2.02,0.6913],[-0.634,-0.0692],[-0.184,-0.1268],[-0.207,-0.2535],[-0.253,-1.01],[-0.081,-1.18],[0.161,-2.49],[0,0],[-0.726,-1.62],[-0.323,-0.3687],[-0.391,-0.2996],[-0.438,-0.2074],[-0.438,-0.0576],[-1.2,0.7144],[-0.484,0.4724],[0,0],[0.034,-0.0576],[0,0],[-0.599,0.5416],[-0.668,0.4494],[0,0],[0,0],[-3.25,0.4609],[-2.51,-0.1037],[-2.69,-0.4263],[-7.07,-0.6107],[-3.37,0.242],[-3.11,1.06],[0,0]],\"o\":[[1.12,-0.3111],[0.772,-0.4033],[0.853,-0.8641],[-0.242,-0.4839],[-1.11,0.0691],[-2.79,0.6683],[-3.03,0.0116],[-6.6,-0.8641],[-9.54,-1.56],[-0.68,0.1153],[-0.668,0.1268],[-0.646,0.1843],[-0.634,0.2419],[-2.56,1.04],[-0.288,0.1959],[-0.265,0.2304],[-0.553,0.4609],[-0.53,0.53],[-0.288,0.2996],[0,0],[-0.058,0.0921],[-0.507,0.6568],[0,-0.0461],[0,0.023],[0,0],[-0.035,0.0461],[0.092,-0.0461],[-0.035,-0.0921],[0,0],[0,0],[0.196,-2.49],[-0.207,-2.7],[-0.876,-1.53],[-1.97,-0.53],[-2.96,0.7259],[-4.16,2.37],[-2.81,1.91],[-1.05,0.6567],[-0.922,0.5646],[-0.807,0.3918],[-0.864,0.2535],[0,0.0231],[0,0],[-0.023,-0.1728],[0.011,-0.7144],[0.15,-1.64],[0.184,-1.96],[-0.173,-1.28],[-0.83,-1.5],[-1.56,-0.6568],[-1.35,-0.0115],[-0.588,0.1152],[0,0],[0,0],[0,0],[-0.645,0.0576],[-1.26,0.2765],[-0.599,0.2305],[0,0],[-4.52,2.35],[-3.33,3.24],[-1.09,0.8988],[0,0],[0,0],[0,0],[-0.0807,0.0461],[-0.1497,0.0346],[-0.3226,-0.0922],[-0.2765,-0.6222],[-0.1498,-0.3342],[-0.1728,-0.3227],[-1.33,-2.55],[-2.41,-1.79],[-2.68,-0.0116],[-0.8988,0.4264],[-0.772,0.4493],[-1.35,0.9103],[-1.07,0.8066],[0,0],[-0.0345,0.0346],[0,0],[0,0],[-0.8757,0.2995],[-1.84,0.2304],[-3.81,-0.4724],[-3.73,-0.9563],[-1.92,-0.1959],[-1.97,0.1729],[-1.03,0.3802],[-0.6337,0.5301],[-0.6452,0.9218],[0.2881,0.3687],[0.4724,-0.1152],[0.6568,-0.1613],[3.01,-0.8757],[3.33,0.5992],[3.66,1.13],[2.25,0.3226],[1.27,-0.1498],[0,0],[0,0],[0,0],[0.2305,-0.0921],[0,0],[0.6683,-0.5761],[0.4378,-0.3226],[0.5069,-0.3226],[0.5416,-0.3802],[0.5991,-0.3572],[1.3,-0.553],[1.37,-0.1267],[1.13,0.7029],[0.2765,0.3572],[0.2305,0.4493],[0.2074,0.4955],[0.0576,0.1267],[0.265,0.507],[1.47,1.8],[1.22,0.0576],[0.2765,-0.1268],[0,0],[0,0],[3.51,-2.22],[2.63,-2.85],[2.75,-2.53],[0.783,-0.3572],[0.807,-0.265],[0,0],[0.103,0],[0,0],[0,0],[0.427,-0.0922],[0.852,-0.1728],[1.54,-0.1152],[0.253,0.1959],[0.184,0.4263],[0.127,1.34],[-0.161,1.5],[-0.173,1.45],[0,0.3456],[0,0.2305],[0,0.2535],[0.058,0.4839],[0.092,0.4378],[0.668,0.5646],[0.679,0.3918],[1.46,0.4609],[0.772,0],[0.369,-0.0461],[3.15,-0.6337],[2.39,-1.36],[4.32,-3.01],[2.09,-1.33],[1,-0.3457],[0.323,0.0345],[0.196,0.0922],[0.403,0.507],[0.265,1.01],[0.196,2.35],[0,0],[-0.127,1.23],[0.184,0.4033],[0.276,0.3802],[0.381,0.3226],[0.438,0.1498],[1.75,0.1959],[0.611,-0.3572],[0,0],[0.185,-0.242],[0,0],[0.553,-0.6222],[0.599,-0.553],[0,0],[0,0],[3.66,-2.1],[3.26,-0.4494],[5.04,0.2765],[8.12,1.37],[3.54,0.3111],[3.36,-0.2304],[0,0],[0,0]],\"v\":[[269.9,21.14],[272.68,19.91],[274.44,18.59],[275.3,16.55],[273.22,15.87],[268.63,16.65],[259.9,17.6],[250.41,16.93],[228.26,12.92],[206.81,12.36],[204.8,12.78],[202.84,13.26],[200.9,13.83],[198.98,14.55],[190.91,18.93],[190.06,19.54],[189.24,20.23],[187.56,21.65],[185.96,23.26],[185.07,24.15],[184.62,24.76],[184.43,25],[182.91,25.8],[182.85,25.95],[182.79,26.04],[182.8,26.03],[182.94,25.91],[183.01,25.83],[183.01,24.77],[183.01,24.68],[183.03,24.58],[183.22,16.81],[181.03,8.17],[176.37,4.58],[171.14,4.59],[163.81,7.69],[153.44,14.37],[147.05,18.6],[143.89,20.58],[140.01,22.72],[137.43,23.7],[135.13,23.96],[134.96,23.87],[134.96,23.81],[134.95,22.85],[135.09,20.54],[135.69,15.2],[135.81,8.6],[134.47,4.37],[130.53,0.888],[126.12,0.0008],[122.31,0.3004],[120.53,0.6345],[119.66,0.8419],[119.26,0.9341],[117.66,1.07],[115.74,1.36],[112.03,2.41],[110.25,3.11],[108.54,3.96],[97.1,12.86],[87.59,21.94],[84.35,24.27],[83.95,24.51],[83.76,24.64],[83.69,24.67],[83.46,24.75],[82.99,24.74],[82.26,24.11],[81.45,22.27],[81.02,21.28],[80.49,20.31],[74.92,13.61],[66.84,11.03],[60.09,12.51],[57.5,13.77],[55.27,15.08],[51.69,17.68],[48.95,19.98],[48.63,20.27],[48.48,20.34],[47.84,20.61],[47.19,20.82],[44.49,21.41],[38.84,21.35],[27.54,18.89],[16.24,16.58],[10.38,16.5],[4.59,17.87],[2.08,19.25],[0.613,20.69],[0.1521,22.64],[2.08,22.88],[3.75,22.45],[5.95,21.81],[15.52,21.67],[25.93,24.52],[38.01,27.61],[45.24,27.8],[49.1,27.01],[50.07,26.71],[51.01,26.32],[51.67,26.04],[52.32,25.67],[53.27,24.84],[55.59,22.95],[56.98,21.92],[58.56,20.9],[60.3,19.92],[62.19,19.05],[66.24,18.06],[69.97,18.94],[73.21,22.39],[73.92,23.67],[74.59,25.05],[75.21,26.54],[75.78,27.8],[76.74,29.23],[82.94,32.33],[86.58,31.7],[87.4,31.31],[87.91,31.01],[88.93,30.38],[97.54,22.83],[105.49,14.56],[114.43,8.67],[116.85,7.93],[119.31,7.56],[120.36,7.46],[120.67,7.39],[120.94,7.33],[121.26,7.25],[122.55,6.95],[125.01,6.59],[128.36,7.12],[128.99,8],[129.36,9.7],[129.22,14.06],[128.68,18.49],[128.31,22.73],[128.29,23.76],[128.29,24.45],[128.35,25.19],[128.51,26.59],[128.8,27.88],[130.76,29.39],[132.76,30.34],[135.87,30.8],[137.57,30.67],[138.12,30.58],[146.2,27.32],[152.96,22.98],[165.59,14.12],[171.84,10.88],[174.43,10.45],[175.16,10.67],[175.75,11.19],[176.8,13.6],[177.32,16.93],[177.29,24.26],[177.32,24.04],[177.85,28.32],[178.57,29.49],[179.62,30.49],[180.89,31.18],[182.22,31.5],[186.65,30.47],[188.26,29.2],[188.93,28.46],[189.34,27.88],[190.91,26.27],[192.74,24.65],[194.67,23.18],[195.66,22.48],[196.71,21.88],[207.24,18.34],[215.92,18.03],[227.16,19.36],[249.74,22.92],[260.09,23.07],[269.88,21.19],[269.9,21.14]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[1,1,1,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,31.44],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"Header purple 1\",\"ddd\":0,\"ty\":4,\"ind\":9,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[575,410.11]},{\"t\":172.73,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[575,410.11]},{\"t\":202.39,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[575,428.54]},{\"t\":337.68,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[575,430.11]},{\"t\":360,\"s\":[575,430.11]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":172.73,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[0]},{\"t\":202.39,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"nm\":\"Header purple 1\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[-6.25,4.56],[-5.17,2.86],[-2.88,1.11],[-2.97,0.1266],[-1.65,-1.04],[-0.8068,-1.57],[-0.1266,-1.85],[0.9017,-1.66],[0.1424,-0.1423],[0.2056,-0.0949],[0.4271,0.1899],[0.6169,0.6802],[0.3481,0.9333],[-0.791,1.91],[-0.6802,0.7435],[0,0],[0,0],[-0.5062,0.4429],[-3.23,0.2215],[-1.5,-0.6486],[-0.4587,-0.2056],[-0.4745,-0.2056],[-4.49,-2.72],[-3.07,-1.52],[-4.1,-0.8384],[-4.41,0.87],[-3.91,2.14],[-0.965,0.5695],[-0.87,0.6486],[0,0],[-0.032,0.0158],[0,0],[-0.348,0.0791],[-0.569,-0.2373],[-0.316,-0.2689],[-0.333,-0.6169],[-0.427,-1.08],[0,0],[-0.205,-0.4271],[-0.602,-0.7752],[-1.63,-0.9017],[-0.854,-0.2532],[-0.427,-0.0949],[-0.221,-0.0316],[-3.67,-0.3638],[-3.75,-0.1423],[-7.15,1.15],[-6.06,3.04],[-0.554,0.4904],[-0.284,0.4429],[0.317,0.5695],[0.996,0.0791],[0.633,-0.1108],[0.823,-0.2056],[6.71,-0.5853],[8.45,0.2215],[6.61,0.9966],[4.03,0.7593],[0.855,0.6644],[0.221,0.3955],[0.079,0.2215],[0.269,0.6485],[1.47,1.85],[2.7,0.8226],[2.28,-0.5853],[0.98,-0.4429],[0,0],[0.459,-0.3164],[0,0],[0,0],[0.696,-0.4746],[1.44,-0.791],[2.93,-0.3955],[2.64,0.5695],[3.13,1.85],[0,0],[1.3,0.8068],[2.64,1.28],[4.26,0.4271],[4.11,-2.18],[0.9966,-0.617],[0.9016,-0.7119],[0,0],[0,0],[0,0],[0.4746,-0.5695],[0.6328,-2.69],[-0.6961,-2.66],[-1.87,-1.85],[-0.522,-0.3639],[-0.5854,-0.3164],[-1.53,-0.1423],[-1.77,2.17],[-0.4587,0.9492],[-0.2056,0.8542],[1.39,3.73],[2.55,1.8],[2.1,0.4113],[1.47,-0.0633],[3.4,-1.42],[2.75,-1.76],[4.16,-3.92],[0,0]],\"o\":[[-5.82,5.65],[4.49,-3.18],[2.59,-1.42],[2.86,-1.09],[3.39,-0.2373],[1.65,1.06],[0.8068,1.58],[0.1265,1.82],[-0.2214,0.348],[-0.1423,0.1582],[-0.3955,0.2057],[-0.3322,-0.0949],[-0.6644,-0.6961],[-0.696,-1.87],[0.3954,-0.9492],[0,0],[0,0],[0.5221,-0.4429],[4.11,-3.51],[3.27,-0.1424],[0.4429,0.2057],[0.4588,0.2373],[1.71,0.7594],[2.26,1.34],[3.07,1.52],[4.08,0.8384],[4.43,-0.8543],[0.981,-0.522],[0.949,-0.5695],[0,0],[0,0],[0,0],[0.379,-0.1582],[1.44,-0.3955],[0.301,0.1108],[0.316,0.3639],[0.506,0.8226],[0,0],[0.126,0.3322],[0.428,0.9175],[1.2,1.57],[0.823,0.4429],[0.427,0.1423],[0.428,0.0791],[4.65,0.6961],[7.35,0.7435],[8.84,0.2057],[7.15,-1.17],[0.839,-0.3797],[0.553,-0.4746],[0.57,-0.8701],[-0.316,-0.5536],[-0.491,-0.0474],[-0.617,0.1265],[-5.76,1.82],[-6.72,0.5695],[-3.29,-0.1266],[-3.31,-0.522],[-2.53,-0.4113],[-0.364,-0.3005],[-0.111,-0.2056],[-0.206,-0.5378],[-0.712,-1.74],[-1.42,-1.84],[-2.91,-0.9017],[-1.11,0.3322],[0,0],[-0.396,0.2215],[0,0],[0,0],[-0.68,0.4904],[-1.38,0.9808],[-2.93,1.38],[-2.93,0.3797],[-5.28,-1.14],[-3.13,-1.91],[0,0],[-1.33,-0.7909],[-2.61,-1.25],[-4.24,-0.4746],[-1.09,0.4746],[-1.01,0.6011],[0,0],[0,0],[0,0],[-0.4113,0.3955],[-1.87,2.06],[-0.6327,2.69],[0.6802,2.64],[0.4746,0.4746],[0.5062,0.3954],[1.19,0.696],[3.12,0.3797],[0.9333,-1.12],[0.4113,-0.9491],[1.27,-5.22],[-1.42,-3.73],[-2.55,-1.84],[-2.14,-0.4113],[-4.49,0.2531],[-3.4,1.44],[-5.49,3.54],[0,0],[0,0]],\"v\":[[2.93,22.25],[7,27.2],[21.33,18.04],[29.52,14.16],[38.43,12.08],[45.67,13.64],[49.25,17.74],[50.64,22.9],[49.6,28.5],[49.11,29.21],[48.58,29.6],[47.26,29.62],[45.25,28.15],[43.66,25.7],[43.76,19.67],[45.39,17.11],[45.93,16.57],[46.7,15.89],[48.24,14.56],[59.88,9.1],[67.27,10.67],[68.61,11.27],[70.02,11.93],[79.35,17.14],[87.31,21.55],[98.08,25.36],[111.16,25.43],[123.77,20.78],[126.64,19.08],[129.4,17.28],[131.84,15.56],[131.92,15.51],[132.24,15.4],[133.33,15.05],[136.46,14.91],[137.34,15.49],[138.36,16.87],[139.76,19.8],[140.08,20.63],[140.63,21.98],[142.2,24.52],[146.54,28.23],[149.05,29.3],[150.35,29.65],[151.5,29.86],[163.99,31.42],[180.53,32.5],[204.32,31.07],[224.1,25.03],[226.17,23.69],[227.42,22.31],[227.75,20.11],[225.73,19.11],[224.03,19.23],[221.9,19.76],[203.33,23.12],[180.78,23.62],[165.82,22.01],[154.79,20.16],[151.06,18.96],[150.16,17.88],[149.87,17.23],[149.16,15.33],[146.11,9.89],[139.73,5.37],[131.75,5.37],[128.55,6.49],[127.41,6.95],[126.33,7.73],[125.23,8.6],[123.23,10.16],[121.15,11.55],[116.86,14.04],[108.03,16.88],[99.63,16.54],[86.83,10.92],[81.8,7.76],[79.78,6.51],[73.89,3.25],[63.63,0.116],[50.37,2.82],[47.37,4.59],[44.58,6.63],[43.22,7.71],[41.97,8.86],[40.72,10.02],[39.42,11.33],[35.56,18.62],[35.66,26.79],[39.68,33.72],[41.15,35],[42.76,36.09],[47.1,37.56],[54.93,34.25],[56.81,31.25],[57.76,28.53],[56.92,15.1],[50.56,6.67],[43.35,3.6],[37.99,3.26],[26.28,6.17],[17.12,11.05],[2.91,22.31],[2.93,22.25]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.7882,0.4863,0.9569,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"Music\",\"ddd\":0,\"ty\":4,\"ind\":10,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[43.75,45.72],\"a\":0},\"p\":{\"k\":[625,742.11],\"a\":0},\"s\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[60.8,60.8]},{\"t\":129.13,\"i\":{\"x\":[0.4],\"y\":[1.4]},\"o\":{\"x\":[0.7],\"y\":[-0.4]},\"s\":[60.8,60.8]},{\"t\":157.43,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[87.55,87.55]},{\"t\":360,\"s\":[87.55,87.55]}]},\"r\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[-8]},{\"t\":129.13,\"i\":{\"x\":[0.4],\"y\":[1.4]},\"o\":{\"x\":[0.7],\"y\":[-0.4]},\"s\":[-8]},{\"t\":157.43,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":360,\"s\":[0]}]},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":129.13,\"i\":{\"x\":[0.4],\"y\":[1.4]},\"o\":{\"x\":[0.7],\"y\":[-0.4]},\"s\":[0]},{\"t\":157.43,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"nm\":\"vector\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[1.07,0],[0,-8.63],[-8.63,0],[-0.4858,8.19],[0,0],[0,0],[0,0],[0,0],[1.07,0],[0,-8.63],[-8.63,0],[-0.118,8.53],[0,0]],\"o\":[[0,0],[0,0],[0,0],[-1.01,-0.205],[-8.63,0],[0,8.63],[8.31,0],[0,0],[0,0],[0,0],[0,0],[-1.01,-0.205],[-8.63,0],[0,8.63],[8.56,0],[0,0],[0,0]],\"v\":[[87.5,69.57],[87.5,0],[18.75,8.52],[18.75,60.51],[15.62,60.2],[0,75.82],[15.62,91.45],[31.22,76.76],[31.25,76.76],[31.25,43.92],[75,39.06],[75,54.26],[71.88,53.95],[56.25,69.57],[71.88,85.2],[87.5,69.79],[87.5,69.57]]},\"a\":0}},{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[75,14.14],[75,26.48],[31.25,31.34],[31.25,19.56],[75,14.14]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.4235,0.4353,0.4667,1],\"a\":0},\"r\":2},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"header c2\",\"ddd\":0,\"ty\":4,\"ind\":11,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[555,816.11]},{\"t\":189.97,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[555,816.11]},{\"t\":219.13,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[575,816.11]},{\"t\":360,\"s\":[575,816.11]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":189.97,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[0]},{\"t\":219.13,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"nm\":\"header\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0.276,0.4641],[0.3155,0.3521],[0.6047,-0.048],[0.3549,-1.2],[-0.1052,-1.01],[-0.7887,-1.23],[-1.88,-0.2881],[-1.39,0.3521],[-2.37,1.3],[-1.18,0.6722],[-0.5652,0.3361],[0,0],[0,0],[-0.0526,0.032],[0,0],[0,0],[0,0],[-0.4338,-0.08],[-0.1972,-0.2401],[-0.1972,-0.3361],[-0.1972,-0.6882],[-0.3024,-1.07],[-0.2235,-0.6081],[-0.3549,-0.4641],[0,0],[-0.184,-0.208],[-0.4075,-0.3041],[-0.4338,-0.16],[-0.4338,-0.08],[-0.8281,0.3201],[-0.3286,0.144],[-0.2892,0.144],[-1.67,1.28],[-0.8544,0.7042],[-0.9859,0.8003],[-1.85,1.58],[-1.93,1.7],[-0.1577,-0.032],[0,0],[0,0],[-0.2498,0],[-0.4338,-0.08],[-0.3944,-0.096],[-1.03,-1.89],[-0.6047,-1.3],[-1.16,-1.44],[-1.7,-0.4802],[-0.6836,0.0481],[-0.3418,0.016],[-0.3155,0.048],[-1.43,0.7042],[-0.8019,0.4481],[-0.8676,0.6402],[-3.35,3.12],[-0.224,0.2081],[0,0.032],[-0.329,0.1601],[-0.565,0.048],[-0.118,0.016],[-0.039,-0.064],[-0.078,-0.048],[-0.092,-0.032],[-0.907,-1.47],[-1.85,-1.57],[-0.5,-0.3361],[-0.539,-0.2401],[-0.538,-0.0961],[0,0],[0,0],[-0.078,0],[0,0],[-1.72,0.4642],[-0.763,0.112],[-0.763,0.128],[-6.26,-0.3521],[-5.77,-0.3681],[-2.96,-0.08],[-5.68,0.8962],[-1.35,0.3041],[-1.3,0.4961],[-2.43,1.28],[5.23,-1.34],[2.48,-0.4961],[1.3,-0.1601],[1.34,-0.096],[6.77,0.2081],[5.36,0.7202],[7.99,0.4641],[2.59,-0.144],[1.46,-0.144],[0.723,-0.064],[0.749,-0.112],[1.49,-0.2721],[1.49,-0.3041],[1.45,-0.4001],[0.683,-0.208],[-0.013,0],[0,0],[0.053,0.016],[0,0],[0.631,0.6882],[0.749,1.22],[1.31,1.34],[0.355,0.2881],[0.42,0.1761],[0.408,0.16],[0.395,0.08],[0.354,0],[0.329,-0.016],[0.315,-0.016],[0.276,-0.064],[0.499,-0.144],[0.407,-0.1761],[0.46,-0.2081],[0.3553,-0.3041],[0.3286,-0.2881],[0,0],[0.9596,-0.8002],[1.74,-1.31],[2.25,-1.06],[0.8939,-0.064],[0,0],[0.092,0],[0.1446,0.032],[0.3155,0.3842],[0.907,1.81],[1.83,1.74],[2.1,0.2721],[0.9727,-0.112],[0.4601,-0.096],[0.6572,-0.112],[0.2761,-0.2561],[0,0],[0,0],[0.6047,-0.5602],[1.14,-1.02],[1.81,-1.42],[1.85,-0.8802],[0.1841,-0.096],[0.0789,-0.0321],[0.1446,0.016],[0.1052,0.2721],[0.0263,0.128],[0.0788,0.3201],[0.3286,0.9923],[1.38,1.14],[0.5258,0.3361],[0.5258,0.1921],[0.4996,0.08],[0.4601,0.032],[0.8545,-0.064],[0.3943,-0.08],[0,0],[0.2892,-0.112],[0,0],[0,0],[0,0],[0.5915,-0.3841],[1.08,-0.7202],[1.87,-0.7522],[0.5915,0],[0.4338,0.4322],[0,0]],\"o\":[[-0.2892,-0.3361],[-0.3024,-0.4321],[-0.5652,-0.7522],[-0.6047,0.048],[-0.1446,0.6242],[0.0657,0.9603],[1.13,1.78],[1.81,0.288],[2.73,-0.7363],[1.14,-0.6562],[0.5652,-0.3201],[0,0],[0,0],[0.1052,-0.048],[0,0],[0,0],[0,0],[0.5127,0],[1.01,0],[0.1446,0.112],[0.184,0.4001],[0.1972,0.6402],[0.1709,0.5601],[0.2892,0.5762],[0,0],[0.1709,0.224],[0.3418,0.4322],[0.4207,0.256],[0.447,0.08],[0.8939,0],[0.3944,-0.128],[0.2892,-0.1441],[2.21,-1.15],[0.815,-0.6242],[0.8808,-0.6882],[1.67,-1.36],[1.81,-1.58],[0.1314,-0.112],[0,0],[0,0],[0.2629,-0.048],[0.4995,-0.016],[0.4732,0.016],[1.58,0.5282],[0.5127,0.9443],[0.6047,1.28],[1.13,1.46],[0.7887,0.176],[0.3549,0],[0.3155,-0.048],[2.45,-0.4481],[1.46,-0.6882],[0.9202,-0.5602],[1.49,-1.2],[0.21,-0.192],[0,0],[0.315,-0.144],[0.815,-0.3521],[0.184,-0.064],[0.092,0.016],[0.053,0.048],[0.066,0.08],[0.408,0.3361],[0.92,1.44],[0.486,0.3521],[0.513,0.3201],[0.539,0.2561],[0,0],[0,0],[0.092,0],[0,0],[1.68,-0.4481],[0.723,-0.224],[0.762,-0.128],[6.12,-0.9443],[8.83,0.2881],[5.78,0.4002],[6.99,0.1761],[1.42,-0.2401],[1.35,-0.3361],[2.6,-0.9283],[5.42,-2.58],[-2.38,0.7362],[-1.24,0.2721],[-1.3,0.128],[-5.4,0.3201],[-2.64,-0.08],[-5.36,-0.6882],[-2.59,-0.1761],[-1.41,0.128],[-0.723,0.064],[-0.736,0.096],[-1.49,0.2241],[-1.49,0.3041],[-1.48,0.2401],[-0.697,0.2081],[0,0],[0,0],[0,0],[0,0],[-0.841,-0.224],[-0.657,-0.6402],[-0.776,-1.18],[-0.276,-0.3361],[-0.381,-0.2721],[-0.408,-0.1921],[-0.407,-0.1761],[-0.381,-0.064],[-0.342,0.016],[-0.328,0.032],[-0.303,0.048],[-0.539,0.16],[-0.447,0.1921],[-0.513,0.2241],[-0.408,0.3521],[-0.4732,0.4001],[-0.6573,0.5602],[0,0],[-0.9596,0.8162],[-1.74,1.26],[-1.12,0.5602],[0,0],[-0.092,-0.016],[-0.1972,0],[-0.2629,-0.128],[-0.631,-0.6722],[-0.8939,-1.79],[-1.81,-1.79],[-1.04,-0.112],[-0.4864,0.032],[-0.6704,0.112],[-0.3813,-0.032],[0,0],[0,0],[-0.6309,0.5762],[-1.24,1.1],[-2.3,2],[-2.69,2.14],[-0.1972,0.0961],[-0.1446,0.064],[-0.1577,0.048],[-0.3023,-0.016],[-0.0526,-0.144],[-0.092,-0.3521],[-0.2235,-0.9443],[-0.6441,-2.02],[-0.4995,-0.4481],[-0.5259,-0.2401],[-0.4996,-0.112],[-0.4863,-0.064],[-0.9465,-0.064],[-0.3944,0.08],[0,0],[-0.2498,0.064],[0,0],[0,0],[0,0],[-0.6047,0.3841],[-1.13,0.7522],[-2.12,1.39],[-0.907,0.3681],[-0.5521,0.064],[0,0],[0,0]],\"v\":[[5.26,14.88],[4.43,13.81],[3.55,12.56],[1.74,11.43],[0.1979,13.22],[0.0402,15.6],[1.3,19.22],[6.11,22.47],[10.75,22.17],[18.23,18.92],[21.72,16.92],[23.41,15.94],[24.23,15.51],[24.62,15.32],[24.7,15.28],[24.83,15.28],[25.23,15.2],[26.08,15.04],[27.63,14.98],[29.51,15.49],[30,16.12],[30.59,17.7],[31.27,20.18],[31.9,22.09],[32.75,23.77],[33.22,24.5],[33.77,25.13],[34.95,26.15],[36.26,26.74],[37.58,27],[40.16,26.63],[41.34,26.26],[42.22,25.83],[47.55,22.25],[50.06,20.26],[52.83,18.04],[58.12,13.59],[63.77,8.66],[64.23,8.45],[64.33,8.45],[64.7,8.4],[65.45,8.37],[66.87,8.42],[68.15,8.67],[71.66,12.05],[73.26,15.41],[75.74,19.61],[80.29,22.79],[82.63,23.11],[83.7,23.09],[84.64,22.95],[90.31,21],[93.62,19.19],[96.26,17.37],[103.84,10.85],[104.48,10.26],[104.48,10.23],[105.47,9.76],[107.69,9.14],[108.04,9.15],[108.31,9.19],[108.52,9.25],[108.75,9.41],[110.75,12.24],[114.76,17.16],[116.25,18.2],[117.84,18.95],[119.45,19.43],[120.53,19.64],[121.08,19.75],[121.35,19.8],[121.61,19.73],[126.71,18.36],[128.94,17.88],[131.22,17.49],[150.04,16.66],[171.93,17.99],[184.98,18.65],[203.85,17.45],[208.01,16.55],[212.01,15.49],[219.6,12.58],[218.28,7.03],[210.93,8.48],[207.11,8.96],[203.16,9.38],[185.14,9.67],[173.1,8.39],[153.09,6.24],[145.27,6.31],[140.97,6.72],[138.79,6.91],[136.57,7.23],[132.11,7.87],[127.66,8.79],[123.28,9.95],[121.2,10.56],[121.23,10.56],[121.16,10.56],[121.03,10.6],[120.68,10.53],[118.55,9.33],[116.52,6.56],[113.68,2.64],[112.66,1.73],[111.53,0.9603],[110.3,0.4161],[109.12,0.144],[107.98,0],[106.97,0.064],[105.99,0.144],[105.15,0.3521],[103.59,0.8002],[102.3,1.34],[100.84,1.98],[99.68,2.98],[98.47,4.02],[97.46,4.88],[95.96,6.13],[91.87,9.36],[85.79,13.14],[82.62,14.08],[82.29,14.12],[82.03,14.07],[81.57,13.96],[80.77,13.32],[78.47,9.25],[74.51,3.51],[68.23,0.4161],[65.16,0.3361],[63.72,0.4801],[61.72,0.8162],[60.81,1.38],[59.97,2.14],[58.91,3.12],[57.05,4.83],[53.49,8.03],[47.26,13.25],[40.17,18.04],[39.58,18.31],[39.32,18.41],[38.86,18.45],[38.21,17.89],[38.08,17.48],[37.83,16.45],[37.01,13.44],[33.8,8.27],[32.22,7.17],[30.63,6.51],[29.12,6.21],[27.72,6.13],[25.15,6.32],[23.98,6.58],[23.37,6.71],[22.56,6.91],[21.77,7.31],[21.24,7.6],[20.26,8.18],[18.46,9.35],[15.14,11.56],[9.15,14.95],[6.72,15.54],[5.22,14.95],[5.26,14.88]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.549,0.5608,0.5922,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"description c2\",\"ddd\":0,\"ty\":4,\"ind\":12,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[575,903.11]},{\"t\":190.15,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[575,903.11]},{\"t\":219.13,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[575,883.11]},{\"t\":360,\"s\":[575,883.11]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":190.15,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[0]},{\"t\":219.13,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"nm\":\"Vector\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0.3455,-0.0231],[0.3179,-0.0808],[0.3731,-0.4271],[-0.2211,-0.6234],[-0.3179,-0.3002],[-0.5666,-0.2539],[-1.82,-0.0924],[-1.76,0.3117],[-3.44,1.34],[-1.85,0.7157],[-0.8431,0.1385],[-0.8292,-0.2078],[-0.6911,-0.6811],[-0.1658,-0.2078],[-0.1382,-0.2655],[-0.1658,-0.254],[-0.2073,-0.3925],[-1.62,-0.6927],[-1.74,0.381],[-0.7877,0.4387],[0,0],[0,0],[0,0],[0,0],[-0.774,0.3116],[-1.26,0.1732],[-0.4837,0.1385],[-2.28,0.2655],[-3.34,-0.1616],[-7.67,-1.71],[-3.79,-0.3001],[-3.7,0.4387],[-3.08,1.2],[3.16,-0.5195],[8.14,0.7965],[9.4,2.12],[1.59,0.1732],[3.66,0.4271],[3.22,0.1616],[2,-0.0924],[0.539,-0.0462],[0,0],[4.33,-1.95],[1.01,-0.5888],[0,0],[0.1244,-0.0577],[0.1382,0.5079],[0,0],[0.1382,0.1963],[0,0],[0.926,0.7042],[2.49,0.1616],[1.76,-0.4156],[1.13,-0.4271],[1.13,-0.4387],[4.27,0.7504],[0,0]],\"o\":[[-0.3731,-0.0924],[-0.3455,0],[-0.6357,0.1732],[-0.3731,0.4271],[0.1106,0.3001],[0.3455,0.2886],[1.63,0.635],[1.82,0.0923],[3.54,-0.6003],[3.81,-1.63],[0.9121,-0.3348],[0.8706,-0.1732],[0.7463,0.1616],[0.1796,0.1385],[0.1659,0.2078],[0.1521,0.2424],[0.1935,0.381],[0.6496,1.42],[1.58,0.6926],[0.8707,-0.1962],[0,0],[0,0],[0,0],[0,0],[0.7739,-0.4156],[3.1,-1.19],[0.5114,-0.0693],[0.8983,-0.1847],[2.29,-0.2424],[6.68,0.254],[10.9,2.26],[4.48,0.4041],[3.72,-0.4502],[3.41,-1.44],[-5.93,0.785],[-3.21,-0.2655],[-1.55,-0.3348],[-3.44,-0.3579],[-3.66,-0.4271],[-3.22,-0.1616],[-1.01,0.0231],[-0.5528,0.0462],[-4.81,0.5079],[-1.05,0.5195],[0,0],[-0.0829,0.0462],[-0.5528,0.2655],[0,0],[-0.1244,-0.1963],[0,0],[-0.6357,-0.7735],[-1.74,-1.44],[-2.93,-0.2193],[-1.73,0.4618],[-2.29,0.8427],[-6.69,2.71],[0,0],[0,0]],\"v\":[[4.07,7.8],[2.99,7.72],[2,7.84],[0.4067,8.77],[0.1026,10.37],[0.7384,11.32],[2.09,12.15],[7.37,13.32],[12.79,12.98],[23.11,9.85],[30.88,6.48],[33.48,5.72],[36.01,5.77],[38.15,6.94],[38.66,7.49],[39.16,8.12],[39.63,8.86],[40.24,10.03],[43.65,13.32],[48.87,13.8],[51.36,12.85],[51.98,12.53],[52.29,12.37],[52.44,12.3],[53.05,12],[55.42,10.97],[62.46,9.07],[63.95,8.76],[68.78,7.91],[77.32,7.65],[99.87,11.1],[121.76,14.71],[134.01,14.65],[144.15,12.14],[142.62,8.18],[122.63,8.27],[103.7,4.06],[99,3.3],[88.21,2.01],[77.7,1.09],[69.65,1.07],[67.3,1.23],[66.45,1.3],[52.51,4.97],[49.34,6.54],[47.99,7.32],[47.63,7.52],[46.21,6.97],[46.07,6.71],[45.72,6.12],[44.88,4.95],[42.64,2.68],[35.79,0.0512],[28.96,0.7785],[24.72,2.13],[19.84,4.01],[4.11,7.8],[4.07,7.8]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.549,0.5608,0.5922,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,6.2],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"gr\",\"it\":[{\"nm\":\"Layer_1-2\",\"ty\":\"gr\",\"it\":[{\"nm\":\"Vector\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[-4.55,3.32],[-3.77,2.09],[-2.1,0.8065],[-2.17,0.0922],[-1.2,-0.7605],[-0.5876,-1.14],[-0.0922,-1.35],[0.6568,-1.21],[0.1037,-0.1037],[0.1498,-0.0692],[0.3111,0.1383],[0.4494,0.4955],[0.2535,0.6798],[-0.5761,1.39],[-0.4955,0.5415],[0,0],[0,0],[-0.3687,0.3226],[-2.35,0.1613],[-1.09,-0.4724],[-0.3341,-0.1498],[-0.3456,-0.1498],[-3.27,-1.98],[-2.24,-1.11],[-2.98,-0.6107],[-3.21,0.6337],[-2.85,1.56],[-0.7029,0.4148],[-0.6337,0.4725],[0,0],[-0.023,0.0115],[0,0],[-0.2535,0.0576],[-0.4148,-0.1728],[-0.23,-0.1958],[-0.242,-0.4494],[-0.311,-0.7835],[0,0],[-0.15,-0.3111],[-0.438,-0.5646],[-1.19,-0.6567],[-0.622,-0.1843],[-0.311,-0.0691],[-0.161,-0.023],[-2.67,-0.265],[-2.73,-0.1037],[-5.21,0.8412],[-4.41,2.21],[-0.403,0.3572],[-0.207,0.3226],[0.23,0.4148],[0.726,0.0576],[0.461,-0.0807],[0.599,-0.1498],[4.88,-0.4263],[6.15,0.1613],[4.82,0.7259],[2.94,0.5531],[0.622,0.4839],[0.162,0.288],[0.058,0.1613],[0.195,0.4724],[1.07,1.35],[1.97,0.5992],[1.66,-0.4263],[0.7144,-0.3226],[0,0],[0.3341,-0.2304],[0,0],[0,0],[0.507,-0.3457],[1.05,-0.5761],[2.13,-0.2881],[1.92,0.4148],[2.28,1.35],[0,0],[0.9449,0.5876],[1.92,0.9333],[3.1,0.3111],[3,-1.59],[0.7259,-0.4494],[0.6567,-0.5185],[0,0],[0,0],[0,0],[0.3457,-0.4148],[0.4609,-1.96],[-0.5069,-1.94],[-1.36,-1.35],[-0.3802,-0.265],[-0.4263,-0.2305],[-1.12,-0.1037],[-1.29,1.58],[-0.3342,0.6913],[-0.1498,0.6222],[1.01,2.72],[1.86,1.31],[1.53,0.2996],[1.07,-0.0461],[2.48,-1.04],[2,-1.28],[3.03,-2.86],[0,0]],\"o\":[[-4.24,4.11],[3.27,-2.32],[1.89,-1.04],[2.09,-0.7951],[2.47,-0.1728],[1.2,0.772],[0.5877,1.15],[0.0922,1.33],[-0.1613,0.2535],[-0.1037,0.1152],[-0.2881,0.1498],[-0.2419,-0.0691],[-0.4839,-0.507],[-0.507,-1.36],[0.2881,-0.6913],[0,0],[0,0],[0.3802,-0.3226],[3,-2.56],[2.39,-0.1037],[0.3226,0.1498],[0.3342,0.1728],[1.24,0.5531],[1.65,0.9794],[2.24,1.11],[2.97,0.6107],[3.23,-0.6222],[0.7143,-0.3803],[0.6913,-0.4148],[0,0],[0,0],[0,0],[0.2765,-0.1152],[1.05,-0.288],[0.2189,0.0807],[0.231,0.265],[0.369,0.5991],[0,0],[0.092,0.2419],[0.311,0.6683],[0.875,1.14],[0.599,0.3227],[0.311,0.1037],[0.311,0.0576],[3.39,0.507],[5.36,0.5416],[6.44,0.1498],[5.21,-0.8526],[0.611,-0.2765],[0.403,-0.3456],[0.415,-0.6337],[-0.23,-0.4033],[-0.357,-0.0345],[-0.449,0.0922],[-4.19,1.33],[-4.9,0.4148],[-2.4,-0.0922],[-2.41,-0.3802],[-1.84,-0.2996],[-0.265,-0.2189],[-0.08,-0.1498],[-0.15,-0.3918],[-0.519,-1.27],[-1.04,-1.34],[-2.12,-0.6568],[-0.8066,0.242],[0,0],[-0.2881,0.1613],[0,0],[0,0],[-0.4954,0.3572],[-1,0.7144],[-2.13,1],[-2.13,0.2765],[-3.85,-0.8296],[-2.28,-1.39],[0,0],[-0.9678,-0.5761],[-1.9,-0.9103],[-3.09,-0.3457],[-0.795,0.3457],[-0.7374,0.4379],[0,0],[0,0],[0,0],[-0.2995,0.2881],[-1.36,1.5],[-0.4609,1.96],[0.4955,1.92],[0.3456,0.3457],[0.3688,0.2881],[0.8642,0.507],[2.27,0.2766],[0.6798,-0.8181],[0.2995,-0.6914],[0.9218,-3.8],[-1.04,-2.72],[-1.86,-1.34],[-1.56,-0.2996],[-3.27,0.1844],[-2.48,1.05],[-4,2.58],[0,0],[0,0]],\"v\":[[2.13,16.2],[5.1,19.81],[15.53,13.14],[21.5,10.32],[27.99,8.8],[33.27,9.94],[35.87,12.92],[36.89,16.68],[36.12,20.76],[35.77,21.27],[35.39,21.56],[34.42,21.57],[32.96,20.5],[31.8,18.72],[31.87,14.33],[33.06,12.46],[33.45,12.07],[34.02,11.57],[35.13,10.6],[43.61,6.63],[48.99,7.77],[49.97,8.21],[51,8.69],[57.8,12.48],[63.59,15.7],[71.44,18.47],[80.97,18.52],[90.15,15.13],[92.24,13.9],[94.25,12.59],[96.03,11.33],[96.09,11.3],[96.32,11.21],[97.11,10.96],[99.39,10.86],[100.04,11.28],[100.78,12.29],[101.8,14.42],[102.03,15.03],[102.44,16.01],[103.58,17.86],[106.73,20.56],[108.56,21.34],[109.51,21.6],[110.35,21.75],[119.44,22.89],[131.49,23.67],[148.82,22.63],[163.23,18.23],[164.74,17.25],[165.65,16.25],[165.89,14.65],[164.41,13.92],[163.18,14],[161.62,14.4],[148.1,16.84],[131.68,17.21],[120.78,16.03],[112.75,14.68],[110.03,13.81],[109.37,13.02],[109.16,12.55],[108.65,11.17],[106.42,7.21],[101.78,3.91],[95.96,3.91],[93.63,4.73],[92.8,5.06],[92.02,5.63],[91.21,6.26],[89.76,7.4],[88.24,8.42],[85.12,10.22],[78.69,12.3],[72.57,12.04],[63.25,7.95],[59.58,5.65],[58.11,4.74],[53.82,2.37],[46.34,0.0845],[36.69,2.05],[34.5,3.35],[32.47,4.83],[31.48,5.62],[30.57,6.46],[29.66,7.3],[28.72,8.25],[25.9,13.57],[25.97,19.51],[28.9,24.56],[29.97,25.49],[31.15,26.29],[34.3,27.36],[40.01,24.95],[41.38,22.76],[42.07,20.78],[41.46,11],[36.83,4.85],[31.57,2.62],[27.67,2.38],[19.14,4.5],[12.47,8.05],[2.12,16.25],[2.13,16.2]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.549,0.5608,0.5922,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[158,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"gr\",\"it\":[{\"nm\":\"Vector\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0.242,0.3341],[0.2765,0.2535],[0.53,-0.0346],[0.3111,-0.8642],[-0.0922,-0.7259],[-0.6913,-0.8872],[-1.65,-0.2074],[-1.22,0.2535],[-2.07,0.9333],[-1.04,0.4839],[-0.4955,0.242],[0,0],[0,0],[-0.046,0.0231],[0,0],[0,0],[0,0],[-0.3802,-0.0576],[-0.1729,-0.1728],[-0.1728,-0.242],[-0.1728,-0.4955],[-0.2651,-0.772],[-0.1959,-0.4379],[-0.3111,-0.3341],[0,0],[-0.1613,-0.1498],[-0.3572,-0.2189],[-0.3802,-0.1153],[-0.3802,-0.0576],[-0.7259,0.2304],[-0.2881,0.1037],[-0.2535,0.1037],[-1.46,0.9218],[-0.7489,0.507],[-0.8641,0.5761],[-1.62,1.14],[-1.69,1.22],[-0.1383,-0.023],[0,0],[0,0],[-0.219,0],[-0.3803,-0.0576],[-0.3456,-0.0691],[-0.8988,-1.36],[-0.53,-0.9333],[-1.01,-1.04],[-1.49,-0.3457],[-0.5991,0.0346],[-0.2996,0.0115],[-0.2765,0.0345],[-1.26,0.5069],[-0.7028,0.3226],[-0.7605,0.4609],[-2.94,2.25],[-0.1959,0.1498],[0,0.023],[-0.288,0.1152],[-0.4955,0.0346],[-0.1037,0.0115],[-0.0345,-0.0461],[-0.0691,-0.0346],[-0.0807,-0.023],[-0.795,-1.06],[-1.62,-1.13],[-0.438,-0.242],[-0.472,-0.1728],[-0.472,-0.0691],[0,0],[0,0],[-0.069,0],[0,0],[-1.51,0.3341],[-0.668,0.0807],[-0.669,0.0922],[-5.48,-0.2534],[-5.06,-0.265],[-2.59,-0.0576],[-4.98,0.6453],[-1.19,0.2189],[-1.14,0.3572],[-2.13,0.9218],[4.59,-0.9679],[2.18,-0.3572],[1.14,-0.1152],[1.18,-0.0691],[5.93,0.1498],[4.7,0.5185],[7,0.3342],[2.27,-0.1037],[1.28,-0.1037],[0.634,-0.0461],[0.657,-0.0807],[1.3,-0.1959],[1.3,-0.2189],[1.27,-0.2881],[0.599,-0.1498],[-0.012,0],[0,0],[0.046,0.0115],[0,0],[0.553,0.4955],[0.657,0.8757],[1.15,0.9679],[0.3111,0.2074],[0.3687,0.1267],[0.3572,0.1152],[0.3457,0.0576],[0.3111,0],[0.288,-0.0115],[0.2766,-0.0115],[0.242,-0.0461],[0.4378,-0.1037],[0.3572,-0.1267],[0.4033,-0.1498],[0.3111,-0.2189],[0.2881,-0.2074],[0,0],[0.8411,-0.5761],[1.52,-0.9448],[1.97,-0.7605],[0.7835,-0.0461],[0,0],[0.0807,0],[0.1268,0.023],[0.2765,0.2765],[0.795,1.3],[1.6,1.26],[1.84,0.1959],[0.8526,-0.0807],[0.4033,-0.0691],[0.5761,-0.0807],[0.242,-0.1844],[0,0],[0,0],[0.53,-0.4033],[1,-0.7374],[1.59,-1.03],[1.62,-0.6338],[0.1613,-0.0691],[0.0691,-0.0231],[0.1267,0.0116],[0.0922,0.1958],[0.023,0.0922],[0.0691,0.2304],[0.288,0.7144],[1.21,0.8181],[0.4608,0.242],[0.4609,0.1383],[0.4379,0.0576],[0.4032,0.023],[0.7489,-0.0461],[0.3457,-0.0576],[0,0],[0.2535,-0.0807],[0,0],[0,0],[0,0],[0.5185,-0.2765],[0.9448,-0.5185],[1.64,-0.5416],[0.5185,0],[0.3802,0.3111],[0,0]],\"o\":[[-0.2535,-0.242],[-0.265,-0.3111],[-0.4955,-0.5415],[-0.53,0.0346],[-0.1267,0.4494],[0.0576,0.6913],[0.9909,1.28],[1.59,0.2074],[2.4,-0.53],[1,-0.4724],[0.4955,-0.2304],[0,0],[0,0],[0.0922,-0.0346],[0,0],[0,0],[0,0],[0.4493,0],[0.8872,0],[0.1267,0.0807],[0.1613,0.288],[0.1728,0.4609],[0.1497,0.4033],[0.2535,0.4148],[0,0],[0.1497,0.1614],[0.2996,0.3111],[0.3687,0.1844],[0.3917,0.0576],[0.7835,0],[0.3457,-0.0922],[0.2535,-0.1037],[1.94,-0.8296],[0.7144,-0.4494],[0.772,-0.4954],[1.46,-0.9794],[1.59,-1.14],[0.1152,-0.0807],[0,0],[0,0],[0.2304,-0.0346],[0.4378,-0.0115],[0.4148,0.0115],[1.38,0.3802],[0.4493,0.6798],[0.53,0.9218],[0.9909,1.05],[0.6913,0.1267],[0.3111,0],[0.2766,-0.0346],[2.14,-0.3226],[1.28,-0.4955],[0.8066,-0.4033],[1.3,-0.8641],[0.1843,-0.1383],[0,0],[0.2765,-0.1037],[0.7144,-0.2535],[0.1613,-0.0461],[0.0807,0.0115],[0.0461,0.0346],[0.0576,0.0576],[0.3572,0.242],[0.8065,1.04],[0.426,0.2535],[0.449,0.2304],[0.472,0.1844],[0,0],[0,0],[0.081,0],[0,0],[1.47,-0.3226],[0.634,-0.1613],[0.669,-0.0921],[5.37,-0.6798],[7.74,0.2074],[5.07,0.288],[6.13,0.1267],[1.24,-0.1728],[1.19,-0.242],[2.28,-0.6683],[4.75,-1.86],[-2.09,0.53],[-1.08,0.1959],[-1.14,0.0922],[-4.74,0.2304],[-2.32,-0.0576],[-4.7,-0.4955],[-2.27,-0.1267],[-1.23,0.0922],[-0.634,0.0461],[-0.645,0.0691],[-1.3,0.1613],[-1.3,0.2189],[-1.3,0.1728],[-0.611,0.1498],[0,0],[0,0],[0,0],[0,0],[-0.738,-0.1613],[-0.576,-0.4609],[-0.68,-0.8527],[-0.2419,-0.242],[-0.3341,-0.1959],[-0.3572,-0.1383],[-0.3572,-0.1267],[-0.3341,-0.0461],[-0.2996,0.0115],[-0.2881,0.023],[-0.265,0.0346],[-0.4724,0.1152],[-0.3918,0.1383],[-0.4494,0.1613],[-0.3572,0.2535],[-0.4148,0.2881],[-0.5761,0.4033],[0,0],[-0.8412,0.5876],[-1.52,0.9103],[-0.9794,0.4033],[0,0],[-0.0806,-0.0115],[-0.1728,0],[-0.2304,-0.0922],[-0.5531,-0.4839],[-0.7835,-1.29],[-1.59,-1.29],[-0.9103,-0.0807],[-0.4263,0.023],[-0.5876,0.0807],[-0.3342,-0.023],[0,0],[0,0],[-0.5531,0.4148],[-1.08,0.795],[-2.02,1.44],[-2.36,1.54],[-0.1728,0.0691],[-0.1267,0.0461],[-0.1383,0.0345],[-0.265,-0.0115],[-0.0461,-0.1037],[-0.0807,-0.2535],[-0.1959,-0.6799],[-0.5646,-1.45],[-0.4378,-0.3226],[-0.4609,-0.1728],[-0.4379,-0.0807],[-0.4263,-0.0461],[-0.8296,-0.0461],[-0.3457,0.0576],[0,0],[-0.2189,0.0461],[0,0],[0,0],[0,0],[-0.53,0.2765],[-0.9909,0.5415],[-1.86,1],[-0.795,0.265],[-0.4839,0.0461],[0,0],[0,0]],\"v\":[[4.61,10.72],[3.88,9.94],[3.11,9.04],[1.52,8.23],[0.1735,9.52],[0.0352,11.23],[1.14,13.84],[5.36,16.18],[9.43,15.96],[15.98,13.62],[19.04,12.18],[20.52,11.48],[21.24,11.16],[21.58,11.03],[21.65,11],[21.77,11],[22.11,10.95],[22.86,10.83],[24.22,10.78],[25.87,11.15],[26.29,11.6],[26.81,12.74],[27.41,14.53],[27.97,15.9],[28.7,17.11],[29.12,17.64],[29.6,18.09],[30.64,18.83],[31.78,19.25],[32.94,19.44],[35.2,19.17],[36.24,18.91],[37.01,18.6],[41.68,16.02],[43.88,14.59],[46.31,12.99],[50.94,9.78],[55.9,6.23],[56.3,6.08],[56.39,6.08],[56.71,6.05],[57.37,6.03],[58.61,6.06],[59.73,6.25],[62.81,8.68],[64.21,11.1],[66.39,14.11],[70.38,16.41],[72.43,16.64],[73.36,16.63],[74.19,16.52],[79.16,15.12],[82.06,13.82],[84.38,12.5],[91.01,7.81],[91.58,7.39],[91.58,7.36],[92.44,7.03],[94.39,6.58],[94.7,6.59],[94.93,6.61],[95.12,6.66],[95.32,6.78],[97.08,8.81],[100.59,12.35],[101.89,13.1],[103.29,13.64],[104.7,13.99],[105.65,14.14],[106.13,14.22],[106.36,14.25],[106.59,14.21],[111.06,13.22],[113.02,12.87],[115.02,12.59],[131.51,11.99],[150.7,12.95],[162.14,13.42],[178.68,12.56],[182.33,11.91],[185.83,11.15],[192.48,9.06],[191.33,5.06],[184.89,6.11],[181.53,6.45],[178.08,6.75],[162.28,6.96],[151.72,6.04],[134.19,4.49],[127.33,4.54],[123.56,4.84],[121.65,4.98],[119.7,5.21],[115.8,5.67],[111.89,6.33],[108.06,7.17],[106.24,7.6],[106.26,7.6],[106.2,7.6],[106.09,7.63],[105.78,7.58],[103.91,6.72],[102.13,4.72],[99.64,1.9],[98.75,1.24],[97.76,0.6913],[96.68,0.2996],[95.65,0.1037],[94.64,0],[93.76,0.0461],[92.9,0.1037],[92.17,0.2535],[90.8,0.5761],[89.67,0.9679],[88.39,1.43],[87.37,2.14],[86.31,2.89],[85.43,3.51],[84.11,4.41],[80.53,6.74],[75.19,9.46],[72.42,10.14],[72.13,10.16],[71.9,10.13],[71.5,10.05],[70.79,9.59],[68.78,6.66],[65.31,2.52],[59.8,0.2996],[57.12,0.242],[55.85,0.3457],[54.1,0.5876],[53.3,0.9909],[52.57,1.54],[51.63,2.25],[50.01,3.48],[46.88,5.78],[41.42,9.54],[35.21,12.99],[34.69,13.18],[34.46,13.25],[34.06,13.29],[33.5,12.88],[33.38,12.58],[33.16,11.84],[32.44,9.68],[29.62,5.96],[28.24,5.16],[26.85,4.69],[25.52,4.47],[24.3,4.41],[22.04,4.55],[21.02,4.74],[20.49,4.83],[19.77,4.98],[19.08,5.27],[18.62,5.47],[17.76,5.89],[16.18,6.73],[13.27,8.32],[8.02,10.76],[5.89,11.19],[4.57,10.76],[4.61,10.72]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.549,0.5608,0.5922,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,51.4],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"Header purple 2\",\"ddd\":0,\"ty\":4,\"ind\":13,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1007,418.11]},{\"t\":107.64,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[1007,418.11]},{\"t\":136.44,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1007,436.54]},{\"t\":272.59,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1007,438.11]},{\"t\":360,\"s\":[1007,438.11]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":107.64,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[0]},{\"t\":136.44,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"nm\":\"Layer_1-2\",\"ty\":\"gr\",\"it\":[{\"nm\":\"Vector\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[-5.45,4.7],[-4.32,3.57],[-5.45,3.54],[-2.18,-0.285],[-0.915,-1.19],[-0.555,-2.37],[-0.36,-2.5],[-0.615,-2.96],[-0.75,-1.66],[-0.3,-0.48],[-0.375,-0.465],[-1.09,-0.51],[-1.2,-0.03],[-0.57,0.105],[-0.405,0.135],[-1.35,0.78],[-0.615,0.405],[0,0],[-0.24,0.225],[0,0],[-0.885,0.795],[-1.55,1.25],[-1.44,0.9],[-0.81,0.57],[-3.67,1.36],[-1.7,-0.21],[-1.29,-1.8],[-0.48,-1.27],[-0.27,-0.87],[-0.945,-1.09],[-2.9,-0.465],[-1.45,0.285],[-1.19,0.75],[-6.75,0.525],[-4.03,-0.285],[-3.24,-0.45],[-3.3,-0.495],[-6.69,0.3],[-5.73,2.31],[-0.6,0.75],[0.24,0.57],[0.9,0.18],[1.51,-0.27],[15.41,2.28],[6.18,1.23],[3.93,0.51],[4.86,-0.165],[3.11,-0.81],[3.28,-1.57],[0.81,-0.405],[0.765,-0.495],[0,0],[0.345,-0.12],[0.69,1.3],[0.045,0.195],[0,0],[0,0],[0.36,0.825],[0.99,1.48],[1.53,0.99],[1.55,0.315],[1.98,-0.39],[0.975,-0.375],[0,0],[1.35,-0.66],[2.19,-1.39],[5.43,-5.31],[0.69,-0.675],[0.015,0.06],[1.19,-0.405],[0.285,0],[0.195,0.18],[0.075,0.105],[0.135,0.315],[0.225,0.75],[0.54,3.3],[0.96,2.8],[1.53,1.82],[2.13,0.555],[1.59,-0.225],[1.22,-0.405],[2.05,-1.28],[4.23,-3.97],[3.42,-3.9],[0,0]],\"o\":[[-4.8,5.53],[3.88,-3.3],[4.32,-3.54],[6.04,-4.09],[1.06,0.105],[0.885,1.2],[0.51,2],[0.375,2.52],[0.33,1.48],[0.18,0.405],[0.24,0.45],[0.78,0.9],[1.07,0.555],[0.6,0],[0.585,-0.09],[1.86,-0.54],[0.69,-0.39],[0,0],[0.225,-0.195],[0,0],[0.9,-0.87],[1.75,-1.59],[3.12,-2.47],[0.855,-0.54],[1.45,-0.96],[1.8,-0.645],[1.71,0.165],[0.645,0.855],[0.27,0.855],[0.48,1.32],[1.85,2.23],[1.45,0.225],[1.44,-0.315],[5.61,-3.58],[4.77,-0.45],[4.03,0.3],[6.54,0.975],[7.91,1.12],[6.68,-0.315],[1.59,-0.585],[0.6,-0.75],[-0.24,-0.57],[-0.915,-0.195],[-10.86,2.39],[-3.01,-0.42],[-3.09,-0.615],[-3.94,-0.495],[-3.16,0.135],[-3.33,0.9],[-0.84,0.36],[-0.81,0.405],[0,0],[-0.315,0.24],[-1.44,0.405],[-0.075,-0.18],[0,0],[0,0],[-0.255,-0.84],[-0.585,-1.65],[-1.09,-1.46],[-1.5,-0.975],[-3.12,-0.705],[-2,0.42],[-0.99,0.375],[0,0],[-1.35,0.66],[-4.38,2.79],[-0.675,0.675],[-0.63,0.63],[-1.28,0.93],[-0.69,0.24],[-0.255,0],[-0.09,-0.09],[-0.075,-0.165],[-0.285,-0.54],[-0.885,-3.07],[-0.54,-3.33],[-0.75,-2.1],[-1.52,-1.81],[-2.15,-0.585],[-1.62,0.225],[-4.7,1.77],[-6.11,4],[-4.21,3.99],[0,0],[0,0]],\"v\":[[2.24,30.04],[6.5,34.36],[18.68,24.12],[33.15,13.23],[45.56,7.93],[48.39,9.69],[50.6,15.04],[51.84,21.87],[53.15,30.06],[54.62,34.75],[55.31,36.07],[56.3,37.48],[59.1,39.72],[62.58,40.56],[64.38,40.45],[65.97,40.11],[70.67,38.04],[72.6,36.84],[73.31,36.36],[73.97,35.73],[74.69,35.04],[77.37,32.55],[82.38,28.3],[89.51,23.22],[92.01,21.57],[99.95,17.37],[105.52,16.44],[109.78,19.06],[111.41,22.42],[112.2,25],[114.32,28.71],[121.73,32.91],[126.14,32.8],[130.19,31.12],[149.22,25],[162.47,25],[173.38,26.22],[188.01,28.39],[209.76,29.8],[228.4,26.02],[231.62,23.83],[232.12,21.81],[230.36,20.64],[226.78,20.83],[189.2,20.04],[175.43,17.34],[164.9,15.6],[151.72,14.91],[142.26,16.26],[132.22,19.86],[129.78,21.1],[127.42,22.47],[125.28,23.8],[124.28,24.27],[120.42,22.59],[120.2,22.06],[120.09,21.76],[119.9,21.13],[119.06,18.64],[116.6,13.92],[112.73,10.11],[108.06,8.1],[100.36,8.11],[95.9,9.4],[94.38,9.99],[92.25,10.98],[86.85,14.07],[71.55,26.53],[69.51,28.56],[67.95,30.15],[63.95,32.43],[62.84,32.67],[62.13,32.38],[61.88,32.1],[61.53,31.48],[60.78,29.47],[58.92,19.51],[56.81,10.21],[53.58,4.23],[47.76,0.4339],[42.12,0.1789],[37.97,1.23],[28.61,6.06],[13.55,18.19],[2.25,29.95],[2.24,30.04]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.7882,0.4863,0.9569,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"Cloud\",\"ddd\":0,\"ty\":4,\"ind\":14,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[50,33.66],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1060.77,746.02]},{\"t\":134.89,\"i\":{\"x\":[0.4],\"y\":[1.4]},\"o\":{\"x\":[0.7],\"y\":[-0.4]},\"s\":[1060.77,746.02]},{\"t\":165.06,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1061.69,747.17]},{\"t\":360,\"s\":[1061.69,747.17]}]},\"s\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[64.7,64.7]},{\"t\":134.89,\"i\":{\"x\":[0.4],\"y\":[1.4]},\"o\":{\"x\":[0.7],\"y\":[-0.4]},\"s\":[64.7,64.7]},{\"t\":165.06,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100,100]},{\"t\":360,\"s\":[100,100]}]},\"r\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[-8]},{\"t\":134.89,\"i\":{\"x\":[0.4],\"y\":[1.4]},\"o\":{\"x\":[0.7],\"y\":[-0.4]},\"s\":[-8]},{\"t\":165.06,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":360,\"s\":[0]}]},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":134.89,\"i\":{\"x\":[0.4],\"y\":[1.4]},\"o\":{\"x\":[0.7],\"y\":[-0.4]},\"s\":[0]},{\"t\":165.06,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"nm\":\"vector\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[-5.56,-8.25],[-1.44,0],[0,-14.97],[14.75,-0.2188],[0,0],[0,0],[0,11.34],[-7.81,3],[-15.81,0],[0,0]],\"o\":[[10.28,0],[1.41,-0.2188],[14.97,0],[0,14.97],[0,0],[0,0],[-11.34,0],[0,-8.66],[1.44,-15.44],[0,0],[0,0]],\"v\":[[43.47,0.0625],[68.66,13.47],[72.91,13.12],[100,40.22],[73.34,67.31],[72.91,67.31],[20.56,67.31],[0,46.75],[13.22,27.53],[43.47,0],[43.47,0.0625]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.4235,0.4353,0.4667,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"header c3\",\"ddd\":0,\"ty\":4,\"ind\":15,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[990,824.11]},{\"t\":109.51,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[990,824.11]},{\"t\":138.1,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1010,824.11]},{\"t\":360,\"s\":[1010,824.11]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":109.51,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[0]},{\"t\":138.1,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"nm\":\"header\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0.3955,-0.0317],[0.3638,-0.1108],[0.4271,-0.5853],[-0.2531,-0.8543],[-0.3638,-0.4113],[-0.6486,-0.348],[-2.09,-0.1266],[-2.01,0.4271],[-3.94,1.83],[-2.12,0.9808],[-0.9649,0.1898],[-0.9491,-0.2847],[-0.791,-0.9333],[-0.1898,-0.2847],[-0.1582,-0.3638],[-0.1898,-0.3481],[-0.2373,-0.5378],[-1.85,-0.9492],[-1.99,0.522],[-0.9017,0.6011],[0,0],[0,0],[0,0],[0,0],[-0.8859,0.4271],[-1.44,0.2373],[-0.5537,0.1898],[-2.61,0.3638],[-3.83,-0.2215],[-8.78,-2.34],[-4.33,-0.4113],[-4.24,0.6011],[-3.53,1.65],[3.62,-0.7118],[9.32,1.09],[10.76,2.91],[1.82,0.2373],[4.19,0.5853],[3.69,0.2215],[2.29,-0.1265],[0.6169,-0.0633],[0,0],[4.95,-2.67],[1.15,-0.8068],[0,0],[0.1424,-0.079],[0.1582,0.6961],[0,0],[0.1582,0.2689],[0,0],[1.06,0.965],[2.85,0.2215],[2.01,-0.5695],[1.3,-0.5853],[1.3,-0.6011],[4.89,1.03],[0,0]],\"o\":[[-0.4271,-0.1265],[-0.3955,0],[-0.7277,0.2373],[-0.4271,0.5853],[0.1266,0.4113],[0.3955,0.3955],[1.87,0.8701],[2.09,0.1265],[4.05,-0.8226],[4.37,-2.23],[1.04,-0.4588],[0.9966,-0.2373],[0.8543,0.2215],[0.2056,0.1898],[0.1898,0.2847],[0.174,0.3322],[0.2215,0.522],[0.7435,1.95],[1.8,0.9491],[0.9966,-0.269],[0,0],[0,0],[0,0],[0,0],[0.8859,-0.5695],[3.54,-1.63],[0.5853,-0.0949],[1.03,-0.2531],[2.63,-0.3322],[7.64,0.348],[12.48,3.1],[5.13,0.5536],[4.25,-0.617],[3.91,-1.98],[-6.79,1.08],[-3.67,-0.3638],[-1.77,-0.4588],[-3.94,-0.4904],[-4.19,-0.5853],[-3.69,-0.2215],[-1.15,0.0316],[-0.6328,0.0633],[-5.51,0.696],[-1.2,0.7119],[0,0],[-0.0949,0.0633],[-0.6328,0.3639],[0,0],[-0.1424,-0.2689],[0,0],[-0.7277,-1.06],[-1.99,-1.98],[-3.35,-0.3006],[-1.98,0.6328],[-2.63,1.15],[-7.66,3.72],[0,0],[0,0]],\"v\":[[4.66,10.68],[3.42,10.57],[2.28,10.75],[0.4655,12.01],[0.1175,14.21],[0.8452,15.51],[2.4,16.65],[8.44,18.25],[14.64,17.79],[26.46,13.5],[35.35,8.88],[38.32,7.84],[41.22,7.9],[43.67,9.51],[44.25,10.26],[44.82,11.13],[45.36,12.14],[46.06,13.74],[49.96,18.25],[55.94,18.91],[58.79,17.61],[59.5,17.17],[59.85,16.95],[60.02,16.85],[60.72,16.44],[63.44,15.04],[71.49,12.42],[73.2,12],[78.72,10.84],[88.5,10.48],[114.32,15.21],[139.37,20.16],[153.39,20.08],[165,16.63],[163.24,11.21],[140.37,11.33],[118.7,5.56],[113.32,4.52],[100.97,2.76],[88.94,1.49],[79.72,1.46],[77.03,1.68],[76.07,1.78],[60.1,6.81],[56.48,8.96],[54.93,10.04],[54.52,10.31],[52.89,9.55],[52.73,9.2],[52.34,8.39],[51.37,6.78],[48.81,3.68],[40.96,0.0702],[33.15,1.07],[28.29,2.92],[22.71,5.5],[4.71,10.68],[4.66,10.68]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.549,0.5608,0.5922,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"description c3\",\"ddd\":0,\"ty\":4,\"ind\":16,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1010,904.66]},{\"t\":109.69,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[1010,904.66]},{\"t\":139.72,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1010,884.66]},{\"t\":360,\"s\":[1010,884.66]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":109.69,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[0]},{\"t\":139.72,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"nm\":\"Vector\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0.242,0.3341],[0.2765,0.2535],[0.53,-0.0346],[0.3111,-0.8642],[-0.0922,-0.7259],[-0.6913,-0.8872],[-1.65,-0.2074],[-1.22,0.2535],[-2.07,0.9333],[-1.04,0.4839],[-0.4955,0.242],[0,0],[0,0],[-0.046,0.0231],[0,0],[0,0],[0,0],[-0.3802,-0.0576],[-0.1729,-0.1728],[-0.1728,-0.242],[-0.1728,-0.4955],[-0.2651,-0.772],[-0.1959,-0.4379],[-0.3111,-0.3341],[0,0],[-0.1613,-0.1498],[-0.3572,-0.2189],[-0.3802,-0.1153],[-0.3802,-0.0576],[-0.7259,0.2304],[-0.2881,0.1037],[-0.2535,0.1037],[-1.46,0.9218],[-0.7489,0.507],[-0.8641,0.5761],[-1.62,1.14],[-1.69,1.22],[-0.1383,-0.023],[0,0],[0,0],[-0.219,0],[-0.3803,-0.0576],[-0.3456,-0.0691],[-0.8988,-1.36],[-0.53,-0.9333],[-1.01,-1.04],[-1.49,-0.3457],[-0.5991,0.0346],[-0.2996,0.0115],[-0.2765,0.0345],[-1.26,0.5069],[-0.7028,0.3226],[-0.7605,0.4609],[-2.94,2.25],[-0.1959,0.1498],[0,0.023],[-0.288,0.1152],[-0.4955,0.0346],[-0.1037,0.0115],[-0.0345,-0.0461],[-0.0691,-0.0346],[-0.0807,-0.023],[-0.795,-1.06],[-1.62,-1.13],[-0.438,-0.242],[-0.472,-0.1728],[-0.472,-0.0691],[0,0],[0,0],[-0.069,0],[0,0],[-1.51,0.3341],[-0.668,0.0807],[-0.669,0.0922],[-5.48,-0.2534],[-5.06,-0.265],[-2.59,-0.0576],[-4.98,0.6453],[-1.19,0.2189],[-1.14,0.3572],[-2.13,0.9218],[4.59,-0.9679],[2.18,-0.3572],[1.14,-0.1152],[1.18,-0.0691],[5.93,0.1498],[4.7,0.5185],[7,0.3342],[2.27,-0.1037],[1.28,-0.1037],[0.634,-0.0461],[0.657,-0.0807],[1.3,-0.1959],[1.3,-0.2189],[1.27,-0.2881],[0.599,-0.1498],[-0.012,0],[0,0],[0.046,0.0115],[0,0],[0.553,0.4955],[0.657,0.8757],[1.15,0.9679],[0.3111,0.2074],[0.3687,0.1267],[0.3572,0.1152],[0.3457,0.0576],[0.3111,0],[0.288,-0.0115],[0.2766,-0.0115],[0.242,-0.0461],[0.4378,-0.1037],[0.3572,-0.1267],[0.4033,-0.1498],[0.3111,-0.2189],[0.2881,-0.2074],[0,0],[0.8411,-0.5761],[1.52,-0.9448],[1.97,-0.7605],[0.7835,-0.0461],[0,0],[0.0807,0],[0.1268,0.023],[0.2765,0.2765],[0.795,1.3],[1.6,1.26],[1.84,0.1959],[0.8526,-0.0807],[0.4033,-0.0691],[0.5761,-0.0807],[0.242,-0.1844],[0,0],[0,0],[0.53,-0.4033],[1,-0.7374],[1.59,-1.03],[1.62,-0.6338],[0.1613,-0.0691],[0.0691,-0.0231],[0.1267,0.0116],[0.0922,0.1958],[0.023,0.0922],[0.0691,0.2304],[0.288,0.7144],[1.21,0.8181],[0.4608,0.242],[0.4609,0.1383],[0.4379,0.0576],[0.4032,0.023],[0.7489,-0.0461],[0.3457,-0.0576],[0,0],[0.2535,-0.0807],[0,0],[0,0],[0,0],[0.5185,-0.2765],[0.9448,-0.5185],[1.64,-0.5416],[0.5185,0],[0.3802,0.3111],[0,0]],\"o\":[[-0.2535,-0.242],[-0.265,-0.3111],[-0.4955,-0.5415],[-0.53,0.0346],[-0.1267,0.4494],[0.0576,0.6913],[0.9909,1.28],[1.59,0.2074],[2.4,-0.53],[1,-0.4724],[0.4955,-0.2304],[0,0],[0,0],[0.0922,-0.0346],[0,0],[0,0],[0,0],[0.4493,0],[0.8872,0],[0.1267,0.0807],[0.1613,0.288],[0.1728,0.4609],[0.1497,0.4033],[0.2535,0.4148],[0,0],[0.1497,0.1614],[0.2996,0.3111],[0.3687,0.1844],[0.3917,0.0576],[0.7835,0],[0.3457,-0.0922],[0.2535,-0.1037],[1.94,-0.8296],[0.7144,-0.4494],[0.772,-0.4954],[1.46,-0.9794],[1.59,-1.14],[0.1152,-0.0807],[0,0],[0,0],[0.2304,-0.0346],[0.4378,-0.0115],[0.4148,0.0115],[1.38,0.3802],[0.4493,0.6798],[0.53,0.9218],[0.9909,1.05],[0.6913,0.1267],[0.3111,0],[0.2766,-0.0346],[2.14,-0.3226],[1.28,-0.4955],[0.8066,-0.4033],[1.3,-0.8641],[0.1843,-0.1383],[0,0],[0.2765,-0.1037],[0.7144,-0.2535],[0.1613,-0.0461],[0.0807,0.0115],[0.0461,0.0346],[0.0576,0.0576],[0.3572,0.242],[0.8065,1.04],[0.426,0.2535],[0.449,0.2304],[0.472,0.1844],[0,0],[0,0],[0.081,0],[0,0],[1.47,-0.3226],[0.634,-0.1613],[0.669,-0.0921],[5.37,-0.6798],[7.74,0.2074],[5.07,0.288],[6.13,0.1267],[1.24,-0.1728],[1.19,-0.242],[2.28,-0.6683],[4.75,-1.86],[-2.09,0.53],[-1.08,0.1959],[-1.14,0.0922],[-4.74,0.2304],[-2.32,-0.0576],[-4.7,-0.4955],[-2.27,-0.1267],[-1.23,0.0922],[-0.634,0.0461],[-0.645,0.0691],[-1.3,0.1613],[-1.3,0.2189],[-1.3,0.1728],[-0.611,0.1498],[0,0],[0,0],[0,0],[0,0],[-0.738,-0.1613],[-0.576,-0.4609],[-0.68,-0.8527],[-0.2419,-0.242],[-0.3341,-0.1959],[-0.3572,-0.1383],[-0.3572,-0.1267],[-0.3341,-0.0461],[-0.2996,0.0115],[-0.2881,0.023],[-0.265,0.0346],[-0.4724,0.1152],[-0.3918,0.1383],[-0.4494,0.1613],[-0.3572,0.2535],[-0.4148,0.2881],[-0.5761,0.4033],[0,0],[-0.8412,0.5876],[-1.52,0.9103],[-0.9794,0.4033],[0,0],[-0.0806,-0.0115],[-0.1728,0],[-0.2304,-0.0922],[-0.5531,-0.4839],[-0.7835,-1.29],[-1.59,-1.29],[-0.9103,-0.0807],[-0.4263,0.023],[-0.5876,0.0807],[-0.3342,-0.023],[0,0],[0,0],[-0.5531,0.4148],[-1.08,0.795],[-2.02,1.44],[-2.36,1.54],[-0.1728,0.0691],[-0.1267,0.0461],[-0.1383,0.0345],[-0.265,-0.0115],[-0.0461,-0.1037],[-0.0807,-0.2535],[-0.1959,-0.6799],[-0.5646,-1.45],[-0.4378,-0.3226],[-0.4609,-0.1728],[-0.4379,-0.0807],[-0.4263,-0.0461],[-0.8296,-0.0461],[-0.3457,0.0576],[0,0],[-0.2189,0.0461],[0,0],[0,0],[0,0],[-0.53,0.2765],[-0.9909,0.5415],[-1.86,1],[-0.795,0.265],[-0.4839,0.0461],[0,0],[0,0]],\"v\":[[4.61,10.72],[3.88,9.94],[3.11,9.04],[1.52,8.23],[0.1735,9.52],[0.0352,11.23],[1.14,13.84],[5.36,16.18],[9.43,15.96],[15.98,13.62],[19.04,12.18],[20.52,11.48],[21.24,11.16],[21.58,11.03],[21.65,11],[21.77,11],[22.11,10.95],[22.86,10.83],[24.22,10.78],[25.87,11.15],[26.29,11.6],[26.81,12.74],[27.41,14.53],[27.97,15.9],[28.7,17.11],[29.12,17.64],[29.6,18.09],[30.64,18.83],[31.78,19.25],[32.94,19.44],[35.2,19.17],[36.24,18.91],[37.01,18.6],[41.68,16.02],[43.88,14.59],[46.31,12.99],[50.94,9.78],[55.9,6.23],[56.3,6.08],[56.39,6.08],[56.71,6.05],[57.37,6.03],[58.61,6.06],[59.73,6.25],[62.81,8.68],[64.21,11.1],[66.39,14.11],[70.38,16.41],[72.43,16.64],[73.36,16.63],[74.19,16.52],[79.16,15.12],[82.06,13.82],[84.38,12.5],[91.01,7.81],[91.58,7.39],[91.58,7.36],[92.44,7.03],[94.39,6.58],[94.7,6.59],[94.93,6.61],[95.12,6.66],[95.32,6.78],[97.08,8.81],[100.59,12.35],[101.89,13.1],[103.29,13.64],[104.7,13.99],[105.65,14.14],[106.13,14.22],[106.36,14.25],[106.59,14.21],[111.06,13.22],[113.02,12.87],[115.02,12.59],[131.51,11.99],[150.7,12.95],[162.14,13.42],[178.68,12.56],[182.33,11.91],[185.83,11.15],[192.48,9.06],[191.33,5.06],[184.89,6.11],[181.53,6.45],[178.08,6.75],[162.28,6.96],[151.72,6.04],[134.19,4.49],[127.33,4.54],[123.56,4.84],[121.65,4.98],[119.7,5.21],[115.8,5.67],[111.89,6.33],[108.06,7.17],[106.24,7.6],[106.26,7.6],[106.2,7.6],[106.09,7.63],[105.78,7.58],[103.91,6.72],[102.13,4.72],[99.64,1.9],[98.75,1.24],[97.76,0.6913],[96.68,0.2996],[95.65,0.1037],[94.64,0],[93.76,0.0461],[92.9,0.1037],[92.17,0.2535],[90.8,0.5761],[89.67,0.9679],[88.39,1.43],[87.37,2.14],[86.31,2.89],[85.43,3.51],[84.11,4.41],[80.53,6.74],[75.19,9.46],[72.42,10.14],[72.13,10.16],[71.9,10.13],[71.5,10.05],[70.79,9.59],[68.78,6.66],[65.31,2.52],[59.8,0.2996],[57.12,0.242],[55.85,0.3457],[54.1,0.5876],[53.3,0.9909],[52.57,1.54],[51.63,2.25],[50.01,3.48],[46.88,5.78],[41.42,9.54],[35.21,12.99],[34.69,13.18],[34.46,13.25],[34.06,13.29],[33.5,12.88],[33.38,12.58],[33.16,11.84],[32.44,9.68],[29.62,5.96],[28.24,5.16],[26.85,4.69],[25.52,4.47],[24.3,4.41],[22.04,4.55],[21.02,4.74],[20.49,4.83],[19.77,4.98],[19.08,5.27],[18.62,5.47],[17.76,5.89],[16.18,6.73],[13.27,8.32],[8.02,10.76],[5.89,11.19],[4.57,10.76],[4.61,10.72]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.549,0.5608,0.5922,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"gr\",\"it\":[{\"nm\":\"Vector\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0.288,-0.0231],[0.265,-0.0807],[0.3111,-0.4263],[-0.1844,-0.6222],[-0.265,-0.2996],[-0.4724,-0.2535],[-1.52,-0.0922],[-1.46,0.3111],[-2.87,1.34],[-1.54,0.7144],[-0.7029,0.1383],[-0.6913,-0.2074],[-0.5761,-0.6798],[-0.1383,-0.2074],[-0.1152,-0.265],[-0.1383,-0.2535],[-0.1728,-0.3917],[-1.35,-0.6914],[-1.45,0.3802],[-0.6567,0.4378],[0,0],[0,0],[0,0],[0,0],[-0.6453,0.3111],[-1.05,0.1728],[-0.4033,0.1383],[-1.9,0.265],[-2.79,-0.1613],[-6.39,-1.71],[-3.16,-0.2995],[-3.09,0.4379],[-2.57,1.2],[2.64,-0.5185],[6.79,0.795],[7.84,2.12],[1.32,0.1728],[3.05,0.4263],[2.68,0.1613],[1.67,-0.0922],[0.4494,-0.0461],[0,0],[3.61,-1.95],[0.8411,-0.5876],[0,0],[0.1037,-0.0576],[0.1153,0.507],[0,0],[0.1152,0.1959],[0,0],[0.772,0.7029],[2.07,0.1613],[1.46,-0.4148],[0.9448,-0.4263],[0.9448,-0.4378],[3.56,0.749],[0,0]],\"o\":[[-0.3111,-0.0922],[-0.2881,0],[-0.53,0.1728],[-0.3111,0.4263],[0.0922,0.2996],[0.2881,0.2881],[1.36,0.6337],[1.52,0.0921],[2.95,-0.5991],[3.18,-1.62],[0.7605,-0.3341],[0.7259,-0.1728],[0.6222,0.1613],[0.1498,0.1383],[0.1383,0.2074],[0.1268,0.242],[0.1613,0.3802],[0.5416,1.42],[1.31,0.6913],[0.7259,-0.1959],[0,0],[0,0],[0,0],[0,0],[0.6453,-0.4148],[2.58,-1.19],[0.4263,-0.0691],[0.7489,-0.1844],[1.91,-0.242],[5.57,0.2535],[9.09,2.26],[3.73,0.4033],[3.1,-0.4493],[2.85,-1.44],[-4.94,0.7835],[-2.67,-0.265],[-1.29,-0.3341],[-2.87,-0.3572],[-3.05,-0.4263],[-2.68,-0.1613],[-0.8412,0.0231],[-0.4609,0.0461],[-4.01,0.507],[-0.8757,0.5185],[0,0],[-0.0691,0.0461],[-0.4609,0.265],[0,0],[-0.1037,-0.1959],[0,0],[-0.53,-0.772],[-1.45,-1.44],[-2.44,-0.2189],[-1.44,0.4609],[-1.91,0.8411],[-5.58,2.71],[0,0],[0,0]],\"v\":[[3.39,7.78],[2.49,7.7],[1.66,7.83],[0.3391,8.75],[0.0856,10.35],[0.6156,11.3],[1.74,12.13],[6.15,13.29],[10.66,12.96],[19.27,9.83],[25.75,6.47],[27.91,5.71],[30.02,5.75],[31.81,6.93],[32.23,7.47],[32.65,8.11],[33.04,8.84],[33.55,10.01],[36.39,13.29],[40.75,13.77],[42.82,12.83],[43.34,12.51],[43.59,12.35],[43.72,12.28],[44.23,11.98],[46.21,10.95],[52.07,9.05],[53.32,8.74],[57.34,7.9],[64.46,7.63],[83.26,11.08],[101.52,14.68],[111.72,14.63],[120.18,12.11],[118.9,8.16],[102.24,8.25],[86.46,4.05],[82.54,3.29],[73.54,2.01],[64.78,1.09],[58.07,1.07],[56.11,1.23],[55.4,1.3],[43.78,4.96],[41.14,6.53],[40.01,7.31],[39.71,7.51],[38.52,6.95],[38.41,6.7],[38.12,6.11],[37.42,4.94],[35.55,2.68],[29.84,0.0511],[24.14,0.777],[20.61,2.13],[16.54,4],[3.43,7.78],[3.39,7.78]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.549,0.5608,0.5922,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[211.46,2.23],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"gr\",\"it\":[{\"nm\":\"Vector\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[-0.76,0.4033],[-0.426,0.4264],[0.242,0.484],[1.11,-0.0461],[1.96,-0.4724],[3.03,0],[3.31,0.4264],[8.39,1.45],[5.46,-0.8872],[0.669,-0.1382],[0.645,-0.1959],[0.645,-0.1959],[0.657,-0.2535],[2.81,-2.06],[0.288,-0.2074],[0.277,-0.2304],[0.576,-0.484],[0.541,-0.5531],[0.3,-0.2996],[0,0],[0.069,-0.0691],[0.081,0.0921],[0.011,-0.0231],[0.012,-0.0115],[0,0],[-0.069,0.0346],[0.011,0.0116],[-0.081,0.5415],[0,0],[0,0],[0.139,2.7],[1.8,3.1],[1.99,0.53],[1.47,-0.3342],[2.12,-1.15],[2.83,-1.9],[1.38,-0.8642],[1.06,-0.6568],[1.64,-0.7604],[0.887,-0.2419],[0.507,0.0922],[0,0.0806],[0,0],[-0.012,0.3226],[-0.069,0.8066],[-0.207,1.95],[0.276,2.55],[0.864,1.5],[1.57,0.6222],[1.35,0.0461],[1.21,-0.1959],[0.576,-0.1383],[0,0],[0,0],[0,0],[0.634,-0.1728],[1.17,-0.4954],[0.565,-0.2765],[0,0],[3.34,-3.2],[3.15,-2.57],[1.07,-0.6107],[0,0],[0,0],[0,0],[0.0692,-0.023],[0.1613,0.0461],[0.1383,0.3111],[0.265,0.6106],[0.1498,0.3341],[0.1728,0.3226],[2.43,1.76],[2.63,-0.0576],[1.92,-0.7028],[0.7835,-0.4494],[0.6913,-0.4379],[1.01,-0.8411],[0.8065,-0.7028],[0,0],[0.1037,-0.0461],[0,0],[0,0],[0.9102,-0.1267],[1.9,0.2304],[3.72,0.9564],[3.86,0.3917],[1.96,-0.1728],[1.86,-0.7375],[0.6683,-0.4608],[0.3226,-0.4609],[-0.2881,-0.3687],[-0.9448,0.219],[-0.6107,0.2189],[-0.8411,0.1959],[-3.32,-0.6107],[-3.65,-1.14],[-4.52,-0.6799],[-2.55,0.2766],[-1.29,0.4148],[0,0],[0,0],[0,0],[-0.1729,0.1959],[0,0],[-0.8988,0.6337],[-0.484,0.3687],[-0.5531,0.3572],[-0.5992,0.3342],[-0.6452,0.2766],[-1.35,0.0922],[-1.15,-0.6683],[-0.9679,-1.64],[-0.2419,-0.4264],[-0.1843,-0.5185],[-0.2189,-0.4955],[-0.2535,-0.4724],[-0.3687,-0.4494],[-2.47,-0.1152],[-1.15,0.4724],[-0.2305,0.1267],[0,0],[0,0],[-2.44,2.62],[-2.78,2.52],[-3.2,1.21],[-0.806,0.2074],[-0.818,0.1152],[0,0],[-0.104,0.023],[0,0],[0,0],[-0.427,0.0691],[-0.784,0.0691],[-0.461,-0.4033],[-0.185,-0.4379],[-0.057,-0.6683],[0.138,-1.49],[0.172,-1.45],[0.046,-1.38],[0,-0.3456],[0,-0.2305],[-0.023,-0.242],[-0.092,-0.4378],[-0.092,-0.4263],[-0.646,-0.4378],[-0.668,-0.2074],[-0.772,-0.0115],[-0.38,0.0461],[0,0],[-2.41,1.34],[-2.16,1.5],[-4.2,2.68],[-2.02,0.6913],[-0.634,-0.0692],[-0.184,-0.1268],[-0.207,-0.2535],[-0.253,-1.01],[-0.081,-1.18],[0.161,-2.49],[0,0],[-0.726,-1.62],[-0.323,-0.3687],[-0.391,-0.2996],[-0.438,-0.2074],[-0.438,-0.0576],[-1.2,0.7144],[-0.484,0.4724],[0,0],[0.034,-0.0576],[0,0],[-0.599,0.5416],[-0.668,0.4494],[0,0],[0,0],[-3.25,0.4609],[-2.51,-0.1037],[-2.69,-0.4263],[-7.07,-0.6107],[-3.37,0.242],[-3.11,1.06],[0,0]],\"o\":[[1.12,-0.3111],[0.772,-0.4033],[0.853,-0.8641],[-0.242,-0.4839],[-1.11,0.0691],[-2.79,0.6683],[-3.03,0.0116],[-6.6,-0.8641],[-9.54,-1.56],[-0.68,0.1153],[-0.668,0.1268],[-0.646,0.1843],[-0.634,0.2419],[-2.56,1.04],[-0.288,0.1959],[-0.265,0.2304],[-0.553,0.4609],[-0.53,0.53],[-0.288,0.2996],[0,0],[-0.058,0.0921],[-0.507,0.6568],[0,-0.0461],[0,0.023],[0,0],[-0.035,0.0461],[0.092,-0.0461],[-0.035,-0.0921],[0,0],[0,0],[0.196,-2.49],[-0.207,-2.7],[-0.876,-1.53],[-1.97,-0.53],[-2.96,0.7259],[-4.16,2.37],[-2.81,1.91],[-1.05,0.6567],[-0.922,0.5646],[-0.807,0.3918],[-0.864,0.2535],[0,0.0231],[0,0],[-0.023,-0.1728],[0.011,-0.7144],[0.15,-1.64],[0.184,-1.96],[-0.173,-1.28],[-0.83,-1.5],[-1.56,-0.6568],[-1.35,-0.0115],[-0.588,0.1152],[0,0],[0,0],[0,0],[-0.645,0.0576],[-1.26,0.2765],[-0.599,0.2305],[0,0],[-4.52,2.35],[-3.33,3.24],[-1.09,0.8988],[0,0],[0,0],[0,0],[-0.0807,0.0461],[-0.1497,0.0346],[-0.3226,-0.0922],[-0.2765,-0.6222],[-0.1498,-0.3342],[-0.1728,-0.3227],[-1.33,-2.55],[-2.41,-1.79],[-2.68,-0.0116],[-0.8988,0.4264],[-0.772,0.4493],[-1.35,0.9103],[-1.07,0.8066],[0,0],[-0.0345,0.0346],[0,0],[0,0],[-0.8757,0.2995],[-1.84,0.2304],[-3.81,-0.4724],[-3.73,-0.9563],[-1.92,-0.1959],[-1.97,0.1729],[-1.03,0.3802],[-0.6337,0.5301],[-0.6452,0.9218],[0.2881,0.3687],[0.4724,-0.1152],[0.6568,-0.1613],[3.01,-0.8757],[3.33,0.5992],[3.66,1.13],[2.25,0.3226],[1.27,-0.1498],[0,0],[0,0],[0,0],[0.2305,-0.0921],[0,0],[0.6683,-0.5761],[0.4378,-0.3226],[0.5069,-0.3226],[0.5416,-0.3802],[0.5991,-0.3572],[1.3,-0.553],[1.37,-0.1267],[1.13,0.7029],[0.2765,0.3572],[0.2305,0.4493],[0.2074,0.4955],[0.0576,0.1267],[0.265,0.507],[1.47,1.8],[1.22,0.0576],[0.2765,-0.1268],[0,0],[0,0],[3.51,-2.22],[2.63,-2.85],[2.75,-2.53],[0.783,-0.3572],[0.807,-0.265],[0,0],[0.103,0],[0,0],[0,0],[0.427,-0.0922],[0.852,-0.1728],[1.54,-0.1152],[0.253,0.1959],[0.184,0.4263],[0.127,1.34],[-0.161,1.5],[-0.173,1.45],[0,0.3456],[0,0.2305],[0,0.2535],[0.058,0.4839],[0.092,0.4378],[0.668,0.5646],[0.679,0.3918],[1.46,0.4609],[0.772,0],[0.369,-0.0461],[3.15,-0.6337],[2.39,-1.36],[4.32,-3.01],[2.09,-1.33],[1,-0.3457],[0.323,0.0345],[0.196,0.0922],[0.403,0.507],[0.265,1.01],[0.196,2.35],[0,0],[-0.127,1.23],[0.184,0.4033],[0.276,0.3802],[0.381,0.3226],[0.438,0.1498],[1.75,0.1959],[0.611,-0.3572],[0,0],[0.185,-0.242],[0,0],[0.553,-0.6222],[0.599,-0.553],[0,0],[0,0],[3.66,-2.1],[3.26,-0.4494],[5.04,0.2765],[8.12,1.37],[3.54,0.3111],[3.36,-0.2304],[0,0],[0,0]],\"v\":[[269.9,21.14],[272.68,19.91],[274.44,18.59],[275.3,16.55],[273.22,15.87],[268.63,16.65],[259.9,17.6],[250.41,16.93],[228.26,12.92],[206.81,12.36],[204.8,12.78],[202.84,13.26],[200.9,13.83],[198.98,14.55],[190.91,18.93],[190.06,19.54],[189.24,20.23],[187.56,21.65],[185.96,23.26],[185.07,24.15],[184.62,24.76],[184.43,25],[182.91,25.8],[182.85,25.95],[182.79,26.04],[182.8,26.03],[182.94,25.91],[183.01,25.83],[183.01,24.77],[183.01,24.68],[183.03,24.58],[183.22,16.81],[181.03,8.17],[176.37,4.58],[171.14,4.59],[163.81,7.69],[153.44,14.37],[147.05,18.6],[143.89,20.58],[140.01,22.72],[137.43,23.7],[135.13,23.96],[134.96,23.87],[134.96,23.81],[134.95,22.85],[135.09,20.54],[135.69,15.2],[135.81,8.6],[134.47,4.37],[130.53,0.888],[126.12,0.0008],[122.31,0.3004],[120.53,0.6345],[119.66,0.8419],[119.26,0.9341],[117.66,1.07],[115.74,1.36],[112.03,2.41],[110.25,3.11],[108.54,3.96],[97.1,12.86],[87.59,21.94],[84.35,24.27],[83.95,24.51],[83.76,24.64],[83.69,24.67],[83.46,24.75],[82.99,24.74],[82.26,24.11],[81.45,22.27],[81.02,21.28],[80.49,20.31],[74.92,13.61],[66.84,11.03],[60.09,12.51],[57.5,13.77],[55.27,15.08],[51.69,17.68],[48.95,19.98],[48.63,20.27],[48.48,20.34],[47.84,20.61],[47.19,20.82],[44.49,21.41],[38.84,21.35],[27.54,18.89],[16.24,16.58],[10.38,16.5],[4.59,17.87],[2.08,19.25],[0.613,20.69],[0.1521,22.64],[2.08,22.88],[3.75,22.45],[5.95,21.81],[15.52,21.67],[25.93,24.52],[38.01,27.61],[45.24,27.8],[49.1,27.01],[50.07,26.71],[51.01,26.32],[51.67,26.04],[52.32,25.67],[53.27,24.84],[55.59,22.95],[56.98,21.92],[58.56,20.9],[60.3,19.92],[62.19,19.05],[66.24,18.06],[69.97,18.94],[73.21,22.39],[73.92,23.67],[74.59,25.05],[75.21,26.54],[75.78,27.8],[76.74,29.23],[82.94,32.33],[86.58,31.7],[87.4,31.31],[87.91,31.01],[88.93,30.38],[97.54,22.83],[105.49,14.56],[114.43,8.67],[116.85,7.93],[119.31,7.56],[120.36,7.46],[120.67,7.39],[120.94,7.33],[121.26,7.25],[122.55,6.95],[125.01,6.59],[128.36,7.12],[128.99,8],[129.36,9.7],[129.22,14.06],[128.68,18.49],[128.31,22.73],[128.29,23.76],[128.29,24.45],[128.35,25.19],[128.51,26.59],[128.8,27.88],[130.76,29.39],[132.76,30.34],[135.87,30.8],[137.57,30.67],[138.12,30.58],[146.2,27.32],[152.96,22.98],[165.59,14.12],[171.84,10.88],[174.43,10.45],[175.16,10.67],[175.75,11.19],[176.8,13.6],[177.32,16.93],[177.29,24.26],[177.32,24.04],[177.85,28.32],[178.57,29.49],[179.62,30.49],[180.89,31.18],[182.22,31.5],[186.65,30.47],[188.26,29.2],[188.93,28.46],[189.34,27.88],[190.91,26.27],[192.74,24.65],[194.67,23.18],[195.66,22.48],[196.71,21.88],[207.24,18.34],[215.92,18.03],[227.16,19.36],[249.74,22.92],[260.09,23.07],[269.88,21.19],[269.9,21.14]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.549,0.5608,0.5922,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,31.44],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"Header purple 3\",\"ddd\":0,\"ty\":4,\"ind\":17,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1445,412.11]},{\"t\":194.87,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[1445,412.11]},{\"t\":226.84,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1445,430.54]},{\"t\":359.82,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1445,432.11]},{\"t\":360,\"s\":[1445,432.11]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":194.87,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[0]},{\"t\":226.84,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"nm\":\"Header purple 3\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[-6.25,4.56],[-5.17,2.86],[-2.88,1.11],[-2.97,0.1266],[-1.65,-1.04],[-0.8068,-1.57],[-0.1266,-1.85],[0.9017,-1.66],[0.1424,-0.1423],[0.2056,-0.0949],[0.4271,0.1899],[0.6169,0.6802],[0.3481,0.9333],[-0.791,1.91],[-0.6802,0.7435],[0,0],[0,0],[-0.5062,0.4429],[-3.23,0.2215],[-1.5,-0.6486],[-0.4587,-0.2056],[-0.4745,-0.2056],[-4.49,-2.72],[-3.07,-1.52],[-4.1,-0.8384],[-4.41,0.87],[-3.91,2.14],[-0.965,0.5695],[-0.87,0.6486],[0,0],[-0.032,0.0158],[0,0],[-0.348,0.0791],[-0.569,-0.2373],[-0.316,-0.2689],[-0.333,-0.6169],[-0.427,-1.08],[0,0],[-0.205,-0.4271],[-0.602,-0.7752],[-1.63,-0.9017],[-0.854,-0.2532],[-0.427,-0.0949],[-0.221,-0.0316],[-3.67,-0.3638],[-3.75,-0.1423],[-7.15,1.15],[-6.06,3.04],[-0.554,0.4904],[-0.284,0.4429],[0.317,0.5695],[0.996,0.0791],[0.633,-0.1108],[0.823,-0.2056],[6.71,-0.5853],[8.45,0.2215],[6.61,0.9966],[4.03,0.7593],[0.855,0.6644],[0.221,0.3955],[0.079,0.2215],[0.269,0.6485],[1.47,1.85],[2.7,0.8226],[2.28,-0.5853],[0.98,-0.4429],[0,0],[0.459,-0.3164],[0,0],[0,0],[0.696,-0.4746],[1.44,-0.791],[2.93,-0.3955],[2.64,0.5695],[3.13,1.85],[0,0],[1.3,0.8068],[2.64,1.28],[4.26,0.4271],[4.11,-2.18],[0.9966,-0.617],[0.9016,-0.7119],[0,0],[0,0],[0,0],[0.4746,-0.5695],[0.6328,-2.69],[-0.6961,-2.66],[-1.87,-1.85],[-0.522,-0.3639],[-0.5854,-0.3164],[-1.53,-0.1423],[-1.77,2.17],[-0.4587,0.9492],[-0.2056,0.8542],[1.39,3.73],[2.55,1.8],[2.1,0.4113],[1.47,-0.0633],[3.4,-1.42],[2.75,-1.76],[4.16,-3.92],[0,0]],\"o\":[[-5.82,5.65],[4.49,-3.18],[2.59,-1.42],[2.86,-1.09],[3.39,-0.2373],[1.65,1.06],[0.8068,1.58],[0.1265,1.82],[-0.2214,0.348],[-0.1423,0.1582],[-0.3955,0.2057],[-0.3322,-0.0949],[-0.6644,-0.6961],[-0.696,-1.87],[0.3954,-0.9492],[0,0],[0,0],[0.5221,-0.4429],[4.11,-3.51],[3.27,-0.1424],[0.4429,0.2057],[0.4588,0.2373],[1.71,0.7594],[2.26,1.34],[3.07,1.52],[4.08,0.8384],[4.43,-0.8543],[0.981,-0.522],[0.949,-0.5695],[0,0],[0,0],[0,0],[0.379,-0.1582],[1.44,-0.3955],[0.301,0.1108],[0.316,0.3639],[0.506,0.8226],[0,0],[0.126,0.3322],[0.428,0.9175],[1.2,1.57],[0.823,0.4429],[0.427,0.1423],[0.428,0.0791],[4.65,0.6961],[7.35,0.7435],[8.84,0.2057],[7.15,-1.17],[0.839,-0.3797],[0.553,-0.4746],[0.57,-0.8701],[-0.316,-0.5536],[-0.491,-0.0474],[-0.617,0.1265],[-5.76,1.82],[-6.72,0.5695],[-3.29,-0.1266],[-3.31,-0.522],[-2.53,-0.4113],[-0.364,-0.3005],[-0.111,-0.2056],[-0.206,-0.5378],[-0.712,-1.74],[-1.42,-1.84],[-2.91,-0.9017],[-1.11,0.3322],[0,0],[-0.396,0.2215],[0,0],[0,0],[-0.68,0.4904],[-1.38,0.9808],[-2.93,1.38],[-2.93,0.3797],[-5.28,-1.14],[-3.13,-1.91],[0,0],[-1.33,-0.7909],[-2.61,-1.25],[-4.24,-0.4746],[-1.09,0.4746],[-1.01,0.6011],[0,0],[0,0],[0,0],[-0.4113,0.3955],[-1.87,2.06],[-0.6327,2.69],[0.6802,2.64],[0.4746,0.4746],[0.5062,0.3954],[1.19,0.696],[3.12,0.3797],[0.9333,-1.12],[0.4113,-0.9491],[1.27,-5.22],[-1.42,-3.73],[-2.55,-1.84],[-2.14,-0.4113],[-4.49,0.2531],[-3.4,1.44],[-5.49,3.54],[0,0],[0,0]],\"v\":[[2.93,22.25],[7,27.2],[21.33,18.04],[29.52,14.16],[38.43,12.08],[45.67,13.64],[49.25,17.74],[50.64,22.9],[49.6,28.5],[49.11,29.21],[48.58,29.6],[47.26,29.62],[45.25,28.15],[43.66,25.7],[43.76,19.67],[45.39,17.11],[45.93,16.57],[46.7,15.89],[48.24,14.56],[59.88,9.1],[67.27,10.67],[68.61,11.27],[70.02,11.93],[79.35,17.14],[87.31,21.55],[98.08,25.36],[111.16,25.43],[123.77,20.78],[126.64,19.08],[129.4,17.28],[131.84,15.56],[131.92,15.51],[132.24,15.4],[133.33,15.05],[136.46,14.91],[137.34,15.49],[138.36,16.87],[139.76,19.8],[140.08,20.63],[140.63,21.98],[142.2,24.52],[146.54,28.23],[149.05,29.3],[150.35,29.65],[151.5,29.86],[163.99,31.42],[180.53,32.5],[204.32,31.07],[224.1,25.03],[226.17,23.69],[227.42,22.31],[227.75,20.11],[225.73,19.11],[224.03,19.23],[221.9,19.76],[203.33,23.12],[180.78,23.62],[165.82,22.01],[154.79,20.16],[151.06,18.96],[150.16,17.88],[149.87,17.23],[149.16,15.33],[146.11,9.89],[139.73,5.37],[131.75,5.37],[128.55,6.49],[127.41,6.95],[126.33,7.73],[125.23,8.6],[123.23,10.16],[121.15,11.55],[116.86,14.04],[108.03,16.88],[99.63,16.54],[86.83,10.92],[81.8,7.76],[79.78,6.51],[73.89,3.25],[63.63,0.116],[50.37,2.82],[47.37,4.59],[44.58,6.63],[43.22,7.71],[41.97,8.86],[40.72,10.02],[39.42,11.33],[35.56,18.62],[35.66,26.79],[39.68,33.72],[41.15,35],[42.76,36.09],[47.1,37.56],[54.93,34.25],[56.81,31.25],[57.76,28.53],[56.92,15.1],[50.56,6.67],[43.35,3.6],[37.99,3.26],[26.28,6.17],[17.12,11.05],[2.91,22.31],[2.93,22.25]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.7882,0.4863,0.9569,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"Blocks\",\"ddd\":0,\"ty\":4,\"ind\":18,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[50,43.75],\"a\":0},\"p\":{\"k\":[1495,744.11],\"a\":0},\"s\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[52.33,52.33]},{\"t\":143.46,\"i\":{\"x\":[0.4],\"y\":[1.4]},\"o\":{\"x\":[0.7],\"y\":[-0.4]},\"s\":[52.33,52.33]},{\"t\":169.63,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100,100]},{\"t\":360,\"s\":[100,100]}]},\"r\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[-8]},{\"t\":143.46,\"i\":{\"x\":[0.4],\"y\":[1.4]},\"o\":{\"x\":[0.7],\"y\":[-0.4]},\"s\":[-8]},{\"t\":169.63,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":360,\"s\":[0]}]},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":143.46,\"i\":{\"x\":[0.4],\"y\":[1.4]},\"o\":{\"x\":[0.7],\"y\":[-0.4]},\"s\":[0]},{\"t\":169.63,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"nm\":\"Vector\",\"ty\":\"gr\",\"it\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[43.75,0],[12.5,0],[12.5,21.88],[43.75,21.88],[43.75,0]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.4235,0.4353,0.4667,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,31.25],[100,31.25],[100,87.5],[0,87.5],[0,31.25]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.4235,0.4353,0.4667,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[56.25,0],[87.5,0],[87.5,21.88],[56.25,21.88],[56.25,0]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.4235,0.4353,0.4667,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"header c4\",\"ddd\":0,\"ty\":4,\"ind\":19,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1425,818.11]},{\"t\":204.41,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[1425,818.11]},{\"t\":236.2,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1445,818.11]},{\"t\":360,\"s\":[1445,818.11]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":204.41,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[0]},{\"t\":236.2,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"nm\":\"header\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0.276,0.4641],[0.3155,0.3521],[0.6047,-0.048],[0.3549,-1.2],[-0.1052,-1.01],[-0.7887,-1.23],[-1.88,-0.2881],[-1.39,0.3521],[-2.37,1.3],[-1.18,0.6722],[-0.5652,0.3361],[0,0],[0,0],[-0.0526,0.032],[0,0],[0,0],[0,0],[-0.4338,-0.08],[-0.1972,-0.2401],[-0.1972,-0.3361],[-0.1972,-0.6882],[-0.3024,-1.07],[-0.2235,-0.6081],[-0.3549,-0.4641],[0,0],[-0.184,-0.208],[-0.4075,-0.3041],[-0.4338,-0.16],[-0.4338,-0.08],[-0.8281,0.3201],[-0.3286,0.144],[-0.2892,0.144],[-1.67,1.28],[-0.8544,0.7042],[-0.9859,0.8003],[-1.85,1.58],[-1.93,1.7],[-0.1577,-0.032],[0,0],[0,0],[-0.2498,0],[-0.4338,-0.08],[-0.3944,-0.096],[-1.03,-1.89],[-0.6047,-1.3],[-1.16,-1.44],[-1.7,-0.4802],[-0.6836,0.0481],[-0.3418,0.016],[-0.3155,0.048],[-1.43,0.7042],[-0.8019,0.4481],[-0.8676,0.6402],[-3.35,3.12],[-0.224,0.2081],[0,0.032],[-0.329,0.1601],[-0.565,0.048],[-0.118,0.016],[-0.039,-0.064],[-0.078,-0.048],[-0.092,-0.032],[-0.907,-1.47],[-1.85,-1.57],[-0.5,-0.3361],[-0.539,-0.2401],[-0.538,-0.0961],[0,0],[0,0],[-0.078,0],[0,0],[-1.72,0.4642],[-0.763,0.112],[-0.763,0.128],[-6.26,-0.3521],[-5.77,-0.3681],[-2.96,-0.08],[-5.68,0.8962],[-1.35,0.3041],[-1.3,0.4961],[-2.43,1.28],[5.23,-1.34],[2.48,-0.4961],[1.3,-0.1601],[1.34,-0.096],[6.77,0.2081],[5.36,0.7202],[7.99,0.4641],[2.59,-0.144],[1.46,-0.144],[0.723,-0.064],[0.749,-0.112],[1.49,-0.2721],[1.49,-0.3041],[1.45,-0.4001],[0.683,-0.208],[-0.013,0],[0,0],[0.053,0.016],[0,0],[0.631,0.6882],[0.749,1.22],[1.31,1.34],[0.355,0.2881],[0.42,0.1761],[0.408,0.16],[0.395,0.08],[0.354,0],[0.329,-0.016],[0.315,-0.016],[0.276,-0.064],[0.499,-0.144],[0.407,-0.1761],[0.46,-0.2081],[0.3553,-0.3041],[0.3286,-0.2881],[0,0],[0.9596,-0.8002],[1.74,-1.31],[2.25,-1.06],[0.8939,-0.064],[0,0],[0.092,0],[0.1446,0.032],[0.3155,0.3842],[0.907,1.81],[1.83,1.74],[2.1,0.2721],[0.9727,-0.112],[0.4601,-0.096],[0.6572,-0.112],[0.2761,-0.2561],[0,0],[0,0],[0.6047,-0.5602],[1.14,-1.02],[1.81,-1.42],[1.85,-0.8802],[0.1841,-0.096],[0.0789,-0.0321],[0.1446,0.016],[0.1052,0.2721],[0.0263,0.128],[0.0788,0.3201],[0.3286,0.9923],[1.38,1.14],[0.5258,0.3361],[0.5258,0.1921],[0.4996,0.08],[0.4601,0.032],[0.8545,-0.064],[0.3943,-0.08],[0,0],[0.2892,-0.112],[0,0],[0,0],[0,0],[0.5915,-0.3841],[1.08,-0.7202],[1.87,-0.7522],[0.5915,0],[0.4338,0.4322],[0,0]],\"o\":[[-0.2892,-0.3361],[-0.3024,-0.4321],[-0.5652,-0.7522],[-0.6047,0.048],[-0.1446,0.6242],[0.0657,0.9603],[1.13,1.78],[1.81,0.288],[2.73,-0.7363],[1.14,-0.6562],[0.5652,-0.3201],[0,0],[0,0],[0.1052,-0.048],[0,0],[0,0],[0,0],[0.5127,0],[1.01,0],[0.1446,0.112],[0.184,0.4001],[0.1972,0.6402],[0.1709,0.5601],[0.2892,0.5762],[0,0],[0.1709,0.224],[0.3418,0.4322],[0.4207,0.256],[0.447,0.08],[0.8939,0],[0.3944,-0.128],[0.2892,-0.1441],[2.21,-1.15],[0.815,-0.6242],[0.8808,-0.6882],[1.67,-1.36],[1.81,-1.58],[0.1314,-0.112],[0,0],[0,0],[0.2629,-0.048],[0.4995,-0.016],[0.4732,0.016],[1.58,0.5282],[0.5127,0.9443],[0.6047,1.28],[1.13,1.46],[0.7887,0.176],[0.3549,0],[0.3155,-0.048],[2.45,-0.4481],[1.46,-0.6882],[0.9202,-0.5602],[1.49,-1.2],[0.21,-0.192],[0,0],[0.315,-0.144],[0.815,-0.3521],[0.184,-0.064],[0.092,0.016],[0.053,0.048],[0.066,0.08],[0.408,0.3361],[0.92,1.44],[0.486,0.3521],[0.513,0.3201],[0.539,0.2561],[0,0],[0,0],[0.092,0],[0,0],[1.68,-0.4481],[0.723,-0.224],[0.762,-0.128],[6.12,-0.9443],[8.83,0.2881],[5.78,0.4002],[6.99,0.1761],[1.42,-0.2401],[1.35,-0.3361],[2.6,-0.9283],[5.42,-2.58],[-2.38,0.7362],[-1.24,0.2721],[-1.3,0.128],[-5.4,0.3201],[-2.64,-0.08],[-5.36,-0.6882],[-2.59,-0.1761],[-1.41,0.128],[-0.723,0.064],[-0.736,0.096],[-1.49,0.2241],[-1.49,0.3041],[-1.48,0.2401],[-0.697,0.2081],[0,0],[0,0],[0,0],[0,0],[-0.841,-0.224],[-0.657,-0.6402],[-0.776,-1.18],[-0.276,-0.3361],[-0.381,-0.2721],[-0.408,-0.1921],[-0.407,-0.1761],[-0.381,-0.064],[-0.342,0.016],[-0.328,0.032],[-0.303,0.048],[-0.539,0.16],[-0.447,0.1921],[-0.513,0.2241],[-0.408,0.3521],[-0.4732,0.4001],[-0.6573,0.5602],[0,0],[-0.9596,0.8162],[-1.74,1.26],[-1.12,0.5602],[0,0],[-0.092,-0.016],[-0.1972,0],[-0.2629,-0.128],[-0.631,-0.6722],[-0.8939,-1.79],[-1.81,-1.79],[-1.04,-0.112],[-0.4864,0.032],[-0.6704,0.112],[-0.3813,-0.032],[0,0],[0,0],[-0.6309,0.5762],[-1.24,1.1],[-2.3,2],[-2.69,2.14],[-0.1972,0.0961],[-0.1446,0.064],[-0.1577,0.048],[-0.3023,-0.016],[-0.0526,-0.144],[-0.092,-0.3521],[-0.2235,-0.9443],[-0.6441,-2.02],[-0.4995,-0.4481],[-0.5259,-0.2401],[-0.4996,-0.112],[-0.4863,-0.064],[-0.9465,-0.064],[-0.3944,0.08],[0,0],[-0.2498,0.064],[0,0],[0,0],[0,0],[-0.6047,0.3841],[-1.13,0.7522],[-2.12,1.39],[-0.907,0.3681],[-0.5521,0.064],[0,0],[0,0]],\"v\":[[5.26,14.88],[4.43,13.81],[3.55,12.56],[1.74,11.43],[0.1979,13.22],[0.0402,15.6],[1.3,19.22],[6.11,22.47],[10.75,22.17],[18.23,18.92],[21.72,16.92],[23.41,15.94],[24.23,15.51],[24.62,15.32],[24.7,15.28],[24.83,15.28],[25.23,15.2],[26.08,15.04],[27.63,14.98],[29.51,15.49],[30,16.12],[30.59,17.7],[31.27,20.18],[31.9,22.09],[32.75,23.77],[33.22,24.5],[33.77,25.13],[34.95,26.15],[36.26,26.74],[37.58,27],[40.16,26.63],[41.34,26.26],[42.22,25.83],[47.55,22.25],[50.06,20.26],[52.83,18.04],[58.12,13.59],[63.77,8.66],[64.23,8.45],[64.33,8.45],[64.7,8.4],[65.45,8.37],[66.87,8.42],[68.15,8.67],[71.66,12.05],[73.26,15.41],[75.74,19.61],[80.29,22.79],[82.63,23.11],[83.7,23.09],[84.64,22.95],[90.31,21],[93.62,19.19],[96.26,17.37],[103.84,10.85],[104.48,10.26],[104.48,10.23],[105.47,9.76],[107.69,9.14],[108.04,9.15],[108.31,9.19],[108.52,9.25],[108.75,9.41],[110.75,12.24],[114.76,17.16],[116.25,18.2],[117.84,18.95],[119.45,19.43],[120.53,19.64],[121.08,19.75],[121.35,19.8],[121.61,19.73],[126.71,18.36],[128.94,17.88],[131.22,17.49],[150.04,16.66],[171.93,17.99],[184.98,18.65],[203.85,17.45],[208.01,16.55],[212.01,15.49],[219.6,12.58],[218.28,7.03],[210.93,8.48],[207.11,8.96],[203.16,9.38],[185.14,9.67],[173.1,8.39],[153.09,6.24],[145.27,6.31],[140.97,6.72],[138.79,6.91],[136.57,7.23],[132.11,7.87],[127.66,8.79],[123.28,9.95],[121.2,10.56],[121.23,10.56],[121.16,10.56],[121.03,10.6],[120.68,10.53],[118.55,9.33],[116.52,6.56],[113.68,2.64],[112.66,1.73],[111.53,0.9603],[110.3,0.4161],[109.12,0.144],[107.98,0],[106.97,0.064],[105.99,0.144],[105.15,0.3521],[103.59,0.8002],[102.3,1.34],[100.84,1.98],[99.68,2.98],[98.47,4.02],[97.46,4.88],[95.96,6.13],[91.87,9.36],[85.79,13.14],[82.62,14.08],[82.29,14.12],[82.03,14.07],[81.57,13.96],[80.77,13.32],[78.47,9.25],[74.51,3.51],[68.23,0.4161],[65.16,0.3361],[63.72,0.4801],[61.72,0.8162],[60.81,1.38],[59.97,2.14],[58.91,3.12],[57.05,4.83],[53.49,8.03],[47.26,13.25],[40.17,18.04],[39.58,18.31],[39.32,18.41],[38.86,18.45],[38.21,17.89],[38.08,17.48],[37.83,16.45],[37.01,13.44],[33.8,8.27],[32.22,7.17],[30.63,6.51],[29.12,6.21],[27.72,6.13],[25.15,6.32],[23.98,6.58],[23.37,6.71],[22.56,6.91],[21.77,7.31],[21.24,7.6],[20.26,8.18],[18.46,9.35],[15.14,11.56],[9.15,14.95],[6.72,15.54],[5.22,14.95],[5.26,14.88]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.549,0.5608,0.5922,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"description c4\",\"ddd\":0,\"ty\":4,\"ind\":20,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1445,905.11]},{\"t\":219.13,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[1445,905.11]},{\"t\":245.41,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1445,885.11]},{\"t\":360,\"s\":[1445,885.11]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":219.13,\"i\":{\"x\":[0.095],\"y\":[1]},\"o\":{\"x\":[0.178],\"y\":[-0.007]},\"s\":[0]},{\"t\":245.41,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":360,\"s\":[100]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"nm\":\"Vector\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0.3455,-0.0231],[0.3179,-0.0808],[0.3731,-0.4271],[-0.2211,-0.6234],[-0.3179,-0.3002],[-0.5666,-0.2539],[-1.82,-0.0924],[-1.76,0.3117],[-3.44,1.34],[-1.85,0.7157],[-0.8431,0.1385],[-0.8292,-0.2078],[-0.6911,-0.6811],[-0.1658,-0.2078],[-0.1382,-0.2655],[-0.1658,-0.254],[-0.2073,-0.3925],[-1.62,-0.6927],[-1.74,0.381],[-0.7877,0.4387],[0,0],[0,0],[0,0],[0,0],[-0.774,0.3116],[-1.26,0.1732],[-0.4837,0.1385],[-2.28,0.2655],[-3.34,-0.1616],[-7.67,-1.71],[-3.79,-0.3001],[-3.7,0.4387],[-3.08,1.2],[3.16,-0.5195],[8.14,0.7965],[9.4,2.12],[1.59,0.1732],[3.66,0.4271],[3.22,0.1616],[2,-0.0924],[0.539,-0.0462],[0,0],[4.33,-1.95],[1.01,-0.5888],[0,0],[0.1244,-0.0577],[0.1382,0.5079],[0,0],[0.1382,0.1963],[0,0],[0.926,0.7042],[2.49,0.1616],[1.76,-0.4156],[1.13,-0.4271],[1.13,-0.4387],[4.27,0.7504],[0,0]],\"o\":[[-0.3731,-0.0924],[-0.3455,0],[-0.6357,0.1732],[-0.3731,0.4271],[0.1106,0.3001],[0.3455,0.2886],[1.63,0.635],[1.82,0.0923],[3.54,-0.6003],[3.81,-1.63],[0.9121,-0.3348],[0.8706,-0.1732],[0.7463,0.1616],[0.1796,0.1385],[0.1659,0.2078],[0.1521,0.2424],[0.1935,0.381],[0.6496,1.42],[1.58,0.6926],[0.8707,-0.1962],[0,0],[0,0],[0,0],[0,0],[0.7739,-0.4156],[3.1,-1.19],[0.5114,-0.0693],[0.8983,-0.1847],[2.29,-0.2424],[6.68,0.254],[10.9,2.26],[4.48,0.4041],[3.72,-0.4502],[3.41,-1.44],[-5.93,0.785],[-3.21,-0.2655],[-1.55,-0.3348],[-3.44,-0.3579],[-3.66,-0.4271],[-3.22,-0.1616],[-1.01,0.0231],[-0.5528,0.0462],[-4.81,0.5079],[-1.05,0.5195],[0,0],[-0.0829,0.0462],[-0.5528,0.2655],[0,0],[-0.1244,-0.1963],[0,0],[-0.6357,-0.7735],[-1.74,-1.44],[-2.93,-0.2193],[-1.73,0.4618],[-2.29,0.8427],[-6.69,2.71],[0,0],[0,0]],\"v\":[[4.07,7.8],[2.99,7.72],[2,7.84],[0.4067,8.77],[0.1026,10.37],[0.7384,11.32],[2.09,12.15],[7.37,13.32],[12.79,12.98],[23.11,9.85],[30.88,6.48],[33.48,5.72],[36.01,5.77],[38.15,6.94],[38.66,7.49],[39.16,8.12],[39.63,8.86],[40.24,10.03],[43.65,13.32],[48.87,13.8],[51.36,12.85],[51.98,12.53],[52.29,12.37],[52.44,12.3],[53.05,12],[55.42,10.97],[62.46,9.07],[63.95,8.76],[68.78,7.91],[77.32,7.65],[99.87,11.1],[121.76,14.71],[134.01,14.65],[144.15,12.14],[142.62,8.18],[122.63,8.27],[103.7,4.06],[99,3.3],[88.21,2.01],[77.7,1.09],[69.65,1.07],[67.3,1.23],[66.45,1.3],[52.51,4.97],[49.34,6.54],[47.99,7.32],[47.63,7.52],[46.21,6.97],[46.07,6.71],[45.72,6.12],[44.88,4.95],[42.64,2.68],[35.79,0.0512],[28.96,0.7785],[24.72,2.13],[19.84,4.01],[4.11,7.8],[4.07,7.8]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.549,0.5608,0.5922,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,6.2],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"gr\",\"it\":[{\"nm\":\"Layer_1-2\",\"ty\":\"gr\",\"it\":[{\"nm\":\"Vector\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[-4.55,3.32],[-3.77,2.09],[-2.1,0.8065],[-2.17,0.0922],[-1.2,-0.7605],[-0.5876,-1.14],[-0.0922,-1.35],[0.6568,-1.21],[0.1037,-0.1037],[0.1498,-0.0692],[0.3111,0.1383],[0.4494,0.4955],[0.2535,0.6798],[-0.5761,1.39],[-0.4955,0.5415],[0,0],[0,0],[-0.3687,0.3226],[-2.35,0.1613],[-1.09,-0.4724],[-0.3341,-0.1498],[-0.3456,-0.1498],[-3.27,-1.98],[-2.24,-1.11],[-2.98,-0.6107],[-3.21,0.6337],[-2.85,1.56],[-0.7029,0.4148],[-0.6337,0.4725],[0,0],[-0.023,0.0115],[0,0],[-0.2535,0.0576],[-0.4148,-0.1728],[-0.23,-0.1958],[-0.242,-0.4494],[-0.311,-0.7835],[0,0],[-0.15,-0.3111],[-0.438,-0.5646],[-1.19,-0.6567],[-0.622,-0.1843],[-0.311,-0.0691],[-0.161,-0.023],[-2.67,-0.265],[-2.73,-0.1037],[-5.21,0.8412],[-4.41,2.21],[-0.403,0.3572],[-0.207,0.3226],[0.23,0.4148],[0.726,0.0576],[0.461,-0.0807],[0.599,-0.1498],[4.88,-0.4263],[6.15,0.1613],[4.82,0.7259],[2.94,0.5531],[0.622,0.4839],[0.162,0.288],[0.058,0.1613],[0.195,0.4724],[1.07,1.35],[1.97,0.5992],[1.66,-0.4263],[0.7144,-0.3226],[0,0],[0.3341,-0.2304],[0,0],[0,0],[0.507,-0.3457],[1.05,-0.5761],[2.13,-0.2881],[1.92,0.4148],[2.28,1.35],[0,0],[0.9449,0.5876],[1.92,0.9333],[3.1,0.3111],[3,-1.59],[0.7259,-0.4494],[0.6567,-0.5185],[0,0],[0,0],[0,0],[0.3457,-0.4148],[0.4609,-1.96],[-0.5069,-1.94],[-1.36,-1.35],[-0.3802,-0.265],[-0.4263,-0.2305],[-1.12,-0.1037],[-1.29,1.58],[-0.3342,0.6913],[-0.1498,0.6222],[1.01,2.72],[1.86,1.31],[1.53,0.2996],[1.07,-0.0461],[2.48,-1.04],[2,-1.28],[3.03,-2.86],[0,0]],\"o\":[[-4.24,4.11],[3.27,-2.32],[1.89,-1.04],[2.09,-0.7951],[2.47,-0.1728],[1.2,0.772],[0.5877,1.15],[0.0922,1.33],[-0.1613,0.2535],[-0.1037,0.1152],[-0.2881,0.1498],[-0.2419,-0.0691],[-0.4839,-0.507],[-0.507,-1.36],[0.2881,-0.6913],[0,0],[0,0],[0.3802,-0.3226],[3,-2.56],[2.39,-0.1037],[0.3226,0.1498],[0.3342,0.1728],[1.24,0.5531],[1.65,0.9794],[2.24,1.11],[2.97,0.6107],[3.23,-0.6222],[0.7143,-0.3803],[0.6913,-0.4148],[0,0],[0,0],[0,0],[0.2765,-0.1152],[1.05,-0.288],[0.2189,0.0807],[0.231,0.265],[0.369,0.5991],[0,0],[0.092,0.2419],[0.311,0.6683],[0.875,1.14],[0.599,0.3227],[0.311,0.1037],[0.311,0.0576],[3.39,0.507],[5.36,0.5416],[6.44,0.1498],[5.21,-0.8526],[0.611,-0.2765],[0.403,-0.3456],[0.415,-0.6337],[-0.23,-0.4033],[-0.357,-0.0345],[-0.449,0.0922],[-4.19,1.33],[-4.9,0.4148],[-2.4,-0.0922],[-2.41,-0.3802],[-1.84,-0.2996],[-0.265,-0.2189],[-0.08,-0.1498],[-0.15,-0.3918],[-0.519,-1.27],[-1.04,-1.34],[-2.12,-0.6568],[-0.8066,0.242],[0,0],[-0.2881,0.1613],[0,0],[0,0],[-0.4954,0.3572],[-1,0.7144],[-2.13,1],[-2.13,0.2765],[-3.85,-0.8296],[-2.28,-1.39],[0,0],[-0.9678,-0.5761],[-1.9,-0.9103],[-3.09,-0.3457],[-0.795,0.3457],[-0.7374,0.4379],[0,0],[0,0],[0,0],[-0.2995,0.2881],[-1.36,1.5],[-0.4609,1.96],[0.4955,1.92],[0.3456,0.3457],[0.3688,0.2881],[0.8642,0.507],[2.27,0.2766],[0.6798,-0.8181],[0.2995,-0.6914],[0.9218,-3.8],[-1.04,-2.72],[-1.86,-1.34],[-1.56,-0.2996],[-3.27,0.1844],[-2.48,1.05],[-4,2.58],[0,0],[0,0]],\"v\":[[2.13,16.2],[5.1,19.81],[15.53,13.14],[21.5,10.32],[27.99,8.8],[33.27,9.94],[35.87,12.92],[36.89,16.68],[36.12,20.76],[35.77,21.27],[35.39,21.56],[34.42,21.57],[32.96,20.5],[31.8,18.72],[31.87,14.33],[33.06,12.46],[33.45,12.07],[34.02,11.57],[35.13,10.6],[43.61,6.63],[48.99,7.77],[49.97,8.21],[51,8.69],[57.8,12.48],[63.59,15.7],[71.44,18.47],[80.97,18.52],[90.15,15.13],[92.24,13.9],[94.25,12.59],[96.03,11.33],[96.09,11.3],[96.32,11.21],[97.11,10.96],[99.39,10.86],[100.04,11.28],[100.78,12.29],[101.8,14.42],[102.03,15.03],[102.44,16.01],[103.58,17.86],[106.73,20.56],[108.56,21.34],[109.51,21.6],[110.35,21.75],[119.44,22.89],[131.49,23.67],[148.82,22.63],[163.23,18.23],[164.74,17.25],[165.65,16.25],[165.89,14.65],[164.41,13.92],[163.18,14],[161.62,14.4],[148.1,16.84],[131.68,17.21],[120.78,16.03],[112.75,14.68],[110.03,13.81],[109.37,13.02],[109.16,12.55],[108.65,11.17],[106.42,7.21],[101.78,3.91],[95.96,3.91],[93.63,4.73],[92.8,5.06],[92.02,5.63],[91.21,6.26],[89.76,7.4],[88.24,8.42],[85.12,10.22],[78.69,12.3],[72.57,12.04],[63.25,7.95],[59.58,5.65],[58.11,4.74],[53.82,2.37],[46.34,0.0845],[36.69,2.05],[34.5,3.35],[32.47,4.83],[31.48,5.62],[30.57,6.46],[29.66,7.3],[28.72,8.25],[25.9,13.57],[25.97,19.51],[28.9,24.56],[29.97,25.49],[31.15,26.29],[34.3,27.36],[40.01,24.95],[41.38,22.76],[42.07,20.78],[41.46,11],[36.83,4.85],[31.57,2.62],[27.67,2.38],[19.14,4.5],[12.47,8.05],[2.12,16.25],[2.13,16.2]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.549,0.5608,0.5922,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[158,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"gr\",\"it\":[{\"nm\":\"Vector\",\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"d\":1,\"ks\":{\"k\":{\"c\":true,\"i\":[[0,0],[0.242,0.3341],[0.2765,0.2535],[0.53,-0.0346],[0.3111,-0.8642],[-0.0922,-0.7259],[-0.6913,-0.8872],[-1.65,-0.2074],[-1.22,0.2535],[-2.07,0.9333],[-1.04,0.4839],[-0.4955,0.242],[0,0],[0,0],[-0.046,0.0231],[0,0],[0,0],[0,0],[-0.3802,-0.0576],[-0.1729,-0.1728],[-0.1728,-0.242],[-0.1728,-0.4955],[-0.2651,-0.772],[-0.1959,-0.4379],[-0.3111,-0.3341],[0,0],[-0.1613,-0.1498],[-0.3572,-0.2189],[-0.3802,-0.1153],[-0.3802,-0.0576],[-0.7259,0.2304],[-0.2881,0.1037],[-0.2535,0.1037],[-1.46,0.9218],[-0.7489,0.507],[-0.8641,0.5761],[-1.62,1.14],[-1.69,1.22],[-0.1383,-0.023],[0,0],[0,0],[-0.219,0],[-0.3803,-0.0576],[-0.3456,-0.0691],[-0.8988,-1.36],[-0.53,-0.9333],[-1.01,-1.04],[-1.49,-0.3457],[-0.5991,0.0346],[-0.2996,0.0115],[-0.2765,0.0345],[-1.26,0.5069],[-0.7028,0.3226],[-0.7605,0.4609],[-2.94,2.25],[-0.1959,0.1498],[0,0.023],[-0.288,0.1152],[-0.4955,0.0346],[-0.1037,0.0115],[-0.0345,-0.0461],[-0.0691,-0.0346],[-0.0807,-0.023],[-0.795,-1.06],[-1.62,-1.13],[-0.438,-0.242],[-0.472,-0.1728],[-0.472,-0.0691],[0,0],[0,0],[-0.069,0],[0,0],[-1.51,0.3341],[-0.668,0.0807],[-0.669,0.0922],[-5.48,-0.2534],[-5.06,-0.265],[-2.59,-0.0576],[-4.98,0.6453],[-1.19,0.2189],[-1.14,0.3572],[-2.13,0.9218],[4.59,-0.9679],[2.18,-0.3572],[1.14,-0.1152],[1.18,-0.0691],[5.93,0.1498],[4.7,0.5185],[7,0.3342],[2.27,-0.1037],[1.28,-0.1037],[0.634,-0.0461],[0.657,-0.0807],[1.3,-0.1959],[1.3,-0.2189],[1.27,-0.2881],[0.599,-0.1498],[-0.012,0],[0,0],[0.046,0.0115],[0,0],[0.553,0.4955],[0.657,0.8757],[1.15,0.9679],[0.3111,0.2074],[0.3687,0.1267],[0.3572,0.1152],[0.3457,0.0576],[0.3111,0],[0.288,-0.0115],[0.2766,-0.0115],[0.242,-0.0461],[0.4378,-0.1037],[0.3572,-0.1267],[0.4033,-0.1498],[0.3111,-0.2189],[0.2881,-0.2074],[0,0],[0.8411,-0.5761],[1.52,-0.9448],[1.97,-0.7605],[0.7835,-0.0461],[0,0],[0.0807,0],[0.1268,0.023],[0.2765,0.2765],[0.795,1.3],[1.6,1.26],[1.84,0.1959],[0.8526,-0.0807],[0.4033,-0.0691],[0.5761,-0.0807],[0.242,-0.1844],[0,0],[0,0],[0.53,-0.4033],[1,-0.7374],[1.59,-1.03],[1.62,-0.6338],[0.1613,-0.0691],[0.0691,-0.0231],[0.1267,0.0116],[0.0922,0.1958],[0.023,0.0922],[0.0691,0.2304],[0.288,0.7144],[1.21,0.8181],[0.4608,0.242],[0.4609,0.1383],[0.4379,0.0576],[0.4032,0.023],[0.7489,-0.0461],[0.3457,-0.0576],[0,0],[0.2535,-0.0807],[0,0],[0,0],[0,0],[0.5185,-0.2765],[0.9448,-0.5185],[1.64,-0.5416],[0.5185,0],[0.3802,0.3111],[0,0]],\"o\":[[-0.2535,-0.242],[-0.265,-0.3111],[-0.4955,-0.5415],[-0.53,0.0346],[-0.1267,0.4494],[0.0576,0.6913],[0.9909,1.28],[1.59,0.2074],[2.4,-0.53],[1,-0.4724],[0.4955,-0.2304],[0,0],[0,0],[0.0922,-0.0346],[0,0],[0,0],[0,0],[0.4493,0],[0.8872,0],[0.1267,0.0807],[0.1613,0.288],[0.1728,0.4609],[0.1497,0.4033],[0.2535,0.4148],[0,0],[0.1497,0.1614],[0.2996,0.3111],[0.3687,0.1844],[0.3917,0.0576],[0.7835,0],[0.3457,-0.0922],[0.2535,-0.1037],[1.94,-0.8296],[0.7144,-0.4494],[0.772,-0.4954],[1.46,-0.9794],[1.59,-1.14],[0.1152,-0.0807],[0,0],[0,0],[0.2304,-0.0346],[0.4378,-0.0115],[0.4148,0.0115],[1.38,0.3802],[0.4493,0.6798],[0.53,0.9218],[0.9909,1.05],[0.6913,0.1267],[0.3111,0],[0.2766,-0.0346],[2.14,-0.3226],[1.28,-0.4955],[0.8066,-0.4033],[1.3,-0.8641],[0.1843,-0.1383],[0,0],[0.2765,-0.1037],[0.7144,-0.2535],[0.1613,-0.0461],[0.0807,0.0115],[0.0461,0.0346],[0.0576,0.0576],[0.3572,0.242],[0.8065,1.04],[0.426,0.2535],[0.449,0.2304],[0.472,0.1844],[0,0],[0,0],[0.081,0],[0,0],[1.47,-0.3226],[0.634,-0.1613],[0.669,-0.0921],[5.37,-0.6798],[7.74,0.2074],[5.07,0.288],[6.13,0.1267],[1.24,-0.1728],[1.19,-0.242],[2.28,-0.6683],[4.75,-1.86],[-2.09,0.53],[-1.08,0.1959],[-1.14,0.0922],[-4.74,0.2304],[-2.32,-0.0576],[-4.7,-0.4955],[-2.27,-0.1267],[-1.23,0.0922],[-0.634,0.0461],[-0.645,0.0691],[-1.3,0.1613],[-1.3,0.2189],[-1.3,0.1728],[-0.611,0.1498],[0,0],[0,0],[0,0],[0,0],[-0.738,-0.1613],[-0.576,-0.4609],[-0.68,-0.8527],[-0.2419,-0.242],[-0.3341,-0.1959],[-0.3572,-0.1383],[-0.3572,-0.1267],[-0.3341,-0.0461],[-0.2996,0.0115],[-0.2881,0.023],[-0.265,0.0346],[-0.4724,0.1152],[-0.3918,0.1383],[-0.4494,0.1613],[-0.3572,0.2535],[-0.4148,0.2881],[-0.5761,0.4033],[0,0],[-0.8412,0.5876],[-1.52,0.9103],[-0.9794,0.4033],[0,0],[-0.0806,-0.0115],[-0.1728,0],[-0.2304,-0.0922],[-0.5531,-0.4839],[-0.7835,-1.29],[-1.59,-1.29],[-0.9103,-0.0807],[-0.4263,0.023],[-0.5876,0.0807],[-0.3342,-0.023],[0,0],[0,0],[-0.5531,0.4148],[-1.08,0.795],[-2.02,1.44],[-2.36,1.54],[-0.1728,0.0691],[-0.1267,0.0461],[-0.1383,0.0345],[-0.265,-0.0115],[-0.0461,-0.1037],[-0.0807,-0.2535],[-0.1959,-0.6799],[-0.5646,-1.45],[-0.4378,-0.3226],[-0.4609,-0.1728],[-0.4379,-0.0807],[-0.4263,-0.0461],[-0.8296,-0.0461],[-0.3457,0.0576],[0,0],[-0.2189,0.0461],[0,0],[0,0],[0,0],[-0.53,0.2765],[-0.9909,0.5415],[-1.86,1],[-0.795,0.265],[-0.4839,0.0461],[0,0],[0,0]],\"v\":[[4.61,10.72],[3.88,9.94],[3.11,9.04],[1.52,8.23],[0.1735,9.52],[0.0352,11.23],[1.14,13.84],[5.36,16.18],[9.43,15.96],[15.98,13.62],[19.04,12.18],[20.52,11.48],[21.24,11.16],[21.58,11.03],[21.65,11],[21.77,11],[22.11,10.95],[22.86,10.83],[24.22,10.78],[25.87,11.15],[26.29,11.6],[26.81,12.74],[27.41,14.53],[27.97,15.9],[28.7,17.11],[29.12,17.64],[29.6,18.09],[30.64,18.83],[31.78,19.25],[32.94,19.44],[35.2,19.17],[36.24,18.91],[37.01,18.6],[41.68,16.02],[43.88,14.59],[46.31,12.99],[50.94,9.78],[55.9,6.23],[56.3,6.08],[56.39,6.08],[56.71,6.05],[57.37,6.03],[58.61,6.06],[59.73,6.25],[62.81,8.68],[64.21,11.1],[66.39,14.11],[70.38,16.41],[72.43,16.64],[73.36,16.63],[74.19,16.52],[79.16,15.12],[82.06,13.82],[84.38,12.5],[91.01,7.81],[91.58,7.39],[91.58,7.36],[92.44,7.03],[94.39,6.58],[94.7,6.59],[94.93,6.61],[95.12,6.66],[95.32,6.78],[97.08,8.81],[100.59,12.35],[101.89,13.1],[103.29,13.64],[104.7,13.99],[105.65,14.14],[106.13,14.22],[106.36,14.25],[106.59,14.21],[111.06,13.22],[113.02,12.87],[115.02,12.59],[131.51,11.99],[150.7,12.95],[162.14,13.42],[178.68,12.56],[182.33,11.91],[185.83,11.15],[192.48,9.06],[191.33,5.06],[184.89,6.11],[181.53,6.45],[178.08,6.75],[162.28,6.96],[151.72,6.04],[134.19,4.49],[127.33,4.54],[123.56,4.84],[121.65,4.98],[119.7,5.21],[115.8,5.67],[111.89,6.33],[108.06,7.17],[106.24,7.6],[106.26,7.6],[106.2,7.6],[106.09,7.63],[105.78,7.58],[103.91,6.72],[102.13,4.72],[99.64,1.9],[98.75,1.24],[97.76,0.6913],[96.68,0.2996],[95.65,0.1037],[94.64,0],[93.76,0.0461],[92.9,0.1037],[92.17,0.2535],[90.8,0.5761],[89.67,0.9679],[88.39,1.43],[87.37,2.14],[86.31,2.89],[85.43,3.51],[84.11,4.41],[80.53,6.74],[75.19,9.46],[72.42,10.14],[72.13,10.16],[71.9,10.13],[71.5,10.05],[70.79,9.59],[68.78,6.66],[65.31,2.52],[59.8,0.2996],[57.12,0.242],[55.85,0.3457],[54.1,0.5876],[53.3,0.9909],[52.57,1.54],[51.63,2.25],[50.01,3.48],[46.88,5.78],[41.42,9.54],[35.21,12.99],[34.69,13.18],[34.46,13.25],[34.06,13.29],[33.5,12.88],[33.38,12.58],[33.16,11.84],[32.44,9.68],[29.62,5.96],[28.24,5.16],[26.85,4.69],[25.52,4.47],[24.3,4.41],[22.04,4.55],[21.02,4.74],[20.49,4.83],[19.77,4.98],[19.08,5.27],[18.62,5.47],[17.76,5.89],[16.18,6.73],[13.27,8.32],[8.02,10.76],[5.89,11.19],[4.57,10.76],[4.61,10.72]]},\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.549,0.5608,0.5922,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,51.4],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"card purple 1 (skeleton)\",\"ddd\":0,\"ty\":4,\"ind\":21,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":3,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":6,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":9,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":12,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":15,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":18,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":21,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":24,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":27,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":30,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":33,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[429.46,422]},{\"t\":36,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[423.47,422]},{\"t\":39,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[408.61,422]},{\"t\":42,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[372.5,422]},{\"t\":45,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[331.14,422]},{\"t\":48,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[313.41,422]},{\"t\":51,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[306.21,422]},{\"t\":54,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[304.03,422]},{\"t\":57,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[304.79,422]},{\"t\":60,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.49,422]},{\"t\":63,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,425.37]},{\"t\":66,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,438.6]},{\"t\":69,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,471.62]},{\"t\":72,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,552.2]},{\"t\":75,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,641.96]},{\"t\":78,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,679.93]},{\"t\":81,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,695.21]},{\"t\":84,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,699.63]},{\"t\":87,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,697.69]},{\"t\":90,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,692]},{\"t\":93,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,692]},{\"t\":96,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,692]},{\"t\":99,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,692]},{\"t\":102,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,692]},{\"t\":105,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,692]},{\"t\":108,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,692]},{\"t\":111,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,692]},{\"t\":360,\"s\":[307.5,692]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[100]},{\"t\":29.99,\"i\":{\"x\":[0.5],\"y\":[1]},\"o\":{\"x\":[0.5],\"y\":[0]},\"s\":[100]},{\"t\":66.89,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[0]},{\"t\":360,\"s\":[0]}]},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"rc\",\"d\":1,\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":3,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":6,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":9,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":12,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":15,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":18,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":21,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":24,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":27,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":30,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":33,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[658.91,80]},{\"t\":36,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[646.93,80]},{\"t\":39,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[617.23,80]},{\"t\":42,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[544.99,80]},{\"t\":45,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[462.29,80]},{\"t\":48,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[426.81,80]},{\"t\":51,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[412.42,80]},{\"t\":54,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[408.06,80]},{\"t\":57,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[409.58,80]},{\"t\":60,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[414.97,80]},{\"t\":63,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,86.74]},{\"t\":66,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,113.2]},{\"t\":69,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,179.23]},{\"t\":72,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,340.4]},{\"t\":75,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,519.91]},{\"t\":78,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,595.85]},{\"t\":81,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,626.41]},{\"t\":84,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,635.26]},{\"t\":87,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,631.38]},{\"t\":90,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":93,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":96,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":99,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":102,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":105,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":108,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":111,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":360,\"s\":[415,620]}]},\"r\":{\"k\":4,\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.4196,0.4314,0.4627,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"card purple 1 (matte)\",\"ddd\":0,\"ty\":4,\"ind\":22,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":3,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":6,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":9,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":12,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":15,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":18,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":21,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":24,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":27,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":30,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[431,422]},{\"t\":33,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[429.46,422]},{\"t\":36,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[423.47,422]},{\"t\":39,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[408.61,422]},{\"t\":42,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[372.5,422]},{\"t\":45,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[331.14,422]},{\"t\":48,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[313.41,422]},{\"t\":51,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[306.21,422]},{\"t\":54,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[304.03,422]},{\"t\":57,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[304.79,422]},{\"t\":60,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.49,422]},{\"t\":63,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,425.37]},{\"t\":66,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,438.6]},{\"t\":69,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,471.62]},{\"t\":72,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,552.2]},{\"t\":75,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,641.96]},{\"t\":78,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,679.93]},{\"t\":81,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,695.21]},{\"t\":84,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,699.63]},{\"t\":87,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,697.69]},{\"t\":90,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,692]},{\"t\":93,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,692]},{\"t\":96,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,692]},{\"t\":99,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,692]},{\"t\":102,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,692]},{\"t\":105,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,692]},{\"t\":108,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,692]},{\"t\":111,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[307.5,692]},{\"t\":360,\"s\":[307.5,692]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"td\":1,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"rc\",\"d\":1,\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":3,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":6,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":9,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":12,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":15,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":18,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":21,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":24,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":27,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":30,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[662,80]},{\"t\":33,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[658.91,80]},{\"t\":36,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[646.93,80]},{\"t\":39,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[617.23,80]},{\"t\":42,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[544.99,80]},{\"t\":45,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[462.29,80]},{\"t\":48,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[426.81,80]},{\"t\":51,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[412.42,80]},{\"t\":54,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[408.06,80]},{\"t\":57,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[409.58,80]},{\"t\":60,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[414.97,80]},{\"t\":63,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,86.74]},{\"t\":66,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,113.2]},{\"t\":69,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,179.23]},{\"t\":72,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,340.4]},{\"t\":75,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,519.91]},{\"t\":78,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,595.85]},{\"t\":81,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,626.41]},{\"t\":84,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,635.26]},{\"t\":87,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,631.38]},{\"t\":90,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":93,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":96,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":99,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":102,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":105,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":108,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":111,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":360,\"s\":[415,620]}]},\"r\":{\"k\":4,\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[1,1,1,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"card purple 1 1\",\"ddd\":0,\"ty\":2,\"ind\":23,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[100,382],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"tt\":1,\"refId\":\"card_purple_1_1\"},{\"nm\":\"card gray 1\",\"ddd\":0,\"ty\":4,\"ind\":24,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[525,851]},{\"t\":3,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[525,851]},{\"t\":6,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[525,851]},{\"t\":9,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[525,851]},{\"t\":12,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[525,851]},{\"t\":15,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[525,851]},{\"t\":18,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[525,851]},{\"t\":21,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[525,851]},{\"t\":24,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[525,851]},{\"t\":27,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[525,851]},{\"t\":30,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[525,851]},{\"t\":33,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[527.72,851]},{\"t\":36,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[538.27,851]},{\"t\":39,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[564.42,851]},{\"t\":42,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[628.03,851]},{\"t\":45,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[700.86,851]},{\"t\":48,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[732.1,851]},{\"t\":51,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[744.78,851]},{\"t\":54,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[748.61,851]},{\"t\":57,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[747.28,851]},{\"t\":60,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[742.52,851]},{\"t\":63,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[742.5,849.02]},{\"t\":66,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[742.5,841.22]},{\"t\":69,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[742.5,821.78]},{\"t\":72,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[742.5,774.33]},{\"t\":75,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[742.5,721.47]},{\"t\":78,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[742.5,699.11]},{\"t\":81,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[742.5,690.11]},{\"t\":84,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[742.5,687.51]},{\"t\":87,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[742.5,688.65]},{\"t\":90,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[742.5,692]},{\"t\":93,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[742.5,692]},{\"t\":96,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[742.5,692]},{\"t\":99,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[742.5,692]},{\"t\":102,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[742.5,692]},{\"t\":105,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[742.5,692]},{\"t\":108,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[742.5,692]},{\"t\":111,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[742.5,692]},{\"t\":360,\"s\":[742.5,692]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"rc\",\"d\":1,\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[850,80]},{\"t\":3,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[850,80]},{\"t\":6,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[850,80]},{\"t\":9,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[850,80]},{\"t\":12,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[850,80]},{\"t\":15,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[850,80]},{\"t\":18,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[850,80]},{\"t\":21,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[850,80]},{\"t\":24,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[850,80]},{\"t\":27,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[850,80]},{\"t\":30,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[850,80]},{\"t\":33,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[844.56,80]},{\"t\":36,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[823.47,80]},{\"t\":39,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[771.15,80]},{\"t\":42,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[643.94,80]},{\"t\":45,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[498.28,80]},{\"t\":48,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[435.8,80]},{\"t\":51,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[410.45,80]},{\"t\":54,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[402.78,80]},{\"t\":57,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[405.45,80]},{\"t\":60,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[414.95,80]},{\"t\":63,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,86.74]},{\"t\":66,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,113.2]},{\"t\":69,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,179.23]},{\"t\":72,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,340.4]},{\"t\":75,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,519.91]},{\"t\":78,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,595.85]},{\"t\":81,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,626.41]},{\"t\":84,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,635.26]},{\"t\":87,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,631.38]},{\"t\":90,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":93,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":96,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":99,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":102,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":105,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":108,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":111,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":360,\"s\":[415,620]}]},\"r\":{\"k\":4,\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.9412,0.9451,0.949,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"card gray 2\",\"ddd\":0,\"ty\":4,\"ind\":25,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,571]},{\"t\":3,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,571]},{\"t\":6,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,571]},{\"t\":9,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,571]},{\"t\":12,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,571]},{\"t\":15,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,571]},{\"t\":18,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,571]},{\"t\":21,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,571]},{\"t\":24,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,571]},{\"t\":27,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,571]},{\"t\":30,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,571]},{\"t\":33,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[962.72,571]},{\"t\":36,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[973.27,571]},{\"t\":39,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[999.42,571]},{\"t\":42,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1063.03,571]},{\"t\":45,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1135.86,571]},{\"t\":48,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1167.1,571]},{\"t\":51,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1179.78,571]},{\"t\":54,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1183.61,571]},{\"t\":57,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1182.28,571]},{\"t\":60,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1177.52,571]},{\"t\":63,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1177.5,572.51]},{\"t\":66,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1177.5,578.44]},{\"t\":69,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1177.5,593.24]},{\"t\":72,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1177.5,629.35]},{\"t\":75,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1177.5,669.57]},{\"t\":78,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1177.5,686.59]},{\"t\":81,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1177.5,693.44]},{\"t\":84,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1177.5,695.42]},{\"t\":87,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1177.5,694.55]},{\"t\":90,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1177.5,692]},{\"t\":93,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1177.5,692]},{\"t\":96,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1177.5,692]},{\"t\":99,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1177.5,692]},{\"t\":102,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1177.5,692]},{\"t\":105,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1177.5,692]},{\"t\":108,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1177.5,692]},{\"t\":111,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1177.5,692]},{\"t\":360,\"s\":[1177.5,692]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"rc\",\"d\":1,\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":3,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":6,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":9,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":12,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":15,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":18,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":21,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":24,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":27,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":30,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":33,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1703.69,80]},{\"t\":36,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1640.4,80]},{\"t\":39,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1483.46,80]},{\"t\":42,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1101.81,80]},{\"t\":45,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[664.83,80]},{\"t\":48,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[477.41,80]},{\"t\":51,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[401.34,80]},{\"t\":54,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[378.33,80]},{\"t\":57,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[386.34,80]},{\"t\":60,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[414.85,80]},{\"t\":63,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,86.74]},{\"t\":66,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,113.2]},{\"t\":69,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,179.23]},{\"t\":72,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,340.4]},{\"t\":75,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,519.91]},{\"t\":78,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,595.85]},{\"t\":81,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,626.41]},{\"t\":84,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,635.26]},{\"t\":87,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,631.38]},{\"t\":90,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":93,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":96,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":99,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":102,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":105,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":108,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":111,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":360,\"s\":[415,620]}]},\"r\":{\"k\":4,\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.9412,0.9451,0.949,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"card gray 3\",\"ddd\":0,\"ty\":4,\"ind\":26,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,711]},{\"t\":3,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,711]},{\"t\":6,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,711]},{\"t\":9,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,711]},{\"t\":12,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,711]},{\"t\":15,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,711]},{\"t\":18,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,711]},{\"t\":21,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,711]},{\"t\":24,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,711]},{\"t\":27,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,711]},{\"t\":30,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[960,711]},{\"t\":33,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[968.16,711]},{\"t\":36,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[999.8,711]},{\"t\":39,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1078.27,711]},{\"t\":42,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1269.09,711]},{\"t\":45,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1487.58,711]},{\"t\":48,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1581.29,711]},{\"t\":51,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1619.33,711]},{\"t\":54,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1630.83,711]},{\"t\":57,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1626.83,711]},{\"t\":60,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1612.57,711]},{\"t\":63,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1612.5,710.76]},{\"t\":66,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1612.5,709.83]},{\"t\":69,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1612.5,707.51]},{\"t\":72,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1612.5,701.84]},{\"t\":75,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1612.5,695.52]},{\"t\":78,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1612.5,692.85]},{\"t\":81,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1612.5,691.77]},{\"t\":84,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1612.5,691.46]},{\"t\":87,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1612.5,691.6]},{\"t\":90,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1612.5,692]},{\"t\":93,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1612.5,692]},{\"t\":96,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1612.5,692]},{\"t\":99,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1612.5,692]},{\"t\":102,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1612.5,692]},{\"t\":105,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1612.5,692]},{\"t\":108,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1612.5,692]},{\"t\":111,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1612.5,692]},{\"t\":360,\"s\":[1612.5,692]}]},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"rc\",\"d\":1,\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"a\":1,\"k\":[{\"t\":0,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":3,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":6,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":9,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":12,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":15,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":18,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":21,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":24,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":27,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":30,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1720,80]},{\"t\":33,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1703.69,80]},{\"t\":36,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1640.4,80]},{\"t\":39,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1483.46,80]},{\"t\":42,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[1101.81,80]},{\"t\":45,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[664.83,80]},{\"t\":48,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[477.41,80]},{\"t\":51,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[401.34,80]},{\"t\":54,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[378.33,80]},{\"t\":57,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[386.34,80]},{\"t\":60,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[414.85,80]},{\"t\":63,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,86.74]},{\"t\":66,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,113.2]},{\"t\":69,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,179.23]},{\"t\":72,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,340.4]},{\"t\":75,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,519.91]},{\"t\":78,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,595.85]},{\"t\":81,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,626.41]},{\"t\":84,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,635.26]},{\"t\":87,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,631.38]},{\"t\":90,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":93,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":96,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":99,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":102,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":105,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":108,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":111,\"i\":{\"x\":[1],\"y\":[1]},\"o\":{\"x\":[0],\"y\":[0]},\"s\":[415,620]},{\"t\":360,\"s\":[415,620]}]},\"r\":{\"k\":4,\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[0.9412,0.9451,0.949,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]},{\"nm\":\"Background\",\"ddd\":0,\"ty\":4,\"ind\":27,\"sr\":1,\"ip\":0,\"op\":360,\"st\":0,\"ks\":{\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}},\"ao\":0,\"bm\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"rc\",\"d\":1,\"p\":{\"k\":[960,540],\"a\":0},\"s\":{\"k\":[1920,1080],\"a\":0},\"r\":{\"k\":0,\"a\":0}},{\"ty\":\"fl\",\"o\":{\"k\":100,\"a\":0},\"c\":{\"k\":[1,1,1,1],\"a\":0}},{\"ty\":\"tr\",\"a\":{\"k\":[0,0],\"a\":0},\"p\":{\"k\":[0,0],\"a\":0},\"s\":{\"k\":[100,100],\"a\":0},\"r\":{\"k\":0,\"a\":0},\"o\":{\"k\":100,\"a\":0},\"sk\":{\"k\":0,\"a\":0},\"sa\":{\"k\":0,\"a\":0}}]}]}],\"nm\":\"Remix animation - Create an infographic\",\"v\":\"5.5.2\",\"fr\":60,\"ip\":0,\"op\":360,\"w\":1920,\"h\":1080,\"ddd\":0,\"assets\":[{\"id\":\"card_purple_1_1\",\"u\":\"\",\"p\":\"remix-animation-card-purple.png\",\"e\":0,\"h\":620,\"w\":415}]}");


const $fc8365e3016e62d6$var$REMIX_ANIMATION_IMAGE_ASSET_ID = 'card_purple_1_1';
const $fc8365e3016e62d6$var$remixAnimationData = {
    ...(0, (/*@__PURE__*/$parcel$interopDefault($d1e5fcd73aeb6479$exports))),
    assets: (0, (/*@__PURE__*/$parcel$interopDefault($d1e5fcd73aeb6479$exports))).assets.map((asset)=>asset.id === $fc8365e3016e62d6$var$REMIX_ANIMATION_IMAGE_ASSET_ID ? {
            ...asset,
            p: (0, (/*@__PURE__*/$parcel$interopDefault($64ff43be3a1ab908$exports))),
            u: ''
        } : asset)
};
const $fc8365e3016e62d6$var$placeholderStyles = null;
const $fc8365e3016e62d6$var$rendererSettings = {
    preserveAspectRatio: 'xMidYMid meet'
}; /** Marks where an accepted SUGGESTED_REMIX result will land while its card is active. */ 
function $fc8365e3016e62d6$export$ad96c1fdd46ef47e() {
    const isReducedMotion = (0, $9ivsj.useIsReducedMotion)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iHsYL))), {
        animationData: $fc8365e3016e62d6$var$remixAnimationData,
        autoplay: !isReducedMotion,
        loop: false,
        rendererSettings: $fc8365e3016e62d6$var$rendererSettings,
        "aria-hidden": "true",
        "data-testid": "ai-suggestions-remix-placeholder",
        className: (0, $hekY6.default)([
            "_0bjKvD8fU6 _4bt5LAnQyn _2WAcuGnQyn _39xV02N91d _1EqgXl8yGE _3v5uP04flE _3138428HPE _0adFHsIZbP _1DCdHi8HPE _2XsHFMIZbP _1pp6NdYbGa"
        ])
    }, isReducedMotion ? 'reduced-motion' : 'animated');
}


/* SuggestionIconButton.tsx generated by @compiled/babel-plugin v3.0.1 */ 



var $cozmU = parcelRequire("cozmU");





var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $gVCFw = parcelRequire("gVCFw");


var $3k5Tv = parcelRequire("3k5Tv");


/* SuggestionIcon.tsx generated by @compiled/babel-plugin v3.0.1 */ 


parcelRequire("cozmU");




const $d7cc8c8cdc2edf4a$var$sizeStyles = {
    small: "_39xV02xpxF _0jFU0VxpxF",
    medium: "_39xV02oWWg _0jFU0VoWWg",
    large: "_39xV02Uofl _0jFU0VUofl",
    xlarge: "_39xV02pJKa _0jFU0VpJKa"
};
const $d7cc8c8cdc2edf4a$var$SPARKLE_PATH = 'M8.11719 1.00879C8.38352 1.05062 8.61063 1.23423 8.70508 1.49316L10.2549 5.74414L14.5068 7.29492C14.8027 7.40285 14.9998 7.6841 15 7.99902V8.00098C14.9998 8.3159 14.8027 8.59715 14.5068 8.70508L10.2549 10.2549L8.70508 14.5068C8.59715 14.8027 8.3159 14.9998 8.00098 15H7.99902C7.6841 14.9998 7.40285 14.8027 7.29492 14.5068L5.74414 10.2549L1.49316 8.70508C1.19728 8.59715 1.00018 8.3159 1 8.00098V7.99902C1.00018 7.6841 1.19728 7.40285 1.49316 7.29492L5.74414 5.74414L7.29492 1.49316L7.34277 1.38672C7.47321 1.15076 7.72343 1.00016 7.99902 1H8.00098L8.11719 1.00879Z'; /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * The sparkle a CSS mask rather than an SVG `clipPath` + `foreignObject` as
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * Safari has issues rendering the foreignObject.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * `%23000` is an encoded `#000`; only the mask's alpha channel matters, so any
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * opaque fill works.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */ 
const $d7cc8c8cdc2edf4a$var$SPARKLE_MASK_IMAGE = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='%23000' d='${$d7cc8c8cdc2edf4a$var$SPARKLE_PATH}'/%3E%3C/svg%3E")`;
const $d7cc8c8cdc2edf4a$var$maskStyles = null;
const $d7cc8c8cdc2edf4a$export$29d3364b0f29ebd1 = ({ size: size = 'large', label: label, children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _1mT5xdRAKS _3X9j4qHU5A _3mXABNUZDI _4AZChJDIqT _45s7WmgIor _1pp6NdYbGa",
            $d7cc8c8cdc2edf4a$var$sizeStyles[size]
        ]),
        children: children
    });
};


const $10017670bb6714bc$var$suggestionIconScaleVar = '--suggestion-icon-scale';
const $10017670bb6714bc$var$suggestionIconRotateVar = '--suggestion-icon-rotate';
const $10017670bb6714bc$var$suggestionIconOpacityVar = '--suggestion-icon-opacity';
const $10017670bb6714bc$var$styles = {
    container: "_1mT5xdWVPG _1VJPcaKthN _1pp6NdYsOL",
    button: "_0bjKvDS5Zs _3iDTPbvLZJ _4BEwsv7dHp _102sn98g64 _2slvlC7dHp _1arFOTvLZJ _3AA1nQIO1S _2KpK8NSldA _0b5YdqdnbC",
    svgContainer: "_23rrnHZreT _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0yKXXaXWGq _1VJPcaxs8n",
    baseIconColorLayer: "_23rrnHgITp _0jFU0VN91d _39xV02N91d _1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC",
    iconColor: "_0KLXru4YkS _1YKVNshOpP",
    iconColorHover: "_2uo31fN72K _1YKVNsYVbG"
};
const $10017670bb6714bc$var$AnimatedIcon = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        className: (0, $hekY6.default)([
            $10017670bb6714bc$var$styles.svgContainer
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $d7cc8c8cdc2edf4a$export$29d3364b0f29ebd1), {
            label: "",
            size: "small",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                    className: (0, $hekY6.default)([
                        $10017670bb6714bc$var$styles.baseIconColorLayer,
                        $10017670bb6714bc$var$styles.iconColor
                    ])
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                    className: (0, $hekY6.default)([
                        $10017670bb6714bc$var$styles.baseIconColorLayer,
                        $10017670bb6714bc$var$styles.iconColorHover
                    ])
                })
            ]
        })
    });
function $10017670bb6714bc$export$b6eb36123ab7ffdf({ leftAdjustment: leftAdjustment, localId: localId, api: api, intl: intl, topAdjustment: topAdjustment }) {
    // Derived primitives (rather than the state maps) so the hook's shallow
    // equality check can skip re-renders that don't affect this button.
    const { firstSuggestionId: firstSuggestionId, isSelected: isSelected, shortDescription: shortDescription, suggestionsCount: suggestionsCount } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiSuggestions'
    ], (state)=>{
        const { suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId, suggestionById: suggestionById, selectedSuggestion: selectedSuggestion } = state?.aiSuggestionsState ?? {};
        const suggestionIds = suggestionIdsByBaseLocalId?.get(localId);
        const firstSuggestionId = suggestionIds?.values().next().value;
        return {
            firstSuggestionId: firstSuggestionId,
            isSelected: Boolean(selectedSuggestion && suggestionIds?.has(selectedSuggestion)),
            shortDescription: firstSuggestionId ? suggestionById?.get(firstSuggestionId)?.shortDescription : undefined,
            suggestionsCount: suggestionIds?.size ?? 0
        };
    });
    const isSelectingSuggestionRef = (0, $cozmU.useRef)(false);
    const onSelectSuggestion = (0, $cozmU.useCallback)(()=>{
        if (isSelectingSuggestionRef.current) return;
        isSelectingSuggestionRef.current = true;
        const selectSuggestion = async ()=>{
            try {
                const canCloseComment = await api?.annotation?.actions.requestCloseInlineComment?.() ?? true;
                if (!canCloseComment || !firstSuggestionId) return;
                api?.aiSuggestions?.actions.selectSuggestion(firstSuggestionId, {
                    interactionPoint: 'card'
                });
            } finally{
                isSelectingSuggestionRef.current = false;
            }
        };
        selectSuggestion();
    }, [
        api,
        firstSuggestionId
    ]);
    const setHoveredSuggestion = (id)=>{
        api?.core?.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $1b159f40bd8b3a1f$export$dbbefe45c19011aa), {
                action: 'HOVER_SUGGESTION',
                id: id
            });
            return tr;
        });
    };
    const tooltip = (0, $cozmU.useMemo)(()=>({
            content: suggestionsCount > 1 ? intl?.formatMessage((0, $gVCFw.aiSuggestionsMessages).iconButtonSuggestionsCountLabel, {
                count: suggestionsCount
            }) || (shortDescription ?? '') : shortDescription ?? '',
            position: 'top'
        }), [
        intl,
        shortDescription,
        suggestionsCount
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.IntlProvider), {
        defaultLocale: intl?.defaultLocale || 'en-US',
        locale: intl?.locale || 'en-US',
        messages: intl?.messages,
        formats: intl?.formats,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            style: {
                anchorName: `--button-${localId}`,
                top: topAdjustment ?? 0,
                right: `calc(${"var(--ds-space-negative-300, -24px)"} + ${"var(--ds-space-negative-300, -24px)"} - ${leftAdjustment ?? '0px'})`
            },
            className: (0, $hekY6.default)([
                $10017670bb6714bc$var$styles.container
            ]),
            children: // We keep the anchorName span rendered so that the suggestion card can reference it
            !isSelected && firstSuggestionId && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                onMouseEnter: ()=>setHoveredSuggestion(firstSuggestionId),
                onMouseLeave: ()=>setHoveredSuggestion(undefined),
                onFocus: ()=>setHoveredSuggestion(firstSuggestionId),
                onBlur: ()=>setHoveredSuggestion(undefined),
                className: (0, $hekY6.default)([
                    $10017670bb6714bc$var$styles.button
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                    isTooltipDisabled: false,
                    tooltip: tooltip,
                    shape: "circle",
                    type: "button",
                    label: tooltip.content,
                    onClick: onSelectSuggestion,
                    appearance: "subtle",
                    spacing: "compact",
                    icon: $10017670bb6714bc$var$AnimatedIcon
                })
            })
        })
    });
}


/**
 * Streaming response types for ConvoAI
 */ function $9b3621d9606bf0dd$export$9167f99f9be83b24() {
    const { origin: origin = '', port: port = '', hostname: hostname = '' } = typeof window.location !== 'undefined' ? window.location : {};
    if (hostname === 'localhost' && port !== '8081' || [
        'atlaskit-website-staging.stg-east.frontend.public.atl-paas.net',
        'statlas.prod.atl-paas.net',
        'atlaskit.atlassian.com'
    ].some((h)=>hostname === h)) return 'https://pug.jira-dev.com';
    return origin;
}
async function $9b3621d9606bf0dd$export$7ba546d072711b5d(body, options = {}) {
    const { onChunk: onChunk, onFinalResponse: onFinalResponse, onError: onError, signal: signal } = options;
    const reader = body.getReader();
    const decoder = new TextDecoder('utf-8');
    let buffer = '';
    let finalResponse = null;
    const chunks = [];
    try {
        while(!signal?.aborted){
            const { value: value, done: done } = await reader.read();
            if (done) break;
            const chunk = decoder.decode(value, {
                stream: true
            });
            buffer += chunk;
            // Split by newlines and process complete lines
            // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
            const lines = buffer.split('\n');
            // Keep the last potentially incomplete line in the buffer
            buffer = lines.pop() || '';
            for (const line of lines){
                if (!line.trim()) continue;
                try {
                    const data = JSON.parse(line);
                    chunks.push(data);
                    onChunk?.(data);
                    // Check for FINAL_RESPONSE type (ConvoAI pattern)
                    if (data.type === 'FINAL_RESPONSE') {
                        finalResponse = data;
                        onFinalResponse?.(data);
                    }
                } catch (parseError) {
                    const error = new Error(`Failed to parse JSON line: ${parseError instanceof Error ? parseError.message : String(parseError)}`);
                    onError?.(error);
                }
            }
        }
        // Check if aborted
        if (signal?.aborted) reader.cancel();
        // Process any remaining buffer content
        if (buffer.trim()) try {
            const data = JSON.parse(buffer);
            chunks.push(data);
            onChunk?.(data);
            if (data.type === 'FINAL_RESPONSE') {
                finalResponse = data;
                onFinalResponse?.(data);
            }
        } catch  {
        // Ignore incomplete final chunk
        }
    } catch (error) {
        const streamError = error instanceof Error ? error : new Error(String(error));
        onError?.(streamError);
        throw streamError;
    }
    return {
        finalResponse: finalResponse,
        chunks: chunks
    };
}
async function $9b3621d9606bf0dd$export$95b9987b6ac049ec(options) {
    const { url: url, fetchOptions: fetchOptions = {}, signal: signal, onChunk: onChunk, onError: onError, onFinalResponse: onFinalResponse } = options;
    const response = await fetch(url, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'X-Channel-Id': 'editor',
            'X-Product': 'confluence',
            'X-Experience-Id': 'editor'
        },
        ...fetchOptions,
        signal: signal
    });
    if (!response.ok) {
        const error = new Error(`Response not OK: ${response.status}`);
        onError?.(error);
        throw error;
    }
    if (!response.body) {
        const error = new Error('No response body');
        onError?.(error);
        throw error;
    }
    return $9b3621d9606bf0dd$export$7ba546d072711b5d(response.body, {
        onChunk: onChunk,
        onError: onError,
        onFinalResponse: onFinalResponse,
        signal: signal
    });
}


const $61b8b9734ab6a330$export$eab6f356b10dc881 = 'content_reviewer_agent';
async function $61b8b9734ab6a330$export$8f943592d88201ff({ cloudId: cloudId, signal: signal }) {
    const url = `${(0, $9b3621d9606bf0dd$export$9167f99f9be83b24)()}/gateway/api/assist/v1/agent/provisioning/ootb/${$61b8b9734ab6a330$export$eab6f356b10dc881}`;
    const response = await fetch(url, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'X-Product': 'confluence',
            'X-Experience-Id': 'ai-mate',
            'Atl-CloudId': cloudId
        },
        signal: signal
    });
    if (!response.ok) throw new Error(`Provision OOTB agent request failed: ${response.status}`);
}
async function $61b8b9734ab6a330$export$ebf2f44fe450da2b({ contentAri: contentAri, signal: signal }) {
    const url = `${(0, $9b3621d9606bf0dd$export$9167f99f9be83b24)()}/gateway/api/assist/api/ai/v2/ai-feature/content-suggested-edits/suggestions?content_ari=${encodeURIComponent(contentAri)}&status=PENDING`;
    const response = await fetch(url, {
        method: 'GET',
        credentials: 'include',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'X-Channel-Id': 'editor',
            'X-Product': 'confluence',
            'X-Experience-Id': 'editor'
        },
        signal: signal
    });
    if (!response.ok) throw new Error(`Get suggestions request failed: ${response.status}`);
    const data = await response.json();
    const items = data?.ai_feature_output?.items;
    return Array.isArray(items) ? items : [];
}
async function $61b8b9734ab6a330$export$1d496d000386893c({ updates: updates, signal: signal }) {
    // /ai-features/content-suggested-edits/update-status
    const payload = {
        experience_id: 'ai-content-suggested-edits',
        ai_feature_input: {
            updates: updates
        }
    };
    const url = `${(0, $9b3621d9606bf0dd$export$9167f99f9be83b24)()}/gateway/api/assist/api/ai/v2/ai-feature/content-suggested-edits/update-status`;
    const response = await fetch(url, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'X-Channel-Id': 'editor',
            'X-Product': 'confluence',
            'X-Experience-Id': 'editor'
        },
        body: JSON.stringify(payload),
        signal: signal
    });
    if (!response.ok) throw new Error(`Content suggested edits request failed: ${response.status}`);
}
async function $61b8b9734ab6a330$export$7ffa8bd2a6ad0cd0({ suggestionIds: suggestionIds, contentAri: contentAri, currentNodes: currentNodes, signal: signal }) {
    const payload = {
        experience_id: 'ai-content-suggested-edits',
        ai_feature_input: {
            content_ari: contentAri,
            current_nodes: currentNodes,
            suggestion_ids: suggestionIds
        }
    };
    const url = `${(0, $9b3621d9606bf0dd$export$9167f99f9be83b24)()}/gateway/api/assist/api/ai/v2/ai-feature/content-suggested-edits/suggestions/regenerate`;
    const response = await fetch(url, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'X-Channel-Id': 'editor',
            'X-Product': 'confluence',
            'X-Experience-Id': 'editor'
        },
        body: JSON.stringify(payload),
        signal: signal
    });
    if (!response.ok) throw new Error(`Regenerate suggestions request failed: ${response.status}`);
    const data = await response.json();
    const items = data?.ai_feature_output?.items;
    return Array.isArray(items) ? items : [];
}



var $eOaGc = parcelRequire("eOaGc");


var $iDrrr = parcelRequire("iDrrr");




const $295ac436451fb879$export$ef2b3f5e81ffeef8 = ()=>(0, $4o0zT.isExperimentEnabled)('platform_editor_ai_suggested_edits_default_on');


function $c08510c480bfb65f$export$e644b4e6be3487e(suggestion) {
    if (suggestion.anchorLocalId) return suggestion.anchorLocalId;
    const firstToolCall = suggestion.toolCalls?.[0];
    return firstToolCall && 'localId' in firstToolCall.arguments ? firstToolCall.arguments.localId : undefined;
}



var $krYZG = parcelRequire("krYZG");

// Walks an inserted ADF subtree to collect every `localId` and node `type`. Captures localIds at
// every depth because tool-call collisions can be triggered by nested ids, not just the root.
function $2a4bc64013915ea2$var$collectFromAdf(node, localIds, nodeTypes) {
    if (!node || typeof node !== 'object') return;
    if (typeof node.type === 'string') nodeTypes.add(node.type);
    const localId = node.attrs?.localId;
    if (typeof localId === 'string') localIds.add(localId);
    if (Array.isArray(node.content)) for (const child of node.content)$2a4bc64013915ea2$var$collectFromAdf(child, localIds, nodeTypes);
}
function $2a4bc64013915ea2$var$collectFromToolCall(toolCall, localIds, nodeTypes) {
    if (toolCall.name === 'removeNodes') {
        for (const id of toolCall.arguments.localIds)localIds.add(id);
        return;
    }
    localIds.add(toolCall.arguments.localId);
    if ('value' in toolCall.arguments && typeof toolCall.arguments.value === 'string') try {
        $2a4bc64013915ea2$var$collectFromAdf(JSON.parse(toolCall.arguments.value), localIds, nodeTypes);
    } catch  {
    // Ignore malformed JSON - the tool call would also fail to apply, surfaced elsewhere.
    }
}
function $2a4bc64013915ea2$var$collectToolCallAttributes(toolCall) {
    const localIds = new Set();
    const nodeTypes = new Set();
    $2a4bc64013915ea2$var$collectFromToolCall(toolCall, localIds, nodeTypes);
    return {
        name: toolCall.name,
        localIds: Array.from(localIds),
        nodeTypes: Array.from(nodeTypes)
    };
}
function $2a4bc64013915ea2$var$getErrorCodeAttributes(errorAttributes) {
    const { errorCode: errorCode, statusCode: statusCode } = errorAttributes ?? {};
    return {
        ...typeof errorCode === 'string' ? {
            errorCode: errorCode
        } : {},
        ...typeof statusCode === 'number' ? {
            statusCode: statusCode
        } : {}
    };
}
const $2a4bc64013915ea2$export$707043ea55006b30 = (editorAnalyticsAPI)=>(transaction, suggestion)=>{
        const toolCalls = (suggestion.toolCalls ?? []).map($2a4bc64013915ea2$var$collectToolCallAttributes);
        const payload = {
            action: (0, $krYZG.ACTION).NO_DIFF_FOUND,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                suggestionType: suggestion.type,
                toolCalls: toolCalls
            }
        };
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(transaction);
        return transaction;
    };
const $2a4bc64013915ea2$export$d485252031168fc9 = (suggestion)=>{
    const ids = new Set();
    for (const localId of suggestion.action?.localIds ?? [])ids.add(localId);
    for (const toolCall of suggestion.toolCalls ?? []){
        if (toolCall.name === 'removeNodes') for (const id of toolCall.arguments.localIds)ids.add(id);
        else ids.add(toolCall.arguments.localId);
    }
    return ids.size;
};
/**
 * Returns the total plain text characters being added by a suggestion.
 * Derived from the `value` ADF JSON of inserting/replacing tool calls.
 */ function $2a4bc64013915ea2$var$getTextFromAdfNode(node) {
    if (node.type === 'text' && typeof node.text === 'string') return node.text;
    if (Array.isArray(node.content)) return node.content.map((child)=>$2a4bc64013915ea2$var$getTextFromAdfNode(child)).join('');
    return '';
}
const $2a4bc64013915ea2$export$d01a7319a5878cbe = (suggestion)=>{
    let count = 0;
    for (const toolCall of suggestion.toolCalls ?? []){
        if ('value' in toolCall.arguments && typeof toolCall.arguments.value === 'string') try {
            count += $2a4bc64013915ea2$var$getTextFromAdfNode(JSON.parse(toolCall.arguments.value)).length;
        } catch  {
        // malformed JSON — skip
        }
    }
    return count;
};
const $2a4bc64013915ea2$export$1dd4e3d2c42a2395 = (suggestion, doc)=>{
    const removingCalls = [
        'removeNode',
        'removeNodes',
        'replaceNode'
    ];
    const visitedIds = new Set();
    let count = 0;
    for (const toolCall of suggestion.toolCalls ?? []){
        if (!removingCalls.includes(toolCall.name)) continue;
        const localIds = toolCall.name === 'removeNodes' ? toolCall.arguments.localIds : [
            toolCall.arguments.localId
        ];
        for (const localId of localIds){
            if (visitedIds.has(localId)) continue;
            visitedIds.add(localId);
            doc.descendants((node)=>{
                if (node.attrs.localId === localId) {
                    count += node.textContent.length;
                    return false;
                }
            });
        }
    }
    return count;
};
const $2a4bc64013915ea2$export$33e4f7f2497d28c1 = (editorAnalyticsAPI)=>(transaction, entryPoint)=>{
        const payload = {
            action: (0, $krYZG.ACTION).CLICKED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                entryPoint: entryPoint
            }
        };
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(transaction);
        return transaction;
    };
const $2a4bc64013915ea2$export$23faece8799b6885 = (editorAnalyticsAPI)=>(transaction)=>{
        const payload = {
            action: (0, $krYZG.ACTION).CLICKED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SUGGESTIONS_ERROR_RETRY,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        };
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(transaction);
        return transaction;
    };
const $2a4bc64013915ea2$export$5a116e8d20eb61e1 = (editorAnalyticsAPI, entryPoint)=>{
    const payload = {
        action: (0, $krYZG.ACTION).EXPOSED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            entryPoint: entryPoint
        }
    };
    editorAnalyticsAPI?.fireAnalyticsEvent(payload);
};
const $2a4bc64013915ea2$export$4ca37dd723b35752 = (editorAnalyticsAPI, error)=>{
    const errorAttributes = error?.errorAttributes;
    const payload = {
        action: (0, $krYZG.ACTION).ERRORED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).CONVERSATION_ERROR,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            reason: 'conversationSetup',
            ...$2a4bc64013915ea2$var$getErrorCodeAttributes(errorAttributes)
        }
    };
    editorAnalyticsAPI?.fireAnalyticsEvent(payload);
};
const $2a4bc64013915ea2$export$c2bc44992302850a = (editorAnalyticsAPI, error)=>{
    const message = error?.message;
    const payload = {
        action: (0, $krYZG.ACTION).ERRORED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).CONVERSATION_ERROR,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            reason: 'streamError',
            ...$2a4bc64013915ea2$var$getErrorCodeAttributes({
                errorCode: message?.key,
                statusCode: message?.status_code
            })
        }
    };
    editorAnalyticsAPI?.fireAnalyticsEvent(payload);
};
const $2a4bc64013915ea2$export$f79b8848e86580c7 = (editorAnalyticsAPI, error)=>{
    const errorAttributes = error?.errorAttributes;
    const payload = {
        action: (0, $krYZG.ACTION).ERRORED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).CONVERSATION_ERROR,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            reason: 'agentProvisioning',
            ...$2a4bc64013915ea2$var$getErrorCodeAttributes(errorAttributes)
        }
    };
    editorAnalyticsAPI?.fireAnalyticsEvent(payload);
};
const $2a4bc64013915ea2$export$340d751fde574e23 = (editorAnalyticsAPI)=>{
    const payload = {
        action: (0, $krYZG.ACTION).ERRORED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).CONVERSATION_ERROR,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            reason: 'agentExternalConfigReference'
        }
    };
    editorAnalyticsAPI?.fireAnalyticsEvent(payload);
};
const $2a4bc64013915ea2$export$b36e176162c1ac33 = (editorAnalyticsAPI)=>{
    const payload = {
        action: (0, $krYZG.ACTION).ERRORED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).CONVERSATION_ERROR,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            reason: 'agentDeactivated'
        }
    };
    editorAnalyticsAPI?.fireAnalyticsEvent(payload);
};
const $2a4bc64013915ea2$export$2c94dca769ea778b = (editorAnalyticsAPI, error, { staleSuggestionCount: staleSuggestionCount, currentNodeCount: currentNodeCount })=>{
    const errorAttributes = error?.errorAttributes;
    const payload = {
        action: (0, $krYZG.ACTION).ERRORED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SUGGESTIONS_REGENERATION_ERROR,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            staleSuggestionCount: staleSuggestionCount,
            currentNodeCount: currentNodeCount,
            ...$2a4bc64013915ea2$var$getErrorCodeAttributes(errorAttributes)
        }
    };
    editorAnalyticsAPI?.fireAnalyticsEvent(payload);
};
const $2a4bc64013915ea2$var$SUGGESTED_EDITS_EXPERIENCE_NAME = 'Suggested edits';
const $2a4bc64013915ea2$export$94b303e4fd9baa4e = (editorAnalyticsAPI, entryPoint, singleInstrumentationId)=>{
    const payload = {
        action: (0, $krYZG.ACTION).INITIATED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_INTERACTION,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EDITOR_PLUGIN_AI,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            aiFeatureName: 'Editor AI',
            aiExperienceName: $2a4bc64013915ea2$var$SUGGESTED_EDITS_EXPERIENCE_NAME,
            singleInstrumentationID: singleInstrumentationId,
            isAIFeature: 1,
            // TODO: EDITOR-8150 - userGeneratedAI / proactiveAIGenerated are hardcoded for
            // the current user-triggered flow; parameterise these once proactive
            // suggestions are supported.
            userGeneratedAI: 1,
            proactiveAIGenerated: 0,
            invokedFrom: entryPoint
        }
    };
    editorAnalyticsAPI?.fireAnalyticsEvent(payload);
};
const $2a4bc64013915ea2$export$ec701ea77bc93a9f = (editorAnalyticsAPI)=>(transaction, suggestion, interactionPoint)=>{
        const payload = {
            action: (0, $krYZG.ACTION).DISCARDED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                actionKind: suggestion.actionKind ?? 'SUGGESTED_EDIT',
                affectedBlocks: $2a4bc64013915ea2$export$d485252031168fc9(suggestion),
                suggestionType: suggestion.type,
                interactionPoint: interactionPoint
            }
        };
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(transaction);
        return transaction;
    };
const $2a4bc64013915ea2$export$6bd5a709c87f4c35 = (editorAnalyticsAPI, sentiment, singleInstrumentationId, interactionPoint)=>{
    const payload = {
        action: (0, $krYZG.ACTION).SUBMITTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_FEEDBACK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EDITOR_PLUGIN_AI,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            aiFeatureName: 'Editor AI',
            aiExperienceName: $2a4bc64013915ea2$var$SUGGESTED_EDITS_EXPERIENCE_NAME,
            singleInstrumentationID: singleInstrumentationId,
            isAIFeature: 1,
            // TODO: EDITOR-8150 - userGeneratedAI / proactiveAIGenerated are hardcoded for
            // the current user-triggered flow; parameterise these once proactive
            // suggestions are supported.
            userGeneratedAI: 1,
            proactiveAIGenerated: 0,
            invokedFrom: interactionPoint,
            aiFeedbackResult: sentiment === 'good' ? 'up' : 'down'
        }
    };
    editorAnalyticsAPI?.fireAnalyticsEvent(payload);
};
const $2a4bc64013915ea2$export$5085d0c956f2f4ac = (editorAnalyticsAPI)=>(transaction, suggestion, interactionPoint)=>{
        const payload = {
            action: (0, $krYZG.ACTION).DISMISSED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                affectedBlocks: $2a4bc64013915ea2$export$d485252031168fc9(suggestion),
                suggestionType: suggestion.type,
                interactionPoint: interactionPoint
            }
        };
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(transaction);
        return transaction;
    };
const $2a4bc64013915ea2$export$c37411486d5e33f8 = ({ currentState: currentState, editorAnalyticsAPI: editorAnalyticsAPI, interactionPoint: interactionPoint, nextSuggestionId: nextSuggestionId, transaction: transaction })=>{
    if (!interactionPoint) return transaction;
    const previousSelectedSuggestionId = currentState?.selectedSuggestion;
    const previousSelectedSuggestion = previousSelectedSuggestionId ? currentState?.suggestionById.get(previousSelectedSuggestionId) : undefined;
    const isClearingSelectedSuggestion = nextSuggestionId === null;
    const isReplacingSelectedSuggestion = nextSuggestionId !== null && currentState?.suggestionById.has(nextSuggestionId) === true;
    const shouldTrackDismissedSuggestion = previousSelectedSuggestionId !== undefined && previousSelectedSuggestionId !== nextSuggestionId && (isClearingSelectedSuggestion || isReplacingSelectedSuggestion);
    const dismissedSuggestion = shouldTrackDismissedSuggestion ? previousSelectedSuggestion : undefined;
    if (dismissedSuggestion) $2a4bc64013915ea2$export$5085d0c956f2f4ac(editorAnalyticsAPI)(transaction, dismissedSuggestion, interactionPoint);
    return transaction;
};
const $2a4bc64013915ea2$export$799e089d141dbbc0 = (suggestion, doc)=>{
    const localIds = new Set(suggestion.action?.localIds ?? []);
    const nodeTypes = new Set();
    for (const toolCall of suggestion.toolCalls ?? [])$2a4bc64013915ea2$var$collectFromToolCall(toolCall, localIds, nodeTypes);
    // Look up removed nodes in the doc by localId to capture their types (removeNodes has no ADF value).
    doc.descendants((node)=>{
        if (typeof node.attrs?.localId === 'string' && localIds.has(node.attrs.localId)) nodeTypes.add(node.type.name);
    });
    const schema = doc.type.schema;
    return Array.from(nodeTypes).filter((typeName)=>schema.nodes[typeName]?.isBlock === true);
};
const $2a4bc64013915ea2$export$aaae075a5bab9523 = (editorAnalyticsAPI)=>(transaction, suggestion, interactionPoint)=>{
        const isSuggestedRemix = suggestion.actionKind === 'SUGGESTED_REMIX';
        const payload = {
            action: (0, $krYZG.ACTION).VIEWED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                actionKind: suggestion.actionKind ?? 'SUGGESTED_EDIT',
                affectedBlocks: $2a4bc64013915ea2$export$d485252031168fc9(suggestion),
                blockTypes: $2a4bc64013915ea2$export$799e089d141dbbc0(suggestion, transaction.doc),
                ...!isSuggestedRemix && {
                    charactersToAdd: $2a4bc64013915ea2$export$d01a7319a5878cbe(suggestion),
                    charactersToRemove: $2a4bc64013915ea2$export$1dd4e3d2c42a2395(suggestion, transaction.doc)
                },
                interactionPoint: interactionPoint,
                suggestionCardCharacterCount: suggestion.shortDescription?.length ?? 0,
                suggestionType: suggestion.type
            }
        };
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(transaction);
        return transaction;
    };
const $2a4bc64013915ea2$export$22bc65b38809466 = (editorAnalyticsAPI, suggestion, interactionPoint)=>{
    const payload = {
        action: (0, $krYZG.ACTION).REASONING_VIEWED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            affectedBlocks: $2a4bc64013915ea2$export$d485252031168fc9(suggestion),
            interactionPoint: interactionPoint,
            reasoningCharacterCount: suggestion.reasoning?.length ?? 0,
            suggestionType: suggestion.type
        }
    };
    editorAnalyticsAPI?.fireAnalyticsEvent(payload);
};
const $2a4bc64013915ea2$export$f1a852c299619cdc = (editorAnalyticsAPI)=>(transaction, suggestion, interactionPoint)=>{
        const isSuggestedRemix = suggestion.actionKind === 'SUGGESTED_REMIX';
        const payload = {
            action: (0, $krYZG.ACTION).ACCEPTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                affectedBlocks: $2a4bc64013915ea2$export$d485252031168fc9(suggestion),
                ...!isSuggestedRemix && {
                    charactersAdded: $2a4bc64013915ea2$export$d01a7319a5878cbe(suggestion),
                    charactersRemoved: $2a4bc64013915ea2$export$1dd4e3d2c42a2395(suggestion, transaction.doc)
                },
                suggestionType: suggestion.type,
                interactionPoint: interactionPoint
            }
        };
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(transaction);
        return transaction;
    };



var $8QOo3 = parcelRequire("8QOo3");


var $5Qi6J = parcelRequire("5Qi6J");




function $2ad4b5801d1093af$var$isRecord(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
function $2ad4b5801d1093af$export$da10b2800363f225(attrs) {
    if ($2ad4b5801d1093af$var$isRecord(attrs)) return attrs;
    if (typeof attrs !== 'string') return undefined;
    try {
        const parsed = JSON.parse(attrs);
        return $2ad4b5801d1093af$var$isRecord(parsed) ? parsed : undefined;
    } catch  {
        return undefined;
    }
}



var $2w79Z = parcelRequire("2w79Z");


var $bjg0G = parcelRequire("bjg0G");

function $2c24ed7b0ddbc6f4$export$676497ef504d5696(tr, position, content, side = 'after') {
    const $insertPos = tr.doc.resolve(position);
    if ((0, $2w79Z.isEmptyParagraph)($insertPos.parent) && $insertPos.depth > 0) {
        const $beforeParagraph = tr.doc.resolve($insertPos.before());
        if ((0, $bjg0G.canInsert)($beforeParagraph, content)) {
            tr.replaceWith($insertPos.before(), $insertPos.after(), content);
            return tr;
        }
    }
    if ((0, $bjg0G.canInsert)($insertPos, content)) {
        tr.insert($insertPos.pos, content);
        return tr;
    }
    for(let depth = $insertPos.depth; depth > 0; depth--){
        const pos = side === 'before' ? $insertPos.before(depth) : $insertPos.after(depth);
        if ((0, $bjg0G.canInsert)(tr.doc.resolve(pos), content)) {
            tr.insert(pos, content);
            return tr;
        }
    }
    return tr;
}



var $lAynq = parcelRequire("lAynq");


var $aPdNQ = parcelRequire("aPdNQ");








function $e655df7f8ec1986e$var$wrapChild(fragment, type, attrs) {
    if (!fragment.firstChild) return null;
    const wrappingNodeTypes = type.contentMatch.findWrapping(fragment.firstChild.type);
    let currentChildNodes = null;
    if (wrappingNodeTypes) {
        currentChildNodes = fragment.content;
        for(let i = wrappingNodeTypes.length - 1; i >= 0; i--){
            const wrappingNodeType = wrappingNodeTypes[i];
            const nextChildNode = wrappingNodeType.createAndFill(null, currentChildNodes);
            if (nextChildNode) currentChildNodes = [
                nextChildNode
            ];
            else {
                currentChildNodes = null;
                break;
            }
        }
    }
    if (currentChildNodes) return type.createAndFill(attrs, currentChildNodes);
    return null;
}
function $e655df7f8ec1986e$var$findPosForNode(node, $to) {
    for(let depth = $to.depth; depth >= 0; depth--){
        const ancestor = $to.node(depth);
        if (ancestor.type.contentMatch.matchType(node.type)) return $to.after(depth + 1);
    }
    return null;
}
const $e655df7f8ec1986e$export$5a065b4e594c5a9c = ({ toolCallArguments: toolCallArguments, tr: tr, pos: pos })=>{
    const $from = tr.doc.resolve(pos);
    const node = tr.doc.nodeAt(pos);
    if (!node) return tr;
    const $to = tr.doc.resolve(pos + node.nodeSize);
    const range = $from.blockRange($to);
    if (range) {
        const type = tr.doc.type.schema.nodes[toolCallArguments.wrapperType];
        try {
            // Tool-call attrs reach us in the shape the payload encoded them in, which is not
            // necessarily the shape ProseMirror can consume — see `parseToolCallAttrs`. An unusable
            // value yields `undefined`, which `findWrapping`/`createAndFill` read as "all schema
            // defaults" rather than as the junk attrs spreading a string produces.
            const wrapperAttrs = (0, $2ad4b5801d1093af$export$da10b2800363f225)(toolCallArguments.wrapperAttrs);
            // A wrapper type that supports `localId` gets one up-front, as the block menu's
            // convert-to-expand does. Without it the local-id plugin's `appendTransaction` assigns
            // one via a `BatchAttrsStep` before the view updates, which swaps the wrapper node
            // object out and drops any state keyed on its identity — including the `expandedState`
            // entry `openWrappedExpands` sets to keep a wrapped expand open. `generateShortUUID` is
            // that plugin's own generator, so the id matches the ones it assigns and is registered
            // for its collision checks.
            const needsLocalId = (0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_1') && Boolean(type.spec.attrs?.localId) && typeof wrapperAttrs?.localId !== 'string';
            const attrs = needsLocalId ? {
                ...wrapperAttrs,
                localId: (0, $lAynq.generateShortUUID)()
            } : wrapperAttrs;
            const wrapping = (0, $eOaGc.findWrapping)(range, type, attrs);
            if (wrapping !== null) tr.wrap(range, wrapping);
            else {
                const slice = tr.doc.slice(range.$from.pos, range.$to.pos);
                const fragment = slice.content;
                let node = type.createAndFill(attrs, fragment);
                if (!node) node = $e655df7f8ec1986e$var$wrapChild(fragment, type, attrs);
                if (node) {
                    const insertPos = $e655df7f8ec1986e$var$findPosForNode(node, $to);
                    if (insertPos !== null) {
                        tr.insert(insertPos, node);
                        tr.replaceRange(range.$from.pos, range.$to.pos, (0, $aPdNQ.Slice).empty);
                    }
                }
            }
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    }
    return tr;
};


function $f40c730c85c0fd70$var$createNodeFromToolCallValue(schema, value) {
    try {
        const parsed = typeof value === 'string' ? JSON.parse(value) : value;
        return (0, $5Qi6J.processRawValue)(schema, parsed);
    } catch  {
        return undefined;
    }
}
function $f40c730c85c0fd70$export$3a685203b954911f(doc, localId) {
    let result;
    doc.descendants((node, pos)=>{
        if (result) return false;
        if (node.attrs.localId === localId) result = {
            from: pos,
            to: pos + node.nodeSize
        };
        return !result;
    });
    return result;
}
const $f40c730c85c0fd70$var$EXPAND_NODE_TYPE_NAMES = [
    'expand',
    'nestedExpand'
];
/**
 * Finds the node of `typeName` that now encloses the node with `localId`, i.e. the
 * wrapper a `wrap` tool call just created around it. Re-deriving it from the tool call's
 * own `localId` avoids having to track the wrapper's position across the steps of the
 * tool calls that follow, which can both move it and replace the node object at it.
 */ function $f40c730c85c0fd70$var$findWrapperOfNode(doc, localId, typeName) {
    const positions = $f40c730c85c0fd70$export$3a685203b954911f(doc, localId);
    if (!positions) return undefined;
    const $pos = doc.resolve(positions.from);
    for(let depth = $pos.depth; depth > 0; depth--){
        const ancestor = $pos.node(depth);
        if (ancestor.type.name === typeName) return ancestor;
    }
    return undefined;
}
/**
 * Opt every `expand` / `nestedExpand` this suggestion wrapped content in into being
 * open, so wrapping content in an expand doesn't collapse it out of sight.
 *
 * The single-player expand implementation keeps open/closed state in the
 * `expandedState` WeakMap keyed by node identity — the `__expanded` attr is only read
 * by the legacy implementation, and its schema default of `true` has no effect here.
 * A wrapper created by `wrapNode` therefore has no entry, and `ExpandNodeView` defaults
 * an unknown node to collapsed. Every other expand-creating path (`insertExpand`, the
 * block menu's convert-to-expand) opts its new node in the same way.
 *
 * Deliberately runs against the final doc of the transform, after every tool call has
 * been applied: the entry is keyed on the node object, so it has to be set against the
 * object that survives — a later tool call editing inside a wrapper replaces it.
 */ function $f40c730c85c0fd70$var$openWrappedExpands(tr, suggestion) {
    if (!(0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_1')) return;
    for (const toolCall of suggestion.toolCalls ?? []){
        if (toolCall.name !== 'wrap' && toolCall.name !== 'wrapNode') continue;
        const { localId: localId, wrapperType: wrapperType } = toolCall.arguments;
        if (!$f40c730c85c0fd70$var$EXPAND_NODE_TYPE_NAMES.includes(wrapperType)) continue;
        // Matching on the requested `wrapperType` keeps a failed wrap from opening a
        // pre-existing expand that merely happened to already contain the target.
        const wrapper = $f40c730c85c0fd70$var$findWrapperOfNode(tr.doc, localId, wrapperType);
        if (wrapper) (0, $8QOo3.expandedState).set(wrapper, true);
    }
}
function $f40c730c85c0fd70$var$applyToolCall(tr, toolCall) {
    if (toolCall.name === 'removeNodes') {
        for (const id of toolCall.arguments.localIds){
            const positions = $f40c730c85c0fd70$export$3a685203b954911f(tr.doc, id);
            if (positions) tr.delete(positions.from, positions.to);
        }
        return;
    }
    const positions = $f40c730c85c0fd70$export$3a685203b954911f(tr.doc, toolCall.arguments.localId);
    if (!positions) return;
    switch(toolCall.name){
        case 'replaceNode':
        case 'insertNodeBefore':
        case 'insertNodeAfter':
            {
                const node = $f40c730c85c0fd70$var$createNodeFromToolCallValue(tr.doc.type.schema, toolCall.arguments.value);
                if (!node) return;
                // An attribute-only replaceNode (e.g. promoting a heading from H4 to H3) keeps the
                // node's type and content identical. Encoding it as a full replace yields a ReplaceStep
                // whose granular diff is empty (the text is unchanged), so the change never surfaces.
                // Apply it via setNodeMarkup instead so the diff plugin renders it as a node change.
                const existingNode = tr.doc.nodeAt(positions.from);
                if (toolCall.name === 'replaceNode' && existingNode && existingNode.type === node.type && existingNode.content.eq(node.content)) {
                    tr.setNodeMarkup(positions.from, undefined, node.attrs, node.marks);
                    return;
                }
                if (toolCall.name === 'replaceNode') {
                    /**
				 *  Only fall back to delete + safeInsertAtPos
				 * (which walks up the doc to find the nearest schema-valid ancestor) when a
				 * direct replace would produce invalid ProseMirror doc nesting.
				 *
				 * canReplaceWith takes in indices, so for replaceNode we only need to check the
				 * from index and the next index since this is for replacing a single node.
				 */ const $from = tr.doc.resolve(positions.from);
                    const canReplaceDirectly = $from.parent.canReplaceWith($from.index(), $from.index() + 1, node.type);
                    if (canReplaceDirectly) {
                        tr.replaceWith(positions.from, positions.to, node);
                        return;
                    }
                    tr.delete(positions.from, positions.to);
                    (0, $2c24ed7b0ddbc6f4$export$676497ef504d5696)(tr, positions.from, node);
                    return;
                }
                const insertPos = toolCall.name === 'insertNodeAfter' ? positions.to : positions.from;
                const side = toolCall.name === 'insertNodeBefore' ? 'before' : 'after';
                (0, $2c24ed7b0ddbc6f4$export$676497ef504d5696)(tr, insertPos, node, side);
                return;
            }
        case 'removeNode':
            tr.delete(positions.from, positions.to);
            return;
        case 'wrap':
        case 'wrapNode':
            (0, $e655df7f8ec1986e$export$5a065b4e594c5a9c)({
                toolCallArguments: toolCall.arguments,
                tr: tr,
                pos: positions.from
            });
            return;
        case 'setAttrs':
            {
                const node = tr.doc.nodeAt(positions.from);
                if (!node) return;
                // The payload may have encoded the attrs as a JSON string, which `setNodeMarkup` would
                // spread as junk keys and apply none of. See `parseToolCallAttrs`.
                const attrs = (0, $2ad4b5801d1093af$export$da10b2800363f225)(toolCall.arguments.attrs);
                // Nothing to apply: skip rather than re-set the node's current attrs, which would add
                // a step the diff then has to render as a change that changed nothing.
                if (!attrs) return;
                tr.setNodeMarkup(positions.from, undefined, {
                    ...node.attrs,
                    ...attrs
                });
                return;
            }
    }
}
function $f40c730c85c0fd70$export$e450239860b6dfe1({ tr: tr, suggestion: suggestion }) {
    for (const toolCall of suggestion.toolCalls ?? [])$f40c730c85c0fd70$var$applyToolCall(tr, toolCall);
    $f40c730c85c0fd70$var$openWrappedExpands(tr, suggestion);
    return tr;
}


function $fca6dda0e2782a58$export$4d731d216504280(doc, suggestion) {
    const findLocalIdPos = (localId)=>{
        let result;
        doc.descendants((node, pos)=>{
            if (result !== undefined) return false;
            if (node.attrs?.localId === localId) {
                result = pos;
                return false;
            }
            return true;
        });
        return result;
    };
    const anchorLocalId = (0, $c08510c480bfb65f$export$e644b4e6be3487e)(suggestion);
    if (anchorLocalId) {
        const anchorPos = findLocalIdPos(anchorLocalId);
        if (anchorPos !== undefined) return anchorPos;
    }
    for (const toolCall of suggestion.toolCalls ?? []){
        const localIds = toolCall.name === 'removeNodes' ? toolCall.arguments.localIds : [
            toolCall.arguments.localId
        ];
        for (const localId of localIds){
            const pos = findLocalIdPos(localId);
            if (pos !== undefined) return pos;
        }
    }
    return undefined;
}
function $fca6dda0e2782a58$export$defbbc198f589f17(api, doc, pos, tr) {
    const $pos = doc.resolve(pos);
    if ($pos.depth === 0) return;
    let hasExpandAncestor = false;
    for(let depth = $pos.depth; depth > 0; depth--){
        const node = $pos.node(depth);
        if (node.type.name === 'expand' || node.type.name === 'nestedExpand') {
            hasExpandAncestor = true;
            break;
        }
    }
    if (!hasExpandAncestor) return;
    api?.expand?.commands.toggleExpandRange($pos.before(1), pos, true)?.({
        tr: tr
    });
}
function $fca6dda0e2782a58$export$9cfe4ac318e0d7a7({ api: api, suggestion: suggestion, tr: tr, options: options }) {
    let noDiffScrollPos;
    const anchorNodePos = $fca6dda0e2782a58$export$4d731d216504280(tr.doc, suggestion);
    if (anchorNodePos !== undefined) $fca6dda0e2782a58$export$defbbc198f589f17(api, tr.doc, anchorNodePos, tr);
    const hasToolCalls = (suggestion.toolCalls?.length ?? 0) > 0;
    if (!hasToolCalls) {
        api?.showDiff?.commands.hideDiff?.({
            tr: tr
        });
        (0, $2a4bc64013915ea2$export$707043ea55006b30)(api?.analytics?.actions)(tr, suggestion);
        noDiffScrollPos = anchorNodePos;
    } else {
        const isolatedTr = new (0, $eOaGc.Transform)(tr.doc);
        const appliedTr = (0, $f40c730c85c0fd70$export$e450239860b6dfe1)({
            tr: isolatedTr,
            suggestion: suggestion
        });
        const stepAttribution = suggestion.createdByAgent?.accountId ? {
            agentId: suggestion.createdByAgent.accountId
        } : undefined;
        if (appliedTr.before.eq(appliedTr.doc)) {
            (0, $2a4bc64013915ea2$export$707043ea55006b30)(api?.analytics?.actions)(tr, suggestion);
            noDiffScrollPos = anchorNodePos;
        }
        api?.showDiff?.commands.showDiff({
            stepsWithAttribution: appliedTr.steps.map((step, i)=>({
                    step: step.invert(appliedTr.docs[i]),
                    stepAttribution: stepAttribution
                })).reverse(),
            originalDoc: appliedTr.doc,
            isInverted: true,
            diffType: (0, $iDrrr.fg)('platform_editor_ai_suggested_edits_smart_diff') && (0, $iDrrr.fg)('platform_editor_ai_smart_diff') ? 'smart' : 'step',
            hideDeletedDiffs: options?.hideDeletedDiffs ?? (0, $295ac436451fb879$export$ef2b3f5e81ffeef8)(),
            scrollIntoView: options?.scrollIntoView ?? true,
            showIndicators: true
        })({
            tr: tr
        });
    }
    return noDiffScrollPos;
}



function $3b455e9f1a609467$export$8eb2ba4e0b5d0f47(params) {
    const suggestionById = new Map();
    const suggestionIdsByLocalId = new Map();
    const baseLocalIdBySuggestionId = new Map();
    const suggestionIdsByBaseLocalId = new Map();
    const orderedSuggestionIds = [];
    if (!params) return {
        suggestionById: suggestionById,
        baseLocalIdBySuggestionId: baseLocalIdBySuggestionId,
        orderedSuggestionIds: orderedSuggestionIds,
        suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId
    };
    const { suggestions: suggestions, doc: doc } = params;
    for (const suggestion of suggestions){
        suggestionById.set(suggestion.id, suggestion);
        /**
		 * Resolve the localId the suggestion anchors to — the explicit `anchorLocalId`
		 * when present, otherwise the first tool call's localId. Only this single
		 * localId is added to the suggestionIdsByLocalId map to simplify navigation,
		 * stacking, and getting logic.
		 */ const localId = (0, $c08510c480bfb65f$export$e644b4e6be3487e)(suggestion);
        if (localId) {
            const ids = suggestionIdsByLocalId.get(localId) ?? new Set();
            ids.add(suggestion.id);
            suggestionIdsByLocalId.set(localId, ids);
        }
    }
    // Map each top-level block position (doc depth 1) to suggestion IDs that target any localId
    // under that block — same docLevelPos as `doc.resolve(pos).before(1)` in the decorations plugin.
    doc.descendants((node, pos)=>{
        const nodeLocalId = node.attrs?.localId;
        if (!nodeLocalId) return true;
        const suggestionIdsAtLocalId = suggestionIdsByLocalId.get(nodeLocalId);
        if (suggestionIdsAtLocalId?.size) {
            const $pos = doc.resolve(pos);
            const baseLocalId = doc.nodeAt($pos.before(1))?.attrs?.localId;
            if (!baseLocalId) return true;
            suggestionIdsAtLocalId.forEach((suggestionId)=>{
                // A localId can repeat across the doc (e.g. clones produced by collab/copy-paste).
                // Keep the first-encountered mapping so each suggestion is anchored once and appears
                // exactly once in the navigation order, otherwise the card stalls on duplicates.
                if (baseLocalIdBySuggestionId.has(suggestionId)) return;
                // each suggestion maps to a base local id
                baseLocalIdBySuggestionId.set(suggestionId, baseLocalId);
                // we use doc.descendants order to determine the order of the suggestions
                orderedSuggestionIds.push(suggestionId);
            });
            const baseSet = suggestionIdsByBaseLocalId.get(baseLocalId) ?? new Set();
            const childSet = suggestionIdsByLocalId.get(nodeLocalId);
            if (childSet) // concat it into the base set
            suggestionIdsByBaseLocalId.set(baseLocalId, new Set([
                ...baseSet,
                ...childSet
            ]));
        }
        return true;
    });
    return {
        suggestionById: suggestionById,
        baseLocalIdBySuggestionId: baseLocalIdBySuggestionId,
        orderedSuggestionIds: orderedSuggestionIds,
        suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId
    };
}


const $56b1bb8689d88b40$export$c88671e3a419bb99 = {
    base: '--followup-card-base',
    end: '--followup-card-end',
    // Outward fallbacks, emitted only when the primary pair sits inside the target node. See
    // `findSuggestionCardAnchorRanges`.
    outerEnd: '--followup-card-outer-end',
    outerStart: '--followup-card-outer-start',
    start: '--followup-card-start'
};
/**
 * Keyed off `markerRef` (the comment's document anchor), which only inline comments carry.
 * The source `type` isn't checked because its value isn't stable — the backend has been seen
 * sending `confluence.comment` where `confluence:comment` was specified.
 */ const $56b1bb8689d88b40$var$isInlineCommentSource = (source)=>!!source.metadata && 'markerRef' in source.metadata;
const $56b1bb8689d88b40$var$isInlineCommentSuggestion = (suggestion)=>suggestion.sources?.some($56b1bb8689d88b40$var$isInlineCommentSource) ?? false;
const $56b1bb8689d88b40$export$20931deba49a7f12 = (suggestion)=>suggestion !== undefined && $56b1bb8689d88b40$var$isInlineCommentSuggestion(suggestion);





/**
 * Produces a deterministic JSON string for any JSON-compatible value.
 *
 * Guarantees:
 * - Object keys are sorted alphabetically at every nesting level.
 * - Keys whose values are `undefined` are omitted.
 * - Keys listed in `ignoreKeys` are omitted.
 * - Primitive values (string, number, boolean, null) are serialized with
 *   standard `JSON.stringify` semantics.
 * - Arrays preserve their element order.
 *
 * This ensures that two structurally equivalent values always produce
 * the same string regardless of original key insertion order.
 *
 * @param value      - The value to serialize.
 * @param ignoreKeys - Optional set of key names to strip at every level.
 * @returns A deterministic JSON string.
 *
 * @internal Not exported from the package — use `hashNode` instead.
 */ function $be28a78572d7c3d7$export$e55b76bdd351fffc(value, ignoreKeys) {
    return $be28a78572d7c3d7$var$serializeValue(value, ignoreKeys);
}
function $be28a78572d7c3d7$var$serializeValue(value, ignoreKeys) {
    // null
    if (value === null) return 'null';
    // undefined — should not normally appear in JSON, but handle gracefully
    if (value === undefined) return 'null';
    // Primitives
    switch(typeof value){
        case 'string':
            return JSON.stringify(value);
        case 'number':
            // Handle special numeric values that JSON.stringify would emit as null
            if (!Number.isFinite(value)) return 'null';
            return String(value);
        case 'boolean':
            return value ? 'true' : 'false';
    }
    // Arrays
    if (Array.isArray(value)) {
        const items = value.map((item)=>$be28a78572d7c3d7$var$serializeValue(item, ignoreKeys));
        return '[' + items.join(',') + ']';
    }
    // Objects
    if (typeof value === 'object') {
        const obj = value;
        const keys = Object.keys(obj).filter((key)=>{
            if (obj[key] === undefined) return false;
            if (ignoreKeys && ignoreKeys.has(key)) return false;
            return true;
        }).sort();
        const entries = keys.map((key)=>JSON.stringify(key) + ':' + $be28a78572d7c3d7$var$serializeValue(obj[key], ignoreKeys));
        return '{' + entries.join(',') + '}';
    }
    // Fallback for unexpected types (symbol, function, bigint, etc.)
    return 'null';
}


async function $8fd292f56cccb492$export$5ddef1f39ba79de1(node, options) {
    const ignoreKeys = options?.ignoreKeys ? new Set(options.ignoreKeys) : undefined;
    const canonical = (0, $be28a78572d7c3d7$export$e55b76bdd351fffc)(node, ignoreKeys);
    return await $8fd292f56cccb492$var$sha256Hex(canonical);
}

/**
 * Computes the SHA-256 hash of a UTF-8 string and returns it as a lowercase
 * hexadecimal string.
 *
 * Uses `globalThis.crypto.subtle` when available (all modern browsers and
 * Node.js 15+). Falls back to Node.js `crypto` module for environments
 * where the Web Crypto API is not exposed on `globalThis` (e.g. some test
 * runners).
 *
 * @internal
 */ async function $8fd292f56cccb492$var$sha256Hex(input) {
    // Prefer Web Crypto API (browsers + modern Node)
    if (typeof globalThis.crypto?.subtle?.digest === 'function') {
        const encoder = new TextEncoder();
        const data = encoder.encode(input);
        const hashBuffer = await globalThis.crypto.subtle.digest('SHA-256', data);
        const hashArray = new Uint8Array(hashBuffer);
        let hex = '';
        for(let i = 0; i < hashArray.length; i++)hex += hashArray[i].toString(16).padStart(2, '0');
        return hex;
    }
    // Fallback: Node.js crypto module
    // eslint-disable-next-line import/no-nodejs-modules, import/dynamic-import-chunkname
    const { createHash: createHash } = await Promise.resolve((parcelRequire("5rA68")));
    return createHash('sha256').update(input, 'utf8').digest('hex');
}





/** Flags the ids of suggestions currently being regenerated. */ function $1460109429ebb090$var$setRegeneratingSuggestionIds(api, ids) {
    api?.core?.actions.execute(({ tr: tr })=>{
        tr.setMeta((0, $1b159f40bd8b3a1f$export$dbbefe45c19011aa), {
            action: 'SET_REGENERATING',
            ids: ids
        });
        return tr;
    });
}
function $1460109429ebb090$export$db2a98cd4f9c538b(suggestions) {
    const trackedLocalIds = new Set();
    for (const suggestion of suggestions)for (const localId of Object.keys(suggestion.nodeHashes ?? {}))trackedLocalIds.add(localId);
    return trackedLocalIds;
}
function $1460109429ebb090$export$118e61a2985e3c01(doc, trackedLocalIds) {
    const remaining = new Set(trackedLocalIds);
    const nodesByLocalId = new Map();
    doc.descendants((node)=>{
        if (remaining.size === 0) return false;
        const localId = node.attrs?.localId;
        if (localId && remaining.delete(localId)) nodesByLocalId.set(localId, node.toJSON());
        return true;
    });
    return nodesByLocalId;
}
async function $1460109429ebb090$export$9bae736c85d3d129(nodesByLocalId) {
    const currentHashByLocalId = new Map();
    await Promise.all(Array.from(nodesByLocalId, async ([localId, node])=>{
        currentHashByLocalId.set(localId, await (0, $8fd292f56cccb492$export$5ddef1f39ba79de1)(node));
    }));
    return currentHashByLocalId;
}
function $1460109429ebb090$export$50a77a9d00df6d98(suggestion, currentHashByLocalId) {
    for (const [localId, expectedHash] of Object.entries(suggestion.nodeHashes ?? {})){
        const currentHash = currentHashByLocalId.get(localId);
        if (currentHash === undefined || currentHash !== expectedHash) return true;
    }
    return false;
}
function $1460109429ebb090$export$88de768fc515b972(suggestions, currentHashByLocalId) {
    const staleSuggestionIds = new Set();
    const staleTrackedLocalIds = new Set();
    for (const suggestion of suggestions)if ($1460109429ebb090$export$50a77a9d00df6d98(suggestion, currentHashByLocalId)) {
        staleSuggestionIds.add(suggestion.id);
        for (const localId of Object.keys(suggestion.nodeHashes ?? {}))staleTrackedLocalIds.add(localId);
    }
    return {
        staleSuggestionIds: staleSuggestionIds,
        staleTrackedLocalIds: staleTrackedLocalIds
    };
}
function $1460109429ebb090$export$7c82f88ef397b806(localIds, nodesByLocalId) {
    const nodes = [];
    for (const localId of localIds){
        const node = nodesByLocalId.get(localId);
        if (node) nodes.push(node);
    }
    return nodes;
}
const $1460109429ebb090$export$d5477d8705cec30f = (getDoc, contentAri, api, options = {})=>async (suggestions)=>{
        const { signal: signal, shouldRetainStale: shouldRetainStale = false } = options;
        const trackedLocalIds = $1460109429ebb090$export$db2a98cd4f9c538b(suggestions);
        if (trackedLocalIds.size === 0) return suggestions;
        const doc = getDoc();
        if (!doc) return suggestions;
        const nodesByLocalId = $1460109429ebb090$export$118e61a2985e3c01(doc, trackedLocalIds);
        const currentHashByLocalId = await $1460109429ebb090$export$9bae736c85d3d129(nodesByLocalId);
        const { staleSuggestionIds: staleSuggestionIds, staleTrackedLocalIds: staleTrackedLocalIds } = $1460109429ebb090$export$88de768fc515b972(suggestions, currentHashByLocalId);
        if (staleSuggestionIds.size === 0) return suggestions;
        $1460109429ebb090$var$setRegeneratingSuggestionIds(api, staleSuggestionIds);
        const currentNodes = $1460109429ebb090$export$7c82f88ef397b806(staleTrackedLocalIds, nodesByLocalId);
        let regenerated;
        try {
            regenerated = await (0, $61b8b9734ab6a330$export$7ffa8bd2a6ad0cd0)({
                suggestionIds: Array.from(staleSuggestionIds),
                contentAri: contentAri,
                currentNodes: currentNodes,
                signal: signal
            });
        } catch (error) {
            // On error, keep the suggestions unchanged
            (0, $2a4bc64013915ea2$export$2c94dca769ea778b)(api?.analytics?.actions, error, {
                staleSuggestionCount: staleSuggestionIds.size,
                currentNodeCount: currentNodes.length
            });
            $1460109429ebb090$var$setRegeneratingSuggestionIds(api, new Set());
            return suggestions;
        }
        $1460109429ebb090$var$setRegeneratingSuggestionIds(api, new Set());
        if (shouldRetainStale) {
            // Swap each stale suggestion for its regenerated counterpart; keep the rest.
            const regeneratedById = new Map(regenerated.map((suggestion)=>[
                    suggestion.id,
                    suggestion
                ]));
            return suggestions.map((suggestion)=>regeneratedById.get(suggestion.id) ?? suggestion);
        }
        // Drop the stale originals and append the backend's replacements.
        const freshSuggestions = suggestions.filter((suggestion)=>!staleSuggestionIds.has(suggestion.id));
        return [
            ...freshSuggestions,
            ...regenerated
        ];
    };


/** The suggestions currently in plugin state, in list order. */ function $575d15e6a5835c33$var$getCurrentSuggestions(api) {
    const state = api?.aiSuggestions?.sharedState.currentState();
    if (!state) return [];
    return state.orderedSuggestionIds.map((id)=>state.suggestionById.get(id)).filter((suggestion)=>suggestion !== undefined);
}
const $575d15e6a5835c33$export$740daa9a9ce77ea8 = async ({ api: api, contentAri: contentAri, signal: signal, getDoc: getDoc, shouldRegenerate: shouldRegenerate = true, regenerateOnly: regenerateOnly = false })=>{
    if (!api) return;
    let suggestions;
    if (regenerateOnly) {
        // Regenerating needs a doc to hash against and an ARI to regenerate under.
        if (!getDoc || !contentAri) return;
        const current = $575d15e6a5835c33$var$getCurrentSuggestions(api);
        if (current.length === 0) return;
        const reconciled = await (0, $1460109429ebb090$export$d5477d8705cec30f)(getDoc, contentAri, api, {
            signal: signal,
            shouldRetainStale: true
        })(current);
        // Same reference back means nothing was stale (or regeneration failed) —
        // skip the dispatch so we don't recompute decorations for no change.
        if (reconciled === current) return;
        suggestions = reconciled;
    } else {
        const fetched = await (0, $61b8b9734ab6a330$export$ebf2f44fe450da2b)({
            contentAri: contentAri ?? '',
            signal: signal
        });
        suggestions = shouldRegenerate && getDoc && contentAri ? await (0, $1460109429ebb090$export$d5477d8705cec30f)(getDoc, contentAri, api, {
            signal: signal,
            shouldRetainStale: false
        })(fetched) : fetched;
    }
    api?.core?.actions?.execute(({ tr: tr })=>{
        tr.setMeta((0, $1b159f40bd8b3a1f$export$dbbefe45c19011aa), {
            action: 'SET_SUGGESTIONS',
            suggestions: suggestions,
            contentAri: contentAri
        });
        return tr;
    });
};








const $f19306cd2f195aad$var$hoverHighlightStyle = (0, $8Dx7s.convertToInlineCss)({
    backgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    // Extend the highlight evenly around the node via a same-colour box-shadow
    // spread instead of padding/margin — box-shadow takes no layout space, so the
    // text doesn't shift while the background still has consistent padding.
    boxShadow: `0 0 0 ${"var(--ds-space-025, 2px)"} ${"var(--ds-background-accent-blue-subtler, #CFE1FD)"}`
});
const $f19306cd2f195aad$export$fde9384a52944e6b = {
    overlay: 'ai-suggestions-hover-overlay',
    table: 'ai-suggestions-hover-table',
    extension: 'ai-suggestions-hover-extension',
    rule: 'ai-suggestions-hover-rule'
};
// Container nodes are full-bleed and/or have their own borders, so a box-shadow
// "padding" looks wrong. They get a translucent blanket overlay instead.
const $f19306cd2f195aad$var$overlayHoverNodeTypes = new Set([
    'panel',
    'codeBlock',
    'expand',
    'nestedExpand',
    'layoutSection'
]);
const $f19306cd2f195aad$var$extensionHoverNodeTypes = new Set([
    'extension',
    'bodiedExtension',
    'multiBodiedExtension'
]);
// Media is handled by the media plugin's own selection affordance — skip it.
const $f19306cd2f195aad$var$excludedHoverNodeTypes = new Set([
    'media',
    'mediaSingle',
    'mediaGroup'
]);
function $f19306cd2f195aad$export$277f5ff788d0fe35(doc, suggestion) {
    if (!suggestion) return (0, $8nvEM.DecorationSet).empty;
    const targetLocalIds = new Set();
    for (const toolCall of suggestion.toolCalls ?? []){
        if (toolCall.name === 'removeNodes') toolCall.arguments.localIds.forEach((id)=>targetLocalIds.add(id));
        else if ('localId' in toolCall.arguments) targetLocalIds.add(toolCall.arguments.localId);
    }
    for (const id of suggestion.action?.localIds ?? [])targetLocalIds.add(id);
    if (targetLocalIds.size === 0) {
        if (suggestion.anchorLocalId) targetLocalIds.add(suggestion.anchorLocalId);
        else return (0, $8nvEM.DecorationSet).empty;
    }
    const decorations = [];
    const matchedLocalIds = new Set();
    doc.descendants((node, pos)=>{
        const { localId: localId } = node.attrs ?? {};
        if (localId && targetLocalIds.has(localId)) {
            matchedLocalIds.add(localId);
            const typeName = node.type.name;
            const to = pos + node.nodeSize;
            if ($f19306cd2f195aad$var$excludedHoverNodeTypes.has(typeName)) ;
            else if (node.isInline) decorations.push((0, $8nvEM.Decoration).inline(pos, to, {
                style: $f19306cd2f195aad$var$hoverHighlightStyle
            }));
            else if (typeName === 'table') decorations.push((0, $8nvEM.Decoration).node(pos, to, {
                class: $f19306cd2f195aad$export$fde9384a52944e6b.table
            }));
            else if ($f19306cd2f195aad$var$overlayHoverNodeTypes.has(typeName)) decorations.push((0, $8nvEM.Decoration).node(pos, to, {
                class: $f19306cd2f195aad$export$fde9384a52944e6b.overlay
            }));
            else if ($f19306cd2f195aad$var$extensionHoverNodeTypes.has(typeName)) decorations.push((0, $8nvEM.Decoration).node(pos, to, {
                class: $f19306cd2f195aad$export$fde9384a52944e6b.extension
            }));
            else if (typeName === 'rule') decorations.push((0, $8nvEM.Decoration).node(pos, to, {
                class: $f19306cd2f195aad$export$fde9384a52944e6b.rule
            }));
            else decorations.push((0, $8nvEM.Decoration).node(pos, to, {
                style: $f19306cd2f195aad$var$hoverHighlightStyle
            }));
        }
        return matchedLocalIds.size < targetLocalIds.size;
    });
    return decorations.length ? (0, $8nvEM.DecorationSet).create(doc, decorations) : (0, $8nvEM.DecorationSet).empty;
}


const $e304709e40e65587$export$f6edc6b3f6e003d = 'ai-suggestions-remix-placeholder';
function $e304709e40e65587$export$516004d46b807715() {
    const element = document.createElement('div');
    element.contentEditable = 'false';
    element.setAttribute('style', 'display: block; width: 100%; pointer-events: none;');
    return element;
}


function $3d32a865531fd601$export$232f392504ff18fb(doc, localIds) {
    if (localIds.length === 0) return undefined;
    const targetLocalIds = new Set(localIds);
    let position;
    doc.descendants((node, pos)=>{
        const id = node.attrs?.localId;
        if (typeof id === 'string' && targetLocalIds.has(id)) {
            position = pos + node.nodeSize;
            return false;
        }
        return true;
    });
    return position;
}








// Facade progress hovers at a randomised target (85-95%) until completion.
const $4d8c0f76a4c8d5f6$var$pickProgressTarget = ()=>85 + Math.random() * 10;
const $4d8c0f76a4c8d5f6$export$1acc4db37d317889 = new (0, $kCECX.PluginKey)('aiSuggestionsThinkingPlugin');
function $4d8c0f76a4c8d5f6$export$145797582d57a3db({ dispatch: dispatch }) {
    return new (0, $kpCD8.SafePlugin)({
        key: $4d8c0f76a4c8d5f6$export$1acc4db37d317889,
        state: {
            init () {
                return {
                    status: 'idle',
                    startedAt: null,
                    progressTarget: null,
                    error: null
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($4d8c0f76a4c8d5f6$export$1acc4db37d317889);
                if (meta && meta.status !== pluginState.status) {
                    let startedAt = pluginState.startedAt;
                    let progressTarget = pluginState.progressTarget;
                    if (meta.status === 'thinking') {
                        // Start of a new session: anchor the shared timing/target once.
                        startedAt = Date.now();
                        progressTarget = $4d8c0f76a4c8d5f6$var$pickProgressTarget();
                    } else if (meta.status === 'idle') {
                        // Session ended/cancelled: clear so the next session starts fresh.
                        startedAt = null;
                        progressTarget = null;
                    }
                    // 'complete' and 'error' keep startedAt/progressTarget so the bar can
                    // settle its progress before showing the ready / error state.
                    // Carry the error payload only into the 'error' state; clear otherwise.
                    const error = meta.status === 'error' ? meta.error ?? {
                        template: 'UNKNOWN'
                    } : null;
                    const result = {
                        status: meta.status,
                        startedAt: startedAt,
                        progressTarget: progressTarget,
                        error: error
                    };
                    dispatch($4d8c0f76a4c8d5f6$export$1acc4db37d317889, result);
                    return result;
                }
                return pluginState;
            }
        }
    });
}


/**
 * Whether an anchor widget can be rendered directly inside `node`, which the schema already
 * knows: a text block holds the span inline, and a block container holds it in an anonymous
 * block box. Only a structural container — `table`, `tableRow`, `layoutSection`, a list —
 * accepts neither, and its DOM element reparents the span into an anonymous row or cell
 * (EDITOR-8442) or turns it into an extra grid item.
 */ function $3e8bb7c5c711e11c$var$canHostAnchor(node) {
    return node.type.inlineContent || node.type.contentMatch.matchType(node.type.schema.nodes.paragraph) !== null;
}
/**
 * The position within `range` closest to its `edge` whose parent can host an anchor widget.
 * Each step of one token enters the first (or last) child of the container that rejected the
 * previous position, so a cell resolves immediately and a row in one step. `undefined` when the
 * whole range is unhostable, i.e. a leaf or a container of leaves.
 */ function $3e8bb7c5c711e11c$var$toHostableAnchorPos(doc, range, edge) {
    const step = edge === 'start' ? 1 : -1;
    for(let pos = edge === 'start' ? range.start : range.end; pos >= range.start && pos <= range.end; pos += step){
        if ($3e8bb7c5c711e11c$var$canHostAnchor(doc.resolve(pos).parent)) return pos;
    }
    return undefined;
}
/**
 * The boundary of the node at `fromDepth`, moved outward while the enclosing node cannot host an
 * anchor widget. `$pos.node(0)` is the doc, which always can, so this always resolves — at worst
 * to the target's own top-level block.
 */ function $3e8bb7c5c711e11c$var$toOutwardAnchorRange($pos, fromDepth) {
    let depth = fromDepth;
    while(depth > 1 && !$3e8bb7c5c711e11c$var$canHostAnchor($pos.node(depth - 1)))depth--;
    return {
        startPos: $pos.before(depth),
        endPos: $pos.after(depth)
    };
}
/**
 * Pairs a primary range with its outward fallback, dropping the fallback when it would resolve to
 * the same positions — no point emitting a second anchor pair on top of the first — and promoting
 * it when there is no primary at all, which happens for a leaf target with no content to sit in.
 */ function $3e8bb7c5c711e11c$var$withOutwardFallback(primary, outward) {
    if (!primary) return {
        primary: outward
    };
    return primary.startPos === outward.startPos && primary.endPos === outward.endPos ? {
        primary: primary
    } : {
        primary: primary,
        fallback: outward
    };
}
function $3e8bb7c5c711e11c$export$213833a0759111eb(doc, pos) {
    const $pos = doc.resolve(pos);
    let outermostExpandDepth;
    let tableCellDepth;
    for(let depth = $pos.depth; depth > 0; depth--){
        const typeName = $pos.node(depth).type.name;
        if (typeName === 'expand' || typeName === 'nestedExpand') outermostExpandDepth = depth;
        else if ((typeName === 'tableCell' || typeName === 'tableHeader') && tableCellDepth === undefined) tableCellDepth = depth;
    }
    // An enclosing expand takes precedence over a table (it can itself contain
    // one), and the icon button renders on the expand, not content buried in
    // its body — so its OUTER boundary (before/after) is the line-up target.
    if (outermostExpandDepth !== undefined) return $3e8bb7c5c711e11c$var$withOutwardFallback({
        startPos: $pos.before(outermostExpandDepth),
        endPos: $pos.after(outermostExpandDepth)
    }, $3e8bb7c5c711e11c$var$toOutwardAnchorRange($pos, outermostExpandDepth));
    // `pos` is the position *before* the anchor node, so `$pos` resolves into the anchor's PARENT
    // and the anchor node itself is absent from the ancestor chain above. When that parent cannot
    // host the span, the anchor node's own boundary is unusable — a `<tr>` between cells, a
    // `<table>` between rows, a layout between columns — and that is exactly where a suggestion
    // targeting one of those nodes directly (`setAttrs` on a cell background or `colwidth`,
    // `removeNode` of a spanning cell) would otherwise be anchored.
    if (!$3e8bb7c5c711e11c$var$canHostAnchor($pos.parent)) {
        const nodeAtPos = doc.nodeAt(pos);
        const innerRange = nodeAtPos ? {
            start: pos + 1,
            end: pos + nodeAtPos.nodeSize - 1
        } : undefined;
        const innerStartPos = innerRange && $3e8bb7c5c711e11c$var$toHostableAnchorPos(doc, innerRange, 'start');
        const innerEndPos = innerRange && $3e8bb7c5c711e11c$var$toHostableAnchorPos(doc, innerRange, 'end');
        // Reaching into the target's content keeps the card aligned with the target itself, which
        // is why it is preferred — but it is also the range the diff can hide, hence the outward
        // fallback.
        return $3e8bb7c5c711e11c$var$withOutwardFallback(innerStartPos !== undefined && innerEndPos !== undefined ? {
            startPos: innerStartPos,
            endPos: innerEndPos
        } : undefined, $3e8bb7c5c711e11c$var$toOutwardAnchorRange($pos, $pos.depth));
    }
    if (tableCellDepth === undefined) return {};
    // Anchor INSIDE the cell's content (start/end), not at either boundary:
    // the cell's outer boundary sits between <td> siblings inside <tr>
    // (extra CSS grid item, collapses cells — EDITOR-8442), and the enclosing
    // row's boundary sits between <tr> siblings inside <tbody> (browser wraps
    // the invalid child in an anonymous row, breaking rowspan continuation).
    return $3e8bb7c5c711e11c$var$withOutwardFallback({
        startPos: $pos.start(tableCellDepth),
        endPos: $pos.end(tableCellDepth)
    }, $3e8bb7c5c711e11c$var$toOutwardAnchorRange($pos, tableCellDepth));
}





function $0b504009849b7a0d$export$82a97b36758288e5(groups) {
    const ids = new Set();
    for (const group of groups ?? [])for (const suggestion of group.suggestions)ids.add(suggestion.id);
    return ids;
}
function $0b504009849b7a0d$export$e4a1d22be49a81bd(pluginState) {
    return pluginState.orderedSuggestionIds.map((id)=>pluginState.suggestionById.get(id)).filter((suggestion)=>suggestion !== undefined);
}
function $0b504009849b7a0d$var$isPmHistoryMeta(meta) {
    return typeof meta === 'object' && meta !== null && typeof meta.redo === 'boolean';
}
function $0b504009849b7a0d$export$4a859a7b0093f8a2(tr) {
    const historyMeta = tr.getMeta((0, $2w79Z.pmHistoryPluginKey));
    if (!$0b504009849b7a0d$var$isPmHistoryMeta(historyMeta)) return undefined;
    return historyMeta.redo ? 'redo' : 'undo';
}
function $0b504009849b7a0d$export$686b6c582e8762c9(tr) {
    const historyMeta = tr.getMeta((0, $2w79Z.pmHistoryPluginKey));
    return historyMeta?.historyState?.done?.eventCount;
}
function $0b504009849b7a0d$export$28a08778956fc267(api) {
    return api?.history?.sharedState.currentState()?.done.eventCount ?? 0;
}


/**
 * We have different adjustments for aligned headings vs. non-aligned headings because
 * they have different margins for some reason, see platform/packages/editor/editor-common/src/styles/shared/headings.ts
 *
 * This is just hard coded at the moment to mimic the positioning logic of block controls plugin, and won't be needed
 * once the icon button positioning logic is moved to a new block controls plugin API.
 */ const $1b159f40bd8b3a1f$var$nodeTopAdjustments = {
    table: 12,
    paragraph: 2,
    heading1: 5,
    heading2: 2,
    heading3: -1,
    heading4: -3,
    heading5: -3,
    heading6: -3,
    heading1_aligned: 5,
    heading2_aligned: 2,
    heading3_aligned: -1,
    heading4_aligned: -3,
    heading5_aligned: -3,
    heading6_aligned: -3,
    layoutSection: 8
};
/**
 * It would be easier to get the margin from the DOM but we don't have access to the view / DOM here
 * so we hard code these values for now, until everything's moved to the block controls plugin.
 */ const $1b159f40bd8b3a1f$var$nodeTopMargins = {
    table: 12,
    paragraph: 12,
    bulletList: 12,
    orderedList: 12,
    decisionList: 8,
    taskList: 12,
    codeBlock: 12,
    panel: 12,
    rule: 4,
    heading1: 40,
    heading2: 32,
    heading3: 24,
    heading4: 20,
    heading5: 20,
    heading6: 20,
    heading1_aligned: 45,
    heading2_aligned: 41,
    heading3_aligned: 36,
    heading4_aligned: 21,
    heading5_aligned: 22,
    heading6_aligned: 18,
    blockquote: 12,
    expand: 4
};
/**
 * Bottom margins of nodes that affect how the icon button is positioned
 */ const $1b159f40bd8b3a1f$var$nodeBeforeAdjustments = {
    rule: 24,
    extension: 12
};
const $1b159f40bd8b3a1f$var$constructHeadingAdjustmentKey = (node)=>{
    if (node.type.name === 'heading') {
        const level = node.attrs.level;
        const hasAlignment = node.marks.some((mark)=>mark.type.name === 'alignment');
        return `heading${level}${hasAlignment ? '_aligned' : ''}`;
    }
    return node.type.name;
};
/**
 * Anchor widget empty marks:
 * `marks: []` tells ProseMirror the widget belongs to no mark wrapper, so `syncToMarks` hoists it out of any
 * enclosing `breakout` wrapper instead of tucking it inside the next sibling's. Without it, a
 * widget with `side >= 0` placed before a breakout-marked sibling is inserted into that sibling's
 * (non-spanning) wrapper, and ProseMirror then destroys and re-creates the sibling and every
 * breakout-marked block after it on each update
 */ const $1b159f40bd8b3a1f$var$ANCHOR_EMPTY_MARKS = [];
/**
 * The paired start/end anchor widgets a card positions from, named `<startName>` / `<endName>`.
 *
 * Emitted twice per card — once for the primary range and once for the outward fallback (see
 * `findSuggestionCardAnchorRanges`) — so the consumer can chain them with `anchor()`'s fallback
 * argument.
 */ function $1b159f40bd8b3a1f$var$createCardAnchorDecorations(names, range) {
    return [
        (0, $8nvEM.Decoration).widget(range.startPos, ()=>$1b159f40bd8b3a1f$var$createAnchorNameSpan(names.start), {
            side: -2,
            // Stable key so rebuilding the DecorationSet (e.g. on SET_SUGGESTIONS from a
            // regeneration) reuses this span instead of remounting it — otherwise the CSS anchor
            // briefly disappears and the card flickers / mis-positions.
            key: names.start,
            marks: $1b159f40bd8b3a1f$var$ANCHOR_EMPTY_MARKS
        }),
        (0, $8nvEM.Decoration).widget(range.endPos, ()=>$1b159f40bd8b3a1f$var$createAnchorNameSpan(names.end), {
            side: 2,
            key: names.end,
            marks: $1b159f40bd8b3a1f$var$ANCHOR_EMPTY_MARKS
        })
    ];
}
/** An empty span carrying `anchor-name`, used as a CSS anchor target for the cards. */ function $1b159f40bd8b3a1f$var$createAnchorNameSpan(anchorName) {
    const spanElement = document.createElement('span');
    spanElement.setAttribute('style', (0, $8Dx7s.convertToInlineCss)({
        anchorName: anchorName
    }));
    return spanElement;
}
/**
 * Horizontal anchor for the follow-up card: a point in the right gutter of the removed
 * suggestion's block, where the suggestion card was anchored.
 *
 * The suggestion card anchors to the icon button's span (`SuggestionIconButton`), but that span
 * is empty whenever a card is open — the button hides while its suggestion is selected — so only
 * the gutter offset needs reproducing, not the button's size or alignment.
 */ function $1b159f40bd8b3a1f$var$createFollowUpCardBaseAnchor() {
    // Full-width, zero-height block to offset the anchor from the content's right edge.
    const container = document.createElement('span');
    container.setAttribute('style', (0, $8Dx7s.convertToInlineCss)({
        position: 'relative',
        width: '100%',
        display: 'block',
        pointerEvents: 'none'
    }));
    const anchor = document.createElement('span');
    anchor.setAttribute('style', (0, $8Dx7s.convertToInlineCss)({
        position: 'absolute',
        // gutter + object actions container width
        right: `calc(${"var(--ds-space-negative-300, -24px)"} + ${"var(--ds-space-negative-300, -24px)"})`,
        anchorName: (0, $56b1bb8689d88b40$export$c88671e3a419bb99).base
    }));
    container.appendChild(anchor);
    return container;
}
/** Position and size of the first node in `doc` carrying `localId`. */ function $1b159f40bd8b3a1f$var$findLocalIdNodePosition(doc, localId) {
    if (!localId) return undefined;
    let result;
    doc.descendants((node, pos)=>{
        if (result !== undefined) return false;
        if (node.attrs?.localId === localId) {
            result = {
                pos: pos,
                nodeSize: node.nodeSize
            };
            return false;
        }
        return true;
    });
    return result;
}
/**
 * Whether the selected suggestion's card can still be positioned against the document.
 * Runs on every doc-changing transaction while a card is open, so it avoids a full-document
 * traversal.
 */ function $1b159f40bd8b3a1f$var$canPositionSelectedCard(doc, pluginState) {
    const selectedId = pluginState.selectedSuggestion;
    if (!selectedId) return true;
    const suggestion = pluginState.suggestionById.get(selectedId);
    if (!suggestion) return true;
    const anchorLocalId = (0, $c08510c480bfb65f$export$e644b4e6be3487e)(suggestion);
    const baseLocalId = pluginState.baseLocalIdBySuggestionId.get(selectedId);
    if (!anchorLocalId || !baseLocalId) return true;
    let baseNode;
    for(let index = 0; index < doc.childCount; index++){
        const child = doc.child(index);
        if (child.attrs?.localId === baseLocalId) {
            baseNode = child;
            break;
        }
    }
    if (!baseNode) return false;
    if (anchorLocalId === baseLocalId) return true;
    // The anchor spans are only emitted from within the base node, so an anchor node that
    // survives elsewhere in the doc (moved out by a cut/paste, say) is just as unpositionable
    // as a deleted one.
    let hasAnchorDescendant = false;
    baseNode.descendants((descendant)=>{
        if (hasAnchorDescendant) return false;
        if (descendant.attrs?.localId === anchorLocalId) {
            hasAnchorDescendant = true;
            return false;
        }
        return true;
    });
    return hasAnchorDescendant;
}
/**
 * Anchor spans for the follow-up card. Emitted for a suggestion that no longer exists, which is
 * the point: they keep the removed card's position addressable through resizes and reflow.
 *
 * Either localId can outlive the other (accepting a suggestion can delete the anchored node, or
 * the block the icon button sat on), so each anchor falls back to the other. With neither in the
 * doc no anchors are emitted and `position-visibility: anchors-valid` keeps the card hidden.
 */ function $1b159f40bd8b3a1f$var$calculateFollowUpCardDecorations(doc, followUpCard) {
    if (!followUpCard) return [];
    const anchorNode = $1b159f40bd8b3a1f$var$findLocalIdNodePosition(doc, followUpCard.anchorLocalId);
    const baseNode = $1b159f40bd8b3a1f$var$findLocalIdNodePosition(doc, followUpCard.baseLocalId);
    const verticalNode = anchorNode ?? baseNode;
    const horizontalNode = baseNode ?? anchorNode;
    if (!verticalNode || !horizontalNode) return [];
    // Same treatment as the suggestion card: pin to the enclosing expand or table
    // row so the card lines up with the block the user actually sees.
    const anchorRanges = (0, $3e8bb7c5c711e11c$export$213833a0759111eb)(doc, verticalNode.pos);
    const primaryRange = anchorRanges.primary ?? {
        startPos: verticalNode.pos,
        endPos: verticalNode.pos + verticalNode.nodeSize
    };
    return [
        ...$1b159f40bd8b3a1f$var$createCardAnchorDecorations((0, $56b1bb8689d88b40$export$c88671e3a419bb99), primaryRange),
        ...anchorRanges.fallback ? $1b159f40bd8b3a1f$var$createCardAnchorDecorations({
            start: (0, $56b1bb8689d88b40$export$c88671e3a419bb99).outerStart,
            end: (0, $56b1bb8689d88b40$export$c88671e3a419bb99).outerEnd
        }, anchorRanges.fallback) : [],
        (0, $8nvEM.Decoration).widget(horizontalNode.pos, $1b159f40bd8b3a1f$var$createFollowUpCardBaseAnchor, {
            side: -2,
            key: (0, $56b1bb8689d88b40$export$c88671e3a419bb99).base,
            marks: $1b159f40bd8b3a1f$var$ANCHOR_EMPTY_MARKS
        })
    ];
}
const $1b159f40bd8b3a1f$export$dbbefe45c19011aa = new (0, $kCECX.PluginKey)('aiSuggestionsPlugin');
const $1b159f40bd8b3a1f$var$pointTouchesRange = (point, range)=>point >= range.from && point <= range.to;
const $1b159f40bd8b3a1f$var$rangesOverlap = (rangeA, rangeB)=>{
    if (rangeA.from === rangeA.to) return $1b159f40bd8b3a1f$var$pointTouchesRange(rangeA.from, rangeB);
    if (rangeB.from === rangeB.to) return $1b159f40bd8b3a1f$var$pointTouchesRange(rangeB.from, rangeA);
    return rangeA.from < rangeB.to && rangeB.from < rangeA.to;
};
const $1b159f40bd8b3a1f$var$getDecoratedNodeRanges = (doc, suggestionIdsByBaseLocalId)=>{
    const decoratedNodeRanges = [];
    doc.descendants((node, pos)=>{
        if (suggestionIdsByBaseLocalId.has(node.attrs?.localId)) {
            decoratedNodeRanges.push({
                from: pos,
                to: pos + node.nodeSize
            });
            return false;
        }
        return true;
    });
    return decoratedNodeRanges;
};
const $1b159f40bd8b3a1f$var$docChangeAffectsDecorations = ({ doc: doc, suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId, tr: tr })=>{
    if (!tr.docChanged || suggestionIdsByBaseLocalId.size === 0) return false;
    const decoratedNodeRanges = $1b159f40bd8b3a1f$var$getDecoratedNodeRanges(doc, suggestionIdsByBaseLocalId);
    if (decoratedNodeRanges.length === 0) return false;
    return tr.mapping.maps.some((stepMap)=>{
        let affectsDecorations = false;
        stepMap.forEach((oldStart, oldEnd)=>{
            if (affectsDecorations) return;
            const changedRange = {
                from: oldStart,
                to: oldEnd
            };
            affectsDecorations = decoratedNodeRanges.some((decoratedRange)=>$1b159f40bd8b3a1f$var$rangesOverlap(changedRange, decoratedRange));
        });
        return affectsDecorations;
    });
};
function $1b159f40bd8b3a1f$var$calculateSuggestionsDecorations({ doc: doc, followUpCard: followUpCard, suggestionById: suggestionById, suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId, api: api, intl: intl, selectedSuggestion: selectedSuggestion, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI }) {
    // The follow-up card outlives the suggestion it replaces, so its anchors are emitted
    // independently of `suggestionById` — including when that map is empty, which is exactly when
    // the card shows.
    const followUpCardDecorations = $1b159f40bd8b3a1f$var$calculateFollowUpCardDecorations(doc, followUpCard);
    if (suggestionById.size === 0) return followUpCardDecorations.length > 0 ? (0, $8nvEM.DecorationSet).create(doc, followUpCardDecorations) : (0, $8nvEM.DecorationSet).empty;
    const decorations = [
        ...followUpCardDecorations
    ];
    doc.descendants((node, pos)=>{
        const { localId: localId } = node.attrs;
        if (localId) {
            const suggestionsAtLocalId = suggestionIdsByBaseLocalId.get(localId);
            if (suggestionsAtLocalId?.size) {
                const firstSuggestionId = suggestionsAtLocalId.values().next().value;
                const firstSuggestion = firstSuggestionId ? suggestionById.get(firstSuggestionId) : undefined;
                if (firstSuggestion) {
                    const element = document.createElement('span');
                    const nodeTypeName = node.type.name === 'heading' ? $1b159f40bd8b3a1f$var$constructHeadingAdjustmentKey(node) : node.type.name;
                    element.setAttribute('style', (0, $8Dx7s.convertToInlineCss)({
                        position: 'relative',
                        width: '100%',
                        display: 'block',
                        pointerEvents: 'none'
                    }));
                    const isSelected = Boolean(selectedSuggestion && suggestionsAtLocalId.has(selectedSuggestion));
                    const isTableNode = node.type.name === 'table';
                    // Tables don't use breakout for resizing, the width is stored in the attrs
                    // but will be clamped by the max content width (100cqw)
                    // The (-4px) is mimicking spacing of the remix icon button in block controls plugin
                    const leftAdjustment = isTableNode && typeof node.attrs?.width === 'number' ? `calc(((min(100cqw - (72px * 2), ${node.attrs.width}px) - 760px) / 2) - 4px)` : undefined;
                    const nodeBefore = doc.resolve(pos).nodeBefore;
                    const isBlockLeafNodeBefore = nodeBefore?.isBlock && nodeBefore.isLeaf;
                    const topAdjustment = $1b159f40bd8b3a1f$var$nodeTopAdjustments[nodeTypeName] ?? 0;
                    const topMargin = $1b159f40bd8b3a1f$var$nodeTopMargins[nodeTypeName] ?? 0;
                    const nodeBeforeAdjustment = $1b159f40bd8b3a1f$var$nodeBeforeAdjustments[nodeBefore?.type.name ?? ''] ?? 0;
                    const calculatedTopAdjustment = (pos === 0 ? isTableNode ? topAdjustment : 0 : isBlockLeafNodeBefore ? Math.max(0, topMargin - nodeBeforeAdjustment) : topMargin) + topAdjustment;
                    /**
           * Stable key so rebuilding the DecorationSet (e.g. a SELECT_SUGGESTION, or a
           * SET_SUGGESTIONS from a regeneration) reuses this widget instead of replacing
           * its DOM. The widget hosts the `--button-<localId>` anchor the card is
           * positioned from, and the portal that renders it is flushed on a throttled
           * update — so recreating the element left a window on every rebuild where the
           * anchor resolved to nothing, and anything measuring the card's anchor position
           * in that window (see `useSuggestionCardPositioning`) read a static-position
           * fallback instead of the button's real position.
           *
           * The geometry inputs are part of the key because ProseMirror skips `toDOM` for
           * a reused widget, so a stale `leftAdjustment` / `topAdjustment` could not be
           * corrected by a re-render. Everything else `SuggestionIconButton` needs it
           * reads from plugin state itself, so selection and suggestion changes re-render
           * the button without disturbing the anchor.
           */ const key = `--button-${localId}|${calculatedTopAdjustment}|${leftAdjustment ?? ''}`;
                    // EDITOR-8771: the icon button is registered via the UI Control Registry API
                    // (see `SuggestionRightSurfaceButton`/`aiSuggestionsPlugin.tsx`) once the migration
                    // gate is on, so skip the legacy widget here to avoid rendering it twice. Every
                    // other decoration below (card anchors, remix placeholder) is unrelated to which
                    // system renders the icon button and must still run regardless of this gate.
                    if (!(0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration')) decorations.push((0, $8nvEM.Decoration).widget(pos, ()=>{
                        nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $10017670bb6714bc$export$b6eb36123ab7ffdf), {
                                leftAdjustment: leftAdjustment,
                                topAdjustment: calculatedTopAdjustment,
                                localId: localId,
                                api: api,
                                intl: intl
                            }), element, key);
                        return element;
                    }, {
                        side: -2,
                        key: key,
                        marks: node.marks.filter((mark)=>mark.type.name === 'breakout'),
                        destroy: ()=>{
                        // Clean up properly
                        // nodeViewPortalProviderAPI.remove(key);
                        }
                    }));
                    if (isSelected) {
                        const selectedSuggestionData = selectedSuggestion ? suggestionById.get(selectedSuggestion) : undefined;
                        const anchorLocalId = selectedSuggestionData ? (0, $c08510c480bfb65f$export$e644b4e6be3487e)(selectedSuggestionData) : undefined;
                        // The remix placeholder is emitted separately (see
                        // `calculateRemixPlaceholderDecorations`).
                        if (anchorLocalId) {
                            let anchorNodePosition;
                            if (anchorLocalId === localId) anchorNodePosition = {
                                pos: pos,
                                nodeSize: node.nodeSize
                            };
                            else node.descendants((descendant, descendantPos)=>{
                                if (anchorNodePosition) return false;
                                const descendantLocalId = descendant.attrs?.localId;
                                if (descendantLocalId === anchorLocalId) {
                                    anchorNodePosition = {
                                        pos: pos + descendantPos + 1,
                                        nodeSize: descendant.nodeSize
                                    };
                                    return false;
                                }
                                return true;
                            });
                            const innerCardStartPos = anchorNodePosition?.pos ?? pos;
                            const innerCardEndPos = anchorNodePosition ? anchorNodePosition.pos + anchorNodePosition.nodeSize : pos + node.nodeSize;
                            // Pin the card anchors to the enclosing expand or table row so the spans
                            // render at that block's boundary rather than deep inside it, keeping the
                            // card aligned with the row the user sees while staying out of the grid
                            // `<tr>` (EDITOR-8442). See `findSuggestionCardAnchorRanges`.
                            const anchorRanges = (0, $3e8bb7c5c711e11c$export$213833a0759111eb)(doc, innerCardStartPos);
                            const primaryRange = anchorRanges.primary ?? {
                                startPos: innerCardStartPos,
                                endPos: innerCardEndPos
                            };
                            /**
               * These decoration widgets are used to track the top and bottom of the localId,
               * also accounting for other decoration widgets (such as diffs).
               */ decorations.push(...$1b159f40bd8b3a1f$var$createCardAnchorDecorations({
                                start: `--card-${anchorLocalId}-start`,
                                end: `--card-${anchorLocalId}-end`
                            }, primaryRange));
                            // Only emitted when the primary range sits inside the target, i.e. where the
                            // diff can hide it. The card chains the two with `anchor()`'s fallback
                            // argument, so these are inert while the primary anchors are rendered.
                            if (anchorRanges.fallback) decorations.push(...$1b159f40bd8b3a1f$var$createCardAnchorDecorations({
                                start: `--card-${anchorLocalId}-outer-start`,
                                end: `--card-${anchorLocalId}-outer-end`
                            }, anchorRanges.fallback));
                        }
                    }
                }
            }
        }
        return false;
    });
    if (!decorations.length) return (0, $8nvEM.DecorationSet).empty;
    return (0, $8nvEM.DecorationSet).create(doc, decorations);
}
// Whether a `SUGGESTED_REMIX` card is selected; gates the manual placeholder-portal teardown.
function $1b159f40bd8b3a1f$var$isSuggestedRemixCardActive(pluginState) {
    if (!pluginState?.selectedSuggestion) return false;
    return pluginState.suggestionById.get(pluginState.selectedSuggestion)?.actionKind === 'SUGGESTED_REMIX';
}
function $1b159f40bd8b3a1f$var$shouldRetainSelectedSuggestionHighlight(suggestion) {
    return suggestion?.actionKind === 'INFORMATIONAL' || suggestion?.actionKind === 'SUGGESTED_REMIX';
}
function $1b159f40bd8b3a1f$var$getSelectedSuggestionForHighlight(pluginState) {
    const selectedSuggestion = pluginState.selectedSuggestion ? pluginState.suggestionById.get(pluginState.selectedSuggestion) : undefined;
    return $1b159f40bd8b3a1f$var$shouldRetainSelectedSuggestionHighlight(selectedSuggestion) ? selectedSuggestion : undefined;
}
function $1b159f40bd8b3a1f$var$calculateSelectedSuggestionDecorations(doc, pluginState, isEditorInViewMode) {
    return isEditorInViewMode ? (0, $8nvEM.DecorationSet).empty : (0, $f19306cd2f195aad$export$277f5ff788d0fe35)(doc, $1b159f40bd8b3a1f$var$getSelectedSuggestionForHighlight(pluginState));
}
/**
 * Placeholder marking where a selected `SUGGESTED_REMIX` result will land. Emitted
 * independently of the sparkle-UI `decorations`, mirroring
 * `calculateSelectedSuggestionDecorations`.
 */ function $1b159f40bd8b3a1f$var$calculateRemixPlaceholderDecorations(doc, pluginState, isEditorInViewMode, nodeViewPortalProviderAPI) {
    if (isEditorInViewMode) return (0, $8nvEM.DecorationSet).empty;
    const selectedSuggestionData = pluginState.selectedSuggestion ? pluginState.suggestionById.get(pluginState.selectedSuggestion) : undefined;
    if (selectedSuggestionData?.actionKind !== 'SUGGESTED_REMIX') return (0, $8nvEM.DecorationSet).empty;
    const anchorLocalId = (0, $c08510c480bfb65f$export$e644b4e6be3487e)(selectedSuggestionData);
    // Drop the placeholder after the last source localId (falling back to the anchor).
    const remixLocalIds = selectedSuggestionData.action?.localIds?.length ? selectedSuggestionData.action.localIds : anchorLocalId ? [
        anchorLocalId
    ] : [];
    const placeholderPos = (0, $3d32a865531fd601$export$232f392504ff18fb)(doc, remixLocalIds);
    if (placeholderPos === undefined) return (0, $8nvEM.DecorationSet).empty;
    const placeholderElement = (0, $e304709e40e65587$export$516004d46b807715)();
    // No `destroy`; the portal is removed manually when the card goes inactive (see plugin `view`).
    return (0, $8nvEM.DecorationSet).create(doc, [
        (0, $8nvEM.Decoration).widget(placeholderPos, ()=>{
            nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $fc8365e3016e62d6$export$ad96c1fdd46ef47e), {}), placeholderElement, (0, $e304709e40e65587$export$f6edc6b3f6e003d));
            return placeholderElement;
        }, {
            key: (0, $e304709e40e65587$export$f6edc6b3f6e003d),
            side: -1
        })
    ]);
}
/**
 * Rebuild the suggestion-driven slice of plugin state (maps + decorations) for a given
 * set of suggestions against `doc`. Shared by accept (removing cards) and undo/redo
 * (restoring/removing cards) so they all produce a consistent state and decorations.
 */ function $1b159f40bd8b3a1f$var$rebuildSuggestionsState({ pluginState: pluginState, suggestions: suggestions, doc: doc, suggestionsHidden: suggestionsHidden, api: api, intl: intl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI }) {
    const { suggestionById: suggestionById, baseLocalIdBySuggestionId: baseLocalIdBySuggestionId, suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId, orderedSuggestionIds: orderedSuggestionIds } = (0, $3b455e9f1a609467$export$8eb2ba4e0b5d0f47)({
        doc: doc,
        suggestions: suggestions
    });
    return {
        ...pluginState,
        suggestionById: suggestionById,
        baseLocalIdBySuggestionId: baseLocalIdBySuggestionId,
        suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId,
        orderedSuggestionIds: orderedSuggestionIds,
        selectedSuggestion: undefined,
        followUpCard: undefined,
        hoveredSuggestionId: undefined,
        hoverDecorations: (0, $8nvEM.DecorationSet).empty,
        selectedSuggestionDecorations: (0, $8nvEM.DecorationSet).empty,
        decorations: suggestionsHidden ? (0, $8nvEM.DecorationSet).empty : $1b159f40bd8b3a1f$var$calculateSuggestionsDecorations({
            doc: doc,
            followUpCard: undefined,
            suggestionById: suggestionById,
            suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId,
            api: api,
            intl: intl,
            selectedSuggestion: undefined,
            nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
        })
    };
}
const { suggestionById: $1b159f40bd8b3a1f$var$initSuggestionById, suggestionIdsByBaseLocalId: $1b159f40bd8b3a1f$var$initSuggestionIdsByBaseLocalId, baseLocalIdBySuggestionId: $1b159f40bd8b3a1f$var$initBaseLocalIdBySuggestionId, orderedSuggestionIds: $1b159f40bd8b3a1f$var$initOrderedSuggestionIds } = (0, $3b455e9f1a609467$export$8eb2ba4e0b5d0f47)(undefined);
const $1b159f40bd8b3a1f$var$initState = {
    contentAri: undefined,
    decorations: (0, $8nvEM.DecorationSet).empty,
    followUpCard: undefined,
    hoverDecorations: (0, $8nvEM.DecorationSet).empty,
    hoveredSuggestionId: undefined,
    mergedDecorations: (0, $8nvEM.DecorationSet).empty,
    isHidden: false,
    selectedSuggestion: undefined,
    suggestionById: $1b159f40bd8b3a1f$var$initSuggestionById,
    suggestionIdsByBaseLocalId: $1b159f40bd8b3a1f$var$initSuggestionIdsByBaseLocalId,
    baseLocalIdBySuggestionId: $1b159f40bd8b3a1f$var$initBaseLocalIdBySuggestionId,
    orderedSuggestionIds: $1b159f40bd8b3a1f$var$initOrderedSuggestionIds,
    regeneratingSuggestionIds: new Set(),
    selectedSuggestionDecorations: (0, $8nvEM.DecorationSet).empty,
    remixPlaceholderDecorations: (0, $8nvEM.DecorationSet).empty,
    undoableAcceptedSuggestions: [],
    redoableAcceptedSuggestions: []
};
// View mode is a hard override for the suggestions UI: the document is read-only, so a suggestion
// can't be meaningfully accepted/discarded. Checked at the source so it can't be undone by a stray
// `setUIVisibility(false)`.
const $1b159f40bd8b3a1f$var$isViewMode = (api)=>api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
function $1b159f40bd8b3a1f$export$ae829ec7b2625219({ api: api, intl: intl, contentAri: contentAri, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI }) {
    return new (0, $kpCD8.SafePlugin)({
        key: $1b159f40bd8b3a1f$export$dbbefe45c19011aa,
        state: {
            init (_config, _state) {
                return $1b159f40bd8b3a1f$var$initState;
            },
            apply (tr, pluginState, _oldState, newState) {
                const meta = tr.getMeta($1b159f40bd8b3a1f$export$dbbefe45c19011aa);
                let nextState = pluginState;
                // View mode is a hard override: suggestions UI must never be shown while read-only,
                // regardless of the `isHidden` flag (which can be toggled by `setUIVisibility`).
                const suggestionsHidden = pluginState.isHidden || $1b159f40bd8b3a1f$var$isViewMode(api);
                if (meta) switch(meta.action){
                    case 'SET_SUGGESTIONS':
                        {
                            const { suggestionById: suggestionById, baseLocalIdBySuggestionId: baseLocalIdBySuggestionId, suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId, orderedSuggestionIds: orderedSuggestionIds } = (0, $3b455e9f1a609467$export$8eb2ba4e0b5d0f47)({
                                suggestions: meta.suggestions,
                                doc: newState.doc
                            });
                            // Track the content these suggestions belong to. Prefer the explicit
                            // `contentAri` on the meta, falling back to the suggestions' own
                            // `contentAri` so direct dispatchers are covered too. `||` (not `??`)
                            // is intentional so an empty-string `contentAri` is treated as "not
                            // provided" rather than a distinct page (which would cause a spurious
                            // reset against a previously-tracked ARI).
                            const incomingContentAri = meta.contentAri || meta.suggestions[0]?.contentAri;
                            // When the suggestions belong to a different page than the one currently
                            // tracked, the selection (and its diff) is stale — reset it. Suggestions
                            // refreshed for the *same* page keep the existing selection.
                            const contentChanged = incomingContentAri !== undefined && pluginState.contentAri !== undefined && incomingContentAri !== pluginState.contentAri;
                            const nextSelectedSuggestion = contentChanged ? undefined : pluginState.selectedSuggestion;
                            // A follow-up card belongs to the page whose suggestion was removed.
                            const nextFollowUpCard = contentChanged ? undefined : pluginState.followUpCard;
                            nextState = {
                                ...pluginState,
                                contentAri: incomingContentAri ?? pluginState.contentAri,
                                selectedSuggestion: nextSelectedSuggestion,
                                followUpCard: nextFollowUpCard,
                                suggestionById: suggestionById,
                                suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId,
                                baseLocalIdBySuggestionId: baseLocalIdBySuggestionId,
                                orderedSuggestionIds: orderedSuggestionIds,
                                hoverDecorations: (0, $8nvEM.DecorationSet).empty,
                                hoveredSuggestionId: undefined,
                                decorations: suggestionsHidden ? (0, $8nvEM.DecorationSet).empty : $1b159f40bd8b3a1f$var$calculateSuggestionsDecorations({
                                    doc: newState.doc,
                                    followUpCard: nextFollowUpCard,
                                    suggestionById: suggestionById,
                                    suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId,
                                    api: api,
                                    intl: intl,
                                    selectedSuggestion: nextSelectedSuggestion,
                                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                                })
                            };
                            break;
                        }
                    case 'CLEAR_SUGGESTIONS':
                        {
                            const { suggestionById: suggestionById, baseLocalIdBySuggestionId: baseLocalIdBySuggestionId, suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId, orderedSuggestionIds: orderedSuggestionIds } = (0, $3b455e9f1a609467$export$8eb2ba4e0b5d0f47)({
                                doc: newState.doc,
                                suggestions: []
                            });
                            nextState = {
                                ...pluginState,
                                suggestionById: suggestionById,
                                suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId,
                                baseLocalIdBySuggestionId: baseLocalIdBySuggestionId,
                                orderedSuggestionIds: orderedSuggestionIds,
                                selectedSuggestion: undefined,
                                followUpCard: undefined,
                                decorations: (0, $8nvEM.DecorationSet).empty,
                                hoverDecorations: (0, $8nvEM.DecorationSet).empty,
                                selectedSuggestionDecorations: (0, $8nvEM.DecorationSet).empty,
                                hoveredSuggestionId: undefined
                            };
                            break;
                        }
                    case 'REMOVE_SUGGESTIONS':
                        {
                            const removedSuggestionIds = new Set(meta.ids);
                            const remainingSuggestions = pluginState.orderedSuggestionIds.filter((id)=>!removedSuggestionIds.has(id)).map((id)=>pluginState.suggestionById.get(id)).filter((suggestion)=>suggestion !== undefined);
                            const { suggestionById: suggestionById, baseLocalIdBySuggestionId: baseLocalIdBySuggestionId, suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId, orderedSuggestionIds: orderedSuggestionIds } = (0, $3b455e9f1a609467$export$8eb2ba4e0b5d0f47)({
                                doc: newState.doc,
                                suggestions: remainingSuggestions
                            });
                            nextState = {
                                ...pluginState,
                                suggestionById: suggestionById,
                                suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId,
                                baseLocalIdBySuggestionId: baseLocalIdBySuggestionId,
                                orderedSuggestionIds: orderedSuggestionIds,
                                selectedSuggestion: undefined,
                                followUpCard: undefined,
                                decorations: suggestionsHidden ? (0, $8nvEM.DecorationSet).empty : $1b159f40bd8b3a1f$var$calculateSuggestionsDecorations({
                                    doc: newState.doc,
                                    followUpCard: undefined,
                                    suggestionById: suggestionById,
                                    suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId,
                                    api: api,
                                    intl: intl,
                                    selectedSuggestion: undefined,
                                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                                }),
                                hoverDecorations: (0, $8nvEM.DecorationSet).empty,
                                selectedSuggestionDecorations: (0, $8nvEM.DecorationSet).empty,
                                hoveredSuggestionId: undefined
                            };
                            break;
                        }
                    case 'SET_REGENERATING':
                        nextState = {
                            ...pluginState,
                            regeneratingSuggestionIds: new Set(meta.ids)
                        };
                        break;
                    case 'SELECT_SUGGESTION':
                        {
                            // Opening a suggestion card supersedes the follow-up card, so both are never on
                            // screen at once. Deselecting leaves it alone, so a stray
                            // `selectSuggestion(null)` can't close it.
                            const nextFollowUpCard = meta.id ? undefined : pluginState.followUpCard;
                            nextState = {
                                ...pluginState,
                                selectedSuggestion: meta.id,
                                followUpCard: nextFollowUpCard,
                                hoverDecorations: (0, $8nvEM.DecorationSet).empty,
                                hoveredSuggestionId: undefined,
                                decorations: suggestionsHidden ? (0, $8nvEM.DecorationSet).empty : $1b159f40bd8b3a1f$var$calculateSuggestionsDecorations({
                                    doc: newState.doc,
                                    followUpCard: nextFollowUpCard,
                                    suggestionById: pluginState.suggestionById,
                                    suggestionIdsByBaseLocalId: pluginState.suggestionIdsByBaseLocalId,
                                    api: api,
                                    intl: intl,
                                    selectedSuggestion: meta.id,
                                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                                })
                            };
                            break;
                        }
                    case 'SET_UI_VISIBILITY':
                        {
                            // Persist the requested `isHidden`, but gate the actual UI on view mode too so a
                            // `setUIVisibility(false)` can never reveal suggestions while read-only.
                            const hidden = meta.isHidden || $1b159f40bd8b3a1f$var$isViewMode(api);
                            nextState = {
                                ...pluginState,
                                isHidden: meta.isHidden,
                                // Hiding the suggestions UI closes the card for good, rather than parking it
                                // to reappear later out of context.
                                followUpCard: hidden ? undefined : pluginState.followUpCard,
                                hoverDecorations: hidden ? (0, $8nvEM.DecorationSet).empty : pluginState.hoverDecorations,
                                hoveredSuggestionId: hidden ? undefined : pluginState.hoveredSuggestionId,
                                decorations: hidden ? (0, $8nvEM.DecorationSet).empty : $1b159f40bd8b3a1f$var$calculateSuggestionsDecorations({
                                    doc: newState.doc,
                                    followUpCard: pluginState.followUpCard,
                                    suggestionById: pluginState.suggestionById,
                                    suggestionIdsByBaseLocalId: pluginState.suggestionIdsByBaseLocalId,
                                    api: api,
                                    intl: intl,
                                    selectedSuggestion: pluginState.selectedSuggestion,
                                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                                })
                            };
                            break;
                        }
                    case 'ACCEPT_SUGGESTION':
                        {
                            const acceptedSuggestions = [
                                meta.suggestion
                            ];
                            const acceptedIds = new Set(acceptedSuggestions.map(({ id: id })=>id));
                            const remainingSuggestions = (0, $0b504009849b7a0d$export$e4a1d22be49a81bd)(pluginState).filter((suggestion)=>!acceptedIds.has(suggestion.id));
                            const acceptedGroup = {
                                suggestions: acceptedSuggestions,
                                undoDepthAtAccept: (0, $0b504009849b7a0d$export$28a08778956fc267)(api) + 1
                            };
                            nextState = $1b159f40bd8b3a1f$var$rebuildSuggestionsState({
                                pluginState: pluginState,
                                suggestions: remainingSuggestions,
                                doc: newState.doc,
                                suggestionsHidden: suggestionsHidden,
                                api: api,
                                intl: intl,
                                nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                            });
                            nextState = {
                                ...nextState,
                                undoableAcceptedSuggestions: [
                                    ...pluginState.undoableAcceptedSuggestions,
                                    acceptedGroup
                                ],
                                redoableAcceptedSuggestions: []
                            };
                            break;
                        }
                    case 'REMOVE_SUGGESTION':
                        {
                            const { suggestionById: suggestionById, baseLocalIdBySuggestionId: baseLocalIdBySuggestionId, suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId, orderedSuggestionIds: orderedSuggestionIds } = pluginState;
                            const removedId = meta.id;
                            const suggestion = suggestionById.get(removedId);
                            if (!suggestion) {
                                nextState = {
                                    ...pluginState,
                                    decorations: $1b159f40bd8b3a1f$var$calculateSuggestionsDecorations({
                                        doc: newState.doc,
                                        followUpCard: pluginState.followUpCard,
                                        suggestionById: suggestionById,
                                        suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId,
                                        api: api,
                                        intl: intl,
                                        selectedSuggestion: undefined,
                                        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                                    })
                                };
                                break;
                            }
                            const nextOrderedSuggestionIds = orderedSuggestionIds.filter((id)=>id !== removedId);
                            // Only the last suggestion leaves a follow-up card behind — while others remain
                            // the user carries on reviewing them. Captured before the maps are pruned
                            // below, which drops the localIds the card anchors itself with.
                            const isLastSuggestion = nextOrderedSuggestionIds.length === 0;
                            const nextFollowUpCard = isLastSuggestion && (0, $56b1bb8689d88b40$export$20931deba49a7f12)(suggestion) ? {
                                suggestionId: removedId,
                                anchorLocalId: (0, $c08510c480bfb65f$export$e644b4e6be3487e)(suggestion),
                                baseLocalId: baseLocalIdBySuggestionId.get(removedId)
                            } : undefined;
                            suggestionById.delete(removedId);
                            const baseLocalId = baseLocalIdBySuggestionId.get(removedId);
                            baseLocalIdBySuggestionId.delete(removedId);
                            if (baseLocalId) suggestionIdsByBaseLocalId.get(baseLocalId)?.delete(removedId);
                            nextState = {
                                ...pluginState,
                                suggestionById: suggestionById,
                                baseLocalIdBySuggestionId: baseLocalIdBySuggestionId,
                                suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId,
                                orderedSuggestionIds: nextOrderedSuggestionIds,
                                selectedSuggestion: undefined,
                                followUpCard: nextFollowUpCard,
                                decorations: $1b159f40bd8b3a1f$var$calculateSuggestionsDecorations({
                                    doc: newState.doc,
                                    followUpCard: nextFollowUpCard,
                                    suggestionById: suggestionById,
                                    suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId,
                                    api: api,
                                    intl: intl,
                                    selectedSuggestion: undefined,
                                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                                })
                            };
                            break;
                        }
                    case 'DISMISS_FOLLOW_UP_CARD':
                        if (!pluginState.followUpCard) break;
                        nextState = {
                            ...pluginState,
                            followUpCard: undefined,
                            // Recalculated rather than mapped, so the card's anchor spans leave the DOM
                            // along with it.
                            decorations: suggestionsHidden ? (0, $8nvEM.DecorationSet).empty : $1b159f40bd8b3a1f$var$calculateSuggestionsDecorations({
                                doc: newState.doc,
                                followUpCard: undefined,
                                suggestionById: pluginState.suggestionById,
                                suggestionIdsByBaseLocalId: pluginState.suggestionIdsByBaseLocalId,
                                api: api,
                                intl: intl,
                                selectedSuggestion: pluginState.selectedSuggestion,
                                nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                            })
                        };
                        break;
                    case 'HOVER_SUGGESTION':
                        {
                            const hoveredSuggestion = meta.id ? pluginState.suggestionById.get(meta.id) : undefined;
                            nextState = {
                                ...pluginState,
                                hoveredSuggestionId: meta.id,
                                hoverDecorations: suggestionsHidden ? (0, $8nvEM.DecorationSet).empty : (0, $f19306cd2f195aad$export$277f5ff788d0fe35)(newState.doc, hoveredSuggestion)
                            };
                            break;
                        }
                    default:
                        break;
                }
                else if (tr.docChanged && (0, $0b504009849b7a0d$export$4a859a7b0093f8a2)(tr) === 'undo' && pluginState.undoableAcceptedSuggestions.length > 0 && (0, $0b504009849b7a0d$export$686b6c582e8762c9)(tr) !== undefined && (0, $0b504009849b7a0d$export$686b6c582e8762c9)(tr) < pluginState.undoableAcceptedSuggestions[pluginState.undoableAcceptedSuggestions.length - 1].undoDepthAtAccept) {
                    const restoredGroup = pluginState.undoableAcceptedSuggestions[pluginState.undoableAcceptedSuggestions.length - 1];
                    const restoredGroups = [
                        restoredGroup
                    ];
                    const remainingUndoable = pluginState.undoableAcceptedSuggestions.slice(0, -1);
                    const restoredIds = new Set(restoredGroup.suggestions.map(({ id: id })=>id));
                    const nextSuggestions = [
                        ...(0, $0b504009849b7a0d$export$e4a1d22be49a81bd)(pluginState).filter((suggestion)=>!restoredIds.has(suggestion.id)),
                        ...restoredGroups.flatMap((group)=>group.suggestions)
                    ];
                    nextState = $1b159f40bd8b3a1f$var$rebuildSuggestionsState({
                        pluginState: pluginState,
                        suggestions: nextSuggestions,
                        doc: newState.doc,
                        suggestionsHidden: suggestionsHidden,
                        api: api,
                        intl: intl,
                        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                    });
                    nextState = {
                        ...nextState,
                        undoableAcceptedSuggestions: remainingUndoable,
                        redoableAcceptedSuggestions: [
                            ...pluginState.redoableAcceptedSuggestions,
                            ...restoredGroups
                        ]
                    };
                } else if (tr.docChanged && (0, $0b504009849b7a0d$export$4a859a7b0093f8a2)(tr) === 'redo' && pluginState.redoableAcceptedSuggestions.length > 0 && (0, $0b504009849b7a0d$export$686b6c582e8762c9)(tr) !== undefined && (0, $0b504009849b7a0d$export$686b6c582e8762c9)(tr) >= pluginState.redoableAcceptedSuggestions[pluginState.redoableAcceptedSuggestions.length - 1].undoDepthAtAccept) {
                    const reAcceptedGroup = pluginState.redoableAcceptedSuggestions[pluginState.redoableAcceptedSuggestions.length - 1];
                    const reAcceptedGroups = [
                        reAcceptedGroup
                    ];
                    const remainingRedoable = pluginState.redoableAcceptedSuggestions.slice(0, -1);
                    const reAcceptedIds = new Set(reAcceptedGroup.suggestions.map(({ id: id })=>id));
                    const nextSuggestions = (0, $0b504009849b7a0d$export$e4a1d22be49a81bd)(pluginState).filter((suggestion)=>!reAcceptedIds.has(suggestion.id));
                    nextState = $1b159f40bd8b3a1f$var$rebuildSuggestionsState({
                        pluginState: pluginState,
                        suggestions: nextSuggestions,
                        doc: newState.doc,
                        suggestionsHidden: suggestionsHidden,
                        api: api,
                        intl: intl,
                        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                    });
                    nextState = {
                        ...nextState,
                        undoableAcceptedSuggestions: [
                            ...pluginState.undoableAcceptedSuggestions,
                            ...reAcceptedGroups
                        ],
                        redoableAcceptedSuggestions: remainingRedoable
                    };
                } else {
                    const shouldRecalculateDecorations = $1b159f40bd8b3a1f$var$docChangeAffectsDecorations({
                        doc: _oldState.doc,
                        suggestionIdsByBaseLocalId: pluginState.suggestionIdsByBaseLocalId,
                        tr: tr
                    });
                    nextState = {
                        ...pluginState,
                        hoverDecorations: suggestionsHidden || pluginState.hoverDecorations === (0, $8nvEM.DecorationSet).empty ? (0, $8nvEM.DecorationSet).empty : pluginState.hoverDecorations.map(tr.mapping, tr.doc),
                        selectedSuggestionDecorations: pluginState.selectedSuggestionDecorations === (0, $8nvEM.DecorationSet).empty ? (0, $8nvEM.DecorationSet).empty : pluginState.selectedSuggestionDecorations.map(tr.mapping, tr.doc),
                        remixPlaceholderDecorations: pluginState.remixPlaceholderDecorations === (0, $8nvEM.DecorationSet).empty ? (0, $8nvEM.DecorationSet).empty : pluginState.remixPlaceholderDecorations.map(tr.mapping, tr.doc),
                        decorations: suggestionsHidden ? (0, $8nvEM.DecorationSet).empty : shouldRecalculateDecorations ? $1b159f40bd8b3a1f$var$calculateSuggestionsDecorations({
                            doc: newState.doc,
                            followUpCard: pluginState.followUpCard,
                            suggestionById: pluginState.suggestionById,
                            suggestionIdsByBaseLocalId: pluginState.suggestionIdsByBaseLocalId,
                            api: api,
                            intl: intl,
                            selectedSuggestion: pluginState.selectedSuggestion,
                            nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                        }) : pluginState.decorations.map(tr.mapping, tr.doc)
                    };
                }
                if (nextState === pluginState) return nextState;
                const shouldRecalculateSelectionDecorations = Boolean(meta) || (0, $0b504009849b7a0d$export$4a859a7b0093f8a2)(tr) !== undefined;
                const selectedSuggestionDecorations = shouldRecalculateSelectionDecorations ? $1b159f40bd8b3a1f$var$calculateSelectedSuggestionDecorations(newState.doc, nextState, $1b159f40bd8b3a1f$var$isViewMode(api)) : nextState.selectedSuggestionDecorations;
                const remixPlaceholderDecorations = shouldRecalculateSelectionDecorations ? $1b159f40bd8b3a1f$var$calculateRemixPlaceholderDecorations(newState.doc, nextState, $1b159f40bd8b3a1f$var$isViewMode(api), nodeViewPortalProviderAPI) : nextState.remixPlaceholderDecorations;
                const activeHighlightDecorations = nextState.hoverDecorations === (0, $8nvEM.DecorationSet).empty ? selectedSuggestionDecorations : nextState.hoverDecorations;
                // Merge the icon widgets with the active highlight and the remix placeholder
                // once here so the `decorations` prop returns a stable set. Reuse the
                // `decorations` reference (no allocation) when there is nothing extra.
                const extraDecorations = [
                    ...activeHighlightDecorations.find(),
                    ...remixPlaceholderDecorations.find()
                ];
                return {
                    ...nextState,
                    selectedSuggestionDecorations: selectedSuggestionDecorations,
                    remixPlaceholderDecorations: remixPlaceholderDecorations,
                    mergedDecorations: extraDecorations.length === 0 ? nextState.decorations : nextState.decorations.add(newState.doc, extraDecorations)
                };
            }
        },
        /**
     * The diff lives in the (separate) show-diff plugin, so it can't be reset from
     * this plugin's `apply`. When the tracked `contentAri` changes — i.e. the
     * suggestions now belong to a different page than the one whose diff is on
     * screen — hide the diff so a stale diff doesn't linger on the new page (which
     * can otherwise re-render whenever the new page contains a node with the same
     * `localId`). The matching selection/decoration reset happens in the
     * `SET_SUGGESTIONS` handler above.
     *
     * Also deselects the open suggestion once the content it is anchored to is gone —
     * see below.
     */ appendTransaction (transactions, oldState, newState) {
            const previousContentAri = $1b159f40bd8b3a1f$export$dbbefe45c19011aa.getState(oldState)?.contentAri;
            const nextState = $1b159f40bd8b3a1f$export$dbbefe45c19011aa.getState(newState);
            const contentChanged = previousContentAri !== undefined && nextState?.contentAri !== undefined && previousContentAri !== nextState.contentAri;
            if (contentChanged) {
                const { tr: tr } = newState;
                api?.showDiff?.commands.hideDiff?.({
                    tr: tr
                });
                tr.setMeta((0, $4d8c0f76a4c8d5f6$export$1acc4db37d317889), {
                    status: 'idle'
                });
                return tr;
            }
            const isUndoRedo = transactions.some((transaction)=>(0, $0b504009849b7a0d$export$4a859a7b0093f8a2)(transaction) !== undefined);
            if (isUndoRedo) {
                const previousPluginState = $1b159f40bd8b3a1f$export$dbbefe45c19011aa.getState(oldState);
                const previousRedoableIds = (0, $0b504009849b7a0d$export$82a97b36758288e5)(previousPluginState?.redoableAcceptedSuggestions);
                const nextRedoableIds = (0, $0b504009849b7a0d$export$82a97b36758288e5)(nextState?.redoableAcceptedSuggestions);
                // An undo moves an accept from the undo pool INTO the redo pool: the accept has been
                // reverted, so its suggestion goes back to PENDING. A redo moves it OUT of the redo pool
                // (back to the undo pool): the accept is re-applied, so its suggestion is ACTIONED again.
                const revertedToPendingIds = [
                    ...nextRedoableIds
                ].filter((id)=>!previousRedoableIds.has(id));
                const reAppliedToActionedIds = [
                    ...previousRedoableIds
                ].filter((id)=>!nextRedoableIds.has(id));
                if (revertedToPendingIds.length > 0) (0, $61b8b9734ab6a330$export$1d496d000386893c)({
                    updates: revertedToPendingIds.map((id)=>({
                            id: id,
                            status: 'PENDING'
                        }))
                });
                if (reAppliedToActionedIds.length > 0) (0, $61b8b9734ab6a330$export$1d496d000386893c)({
                    updates: reAppliedToActionedIds.map((id)=>({
                            id: id,
                            status: 'ACTIONED'
                        }))
                });
                const previousSelectedId = previousPluginState?.selectedSuggestion;
                const nextSelectedId = nextState?.selectedSuggestion;
                const selectionChanged = nextSelectedId !== previousSelectedId;
                // Surface refresh on undo/redo is handled in the view.update hook (post-DOM-flush); here we
                // only handle the open card's diff/selection.
                if (selectionChanged) {
                    const { tr: tr } = newState;
                    const nextSelected = nextSelectedId ? nextState?.suggestionById.get(nextSelectedId) : undefined;
                    if (nextSelected) {
                        (0, $fca6dda0e2782a58$export$9cfe4ac318e0d7a7)({
                            api: api,
                            suggestion: nextSelected,
                            tr: tr
                        });
                        api?.userIntent?.commands.setCurrentUserIntent('reviewing')({
                            tr: tr
                        });
                    } else {
                        api?.showDiff?.commands.hideDiff?.({
                            tr: tr
                        });
                        api?.userIntent?.commands.setCurrentUserIntent('default')({
                            tr: tr
                        });
                    }
                    tr.setMeta('addToHistory', false);
                    return tr;
                }
            }
            /**
       * If the content that the card is anchored to is deleted, the card is dangling
       * Deselect it if the corresponding localId is no longer present in the doc.
       */ const shouldDeselect = nextState?.selectedSuggestion !== undefined && transactions.some((transaction)=>transaction.docChanged) && !$1b159f40bd8b3a1f$var$canPositionSelectedCard(newState.doc, nextState);
            if (shouldDeselect) {
                const { tr: tr } = newState;
                tr.setMeta($1b159f40bd8b3a1f$export$dbbefe45c19011aa, {
                    action: 'SELECT_SUGGESTION',
                    id: undefined
                });
                api?.showDiff?.commands.hideDiff?.({
                    tr: tr
                });
                api?.userIntent?.commands.setCurrentUserIntent('default')({
                    tr: tr
                });
                return tr;
            }
            return null;
        },
        props: {
            decorations (state) {
                const pluginState = $1b159f40bd8b3a1f$export$dbbefe45c19011aa.getState(state);
                return pluginState?.mergedDecorations ?? (0, $8nvEM.DecorationSet).empty;
            }
        },
        view: (editorView)=>{
            const abortController = new AbortController();
            if (contentAri && api) (0, $575d15e6a5835c33$export$740daa9a9ce77ea8)({
                contentAri: contentAri,
                api: api,
                signal: abortController.signal,
                /**
           * getDoc is a function so it will get the most up to date
           * doc when it eventually gets called when
           * checking for staleness
           */ getDoc: ()=>editorView.state.doc,
                shouldRegenerate: true
            });
            // A view-mode change (edit ↔ view) isn't an ai-suggestions transaction, so the suggestion
            // decorations/diff won't otherwise refresh. Deselecting recomputes the decorations (empty
            // in view mode, restored in edit mode) and hides any open diff via the selectSuggestion
            // action — covering all surfaces without extra machinery.
            const unsubscribeViewMode = api?.editorViewMode?.sharedState.onChange?.(({ nextSharedState: nextSharedState, prevSharedState: prevSharedState })=>{
                if (nextSharedState?.mode === prevSharedState?.mode) return;
                api?.aiSuggestions?.actions.selectSuggestion(null);
            });
            const unsubscribeAnnotation = (0, $2pQiO.UNSAFE_expValNoExposure)('confluence_suggested_edits_inline_comment_fix', 'isEnabled', false) ? api?.annotation?.sharedState.onChange?.(({ nextSharedState: nextSharedState })=>{
                const isInlineCommentOpen = !nextSharedState?.isInlineCommentViewClosed && (nextSharedState?.isDrafting || Boolean(nextSharedState?.selectedAnnotations.length));
                const hasSelectedSuggestion = Boolean($1b159f40bd8b3a1f$export$dbbefe45c19011aa.getState(editorView.state)?.selectedSuggestion);
                if (isInlineCommentOpen && hasSelectedSuggestion) api?.aiSuggestions?.actions.selectSuggestion(null);
            }) : undefined;
            return {
                update: (view, prevState)=>{
                    // Remove the remix placeholder portal once, on the active → inactive transition.
                    const wasActive = $1b159f40bd8b3a1f$var$isSuggestedRemixCardActive($1b159f40bd8b3a1f$export$dbbefe45c19011aa.getState(prevState));
                    const isActive = $1b159f40bd8b3a1f$var$isSuggestedRemixCardActive($1b159f40bd8b3a1f$export$dbbefe45c19011aa.getState(view.state));
                    if (wasActive && !isActive) nodeViewPortalProviderAPI.remove((0, $e304709e40e65587$export$f6edc6b3f6e003d));
                },
                destroy: ()=>{
                    abortController.abort();
                    unsubscribeViewMode?.();
                    unsubscribeAnnotation?.();
                    nodeViewPortalProviderAPI.remove((0, $e304709e40e65587$export$f6edc6b3f6e003d));
                }
            };
        }
    });
}




const $61cbf5e36086ffd7$export$11f54cceda85c938 = (api)=>(id, interactionPoint = 'sidebar')=>{
        const suggestion = api?.aiSuggestions?.sharedState.currentState()?.suggestionById.get(id);
        if (!suggestion) return false;
        api?.core?.actions.execute(({ tr: tr })=>{
            (0, $2a4bc64013915ea2$export$f1a852c299619cdc)(api?.analytics?.actions)(tr, suggestion, interactionPoint);
            tr.setMeta('addToHistory', false);
            return tr;
        });
        api?.core?.actions.execute(({ tr: tr })=>{
            api?.showDiff?.commands.hideDiff?.({
                tr: tr
            });
            (0, $f40c730c85c0fd70$export$e450239860b6dfe1)({
                tr: tr,
                suggestion: suggestion
            });
            tr.setMeta('scrollIntoView', false);
            tr.setMeta((0, $1b159f40bd8b3a1f$export$dbbefe45c19011aa), {
                action: 'ACCEPT_SUGGESTION',
                suggestion: suggestion
            });
            return tr;
        });
        return true;
    };




const $8bb2f22922f0bfc3$export$7cd05c39d88c72e0 = (api)=>()=>{
        const suggestionById = api?.aiSuggestions?.sharedState.currentState()?.suggestionById;
        if (!suggestionById || suggestionById.size === 0) return false;
        const ids = Array.from(suggestionById.keys());
        api?.core?.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $1b159f40bd8b3a1f$export$dbbefe45c19011aa), {
                action: 'CLEAR_SUGGESTIONS'
            });
            api?.showDiff?.commands.hideDiff?.({
                tr: tr
            });
            return tr;
        });
        const updates = ids.map((id)=>({
                id: id,
                status: 'DISMISSED'
            }));
        (0, $61b8b9734ab6a330$export$1d496d000386893c)({
            updates: updates
        });
        return true;
    };




const $f22f7a878bb21ed6$export$97ae1e6707b788ba = (api)=>(id)=>{
        let found = false;
        api?.core?.actions.execute(({ tr: tr })=>{
            const pluginState = api?.aiSuggestions?.sharedState.currentState();
            const suggestion = pluginState?.suggestionById.get(id);
            if (!suggestion) return tr;
            found = true;
            (0, $2a4bc64013915ea2$export$ec701ea77bc93a9f)(api?.analytics?.actions)(tr, suggestion, 'sidebar');
            tr.setMeta((0, $1b159f40bd8b3a1f$export$dbbefe45c19011aa), {
                action: 'REMOVE_SUGGESTION',
                id: id
            });
            api?.showDiff?.commands.hideDiff?.({
                tr: tr
            });
            return tr;
        });
        return found;
    };


const $9c533a1ee7f54d08$export$63a2edde6c848f66 = (api)=>()=>{
        api?.core?.actions.execute(({ tr: tr })=>{
            api?.showDiff?.commands.hideDiff?.({
                tr: tr
            });
            return tr;
        });
        return true;
    };



const $943e90f24ff1479e$export$8c023f02ab5dbd45 = (api, contentAri)=>{
    return (options)=>{
        if (!api) return false;
        const regenerateOnly = options?.regenerateOnly ?? false;
        /**
		 * Quick way to get the doc PMNode
		 * since we don't have access to editorView here
		 */ const getDoc = ()=>{
            let doc;
            api.core?.actions.execute(({ tr: tr })=>{
                doc = tr.doc;
                return null;
            });
            return doc;
        };
        (0, $575d15e6a5835c33$export$740daa9a9ce77ea8)({
            api: api,
            contentAri: contentAri,
            getDoc: getDoc,
            shouldRegenerate: true,
            regenerateOnly: regenerateOnly
        });
        return true;
    };
};







/**
 * Show the diff for a suggestion in its own transaction (then scroll if there is
 * no diff). Used to refresh the diff after a stale suggestion is regenerated —
 * deliberately does NOT go through `selectSuggestion`, which would re-trigger
 * regeneration and loop.
 */ function $93a0ea89424771d8$var$showDiffForSuggestion({ api: api, suggestion: suggestion, options: options }) {
    let noDiffScrollPos;
    api?.core?.actions.execute(({ tr: tr })=>{
        noDiffScrollPos = (0, $fca6dda0e2782a58$export$9cfe4ac318e0d7a7)({
            api: api,
            suggestion: suggestion,
            tr: tr,
            options: options
        });
        api?.userIntent?.commands.setCurrentUserIntent('reviewing')({
            tr: tr
        });
        return tr;
    });
    if (noDiffScrollPos !== undefined) api?.core?.actions.scrollToPos(noDiffScrollPos, {
        behavior: 'smooth',
        block: 'start'
    });
}
/**
 * On select, check the selected suggestion (or all suggestions when
 * `regenerateAll`) for staleness and regenerate any stale ones, retaining every
 * suggestion in place (each stale one is swapped for its regenerated counterpart,
 * which carries its new status + changes). No navigation or removal. Guarded so
 * only one regeneration batch runs at a time. The selected suggestion's diff is
 * refreshed (or hidden if it came back stale) once its data settles.
 */ async function $93a0ea89424771d8$var$regenerateOnSelect({ api: api, selectedId: selectedId, regenerateAll: regenerateAll, options: options }) {
    const state = api?.aiSuggestions?.sharedState.currentState();
    if (!state) return;
    // One regeneration batch at a time — rapid re-selects skip while one runs.
    if (state.regeneratingSuggestionIds.size > 0) return;
    const originalSelected = state.suggestionById.get(selectedId);
    const contentAri = originalSelected?.contentAri;
    if (!contentAri) return;
    // The suggestions to check: all, or just the selected one.
    const scope = (regenerateAll ? state.orderedSuggestionIds : [
        selectedId
    ]).map((id)=>state.suggestionById.get(id)).filter((suggestion)=>suggestion !== undefined);
    // Read the current doc without dispatching (the command returns null).
    const getDoc = ()=>{
        let doc;
        api?.core?.actions.execute(({ tr: tr })=>{
            doc = tr.doc;
            return null;
        });
        return doc;
    };
    const reconcile = (0, $1460109429ebb090$export$d5477d8705cec30f)(getDoc, contentAri, api, {
        shouldRetainStale: true
    });
    const updatedScope = await reconcile(scope);
    // Same reference back means nothing was regenerated (nothing stale / failed).
    if (updatedScope === scope) return;
    // Merge the (possibly scoped) updated suggestions back into the full list.
    const latest = api?.aiSuggestions?.sharedState.currentState();
    if (!latest) return;
    const updatedById = new Map(updatedScope.map((suggestion)=>[
            suggestion.id,
            suggestion
        ]));
    const mergedSuggestions = latest.orderedSuggestionIds.map((id)=>updatedById.get(id) ?? latest.suggestionById.get(id)).filter((suggestion)=>suggestion !== undefined);
    api?.core?.actions.execute(({ tr: tr })=>{
        tr.setMeta((0, $1b159f40bd8b3a1f$export$dbbefe45c19011aa), {
            action: 'SET_SUGGESTIONS',
            suggestions: mergedSuggestions,
            contentAri: contentAri
        });
        return tr;
    });
    // The selected suggestion was regenerated when its object identity changed.
    // Refresh its diff (fresh) or hide it (stale) — only while it's still selected.
    const afterMerge = api?.aiSuggestions?.sharedState.currentState();
    const updatedSelected = afterMerge?.suggestionById.get(selectedId);
    if (afterMerge?.selectedSuggestion === selectedId && updatedSelected && updatedSelected !== originalSelected) {
        if (updatedSelected.status === 'STALE') api?.core?.actions.execute(({ tr: tr })=>{
            api?.showDiff?.commands.hideDiff?.({
                tr: tr
            });
            return tr;
        });
        else $93a0ea89424771d8$var$showDiffForSuggestion({
            api: api,
            suggestion: updatedSelected,
            options: options
        });
    }
}
const $93a0ea89424771d8$export$85c07d6dab7fe6b1 = (api)=>(id, options)=>{
        // Captured during the `execute` callback so we can run the scroll after the
        // transaction has been dispatched — that way `SELECT_SUGGESTION` has already
        // flowed through the plugin state and the card anchors are in the DOM by
        // the time the viewport moves into place.
        let noDiffScrollPos;
        // Read thinking status before execute to check if we should dismiss the
        // 'ready' bar — only when thinking is 'complete', not while still 'thinking'.
        const currentState = api?.aiSuggestions?.sharedState.currentState();
        api?.core?.actions.execute(({ tr: tr })=>{
            (0, $2a4bc64013915ea2$export$c37411486d5e33f8)({
                currentState: currentState,
                editorAnalyticsAPI: api?.analytics?.actions,
                interactionPoint: options?.interactionPoint,
                nextSuggestionId: id,
                transaction: tr
            });
            tr.setMeta((0, $1b159f40bd8b3a1f$export$dbbefe45c19011aa), {
                action: 'SELECT_SUGGESTION',
                id: id ?? undefined
            });
            tr.setMeta('addToHistory', false);
            // Close the 'ready' bar when a suggestion is opened,
            // but only if thinking is complete (don't dismiss while still thinking).
            if (id !== null && currentState?.thinkingStatus === 'complete') tr.setMeta((0, $4d8c0f76a4c8d5f6$export$1acc4db37d317889), {
                status: 'idle'
            });
            if (id === null) {
                // Deselecting — hide the diff and clear the reviewing intent so node floating
                // toolbars become available again.
                api?.showDiff?.commands.hideDiff?.({
                    tr: tr
                });
                api?.userIntent?.commands.setCurrentUserIntent('default')({
                    tr: tr
                });
            } else {
                // Selecting — show the diff for this suggestion
                const suggestion = currentState?.suggestionById.get(id);
                if (suggestion) {
                    if (options?.interactionPoint) (0, $2a4bc64013915ea2$export$aaae075a5bab9523)(api?.analytics?.actions)(tr, suggestion, options.interactionPoint);
                    noDiffScrollPos = (0, $fca6dda0e2782a58$export$9cfe4ac318e0d7a7)({
                        api: api,
                        suggestion: suggestion,
                        tr: tr,
                        options: options
                    });
                }
                // Reviewing a suggestion card: suppress node floating toolbars so they don't overlap
                // or mis-position against the card / diff decorations. Set last so it wins over the
                // `viewingDiff`/`default` intent that showDiff/hideDiff write on this same transaction.
                api?.userIntent?.commands.setCurrentUserIntent('reviewing')({
                    tr: tr
                });
            }
            return tr;
        });
        if (noDiffScrollPos !== undefined) api?.core?.actions.scrollToPos(noDiffScrollPos, {
            behavior: 'smooth',
            block: 'start'
        });
        // Reconcile staleness in the background. Fresh → diff refreshed;
        // stale → kept and marked STALE for the card to render differently.
        if (id !== null) $93a0ea89424771d8$var$regenerateOnSelect({
            api: api,
            selectedId: id,
            regenerateAll: options?.regenerateAll ?? false,
            options: options
        });
        return true;
    };



const $19b7760d1a1a9061$export$6525a287b5847561 = (api)=>(isHidden)=>{
        api?.core?.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $1b159f40bd8b3a1f$export$dbbefe45c19011aa), {
                action: 'SET_UI_VISIBILITY',
                isHidden: isHidden
            });
            return tr;
        });
        return true;
    };






const $95d83135ce202b5d$export$abeb109a09e4f140 = (api)=>(id, options)=>{
        let found = false;
        api?.core?.actions.execute(({ tr: tr })=>{
            const suggestion = api?.aiSuggestions?.sharedState.currentState()?.suggestionById.get(id);
            if (!suggestion) return tr;
            found = true;
            // Apply tool calls to an isolated transaction so we can read its `steps`
            // and `before` for diff visualisation without affecting the source transaction.
            // PM nodes are immutable, so reusing tr.doc is safe.
            const isolatedTr = (0, $kCECX.EditorState).create({
                doc: tr.doc
            }).tr;
            const appliedTr = (0, $f40c730c85c0fd70$export$e450239860b6dfe1)({
                tr: isolatedTr,
                suggestion: suggestion
            });
            const stepAttribution = suggestion.createdByAgent?.accountId ? {
                agentId: suggestion.createdByAgent.accountId
            } : undefined;
            api?.showDiff?.commands.showDiff({
                // Each step's positions live in the doc BEFORE that step is applied
                // (= `appliedTr.docs[i]`). Inverting every step against
                // `appliedTr.before` throws `RangeError` for any step past index 0
                // in a multi-tool-call suggestion. Reverse afterwards so the inverted
                // steps replay back to the original doc when the diff plugin applies
                // them to `appliedTr.doc`.
                stepsWithAttribution: appliedTr.steps.map((step, i)=>({
                        step: step.invert(appliedTr.docs[i]),
                        stepAttribution: stepAttribution
                    })).reverse(),
                originalDoc: appliedTr.doc,
                isInverted: true,
                diffType: 'step',
                hideDeletedDiffs: options?.hideDeletedDiffs,
                scrollIntoView: true
            })({
                tr: tr
            });
            return tr;
        });
        return found;
    };




// Number of top-level blocks either side of a targeted block to include for context.
const $7f796363d3edeeee$var$ADJACENT_NODE_RADIUS = 1;
// Collect every localId a suggestion targets, across all tool-call kinds and
// remix actions, de-duplicated and in first-seen order.
const $7f796363d3edeeee$var$collectTargetLocalIds = (suggestion)=>{
    const ids = [];
    const add = (id)=>{
        if (id && !ids.includes(id)) ids.push(id);
    };
    for (const toolCall of suggestion.toolCalls ?? [])if (toolCall.name === 'removeNodes') toolCall.arguments.localIds.forEach(add);
    else add(toolCall.arguments.localId);
    suggestion.action?.localIds?.forEach(add);
    return ids;
};
// Build a minimal ADF doc from the targeted top-level block(s) plus adjacent siblings (de-duped, in document order).
const $7f796363d3edeeee$var$buildTargetNodeAdf = (doc, suggestion)=>{
    const radius = $7f796363d3edeeee$var$ADJACENT_NODE_RADIUS;
    const lastIndex = doc.childCount - 1;
    // Collect top-level indices to emit, merging each targeted node's adjacency window.
    const selectedIndices = new Set();
    for (const localId of $7f796363d3edeeee$var$collectTargetLocalIds(suggestion)){
        const positions = (0, $f40c730c85c0fd70$export$3a685203b954911f)(doc, localId);
        if (!positions) continue;
        // Top-level block (direct child of doc) containing this position.
        const topLevelIndex = doc.resolve(positions.from).index(0);
        const start = Math.max(0, topLevelIndex - radius);
        const end = Math.min(lastIndex, topLevelIndex + radius);
        for(let index = start; index <= end; index++)selectedIndices.add(index);
    }
    // Emit whole blocks in document order.
    const content = [];
    for (const index of [
        ...selectedIndices
    ].sort((a, b)=>a - b))content.push(doc.child(index).toJSON());
    return content.length > 0 ? {
        version: 1,
        type: 'doc',
        content: content
    } : undefined;
};
const $7f796363d3edeeee$export$be7787b2fea0b5c6 = (api, onSubmitSuggestionFeedback)=>(id, sentiment, options)=>{
        const pluginState = api?.aiSuggestions?.sharedState.currentState();
        const suggestion = pluginState?.suggestionById.get(id);
        if (!suggestion) return false;
        const interactionPoint = options?.interactionPoint ?? 'card';
        (0, $2a4bc64013915ea2$export$6bd5a709c87f4c35)(api?.analytics?.actions, sentiment, id, interactionPoint);
        // Snapshot the ADF of just the targeted node(s) so the product can save a
        // compact artifact for reproducing the suggestion locally.
        let documentAdf;
        api?.core?.actions.execute(({ tr: tr })=>{
            documentAdf = $7f796363d3edeeee$var$buildTargetNodeAdf(tr.doc, suggestion);
            return tr;
        });
        // Forward feedback plus the full payload and targeted node ADF.
        onSubmitSuggestionFeedback?.({
            interactionPoint: interactionPoint,
            sentiment: sentiment,
            suggestionId: id,
            suggestionType: suggestion.type,
            suggestion: suggestion,
            documentAdf: documentAdf
        });
        return true;
    };




const $2d7f810d13618094$export$bf49a0593cfa46b5 = (api)=>(state, options)=>api?.core?.actions.execute(({ tr: tr })=>{
            if (state === 'thinking') {
                if (options?.entryPoint) {
                    // TODO: EDITOR-8269 - placeholder id; may come from the backend once the
                    // unified suggested-edits analytics structure is finalised.
                    const singleInstrumentationId = crypto.randomUUID();
                    (0, $2a4bc64013915ea2$export$33e4f7f2497d28c1)(api?.analytics?.actions)(tr, options.entryPoint);
                    (0, $2a4bc64013915ea2$export$94b303e4fd9baa4e)(api?.analytics?.actions, options.entryPoint, singleInstrumentationId);
                }
                if (options?.isRetry) (0, $2a4bc64013915ea2$export$23faece8799b6885)(api?.analytics?.actions)(tr);
            }
            tr.setMeta((0, $4d8c0f76a4c8d5f6$export$1acc4db37d317889), {
                status: state,
                ...state === 'error' && options?.template ? {
                    error: {
                        template: options.template
                    }
                } : {}
            });
            return tr;
        }) || false;




/* FollowUpCardContentComponent.tsx generated by @compiled/babel-plugin v3.0.1 */ 
















var $3z1p5 = parcelRequire("3z1p5");


var $eKjv9 = parcelRequire("eKjv9");


var $lJ6db = parcelRequire("lJ6db");




var $cXtTj = parcelRequire("cXtTj");

const $19944a85f91ff832$export$183509673cddb866 = 'platform_editor_ai_content_reviewer_agent_config';
const $19944a85f91ff832$var$AGENT_ID_PARAMETER = 'value';
function $19944a85f91ff832$export$bc0c8fb7f661940a() {
    try {
        if (!(0, $cXtTj.default).initializeCompleted()) return undefined;
        const agentId = (0, $cXtTj.default).getExperiment($19944a85f91ff832$export$183509673cddb866).get($19944a85f91ff832$var$AGENT_ID_PARAMETER, '');
        const normalizedAgentId = agentId.trim();
        return normalizedAgentId || undefined;
    } catch  {
        return undefined;
    }
}


const $b272a1ed87714e54$var$useAgentByIdResolver = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { assistanceService: assistanceService } })=>{
    const assistanceServiceRef = (0, $cozmU.useRef)(assistanceService);
    assistanceServiceRef.current = assistanceService;
    return (0, $cozmU.useCallback)((agentId)=>assistanceServiceRef.current.getAgentDetails(agentId), []);
});
function $b272a1ed87714e54$export$a966ab2407ae668d({ api: api }) {
    // The Rovo provider owns the product/site identity the assistance service needs, so read it
    // from global config rather than making this plugin's consumers pass it in.
    const { productHeader: productHeader, siteId: siteId, experienceId: experienceId } = (0, $eKjv9.useGlobalConfig)();
    const assistanceServiceParams = {
        product: productHeader,
        experienceId: experienceId,
        siteId: siteId,
        touchpointSource: 'editor-ai'
    };
    const { getAndStoreAgentByExternalConfigReference: getAndStoreAgentByExternalConfigReference } = (0, $3z1p5.usePaginatedAgentByConfigReference)({
        assistanceServiceParams: assistanceServiceParams
    });
    const getAgentById = $b272a1ed87714e54$var$useAgentByIdResolver({
        assistanceServiceParams: assistanceServiceParams
    });
    // Read through refs so the resolver stays stable however often the global config values —
    // and with them the lookup's identity — change.
    const getAgentRef = (0, $cozmU.useRef)(getAndStoreAgentByExternalConfigReference);
    getAgentRef.current = getAndStoreAgentByExternalConfigReference;
    const getAgentByIdRef = (0, $cozmU.useRef)(getAgentById);
    getAgentByIdRef.current = getAgentById;
    const siteIdRef = (0, $cozmU.useRef)(siteId);
    siteIdRef.current = siteId;
    const analyticsApiRef = (0, $cozmU.useRef)(api?.analytics?.actions);
    analyticsApiRef.current = api?.analytics?.actions;
    const resolveAgent = (0, $cozmU.useCallback)(async ({ signal: signal } = {})=>{
        const configuredAgentId = (0, $19944a85f91ff832$export$bc0c8fb7f661940a)();
        if (configuredAgentId) return getAgentByIdRef.current(configuredAgentId);
        // Provisioning is idempotent and must happen first: on a site that has never used
        // suggested edits the agent doesn't exist yet, so the lookup would come back empty. A
        // failure isn't fatal — the agent may exist from an earlier session — so report and
        // still attempt the lookup.
        try {
            await (0, $61b8b9734ab6a330$export$8f943592d88201ff)({
                cloudId: siteIdRef.current,
                signal: signal
            });
        } catch (error) {
            (0, $2a4bc64013915ea2$export$f79b8848e86580c7)(analyticsApiRef.current, error);
        }
        return getAgentRef.current({
            externalConfigReference: (0, $61b8b9734ab6a330$export$eab6f356b10dc881)
        });
    }, []);
    // Memoised so the object is as stable as the resolver it carries, and safe to use directly
    // in a caller's effect deps.
    return (0, $cozmU.useMemo)(()=>({
            resolveAgent: resolveAgent
        }), [
        resolveAgent
    ]);
}



/* AnchoredCard.tsx generated by @compiled/babel-plugin v3.0.1 */ 









var $1jz5K = parcelRequire("1jz5K");




const $9c1b84e35bed847a$var$SCROLL_MARGIN = 32;
/**
 * Fallback for the card's measured width, which must stay in sync with the `card`
 * style in `SuggestionCard.tsx`.
 *
 * `cardWidth` is read off the ref during render, so it is 0 on the first render after
 * the card mounts (the ref is only attached on commit) — and the horizontal observer
 * built from that render would use a right inset of just `SCROLL_MARGIN`, reporting
 * room on the right for any target with ≥32px to spare.
 */ const $9c1b84e35bed847a$var$CARD_WIDTH_FALLBACK = 280;
const $9c1b84e35bed847a$export$8d7a4d77df9967d4 = ({ id: id, root: root, targetStart: targetStart, targetBase: targetBase, targetEnd: targetEnd, cardRef: cardRef })=>{
    const [isTargetAboveViewport, setIsTargetAboveViewport] = (0, $cozmU.useState)(false);
    const [isTargetBelowViewport, setIsTargetBelowViewport] = (0, $cozmU.useState)(false);
    const [isCardBottomBelowViewport, setIsCardBottomBelowViewport] = (0, $cozmU.useState)(false);
    const [isTargetRightOfViewport, setIsTargetRightOfViewport] = (0, $cozmU.useState)(false);
    const [isTargetEndAboveViewport, setIsTargetEndAboveViewport] = (0, $cozmU.useState)(false);
    const [isTargetEndBelowViewport, setIsTargetEndBelowViewport] = (0, $cozmU.useState)(false);
    const [isTargetInitiallyOutsideViewport, setIsTargetInitiallyOutsideViewport] = (0, $cozmU.useState)(false);
    const [isMeasured, setIsMeasured] = (0, $cozmU.useState)(false);
    const cardHeight = cardRef.current?.offsetHeight ?? 0;
    // `|| CARD_WIDTH_FALLBACK` rather than `??` so a 0 from an unmounted (or
    // not-yet-laid-out) card also falls back instead of collapsing the inset.
    const cardWidth = cardRef.current?.offsetWidth || $9c1b84e35bed847a$var$CARD_WIDTH_FALLBACK;
    const measure = (0, $cozmU.useCallback)(()=>{
        const card = cardRef.current;
        if (!id || !root || !targetStart || !targetEnd || !targetBase || !card) return null;
        const rootRect = root.getBoundingClientRect();
        // IntersectionObserver resolves an element root against its content-clip box —
        // the padding box minus scrollbars — which is what client* describes.
        const rootTop = rootRect.top + root.clientTop;
        const rootBottom = rootTop + root.clientHeight;
        const rootRight = rootRect.left + root.clientLeft + root.clientWidth;
        const height = card.offsetHeight;
        const width = card.offsetWidth || $9c1b84e35bed847a$var$CARD_WIDTH_FALLBACK;
        const startRect = targetStart.getBoundingClientRect();
        const endRect = targetEnd.getBoundingClientRect();
        const baseRect = targetBase.getBoundingClientRect();
        // These mirror each observer's `rootMargin` below; keep the two in step.
        const targetAbove = startRect.top < rootTop + $9c1b84e35bed847a$var$SCROLL_MARGIN;
        const targetEndAbove = endRect.top < rootTop;
        const targetBelow = startRect.top > rootBottom - $9c1b84e35bed847a$var$SCROLL_MARGIN;
        const targetEndBelow = endRect.bottom > rootBottom - (height + $9c1b84e35bed847a$var$SCROLL_MARGIN + 24);
        setIsTargetAboveViewport(targetAbove);
        setIsCardBottomBelowViewport(startRect.bottom > rootBottom - (height + $9c1b84e35bed847a$var$SCROLL_MARGIN));
        setIsTargetBelowViewport(targetBelow);
        setIsTargetEndAboveViewport(targetEndAbove);
        setIsTargetEndBelowViewport(targetEndBelow);
        setIsTargetRightOfViewport(baseRect.right > rootRight - (width + $9c1b84e35bed847a$var$SCROLL_MARGIN));
        const isOutsideViewport = targetAbove && targetEndAbove || targetBelow && targetEndBelow;
        return isOutsideViewport;
    }, [
        id,
        root,
        targetStart,
        targetBase,
        targetEnd,
        cardRef
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        measure();
        const frame = requestAnimationFrame(()=>{
            const isOutsideViewport = measure();
            if (isOutsideViewport === null) return;
            setIsTargetInitiallyOutsideViewport(isOutsideViewport);
            setIsMeasured(true);
        });
        return ()=>cancelAnimationFrame(frame);
    }, [
        measure
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!id || !root || !targetStart || !targetEnd || !cardRef.current || !targetBase) {
            setIsTargetRightOfViewport(false);
            setIsTargetEndAboveViewport(false);
            setIsTargetEndBelowViewport(false);
            setIsTargetBelowViewport(false);
            setIsTargetAboveViewport(false);
            setIsCardBottomBelowViewport(false);
            setIsTargetInitiallyOutsideViewport(false);
            setIsMeasured(false);
            return;
        }
        /**
		 * A notification may only *release* `isTargetInitiallyOutsideViewport` — as soon as the
		 * target is no longer wholly out of view, because the user scrolled back or a smooth
		 * scroll landed — so that a later scroll-away gets the normal card-to-button hand-off
		 * rather than the immediate swap. Re-arming here would make the flag indistinguishable
		 * from `shouldScrollUp || shouldScrollDown`.
		 */ const notify = ()=>{
            if (measure() === false) setIsTargetInitiallyOutsideViewport(false);
        };
        const verticalCardPositionObserver = new IntersectionObserver(notify, {
            root: root,
            rootMargin: `-${$9c1b84e35bed847a$var$SCROLL_MARGIN}px 0px -${cardHeight + $9c1b84e35bed847a$var$SCROLL_MARGIN}px 0px`
        });
        const verticalTargetObserver = new IntersectionObserver(notify, {
            root: root,
            rootMargin: `${cardHeight + $9c1b84e35bed847a$var$SCROLL_MARGIN}px 0px -${$9c1b84e35bed847a$var$SCROLL_MARGIN}px 0px`
        });
        const targetEndObserver = new IntersectionObserver(notify, {
            root: root,
            // Extra 24 for the gap above card and content
            rootMargin: `0px 0px -${cardHeight + $9c1b84e35bed847a$var$SCROLL_MARGIN + 24}px 0px`
        });
        /**
		 * This observer is for determining if there's enough space on the right side to display the card.
		 * We use arbitrarily large root margins to ensure that the intersection observer detects it even
		 * when the targetBase anchor (anchored to the icon button) is off the screen.
		 *
		 * A hypotheical edge case is if a toolcall's localid position is more than 99999px further than the
		 * doc-level node's local id, but that is really unlikely.
		 */ const horizontalObserver = new IntersectionObserver(notify, {
            root: root,
            rootMargin: `99999px -${cardWidth + $9c1b84e35bed847a$var$SCROLL_MARGIN}px 99999px 0px`
        });
        verticalCardPositionObserver.observe(targetStart);
        horizontalObserver.observe(targetBase);
        targetEndObserver.observe(targetEnd);
        verticalTargetObserver.observe(targetStart);
        return ()=>{
            verticalCardPositionObserver.disconnect();
            horizontalObserver.disconnect();
            targetEndObserver.disconnect();
            verticalTargetObserver.disconnect();
        };
    }, [
        targetStart,
        targetBase,
        cardRef,
        root,
        targetEnd,
        cardHeight,
        cardWidth,
        id,
        measure
    ]);
    return {
        isTargetAboveViewport: isTargetAboveViewport,
        isTargetBelowViewport: isTargetBelowViewport,
        isCardBottomBelowViewport: isCardBottomBelowViewport,
        isTargetRightOfViewport: isTargetRightOfViewport,
        isTargetEndAboveViewport: isTargetEndAboveViewport,
        isTargetEndBelowViewport: isTargetEndBelowViewport,
        isTargetInitiallyOutsideViewport: isTargetInitiallyOutsideViewport,
        isMeasured: isMeasured
    };
};


/* ScrollBackToSuggestionButton.tsx generated by @compiled/babel-plugin v3.0.1 */ 












var $ad7Ou = parcelRequire("ad7Ou");





var $fS8Zl = parcelRequire("fS8Zl");


var $f6cdQ = parcelRequire("f6cdQ");


var $4aRua = parcelRequire("4aRua");

const $b409976b87630c23$var$styles = {
    buttonContainer: "_0bjKvDyzSk _30huDKYbGa _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M _0KLXruqi9L _2OUyjtGk8v"
};
const $b409976b87630c23$export$1f302f0e3d37f52d = ({ direction: direction, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const label = formatMessage((0, $gVCFw.aiSuggestionsMessages).cardScrollBackToSuggestionLabel);
    const ArrowIcon = (0, $cozmU.useCallback)(()=>{
        return direction === 'up' ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f6cdQ))), {
            label: "",
            size: "small"
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fS8Zl))), {
            label: "",
            size: "small"
        });
    }, [
        direction
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            $b409976b87630c23$var$styles.buttonContainer
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
            appearance: "subtle",
            iconBefore: ArrowIcon,
            onClick: onClick,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                size: "medium",
                color: "color.text.subtle",
                children: label
            })
        })
    });
};


const $b79c09504f84e6ab$var$styles = {
    targetAnchoring: "_3iDTPbvLZJ _1mT5xdWVPG _2I62gzEScs _3iC0zdNRM5",
    cardContainer: "_42Yu6B6zpv _2RljVs3MbP _1kOSYt0a1V _3Z9K0wqvoi _0qk6IKxt7V",
    preMeasurement: "_1YKVNsdnbC",
    fadeIn: "_1gBibygnQY _0nFVCGRLuw _43vdfTjwM9 _3Y6bKp38c8 _39Ohv4YbGa",
    scrollBackContainer: "_39xV02ehCh _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _1mT5xdy1CL",
    scrollBackTop: "_2fBhteo1qc _2IhTonNHnM",
    scrollBackBottom: "_2fBhte0t9Q _0Bm75GNHnM",
    scrollBackAnimation: "_1jakNnpCLV _3Y6bKpZSoF _39Ohv4YbGa",
    scrollBackAnimationQuick: "_1jakNnBMlD _3Y6bKpZSoF _39Ohv4YbGa",
    scrollBackRight: "_4ApkO208ky",
    pinnedBottomRight: "_1mT5xdy1CL _0Bm75GNHnM _4ApkO208ky",
    anchoredToTargetEnd: "_1mT5xdWVPG _4ApkO208ky",
    pinnedTop: "_1mT5xdy1CL _2IhTonNHnM",
    pinnedBottom: "_1mT5xdy1CL _0Bm75GNHnM",
    anchoredToTarget: "_1mT5xdWVPG",
    slideUp: "_1YKVNsdnbC _1VJPcaY45Z _1kOSYt0a1V _3Z9K0wqvoi _0qk6IKjwM9 _3OZqoKUoWQ",
    slideDown: "_1YKVNsdnbC _1VJPcat7Id _1kOSYt0a1V _3Z9K0wqvoi _0qk6IKjwM9 _3OZqoKUoWQ",
    hiddenForScrollBack: "_1YKVNsdnbC _1pp6NdYbGa _3Z9K0wxlqh"
};
const $b79c09504f84e6ab$var$anchorWithFallback = (name, side, fallbackName)=>fallbackName ? `anchor(${name} ${side}, anchor(${fallbackName} ${side}))` : `anchor(${name} ${side})`;
const $b79c09504f84e6ab$export$8f339c4f2834aeec = ({ anchorNames: anchorNames, cardRef: cardRef, children: children, onScrollBack: onScrollBack, targetId: targetId, view: view })=>{
    /**
   * State-backed refs, so the card mounts correctly after its anchor does. Start and end are
   * separate spans (top and bottom of the block) so we can tell when the target leaves the
   * editor viewport.
   */ const [targetStart, setTargetStart] = (0, $cozmU.useState)();
    const targetStartRef = (0, $cozmU.useCallback)((node)=>{
        setTargetStart(node);
    }, []);
    const [targetEnd, setTargetEnd] = (0, $cozmU.useState)();
    const targetEndRef = (0, $cozmU.useCallback)((node)=>{
        setTargetEnd(node);
    }, []);
    const [targetBase, setTargetBase] = (0, $cozmU.useState)();
    const targetBaseRef = (0, $cozmU.useCallback)((node)=>{
        setTargetBase(node);
    }, []);
    const [root, setRoot] = (0, $cozmU.useState)();
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!view?.dom) {
            setRoot(undefined);
            return;
        }
        const _root = (0, $1jz5K.findOverflowScrollParent)(view.dom);
        setRoot(_root || undefined);
    }, [
        view
    ]);
    const { isMeasured: isMeasured, isTargetAboveViewport: isTargetAboveViewport, isTargetBelowViewport: isTargetBelowViewport, isCardBottomBelowViewport: isCardBottomBelowViewport, isTargetRightOfViewport: isTargetRightOfViewport, isTargetEndAboveViewport: isTargetEndAboveViewport, isTargetEndBelowViewport: isTargetEndBelowViewport, isTargetInitiallyOutsideViewport: isTargetInitiallyOutsideViewport } = (0, $9c1b84e35bed847a$export$8d7a4d77df9967d4)({
        root: root,
        targetStart: targetStart,
        targetEnd: targetEnd,
        targetBase: targetBase,
        cardRef: cardRef,
        id: targetId
    });
    const shouldScrollUp = isTargetEndAboveViewport && isTargetAboveViewport;
    const shouldScrollDown = isTargetBelowViewport && isTargetEndBelowViewport; /**
                                                                               * The target was already out of view when this card was opened, so there is no
                                                                               * card-to-button hand-off to play: show the scroll-back pill at once and never paint the
                                                                               * card. When the target scrolls out of view *while* the card is open, the delayed
                                                                               * slide-away + fade-in below still runs, which is what it was designed for.
                                                                               */ 
    const shouldSkipScrollBackTransition = isTargetInitiallyOutsideViewport && (shouldScrollUp || shouldScrollDown); /**
                                                                                                                    * The fade-in is a keyframe animation, so removing its class and adding it back *restarts*
                                                                                                                    * it — the card re-animates. That is exactly what happens when the card is revealed while
                                                                                                                    * `shouldSkipScrollBackTransition` is true and it later goes false (a target that was out of
                                                                                                                    * view on select is scrolled back to), so latch it: once the card has faded in it keeps the
                                                                                                                    * class for the rest of its life, and the finished animation holds no value that could
                                                                                                                    * interfere with the slide/hidden states. A different card gets a fresh fade because the
                                                                                                                    * `key` in the consumer remounts this component.
                                                                                                                    */ 
    const [hasFadedIn, setHasFadedIn] = (0, $cozmU.useState)(false);
    if (isMeasured && !shouldSkipScrollBackTransition && !hasFadedIn) // Set during render, not in an effect: an effect would land the class one frame after
    // `preMeasurement` stops hiding the card, which paints a frame at full opacity — the very
    // flash the fade-in exists to smooth over.
    setHasFadedIn(true);
     /**
     * Mutually exclusive positioning modes, one per combination of viewport state:
     *  - `isPinnedBottomRight`     : fixed to the bottom-right of the viewport
     *  - `isAnchoredToTargetEnd`   : absolutely anchored to the end of the target
     *  - `isPinnedTop`             : fixed to the top of the viewport
     *  - `isPinnedBottom`          : fixed to the bottom of the viewport
     *  - `isAnchoredToTarget`      : absolutely anchored to the target (default)
     */ 
    const isPinnedBottomRight = isTargetRightOfViewport && isTargetEndBelowViewport;
    const isAnchoredToTargetEnd = isTargetRightOfViewport && !isTargetEndBelowViewport;
    const isPinnedTop = !isTargetRightOfViewport && isTargetAboveViewport;
    const isPinnedBottom = !isTargetRightOfViewport && !isTargetAboveViewport && (isCardBottomBelowViewport || isTargetBelowViewport);
    const isAnchoredToTarget = !isPinnedBottomRight && !isAnchoredToTargetEnd && !isPinnedTop && !isPinnedBottom;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                ref: targetEndRef,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- anchor names are per-suggestion, so these cannot be static
                    insetBlockStart: $b79c09504f84e6ab$var$anchorWithFallback(anchorNames.end, 'start', anchorNames.outerEnd),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- anchor names are per-suggestion, so these cannot be static
                    insetInlineStart: $b79c09504f84e6ab$var$anchorWithFallback(anchorNames.end, 'end', anchorNames.outerEnd)
                },
                className: (0, $hekY6.default)([
                    $b79c09504f84e6ab$var$styles.targetAnchoring
                ])
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                ref: targetStartRef,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- anchor names are per-suggestion, so these cannot be static
                    insetBlockStart: $b79c09504f84e6ab$var$anchorWithFallback(anchorNames.start, 'start', anchorNames.outerStart),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- anchor names are per-suggestion, so these cannot be static
                    insetInlineStart: $b79c09504f84e6ab$var$anchorWithFallback(anchorNames.start, 'end', anchorNames.outerStart)
                },
                className: (0, $hekY6.default)([
                    $b79c09504f84e6ab$var$styles.targetAnchoring
                ])
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                ref: targetBaseRef,
                style: {
                    positionAnchor: anchorNames.base
                },
                className: (0, $hekY6.default)([
                    $b79c09504f84e6ab$var$styles.targetAnchoring
                ])
            }),
            onScrollBack && (shouldScrollUp || shouldScrollDown) && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- this is being flagged by precommit hook incorrectly
                    ...!isTargetRightOfViewport && {
                        insetInlineStart: `anchor(${anchorNames.base} start)`
                    }
                },
                className: (0, $hekY6.default)([
                    $b79c09504f84e6ab$var$styles.cardContainer,
                    $b79c09504f84e6ab$var$styles.scrollBackContainer,
                    isTargetRightOfViewport && $b79c09504f84e6ab$var$styles.scrollBackRight,
                    shouldScrollUp ? $b79c09504f84e6ab$var$styles.scrollBackTop : $b79c09504f84e6ab$var$styles.scrollBackBottom,
                    shouldSkipScrollBackTransition ? $b79c09504f84e6ab$var$styles.scrollBackAnimationQuick : $b79c09504f84e6ab$var$styles.scrollBackAnimation
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b409976b87630c23$export$1f302f0e3d37f52d), {
                    direction: shouldScrollUp ? 'up' : 'down',
                    onClick: onScrollBack
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                style: {
                    // Modes that aren't right-constrained align the card's inline start with the icon
                    // button's inline end. The two that are use a `right` offset from their styles
                    // instead, so they must not also get an inline start.
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- this is being flagged by precommit hook incorrectly
                    ...!isTargetRightOfViewport && {
                        insetInlineStart: `anchor(${anchorNames.base} end)`
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- this is being flagged by precommit hook incorrectly
                    ...isAnchoredToTarget && {
                        insetBlockStart: $b79c09504f84e6ab$var$anchorWithFallback(anchorNames.start, 'start', anchorNames.outerStart)
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- this is being flagged by precommit hook incorrectly
                    ...isAnchoredToTargetEnd && {
                        insetBlockStart: `calc(${$b79c09504f84e6ab$var$anchorWithFallback(anchorNames.end, 'start', anchorNames.outerEnd)} + ${"var(--ds-space-300, 24px)"})`
                    }
                },
                className: (0, $hekY6.default)([
                    $b79c09504f84e6ab$var$styles.cardContainer,
                    hasFadedIn && $b79c09504f84e6ab$var$styles.fadeIn,
                    isPinnedBottomRight && $b79c09504f84e6ab$var$styles.pinnedBottomRight,
                    isAnchoredToTargetEnd && $b79c09504f84e6ab$var$styles.anchoredToTargetEnd,
                    isPinnedTop && $b79c09504f84e6ab$var$styles.pinnedTop,
                    isPinnedBottom && $b79c09504f84e6ab$var$styles.pinnedBottom,
                    isAnchoredToTarget && $b79c09504f84e6ab$var$styles.anchoredToTarget,
                    !isMeasured && $b79c09504f84e6ab$var$styles.preMeasurement,
                    shouldScrollUp && !shouldSkipScrollBackTransition && $b79c09504f84e6ab$var$styles.slideUp,
                    shouldScrollDown && !shouldSkipScrollBackTransition && $b79c09504f84e6ab$var$styles.slideDown,
                    shouldSkipScrollBackTransition && $b79c09504f84e6ab$var$styles.hiddenForScrollBack
                ]),
                children: children
            })
        ]
    });
};


/* FollowUpCard.tsx generated by @compiled/babel-plugin v3.0.1 */ 


















var $4u3xL = parcelRequire("4u3xL");


var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");




var $6gGPb = parcelRequire("6gGPb");

const $0c747e6c17d2a0bd$var$styles = {
    card: "_0bjKvDyzSk _2mHwu85zaO _1mT5xdRAKS _0KLXrulfZc _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE _2OUyjtGk8v _39xV02ehCh _3iDTPbQ4SZ _0aFT5vbt8w _24h04i2Njc"
}; /**
    * Shown in place of the suggestion card once the last suggestion has been removed, offering to
    * generate suggestions for the rest of the page.
    */ 
const $0c747e6c17d2a0bd$export$1eaf41494299ca89 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(function FollowUpCard({ agent: agent, onDismiss: onDismiss, onReview: onReview }, ref) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
        ref: ref,
        "data-testid": 'ai-suggestion-follow-up-card',
        className: (0, $hekY6.default)([
            $0c747e6c17d2a0bd$var$styles.card
        ]),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                space: "space.200",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                        space: "space.050",
                        alignBlock: "center",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6gGPb.AgentAvatar), {
                                agentId: agent?.id,
                                agentNamedId: agent?.external_config_reference ?? agent?.named_id,
                                agentIdentityAccountId: agent?.identity_account_id,
                                size: "small",
                                label: agent?.name ?? '',
                                showBorder: false
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                size: "large",
                                weight: "medium",
                                children: formatMessage((0, $gVCFw.aiSuggestionsMessages).followUpCardTitle)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        as: "p",
                        color: "color.text",
                        children: formatMessage((0, $gVCFw.aiSuggestionsMessages).followUpCardDescription)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                space: "space.050",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($4u3xL))),
                        onClick: onReview,
                        children: formatMessage((0, $gVCFw.aiSuggestionsMessages).followUpCardReviewButtonLabel)
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                        appearance: "subtle",
                        onClick: onDismiss,
                        children: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardDismissButtonLabel)
                    })
                ]
            })
        ]
    });
});


const $a07fe340660de233$export$b37784161dbefc65 = ({ api: api, view: view })=>{
    const cardRef = (0, $cozmU.useRef)(null);
    const { followUpCard: followUpCard, isHidden: isHidden } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiSuggestions',
        'editorViewMode'
    ], (state)=>({
            followUpCard: state?.aiSuggestionsState?.followUpCard,
            // View mode is a hard override: never show the suggestions UI while read-only.
            isHidden: (state?.aiSuggestionsState?.isHidden ?? false) || state?.editorViewModeState?.mode === 'view'
        })); // Resolved only while the card is on screen, so nothing is provisioned or fetched for a card
    // that isn't shown. Until it lands the card falls back to the Rovo mark. The agent store
    // caches the lookup, so re-opening doesn't refetch.
    const [agent, setAgent] = (0, $cozmU.useState)();
    const { resolveAgent: resolveAgent } = (0, $b272a1ed87714e54$export$a966ab2407ae668d)({
        api: api
    });
    const isCardShown = Boolean(followUpCard) && !isHidden;
    (0, $cozmU.useEffect)(()=>{
        if (!isCardShown || agent || !(0, $iDrrr.fg)('content_reviewer_agent')) return;
        let isActive = true;
        const abortController = new AbortController();
        resolveAgent({
            signal: abortController.signal
        }).then((resolved)=>{
            if (isActive && resolved) setAgent(resolved);
        });
        return ()=>{
            isActive = false;
            abortController.abort();
        };
    }, [
        agent,
        isCardShown,
        resolveAgent
    ]);
    const onDismiss = (0, $cozmU.useCallback)(()=>{
        api?.core?.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $1b159f40bd8b3a1f$export$dbbefe45c19011aa), {
                action: 'DISMISS_FOLLOW_UP_CARD'
            });
            return tr;
        });
    }, [
        api
    ]);
    const onReview = (0, $cozmU.useCallback)(()=>{
        api?.aiSuggestions?.actions.setThinkingState('thinking', {
            entryPoint: 'followUpCard'
        }); // The thinking bar takes over from here.
        onDismiss();
    }, [
        api,
        onDismiss
    ]);
    if (!followUpCard || isHidden) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b79c09504f84e6ab$export$8f339c4f2834aeec // Remounts per suggestion, so a card replacing another one fades in rather than
    ), {
        anchorNames: (0, $56b1bb8689d88b40$export$c88671e3a419bb99),
        cardRef: cardRef,
        targetId: followUpCard.suggestionId,
        view: view,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $0c747e6c17d2a0bd$export$1eaf41494299ca89), {
            agent: agent,
            ref: cardRef,
            onDismiss: onDismiss,
            onReview: onReview
        })
    }, followUpCard.suggestionId);
};





parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");

/**
 * Per-node-type hover highlight styles for the suggestion icon hover, mirroring
 * how the block controls "remix" selection treats container, extension and rule
 * nodes. Default text blocks and cards keep the inline box-shadow highlight set
 * directly on their decoration, so they aren't styled here.
 *
 * The class selectors below are inlined as string literals (rather than imported
 * from `hoverHighlightClassNames`) because the ui-styling-standard rules disallow
 * dynamic/imported object-style keys. Keep them in sync with
 * `hoverHighlightClassNames` in `../../pm-plugins/hoverHighlightDecorations`.
 */ const $997801478ebdd729$var$hoverHighlightStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // Container nodes (panel, codeBlock, expand, layoutSection): a translucent blue
    // blanket overlay on top of the content + a subtle ring, instead of a
    // box-shadow that would look wrong on full-bleed nodes.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror .ai-suggestions-hover-overlay': {
        position: 'relative',
        boxShadow: `0 0 0 ${"var(--ds-border-width, 1px)"} ${"var(--ds-border-focused, #4688EC)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror .ai-suggestions-hover-overlay::before': {
        content: '""',
        position: 'absolute',
        inset: 0,
        zIndex: 1,
        pointerEvents: 'none',
        backgroundColor: "var(--ds-blanket-selected, #388BFF14)"
    },
    // Tables: draw a uniform 1px blue border + translucent blue background on every
    // cell via the cell's ::after overlay, mirroring how "remix" highlights a
    // selected table. The -1px offsets (matching the editor's own selected-cell
    // overlay) make the border sit on top of the collapsed shared borders so both
    // horizontal and vertical lines render, and header cells get the same uniform
    // border.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror .ai-suggestions-hover-table td, .ProseMirror .ai-suggestions-hover-table th': {
        position: 'relative'
    },
    // !important overrides the table plugin's own base cell ::after, which has
    // higher selector specificity and uses width/height: 100% with no offsets.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror .ai-suggestions-hover-table td::after, .ProseMirror .ai-suggestions-hover-table th::after': {
        content: '""',
        position: 'absolute',
        pointerEvents: 'none',
        zIndex: 2,
        /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ top: '-1px !important',
        right: '-1px !important',
        bottom: '-1px !important',
        left: '-1px !important',
        width: 'auto !important',
        height: 'auto !important',
        border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-focused, #4688EC)"} !important`,
        backgroundColor: `${"var(--ds-blanket-selected, #388BFF14)"} !important`
    },
    // Extensions: highlight the inner container rather than the wrapper.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror .ai-suggestions-hover-extension .extension-container': {
        boxShadow: `0 0 0 ${"var(--ds-border-width, 1px)"} ${"var(--ds-border-focused, #4688EC)"}`
    },
    // Rule: fill the line so the thin node is visibly highlighted.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror .ai-suggestions-hover-rule': {
        backgroundColor: "var(--ds-border-focused, #4688EC)"
    }
});
const $997801478ebdd729$export$a1fd8428be46e11c = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $lOiVq.Global), {
        styles: $997801478ebdd729$var$hoverHighlightStyles
    });


/* SuggestionCardContentComponent.tsx generated by @compiled/babel-plugin v3.0.1 */ 













const $e40b4e35496d16c5$export$4cbf498e35d8c873 = (suggestion, isRegenerating)=>{
    const id = suggestion?.id;
    const isStale = suggestion?.status === 'STALE';
    const [tracking, setTracking] = (0, $cozmU.useState)({
        id: id,
        isRegenerating: isRegenerating,
        isJustUpdated: false
    });
    const isSameSuggestion = tracking.id === id;
    const justFinishedRegenerating = isSameSuggestion && tracking.isRegenerating && !isRegenerating;
    const isJustUpdated = justFinishedRegenerating ? !isStale : isSameSuggestion && tracking.isJustUpdated;
    if (tracking.id !== id || tracking.isRegenerating !== isRegenerating || tracking.isJustUpdated !== isJustUpdated) setTracking({
        id: id,
        isRegenerating: isRegenerating,
        isJustUpdated: isJustUpdated
    });
    if (isRegenerating) return 'regenerating';
    if (isJustUpdated) return 'updated';
    if (isStale) return 'stale';
    return undefined;
};





const $3ff3f4249608fe22$var$selectSelectedSuggestion = (state)=>{
    const { selectedSuggestion: selectedId, suggestionById: suggestionById } = state ?? {};
    return selectedId !== undefined && suggestionById !== undefined ? suggestionById.get(selectedId) : undefined;
};
const $3ff3f4249608fe22$var$selectBaseLocalId = (state)=>{
    const { selectedSuggestion: selectedId, baseLocalIdBySuggestionId: baseLocalIdBySuggestionId } = state ?? {};
    return baseLocalIdBySuggestionId && selectedId ? baseLocalIdBySuggestionId.get(selectedId) : undefined;
};
const $3ff3f4249608fe22$export$12e742fdeff6e7ba = (api)=>{
    const [selectedSuggestion, setSelectedSuggestion] = (0, $cozmU.useState)(()=>$3ff3f4249608fe22$var$selectSelectedSuggestion(api?.aiSuggestions?.sharedState.currentState()));
    const [baseLocalId, setBaseLocalId] = (0, $cozmU.useState)(()=>$3ff3f4249608fe22$var$selectBaseLocalId(api?.aiSuggestions?.sharedState.currentState()));
    (0, $cozmU.useEffect)(()=>{
        const aiSuggestions = api?.aiSuggestions;
        if (!aiSuggestions) return;
        // Re-read once at subscription time so we don't miss a transaction that fired between
        // the initial render and the effect commit.
        const initial = aiSuggestions.sharedState.currentState();
        setSelectedSuggestion($3ff3f4249608fe22$var$selectSelectedSuggestion(initial));
        setBaseLocalId($3ff3f4249608fe22$var$selectBaseLocalId(initial));
        return aiSuggestions.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            setSelectedSuggestion($3ff3f4249608fe22$var$selectSelectedSuggestion(nextSharedState));
            setBaseLocalId($3ff3f4249608fe22$var$selectBaseLocalId(nextSharedState));
        });
    }, [
        api
    ]);
    return {
        selectedSuggestion: selectedSuggestion,
        baseLocalId: baseLocalId
    };
};






/* StatusBanner.tsx generated by @compiled/babel-plugin v3.0.1 */ 





parcelRequire("cozmU");








var $fxbF1 = parcelRequire("fxbF1");


var $iZMIZ = parcelRequire("iZMIZ");





var $lfoFx = parcelRequire("lfoFx");

const $59fa28a6d850aa68$var$styles = {
    banner: "_0bjKvDKTcp _2sNsIg7NXe _24h04i2Njc _39xV02N91d _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _0KLXrunmFW _1UtDYzZpcK",
    bannerSuccess: "_0KLXruzaZe _1UtDYzGL5O"
};
function $59fa28a6d850aa68$var$getBannerContent(status) {
    return ({
        regenerating: {
            icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
                size: "xsmall"
            }),
            label: (0, $gVCFw.aiSuggestionsMessages).cardRegeneratingBannerLabel
        },
        updated: {
            icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iZMIZ))), {
                label: "",
                size: "small",
                color: "var(--ds-icon-success, #6A9A23)"
            }),
            label: (0, $gVCFw.aiSuggestionsMessages).cardUpdatedBannerLabel
        },
        stale: {
            icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fxbF1))), {
                label: "",
                size: "small",
                color: "var(--ds-icon-subtle, #505258)"
            }),
            label: (0, $gVCFw.aiSuggestionsMessages).cardStaleBannerLabel
        }
    })[status];
} /**
   * Status banner shown at the top of a suggestion card body — while the
   * suggestion is being regenerated, once it's confirmed updated, or when it's
   * out of date (stale).
   */ 
const $59fa28a6d850aa68$export$fcf9195d8c4d40ff = ({ status: status })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { icon: icon, label: label } = $59fa28a6d850aa68$var$getBannerContent(status);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            $59fa28a6d850aa68$var$styles.banner,
            status === 'updated' && $59fa28a6d850aa68$var$styles.bannerSuccess
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
            space: "space.075",
            alignBlock: "center",
            children: [
                icon,
                formatMessage(label)
            ]
        })
    });
};


/* SuggestionCard.tsx generated by @compiled/babel-plugin v3.0.1 */ 


















var $3vgx3 = parcelRequire("3vgx3");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");





var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $j6vyT = parcelRequire("j6vyT");


var $l3wuH = parcelRequire("l3wuH");


var $a79Sy = parcelRequire("a79Sy");


var $bsSbN = parcelRequire("bsSbN");





var $4efpo = parcelRequire("4efpo");


var $aCJyI = parcelRequire("aCJyI");


var $gDx2k = parcelRequire("gDx2k");


var $6TaGl = parcelRequire("6TaGl");


var $93fnf = parcelRequire("93fnf");


var $c8bBH = parcelRequire("c8bBH");


var $4ez2K = parcelRequire("4ez2K");



var $hBYtq = parcelRequire("hBYtq");






var $lpNn5 = parcelRequire("lpNn5");

/* SuggestionAgentIdentity.tsx generated by @compiled/babel-plugin v3.0.1 */ 





parcelRequire("cozmU");





var $arQY7 = parcelRequire("arQY7");





var $bUd6P = parcelRequire("bUd6P");







const $bec308cf666f8943$var$styles = {
    row: "_3iDTPbQ4SZ _0hPCNLDIqT _0jFU0VNHnM _2YgrGrP0S5",
    agentAvatar: "_3iDTPbccYA _3YEZNOdnbC _1mT5xdRAKS _42Yu6BiZR3",
    rovoAvatar: "_0hPCNLDIqT _3iDTPbQ4SZ _0jFU0VNHnM _37wbyuDIqT _1mT5xdRAKS _39xV02NHnM",
    rovoAvatarBorder: "_49OCfRnBff _1mT5xdWVPG _42Yu6BdnbC _0KLXrulfZc",
    rovoAvatarContent: "_3iDTPbccYA _1mT5xdRAKS _42Yu6B7dHp",
    agentAvatarOverlapping: "_2xTnZxQPN6",
    userAvatar: "_3iDTPbccYA _1mT5xdRAKS _42Yu6B7dHp"
};
/** Renders the compact Rovo identity used when no agent avatar is available. */ function $bec308cf666f8943$var$RovoIdentity() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bUd6P.RovoHexIcon), {
        label: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardRovoAuthorLabel),
        size: "small"
    });
}
function $bec308cf666f8943$var$AuthorsTooltip({ agentName: agentName, children: children, userName: userName }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
        content: userName ? formatMessage((0, $gVCFw.aiSuggestionsMessages).cardAuthorsTooltipLabel, {
            agentName: agentName,
            userName: userName
        }) : agentName,
        ignoreTooltipPointerEvents: true,
        position: "bottom",
        children: children
    });
} /** Renders the agent and user identities associated with a suggestion. */ 
function $bec308cf666f8943$export$17e466db07db7ac6({ agent: agent, user: user }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const agentName = agent?.name?.trim();
    const userName = user?.name?.trim();
    const validAgent = agent?.accountId && agentName ? {
        name: agentName,
        picture: agent.picture?.trim() || undefined
    } : undefined;
    const validUser = user?.accountId && userName ? {
        name: userName,
        picture: user.picture?.trim() || undefined
    } : undefined;
    const authorAvatars = /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
        className: (0, $hekY6.default)([
            $bec308cf666f8943$var$styles.row
        ]),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                className: (0, $hekY6.default)([
                    $bec308cf666f8943$var$styles.agentAvatar,
                    validUser && $bec308cf666f8943$var$styles.agentAvatarOverlapping
                ]),
                children: validAgent ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
                    appearance: "hexagon",
                    label: validAgent.name,
                    name: validAgent.name,
                    size: "small",
                    src: validAgent.picture
                }) : /*#__PURE__*/ (0, $8aG6j.jsxs)("span", {
                    className: (0, $hekY6.default)([
                        $bec308cf666f8943$var$styles.rovoAvatar
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                            "aria-hidden": true,
                            style: {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop
                                clipPath: (0, $6gGPb.AGENT_AVATAR_CLIP_PATH)
                            },
                            className: (0, $hekY6.default)([
                                $bec308cf666f8943$var$styles.rovoAvatarBorder
                            ])
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                            className: (0, $hekY6.default)([
                                $bec308cf666f8943$var$styles.rovoAvatarContent
                            ]),
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)($bec308cf666f8943$var$RovoIdentity, {})
                        })
                    ]
                })
            }),
            validUser && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                className: (0, $hekY6.default)([
                    $bec308cf666f8943$var$styles.userAvatar
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
                    label: validUser.name,
                    name: validUser.name,
                    size: "small",
                    src: validUser.picture
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)($bec308cf666f8943$var$AuthorsTooltip, {
        agentName: validAgent?.name ?? formatMessage((0, $gVCFw.aiSuggestionsMessages).cardRovoAuthorLabel),
        userName: validUser?.name,
        children: authorAvatars
    });
}


/* SuggestionCardSources.tsx generated by @compiled/babel-plugin v3.0.1 */ 









var $9EOlJ = parcelRequire("9EOlJ");








var $aZ9If = parcelRequire("aZ9If");







var $a9aSv = parcelRequire("a9aSv");


var $l8wPz = parcelRequire("l8wPz");


var $4yYAm = parcelRequire("4yYAm");


var $jdA6O = parcelRequire("jdA6O");

const $cd2ba89ca6eab913$var$cardUiOptions = {
    clickableContainer: true,
    hideBackground: true,
    hideElevation: true,
    hidePadding: true,
    size: (0, $4yYAm.SmartLinkSize).Medium,
    theme: (0, $4yYAm.SmartLinkTheme).Black
};
const $cd2ba89ca6eab913$var$styles = {
    sourcesContainer: "_4bt5LAYvD1 _2WAcuGYvD1 _2mHwu82ADO _39xV02N91d _4ouGXIdnbC _3iDTPbQ4SZ _0aFT5vbt8w",
    sourceLabel: "_1Znuxb8HPE _2Zuz6Q8HPE",
    sourceCard: "_4bt5LAYvD1 _2WAcuGYvD1 _1mT5xdRAKS _39xV02N91d _24h04i2Njc _4ouGXIdnbC _4kiQYAkG2W _1Znuxb8HPE _2Zuz6Q8HPE",
    cardLoading: "_0fKRyPnQyn",
    skeletonOverlay: "_49OCfRPgdg _1mT5xdWVPG _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _1pp6NdYbGa"
};
// without an ancestor <SmartCardProvider> (e.g. outside the editor), where the smart
// Card throws. Hoisted so the reference is stable across renders.
const $cd2ba89ca6eab913$var$renderNoSources = ()=>null; /** Skeleton stand-in for the card's title and footer while the URL resolves. */ 
function $cd2ba89ca6eab913$var$SourceSkeleton() {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "aria-hidden": true,
        className: (0, $hekY6.default)([
            $cd2ba89ca6eab913$var$styles.skeletonOverlay
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
            width: "65%",
            height: 12,
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        })
    });
}
function $cd2ba89ca6eab913$var$SourceCard({ url: url }) {
    const [status, setStatus] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState('loading');
    const handleResolve = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>setStatus('resolved'), []);
    const handleError = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>setStatus('errored'), []);
    if (status === 'errored') return null;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                className: (0, $hekY6.default)([
                    status === 'loading' && $cd2ba89ca6eab913$var$styles.cardLoading
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $l8wPz.Card), {
                    appearance: "inline",
                    ui: $cd2ba89ca6eab913$var$cardUiOptions,
                    url: url,
                    onResolve: handleResolve,
                    onError: handleError,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jdA6O.TitleBlock), {
                        maxLines: 1
                    })
                })
            }),
            status === 'loading' && /*#__PURE__*/ (0, $8aG6j.jsx)($cd2ba89ca6eab913$var$SourceSkeleton, {})
        ]
    });
}
function $cd2ba89ca6eab913$var$SuggestionCardSourcesInner({ sources: sources }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)(); // The backend supplies the URL, so a source without one can't be linked to and is
    // dropped — even when it has an ARI. De-duplicated so the same URL sent twice doesn't
    // render two identical cards.
    const urls = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        const unique = new Set();
        for (const { url: url } of sources)if (url) unique.add(url);
        return Array.from(unique);
    }, [
        sources
    ]);
    if (urls.length === 0) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
        className: (0, $hekY6.default)([
            $cd2ba89ca6eab913$var$styles.sourcesContainer
        ]),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                xcss: $cd2ba89ca6eab913$var$styles.sourceLabel,
                space: "space.100",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aZ9If))), {
                        label: "",
                        size: "medium",
                        color: "var(--ds-icon-subtle, #505258)"
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        as: "span",
                        color: "color.text.subtle",
                        size: "medium",
                        weight: "medium",
                        children: formatMessage((0, $gVCFw.aiSuggestionsMessages).teamworkGraphLabel)
                    })
                ]
            }),
            urls.map((url)=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                    className: (0, $hekY6.default)([
                        $cd2ba89ca6eab913$var$styles.sourceCard
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)($cd2ba89ca6eab913$var$SourceCard, {
                        url: url
                    })
                }, url))
        ]
    });
} /** Displays the resolvable sources associated with a suggestion. */ 
function $cd2ba89ca6eab913$export$bedb00e2a4ac3f71({ sources: sources }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9EOlJ.ErrorBoundary), {
        fallbackRender: $cd2ba89ca6eab913$var$renderNoSources,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($cd2ba89ca6eab913$var$SuggestionCardSourcesInner, {
            sources: sources
        })
    });
}












var $8EgKx = parcelRequire("8EgKx");


var $ivSJV = parcelRequire("ivSJV");




const $fc031696110d746a$export$387983f036737d8 = 'ai-suggestion-source-app-stack';
/**
 * Caps how many logos are shown. The design shows two; a third leaves room for a genuinely
 * multi-app suggestion without the stack crowding the Details row it shares with the
 * Restricted lozenge.
 */ const $fc031696110d746a$var$MAX_VISIBLE_APPS = 3;
const $fc031696110d746a$export$10542f0e75dbe131 = (sources)=>{
    const apps = [];
    const seen = new Set();
    for (const { url: url } of sources ?? []){
        if (!url) continue;
        const sourceType = (0, $ivSJV.getSourceType)(url);
        if (sourceType === 'unknown' || seen.has(sourceType)) continue;
        seen.add(sourceType);
        apps.push({
            // `source-util` types its logos as `ElementType<LogoProps>`; `AppStackItemProps` is a
            // subset of `LogoProps`, so the props `AppStack` passes are all accepted.
            component: (0, $ivSJV.getLogoForSourceType)(sourceType),
            key: sourceType
        });
    }
    return apps;
};
function $fc031696110d746a$export$38ea68c086fb8e7d({ sources: sources }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    // No `label` per item: the ADS product logos supply their own accessible names, which are
    // better than the internal source-type keys we'd otherwise pass.
    const data = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>$fc031696110d746a$export$10542f0e75dbe131(sources).map(({ component: component })=>({
                component: component
            })), [
        sources
    ]);
    if (data.length === 0) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8EgKx.default), {
        data: data,
        // `xsmall` is the design's 20px tile, and gives the -4px overlap it shows.
        size: "xsmall",
        maxCount: $fc031696110d746a$var$MAX_VISIBLE_APPS,
        label: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardSourceAppsLabel),
        testId: $fc031696110d746a$export$387983f036737d8
    });
}


const $1bd78593134dbc9f$export$302061637fb228b9 = 'ai-suggestion-card';
const $1bd78593134dbc9f$var$tooltipAbove = {
    position: 'top'
};
// Shimmer applied to the description while the suggestion is regenerating.
// Copied from rovo-platform-ui-components' ShimmerText so we don't couple to it.
const $1bd78593134dbc9f$var$shimmerAnimation = null;
const $1bd78593134dbc9f$var$shimmerGradient = null;
const $1bd78593134dbc9f$var$styles = {
    sourceButton: "_2mHwu8gVvo _3iDTPbQ4SZ _0KLXrujOvk _0hPCNLDIqT _1ZnuxbPgdg _2Zuz6QPgdg _1UtDYzZpcK _24bGaTot27",
    detailsContainer: "_0bjKvD8fU6 _4c065U8HPE _39xV02N91d _0KLXrumhAQ _3CkH9oUkuA _3OqcjTLvrC _1DJ2rV9GZ1",
    reasoningContent: "_1Znuxb8HPE _2Zuz6Q8HPE",
    card: "_0bjKvDyzSk _2mHwu85zaO _3vBAKHxCOs _3hxITi6wH8 _2V7sgOmVJw _1mT5xdRAKS _0KLXruwawV _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _2OUyjtGk8v _39xV02ehCh _3iDTPbQ4SZ _0aFT5vbt8w _24h04i2Njc",
    privateMetadata: "_3YEZNOdnbC _3iDTPbQ4SZ _0hPCNLDIqT",
    restrictedMetadata: "_4bt5LAnQyn _2WAcuGnQyn _0hPCNLDIqT _0wOv4Q18ZR _3iDTPbQ4SZ",
    restrictedContent: "_0hPCNLDIqT _17lj8pPgdg _3iDTPbkfkE _2iEGP2emYi _2xTnZxt7Uv _0GTcwRt7Uv _3Z9K0wLrT7 _1kOSYtLM0u _0qk6IKxt7V _1RrJLit2nV",
    restrictedContentExpanded: "_17lj8p1Y8M _2iEGP2cMcx _2xTnZxPgdg _0GTcwRPgdg",
    restrictedLabel: "_4bt5LAnQyn _2WAcuGnQyn _4ouGXIPgdg _1YKVNsdnbC _3Z9K0wLrT7 _1kOSYt9v2r _0qk6IKjwM9 _1ANEUSLRg7",
    restrictedLabelExpanded: "_1YKVNs7dHp",
    reasoningHeader: "_39xV02N91d"
};
const $1bd78593134dbc9f$export$5864b77b647e728c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(function SuggestionCard({ banner: banner, onAccept: onAccept, onDiscard: onDiscard, onDismiss: onDismiss, onGoodSuggestion: onGoodSuggestion, onBadSuggestion: onBadSuggestion, onNavigate: onNavigate, onReasoningViewed: onReasoningViewed, onClose: onClose, onShowSidebar: onShowSidebar, onToggleDeletedDiffs: onToggleDeletedDiffs, isHidingDeletedDiffs: isHidingDeletedDiffs, isRegenerating: isRegenerating = false, showComparisonButton: showComparisonButton = false, suggestion: suggestion }, ref) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isSourcesExpanded, setIsSourcesExpanded] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const [isRestrictedHovered, setIsRestrictedHovered] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const handleSourcesToggle = (0, $cozmU.useCallback)(()=>{
        if (!isSourcesExpanded) onReasoningViewed?.();
        setIsSourcesExpanded((previous)=>!previous);
    }, [
        isSourcesExpanded,
        onReasoningViewed
    ]);
    const renderMoreOptionsTrigger = (0, $cozmU.useCallback)(({ triggerRef: triggerRef, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, onClick: onClick, isSelected: isSelected })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
            ref: triggerRef,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHasPopup,
            isDisabled: isRegenerating,
            isSelected: isSelected,
            onClick: onClick,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
            label: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardMoreOptionsButtonLabel),
            isTooltipDisabled: false,
            tooltip: $1bd78593134dbc9f$var$tooltipAbove,
            appearance: "subtle",
            spacing: "default"
        }), [
        formatMessage,
        isRegenerating
    ]); // `IconButton` already renders its `label` as both the accessible name and the
    // tooltip, so these icons are decorative.
    const ChevronUpSmall = (0, $cozmU.useCallback)(()=>{
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
            label: "",
            size: "small"
        });
    }, []);
    const ChevronDownSmall = (0, $cozmU.useCallback)(()=>{
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: "",
            size: "small"
        });
    }, []);
    const isInsight = suggestion.actionKind === 'INFORMATIONAL'; // An out-of-date suggestion can no longer be safely applied — only discard.
    const isStale = suggestion.status === 'STALE'; // The restricted lozenge warns that the suggestion's sources aren't visible to
    // every editor, so it's only meaningful when the suggestion has sources.
    const hasSources = !!suggestion.sources?.length;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
        ref: ref,
        "data-testid": $1bd78593134dbc9f$export$302061637fb228b9,
        "data-suggestion-id": suggestion.id,
        className: (0, $hekY6.default)([
            $1bd78593134dbc9f$var$styles.card
        ]),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                        space: "space.0",
                        alignBlock: "center",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                                icon: ChevronUpSmall,
                                label: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardPreviousSuggestionButtonLabel),
                                isTooltipDisabled: false,
                                tooltip: $1bd78593134dbc9f$var$tooltipAbove,
                                appearance: "subtle",
                                spacing: "compact",
                                isDisabled: !onNavigate,
                                onClick: onNavigate ? ()=>onNavigate('up') : undefined
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                                icon: ChevronDownSmall,
                                label: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardNextSuggestionButtonLabel),
                                isTooltipDisabled: false,
                                tooltip: $1bd78593134dbc9f$var$tooltipAbove,
                                appearance: "subtle",
                                spacing: "compact",
                                isDisabled: !onNavigate,
                                onClick: onNavigate ? ()=>onNavigate('down') : undefined
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                        space: "space.050",
                        alignBlock: "center",
                        children: [
                            onShowSidebar && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($gDx2k))),
                                label: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardShowSidebarButtonLabel),
                                isTooltipDisabled: false,
                                tooltip: $1bd78593134dbc9f$var$tooltipAbove,
                                appearance: "subtle",
                                spacing: "compact",
                                onClick: onShowSidebar
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
                                label: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardCloseButtonLabel),
                                isTooltipDisabled: false,
                                tooltip: $1bd78593134dbc9f$var$tooltipAbove,
                                appearance: "subtle",
                                spacing: "compact",
                                onClick: onClose
                            })
                        ]
                    })
                ]
            }),
            banner,
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                space: "space.100",
                children: [
                    isRegenerating ? /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                        className: (0, $hekY6.default)([
                            "_2uo31fSyNX _2fBhteSSZw _3OqcjTzGaF _02U3A5JxkL _1CY1NjjOvk _07XDTDJxkL"
                        ]),
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                            as: "p",
                            size: "medium",
                            weight: "medium",
                            color: isRegenerating ? 'color.text.disabled' : 'color.text.subtlest',
                            children: suggestion.description
                        })
                    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        as: "p",
                        size: "medium",
                        weight: "medium",
                        color: "color.text",
                        children: suggestion.description
                    }),
                    suggestion.reasoning && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
                        alignItems: "start",
                        direction: "column",
                        gap: "space.100",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
                                alignItems: "center",
                                justifyContent: "space-between",
                                xcss: $1bd78593134dbc9f$var$styles.reasoningHeader,
                                children: [
                                    /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hBYtq.Pressable), {
                                        xcss: $1bd78593134dbc9f$var$styles.sourceButton,
                                        onClick: handleSourcesToggle,
                                        isDisabled: isRegenerating,
                                        "aria-expanded": isSourcesExpanded,
                                        children: [
                                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                                size: "medium",
                                                weight: "medium",
                                                color: "inherit",
                                                children: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardDetailsButtonLabel)
                                            }),
                                            isSourcesExpanded ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                                                label: "",
                                                size: "small"
                                            }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                                                label: "",
                                                size: "small"
                                            })
                                        ]
                                    }),
                                    hasSources && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                                        space: "space.050",
                                        alignBlock: "center",
                                        children: [
                                            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                                                className: (0, $hekY6.default)([
                                                    $1bd78593134dbc9f$var$styles.privateMetadata
                                                ]),
                                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                                                    position: "top",
                                                    content: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardRestrictedTooltipLabel),
                                                    ignoreTooltipPointerEvents: true,
                                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                                                        "data-testid": "ai-suggestion-card-restricted",
                                                        onMouseEnter: ()=>setIsRestrictedHovered(true),
                                                        onMouseLeave: ()=>setIsRestrictedHovered(false),
                                                        onFocus: ()=>setIsRestrictedHovered(true),
                                                        onBlur: ()=>setIsRestrictedHovered(false),
                                                        className: (0, $hekY6.default)([
                                                            $1bd78593134dbc9f$var$styles.restrictedMetadata
                                                        ]),
                                                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aCJyI.default), {
                                                            appearance: "neutral",
                                                            children: /*#__PURE__*/ (0, $8aG6j.jsxs)("span", {
                                                                className: (0, $hekY6.default)([
                                                                    $1bd78593134dbc9f$var$styles.restrictedContent,
                                                                    isRestrictedHovered && $1bd78593134dbc9f$var$styles.restrictedContentExpanded
                                                                ]),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4efpo))), {
                                                                        label: "",
                                                                        size: "small",
                                                                        color: "var(--ds-icon-subtle, #505258)"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                                                                        className: (0, $hekY6.default)([
                                                                            $1bd78593134dbc9f$var$styles.restrictedLabel,
                                                                            isRestrictedHovered && $1bd78593134dbc9f$var$styles.restrictedLabelExpanded
                                                                        ]),
                                                                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                                                            as: "span",
                                                                            color: "inherit",
                                                                            size: "small",
                                                                            children: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardRestrictedLabel)
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fc031696110d746a$export$38ea68c086fb8e7d), {
                                                sources: suggestion.sources
                                            })
                                        ]
                                    })
                                ]
                            }),
                            isSourcesExpanded && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                                xcss: $1bd78593134dbc9f$var$styles.detailsContainer,
                                space: "space.250",
                                testId: "ai-suggestion-card-details",
                                children: [
                                    /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                                        className: (0, $hekY6.default)([
                                            $1bd78593134dbc9f$var$styles.reasoningContent
                                        ]),
                                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                            as: "p",
                                            color: "color.text",
                                            children: suggestion.reasoning
                                        })
                                    }),
                                    !!suggestion?.sources?.length && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cd2ba89ca6eab913$export$bedb00e2a4ac3f71), {
                                        sources: suggestion.sources
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
                alignItems: "center",
                justifyContent: "space-between",
                gap: "space.100",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bec308cf666f8943$export$17e466db07db7ac6), {
                        agent: suggestion.createdByAgent,
                        user: suggestion.createdByUser
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                        space: "space.050",
                        alignBlock: "center",
                        children: [
                            !isInsight && (onToggleDeletedDiffs || onGoodSuggestion || onBadSuggestion) && (showComparisonButton && onToggleDeletedDiffs ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                                space: "space.050",
                                alignBlock: "center",
                                children: [
                                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                                        icon: isHidingDeletedDiffs ? (0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))) : (0, (/*@__PURE__*/$parcel$interopDefault($a79Sy))),
                                        label: formatMessage(isHidingDeletedDiffs ? (0, $gVCFw.aiSuggestionsMessages).cardShowDeletedDiffsLabel : (0, $gVCFw.aiSuggestionsMessages).cardHideDeletedDiffsLabel),
                                        appearance: "subtle",
                                        spacing: "compact",
                                        isDisabled: isRegenerating,
                                        onClick: onToggleDeletedDiffs
                                    }),
                                    (onGoodSuggestion || onBadSuggestion) && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3vgx3.default), {
                                        placement: "bottom-end",
                                        trigger: renderMoreOptionsTrigger,
                                        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $9erVg.default), {
                                            children: [
                                                onGoodSuggestion && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $is1T6.default), {
                                                    elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))), {
                                                        label: ""
                                                    }),
                                                    onClick: onGoodSuggestion,
                                                    children: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardGoodSuggestionLabel)
                                                }),
                                                onBadSuggestion && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $is1T6.default), {
                                                    elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($93fnf))), {
                                                        label: ""
                                                    }),
                                                    onClick: onBadSuggestion,
                                                    children: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardBadSuggestionLabel)
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3vgx3.default), {
                                placement: "bottom-end",
                                trigger: renderMoreOptionsTrigger,
                                children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $9erVg.default), {
                                    children: [
                                        onToggleDeletedDiffs && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $is1T6.default // The same icon in both states: the item's label already says which
                                        ), {
                                            // way the toggle goes, so a changing icon just adds noise.
                                            elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fxbF1))), {
                                                label: ""
                                            }),
                                            onClick: onToggleDeletedDiffs,
                                            children: isHidingDeletedDiffs ? formatMessage((0, $gVCFw.aiSuggestionsMessages).cardShowDeletedDiffsLabel) : formatMessage((0, $gVCFw.aiSuggestionsMessages).cardHideDeletedDiffsLabel)
                                        }),
                                        onGoodSuggestion && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $is1T6.default), {
                                            elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))), {
                                                label: ""
                                            }),
                                            onClick: onGoodSuggestion,
                                            children: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardGoodSuggestionLabel)
                                        }),
                                        onBadSuggestion && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $is1T6.default), {
                                            elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($93fnf))), {
                                                label: ""
                                            }),
                                            onClick: onBadSuggestion,
                                            children: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardBadSuggestionLabel)
                                        })
                                    ]
                                })
                            })),
                            isInsight ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                                onClick: onDismiss,
                                isDisabled: isRegenerating,
                                children: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardDismissButtonLabel)
                            }) : /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                                        appearance: isStale ? 'primary' : 'subtle',
                                        onClick: onDiscard,
                                        isDisabled: isRegenerating,
                                        children: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardDiscardButtonLabel)
                                    }),
                                    !isStale && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                                        appearance: "primary",
                                        onClick: onAccept,
                                        isDisabled: isRegenerating,
                                        children: formatMessage((0, $gVCFw.aiSuggestionsMessages).cardAcceptButtonLabel)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
});


function $cae1b4cc9a9bf61d$export$9e133524747bf9c({ launchOptions: launchOptions, userPrompt: userPrompt }) {
    return {
        userPrompt: userPrompt,
        dynamicUiType: launchOptions?.dynamicUiType,
        dynamicUiSubtype: launchOptions?.dynamicUiSubtype,
        aspectRatio: launchOptions?.aspectRatio,
        remixSource: 'suggestedRemix'
    };
}
function $cae1b4cc9a9bf61d$export$42d6e4bc0dd0cdb6({ api: api, launchOptions: launchOptions, localIds: localIds, userPrompt: userPrompt }) {
    if (!api?.core) return undefined;
    const request = {
        localIds: localIds,
        metadata: $cae1b4cc9a9bf61d$export$9e133524747bf9c({
            launchOptions: launchOptions,
            userPrompt: userPrompt
        })
    };
    const startRemix = api.malleableUi?.commands?.startRemix;
    if (startRemix) api.core.actions.execute(startRemix({
        localIds: request.localIds,
        remixModalMetadata: request.metadata
    }));
    return request;
}


// render at its anchor while the card is still there.
const $d79d0d9956135474$var$SUGGESTED_REMIX_NAVIGATE_DELAY_MS = 2000; /**
                                                 * We render this in a content component because rendering directly in a Decoration widget
                                                 * will cause it to inherit font stylings from Editor which is not appropriate for this component.
                                                 */ 
const $d79d0d9956135474$export$b9f1c5d82af9ea41 = ({ api: api, onShowSidebar: onShowSidebar, view: view })=>{
    const cardRef = (0, $cozmU.useRef)(null);
    const suggestedEditsDefaultOn = (0, $cozmU.useMemo)(()=>(0, $295ac436451fb879$export$ef2b3f5e81ffeef8)(), []);
    const [isHidingDeletedDiffs, setIsHidingDeletedDiffs] = (0, $cozmU.useState)(suggestedEditsDefaultOn); // Positioning-critical slice — kept synchronous (no debounce) so the CSS-anchor references
    // stay in lock-step with the ProseMirror transaction that swapped the selection.
    const { selectedSuggestion: selectedSuggestion, baseLocalId: baseLocalId } = (0, $3ff3f4249608fe22$export$12e742fdeff6e7ba)(api); // Reset the toggle to the experiment default whenever the selected suggestion changes.
    (0, $cozmU.useEffect)(()=>{
        setIsHidingDeletedDiffs(suggestedEditsDefaultOn);
    }, [
        selectedSuggestion?.id,
        suggestedEditsDefaultOn
    ]);
    const anchorLocalId = selectedSuggestion ? (0, $c08510c480bfb65f$export$e644b4e6be3487e)(selectedSuggestion) : undefined;
    const { orderedSuggestionIds: orderedSuggestionIds, isHidden: isHidden, regeneratingSuggestionIds: regeneratingSuggestionIds } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiSuggestions',
        'editorViewMode'
    ], (state)=>{
        const { orderedSuggestionIds: orderedSuggestionIds, isHidden: isHidden, regeneratingSuggestionIds: regeneratingSuggestionIds } = state?.aiSuggestionsState ?? {};
        return {
            orderedSuggestionIds: orderedSuggestionIds,
            // View mode is a hard override: never show the suggestion card while read-only.
            isHidden: (isHidden ?? false) || state?.editorViewModeState?.mode === 'view',
            regeneratingSuggestionIds: regeneratingSuggestionIds
        };
    });
    // Checked against the synced `selectedSuggestion.id` (not the debounced plugin
    // state's own `selectedSuggestion`) so this always reflects the suggestion
    // actually being rendered — otherwise a quick navigation away from a
    // regenerating suggestion can transiently attribute its regenerating status to
    // whichever suggestion is selected next.
    const isRegenerating = selectedSuggestion ? regeneratingSuggestionIds?.has(selectedSuggestion.id) ?? false : false;
    const regenerationStatus = (0, $e40b4e35496d16c5$export$4cbf498e35d8c873)(selectedSuggestion, isRegenerating);
    const banner = regenerationStatus ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $59fa28a6d850aa68$export$fcf9195d8c4d40ff), {
        status: regenerationStatus
    }) : undefined;
    const anchorNames = (0, $cozmU.useMemo)(()=>({
            start: `--card-${anchorLocalId}-start`,
            end: `--card-${anchorLocalId}-end`,
            // Emitted only for targets whose primary anchors sit inside them, where the diff can
            // hide the anchor. Naming them unconditionally is harmless: `anchor()` treats an
            // unmatched name as invalid, exactly as it treats the primary when that is the one
            // missing, so the chain still resolves to the primary.
            outerStart: `--card-${anchorLocalId}-outer-start`,
            outerEnd: `--card-${anchorLocalId}-outer-end`,
            base: `--button-${baseLocalId}`
        }), [
        anchorLocalId,
        baseLocalId
    ]);
    const onScrollBackClick = (0, $cozmU.useCallback)(()=>{
        if (!selectedSuggestion) return;
        api?.aiSuggestions?.actions.selectSuggestion(selectedSuggestion.id, {
            hideDeletedDiffs: isHidingDeletedDiffs
        });
    }, [
        api,
        isHidingDeletedDiffs,
        selectedSuggestion
    ]);
    const onToggleDeletedDiffs = (0, $cozmU.useCallback)(()=>{
        if (!selectedSuggestion) return;
        const updatedHideDeletedDiffs = !isHidingDeletedDiffs;
        setIsHidingDeletedDiffs(updatedHideDeletedDiffs);
        api?.aiSuggestions?.actions.selectSuggestion(selectedSuggestion.id, {
            hideDeletedDiffs: updatedHideDeletedDiffs,
            scrollIntoView: false
        });
    }, [
        api,
        isHidingDeletedDiffs,
        selectedSuggestion
    ]);
    if (selectedSuggestion === undefined || isHidden) return;
    const onClose = ()=>{
        api?.aiSuggestions?.actions.selectSuggestion(null, {
            interactionPoint: 'card'
        });
    };
    const onDiscard = ()=>{
        api?.core?.actions.execute(({ tr: tr })=>{
            (0, $61b8b9734ab6a330$export$1d496d000386893c)({
                updates: [
                    {
                        id: selectedSuggestion.id,
                        status: 'DISMISSED'
                    }
                ]
            });
            (0, $2a4bc64013915ea2$export$ec701ea77bc93a9f)(api?.analytics?.actions)(tr, selectedSuggestion, 'card');
            tr.setMeta((0, $1b159f40bd8b3a1f$export$dbbefe45c19011aa), {
                action: 'REMOVE_SUGGESTION',
                id: selectedSuggestion.id
            });
            api?.showDiff?.commands.hideDiff?.({
                tr: tr
            });
            return tr;
        });
        // navigate to the next suggestion
        onNavigate('down');
    };
    const onAccept = ()=>{
        (0, $61b8b9734ab6a330$export$1d496d000386893c)({
            updates: [
                {
                    id: selectedSuggestion.id,
                    status: 'ACTIONED'
                }
            ]
        });
        if (selectedSuggestion.actionKind === 'SUGGESTED_REMIX') {
            api?.core?.actions.execute(({ tr: tr })=>{
                (0, $2a4bc64013915ea2$export$f1a852c299619cdc)(api?.analytics?.actions)(tr, selectedSuggestion, 'card');
                api?.showDiff?.commands.hideDiff?.({
                    tr: tr
                });
                tr.setMeta((0, $1b159f40bd8b3a1f$export$dbbefe45c19011aa), {
                    action: 'REMOVE_SUGGESTION',
                    id: selectedSuggestion.id
                });
                return tr;
            });
            // Suggested remixes carry no tool calls to apply; hand the backend-supplied action
            // to the remix flow instead. Engine wiring lands in the malleable-ui follow-up.
            const action = selectedSuggestion.action;
            (0, $cae1b4cc9a9bf61d$export$42d6e4bc0dd0cdb6)({
                api: api,
                launchOptions: action?.launchOptions,
                localIds: action?.localIds,
                userPrompt: action?.userPrompt
            }); // Give the remix a beat to appear at the anchor before the card jumps to the next suggestion.
            setTimeout(()=>onNavigate('down'), $d79d0d9956135474$var$SUGGESTED_REMIX_NAVIGATE_DELAY_MS);
            return;
        }
        api?.aiSuggestions?.actions.acceptSuggestion(selectedSuggestion.id, 'card'); // navigate to the next suggestion
        onNavigate('down');
    };
    const onDismiss = ()=>{
        api?.core?.actions.execute(({ tr: tr })=>{
            (0, $2a4bc64013915ea2$export$ec701ea77bc93a9f)(api?.analytics?.actions)(tr, selectedSuggestion, 'card');
            tr.setMeta((0, $1b159f40bd8b3a1f$export$dbbefe45c19011aa), {
                action: 'REMOVE_SUGGESTION',
                id: selectedSuggestion.id
            });
            return tr;
        });
        onNavigate('down');
    };
    const onGoodSuggestion = ()=>{
        api?.aiSuggestions?.actions.submitSuggestionFeedback(selectedSuggestion.id, 'good', {
            interactionPoint: 'card'
        });
    };
    const onBadSuggestion = ()=>{
        api?.aiSuggestions?.actions.submitSuggestionFeedback(selectedSuggestion.id, 'bad', {
            interactionPoint: 'card'
        });
    };
    const onReasoningViewed = ()=>{
        (0, $2a4bc64013915ea2$export$22bc65b38809466)(api?.analytics?.actions, selectedSuggestion, 'card');
    };
    const onNavigate = (direction)=>{
        const currentId = selectedSuggestion.id;
        if (!orderedSuggestionIds || orderedSuggestionIds?.length === 0) return undefined;
        const idx = orderedSuggestionIds.indexOf(currentId);
        if (idx === -1) return undefined;
        const delta = direction === 'up' ? -1 : 1;
        const nextIdx = (idx + delta + orderedSuggestionIds.length) % orderedSuggestionIds.length;
        const nextId = orderedSuggestionIds[nextIdx]; // When only one suggestion exists, the modulo wraps back to the current id.
        // Skip navigation in that case so we don't re-select the suggestion that's about to be removed.
        if (nextId === currentId) return undefined;
        api?.aiSuggestions?.actions.selectSuggestion(nextId);
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b79c09504f84e6ab$export$8f339c4f2834aeec // Remounts when a different suggestion is opened, which replays the fade-in — the
    ), {
        anchorNames: anchorNames,
        cardRef: cardRef,
        onScrollBack: onScrollBackClick,
        targetId: baseLocalId,
        view: view,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1bd78593134dbc9f$export$5864b77b647e728c), {
            ref: cardRef,
            suggestion: selectedSuggestion,
            onNavigate: orderedSuggestionIds && orderedSuggestionIds.length > 1 ? onNavigate : undefined,
            onClose: onClose,
            onDiscard: onDiscard,
            onDismiss: onDismiss,
            onAccept: onAccept,
            onGoodSuggestion: onGoodSuggestion,
            onBadSuggestion: onBadSuggestion,
            onReasoningViewed: onReasoningViewed,
            onShowSidebar: onShowSidebar,
            onToggleDeletedDiffs: onToggleDeletedDiffs,
            isHidingDeletedDiffs: isHidingDeletedDiffs,
            isRegenerating: isRegenerating,
            showComparisonButton: suggestedEditsDefaultOn,
            banner: banner
        })
    }, selectedSuggestion.id);
};


/* SuggestionRightSurfaceButton.tsx generated by @compiled/babel-plugin v3.0.1 */ 





















function $6b167ecb058e19e8$export$6c43944391554e2e(suggestionIds, suggestionById) {
    const profilesByAccountId = new Map();
    for (const suggestionId of suggestionIds ?? []){
        const suggestion = suggestionById?.get(suggestionId);
        if (!suggestion) continue;
        const agent = suggestion.createdByAgent ?? undefined;
        if (!profilesByAccountId.has(agent?.accountId)) profilesByAccountId.set(agent?.accountId, {
            profile: agent
        });
    }
    return Array.from(profilesByAccountId.values());
}


/* SuggestionAvatarIndicator.tsx generated by @compiled/babel-plugin v3.0.1 */ 












var $9Ke0t = parcelRequire("9Ke0t");




/* SuggestionAvatar.tsx generated by @compiled/babel-plugin v3.0.1 */ 


parcelRequire("cozmU");










// avatars elsewhere. `color.border.inverse` reads as white in light mode against the avatar's bold
// background, and flips to a dark ring in dark mode for the same contrast.
const $fb1ab760787ae2e9$var$avatarRingColor = "var(--ds-border-inverse, #FFFFFF)";
const $fb1ab760787ae2e9$var$styles = {
    avatarRingWrapper: "_1mT5xdRAKS _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0V5zaO _39xV025zaO",
    agentAvatarRing: "_49OCfRpgTj _1mT5xdWVPG _42Yu6BdnbC _0KLXruxCOs _1uo2ZfTcEg",
    avatarRingContent: "_1mT5xdRAKS _42Yu6B7dHp _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0V5zaO _39xV025zaO _4ya3eEdnbC"
}; /**
    * One agent avatar's ring + content — the specific agent, or the generic Rovo fallback when the
    * suggestion has no agent profile. Used by `SuggestionAvatarIndicator` to render each entry in the
    * stack.
    */ 
function $fb1ab760787ae2e9$export$6fb32e417ef0be07({ profile: profile }) {
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("span", {
        className: (0, $hekY6.default)([
            $fb1ab760787ae2e9$var$styles.avatarRingWrapper
        ]),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                className: (0, $hekY6.default)([
                    $fb1ab760787ae2e9$var$styles.agentAvatarRing
                ])
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                className: (0, $hekY6.default)([
                    $fb1ab760787ae2e9$var$styles.avatarRingContent
                ]),
                children: profile ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6gGPb.AgentAvatar), {
                    imageUrl: profile.picture?.trim() || undefined,
                    agentIdentityAccountId: profile.accountId,
                    name: profile.name,
                    label: profile.name,
                    size: "xxsmall",
                    showBorder: false
                }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bUd6P.RovoHexIcon), {
                    size: "xxsmall"
                })
            })
        ]
    });
}


// `indicatorBase`'s width below, so this real flex item grows and pushes sibling right-surface
// controls instead of overlapping them.
const $d31faf014d0f6436$var$avatarCountVar = '--suggestion-avatar-count';
const $d31faf014d0f6436$var$MAX_VISIBLE_AVATARS = 3; // Shared by `indicatorActive` and `avatarStackPillRevealed` below — the container and the pill
// must grow by the exact same formula, or the pill overflows its flex slot.
const $d31faf014d0f6436$var$stackWidthCalc = `calc(${"var(--ds-space-300, 24px)"} + ${"var(--ds-space-150, 12px)"} * (var(${$d31faf014d0f6436$var$avatarCountVar}, 1) - 1))`;
const $d31faf014d0f6436$var$avatarStackPillRevealTransition = `opacity ${"var(--ds-duration-xshort, 100ms)"} ${"var(--ds-easing-out-practical, cubic-bezier(0.4, 1, 0.6, 1))"}, width ${"var(--ds-duration-medium, 200ms)"} ${"var(--ds-easing-out-practical, cubic-bezier(0.4, 1, 0.6, 1))"}`;
const $d31faf014d0f6436$var$styles = {
    indicatorBase: "_23rrnHvplL _1mT5xdRAKS _3iDTPbvLZJ _0jFU0VNHnM _39xV02NHnM",
    indicatorActive: "_39xV02BS27",
    iconLayer: "_49OCfRdnbC _23rrnHbMfy _1mT5xdWVPG _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _1YKVNs7dHp",
    iconLayerHidden: "_1YKVNsdnbC",
    avatarStackPillWrapper: "_23rrnHvUpb _1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _24h04i2Njc _0jFU0VNHnM _39xV02NHnM _1YKVNsdnbC",
    avatarStackPillWrapperRevealed: "_1YKVNs7dHp _39xV02BS27",
    avatarStackPill: "_30huDKYbGa _0bjKvDS5Zs _2sNsIgOLYo _4c065UgVvo _2Y7lL4gVvo _3iDTPbQ4SZ _0hPCNLDIqT _0jFU0VN91d _39xV02N91d _0KLXruwawV _0wOv4Q7zJH",
    avatarStackPillInteractive: "_23rrnHyKLB _1eOmH6rWzL _3fSdSTFYNq _3sFUREiSCN _3gzVzLgE2d",
    avatarStackRow: "_3iDTPbQ4SZ _0hPCNLDIqT _2YgrGrP0S5",
    avatar: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _1mT5xdRAKS _0jFU0V8HPE _39xV028HPE",
    avatarSlide: "_23rrnHdEki"
};
const $d31faf014d0f6436$var$AnimatedIcon = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        className: (0, $hekY6.default)([
            $d31faf014d0f6436$var$styles.iconLayer
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9Ke0t))), {
            label: "",
            size: "small",
            color: "var(--ds-icon-subtle, #505258)"
        })
    });
function $d31faf014d0f6436$export$a3ce2c0cf1a02890({ isActive: isActive, label: label, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, profiles: profiles, tooltip: tooltip }) {
    // Hovering/focusing this icon directly also reveals the stack, on top of `isActive`.
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const showAvatars = (isActive || isHovered) && profiles.length > 0;
    const visibleProfiles = profiles.slice(0, $d31faf014d0f6436$var$MAX_VISIBLE_AVATARS);
    const containerRef = (0, $cozmU.useRef)(null); // `@atlaskit/tooltip` only flips vertically for viewport overflow, not horizontally — so a
    // bubble near the right edge still gets cropped. We measure the trigger ourselves and switch
    // our requested alignment from 'start' to 'end' to work around that.
    const [horizontalAlign, setHorizontalAlign] = (0, $cozmU.useState)('start');
    const measureHorizontalAlign = (0, $cozmU.useCallback)(()=>{
        const node = containerRef.current;
        if (!node) return;
         // Matches `SuggestionTooltip`'s `maxWidth`.
        const tooltipMaxWidth = 240;
        const { left: left } = node.getBoundingClientRect();
        setHorizontalAlign(left + tooltipMaxWidth > window.innerWidth ? 'end' : 'start');
    }, []);
    const handleMouseEnter = (0, $cozmU.useCallback)(()=>{
        measureHorizontalAlign();
        setIsHovered(true);
        onMouseEnter?.();
    }, [
        measureHorizontalAlign,
        onMouseEnter
    ]);
    const handleMouseLeave = (0, $cozmU.useCallback)(()=>{
        setIsHovered(false);
        onMouseLeave?.();
    }, [
        onMouseLeave
    ]);
    const handleFocus = (0, $cozmU.useCallback)(()=>{
        measureHorizontalAlign();
        setIsHovered(true);
        onFocus?.();
    }, [
        measureHorizontalAlign,
        onFocus
    ]);
    const handleBlur = (0, $cozmU.useCallback)(()=>{
        setIsHovered(false);
        onBlur?.();
    }, [
        onBlur
    ]);
    const resolvedTooltip = (0, $cozmU.useMemo)(()=>{
        const verticalSide = typeof tooltip.position === 'string' ? tooltip.position.split('-')[0] : 'top';
        return {
            ...tooltip,
            position: `${verticalSide}-${horizontalAlign}`
        };
    }, [
        tooltip,
        horizontalAlign
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("span", {
        ref: containerRef,
        style: {
            [$d31faf014d0f6436$var$avatarCountVar]: visibleProfiles.length || 1
        },
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        className: (0, $hekY6.default)([
            $d31faf014d0f6436$var$styles.indicatorBase,
            showAvatars && $d31faf014d0f6436$var$styles.indicatorActive
        ]),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                style: {
                    pointerEvents: showAvatars ? 'none' : 'auto'
                },
                className: (0, $hekY6.default)([
                    $d31faf014d0f6436$var$styles.iconLayer,
                    showAvatars && $d31faf014d0f6436$var$styles.iconLayerHidden
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                    isTooltipDisabled: false,
                    tooltip: resolvedTooltip,
                    shape: "circle",
                    type: "button",
                    label: label,
                    onClick: onClick,
                    appearance: "subtle",
                    spacing: "compact",
                    icon: $d31faf014d0f6436$var$AnimatedIcon
                })
            }),
            profiles.length > 0 && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                style: {
                    pointerEvents: showAvatars ? 'auto' : 'none'
                },
                className: (0, $hekY6.default)([
                    $d31faf014d0f6436$var$styles.avatarStackPillWrapper,
                    showAvatars && $d31faf014d0f6436$var$styles.avatarStackPillWrapperRevealed
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                    content: resolvedTooltip.content ?? label,
                    position: resolvedTooltip.position,
                    component: resolvedTooltip.component,
                    delay: resolvedTooltip.delay,
                    ignoreTooltipPointerEvents: resolvedTooltip.ignoreTooltipPointerEvents,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)("button", {
                        type: "button",
                        onClick: onClick,
                        "aria-label": label,
                        className: (0, $hekY6.default)([
                            $d31faf014d0f6436$var$styles.avatarStackPill,
                            $d31faf014d0f6436$var$styles.avatarStackPillInteractive
                        ]),
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                            className: (0, $hekY6.default)([
                                $d31faf014d0f6436$var$styles.avatarStackRow
                            ]),
                            children: visibleProfiles.map((avatarProfile, index)=>/*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                                    style: {
                                        // Earlier avatars stack in front of later ones.
                                        zIndex: visibleProfiles.length - index,
                                        // Hidden: each avatar slides left by index * 12px (its slot width),
                                        // stacking on avatar 0. Revealed: no offset, natural flex position.
                                        transform: `translateX(${showAvatars ? 0 : -index * 12}px)`
                                    },
                                    className: (0, $hekY6.default)([
                                        $d31faf014d0f6436$var$styles.avatar,
                                        $d31faf014d0f6436$var$styles.avatarSlide
                                    ]),
                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fb1ab760787ae2e9$export$6fb32e417ef0be07), {
                                        profile: avatarProfile.profile
                                    })
                                }, avatarProfile.profile?.accountId ?? index))
                        })
                    })
                })
            })
        ]
    });
}


/* SuggestionTooltip.tsx generated by @compiled/babel-plugin v3.0.1 */ 









var $1B9Aq = parcelRequire("1B9Aq");

const $ba4ab5594767adb9$var$styles = {
    base: "_2mHwu82ADO _2sNsIg7NXe _2V7sgONvrM _3hxITi6wH8 _3vBAKHxCOs _4c065U2ADO _2Y7lL48HPE _24h04i2Njc _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _1EqgXlGVdc _0KLXrugozt _2OUyjtFYNq _1UtDYze5R3 _3zvHkHwPeg _1T2N03wPeg",
    notchBottomLeft: "_2C2kUQyzSk _1Lz9loyzSk _3XDz3ByzSk _1v9SsVKxmn",
    notchBottomRight: "_2C2kUQyzSk _1Lz9loyzSk _3XDz3BKxmn _1v9SsVyzSk",
    notchTopLeft: "_2C2kUQKxmn _1Lz9loyzSk _3XDz3ByzSk _1v9SsVyzSk",
    notchTopRight: "_2C2kUQyzSk _1Lz9loKxmn _3XDz3ByzSk _1v9SsVyzSk"
};
const $ba4ab5594767adb9$export$faf6d8e1d1b7acad = /*#__PURE__*/ (0, $cozmU.forwardRef)(function SuggestionTooltip({ style: style, className: className, children: children, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id, shortcut: shortcut, role: role }, ref) {
    const isBelowTrigger = placement?.startsWith('bottom');
    const isEndAligned = placement?.endsWith('end');
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1B9Aq.default), {
        ref: ref,
        style: style,
        className: (0, $hekY6.default)([
            $ba4ab5594767adb9$var$styles.base,
            !isBelowTrigger && !isEndAligned && $ba4ab5594767adb9$var$styles.notchBottomLeft,
            !isBelowTrigger && isEndAligned && $ba4ab5594767adb9$var$styles.notchBottomRight,
            isBelowTrigger && !isEndAligned && $ba4ab5594767adb9$var$styles.notchTopLeft,
            isBelowTrigger && isEndAligned && $ba4ab5594767adb9$var$styles.notchTopRight,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut,
        role: role,
        children: children
    });
});


const $92877f9d742eca51$var$styles = {
    container: "_1mT5xdRAKS _1pp6NdYsOL"
};
function $92877f9d742eca51$export$509594734c522b9c({ api: api, surfaceContext: surfaceContext }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const context = surfaceContext?.get((0, $jbxiN.BLOCK_CONTROL_UI_CONTEXT));
    const localId = context?.targetNode.node.attrs?.localId; // True while block-controls has this block (or a node nested inside it, e.g. a paragraph in
    // a panel) as the active node.
    const isBlockActive = Boolean(context?.activeNode && context.rootNode.pos === context.targetNode.pos); // Derived primitives (rather than the state maps) so the hook's shallow
    // equality check can skip re-renders that don't affect this button.
    const { firstSuggestionId: firstSuggestionId, isAnySuggestionSelected: isAnySuggestionSelected, isSelected: isSelected, profiles: profiles, shortDescription: shortDescription, suggestionsCount: suggestionsCount } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiSuggestions'
    ], (state)=>{
        const { suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId, suggestionById: suggestionById, selectedSuggestion: selectedSuggestion } = state?.aiSuggestionsState ?? {};
        const suggestionIds = localId ? suggestionIdsByBaseLocalId?.get(localId) : undefined;
        const firstSuggestionId = suggestionIds?.values().next().value;
        return {
            firstSuggestionId: firstSuggestionId,
            isAnySuggestionSelected: Boolean(selectedSuggestion),
            isSelected: Boolean(selectedSuggestion && suggestionIds?.has(selectedSuggestion)),
            profiles: (0, $6b167ecb058e19e8$export$6c43944391554e2e)(suggestionIds, suggestionById),
            shortDescription: firstSuggestionId ? suggestionById?.get(firstSuggestionId)?.shortDescription : undefined,
            suggestionsCount: suggestionIds?.size ?? 0
        };
    });
    // `SuggestionAvatarIndicator` ORs in one more trigger (hovering the icon directly), so it
    // only needs this single combined boolean from here.
    const isActive = isAnySuggestionSelected || isBlockActive;
    const isSelectingSuggestionRef = (0, $cozmU.useRef)(false);
    const onSelectSuggestion = (0, $cozmU.useCallback)(()=>{
        if (isSelectingSuggestionRef.current) return;
        isSelectingSuggestionRef.current = true;
        const selectSuggestion = async ()=>{
            try {
                const canCloseComment = await api?.annotation?.actions.requestCloseInlineComment?.() ?? true;
                if (!canCloseComment || !firstSuggestionId) return;
                api?.aiSuggestions?.actions.selectSuggestion(firstSuggestionId, {
                    interactionPoint: 'card'
                });
            } finally{
                isSelectingSuggestionRef.current = false;
            }
        };
        selectSuggestion();
    }, [
        api,
        firstSuggestionId
    ]);
    const setHoveredSuggestion = (0, $cozmU.useCallback)((id)=>{
        api?.core?.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $1b159f40bd8b3a1f$export$dbbefe45c19011aa), {
                action: 'HOVER_SUGGESTION',
                id: id
            });
            return tr;
        });
    }, [
        api
    ]);
    const onMouseEnter = (0, $cozmU.useCallback)(()=>setHoveredSuggestion(firstSuggestionId), [
        setHoveredSuggestion,
        firstSuggestionId
    ]);
    const onMouseLeave = (0, $cozmU.useCallback)(()=>setHoveredSuggestion(undefined), [
        setHoveredSuggestion
    ]);
    const onFocus = (0, $cozmU.useCallback)(()=>setHoveredSuggestion(firstSuggestionId), [
        setHoveredSuggestion,
        firstSuggestionId
    ]);
    const onBlur = (0, $cozmU.useCallback)(()=>setHoveredSuggestion(undefined), [
        setHoveredSuggestion
    ]);
    const tooltip = (0, $cozmU.useMemo)(()=>({
            content: suggestionsCount > 1 ? formatMessage((0, $gVCFw.aiSuggestionsMessages).iconButtonSuggestionsCountLabel, {
                count: suggestionsCount
            }) || (shortDescription ?? '') : shortDescription ?? '',
            position: 'top-start',
            component: (0, $ba4ab5594767adb9$export$faf6d8e1d1b7acad),
            delay: 0,
            ignoreTooltipPointerEvents: true
        }), [
        formatMessage,
        shortDescription,
        suggestionsCount
    ]);
    if (!localId || !firstSuggestionId) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        style: {
            anchorName: `--button-${localId}`
        },
        className: (0, $hekY6.default)([
            $92877f9d742eca51$var$styles.container
        ]),
        children: // We keep the anchorName span rendered so that the suggestion card can reference it
        !isSelected && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d31faf014d0f6436$export$a3ce2c0cf1a02890), {
            isActive: isActive,
            profiles: profiles,
            tooltip: tooltip,
            label: tooltip.content,
            onClick: onSelectSuggestion,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onFocus: onFocus,
            onBlur: onBlur
        })
    });
}


/* ThinkingContentComponent.tsx generated by @compiled/babel-plugin v3.0.1 */ 









var $cbY7C = parcelRequire("cbY7C");




















var $7vK9E = parcelRequire("7vK9E");





var $bGNkz = parcelRequire("bGNkz");


var $doA2E = parcelRequire("doA2E");


var $3sXr4 = parcelRequire("3sXr4");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");








var $frX6f = parcelRequire("frX6f");











var $k12R1 = parcelRequire("k12R1");





var $iMnC5 = parcelRequire("iMnC5");





var $2diYd = parcelRequire("2diYd");


var $02Wb7 = parcelRequire("02Wb7");

const $9fef98e8a0a21e6b$var$styles = {
    pill: "_0bjKvDS5Zs _4c065UgVvo _3iDTPbccYA _0hPCNLDIqT _39xV02E6Kk _1EqgXlN91d _24h04i2Njc _2Zuz6QgVvo _1Znuxb2ADO _0KLXruoI2d _2OUyjtGk8v",
    pressable: "_30huDKYbGa _23rrnHyKLB _0wOv4Q7zJH _2fwxA57p2s _1eOmH6hWTW _3sFUREiSCN _3gzVzL0GoB"
};
const $9fef98e8a0a21e6b$export$1b83241eb743f10a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { status: t1, label: label, onClick: onClick, testId: t2 } = t0;
    const status = t1 === undefined ? "analyzing" : t1;
    const testId = t2 === undefined ? "rovo-thinking-pill" : t2;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t3;
    if ($[0] !== formatMessage || $[1] !== label || $[2] !== status) {
        t3 = label ?? formatMessage(status === "editing" ? (0, $02Wb7.default).editingTextShort : (0, $02Wb7.default).thinkingTextShort);
        $[0] = formatMessage;
        $[1] = label;
        $[2] = status;
        $[3] = t3;
    } else t3 = $[3];
    const title = t3;
    let t4;
    if ($[4] !== title) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $2diYd.RovoThinkingIndicator), {
            title: title,
            animation: true
        });
        $[4] = title;
        $[5] = t4;
    } else t4 = $[5];
    const indicator = t4;
    if (onClick) {
        let t5;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
            t5 = (0, $k12R1.cx)($9fef98e8a0a21e6b$var$styles.pill, $9fef98e8a0a21e6b$var$styles.pressable);
            $[6] = t5;
        } else t5 = $[6];
        let t6;
        if ($[7] !== indicator || $[8] !== onClick || $[9] !== testId) {
            t6 = /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
                xcss: t5,
                onClick: onClick,
                testId: testId
            }, indicator);
            $[7] = indicator;
            $[8] = onClick;
            $[9] = testId;
            $[10] = t6;
        } else t6 = $[10];
        return t6;
    }
    let t5;
    if ($[11] !== indicator || $[12] !== testId) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $9fef98e8a0a21e6b$var$styles.pill,
            testId: testId
        }, indicator);
        $[11] = indicator;
        $[12] = testId;
        $[13] = t5;
    } else t5 = $[13];
    return t5;
} : ({ status: status = 'analyzing', label: label, onClick: onClick, testId: testId = 'rovo-thinking-pill' })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const title = label ?? formatMessage(status === 'editing' ? (0, $02Wb7.default).editingTextShort : (0, $02Wb7.default).thinkingTextShort);
    const indicator = /*#__PURE__*/ $cozmU.createElement((0, $2diYd.RovoThinkingIndicator), {
        title: title,
        animation: true
    });
    if (onClick) return /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        xcss: (0, $k12R1.cx)($9fef98e8a0a21e6b$var$styles.pill, $9fef98e8a0a21e6b$var$styles.pressable),
        onClick: onClick,
        testId: testId
    }, indicator);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $9fef98e8a0a21e6b$var$styles.pill,
        testId: testId
    }, indicator);
};


const $c0d8764173773235$var$centerPillStyles = null;
var $c0d8764173773235$var$ThinkingView = /*#__PURE__*/ function(ThinkingView) {
    ThinkingView["Pill"] = "pill";
    ThinkingView["Full"] = "full";
    return ThinkingView;
}($c0d8764173773235$var$ThinkingView || {})// Delay before a view swap, as a plain number for `setTimeout`. Sourced from
;
// `@atlaskit/motion`'s numeric exit duration (175ms) rather than the ADS motion
// tokens (which are CSS values, not numbers). It doesn't exactly equal the
// token-based exit `animationDuration` (`motion.duration.short`, 150ms) used in
// the CSS, and that's fine: the timer only needs to be >= the exit animation so
// the outgoing side finishes fading before it's hidden.
const $c0d8764173773235$var$TRANSITION_MS = (0, $frX6f.exitingDurations).medium;
const $c0d8764173773235$var$pillFadeInKeyframes = null;
const $c0d8764173773235$var$pillFadeOutKeyframes = null;
const $c0d8764173773235$var$fullSlideInKeyframes = null;
const $c0d8764173773235$var$fullSlideOutKeyframes = null;
const $c0d8764173773235$var$animationBaseStyles = null;
const $c0d8764173773235$var$pillEnterStyles = null;
const $c0d8764173773235$var$pillExitStyles = null;
const $c0d8764173773235$var$fullEnterStyles = null;
const $c0d8764173773235$var$fullExitStyles = null;
const $c0d8764173773235$var$reducedMotionStyles = null; /** Default delay before the expanded experience auto-minimizes into the pill. */ 
const $c0d8764173773235$var$DEFAULT_AUTO_MINIMIZE_DELAY_MS = 8000; /**
                                              * Minimum remaining budget (ms) granted after the pointer/focus leaves, so a
                                              * brief hover near the end of the countdown doesn't immediately trigger
                                              * auto-minimize.
                                              */ 
const $c0d8764173773235$var$MIN_REMAINING_MS = 2000; /**
                                * Imperative handle for triggering a minimize/expand from outside the
                                * component (e.g. a "Hide" button elsewhere in your UI), without a
                                * controlled prop + callback contract.
                                */ 
const $c0d8764173773235$export$3582558a29e46c9d = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function RovoThinkingMinimization(t0, ref) {
    const $ = (0, $bDgLe.c)(41);
    const { children: children, pillProps: pillProps, autoMinimizeDelayMs: t1, isThinking: t2, testId: testId } = t0;
    const autoMinimizeDelayMs = t1 === undefined ? $c0d8764173773235$var$DEFAULT_AUTO_MINIMIZE_DELAY_MS : t1;
    const isThinking = t2 === undefined ? true : t2;
    const [isMinimized, setIsMinimized] = (0, $cozmU.useState)(false);
    const [displayedView, setDisplayedView] = (0, $cozmU.useState)("full");
    const configuredDelayMs = autoMinimizeDelayMs != null && autoMinimizeDelayMs > 0 ? autoMinimizeDelayMs : null;
    const timeoutIdRef = (0, $cozmU.useRef)(null);
    const scheduledAtRef = (0, $cozmU.useRef)(null);
    const remainingRef = (0, $cozmU.useRef)(0);
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            if (timeoutIdRef.current !== null) {
                clearTimeout(timeoutIdRef.current);
                timeoutIdRef.current = null;
            }
            scheduledAtRef.current = null;
        };
        $[0] = t3;
    } else t3 = $[0];
    const clearTimer = t3;
    let t4;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (delay)=>{
            clearTimer();
            scheduledAtRef.current = Date.now() + delay;
            timeoutIdRef.current = setTimeout(()=>{
                timeoutIdRef.current = null;
                scheduledAtRef.current = null;
                setIsMinimized(true);
            }, delay);
        };
        $[1] = t4;
    } else t4 = $[1];
    const startTimer = t4;
    let t5;
    let t6;
    if ($[2] !== configuredDelayMs || $[3] !== isMinimized || $[4] !== isThinking) {
        t5 = ()=>{
            if (!isThinking || isMinimized || configuredDelayMs === null) {
                clearTimer();
                return;
            }
            remainingRef.current = configuredDelayMs;
            startTimer(configuredDelayMs);
            return clearTimer;
        };
        t6 = [
            isMinimized,
            isThinking,
            configuredDelayMs,
            startTimer,
            clearTimer
        ];
        $[2] = configuredDelayMs;
        $[3] = isMinimized;
        $[4] = isThinking;
        $[5] = t5;
        $[6] = t6;
    } else {
        t5 = $[5];
        t6 = $[6];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>{
            if (scheduledAtRef.current === null) return;
            remainingRef.current = Math.max(0, scheduledAtRef.current - Date.now());
            clearTimer();
        };
        $[7] = t7;
    } else t7 = $[7];
    const handlePauseTimer = t7;
    let t8;
    if ($[8] !== configuredDelayMs || $[9] !== isMinimized) {
        t8 = ()=>{
            if (isMinimized || configuredDelayMs === null || timeoutIdRef.current !== null) return;
            const minFloor = Math.min($c0d8764173773235$var$MIN_REMAINING_MS, configuredDelayMs);
            startTimer(Math.max(remainingRef.current, minFloor));
        };
        $[8] = configuredDelayMs;
        $[9] = isMinimized;
        $[10] = t8;
    } else t8 = $[10];
    const handleResumeTimer = t8;
    let t9;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = ()=>setIsMinimized(false);
        $[11] = t9;
    } else t9 = $[11];
    const handleExpandFromPill = t9;
    let t10;
    let t11;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = ()=>({
                minimize: ()=>setIsMinimized(true),
                expand: ()=>setIsMinimized(false)
            });
        t11 = [];
        $[12] = t10;
        $[13] = t11;
    } else {
        t10 = $[12];
        t11 = $[13];
    }
    (0, $cozmU.useImperativeHandle)(ref, t10, t11);
    if (!isThinking && isMinimized) setIsMinimized(false);
    const showPill = isMinimized && isThinking;
    const target = showPill ? "pill" : "full";
    let t12;
    let t13;
    if ($[14] !== displayedView || $[15] !== target) {
        t12 = ()=>{
            if (displayedView === target) return;
            const swapId = setTimeout(()=>setDisplayedView(target), $c0d8764173773235$var$TRANSITION_MS);
            return ()=>clearTimeout(swapId);
        };
        t13 = [
            target,
            displayedView
        ];
        $[14] = displayedView;
        $[15] = target;
        $[16] = t12;
        $[17] = t13;
    } else {
        t12 = $[16];
        t13 = $[17];
    }
    (0, $cozmU.useEffect)(t12, t13);
    const pillShown = displayedView === "pill";
    const pillExiting = pillShown && target === "full";
    const fullExiting = !pillShown && target === "pill";
    const t14 = testId ?? "rovo-thinking-minimization";
    const t15 = configuredDelayMs !== null && isThinking ? handlePauseTimer : undefined;
    const t16 = configuredDelayMs !== null && isThinking ? handleResumeTimer : undefined;
    const t17 = configuredDelayMs !== null && isThinking ? handlePauseTimer : undefined;
    const t18 = configuredDelayMs !== null && isThinking ? handleResumeTimer : undefined;
    let t19;
    if ($[18] !== pillExiting || $[19] !== pillProps || $[20] !== pillShown) {
        t19 = pillShown ? /*#__PURE__*/ $cozmU.createElement("span", {
            className: (0, $hekY6.default)([
                "_3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT",
                "_3Y6bKpZSoF",
                pillExiting && "",
                pillExiting && "_1gBibyfsJg _0nFVCGRLuw _43vdfTyNAO",
                !pillExiting && "",
                !pillExiting && "_1gBibyZMPz _0nFVCGRLuw _43vdfTjwM9 _1jakNnRLuw",
                "_0LqqFdYbGa"
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $9fef98e8a0a21e6b$export$1b83241eb743f10a), {
            ...pillProps,
            onClick: handleExpandFromPill
        })) : null;
        $[18] = pillExiting;
        $[19] = pillProps;
        $[20] = pillShown;
        $[21] = t19;
    } else t19 = $[21];
    const t20 = !pillShown && "_3Y6bKpZSoF";
    const t21 = !pillShown && fullExiting && "";
    const t22 = !pillShown && fullExiting && "_1gBiby5Akc _0nFVCGLrT7 _43vdfTyNAO";
    const t23 = !pillShown && !fullExiting && "";
    const t24 = !pillShown && !fullExiting && "_1gBibypn1L _0nFVCGLrT7 _43vdfT0Rsm";
    const t25 = !pillShown && "_0LqqFdYbGa";
    let t26;
    if ($[22] !== t20 || $[23] !== t21 || $[24] !== t22 || $[25] !== t23 || $[26] !== t24 || $[27] !== t25) {
        t26 = (0, $hekY6.default)([
            t20,
            t21,
            t22,
            t23,
            t24,
            t25
        ]);
        $[22] = t20;
        $[23] = t21;
        $[24] = t22;
        $[25] = t23;
        $[26] = t24;
        $[27] = t25;
        $[28] = t26;
    } else t26 = $[28];
    let t27;
    if ($[29] !== children || $[30] !== pillShown || $[31] !== t26) {
        t27 = /*#__PURE__*/ $cozmU.createElement("div", {
            hidden: pillShown,
            className: t26
        }, children);
        $[29] = children;
        $[30] = pillShown;
        $[31] = t26;
        $[32] = t27;
    } else t27 = $[32];
    let t28;
    if ($[33] !== t14 || $[34] !== t15 || $[35] !== t16 || $[36] !== t17 || $[37] !== t18 || $[38] !== t19 || $[39] !== t27) {
        t28 = /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": t14,
            onMouseEnter: t15,
            onMouseLeave: t16,
            onFocus: t17,
            onBlur: t18
        }, t19, t27);
        $[33] = t14;
        $[34] = t15;
        $[35] = t16;
        $[36] = t17;
        $[37] = t18;
        $[38] = t19;
        $[39] = t27;
        $[40] = t28;
    } else t28 = $[40];
    return t28;
} : function RovoThinkingMinimization({ children: children, pillProps: pillProps, autoMinimizeDelayMs: autoMinimizeDelayMs = $c0d8764173773235$var$DEFAULT_AUTO_MINIMIZE_DELAY_MS, isThinking: isThinking = true, testId: testId }, ref) {
    const [isMinimized, setIsMinimized] = (0, $cozmU.useState)(false); // The side currently occupying the layout. It lags behind the `showPill`
    // target during a swap so the outgoing side can finish its exit animation
    // (see the swap effect below) before the incoming side takes over.
    const [displayedView, setDisplayedView] = (0, $cozmU.useState)("full"); // `null` means auto-minimize is disabled; otherwise this *is* the delay
    // to use — one variable instead of a separate "is configured" flag plus
    // a redundantly-defaulted number.
    const configuredDelayMs = autoMinimizeDelayMs != null && autoMinimizeDelayMs > 0 ? autoMinimizeDelayMs : null;
    const timeoutIdRef = (0, $cozmU.useRef)(null);
    const scheduledAtRef = (0, $cozmU.useRef)(null);
    const remainingRef = (0, $cozmU.useRef)(0);
    const clearTimer = (0, $cozmU.useCallback)(()=>{
        if (timeoutIdRef.current !== null) {
            clearTimeout(timeoutIdRef.current);
            timeoutIdRef.current = null;
        }
        scheduledAtRef.current = null;
    }, []);
    const startTimer = (0, $cozmU.useCallback)((delay)=>{
        clearTimer();
        scheduledAtRef.current = Date.now() + delay;
        timeoutIdRef.current = setTimeout(()=>{
            timeoutIdRef.current = null;
            scheduledAtRef.current = null;
            setIsMinimized(true);
        }, delay);
    }, [
        clearTimer
    ]); // Starts a fresh, full-length countdown for every expanded session
    // (including on mount), and stops it once minimized.
    (0, $cozmU.useEffect)(()=>{
        if (!isThinking || isMinimized || configuredDelayMs === null) {
            clearTimer();
            return;
        }
        remainingRef.current = configuredDelayMs;
        startTimer(configuredDelayMs);
        return clearTimer;
    }, [
        isMinimized,
        isThinking,
        configuredDelayMs,
        startTimer,
        clearTimer
    ]);
    const handlePauseTimer = (0, $cozmU.useCallback)(()=>{
        if (scheduledAtRef.current === null) return; // not currently running
        remainingRef.current = Math.max(0, scheduledAtRef.current - Date.now());
        clearTimer();
    }, [
        clearTimer
    ]);
    const handleResumeTimer = (0, $cozmU.useCallback)(()=>{
        if (isMinimized || configuredDelayMs === null || timeoutIdRef.current !== null) return; // already minimized, disabled, or already running
        const minFloor = Math.min($c0d8764173773235$var$MIN_REMAINING_MS, configuredDelayMs);
        startTimer(Math.max(remainingRef.current, minFloor));
    }, [
        isMinimized,
        configuredDelayMs,
        startTimer
    ]);
    const handleExpandFromPill = (0, $cozmU.useCallback)(()=>setIsMinimized(false), []);
    (0, $cozmU.useImperativeHandle)(ref, ()=>({
            minimize: ()=>setIsMinimized(true),
            expand: ()=>setIsMinimized(false)
        }), []); // When thinking stops, drop any lingering minimized state so the next
    // thinking session starts from the full experience rather than the pill.
    // Done during render (React re-renders before committing) to avoid the
    // extra commit + effect pass an effect-based reset would trigger. The
    // guard keeps it from looping.
    if (!isThinking && isMinimized) setIsMinimized(false);
    const showPill = isMinimized && isThinking;
    const target = showPill ? "pill" : "full"; /**
                                                                                  * We have to use our own state to track transitions as ExitingPersistence won't keep the
                                                                                  * children's state (e.g. progress bars)
                                                                                  */ 
    (0, $cozmU.useEffect)(()=>{
        if (displayedView === target) return;
        const swapId = setTimeout(()=>setDisplayedView(target), $c0d8764173773235$var$TRANSITION_MS);
        return ()=>clearTimeout(swapId);
    }, [
        target,
        displayedView
    ]);
    const pillShown = displayedView === "pill"; // The pill is exiting while it's still displayed but the target has moved on.
    const pillExiting = pillShown && target === "full"; // The full view is exiting while it's still displayed but headed to the pill.
    const fullExiting = !pillShown && target === "pill";
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId ?? 'rovo-thinking-minimization',
        onMouseEnter: configuredDelayMs !== null && isThinking ? handlePauseTimer : undefined,
        onMouseLeave: configuredDelayMs !== null && isThinking ? handleResumeTimer : undefined,
        onFocus: configuredDelayMs !== null && isThinking ? handlePauseTimer : undefined,
        onBlur: configuredDelayMs !== null && isThinking ? handleResumeTimer : undefined
    }, pillShown ? /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT",
            "_3Y6bKpZSoF",
            pillExiting && "",
            pillExiting && "_1gBibyfsJg _0nFVCGRLuw _43vdfTyNAO",
            !pillExiting && "",
            !pillExiting && "_1gBibyZMPz _0nFVCGRLuw _43vdfTjwM9 _1jakNnRLuw",
            "_0LqqFdYbGa"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $9fef98e8a0a21e6b$export$1b83241eb743f10a), {
        ...pillProps,
        onClick: handleExpandFromPill
    })) : null, /*#__PURE__*/ $cozmU.createElement("div", {
        hidden: pillShown,
        className: (0, $hekY6.default)([
            !pillShown && "_3Y6bKpZSoF",
            !pillShown && fullExiting && "",
            !pillShown && fullExiting && "_1gBiby5Akc _0nFVCGLrT7 _43vdfTyNAO",
            !pillShown && !fullExiting && "",
            !pillShown && !fullExiting && "_1gBibypn1L _0nFVCGLrT7 _43vdfT0Rsm",
            !pillShown && "_0LqqFdYbGa"
        ])
    }, children));
});



var $eR1aL = parcelRequire("eR1aL");















var $4m5jb = parcelRequire("4m5jb");


var $igOtY = parcelRequire("igOtY");


var $3TxKn = parcelRequire("3TxKn");

var $kuGC4 = parcelRequire("kuGC4");



var $eBgZa = parcelRequire("eBgZa");

const $2aabca309590cf92$var$KNOWN_TEMPLATES = new Set([
    'RATE_LIMIT',
    'ACCEPTABLE_USE_VIOLATIONS',
    'TOKEN_LIMIT_EXCEEDED'
]);
// Reads the raw StreamError frame directly (onError's input); other inputs go through ai-mate's
// createStoreError (shared with Rovo inline chat) to stay in lockstep for thrown error classes.
const $2aabca309590cf92$var$extractErrorFields = (error)=>{
    const frameMessage = error?.message;
    if (frameMessage && (frameMessage.message_template || frameMessage.status_code !== undefined)) return {
        message_template: frameMessage.message_template,
        status_code: frameMessage.status_code
    };
    const { message_template: message_template, status_code: status_code } = (0, $eBgZa.createStoreError)(error);
    return {
        message_template: message_template,
        status_code: status_code
    };
};
const $2aabca309590cf92$export$41586e6680e6a992 = (error)=>{
    const { message_template: message_template, status_code: status_code } = $2aabca309590cf92$var$extractErrorFields(error);
    if (message_template && $2aabca309590cf92$var$KNOWN_TEMPLATES.has(message_template)) return message_template;
    if (status_code === 429) return 'RATE_LIMIT';
    return 'UNKNOWN';
};



const $4ad7534fec02b2d0$export$20928c7586c5104e = (precedingText)=>({
        type: 'doc',
        version: 1,
        content: [
            {
                type: 'paragraph',
                content: [
                    {
                        type: 'text',
                        text: precedingText
                    },
                    {
                        type: 'inlineExtension',
                        attrs: {
                            extensionKey: 'skill:skillTag',
                            extensionType: 'com.atlassian.rovo.skill',
                            parameters: {
                                slug: 'add-suggestions-to-content'
                            }
                        }
                    }
                ]
            }
        ]
    });
const $4ad7534fec02b2d0$export$514433bce93f0391 = (text)=>({
        type: 'doc',
        version: 1,
        content: [
            {
                type: 'paragraph',
                content: [
                    {
                        type: 'text',
                        text: text
                    }
                ]
            }
        ]
    });
function $4ad7534fec02b2d0$export$d4b080f8bd589023({ api: api, thinkingStatus: thinkingStatus, isRovoMounted: isRovoMounted }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createConversationOptimistically: createConversationOptimistically, sendMessage: sendMessage, abortRequests: abortRequests, setConversationData: setConversationData, setSelectedConversation: setSelectedConversation } = (0, $3TxKn.useChatStoreActions)();
    // Resolves (and provisions) the agent the prompt is sent at. Stable, so it can't re-trigger
    // the send effect mid-session.
    const { resolveAgent: resolveAgent } = (0, $b272a1ed87714e54$export$a966ab2407ae668d)({
        api: api
    });
    // The legacy route owns its optimistic id. Content Reviewer starts from AI Mate's
    // supported empty slot and records the canonical id minted by the first-message flow.
    const conversationIdRef = (0, $cozmU.useRef)(null);
    if (!(0, $iDrrr.fg)('content_reviewer_agent') && thinkingStatus === 'thinking' && !conversationIdRef.current) conversationIdRef.current = crypto.randomUUID();
    const legacyConversationId = conversationIdRef.current;
    const contentReviewerConversationIdRef = (0, $cozmU.useRef)(null);
    const [contentReviewerConversationId, setContentReviewerConversationId] = (0, $cozmU.useState)(null);
    const sessionRef = (0, $cozmU.useRef)(null);
    if (thinkingStatus === 'thinking' && !sessionRef.current) sessionRef.current = {};
    const session = thinkingStatus === 'thinking' ? sessionRef.current : null;
    const activeConversation = (0, $kuGC4.useConversationById)({
        conversationId: (0, $iDrrr.fg)('content_reviewer_agent') ? contentReviewerConversationId ?? '' : legacyConversationId ?? ''
    });
    // The stream callbacks are created once at send time but fire later, after Rovo
    // may have mounted/unmounted. Read the latest value through a ref so completion
    // branches on the current mount state (matching the old status-driven effect).
    const isRovoMountedRef = (0, $cozmU.useRef)(isRovoMounted);
    isRovoMountedRef.current = isRovoMounted;
    /**
   * Backend assigned assistant_message_id to be used as
   * singleInstrumentationId for Unified Instrumentation Events.
   *
   * Stub for now until we have unified analytics
   */ const [_, setAssistantMessageId] = (0, $cozmU.useState)(undefined);
    // Kick off the add-suggestions-to-content skill once per thinking session.
    (0, $cozmU.useEffect)(()=>{
        if (!session) return;
        const promptPrefix = formatMessage((0, $gVCFw.aiSuggestionsMessages).suggestEditsPromptPrefix);
        const agentPrompt = formatMessage((0, $gVCFw.aiSuggestionsMessages).contentReviewAgentPrompt);
        let didFireStreamErrorAnalytics = false;
        let cancelled = false;
        /**
     * Provisioning and resolving the agent are slow, so the session can end while
     * `run` is still between awaits. Everything that dispatches after an await —
     * sending the prompt, driving the thinking state — has to check this first.
     * The ref no longer holding this session's id means the abort effect cleared
     * it (user stopped) or a later render minted a new one; the flag covers this
     * effect being torn down, which the ref alone doesn't catch.
     */ const isCancelled = ()=>cancelled || sessionRef.current !== session;
        const run = async ()=>{
            let contentReviewerAgent;
            if ((0, $iDrrr.fg)('content_reviewer_agent')) {
                contentReviewerConversationIdRef.current = (0, $4m5jb.EMPTY_CONVERSATION_ID);
                setContentReviewerConversationId((0, $4m5jb.EMPTY_CONVERSATION_ID));
                await createConversationOptimistically({
                    id: (0, $4m5jb.EMPTY_CONVERSATION_ID),
                    status: (0, $igOtY.CHAT_STORE_STATUS).loadingChat
                });
                if (isCancelled()) return;
                contentReviewerAgent = await resolveAgent();
                // The empty-agent branch below dispatches and then returns, so it never
                // reaches the check before the send — it needs its own.
                if (isCancelled()) return;
                if (!contentReviewerAgent) {
                    // No agent to run the skill: clean up the store and show the error screen.
                    await setConversationData({
                        conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID),
                        data: {
                            status: (0, $igOtY.CHAT_STORE_STATUS).idle
                        }
                    });
                    (0, $2a4bc64013915ea2$export$340d751fde574e23)(api?.analytics?.actions);
                    api?.aiSuggestions?.actions.setThinkingState('error');
                    return;
                }
                await setConversationData({
                    conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID),
                    data: {
                        sourceAgentId: contentReviewerAgent.id,
                        agent: {
                            agent_id: contentReviewerAgent.id,
                            agent_named_id: contentReviewerAgent.external_config_reference ?? contentReviewerAgent.named_id,
                            agent_name: contentReviewerAgent.name,
                            creator_type: contentReviewerAgent.creator_type,
                            is_default: contentReviewerAgent.is_default,
                            identity_account_id: contentReviewerAgent.identity_account_id ?? undefined
                        }
                    }
                });
            } else if (legacyConversationId) await createConversationOptimistically({
                id: legacyConversationId
            });
            if (isCancelled()) return;
            await sendMessage({
                // The agent has the add-suggestions-to-content skill built in, so it only needs a
                // plain review prompt. Without the agent the skill has to be invoked explicitly.
                prompt: (0, $iDrrr.fg)('content_reviewer_agent') ? $4ad7534fec02b2d0$export$514433bce93f0391(agentPrompt) : $4ad7534fec02b2d0$export$20928c7586c5104e(promptPrefix),
                conversationId: (0, $iDrrr.fg)('content_reviewer_agent') ? (0, $4m5jb.EMPTY_CONVERSATION_ID) : legacyConversationId ?? undefined,
                // If contentReviewerAgent is undefined it won't go to agent
                agent: contentReviewerAgent,
                storeUserMessages: true,
                fastModeEnabled: true,
                addCurrentPageAsContextUserPreference: true,
                /**
         * This fires when the temporary message id is replaced with the
         * backend-assigned assistant_message_id.
         */ onTempMessageIdReplacedOverride: (_, newId)=>{
                    setAssistantMessageId(newId);
                },
                ...(0, $iDrrr.fg)('content_reviewer_agent') ? {
                    onNewConversationIdAvailable: (conversationId)=>{
                        if (isCancelled()) return;
                        contentReviewerConversationIdRef.current = conversationId;
                        setContentReviewerConversationId(conversationId);
                    }
                } : {},
                promptStreamHook: {
                    /**
           * Fires when the FINAL_RESPONSE stream chunk is processed — the
           * add-suggestions-to-content skill has produced its answer.
           *   - Rovo mounted   → setThinkingState('idle') (Rovo chat takes over, no bar)
           *   - Rovo unmounted → refreshSuggestions then setThinkingState('complete')
           *
           * Ignored once cancelled, so a late response can't reopen the bar.
           */ onFinalResponse: ()=>{
                        if (isCancelled()) return Promise.resolve();
                        if (isRovoMountedRef.current) api?.aiSuggestions?.actions.setThinkingState('idle');
                        else {
                            api?.aiSuggestions?.actions.refreshSuggestions();
                            api?.aiSuggestions?.actions.setThinkingState('complete');
                        }
                        return Promise.resolve();
                    },
                    /**
           * Fires on an in-stream ERROR / ACTION_ERROR chunk, and on send rejection —
           * which includes the `AbortError` from stopping, hence the cancel check.
           */ onError: (error)=>{
                        if (isCancelled()) return Promise.resolve();
                        didFireStreamErrorAnalytics = true;
                        (0, $2a4bc64013915ea2$export$c2bc44992302850a)(api?.analytics?.actions, error);
                        // Classify the backend error so the bar shows the matching copy/links.
                        api?.aiSuggestions?.actions.setThinkingState('error', {
                            template: (0, $2aabca309590cf92$export$41586e6680e6a992)(error)
                        });
                        return Promise.resolve();
                    }
                }
            });
        };
        run().catch((error)=>{
            // Stopping the session aborts the in-flight request, so the rejection that
            // follows is the expected outcome of a user cancellation rather than a
            // failure worth reporting — and stopping again would end whichever session
            // is current by now.
            if (isCancelled()) return;
            if (!didFireStreamErrorAnalytics) (0, $2a4bc64013915ea2$export$4ca37dd723b35752)(api?.analytics?.actions, error);
            if ((0, $iDrrr.fg)('content_reviewer_agent')) setConversationData({
                conversationId: contentReviewerConversationIdRef.current ?? (0, $4m5jb.EMPTY_CONVERSATION_ID),
                data: {
                    status: (0, $igOtY.CHAT_STORE_STATUS).idle
                }
            });
            api?.aiSuggestions?.actions.setThinkingState('error');
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        session,
        api,
        createConversationOptimistically,
        legacyConversationId,
        sendMessage,
        setConversationData,
        formatMessage,
        resolveAgent
    ]);
    // Clear the conversation id (and abort any in-flight request) whenever a
    // thinking session ends (both 'idle' and 'complete'). Clearing on 'complete'
    // lets a second "Review" mint a fresh id and re-trigger the skill — otherwise
    // it reused the stale id and did nothing.
    (0, $cozmU.useEffect)(()=>{
        if (thinkingStatus === 'thinking') return;
        const conversationId = (0, $iDrrr.fg)('content_reviewer_agent') ? contentReviewerConversationIdRef.current : conversationIdRef.current;
        if (conversationId) abortRequests?.({
            conversationId: conversationId
        });
        conversationIdRef.current = null;
        contentReviewerConversationIdRef.current = null;
        setContentReviewerConversationId(null);
        sessionRef.current = null;
        setAssistantMessageId(undefined);
    }, [
        thinkingStatus,
        abortRequests
    ]);
    // React to conversation status changes reported by the store and drive the
    // editor thinking state accordingly:
    //   - store idle + Rovo mounted   → setThinkingState('idle') (Rovo chat takes over)
    //   - store idle + Rovo unmounted → setThinkingState('complete')
    //   - deactivatedAgentError       → setThinkingState('error')
    (0, $cozmU.useEffect)(()=>{
        /**
     * Note - because promptStreamHook already handles onFinalResponse,
     * this hook shouldn't need to do anything unless the conversation
     * somehow terminates without a final response (e.g. deactivatedAgentError)
     * or has an error that isn't caught by onError.
     */ if (!activeConversation) return;
        if ((0, $iDrrr.fg)('content_reviewer_agent') && activeConversation.id !== contentReviewerConversationIdRef.current) return;
        switch(activeConversation.status){
            case (0, $igOtY.CHAT_STORE_STATUS).idle:
                // Returning to idle mid-thinking means the session finished. The first
                // idle has lastAgentMessageStatus undefined; once set, it's done.
                if (thinkingStatus === 'thinking' && activeConversation.lastAgentMessageStatus !== undefined) {
                    // FAILED/CANCELLED means no suggestions — show the error screen
                    // instead of completing (which would overwrite the error state).
                    const lastAgentMessageFailed = activeConversation.lastAgentMessageStatus === 'FAILED' || activeConversation.lastAgentMessageStatus === 'CANCELLED';
                    if (lastAgentMessageFailed) api?.aiSuggestions?.actions.setThinkingState('error');
                    else if (isRovoMountedRef.current) // Rovo chat is open, so don't show the thinking bar on completion.
                    api?.aiSuggestions?.actions.setThinkingState('idle');
                    else {
                        api?.aiSuggestions?.actions.refreshSuggestions();
                        api?.aiSuggestions?.actions.setThinkingState('complete');
                    }
                } else if (thinkingStatus === 'thinking' && !(0, $iDrrr.fg)('content_reviewer_agent') && isRovoMountedRef.current) api?.aiSuggestions?.actions.setThinkingState('idle');
                break;
            case (0, $igOtY.CHAT_STORE_STATUS).deactivatedAgentError:
                (0, $2a4bc64013915ea2$export$b36e176162c1ac33)(api?.analytics?.actions);
                api?.aiSuggestions?.actions.setThinkingState('error');
                break;
        }
    }, [
        activeConversation,
        api,
        thinkingStatus
    ]);
    // When Rovo chat is open and a conversation is active, surface it in the
    // Rovo panel so the user can follow along in real time.
    (0, $cozmU.useEffect)(()=>{
        const conversationId = (0, $iDrrr.fg)('content_reviewer_agent') ? contentReviewerConversationId : legacyConversationId;
        if (isRovoMounted && thinkingStatus !== 'idle' && conversationId) setSelectedConversation({
            conversationId: conversationId
        });
    }, [
        contentReviewerConversationId,
        isRovoMounted,
        legacyConversationId,
        setSelectedConversation,
        thinkingStatus
    ]);
}





const $7dbfdbb5e4f21539$var$selectThinkingStatus = (state)=>state?.thinkingStatus;
const $7dbfdbb5e4f21539$export$ddd92d4bbdb8026a = (api)=>{
    const [thinkingStatus, setThinkingStatus] = (0, $cozmU.useState)(()=>$7dbfdbb5e4f21539$var$selectThinkingStatus(api?.aiSuggestions?.sharedState.currentState()));
    (0, $cozmU.useEffect)(()=>{
        const aiSuggestions = api?.aiSuggestions;
        if (!aiSuggestions) return;
        // Re-read once at subscription time so we don't miss a transaction that fired between
        // the initial render and the effect commit.
        setThinkingStatus($7dbfdbb5e4f21539$var$selectThinkingStatus(aiSuggestions.sharedState.currentState()));
        return aiSuggestions.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            setThinkingStatus($7dbfdbb5e4f21539$var$selectThinkingStatus(nextSharedState));
        });
    }, [
        api
    ]);
    return thinkingStatus;
};





function $087d4f5bdd623c49$export$7db74264aed7f36b(formatMessage) {
    return [
        formatMessage((0, $gVCFw.aiSuggestionsMessages).thinkingReviewingContent),
        formatMessage((0, $gVCFw.aiSuggestionsMessages).thinkingMayTakeAFewMinutes),
        formatMessage((0, $gVCFw.aiSuggestionsMessages).thinkingAnalyzingStructure),
        formatMessage((0, $gVCFw.aiSuggestionsMessages).thinkingCheckingRelatedSources),
        formatMessage((0, $gVCFw.aiSuggestionsMessages).thinkingGatheringContext),
        formatMessage((0, $gVCFw.aiSuggestionsMessages).thinkingIdentifyingImprovements),
        formatMessage((0, $gVCFw.aiSuggestionsMessages).thinkingEvaluatingOptions),
        formatMessage((0, $gVCFw.aiSuggestionsMessages).thinkingCheckingConsistency),
        formatMessage((0, $gVCFw.aiSuggestionsMessages).thinkingPreparingSuggestions),
        formatMessage((0, $gVCFw.aiSuggestionsMessages).thinkingRefiningSuggestions),
        formatMessage((0, $gVCFw.aiSuggestionsMessages).thinkingFinalizingSuggestionsForReview)
    ];
}
function $087d4f5bdd623c49$export$4dbf531e0d81d760(formatMessage, agentName) {
    return formatMessage((0, $gVCFw.aiSuggestionsMessages).thinkingReviewingContentWithAgent, {
        agentName: agentName
    });
}


const $031367d96107a088$var$AUTO_CLOSE_DELAY_MS = 3000;
const $031367d96107a088$var$styles = {
    container: "_1mT5xdy1CL _0Bm75GNHnM _4ouGXIHakr _42Yu6BFIQA _3OE6xY715P _1VJPcajssS",
    resizableContainer: "_1EqgXlgxv1",
    hidden: "_3iDTPbYbGa"
};
function $031367d96107a088$export$58900a3f971bc8cc({ api: api, editorView: editorView }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const thinkingStatus = (0, $7dbfdbb5e4f21539$export$ddd92d4bbdb8026a)(api);
    const minimizationRef = (0, $cozmU.useRef)(null);
    const isRequestingInlineCommentCloseRef = (0, $cozmU.useRef)(false); /**
                                                            * We use this to detect when to hide / show the thinking component
                                                            */ 
    const { mounted: isRovoMounted } = (0, $bGNkz.useUIStore)();
    const { firstSuggestionId: firstSuggestionId, isHidden: isHidden, thinkingStartedAt: thinkingStartedAt, thinkingProgressTarget: thinkingProgressTarget, thinkingError: thinkingError } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiSuggestions',
        'editorViewMode'
    ], (state)=>({
            firstSuggestionId: state?.aiSuggestionsState?.orderedSuggestionIds?.[0],
            // View mode is a hard override: never show the suggestions UI while read-only.
            isHidden: (state?.aiSuggestionsState?.isHidden ?? false) || state?.editorViewModeState?.mode === 'view',
            // Shared thinking-session anchor so this bar and the sidebar bar keep
            // their progress/rotation in sync across mount/unmount.
            thinkingStartedAt: state?.aiSuggestionsState?.thinkingStartedAt ?? null,
            thinkingProgressTarget: state?.aiSuggestionsState?.thinkingProgressTarget ?? null,
            thinkingError: state?.aiSuggestionsState?.thinkingError ?? null
        }));
    (0, $4ad7534fec02b2d0$export$d4b080f8bd589023)({
        api: api,
        thinkingStatus: thinkingStatus,
        isRovoMounted: isRovoMounted
    });
    const [agent, setAgent] = (0, $cozmU.useState)();
    const { resolveAgent: resolveAgent } = (0, $b272a1ed87714e54$export$a966ab2407ae668d)({
        api: api
    }); // Resolve the reviewing agent up front — this component is always mounted, so
    // the lookup runs well before the user triggers a review. That way the first
    // thinking status can name the agent and show its avatar from the very first
    // frame, instead of showing the generic status and swapping the agent in mid
    // rotation once a lookup started at thinking-time resolves. The agent store
    // caches the lookup, so this doesn't refetch. Gated on the same flag that
    // determines whether an agent actually handles the review.
    (0, $cozmU.useEffect)(()=>{
        if (agent || !(0, $iDrrr.fg)('content_reviewer_agent')) return;
        let isActive = true;
        const abortController = new AbortController();
        resolveAgent({
            signal: abortController.signal
        }).then((resolved)=>{
            if (isActive && resolved) setAgent(resolved);
        });
        return ()=>{
            isActive = false;
            abortController.abort();
        };
    }, [
        agent,
        resolveAgent
    ]); // Collapse the thinking bar into the pill as soon as the user scrolls the
    // editor, so it stays out of the way while they read/navigate. Only wired up
    // while actively thinking (the pill is only shown then); the listener binds
    // to the editor's real overflow-scroll ancestor, falling back to the window
    // when the page itself scrolls.
    (0, $cozmU.useEffect)(()=>{
        if (thinkingStatus !== 'thinking' || !editorView) return;
        const scrollTarget = (0, $1jz5K.findOverflowScrollParent)(editorView.dom) || window;
        return (0, $cbY7C.bind)(scrollTarget, {
            type: 'scroll',
            listener: ()=>{
                minimizationRef.current?.minimize();
            },
            options: {
                passive: true
            }
        });
    }, [
        editorView,
        thinkingStatus
    ]);
    const handleStop = (0, $cozmU.useCallback)(()=>{
        api?.aiSuggestions?.actions.setThinkingState('idle');
    }, [
        api
    ]);
    const onViewSuggestions = (0, $cozmU.useCallback)(()=>{
        const viewSuggestions = async ()=>{
            if ((0, $2pQiO.UNSAFE_expValNoExposure)('confluence_suggested_edits_inline_comment_fix', 'isEnabled', false)) {
                if (isRequestingInlineCommentCloseRef.current) return;
                isRequestingInlineCommentCloseRef.current = true;
                const canCloseComment = await (api?.annotation?.actions.requestCloseInlineComment?.() ?? Promise.resolve(true)).finally(()=>{
                    isRequestingInlineCommentCloseRef.current = false;
                });
                if (!canCloseComment) return;
            }
            api?.aiSuggestions?.actions.setThinkingState('idle');
            api?.aiSuggestions?.actions.selectSuggestion(firstSuggestionId ?? null, firstSuggestionId ? {
                interactionPoint: 'statusBar'
            } : undefined);
        };
        viewSuggestions();
    }, [
        api,
        firstSuggestionId
    ]);
    const agentName = agent?.name?.trim();
    const customRotatingMessages = (0, $cozmU.useMemo)(()=>(0, $087d4f5bdd623c49$export$7db74264aed7f36b)(formatMessage), [
        formatMessage
    ]); // Once the reviewing agent resolves, override the first status to name it and
    // show its avatar in place of the usual thinking icon.
    const firstMessage = (0, $cozmU.useMemo)(()=>{
        if (!agent || !agentName) return undefined;
        return {
            text: (0, $087d4f5bdd623c49$export$4dbf531e0d81d760)(formatMessage, agentName),
            icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6gGPb.AgentAvatar), {
                agentId: agent.id,
                agentNamedId: agent.external_config_reference ?? agent.named_id,
                agentIdentityAccountId: agent.identity_account_id,
                size: "small",
                showBorder: false
            })
        };
    }, [
        agent,
        agentName,
        formatMessage
    ]); // When the auto-close timer fires, only dismiss (return to idle) if there
    // are no suggestions — matching the legacy ThinkingTransitionWrapper
    // behaviour where the complete bar stayed visible until the user clicked
    // "View Suggestions" or "Close".
    const handleClose = (0, $cozmU.useCallback)(()=>{
        api?.aiSuggestions?.actions.setThinkingState('idle');
    }, [
        api
    ]);
    const handleTryAgain = (0, $cozmU.useCallback)(()=>{
        api?.aiSuggestions?.actions.setThinkingState('thinking', {
            isRetry: true
        });
    }, [
        api
    ]);
    const isError = thinkingStatus === 'error';
    const isReady = thinkingStatus === 'complete';
    const hasSuggestions = !!firstSuggestionId;
    const readyText = hasSuggestions ? formatMessage((0, $iDrrr.fg)('rovo_ready_bar_ui_update') ? (0, $gVCFw.aiSuggestionsMessages).thinkingCompleteReviewCompleteUpdated : (0, $gVCFw.aiSuggestionsMessages).thinkingCompleteReviewComplete) : formatMessage((0, $iDrrr.fg)('rovo_ready_bar_ui_update') ? (0, $gVCFw.aiSuggestionsMessages).thinkingCompleteNoSuggestionsUpdated : (0, $gVCFw.aiSuggestionsMessages).thinkingCompleteNoSuggestions);
    const thinkingBarProps = (0, $cozmU.useMemo)(()=>({
            onStop: handleStop,
            showProgressBar: true,
            useRotatingTitle: true,
            customRotatingMessages: customRotatingMessages,
            startedAt: thinkingStartedAt,
            progressTarget: thinkingProgressTarget,
            firstMessage: firstMessage
        }), [
        handleStop,
        customRotatingMessages,
        thinkingStartedAt,
        thinkingProgressTarget,
        firstMessage
    ]);
    const thinkingReadyProps = (0, $cozmU.useMemo)(()=>({
            onClose: handleClose,
            onView: hasSuggestions ? onViewSuggestions : undefined,
            readyText: readyText
        }), [
        handleClose,
        hasSuggestions,
        onViewSuggestions,
        readyText
    ]); // Resolve the error copy/links from the template, mirroring inline chat's ErrorView.
    const { errorText: errorText, canRetry: canRetry } = (0, $cozmU.useMemo)(()=>{
        switch(thinkingError?.template){
            case 'RATE_LIMIT':
                return {
                    errorText: formatMessage((0, $doA2E.default).rateLimited, {
                        a: (chunks)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $7vK9E.Anchor), {
                                href: "https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/",
                                target: "_blank",
                                children: chunks
                            })
                    }),
                    canRetry: false
                };
            case 'ACCEPTABLE_USE_VIOLATIONS':
                return {
                    errorText: formatMessage((0, $doA2E.default).aupViolation, {
                        a: (chunks)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $7vK9E.Anchor), {
                                href: "https://www.atlassian.com/legal/acceptable-use-policy",
                                target: "_blank",
                                children: chunks
                            })
                    }),
                    canRetry: false
                };
            case 'TOKEN_LIMIT_EXCEEDED':
                return {
                    errorText: formatMessage((0, $gVCFw.aiSuggestionsMessages).thinkingErrorTokenLimitExceeded),
                    canRetry: true
                };
            default:
                return {
                    errorText: formatMessage((0, $doA2E.default).unknownError),
                    canRetry: true
                };
        }
    }, [
        thinkingError,
        formatMessage
    ]);
    const thinkingErrorProps = (0, $cozmU.useMemo)(()=>({
            onClose: handleClose,
            // Hide "Try again" for non-retryable errors (rate limit, AUP).
            onTryAgain: canRetry ? handleTryAgain : undefined,
            errorText: errorText
        }), [
        handleClose,
        handleTryAgain,
        canRetry,
        errorText
    ]);
    if (thinkingStatus === 'idle' || thinkingStatus === undefined) return null;
     // Errors bypass the isRovoMounted hide so they show even when Rovo chat is open.
    const isContainerHidden = isError ? isHidden : isRovoMounted || isHidden;
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            $031367d96107a088$var$styles.container,
            (0, $iDrrr.fg)('rovo_ready_bar_ui_update') && $031367d96107a088$var$styles.resizableContainer,
            isContainerHidden && $031367d96107a088$var$styles.hidden
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c0d8764173773235$export$3582558a29e46c9d), {
            ref: minimizationRef,
            isThinking: thinkingStatus === 'thinking',
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3sXr4.RovoThinkingBarWrapper), {
                isThinking: thinkingStatus === 'thinking',
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eR1aL.RovoThinkingReadyTransition), {
                    isReady: isReady,
                    autoClose: !hasSuggestions,
                    autoCloseDelay: $031367d96107a088$var$AUTO_CLOSE_DELAY_MS,
                    resizeToReadyContent: (0, $iDrrr.fg)('rovo_ready_bar_ui_update'),
                    thinkingBarProps: thinkingBarProps,
                    thinkingReadyProps: thinkingReadyProps,
                    isError: isError,
                    thinkingErrorProps: thinkingErrorProps
                })
            })
        })
    });
}


















var $3nacY = parcelRequire("3nacY");

var $hVLmg = parcelRequire("hVLmg");


var $7T88d = parcelRequire("7T88d");

var $6t3CY = parcelRequire("6t3CY");

var $5AKbu = parcelRequire("5AKbu");











const $73af48bb16180a81$export$b8df0cc5d101b7a3 = ()=>{
    const exposedEntryPoints = new Set();
    return {
        hasBeenExposed: (entryPoint)=>exposedEntryPoints.has(entryPoint),
        markExposed: (entryPoint)=>{
            exposedEntryPoints.add(entryPoint);
        }
    };
};
const $73af48bb16180a81$export$461fbf8dec24c525 = ({ api: api, entryPoint: entryPoint, exposureSession: exposureSession })=>{
    const buttonRef = (0, $cozmU.useRef)(null);
    const hasFiredRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        const element = buttonRef.current;
        if (!element || hasFiredRef.current || exposureSession.hasBeenExposed(entryPoint)) return;
        const fireIfVisible = ()=>{
            if (hasFiredRef.current || exposureSession.hasBeenExposed(entryPoint)) return;
            const style = window.getComputedStyle(element);
            const isVisible = style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
            if (isVisible) {
                (0, $2a4bc64013915ea2$export$5a116e8d20eb61e1)(api?.analytics?.actions, entryPoint);
                hasFiredRef.current = true;
                exposureSession.markExposed(entryPoint);
            }
        };
        // In tests or older browsers, wait one frame so layout/CSS can settle before checking visibility.
        if (typeof window.IntersectionObserver === 'undefined') {
            const frame = window.requestAnimationFrame(fireIfVisible);
            return ()=>window.cancelAnimationFrame(frame);
        }
        // Watch for the button becoming visible after responsive/container-query layout resolves.
        const observer = new window.IntersectionObserver(([entry])=>{
            if (entry?.isIntersecting) {
                fireIfVisible();
                observer.disconnect();
            }
        });
        observer.observe(element);
        return ()=>observer.disconnect();
    }, [
        api,
        entryPoint,
        exposureSession
    ]);
    return buttonRef;
};


const $f0a9c0a88855b568$var$AiSuggestionsButton = ({ api: api, exposureSession: exposureSession })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const label = formatMessage((0, $gVCFw.aiSuggestionsMessages).suggestEditsButtonLabel);
    const exposureRef = (0, $73af48bb16180a81$export$461fbf8dec24c525)({
        api: api,
        entryPoint: 'primaryToolbar',
        exposureSession: exposureSession
    });
    const isThinking = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiSuggestions'
    ], (state)=>state.aiSuggestionsState?.thinkingStatus === 'thinking');
    const handleClick = (0, $cozmU.useCallback)(()=>{
        if (isThinking) return;
        api?.aiSuggestions?.actions.setThinkingState('thinking', {
            entryPoint: 'primaryToolbar'
        });
    }, [
        api,
        isThinking
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
        content: formatMessage((0, $gVCFw.aiSuggestionsMessages).suggestEditsButtonTooltip),
        position: "bottom",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6t3CY.ToolbarButton), {
            ref: exposureRef,
            onClick: handleClick,
            testId: "editor-toolbar__ai-suggestions-button",
            iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4u3xL))), {
                label: label,
                size: "small"
            }),
            ignoreInteractionDisabled: true,
            isDisabled: isThinking,
            children: label
        })
    });
};
const $f0a9c0a88855b568$export$e43f2f89cc843502 = ({ api: api })=>{
    // Scope exposure tracking to this toolbar registration, not the whole browser session.
    const exposureSession = (0, $73af48bb16180a81$export$b8df0cc5d101b7a3)();
    return [
        // AI SUGGESTIONS GROUP — only registered in the pinned primary toolbar sections,
        // not in AI_SECTION (which is used by the floating toolbar).
        //
        // The group wraps its children in <Show above="lg"> so it hides below the breakpoint
        {
            type: (0, $3nacY.AI_SUGGESTIONS_GROUP).type,
            key: (0, $3nacY.AI_SUGGESTIONS_GROUP).key,
            parents: [
                {
                    type: (0, $3nacY.AI_SECTION).type,
                    key: (0, $3nacY.AI_SECTION_FULL_PAGE_PRIMARY_TOOLBAR).key,
                    rank: (0, $hVLmg.AI_SECTION_RANK)[(0, $3nacY.AI_SUGGESTIONS_GROUP).key]
                },
                {
                    type: (0, $3nacY.AI_SECTION).type,
                    key: (0, $3nacY.AI_SECTION_COMMENT_PRIMARY_TOOLBAR).key,
                    rank: (0, $hVLmg.AI_SECTION_RANK)[(0, $3nacY.AI_SUGGESTIONS_GROUP).key]
                },
                {
                    type: (0, $3nacY.AI_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $3nacY.AI_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $hVLmg.AI_SECTION_RANK)[(0, $3nacY.AI_SUGGESTIONS_GROUP).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $7T88d.Show), {
                    above: "lg",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5AKbu.ToolbarButtonGroup), {
                        children: children
                    })
                })
        },
        // AI SUGGESTIONS BUTTON — shown as a full labelled button when space is available
        // (via AI_SUGGESTIONS_GROUP above "lg"), or as an icon-only button with tooltip
        // inside ROVO_GROUP_DISPLAY_SMALL when space is tight (below "lg").
        {
            type: (0, $3nacY.AI_SUGGESTIONS_BUTTON).type,
            key: (0, $3nacY.AI_SUGGESTIONS_BUTTON).key,
            parents: [
                {
                    type: (0, $3nacY.AI_SUGGESTIONS_GROUP).type,
                    key: (0, $3nacY.AI_SUGGESTIONS_GROUP).key,
                    rank: (0, $hVLmg.AI_SUGGESTIONS_GROUP_RANK)[(0, $3nacY.AI_SUGGESTIONS_BUTTON).key]
                },
                {
                    type: (0, $3nacY.ROVO_GROUP_DISPLAY_SMALL).type,
                    key: (0, $3nacY.ROVO_GROUP_DISPLAY_SMALL).key,
                    rank: (0, $hVLmg.ROVO_GROUP_DISPLAY_SMALL_RANK)[(0, $3nacY.AI_SUGGESTIONS_BUTTON).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)($f0a9c0a88855b568$var$AiSuggestionsButton, {
                    api: api,
                    exposureSession: exposureSession
                })
        }
    ];
};


const $bd706ffb3e69dbe0$export$e4fa509a217898d8 = ({ api: api, config: config })=>{
    const { contentAri: contentAri, onShowSidebar: onShowSidebar, ConversationAssistant: ConversationAssistant, onSubmitSuggestionFeedback: onSubmitSuggestionFeedback } = config;
    if (api?.toolbar) api.toolbar.actions.registerComponents((0, $f0a9c0a88855b568$export$e43f2f89cc843502)({
        api: api
    }));
    // EDITOR-8771: prefer the right surface via the UI Control Registry API once the migration
    // gate is on, falling back to the legacy widget decoration built in `calculateSuggestionsDecorations`
    // (see `main.tsx`) when it is off.
    if ((0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration')) {
        const suggestionRightSurfaceButton = {
            component: ({ surfaceContext: surfaceContext })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $92877f9d742eca51$export$509594734c522b9c), {
                    surfaceContext: surfaceContext,
                    api: api
                }),
            isHidden: ({ surfaceContext: surfaceContext } = {})=>{
                const context = surfaceContext?.get((0, $jbxiN.BLOCK_CONTROL_UI_CONTEXT));
                const localId = context?.targetNode.node.attrs?.localId;
                if (!localId) return true;
                const suggestionIds = api?.aiSuggestions?.sharedState.currentState()?.suggestionIdsByBaseLocalId.get(localId);
                return !suggestionIds || suggestionIds.size === 0;
            },
            key: 'ai-suggestions-right-surface-button',
            parents: [
                {
                    ...(0, $eRJEr.BLOCK_CONTROLS_RIGHT_GROUP),
                    rank: 100
                }
            ],
            type: 'button'
        };
        api?.uiControlRegistry?.actions.register([
            suggestionRightSurfaceButton
        ]);
    }
    return {
        name: 'aiSuggestions',
        actions: {
            acceptSuggestion: (0, $61cbf5e36086ffd7$export$11f54cceda85c938)(api),
            discardSuggestion: (0, $f22f7a878bb21ed6$export$97ae1e6707b788ba)(api),
            // Deprecated - will remove in direct follow up - use SelectSuggestionAction instead
            showSuggestionDiff: (0, $95d83135ce202b5d$export$abeb109a09e4f140)(api),
            // Deprecated - will remove in direct follow up - use SelectSuggestionAction instead
            hideSuggestionDiff: (0, $9c533a1ee7f54d08$export$63a2edde6c848f66)(api),
            discardAllSuggestions: (0, $8bb2f22922f0bfc3$export$7cd05c39d88c72e0)(api),
            refreshSuggestions: (0, $943e90f24ff1479e$export$8c023f02ab5dbd45)(api, contentAri),
            selectSuggestion: (0, $93a0ea89424771d8$export$85c07d6dab7fe6b1)(api),
            setThinkingState: (0, $2d7f810d13618094$export$bf49a0593cfa46b5)(api),
            setUIVisibility: (0, $19b7760d1a1a9061$export$6525a287b5847561)(api),
            submitSuggestionFeedback: (0, $7f796363d3edeeee$export$be7787b2fea0b5c6)(api, onSubmitSuggestionFeedback)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $1b159f40bd8b3a1f$export$dbbefe45c19011aa).getState(editorState);
            if (!pluginState) return undefined;
            const thinkingState = (0, $4d8c0f76a4c8d5f6$export$1acc4db37d317889).getState(editorState);
            return {
                isHidden: pluginState.isHidden,
                selectedSuggestion: pluginState.selectedSuggestion,
                suggestionById: pluginState.suggestionById,
                baseLocalIdBySuggestionId: pluginState.baseLocalIdBySuggestionId,
                suggestionIdsByBaseLocalId: pluginState.suggestionIdsByBaseLocalId,
                orderedSuggestionIds: pluginState.orderedSuggestionIds,
                followUpCard: pluginState.followUpCard,
                regeneratingSuggestionIds: pluginState.regeneratingSuggestionIds,
                thinkingStatus: thinkingState?.status ?? 'idle',
                thinkingStartedAt: thinkingState?.startedAt ?? null,
                thinkingProgressTarget: thinkingState?.progressTarget ?? null,
                thinkingError: thinkingState?.error ?? null
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'aiSuggestionsPlugin',
                    plugin: ({ getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
                        const intl = getIntl?.();
                        return (0, $1b159f40bd8b3a1f$export$ae829ec7b2625219)({
                            api: api,
                            intl: intl,
                            contentAri: contentAri,
                            nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                        });
                    }
                },
                {
                    name: 'aiSuggestionsThinkingPlugin',
                    plugin: ({ dispatch: dispatch })=>{
                        return (0, $4d8c0f76a4c8d5f6$export$145797582d57a3db)({
                            dispatch: dispatch
                        });
                    }
                }
            ];
        },
        contentComponent ({ editorView: editorView }) {
            return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $997801478ebdd729$export$a1fd8428be46e11c), {}),
                    /**
         * Both need the ConversationAssistant store: the thinking surface to invoke the
         * skill, track thinking states and abort requests, and the follow-up card to
         * resolve the Content Reviewer agent for its avatar.
         */ ConversationAssistant && /*#__PURE__*/ (0, $8aG6j.jsxs)(ConversationAssistant, {
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $031367d96107a088$export$58900a3f971bc8cc), {
                                api: api,
                                editorView: editorView
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a07fe340660de233$export$b37784161dbefc65), {
                                api: api,
                                view: editorView
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d79d0d9956135474$export$b9f1c5d82af9ea41), {
                        api: api,
                        onShowSidebar: onShowSidebar,
                        view: editorView
                    })
                ]
            });
        }
    };
};
module.exports["aiSuggestionsPlugin"] = $bd706ffb3e69dbe0$export$e4fa509a217898d8;

});

parcelRegister("83dR4", function(module, exports) {
function $0c1697ece550cffc$export$13aeab2a71badd1e({ options: options }) {
    // Options not declared here as they are all nested inside hooks, starting with `useEditorPluginAIDefinitionsConfig`.
    return options;
}
module.exports["aiDefinitionsPluginOptions"] = $0c1697ece550cffc$export$13aeab2a71badd1e;

});

parcelRegister("2H7bJ", function(module, exports) {
function $8fd9d5f3e39c04b8$export$a9185f12eb6f9427({ options: options }) {
    return options;
}
module.exports["aiImageGenerationPluginOptions"] = $8fd9d5f3e39c04b8$export$a9185f12eb6f9427;

});

parcelRegister("b0PJa", function(module, exports) {
function $e8192d24f72a522a$export$a2b90416e38bfd44({ options: options }) {
    // Options not declared here as they are all nested inside hooks, starting with `useEditorPluginAIOptions`.
    return options;
}
module.exports["aiPluginOptions"] = $e8192d24f72a522a$export$a2b90416e38bfd44;

});

parcelRegister("emOXs", function(module, exports) {
function $5bddf9453bb6896b$export$bc5ff52c1b8ecb7e({ options: options }) {
    return {
        streamFlowPacerEnabled: options?.streamFlowPacerEnabled,
        telemetryEventsEnabled: true
    };
}
module.exports["aiStreamingOrchestratorPluginOptions"] = $5bddf9453bb6896b$export$bc5ff52c1b8ecb7e;

});

parcelRegister("b11Eg", function(module, exports) {
function $8e54f803183465b8$export$ac204ba03d7a4a41({ options: options }) {
    return options;
}
module.exports["aiSuggestionsOptions"] = $8e54f803183465b8$export$ac204ba03d7a4a41;

});

parcelRegister("hYVYG", function(module, exports) {
function $bad4e0ae48934f00$export$bfd53895e8497571({}) {
    return {};
}
module.exports["analyticsPluginOptions"] = $bad4e0ae48934f00$export$bfd53895e8497571;

});

parcelRegister("458fo", function(module, exports) {
function $7015f0e5b11954a6$export$b3e029fd31f94f55({ options: options, providers: providers }) {
    if (!providers.inlineCommentAnnotationProvider) return undefined;
    return {
        inlineComment: providers.inlineCommentAnnotationProvider,
        createCommentExperience: options.createCommentExperience,
        selectCommentExperience: {
            selectAnnotation: {
                complete: (annotationId)=>{
                    options.selectCommentExperience?.selectAnnotation.complete({
                        pageClass: 'editor',
                        annotationId: annotationId,
                        entryPoint: 'annotation-change'
                    });
                }
            }
        },
        viewInlineCommentTraceUFOPress: options.viewInlineCommentTraceUFOPress,
        annotationManager: options.annotationManager
    };
}
module.exports["annotationPluginOptions"] = $7015f0e5b11954a6$export$b3e029fd31f94f55;

});

parcelRegister("gGfnN", function(module, exports) {
function $ebeab0a1417a59cc$export$eeaea850bc5c5797({ options: options }) {
    return {
        // Avatars are moved to Confluence codebase for Edit in Context
        // When Edit in Context is enabled primaryToolbarComponents is undefined
        // For more details please check
        // https://hello.atlassian.net/wiki/spaces/PCG/pages/2851572180/Editor+toolbar+for+live+pages+and+edit+in+context+projects
        collabEdit: options.collabEdit,
        // originally depends on !hasBeforePrimaryToolbar(props.primaryToolbarComponents),
        takeFullWidth: true,
        showAvatarGroup: false
    };
}
module.exports["avatarGroupPluginOptions"] = $ebeab0a1417a59cc$export$eeaea850bc5c5797;

});

parcelRegister("2j2nv", function(module, exports) {
function $9526f0ade8be7db5$export$a23b3fa66082f163() {
    return {
        allowInlineCursorTarget: true,
        allowScrollGutter: {
            getScrollElement: ()=>document.querySelector('.fabric-editor-popup-scroll-parent')
        }
    };
}
module.exports["basePluginOptions"] = $9526f0ade8be7db5$export$a23b3fa66082f163;

});

parcelRegister("37pZs", function(module, exports) {
function $8c14fc49394a0032$export$817c0e398e6ff750({}) {
    return {
        allowFontSize: true,
        includeBlockQuoteAsTextstyleOption: true,
        lastNodeMustBeParagraph: false,
        isUndoRedoButtonsEnabled: true,
        allowBlockType: undefined
    };
}
module.exports["blockTypePluginOptions"] = $8c14fc49394a0032$export$817c0e398e6ff750;

});

parcelRegister("ccSax", function(module, exports) {
function $d7cf87936bb69c1a$export$3be6b735d5cbc3e6({ options: options }) {
    return {
        allowBreakoutButton: options.editorAppearance === 'full-page',
        appearance: options.editorAppearance
    };
}
module.exports["breakoutPluginOptions"] = $d7cf87936bb69c1a$export$3be6b735d5cbc3e6;

});

parcelRegister("21YtE", function(module, exports) {

var $4iudd = parcelRequire("4iudd");


var $mW7G5 = parcelRequire("mW7G5");

// SECTION: From confluence/next/packages/editor-features/src/utils/smartCardOptions.ts
/**
 * Supported Jira URLs and Jira Roadmap URLs, GDrive and ODFB will become Smart Links
 * (only supports Cloud single-issue URLs right now)
 */ const $46d140459d17e176$var$SMART_LINKS_BEFORE_MACROS = 'jira,jiraroadmap,google-drive-sheets,google-drive-docs,OneDrive,google-drive-slides'.split(',');
function $46d140459d17e176$export$514131654bb897e2({ options: options, providers: providers }) {
    return {
        smartCardContext: options.smartCardContext,
        // From confluence/next/packages/full-page-editor/src/FullPageEditorComponent.tsx `CARD_OPTIONS =`
        allowDatasource: true,
        // END SECTION
        // SECTION: From confluence/next/packages/editor-features/src/utils/smartCardOptions.ts
        provider: providers.cardProvider,
        resolveBeforeMacros: $46d140459d17e176$var$SMART_LINKS_BEFORE_MACROS,
        allowBlockCards: true,
        allowEmbeds: true,
        // END SECTION
        onClickCallback: options.onClickCallback,
        fullWidthMode: options.editorAppearance === 'full-width',
        linkPicker: options.linkPicker,
        // SECTION: From confluence/next/packages/editor-features/src/hooks/useEditorFeatureFlags.ts
        lpLinkPicker: true,
        // END SECTION
        editorAppearance: options.editorAppearance,
        // @ts-ignore Temporary solution to check for Live Page editor.
        __livePage: options.__livePage,
        isPageSSRed: Boolean((0, $4iudd.isSSR)() || window.__SSR_RENDERED__),
        CompetitorPrompt: options.CompetitorPrompt,
        enablePasteDisplayAsMenu: [
            'hasSpellingAndGrammar',
            'hasAltAiActions'
        ].includes((0, $mW7G5.expValNoExposure)('platform_editor_paste_actions_menu_v2', 'variant', 'control'))
    };
}
module.exports["cardPluginOptions"] = $46d140459d17e176$export$514131654bb897e2;

});

parcelRegister("1aAo1", function(module, exports) {
function $2e18ec67f19caff3$export$74cc43e84bb9c20({ providers: providers }) {
    return {
        allowCopyToClipboard: true,
        useLongPressSelection: false,
        allowCompositionInputOverride: false,
        formatCodeProvider: providers.formatCodeProvider
    };
}
module.exports["codeBlockPluginOptions"] = $2e18ec67f19caff3$export$74cc43e84bb9c20;

});

parcelRegister("6HTz8", function(module, exports) {

var $jj5K7 = parcelRequire("jj5K7");


var $ieeJu = parcelRequire("ieeJu");

function $71921227359166a3$export$c1ebe19806bc53b1({ options: options, providers: providers }) {
    return {
        // Core options
        provider: providers.collabEditProvider,
        userId: options.collabEdit?.userId,
        useNativePlugin: options.collabEdit?.useNativePlugin,
        sanitizePrivateContent: true,
        hideTelecursorOnLoad: options.__livePage || (0, $ieeJu.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true),
        // Invite to edit related options
        inviteToEditHandler: options.collabEdit?.inviteToEditHandler,
        isInviteToEditButtonSelected: options.collabEdit?.isInviteToEditButtonSelected,
        inviteToEditComponent: options.collabEdit?.inviteToEditComponent,
        // Analytics options
        EXPERIMENTAL_allowInternalErrorAnalytics: options.collabEdit?.EXPERIMENTAL_allowInternalErrorAnalytics ?? (0, $jj5K7.shouldForceTracking)()
    };
}
module.exports["collabEditPluginOptions"] = $71921227359166a3$export$c1ebe19806bc53b1;

});

parcelRegister("UzlxI", function(module, exports) {
function $04b012c1cc13df71$export$8a4106078b67336e({ options: options }) {
    return {
        initialContentMode: options?.initialContentMode ?? 'standard'
    };
}
module.exports["contentFormatPluginOptions"] = $04b012c1cc13df71$export$8a4106078b67336e;

});

parcelRegister("lMcW5", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

function $7ebe3cdb2b372331$export$48a60d81b6bb28e3({ options: options }) {
    if (!options) return undefined;
    return(// SECTION: From confluence/next/packages/editor-presets/src/full-page/useFullPageEditorPreset.ts
    // If object-sidebar is not enabled, then we don't need to pass the contextPanelOptions
    (0, $iDrrr.fg)('platform_editor_ai_object_sidebar_injection') ? {
        objectSideBar: options.objectSideBar
    } : undefined);
}
module.exports["contextPanelPluginOptions"] = $7ebe3cdb2b372331$export$48a60d81b6bb28e3;

});

parcelRegister("5gRoW", function(module, exports) {
function $544934f3b4646806$export$de47eee62065048e({ options: options }) {
    return {
        initialDisabledState: options?.disabled
    };
}
module.exports["editorDisabledPluginOptions"] = $544934f3b4646806$export$de47eee62065048e;

});

parcelRegister("dUIcZ", function(module, exports) {
function $f92bb1f96a602b3d$export$36a79e2b5698697a({ options: options }) {
    return {
        mode: options.viewMode
    };
}
module.exports["editorViewModePluginOptions"] = $f92bb1f96a602b3d$export$36a79e2b5698697a;

});

parcelRegister("n7lIn", function(module, exports) {
function $090afbe8b4f614b7$export$128eafe7f843e327({ options: options }) {
    return {
        coordinationClient: options.coordinationClient
    };
}
module.exports["engagementPlatformPluginOptions"] = $090afbe8b4f614b7$export$128eafe7f843e327;

});

parcelRegister("1oaTe", function(module, exports) {
function $2b2ae13c81f0b3eb$export$c18b9102cd0790c9({ options: options }) {
    return {
        breakoutEnabled: options.editorAppearance === 'full-page',
        extensionHandlers: options.extensionHandlers,
        useLongPressSelection: false,
        appearance: options.editorAppearance,
        __rendererExtensionOptions: options.__rendererExtensionOptions,
        getExtensionHeight: options.getExtensionHeight,
        getUnsupportedContent: options.getUnsupportedContent
    };
}
module.exports["extensionPluginOptions"] = $2b2ae13c81f0b3eb$export$c18b9102cd0790c9;

});

parcelRegister("k1Nk4", function(module, exports) {

var $jkcNT = parcelRequire("jkcNT");

function $b7925b5fe11bfb81$export$3bff061e5229a7({}) {
    /**
	 * @private
	 * @deprecated Don't add any new feature flags here!
	 *             If you need a new feature flag, use:
	 *             - {@link editorExperiment} for new experiments.
	 *             - {@link fg} for new feature gates.
	 */ return {
        // SECTION: From confluence/next/packages/editor-features/src/hooks/useEditorFeatureFlags.ts
        /**
		 * This feature flag has completed rollout in Confluence and is to be cleaned up from LD
		 * but cannot yet be cleaned up from editor component as pending rollout in other products first
		 */ lpLinkPicker: true,
        tableWithFixedColumnWidthsOption: true,
        // END SECTION
        // SECTION: From confluence/next/packages/full-page-editor/src/hooks/useEditorFullPageExperiments.ts
        tableSelector: (0, $jkcNT.editorExperiment)('platform_editor_tables_table_selector', true),
        macroInteractionUpdates: true,
        moreElementsInQuickInsertView: true,
        // END SECTION
        // SECTION: From confluence/next/packages/editor-presets/src/utils/createFeatureFlagsFromProps.ts
        catchAllTracking: false,
        showAvatarGroupAsPlugin: false,
        errorBoundaryDocStructure: false,
        synchronyErrorDocStructure: false,
        enableViewUpdateSubscription: false,
        collabAvatarScroll: false,
        twoLineEditorToolbar: false,
        disableSpellcheckByBrowser: undefined
    };
}
module.exports["featureFlagsPluginOptions"] = $b7925b5fe11bfb81$export$3bff061e5229a7;

});

parcelRegister("6fxhr", function(module, exports) {
function $59b29edff314acad$export$2a67100cd9c61f05({ options: options }) {
    return options;
}
module.exports["helpDialogPluginOptions"] = $59b29edff314acad$export$2a67100cd9c61f05;

});

parcelRegister("3psuc", function(module, exports) {
function $b368953c3f0aa2c8$export$ab9ae3984d5aef33({ options: options }) {
    return {
        editorAppearance: options.editorAppearance,
        // SECTION: From confluence/next/packages/editor-features/src/hooks/useEditorFeatureFlags.ts
        lpLinkPicker: true,
        // END SECTION
        linkPicker: options.linkPicker,
        onClickCallback: options.onClickCallback,
        platform: 'web'
    };
}
module.exports["hyperlinkPluginOptions"] = $b368953c3f0aa2c8$export$ab9ae3984d5aef33;

});

parcelRegister("fqvyt", function(module, exports) {

var $jkcNT = parcelRequire("jkcNT");

function $fb62125893162074$export$1e11b615e9dc119e({ options: options }) {
    return {
        allowTables: true,
        allowExpand: true,
        horizontalRuleEnabled: true,
        tableSelectorSupported: (0, $jkcNT.editorExperiment)('platform_editor_tables_table_selector', true),
        nativeStatusSupported: true,
        showElementBrowserLink: true,
        appearance: options.editorAppearance,
        itemFilter: options.itemFilter,
        toolbarButtons: options.toolbarButtons
    };
}
module.exports["insertBlockPluginOptions"] = $fb62125893162074$export$1e11b615e9dc119e;

});

parcelRegister("19EZx", function(module, exports) {
function $9db31477b8097e5d$export$d384a797e800fdbe({ options: options }) {
    return {
        showFlag: options.showFlag,
        contentId: options.contentId,
        killSwitchEnabled: options.killSwitchEnabled
    };
}
module.exports["limitedModePluginOptions"] = $9db31477b8097e5d$export$d384a797e800fdbe;

});

parcelRegister("7OeAC", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $049fc7d34c7d1ed8$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    invalidAltText: {
        id: "editor-presets-confluence.media.alt-text.invalid",
        defaultMessage: "We aren\u2019t able to accept every possible character in Alt text. All Unicode letters and numbers are OK, but these are the only acceptable symbols: , ' . - _ ( )."
    }
});


const $31fa319867936cb4$var$STORAGE_SUPPORTS_REGEX = RegExp("^([\\p{L}\\p{N},'\\.\\s\\-_\\(\\)]|&amp;[0-9]{2};)*$", "u");
function $31fa319867936cb4$export$484123ae56f6fbd9({ intl: intl, options: options, providers: providers }) {
    return {
        // SECTION: From confluence/next/packages/editor-features/src/utils/mediaOptions.ts
        provider: providers.mediaProvider,
        syncProvider: providers.syncMediaProvider,
        allowMediaSingle: true,
        allowResizing: options.allowResizing ?? true,
        allowResizingInTables: options.allowResizing ?? true,
        allowLinking: true,
        allowAltTextOnImages: true,
        allowCaptions: options.allowCaptions ?? true,
        allowMediaInlineImages: true,
        allowPixelResizing: options.allowResizing ?? true,
        altTextValidator: (text)=>{
            if (!$31fa319867936cb4$var$STORAGE_SUPPORTS_REGEX.test(text)) return [
                intl.formatMessage((0, $049fc7d34c7d1ed8$export$a7357cdd1f0b0168).invalidAltText)
            ];
            return [];
        },
        // END SECTION
        // SECTION: From confluence/next/packages/fabric-media-support/src/mediaFeatureFlags.ts
        featureFlags: {
            mediaInline: true
        },
        // END SECTION
        // SECTION: From confluence/next/packages/editor-presets/src/full-page/createFullPageEditorPreset.ts
        allowLazyLoading: true,
        allowBreakoutSnapPoints: true,
        allowAdvancedToolBarOptions: true,
        // originally value was Boolean(options.annotationProviders),
        allowCommentsOnMedia: true,
        allowDropzoneDropLine: true,
        allowMediaSingleEditable: true,
        allowRemoteDimensionsFetch: true,
        allowMarkingUploadsAsIncomplete: false,
        allowImagePreview: true,
        fullWidthEnabled: options.editorAppearance === 'full-width',
        createCommentExperience: options.createCommentExperience,
        editorAppearance: options.editorAppearance,
        isCopyPasteEnabled: true,
        alignLeftOnInsert: false,
        allowImageEditing: true,
        // END SECTION
        // SECTION: From confluence/next/packages/full-page-editor/src/FullPageEditorComponent.tsx
        waitForMediaUpload: true,
        // END SECTION
        mediaViewerExtensions: options.mediaViewerExtensions,
        fallbackMediaNameFetcher: options.fallbackMediaNameFetcher,
        onMediaRenderEvent: options.onMediaRenderEvent
    };
}
module.exports["mediaPluginOptions"] = $31fa319867936cb4$export$484123ae56f6fbd9;

});

parcelRegister("18rHt", function(module, exports) {
function $5c4ff6f59d771305$export$4677177d82484aef({ options: options }) {
    return options;
}
module.exports["metricsPluginOptions"] = $5c4ff6f59d771305$export$4677177d82484aef;

});

parcelRegister("5nazv", function(module, exports) {
/**
 * Pure helpers for converting between ADF (ProseMirror) docs and markdown
 * source. Used by `MarkdownSourceView` to populate its textarea on mount and
 * to round-trip the user's edits back to ADF on unmount.
 *
 * Both functions are intentionally side-effect free and React-free so they can
 * be unit-tested in isolation. Errors from the markdown parser are *thrown* —
 * `markdownToAdf` is a "throws on parse error" boundary; the calling component
 * is responsible for catching and surfacing them.
 *
 * Ticket: https://hello.jira.atlassian.cloud/browse/EDITOR-6558
 */ /**
 * @import {
 *   Break,
 *   Blockquote,
 *   Code,
 *   Definition,
 *   Emphasis,
 *   Heading,
 *   Html,
 *   Image,
 *   InlineCode,
 *   Link,
 *   ListItem,
 *   List,
 *   Nodes,
 *   Paragraph,
 *   PhrasingContent,
 *   ReferenceType,
 *   Root,
 *   Strong,
 *   Text,
 *   ThematicBreak
 * } from 'mdast'
 * @import {
 *   Encoding,
 *   Event,
 *   Token,
 *   Value
 * } from 'micromark-util-types'
 * @import {Point} from 'unist'
 * @import {
 *   CompileContext,
 *   CompileData,
 *   Config,
 *   Extension,
 *   Handle,
 *   OnEnterError,
 *   Options
 * } from './types.js'
 */ /**
 * @typedef {import('mdast').Nodes} Nodes
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [includeImageAlt=true]
 *   Whether to use `alt` for `image`s (default: `true`).
 * @property {boolean | null | undefined} [includeHtml=true]
 *   Whether to use `value` of HTML (default: `true`).
 */ /** @type {Options} */ const $9c936c031fc463e9$var$emptyOptions = {};
function $9c936c031fc463e9$export$f84e8e69fd4488a5(value, options) {
    const settings = options || $9c936c031fc463e9$var$emptyOptions;
    const includeImageAlt = typeof settings.includeImageAlt === 'boolean' ? settings.includeImageAlt : true;
    const includeHtml = typeof settings.includeHtml === 'boolean' ? settings.includeHtml : true;
    return $9c936c031fc463e9$var$one(value, includeImageAlt, includeHtml);
}
/**
 * One node or several nodes.
 *
 * @param {unknown} value
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized node.
 */ function $9c936c031fc463e9$var$one(value, includeImageAlt, includeHtml) {
    if ($9c936c031fc463e9$var$node(value)) {
        if ('value' in value) return value.type === 'html' && !includeHtml ? '' : value.value;
        if (includeImageAlt && 'alt' in value && value.alt) return value.alt;
        if ('children' in value) return $9c936c031fc463e9$var$all(value.children, includeImageAlt, includeHtml);
    }
    if (Array.isArray(value)) return $9c936c031fc463e9$var$all(value, includeImageAlt, includeHtml);
    return '';
}
/**
 * Serialize a list of nodes.
 *
 * @param {Array<unknown>} values
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized nodes.
 */ function $9c936c031fc463e9$var$all(values, includeImageAlt, includeHtml) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    while(++index < values.length)result[index] = $9c936c031fc463e9$var$one(values[index], includeImageAlt, includeHtml);
    return result.join('');
}
/**
 * Check if `value` looks like a node.
 *
 * @param {unknown} value
 *   Thing.
 * @returns {value is Nodes}
 *   Whether `value` is a node.
 */ function $9c936c031fc463e9$var$node(value) {
    return Boolean(value && typeof value === 'object');
}




/**
 * @import {Encoding, Value} from 'micromark-util-types'
 */ /**
 * @typedef {import('micromark-util-types').Options} Options
 */ 
var $ll8uR = parcelRequire("ll8uR");


var $9coEp = parcelRequire("9coEp");


var $812u3 = parcelRequire("812u3");


var $3K32B = parcelRequire("3K32B");

function $f395668163fb8133$export$eb6d260b88819962(value, encoding, options) {
    if (typeof encoding !== 'string') {
        options = encoding;
        encoding = undefined;
    }
    return (0, $ll8uR.compile)(options)((0, $812u3.postprocess)((0, $9coEp.parse)(options).document().write((0, $3K32B.preprocess)()(value, encoding, true))));
}



var $eEM9l = parcelRequire("eEM9l");


var $cbxPV = parcelRequire("cbxPV");




const $6e1bc74b64366ebf$var$characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function $6e1bc74b64366ebf$export$a0fb664af7d0cc44(value) {
    return value.replace($6e1bc74b64366ebf$var$characterEscapeOrReference, $6e1bc74b64366ebf$var$decode);
}
/**
 * @param {string} $0
 *   Match.
 * @param {string} $1
 *   Character escape.
 * @param {string} $2
 *   Character reference.
 * @returns {string}
 *   Decoded value
 */ function $6e1bc74b64366ebf$var$decode($0, $1, $2) {
    if ($1) // Escape.
    return $1;
    // Reference.
    const head = $2.charCodeAt(0);
    if (head === 35) {
        const head = $2.charCodeAt(1);
        const hex = head === 120 || head === 88;
        return (0, $eEM9l.decodeNumericCharacterReference)($2.slice(hex ? 2 : 1), hex ? 16 : 10);
    }
    return (0, $cbxPV.decodeNamedCharacterReference)($2) || $0;
}



var $fEgdu = parcelRequire("fEgdu");




/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 */ /**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Point | PointLike | Position | PositionLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */ function $cedbd614bd2c3cee$export$c304dd45fe166145(value) {
    // Nothing.
    if (!value || typeof value !== 'object') return '';
    // Node.
    if ('position' in value || 'type' in value) return $cedbd614bd2c3cee$var$position(value.position);
    // Position.
    if ('start' in value || 'end' in value) return $cedbd614bd2c3cee$var$position(value);
    // Point.
    if ('line' in value || 'column' in value) return $cedbd614bd2c3cee$var$point(value);
    // ?
    return '';
}
/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */ function $cedbd614bd2c3cee$var$point(point) {
    return $cedbd614bd2c3cee$var$index(point && point.line) + ':' + $cedbd614bd2c3cee$var$index(point && point.column);
}
/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */ function $cedbd614bd2c3cee$var$position(pos) {
    return $cedbd614bd2c3cee$var$point(pos && pos.start) + '-' + $cedbd614bd2c3cee$var$point(pos && pos.end);
}
/**
 * @param {number | null | undefined} value
 * @returns {number}
 */ function $cedbd614bd2c3cee$var$index(value) {
    return value && typeof value === 'number' ? value : 1;
}


const $1f573826a160da4c$var$own = {}.hasOwnProperty;
function $1f573826a160da4c$export$d744d789c09bfde6(value, encoding, options) {
    if (typeof encoding !== 'string') {
        options = encoding;
        encoding = undefined;
    }
    return $1f573826a160da4c$var$compiler(options)((0, $812u3.postprocess)((0, $9coEp.parse)(options).document().write((0, $3K32B.preprocess)()(value, encoding, true))));
}
/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options | null | undefined} [options]
 */ function $1f573826a160da4c$var$compiler(options) {
    /** @type {Config} */ const config = {
        transforms: [],
        canContainEols: [
            'emphasis',
            'fragment',
            'heading',
            'paragraph',
            'strong'
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            characterReference: onexitcharacterreference,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    };
    $1f573826a160da4c$var$configure(config, (options || {}).mdastExtensions || []);
    /** @type {CompileData} */ const data = {};
    return compile;
    /**
   * Turn micromark events into an mdast tree.
   *
   * @param {Array<Event>} events
   *   Events.
   * @returns {Root}
   *   mdast tree.
   */ function compile(events) {
        /** @type {Root} */ let tree = {
            type: 'root',
            children: []
        };
        /** @type {Omit<CompileContext, 'sliceSerialize'>} */ const context = {
            stack: [
                tree
            ],
            tokenStack: [],
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            data: data
        };
        /** @type {Array<number>} */ const listStack = [];
        let index = -1;
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
            if (events[index][0] === 'enter') listStack.push(index);
            else {
                const tail = listStack.pop();
                index = prepareList(events, tail, index);
            }
        }
        index = -1;
        while(++index < events.length){
            const handler = config[events[index][0]];
            if ($1f573826a160da4c$var$own.call(handler, events[index][1].type)) handler[events[index][1].type].call(Object.assign({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        // Handle tokens still being open.
        if (context.tokenStack.length > 0) {
            const tail = context.tokenStack[context.tokenStack.length - 1];
            const handler = tail[1] || $1f573826a160da4c$var$defaultOnError;
            handler.call(context, undefined, tail[0]);
        }
        // Figure out `root` position.
        tree.position = {
            start: $1f573826a160da4c$var$point(events.length > 0 ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: $1f573826a160da4c$var$point(events.length > 0 ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        // Call transforms.
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */ function prepareList(events, start, length) {
        let index = start - 1;
        let containerBalance = -1;
        let listSpread = false;
        /** @type {Token | undefined} */ let listItem;
        /** @type {number | undefined} */ let lineIndex;
        /** @type {number | undefined} */ let firstBlankLineIndex;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index <= length){
            const event = events[index];
            switch(event[1].type){
                case "listUnordered":
                case "listOrdered":
                case "blockQuote":
                    if (event[0] === 'enter') containerBalance++;
                    else containerBalance--;
                    atMarker = undefined;
                    break;
                case "lineEndingBlank":
                    if (event[0] === 'enter') {
                        if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                        atMarker = undefined;
                    }
                    break;
                case "linePrefix":
                case "listItemValue":
                case "listItemMarker":
                case "listItemPrefix":
                case "listItemPrefixWhitespace":
                    break;
                default:
                    atMarker = undefined;
            }
            if (!containerBalance && event[0] === 'enter' && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === 'exit' && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
                if (listItem) {
                    let tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        const tailEvent = events[tailIndex];
                        if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
                            if (tailEvent[0] === 'exit') continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = "lineEndingBlank";
                                listSpread = true;
                            }
                            tailEvent[1].type = "lineEnding";
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent") ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem._spread = true;
                    // Fix position.
                    listItem.end = Object.assign({}, lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        'exit',
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === "listItemPrefix") {
                    /** @type {Token} */ const item = {
                        type: 'listItem',
                        _spread: false,
                        start: Object.assign({}, event[1].start),
                        // @ts-expect-error: we’ll add `end` in a second.
                        end: undefined
                    };
                    listItem = item;
                    events.splice(index, 0, [
                        'enter',
                        item,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        events[start][1]._spread = listSpread;
        return length;
    }
    /**
   * Create an opener handle.
   *
   * @param {(token: Token) => Nodes} create
   *   Create a node.
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function opener(create, and) {
        return open;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */ function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    /**
   * @type {CompileContext['buffer']}
   */ function buffer() {
        this.stack.push({
            type: 'fragment',
            children: []
        });
    }
    /**
   * @type {CompileContext['enter']}
   */ function enter(node, token, errorHandler) {
        const parent = this.stack[this.stack.length - 1];
        /** @type {Array<Nodes>} */ const siblings = parent.children;
        siblings.push(node);
        this.stack.push(node);
        this.tokenStack.push([
            token,
            errorHandler || undefined
        ]);
        node.position = {
            start: $1f573826a160da4c$var$point(token.start),
            // @ts-expect-error: `end` will be patched later.
            end: undefined
        };
    }
    /**
   * Create a closer handle.
   *
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function closer(and) {
        return close;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */ function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    /**
   * @type {CompileContext['exit']}
   */ function exit(token, onExitError) {
        const node = this.stack.pop();
        const open = this.tokenStack.pop();
        if (!open) throw new Error('Cannot close `' + token.type + '` (' + (0, $cedbd614bd2c3cee$export$c304dd45fe166145)({
            start: token.start,
            end: token.end
        }) + "): it\u2019s not open");
        else if (open[0].type !== token.type) {
            if (onExitError) onExitError.call(this, token, open[0]);
            else {
                const handler = open[1] || $1f573826a160da4c$var$defaultOnError;
                handler.call(this, token, open[0]);
            }
        }
        node.position.end = $1f573826a160da4c$var$point(token.end);
    }
    /**
   * @type {CompileContext['resume']}
   */ function resume() {
        return (0, $9c936c031fc463e9$export$f84e8e69fd4488a5)(this.stack.pop());
    }
    //
    // Handlers.
    //
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered() {
        this.data.expectingFirstListItemValue = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (this.data.expectingFirstListItemValue) {
            const ancestor = this.stack[this.stack.length - 2];
            ancestor.start = Number.parseInt(this.sliceSerialize(token), 10);
            this.data.expectingFirstListItemValue = undefined;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.lang = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfencemeta() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.meta = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (this.data.flowCodeInside) return;
        this.buffer();
        this.data.flowCodeInside = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefenced() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, '');
        this.data.flowCodeInside = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeindented() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/(\r?\n|\r)$/g, '');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.label = label;
        node.identifier = (0, $fEgdu.normalizeIdentifier)(this.sliceSerialize(token)).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        const node = this.stack[this.stack.length - 1];
        if (!node.depth) {
            const depth = this.sliceSerialize(token).length;
            node.depth = depth;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        this.data.setextHeadingSlurpLineEnding = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        const node = this.stack[this.stack.length - 1];
        node.depth = this.sliceSerialize(token).codePointAt(0) === 61 ? 1 : 2;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        this.data.setextHeadingSlurpLineEnding = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdata(token) {
        const node = this.stack[this.stack.length - 1];
        /** @type {Array<Nodes>} */ const siblings = node.children;
        let tail = siblings[siblings.length - 1];
        if (!tail || tail.type !== 'text') {
            // Add a new text node.
            tail = text();
            tail.position = {
                start: $1f573826a160da4c$var$point(token.start),
                // @ts-expect-error: we’ll add `end` later.
                end: undefined
            };
            siblings.push(tail);
        }
        this.stack.push(tail);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        const tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = $1f573826a160da4c$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        const context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (this.data.atHardBreak) {
            const tail = context.children[context.children.length - 1];
            tail.position.end = $1f573826a160da4c$var$point(token.end);
            this.data.atHardBreak = undefined;
            return;
        }
        if (!this.data.setextHeadingSlurpLineEnding && config.canContainEols.includes(context.type)) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        this.data.atHardBreak = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmlflow() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmltext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodetext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlink() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (this.data.inReference) {
            /** @type {ReferenceType} */ const referenceType = this.data.referenceType || 'shortcut';
            node.type += 'Reference';
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        this.data.referenceType = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitimage() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (this.data.inReference) {
            /** @type {ReferenceType} */ const referenceType = this.data.referenceType || 'shortcut';
            node.type += 'Reference';
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        this.data.referenceType = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        const string = this.sliceSerialize(token);
        const ancestor = this.stack[this.stack.length - 2];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        ancestor.label = (0, $6e1bc74b64366ebf$export$a0fb664af7d0cc44)(string);
        // @ts-expect-error: same as above.
        ancestor.identifier = (0, $fEgdu.normalizeIdentifier)(string).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        const fragment = this.stack[this.stack.length - 1];
        const value = this.resume();
        const node = this.stack[this.stack.length - 1];
        // Assume a reference.
        this.data.inReference = true;
        if (node.type === 'link') {
            /** @type {Array<PhrasingContent>} */ const children = fragment.children;
            node.children = children;
        } else node.alt = value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresource() {
        this.data.inReference = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterreference() {
        this.data.referenceType = 'collapsed';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        node.label = label;
        // @ts-expect-error: same as above.
        node.identifier = (0, $fEgdu.normalizeIdentifier)(this.sliceSerialize(token)).toLowerCase();
        this.data.referenceType = 'full';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencemarker(token) {
        this.data.characterReferenceType = token.type;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const data = this.sliceSerialize(token);
        const type = this.data.characterReferenceType;
        /** @type {string} */ let value;
        if (type) {
            value = (0, $eEM9l.decodeNumericCharacterReference)(data, type === "characterReferenceMarkerNumeric" ? 10 : 16);
            this.data.characterReferenceType = undefined;
        } else {
            const result = (0, $cbxPV.decodeNamedCharacterReference)(data);
            value = result;
        }
        const tail = this.stack[this.stack.length - 1];
        tail.value += value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreference(token) {
        const tail = this.stack.pop();
        tail.position.end = $1f573826a160da4c$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = 'mailto:' + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    /** @returns {Blockquote} */ function blockQuote() {
        return {
            type: 'blockquote',
            children: []
        };
    }
    /** @returns {Code} */ function codeFlow() {
        return {
            type: 'code',
            lang: null,
            meta: null,
            value: ''
        };
    }
    /** @returns {InlineCode} */ function codeText() {
        return {
            type: 'inlineCode',
            value: ''
        };
    }
    /** @returns {Definition} */ function definition() {
        return {
            type: 'definition',
            identifier: '',
            label: null,
            title: null,
            url: ''
        };
    }
    /** @returns {Emphasis} */ function emphasis() {
        return {
            type: 'emphasis',
            children: []
        };
    }
    /** @returns {Heading} */ function heading() {
        return {
            type: 'heading',
            // @ts-expect-error `depth` will be set later.
            depth: 0,
            children: []
        };
    }
    /** @returns {Break} */ function hardBreak() {
        return {
            type: 'break'
        };
    }
    /** @returns {Html} */ function html() {
        return {
            type: 'html',
            value: ''
        };
    }
    /** @returns {Image} */ function image() {
        return {
            type: 'image',
            title: null,
            url: '',
            alt: null
        };
    }
    /** @returns {Link} */ function link() {
        return {
            type: 'link',
            title: null,
            url: '',
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {List}
   */ function list(token) {
        return {
            type: 'list',
            ordered: token.type === 'listOrdered',
            start: null,
            spread: token._spread,
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {ListItem}
   */ function listItem(token) {
        return {
            type: 'listItem',
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    /** @returns {Paragraph} */ function paragraph() {
        return {
            type: 'paragraph',
            children: []
        };
    }
    /** @returns {Strong} */ function strong() {
        return {
            type: 'strong',
            children: []
        };
    }
    /** @returns {Text} */ function text() {
        return {
            type: 'text',
            value: ''
        };
    }
    /** @returns {ThematicBreak} */ function thematicBreak() {
        return {
            type: 'thematicBreak'
        };
    }
}
/**
 * Copy a point-like value.
 *
 * @param {Point} d
 *   Point-like value.
 * @returns {Point}
 *   unist point.
 */ function $1f573826a160da4c$var$point(d) {
    return {
        line: d.line,
        column: d.column,
        offset: d.offset
    };
}
/**
 * @param {Config} combined
 * @param {Array<Array<Extension> | Extension>} extensions
 * @returns {undefined}
 */ function $1f573826a160da4c$var$configure(combined, extensions) {
    let index = -1;
    while(++index < extensions.length){
        const value = extensions[index];
        if (Array.isArray(value)) $1f573826a160da4c$var$configure(combined, value);
        else $1f573826a160da4c$var$extension(combined, value);
    }
}
/**
 * @param {Config} combined
 * @param {Extension} extension
 * @returns {undefined}
 */ function $1f573826a160da4c$var$extension(combined, extension) {
    /** @type {keyof Extension} */ let key;
    for(key in extension)if ($1f573826a160da4c$var$own.call(extension, key)) switch(key){
        case 'canContainEols':
            {
                const right = extension[key];
                if (right) combined[key].push(...right);
                break;
            }
        case 'transforms':
            {
                const right = extension[key];
                if (right) combined[key].push(...right);
                break;
            }
        case 'enter':
        case 'exit':
            {
                const right = extension[key];
                if (right) Object.assign(combined[key], right);
                break;
            }
    }
}
/** @type {OnEnterError} */ function $1f573826a160da4c$var$defaultOnError(left, right) {
    if (left) throw new Error('Cannot close `' + left.type + '` (' + (0, $cedbd614bd2c3cee$export$c304dd45fe166145)({
        start: left.start,
        end: left.end
    }) + '): a different token (`' + right.type + '`, ' + (0, $cedbd614bd2c3cee$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ') is open');
    else throw new Error('Cannot close document, a token (`' + right.type + '`, ' + (0, $cedbd614bd2c3cee$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ') is still open');
}


/**
 * @typedef {import('mdast').Delete} Delete
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').ConstructName} ConstructName
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 */ /**
 * List of constructs that occur in phrasing (paragraphs, headings), but cannot
 * contain strikethrough.
 * So they sort of cancel each other out.
 * Note: could use a better name.
 *
 * Note: keep in sync with: <https://github.com/syntax-tree/mdast-util-to-markdown/blob/8ce8dbf/lib/unsafe.js#L14>
 *
 * @type {Array<ConstructName>}
 */ const $4b5736c281b8a126$var$constructsWithoutStrikethrough = [
    'autolink',
    'destinationLiteral',
    'destinationRaw',
    'reference',
    'titleQuote',
    'titleApostrophe'
];
$4b5736c281b8a126$var$handleDelete.peek = $4b5736c281b8a126$var$peekDelete;
function $4b5736c281b8a126$export$34d64e709dd0b9bb() {
    return {
        canContainEols: [
            'delete'
        ],
        enter: {
            strikethrough: $4b5736c281b8a126$var$enterStrikethrough
        },
        exit: {
            strikethrough: $4b5736c281b8a126$var$exitStrikethrough
        }
    };
}
function $4b5736c281b8a126$export$1632835bd2c84956() {
    return {
        unsafe: [
            {
                character: '~',
                inConstruct: 'phrasing',
                notInConstruct: $4b5736c281b8a126$var$constructsWithoutStrikethrough
            }
        ],
        handlers: {
            delete: $4b5736c281b8a126$var$handleDelete
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $4b5736c281b8a126$var$enterStrikethrough(token) {
    this.enter({
        type: 'delete',
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $4b5736c281b8a126$var$exitStrikethrough(token) {
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {Delete} node
 */ function $4b5736c281b8a126$var$handleDelete(node, _, state, info) {
    const tracker = state.createTracker(info);
    const exit = state.enter('strikethrough');
    let value = tracker.move('~~');
    value += state.containerPhrasing(node, {
        ...tracker.current(),
        before: value,
        after: '~'
    });
    value += tracker.move('~~');
    exit();
    return value;
}
/** @type {ToMarkdownHandle} */ function $4b5736c281b8a126$var$peekDelete() {
    return '~';
}


/**
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Table} Table
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('mdast').TableRow} TableRow
 *
 * @typedef {import('markdown-table').Options} MarkdownTableOptions
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').State} State
 * @typedef {import('mdast-util-to-markdown').Info} Info
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [tableCellPadding=true]
 *   Whether to add a space of padding between delimiters and cells (default:
 *   `true`).
 * @property {boolean | null | undefined} [tablePipeAlign=true]
 *   Whether to align the delimiters (default: `true`).
 * @property {MarkdownTableOptions['stringLength'] | null | undefined} [stringLength]
 *   Function to detect the length of table cell content, used when aligning
 *   the delimiters between cells (optional).
 */ function $32ab9fa51385bfd8$export$b680e6b2c82f8c2f(fn) {
    return fn;
}
function $32ab9fa51385bfd8$export$411ce8e5a71e3069() {}
function $32ab9fa51385bfd8$export$dcb8b3f0e2de7e49() {}
function $32ab9fa51385bfd8$export$565e9d9bd6b6e0d4() {}


/**
 * @typedef Options
 *   Configuration (optional).
 * @property {string|null|Array<string|null|undefined>} [align]
 *   One style for all columns, or styles for their respective columns.
 *   Each style is either `'l'` (left), `'r'` (right), or `'c'` (center).
 *   Other values are treated as `''`, which doesn’t place the colon in the
 *   alignment row but does align left.
 *   *Only the lowercased first character is used, so `Right` is fine.*
 * @property {boolean} [padding=true]
 *   Whether to add a space of padding between delimiters and cells.
 *
 *   When `true`, there is padding:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there is no padding:
 *
 *   ```markdown
 *   |Alpha|B    |
 *   |-----|-----|
 *   |C    |Delta|
 *   ```
 * @property {boolean} [delimiterStart=true]
 *   Whether to begin each row with the delimiter.
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are starting delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no starting delimiters:
 *
 *   ```markdown
 *   Alpha | B     |
 *   ----- | ----- |
 *   C     | Delta |
 *   ```
 * @property {boolean} [delimiterEnd=true]
 *   Whether to end each row with the delimiter.
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B
 *   | ----- | -----
 *   | C     | Delta
 *   ```
 * @property {boolean} [alignDelimiters=true]
 *   Whether to align the delimiters.
 *   By default, they are aligned:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   Pass `false` to make them staggered:
 *
 *   ```markdown
 *   | Alpha | B |
 *   | - | - |
 *   | C | Delta |
 *   ```
 * @property {(value: string) => number} [stringLength]
 *   Function to detect the length of table cell content.
 *   This is used when aligning the delimiters (`|`) between table cells.
 *   Full-width characters and emoji mess up delimiter alignment when viewing
 *   the markdown source.
 *   To fix this, you can pass this function, which receives the cell content
 *   and returns its “visible” size.
 *   Note that what is and isn’t visible depends on where the text is displayed.
 *
 *   Without such a function, the following:
 *
 *   ```js
 *   markdownTable([
 *     ['Alpha', 'Bravo'],
 *     ['中文', 'Charlie'],
 *     ['👩‍❤️‍👩', 'Delta']
 *   ])
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo |
 *   | - | - |
 *   | 中文 | Charlie |
 *   | 👩‍❤️‍👩 | Delta |
 *   ```
 *
 *   With [`string-width`](https://github.com/sindresorhus/string-width):
 *
 *   ```js
 *   import stringWidth from 'string-width'
 *
 *   markdownTable(
 *     [
 *       ['Alpha', 'Bravo'],
 *       ['中文', 'Charlie'],
 *       ['👩‍❤️‍👩', 'Delta']
 *     ],
 *     {stringLength: stringWidth}
 *   )
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo   |
 *   | ----- | ------- |
 *   | 中文  | Charlie |
 *   | 👩‍❤️‍👩    | Delta   |
 *   ```
 */ /**
 * @typedef {Options} MarkdownTableOptions
 * @todo
 *   Remove next major.
 */ /**
 * Generate a markdown ([GFM](https://docs.github.com/en/github/writing-on-github/working-with-advanced-formatting/organizing-information-with-tables)) table..
 *
 * @param {Array<Array<string|null|undefined>>} table
 *   Table data (matrix of strings).
 * @param {Options} [options]
 *   Configuration (optional).
 * @returns {string}
 */ function $47ef1b28add45b5f$export$cdb7288612c4f3d6(table, options = {}) {
    const align = (options.align || []).concat();
    const stringLength = options.stringLength || $47ef1b28add45b5f$var$defaultStringLength;
    /** @type {Array<number>} Character codes as symbols for alignment per column. */ const alignments = [];
    /** @type {Array<Array<string>>} Cells per row. */ const cellMatrix = [];
    /** @type {Array<Array<number>>} Sizes of each cell per row. */ const sizeMatrix = [];
    /** @type {Array<number>} */ const longestCellByColumn = [];
    let mostCellsPerRow = 0;
    let rowIndex = -1;
    // This is a superfluous loop if we don’t align delimiters, but otherwise we’d
    // do superfluous work when aligning, so optimize for aligning.
    while(++rowIndex < table.length){
        /** @type {Array<string>} */ const row = [];
        /** @type {Array<number>} */ const sizes = [];
        let columnIndex = -1;
        if (table[rowIndex].length > mostCellsPerRow) mostCellsPerRow = table[rowIndex].length;
        while(++columnIndex < table[rowIndex].length){
            const cell = $47ef1b28add45b5f$var$serialize(table[rowIndex][columnIndex]);
            if (options.alignDelimiters !== false) {
                const size = stringLength(cell);
                sizes[columnIndex] = size;
                if (longestCellByColumn[columnIndex] === undefined || size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            }
            row.push(cell);
        }
        cellMatrix[rowIndex] = row;
        sizeMatrix[rowIndex] = sizes;
    }
    // Figure out which alignments to use.
    let columnIndex = -1;
    if (typeof align === 'object' && 'length' in align) while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = $47ef1b28add45b5f$var$toAlignment(align[columnIndex]);
    else {
        const code = $47ef1b28add45b5f$var$toAlignment(align);
        while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = code;
    }
    // Inject the alignment row.
    columnIndex = -1;
    /** @type {Array<string>} */ const row = [];
    /** @type {Array<number>} */ const sizes = [];
    while(++columnIndex < mostCellsPerRow){
        const code = alignments[columnIndex];
        let before = '';
        let after = '';
        if (code === 99 /* `c` */ ) {
            before = ':';
            after = ':';
        } else if (code === 108 /* `l` */ ) before = ':';
        else if (code === 114 /* `r` */ ) after = ':';
        // There *must* be at least one hyphen-minus in each alignment cell.
        let size = options.alignDelimiters === false ? 1 : Math.max(1, longestCellByColumn[columnIndex] - before.length - after.length);
        const cell = before + '-'.repeat(size) + after;
        if (options.alignDelimiters !== false) {
            size = before.length + size + after.length;
            if (size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            sizes[columnIndex] = size;
        }
        row[columnIndex] = cell;
    }
    // Inject the alignment row.
    cellMatrix.splice(1, 0, row);
    sizeMatrix.splice(1, 0, sizes);
    rowIndex = -1;
    /** @type {Array<string>} */ const lines = [];
    while(++rowIndex < cellMatrix.length){
        const row = cellMatrix[rowIndex];
        const sizes = sizeMatrix[rowIndex];
        columnIndex = -1;
        /** @type {Array<string>} */ const line = [];
        while(++columnIndex < mostCellsPerRow){
            const cell = row[columnIndex] || '';
            let before = '';
            let after = '';
            if (options.alignDelimiters !== false) {
                const size = longestCellByColumn[columnIndex] - (sizes[columnIndex] || 0);
                const code = alignments[columnIndex];
                if (code === 114 /* `r` */ ) before = ' '.repeat(size);
                else if (code === 99 /* `c` */ ) {
                    if (size % 2) {
                        before = ' '.repeat(size / 2 + 0.5);
                        after = ' '.repeat(size / 2 - 0.5);
                    } else {
                        before = ' '.repeat(size / 2);
                        after = before;
                    }
                } else after = ' '.repeat(size);
            }
            if (options.delimiterStart !== false && !columnIndex) line.push('|');
            if (options.padding !== false && // Don’t add the opening space if we’re not aligning and the cell is
            // empty: there will be a closing space.
            !(options.alignDelimiters === false && cell === '') && (options.delimiterStart !== false || columnIndex)) line.push(' ');
            if (options.alignDelimiters !== false) line.push(before);
            line.push(cell);
            if (options.alignDelimiters !== false) line.push(after);
            if (options.padding !== false) line.push(' ');
            if (options.delimiterEnd !== false || columnIndex !== mostCellsPerRow - 1) line.push('|');
        }
        lines.push(options.delimiterEnd === false ? line.join('').replace(/ +$/, '') : line.join(''));
    }
    return lines.join('\n');
}
/**
 * @param {string|null|undefined} [value]
 * @returns {string}
 */ function $47ef1b28add45b5f$var$serialize(value) {
    return value === null || value === undefined ? '' : String(value);
}
/**
 * @param {string} value
 * @returns {number}
 */ function $47ef1b28add45b5f$var$defaultStringLength(value) {
    return value.length;
}
/**
 * @param {string|null|undefined} value
 * @returns {number}
 */ function $47ef1b28add45b5f$var$toAlignment(value) {
    const code = typeof value === 'string' ? value.codePointAt(0) : 0;
    return code === 67 /* `C` */  || code === 99 /* `c` */  ? 99 /* `c` */  : code === 76 /* `L` */  || code === 108 /* `l` */  ? 108 /* `l` */  : code === 82 /* `R` */  || code === 114 /* `r` */  ? 114 /* `r` */  : 0;
}


/**
 * @import {Blockquote, Parents} from 'mdast'
 * @import {Info, Map, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {Blockquote} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $7d251492bbe175dd$export$67dc04e652a298ca(node, _, state, info) {
    const exit = state.enter('blockquote');
    const tracker = state.createTracker(info);
    tracker.move('> ');
    tracker.shift(2);
    const value = state.indentLines(state.containerFlow(node, tracker.current()), $7d251492bbe175dd$var$map);
    exit();
    return value;
}
/** @type {Map} */ function $7d251492bbe175dd$var$map(line, _, blank) {
    return '>' + (blank ? '' : ' ') + line;
}


/**
 * @import {Break, Parents} from 'mdast'
 * @import {Info, State} from 'mdast-util-to-markdown'
 */ /**
 * @import {ConstructName, Unsafe} from 'mdast-util-to-markdown'
 */ /**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe} pattern
 * @returns {boolean}
 */ function $36b9be5098ae8407$export$78221a09424368d(stack, pattern) {
    return $36b9be5098ae8407$var$listInScope(stack, pattern.inConstruct, true) && !$36b9be5098ae8407$var$listInScope(stack, pattern.notInConstruct, false);
}
/**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe['inConstruct']} list
 * @param {boolean} none
 * @returns {boolean}
 */ function $36b9be5098ae8407$var$listInScope(stack, list, none) {
    if (typeof list === 'string') list = [
        list
    ];
    if (!list || list.length === 0) return none;
    let index = -1;
    while(++index < list.length){
        if (stack.includes(list[index])) return true;
    }
    return false;
}


function $e9025e3c1bee6e10$export$371da9dd35aba193(_, _1, state, info) {
    let index = -1;
    while(++index < state.unsafe.length){
        // If we can’t put eols in this construct (setext headings, tables), use a
        // space instead.
        if (state.unsafe[index].character === '\n' && (0, $36b9be5098ae8407$export$78221a09424368d)(state.stack, state.unsafe[index])) return /[ \t]/.test(info.before) ? '' : ' ';
    }
    return '\\\n';
}


/**
 * @import {Info, Map, State} from 'mdast-util-to-markdown'
 * @import {Code, Parents} from 'mdast'
 */ /**
 * Get the count of the longest repeating streak of `character` in `value`.
 *
 * @param {string} value
 *   Content to search in.
 * @param {string} character
 *   Single character to look for.
 * @returns {number}
 *   Count of most frequent adjacent `character`s in `value`.
 */ function $db366dab856db2bf$export$711675ff42d864f2(value, character) {
    const source = String(value);
    let index = source.indexOf(character);
    let expected = index;
    let count = 0;
    let max = 0;
    if (typeof character !== 'string' || character.length !== 1) throw new Error('Expected character');
    while(index !== -1){
        if (index === expected) {
            if (++count > max) max = count;
        } else count = 1;
        expected = index + 1;
        index = source.indexOf(character, expected);
    }
    return max;
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Code} from 'mdast'
 */ /**
 * @param {Code} node
 * @param {State} state
 * @returns {boolean}
 */ function $f094dc48315fec93$export$8c0df78a8cad9f4b(node, state) {
    return Boolean(state.options.fences === false && node.value && // If there’s no info…
    !node.lang && // And there’s a non-whitespace character…
    /[^ \r\n]/.test(node.value) && // And the value doesn’t start or end in a blank…
    !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(node.value));
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['fence'], null | undefined>}
 */ function $67c03cf413b70ec4$export$7487ee7cbb2e2919(state) {
    const marker = state.options.fence || '`';
    if (marker !== '`' && marker !== '~') throw new Error('Cannot serialize code with `' + marker + '` for `options.fence`, expected `` ` `` or `~`');
    return marker;
}


function $a3c4f0d1a4532fba$export$6565f9f03506010b(node, _, state, info) {
    const marker = (0, $67c03cf413b70ec4$export$7487ee7cbb2e2919)(state);
    const raw = node.value || '';
    const suffix = marker === '`' ? 'GraveAccent' : 'Tilde';
    if ((0, $f094dc48315fec93$export$8c0df78a8cad9f4b)(node, state)) {
        const exit = state.enter('codeIndented');
        const value = state.indentLines(raw, $a3c4f0d1a4532fba$var$map);
        exit();
        return value;
    }
    const tracker = state.createTracker(info);
    const sequence = marker.repeat(Math.max((0, $db366dab856db2bf$export$711675ff42d864f2)(raw, marker) + 1, 3));
    const exit = state.enter('codeFenced');
    let value = tracker.move(sequence);
    if (node.lang) {
        const subexit = state.enter(`codeFencedLang${suffix}`);
        value += tracker.move(state.safe(node.lang, {
            before: value,
            after: ' ',
            encode: [
                '`'
            ],
            ...tracker.current()
        }));
        subexit();
    }
    if (node.lang && node.meta) {
        const subexit = state.enter(`codeFencedMeta${suffix}`);
        value += tracker.move(' ');
        value += tracker.move(state.safe(node.meta, {
            before: value,
            after: '\n',
            encode: [
                '`'
            ],
            ...tracker.current()
        }));
        subexit();
    }
    value += tracker.move('\n');
    if (raw) value += tracker.move(raw + '\n');
    value += tracker.move(sequence);
    exit();
    return value;
}
/** @type {Map} */ function $a3c4f0d1a4532fba$var$map(line, _, blank) {
    return (blank ? '' : '    ') + line;
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Definition, Parents} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['quote'], null | undefined>}
 */ function $15dd31c2b346c066$export$7aeba63896b2719(state) {
    const marker = state.options.quote || '"';
    if (marker !== '"' && marker !== "'") throw new Error('Cannot serialize title with `' + marker + '` for `options.quote`, expected `"`, or `\'`');
    return marker;
}


function $2b4c226394604709$export$69f215ed977cdb73(node, _, state, info) {
    const quote = (0, $15dd31c2b346c066$export$7aeba63896b2719)(state);
    const suffix = quote === '"' ? 'Quote' : 'Apostrophe';
    const exit = state.enter('definition');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('[');
    value += tracker.move(state.safe(state.associationId(node), {
        before: value,
        after: ']',
        ...tracker.current()
    }));
    value += tracker.move(']: ');
    subexit();
    if (// If there’s no url, or…
    !node.url || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter('destinationLiteral');
        value += tracker.move('<');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: '>',
            ...tracker.current()
        }));
        value += tracker.move('>');
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter('destinationRaw');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: node.title ? ' ' : '\n',
            ...tracker.current()
        }));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(' ' + quote);
        value += tracker.move(state.safe(node.title, {
            before: value,
            after: quote,
            ...tracker.current()
        }));
        value += tracker.move(quote);
        subexit();
    }
    exit();
    return value;
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Emphasis, Parents} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['emphasis'], null | undefined>}
 */ function $bc23b718346e7a99$export$f967eb786dea04e7(state) {
    const marker = state.options.emphasis || '*';
    if (marker !== '*' && marker !== '_') throw new Error('Cannot serialize emphasis with `' + marker + '` for `options.emphasis`, expected `*`, or `_`');
    return marker;
}


/**
 * Encode a code point as a character reference.
 *
 * @param {number} code
 *   Code point to encode.
 * @returns {string}
 *   Encoded character reference.
 */ function $99eff785a80d0ced$export$5810cf1e579e9d5b(code) {
    return '&#x' + code.toString(16).toUpperCase() + ';';
}


/**
 * @import {EncodeSides} from '../types.js'
 */ 
var $0A5sK = parcelRequire("0A5sK");

function $cc87f065c8fcb68b$export$b444be54825dd0b6(outside, inside, marker) {
    const outsideKind = (0, $0A5sK.classifyCharacter)(outside);
    const insideKind = (0, $0A5sK.classifyCharacter)(inside);
    // Letter outside:
    if (outsideKind === undefined) return insideKind === undefined ? // we have to encode *both* letters for `_` as it is looser.
    // it already forms for `*` (and GFMs `~`).
    marker === '_' ? {
        inside: true,
        outside: true
    } : {
        inside: false,
        outside: false
    } : insideKind === 1 ? {
        inside: true,
        outside: true
    } : {
        inside: false,
        outside: true
    };
    // Whitespace outside:
    if (outsideKind === 1) return insideKind === undefined ? {
        inside: false,
        outside: false
    } : insideKind === 1 ? {
        inside: true,
        outside: true
    } : {
        inside: false,
        outside: false
    };
    // Punctuation outside:
    return insideKind === undefined ? {
        inside: false,
        outside: false
    } : insideKind === 1 ? {
        inside: true,
        outside: false
    } : {
        inside: false,
        outside: false
    };
}


$37f4d435a8f78ec9$export$bef81ba411953b51.peek = $37f4d435a8f78ec9$var$emphasisPeek;
function $37f4d435a8f78ec9$export$bef81ba411953b51(node, _, state, info) {
    const marker = (0, $bc23b718346e7a99$export$f967eb786dea04e7)(state);
    const exit = state.enter('emphasis');
    const tracker = state.createTracker(info);
    const before = tracker.move(marker);
    let between = tracker.move(state.containerPhrasing(node, {
        after: marker,
        before: before,
        ...tracker.current()
    }));
    const betweenHead = between.charCodeAt(0);
    const open = (0, $cc87f065c8fcb68b$export$b444be54825dd0b6)(info.before.charCodeAt(info.before.length - 1), betweenHead, marker);
    if (open.inside) between = (0, $99eff785a80d0ced$export$5810cf1e579e9d5b)(betweenHead) + between.slice(1);
    const betweenTail = between.charCodeAt(between.length - 1);
    const close = (0, $cc87f065c8fcb68b$export$b444be54825dd0b6)(info.after.charCodeAt(0), betweenTail, marker);
    if (close.inside) between = between.slice(0, -1) + (0, $99eff785a80d0ced$export$5810cf1e579e9d5b)(betweenTail);
    const after = tracker.move(marker);
    exit();
    state.attentionEncodeSurroundingInfo = {
        after: close.outside,
        before: open.outside
    };
    return before + between + after;
}
/**
 * @param {Emphasis} _
 * @param {Parents | undefined} _1
 * @param {State} state
 * @returns {string}
 */ function $37f4d435a8f78ec9$var$emphasisPeek(_, _1, state) {
    return state.options.emphasis || '*';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Heading, Parents} from 'mdast'
 */ 
/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Heading} from 'mdast'
 */ 
var $dPbz3 = parcelRequire("dPbz3");
/**
 * @typedef {import('unist').Node} UnistNode
 * @typedef {import('unist').Parent} UnistParent
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ // To do: use types from `unist-util-visit-parents` when it’s released.
/**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends Array<any>
 *   ? MatchesOne<Value, Check[keyof Check]>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends UnistNode ? number | undefined : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends UnistParent ? Ancestor | undefined : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [Ancestor=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Visited, Parent<Ancestor, Visited>>} BuildVisitorFromMatch
 *   Build a typed `Visitor` function from a node and all possible parents.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Visited
 *   Node type.
 * @template {UnistParent} Ancestor
 *   Parent type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     Matches<Descendant, Check>,
 *     Extract<Descendant, UnistParent>
 *   >
 * )} BuildVisitorFromDescendants
 *   Build a typed `Visitor` function from a list of descendants and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Node type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ 


function $1e1506f4046c52e9$export$bf638b60ea8b89b7(tree, testOrVisitor, visitorOrReverse, maybeReverse) {
    /** @type {boolean | null | undefined} */ let reverse;
    /** @type {Test} */ let test;
    /** @type {Visitor} */ let visitor;
    if (typeof testOrVisitor === 'function' && typeof visitorOrReverse !== 'function') {
        test = undefined;
        visitor = testOrVisitor;
        reverse = visitorOrReverse;
    } else {
        // @ts-expect-error: assume the overload with test was given.
        test = testOrVisitor;
        // @ts-expect-error: assume the overload with test was given.
        visitor = visitorOrReverse;
        reverse = maybeReverse;
    }
    (0, $dPbz3.visitParents)(tree, test, overload, reverse);
    /**
   * @param {UnistNode} node
   * @param {Array<UnistParent>} parents
   */ function overload(node, parents) {
        const parent = parents[parents.length - 1];
        const index = parent ? parent.children.indexOf(node) : undefined;
        return visitor(node, index, parent);
    }
}



function $eb35c8f481069a11$export$78863676235adfbc(node, state) {
    let literalWithBreak = false;
    // Look for literals with a line break.
    // Note that this also
    (0, $1e1506f4046c52e9$export$bf638b60ea8b89b7)(node, function(node) {
        if ('value' in node && /\r?\n|\r/.test(node.value) || node.type === 'break') {
            literalWithBreak = true;
            return 0, $dPbz3.EXIT;
        }
    });
    return Boolean((!node.depth || node.depth < 3) && (0, $9c936c031fc463e9$export$f84e8e69fd4488a5)(node) && (state.options.setext || literalWithBreak));
}


function $2a10e429905f7802$export$46e4a324ac90507f(node, _, state, info) {
    const rank = Math.max(Math.min(6, node.depth || 1), 1);
    const tracker = state.createTracker(info);
    if ((0, $eb35c8f481069a11$export$78863676235adfbc)(node, state)) {
        const exit = state.enter('headingSetext');
        const subexit = state.enter('phrasing');
        const value = state.containerPhrasing(node, {
            ...tracker.current(),
            before: '\n',
            after: '\n'
        });
        subexit();
        exit();
        return value + '\n' + (rank === 1 ? '=' : '-').repeat(// The whole size…
        value.length - // Minus the position of the character after the last EOL (or
        // 0 if there is none)…
        (Math.max(value.lastIndexOf('\r'), value.lastIndexOf('\n')) + 1));
    }
    const sequence = '#'.repeat(rank);
    const exit = state.enter('headingAtx');
    const subexit = state.enter('phrasing');
    // Note: for proper tracking, we should reset the output positions when there
    // is no content returned, because then the space is not output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    tracker.move(sequence + ' ');
    let value = state.containerPhrasing(node, {
        before: '# ',
        after: '\n',
        ...tracker.current()
    });
    if (/^[\t ]/.test(value)) // To do: what effect has the character reference on tracking?
    value = (0, $99eff785a80d0ced$export$5810cf1e579e9d5b)(value.charCodeAt(0)) + value.slice(1);
    value = value ? sequence + ' ' + value : sequence;
    if (state.options.closeAtx) value += ' ' + sequence;
    subexit();
    exit();
    return value;
}


/**
 * @import {Html} from 'mdast'
 */ $3d276c9c57f3c631$export$c0bb0b647f701bb5.peek = $3d276c9c57f3c631$var$htmlPeek;
function $3d276c9c57f3c631$export$c0bb0b647f701bb5(node) {
    return node.value || '';
}
/**
 * @returns {string}
 */ function $3d276c9c57f3c631$var$htmlPeek() {
    return '<';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Image, Parents} from 'mdast'
 */ 
$6434446ed6285131$export$5c452ff88e35e47d.peek = $6434446ed6285131$var$imagePeek;
function $6434446ed6285131$export$5c452ff88e35e47d(node, _, state, info) {
    const quote = (0, $15dd31c2b346c066$export$7aeba63896b2719)(state);
    const suffix = quote === '"' ? 'Quote' : 'Apostrophe';
    const exit = state.enter('image');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('![');
    value += tracker.move(state.safe(node.alt, {
        before: value,
        after: ']',
        ...tracker.current()
    }));
    value += tracker.move('](');
    subexit();
    if (// If there’s no url but there is a title…
    !node.url && node.title || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter('destinationLiteral');
        value += tracker.move('<');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: '>',
            ...tracker.current()
        }));
        value += tracker.move('>');
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter('destinationRaw');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: node.title ? ' ' : ')',
            ...tracker.current()
        }));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(' ' + quote);
        value += tracker.move(state.safe(node.title, {
            before: value,
            after: quote,
            ...tracker.current()
        }));
        value += tracker.move(quote);
        subexit();
    }
    value += tracker.move(')');
    exit();
    return value;
}
/**
 * @returns {string}
 */ function $6434446ed6285131$var$imagePeek() {
    return '!';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {ImageReference, Parents} from 'mdast'
 */ $b0c5a432f0c1daa1$export$f281796f6bc3b8db.peek = $b0c5a432f0c1daa1$var$imageReferencePeek;
function $b0c5a432f0c1daa1$export$f281796f6bc3b8db(node, _, state, info) {
    const type = node.referenceType;
    const exit = state.enter('imageReference');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('![');
    const alt = state.safe(node.alt, {
        before: value,
        after: ']',
        ...tracker.current()
    });
    value += tracker.move(alt + '][');
    subexit();
    // Hide the fact that we’re in phrasing, because escapes don’t work.
    const stack = state.stack;
    state.stack = [];
    subexit = state.enter('reference');
    // Note: for proper tracking, we should reset the output positions when we end
    // up making a `shortcut` reference, because then there is no brace output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    const reference = state.safe(state.associationId(node), {
        before: value,
        after: ']',
        ...tracker.current()
    });
    subexit();
    state.stack = stack;
    exit();
    if (type === 'full' || !alt || alt !== reference) value += tracker.move(reference + ']');
    else if (type === 'shortcut') // Remove the unwanted `[`.
    value = value.slice(0, -1);
    else value += tracker.move(']');
    return value;
}
/**
 * @returns {string}
 */ function $b0c5a432f0c1daa1$var$imageReferencePeek() {
    return '!';
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {InlineCode, Parents} from 'mdast'
 */ $e8433c752d6efad0$export$91b9bee19a0d8569.peek = $e8433c752d6efad0$var$inlineCodePeek;
function $e8433c752d6efad0$export$91b9bee19a0d8569(node, _, state) {
    let value = node.value || '';
    let sequence = '`';
    let index = -1;
    // If there is a single grave accent on its own in the code, use a fence of
    // two.
    // If there are two in a row, use one.
    while(new RegExp('(^|[^`])' + sequence + '([^`]|$)').test(value))sequence += '`';
    // If this is not just spaces or eols (tabs don’t count), and either the
    // first or last character are a space, eol, or tick, then pad with spaces.
    if (/[^ \r\n]/.test(value) && (/^[ \r\n]/.test(value) && /[ \r\n]$/.test(value) || /^`|`$/.test(value))) value = ' ' + value + ' ';
    // We have a potential problem: certain characters after eols could result in
    // blocks being seen.
    // For example, if someone injected the string `'\n# b'`, then that would
    // result in an ATX heading.
    // We can’t escape characters in `inlineCode`, but because eols are
    // transformed to spaces when going from markdown to HTML anyway, we can swap
    // them out.
    while(++index < state.unsafe.length){
        const pattern = state.unsafe[index];
        const expression = state.compilePattern(pattern);
        /** @type {RegExpExecArray | null} */ let match;
        // Only look for `atBreak`s.
        // Btw: note that `atBreak` patterns will always start the regex at LF or
        // CR.
        if (!pattern.atBreak) continue;
        while(match = expression.exec(value)){
            let position = match.index;
            // Support CRLF (patterns only look for one of the characters).
            if (value.charCodeAt(position) === 10 /* `\n` */  && value.charCodeAt(position - 1) === 13 /* `\r` */ ) position--;
            value = value.slice(0, position) + ' ' + value.slice(match.index + 1);
        }
    }
    return sequence + value + sequence;
}
/**
 * @returns {string}
 */ function $e8433c752d6efad0$var$inlineCodePeek() {
    return '`';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Link, Parents} from 'mdast'
 * @import {Exit} from '../types.js'
 */ 
/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Link} from 'mdast'
 */ 
function $b8742a2dcd1a1846$export$74cae3045e3179ed(node, state) {
    const raw = (0, $9c936c031fc463e9$export$f84e8e69fd4488a5)(node);
    return Boolean(!state.options.resourceLink && // If there’s a url…
    node.url && // And there’s a no title…
    !node.title && // And the content of `node` is a single text node…
    node.children && node.children.length === 1 && node.children[0].type === 'text' && // And if the url is the same as the content…
    (raw === node.url || 'mailto:' + raw === node.url) && // And that starts w/ a protocol…
    /^[a-z][a-z+.-]+:/i.test(node.url) && // And that doesn’t contain ASCII control codes (character escapes and
    // references don’t work), space, or angle brackets…
    !/[\0- <>\u007F]/.test(node.url));
}


$9d927512da264ecb$export$9c30223ca0a664fb.peek = $9d927512da264ecb$var$linkPeek;
function $9d927512da264ecb$export$9c30223ca0a664fb(node, _, state, info) {
    const quote = (0, $15dd31c2b346c066$export$7aeba63896b2719)(state);
    const suffix = quote === '"' ? 'Quote' : 'Apostrophe';
    const tracker = state.createTracker(info);
    /** @type {Exit} */ let exit;
    /** @type {Exit} */ let subexit;
    if ((0, $b8742a2dcd1a1846$export$74cae3045e3179ed)(node, state)) {
        // Hide the fact that we’re in phrasing, because escapes don’t work.
        const stack = state.stack;
        state.stack = [];
        exit = state.enter('autolink');
        let value = tracker.move('<');
        value += tracker.move(state.containerPhrasing(node, {
            before: value,
            after: '>',
            ...tracker.current()
        }));
        value += tracker.move('>');
        exit();
        state.stack = stack;
        return value;
    }
    exit = state.enter('link');
    subexit = state.enter('label');
    let value = tracker.move('[');
    value += tracker.move(state.containerPhrasing(node, {
        before: value,
        after: '](',
        ...tracker.current()
    }));
    value += tracker.move('](');
    subexit();
    if (// If there’s no url but there is a title…
    !node.url && node.title || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter('destinationLiteral');
        value += tracker.move('<');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: '>',
            ...tracker.current()
        }));
        value += tracker.move('>');
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter('destinationRaw');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: node.title ? ' ' : ')',
            ...tracker.current()
        }));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(' ' + quote);
        value += tracker.move(state.safe(node.title, {
            before: value,
            after: quote,
            ...tracker.current()
        }));
        value += tracker.move(quote);
        subexit();
    }
    value += tracker.move(')');
    exit();
    return value;
}
/**
 * @param {Link} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @returns {string}
 */ function $9d927512da264ecb$var$linkPeek(node, _, state) {
    return (0, $b8742a2dcd1a1846$export$74cae3045e3179ed)(node, state) ? '<' : '[';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {LinkReference, Parents} from 'mdast'
 */ $7e069fd84f16cac2$export$e6c469b1b7b2bc6a.peek = $7e069fd84f16cac2$var$linkReferencePeek;
function $7e069fd84f16cac2$export$e6c469b1b7b2bc6a(node, _, state, info) {
    const type = node.referenceType;
    const exit = state.enter('linkReference');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('[');
    const text = state.containerPhrasing(node, {
        before: value,
        after: ']',
        ...tracker.current()
    });
    value += tracker.move(text + '][');
    subexit();
    // Hide the fact that we’re in phrasing, because escapes don’t work.
    const stack = state.stack;
    state.stack = [];
    subexit = state.enter('reference');
    // Note: for proper tracking, we should reset the output positions when we end
    // up making a `shortcut` reference, because then there is no brace output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    const reference = state.safe(state.associationId(node), {
        before: value,
        after: ']',
        ...tracker.current()
    });
    subexit();
    state.stack = stack;
    exit();
    if (type === 'full' || !text || text !== reference) value += tracker.move(reference + ']');
    else if (type === 'shortcut') // Remove the unwanted `[`.
    value = value.slice(0, -1);
    else value += tracker.move(']');
    return value;
}
/**
 * @returns {string}
 */ function $7e069fd84f16cac2$var$linkReferencePeek() {
    return '[';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {List, Parents} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['bullet'], null | undefined>}
 */ function $c7cb9d964a966a3c$export$7425517207a4d0ae(state) {
    const marker = state.options.bullet || '*';
    if (marker !== '*' && marker !== '+' && marker !== '-') throw new Error('Cannot serialize items with `' + marker + '` for `options.bullet`, expected `*`, `+`, or `-`');
    return marker;
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ 
function $2b65939273ce6b44$export$e6803bf0889262a1(state) {
    const bullet = (0, $c7cb9d964a966a3c$export$7425517207a4d0ae)(state);
    const bulletOther = state.options.bulletOther;
    if (!bulletOther) return bullet === '*' ? '-' : '*';
    if (bulletOther !== '*' && bulletOther !== '+' && bulletOther !== '-') throw new Error('Cannot serialize items with `' + bulletOther + '` for `options.bulletOther`, expected `*`, `+`, or `-`');
    if (bulletOther === bullet) throw new Error('Expected `bullet` (`' + bullet + '`) and `bulletOther` (`' + bulletOther + '`) to be different');
    return bulletOther;
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['bulletOrdered'], null | undefined>}
 */ function $f98fb12dcad32ab4$export$98d522b78eddc19b(state) {
    const marker = state.options.bulletOrdered || '.';
    if (marker !== '.' && marker !== ')') throw new Error('Cannot serialize items with `' + marker + '` for `options.bulletOrdered`, expected `.` or `)`');
    return marker;
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['rule'], null | undefined>}
 */ function $f3d9dffafaf29204$export$d8d533ef24dba866(state) {
    const marker = state.options.rule || '*';
    if (marker !== '*' && marker !== '-' && marker !== '_') throw new Error('Cannot serialize rules with `' + marker + '` for `options.rule`, expected `*`, `-`, or `_`');
    return marker;
}


function $7c04ea66ff098284$export$8837f4fc672e936d(node, parent, state, info) {
    const exit = state.enter('list');
    const bulletCurrent = state.bulletCurrent;
    /** @type {string} */ let bullet = node.ordered ? (0, $f98fb12dcad32ab4$export$98d522b78eddc19b)(state) : (0, $c7cb9d964a966a3c$export$7425517207a4d0ae)(state);
    /** @type {string} */ const bulletOther = node.ordered ? bullet === '.' ? ')' : '.' : (0, $2b65939273ce6b44$export$e6803bf0889262a1)(state);
    let useDifferentMarker = parent && state.bulletLastUsed ? bullet === state.bulletLastUsed : false;
    if (!node.ordered) {
        const firstListItem = node.children ? node.children[0] : undefined;
        // If there’s an empty first list item directly in two list items,
        // we have to use a different bullet:
        //
        // ```markdown
        // * - *
        // ```
        //
        // …because otherwise it would become one big thematic break.
        if (// Bullet could be used as a thematic break marker:
        (bullet === '*' || bullet === '-') && // Empty first list item:
        firstListItem && (!firstListItem.children || !firstListItem.children[0]) && // Directly in two other list items:
        state.stack[state.stack.length - 1] === 'list' && state.stack[state.stack.length - 2] === 'listItem' && state.stack[state.stack.length - 3] === 'list' && state.stack[state.stack.length - 4] === 'listItem' && // That are each the first child.
        state.indexStack[state.indexStack.length - 1] === 0 && state.indexStack[state.indexStack.length - 2] === 0 && state.indexStack[state.indexStack.length - 3] === 0) useDifferentMarker = true;
        // If there’s a thematic break at the start of the first list item,
        // we have to use a different bullet:
        //
        // ```markdown
        // * ---
        // ```
        //
        // …because otherwise it would become one big thematic break.
        if ((0, $f3d9dffafaf29204$export$d8d533ef24dba866)(state) === bullet && firstListItem) {
            let index = -1;
            while(++index < node.children.length){
                const item = node.children[index];
                if (item && item.type === 'listItem' && item.children && item.children[0] && item.children[0].type === 'thematicBreak') {
                    useDifferentMarker = true;
                    break;
                }
            }
        }
    }
    if (useDifferentMarker) bullet = bulletOther;
    state.bulletCurrent = bullet;
    const value = state.containerFlow(node, info);
    state.bulletLastUsed = bullet;
    state.bulletCurrent = bulletCurrent;
    exit();
    return value;
}


/**
 * @import {Info, Map, State} from 'mdast-util-to-markdown'
 * @import {ListItem, Parents} from 'mdast'
 */ 
/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['listItemIndent'], null | undefined>}
 */ function $5be5b59726ad2c2e$export$2d5358b63da92261(state) {
    const style = state.options.listItemIndent || 'one';
    if (style !== 'tab' && style !== 'one' && style !== 'mixed') throw new Error('Cannot serialize items with `' + style + '` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`');
    return style;
}


function $a671066e887fbb3a$export$76c7e83ecc9cdf05(node, parent, state, info) {
    const listItemIndent = (0, $5be5b59726ad2c2e$export$2d5358b63da92261)(state);
    let bullet = state.bulletCurrent || (0, $c7cb9d964a966a3c$export$7425517207a4d0ae)(state);
    // Add the marker value for ordered lists.
    if (parent && parent.type === 'list' && parent.ordered) bullet = (typeof parent.start === 'number' && parent.start > -1 ? parent.start : 1) + (state.options.incrementListMarker === false ? 0 : parent.children.indexOf(node)) + bullet;
    let size = bullet.length + 1;
    if (listItemIndent === 'tab' || listItemIndent === 'mixed' && (parent && parent.type === 'list' && parent.spread || node.spread)) size = Math.ceil(size / 4) * 4;
    const tracker = state.createTracker(info);
    tracker.move(bullet + ' '.repeat(size - bullet.length));
    tracker.shift(size);
    const exit = state.enter('listItem');
    const value = state.indentLines(state.containerFlow(node, tracker.current()), map);
    exit();
    return value;
    /** @type {Map} */ function map(line, index, blank) {
        if (index) return (blank ? '' : ' '.repeat(size)) + line;
        return (blank ? bullet : bullet + ' '.repeat(size - bullet.length)) + line;
    }
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Paragraph, Parents} from 'mdast'
 */ /**
 * @param {Paragraph} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $4ea8e604cf36e2a2$export$9c206ddddb32a9b(node, _, state, info) {
    const exit = state.enter('paragraph');
    const subexit = state.enter('phrasing');
    const value = state.containerPhrasing(node, info);
    subexit();
    exit();
    return value;
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Parents, Root} from 'mdast'
 */ /**
 * @typedef {import('mdast').Html} Html
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 */ 
var $723Ml = parcelRequire("723Ml");

const $b7491e2f7a0af77b$export$444c9dec66a6f08c = /** @type {(node?: unknown) => node is Exclude<PhrasingContent, Html>} */ (0, $723Ml.convert)([
    'break',
    'delete',
    'emphasis',
    // To do: next major: removed since footnotes were added to GFM.
    'footnote',
    'footnoteReference',
    'image',
    'imageReference',
    'inlineCode',
    // Enabled by `mdast-util-math`:
    'inlineMath',
    'link',
    'linkReference',
    // Enabled by `mdast-util-mdx`:
    'mdxJsxTextElement',
    // Enabled by `mdast-util-mdx`:
    'mdxTextExpression',
    'strong',
    'text',
    // Enabled by `mdast-util-directive`:
    'textDirective'
]);


function $09b5a36e740d6c02$export$e8e78c978b129247(node, _, state, info) {
    // Note: `html` nodes are ambiguous.
    const hasPhrasing = node.children.some(function(d) {
        return (0, $b7491e2f7a0af77b$export$444c9dec66a6f08c)(d);
    });
    const container = hasPhrasing ? state.containerPhrasing : state.containerFlow;
    return container.call(state, node, info);
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Parents, Strong} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['strong'], null | undefined>}
 */ function $561cadae5bbf9bc7$export$b7ce17905d66a6c3(state) {
    const marker = state.options.strong || '*';
    if (marker !== '*' && marker !== '_') throw new Error('Cannot serialize strong with `' + marker + '` for `options.strong`, expected `*`, or `_`');
    return marker;
}




$ca0817ef3e457783$export$59ae2c325a998f89.peek = $ca0817ef3e457783$var$strongPeek;
function $ca0817ef3e457783$export$59ae2c325a998f89(node, _, state, info) {
    const marker = (0, $561cadae5bbf9bc7$export$b7ce17905d66a6c3)(state);
    const exit = state.enter('strong');
    const tracker = state.createTracker(info);
    const before = tracker.move(marker + marker);
    let between = tracker.move(state.containerPhrasing(node, {
        after: marker,
        before: before,
        ...tracker.current()
    }));
    const betweenHead = between.charCodeAt(0);
    const open = (0, $cc87f065c8fcb68b$export$b444be54825dd0b6)(info.before.charCodeAt(info.before.length - 1), betweenHead, marker);
    if (open.inside) between = (0, $99eff785a80d0ced$export$5810cf1e579e9d5b)(betweenHead) + between.slice(1);
    const betweenTail = between.charCodeAt(between.length - 1);
    const close = (0, $cc87f065c8fcb68b$export$b444be54825dd0b6)(info.after.charCodeAt(0), betweenTail, marker);
    if (close.inside) between = between.slice(0, -1) + (0, $99eff785a80d0ced$export$5810cf1e579e9d5b)(betweenTail);
    const after = tracker.move(marker + marker);
    exit();
    state.attentionEncodeSurroundingInfo = {
        after: close.outside,
        before: open.outside
    };
    return before + between + after;
}
/**
 * @param {Strong} _
 * @param {Parents | undefined} _1
 * @param {State} state
 * @returns {string}
 */ function $ca0817ef3e457783$var$strongPeek(_, _1, state) {
    return state.options.strong || '*';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Parents, Text} from 'mdast'
 */ /**
 * @param {Text} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $69655dff23ef6fdb$export$6f093cfa640b7166(node, _, state, info) {
    return state.safe(node.value, info);
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Parents, ThematicBreak} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['ruleRepetition'], null | undefined>}
 */ function $69ce093428a450be$export$72f02155834d89c4(state) {
    const repetition = state.options.ruleRepetition || 3;
    if (repetition < 3) throw new Error('Cannot serialize rules with repetition `' + repetition + '` for `options.ruleRepetition`, expected `3` or more');
    return repetition;
}



function $ce83a9901161a99f$export$ba7b13e047416c03(_, _1, state) {
    const value = ((0, $f3d9dffafaf29204$export$d8d533ef24dba866)(state) + (state.options.ruleSpaces ? ' ' : '')).repeat((0, $69ce093428a450be$export$72f02155834d89c4)(state));
    return state.options.ruleSpaces ? value.slice(0, -1) : value;
}


const $d72bf69742075527$export$8f34ce051745d39e = {
    blockquote: $7d251492bbe175dd$export$67dc04e652a298ca,
    break: (0, $e9025e3c1bee6e10$export$371da9dd35aba193),
    code: $a3c4f0d1a4532fba$export$6565f9f03506010b,
    definition: $2b4c226394604709$export$69f215ed977cdb73,
    emphasis: $37f4d435a8f78ec9$export$bef81ba411953b51,
    hardBreak: $e9025e3c1bee6e10$export$371da9dd35aba193,
    heading: $2a10e429905f7802$export$46e4a324ac90507f,
    html: $3d276c9c57f3c631$export$c0bb0b647f701bb5,
    image: $6434446ed6285131$export$5c452ff88e35e47d,
    imageReference: $b0c5a432f0c1daa1$export$f281796f6bc3b8db,
    inlineCode: $e8433c752d6efad0$export$91b9bee19a0d8569,
    link: $9d927512da264ecb$export$9c30223ca0a664fb,
    linkReference: $7e069fd84f16cac2$export$e6c469b1b7b2bc6a,
    list: $7c04ea66ff098284$export$8837f4fc672e936d,
    listItem: $a671066e887fbb3a$export$76c7e83ecc9cdf05,
    paragraph: $4ea8e604cf36e2a2$export$9c206ddddb32a9b,
    root: $09b5a36e740d6c02$export$e8e78c978b129247,
    strong: $ca0817ef3e457783$export$59ae2c325a998f89,
    text: $69655dff23ef6fdb$export$6f093cfa640b7166,
    thematicBreak: $ce83a9901161a99f$export$ba7b13e047416c03
};


function $7838a54ced4bd729$export$8bd0ec8ecf6adb7d() {
    return {
        enter: {
            table: $7838a54ced4bd729$var$enterTable,
            tableData: $7838a54ced4bd729$var$enterCell,
            tableHeader: $7838a54ced4bd729$var$enterCell,
            tableRow: $7838a54ced4bd729$var$enterRow
        },
        exit: {
            codeText: $7838a54ced4bd729$var$exitCodeText,
            table: $7838a54ced4bd729$var$exitTable,
            tableData: $7838a54ced4bd729$var$exit,
            tableHeader: $7838a54ced4bd729$var$exit,
            tableRow: $7838a54ced4bd729$var$exit
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $7838a54ced4bd729$var$enterTable(token) {
    const align = token._align;
    (0, $32ab9fa51385bfd8$export$dcb8b3f0e2de7e49)(align, 'expected `_align` on table');
    this.enter({
        type: 'table',
        align: align.map(function(d) {
            return d === 'none' ? null : d;
        }),
        children: []
    }, token);
    this.data.inTable = true;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $7838a54ced4bd729$var$exitTable(token) {
    this.exit(token);
    this.data.inTable = undefined;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $7838a54ced4bd729$var$enterRow(token) {
    this.enter({
        type: 'tableRow',
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $7838a54ced4bd729$var$exit(token) {
    this.exit(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $7838a54ced4bd729$var$enterCell(token) {
    this.enter({
        type: 'tableCell',
        children: []
    }, token);
}
// Overwrite the default code text data handler to unescape escaped pipes when
// they are in tables.
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $7838a54ced4bd729$var$exitCodeText(token) {
    let value = this.resume();
    if (this.data.inTable) value = value.replace(/\\([\\|])/g, $7838a54ced4bd729$var$replace);
    const node = this.stack[this.stack.length - 1];
    (0, $32ab9fa51385bfd8$export$dcb8b3f0e2de7e49)(node.type === 'inlineCode');
    node.value = value;
    this.exit(token);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */ function $7838a54ced4bd729$var$replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === '|' ? $1 : $0;
}
function $7838a54ced4bd729$export$dafcad76ea6e0045(options) {
    const settings = options || {};
    const padding = settings.tableCellPadding;
    const alignDelimiters = settings.tablePipeAlign;
    const stringLength = settings.stringLength;
    const around = padding ? ' ' : '|';
    return {
        unsafe: [
            {
                character: '\r',
                inConstruct: 'tableCell'
            },
            {
                character: '\n',
                inConstruct: 'tableCell'
            },
            // A pipe, when followed by a tab or space (padding), or a dash or colon
            // (unpadded delimiter row), could result in a table.
            {
                atBreak: true,
                character: '|',
                after: '[\t :-]'
            },
            // A pipe in a cell must be encoded.
            {
                character: '|',
                inConstruct: 'tableCell'
            },
            // A colon must be followed by a dash, in which case it could start a
            // delimiter row.
            {
                atBreak: true,
                character: ':',
                after: '-'
            },
            // A delimiter row can also start with a dash, when followed by more
            // dashes, a colon, or a pipe.
            // This is a stricter version than the built in check for lists, thematic
            // breaks, and setex heading underlines though:
            // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
            {
                atBreak: true,
                character: '-',
                after: '[:|-]'
            }
        ],
        handlers: {
            inlineCode: inlineCodeWithTable,
            table: handleTable,
            tableCell: handleTableCell,
            tableRow: handleTableRow
        }
    };
    /**
   * @type {ToMarkdownHandle}
   * @param {Table} node
   */ function handleTable(node, _, state, info) {
        return serializeData(handleTableAsData(node, state, info), node.align);
    }
    /**
   * This function isn’t really used normally, because we handle rows at the
   * table level.
   * But, if someone passes in a table row, this ensures we make somewhat sense.
   *
   * @type {ToMarkdownHandle}
   * @param {TableRow} node
   */ function handleTableRow(node, _, state, info) {
        const row = handleTableRowAsData(node, state, info);
        const value = serializeData([
            row
        ]);
        // `markdown-table` will always add an align row
        return value.slice(0, value.indexOf('\n'));
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {TableCell} node
   */ function handleTableCell(node, _, state, info) {
        const exit = state.enter('tableCell');
        const subexit = state.enter('phrasing');
        const value = state.containerPhrasing(node, {
            ...info,
            before: around,
            after: around
        });
        subexit();
        exit();
        return value;
    }
    /**
   * @param {Array<Array<string>>} matrix
   * @param {Array<string | null | undefined> | null | undefined} [align]
   */ function serializeData(matrix, align) {
        return (0, $47ef1b28add45b5f$export$cdb7288612c4f3d6)(matrix, {
            align: align,
            alignDelimiters: // @ts-expect-error: `markdown-table` types should support `null`.
            alignDelimiters,
            padding: // @ts-expect-error: `markdown-table` types should support `null`.
            padding,
            stringLength: // @ts-expect-error: `markdown-table` types should support `null`.
            stringLength
        });
    }
    /**
   * @param {Table} node
   * @param {State} state
   * @param {Info} info
   */ function handleTableAsData(node, state, info) {
        const children = node.children;
        let index = -1;
        /** @type {Array<Array<string>>} */ const result = [];
        const subexit = state.enter('table');
        while(++index < children.length)result[index] = handleTableRowAsData(children[index], state, info);
        subexit();
        return result;
    }
    /**
   * @param {TableRow} node
   * @param {State} state
   * @param {Info} info
   */ function handleTableRowAsData(node, state, info) {
        const children = node.children;
        let index = -1;
        /** @type {Array<string>} */ const result = [];
        const subexit = state.enter('tableRow');
        while(++index < children.length)// Note: the positional info as used here is incorrect.
        // Making it correct would be impossible due to aligning cells?
        // And it would need copy/pasting `markdown-table` into this project.
        result[index] = handleTableCell(children[index], node, state, info);
        subexit();
        return result;
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {InlineCode} node
   */ function inlineCodeWithTable(node, parent, state) {
        let value = (0, $d72bf69742075527$export$8f34ce051745d39e).inlineCode(node, parent, state);
        if (state.stack.includes('tableCell')) value = value.replace(/\|/g, '\\$&');
        return value;
    }
}


/**
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */ 

function $4f16eb57f7bc15ef$export$a427a608608b215f() {
    return {
        exit: {
            taskListCheckValueChecked: $4f16eb57f7bc15ef$var$exitCheck,
            taskListCheckValueUnchecked: $4f16eb57f7bc15ef$var$exitCheck,
            paragraph: $4f16eb57f7bc15ef$var$exitParagraphWithTaskListItem
        }
    };
}
function $4f16eb57f7bc15ef$export$9975722e7e834b78() {
    return {
        unsafe: [
            {
                atBreak: true,
                character: '-',
                after: '[:|-]'
            }
        ],
        handlers: {
            listItem: $4f16eb57f7bc15ef$var$listItemWithTaskListItem
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $4f16eb57f7bc15ef$var$exitCheck(token) {
    // We’re always in a paragraph, in a list item.
    const node = this.stack[this.stack.length - 2];
    (0, $32ab9fa51385bfd8$export$dcb8b3f0e2de7e49)(node.type === 'listItem');
    node.checked = token.type === 'taskListCheckValueChecked';
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $4f16eb57f7bc15ef$var$exitParagraphWithTaskListItem(token) {
    const parent = this.stack[this.stack.length - 2];
    if (parent && parent.type === 'listItem' && typeof parent.checked === 'boolean') {
        const node = this.stack[this.stack.length - 1];
        (0, $32ab9fa51385bfd8$export$dcb8b3f0e2de7e49)(node.type === 'paragraph');
        const head = node.children[0];
        if (head && head.type === 'text') {
            const siblings = parent.children;
            let index = -1;
            /** @type {Paragraph | undefined} */ let firstParaghraph;
            while(++index < siblings.length){
                const sibling = siblings[index];
                if (sibling.type === 'paragraph') {
                    firstParaghraph = sibling;
                    break;
                }
            }
            if (firstParaghraph === node) {
                // Must start with a space or a tab.
                head.value = head.value.slice(1);
                if (head.value.length === 0) node.children.shift();
                else if (node.position && head.position && typeof head.position.start.offset === 'number') {
                    head.position.start.column++;
                    head.position.start.offset++;
                    node.position.start = Object.assign({}, head.position.start);
                }
            }
        }
    }
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {ListItem} node
 */ function $4f16eb57f7bc15ef$var$listItemWithTaskListItem(node, parent, state, info) {
    const head = node.children[0];
    const checkable = typeof node.checked === 'boolean' && head && head.type === 'paragraph';
    const checkbox = '[' + (node.checked ? 'x' : ' ') + '] ';
    const tracker = state.createTracker(info);
    if (checkable) tracker.move(checkbox);
    let value = (0, $d72bf69742075527$export$8f34ce051745d39e).listItem(node, parent, state, {
        ...info,
        ...tracker.current()
    });
    if (checkable) value = value.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, check);
    return value;
    /**
   * @param {string} $0
   * @returns {string}
   */ function check($0) {
        return $0 + checkbox;
    }
}


/**
 * @import {Options} from 'micromark-extension-gfm-strikethrough'
 * @import {Event, Extension, Resolver, State, Token, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ 
var $bHIRo = parcelRequire("bHIRo");





var $9CjcD = parcelRequire("9CjcD");

function $1fdd2be315857d56$export$8bbec8ea1400a00e(options) {
    const options_ = options || {};
    let single = options_.singleTilde;
    const tokenizer = {
        name: 'strikethrough',
        tokenize: tokenizeStrikethrough,
        resolveAll: resolveAllStrikethrough
    };
    if (single === null || single === undefined) single = true;
    return {
        text: {
            [126]: tokenizer
        },
        insideSpan: {
            null: [
                tokenizer
            ]
        },
        attentionMarkers: {
            null: [
                126
            ]
        }
    };
    /**
   * Take events and resolve strikethrough.
   *
   * @type {Resolver}
   */ function resolveAllStrikethrough(events, context) {
        let index = -1;
        // Walk through all events.
        while(++index < events.length)// Find a token that can close.
        if (events[index][0] === 'enter' && events[index][1].type === 'strikethroughSequenceTemporary' && events[index][1]._close) {
            let open = index;
            // Now walk back to find an opener.
            while(open--)// Find a token that can open the closer.
            if (events[open][0] === 'exit' && events[open][1].type === 'strikethroughSequenceTemporary' && events[open][1]._open && // If the sizes are the same:
            events[index][1].end.offset - events[index][1].start.offset === events[open][1].end.offset - events[open][1].start.offset) {
                events[index][1].type = 'strikethroughSequence';
                events[open][1].type = 'strikethroughSequence';
                /** @type {Token} */ const strikethrough = {
                    type: 'strikethrough',
                    start: Object.assign({}, events[open][1].start),
                    end: Object.assign({}, events[index][1].end)
                };
                /** @type {Token} */ const text = {
                    type: 'strikethroughText',
                    start: Object.assign({}, events[open][1].end),
                    end: Object.assign({}, events[index][1].start)
                };
                // Opening.
                /** @type {Array<Event>} */ const nextEvents = [
                    [
                        'enter',
                        strikethrough,
                        context
                    ],
                    [
                        'enter',
                        events[open][1],
                        context
                    ],
                    [
                        'exit',
                        events[open][1],
                        context
                    ],
                    [
                        'enter',
                        text,
                        context
                    ]
                ];
                const insideSpan = context.parser.constructs.insideSpan.null;
                if (insideSpan) // Between.
                (0, $bHIRo.splice)(nextEvents, nextEvents.length, 0, (0, $9CjcD.resolveAll)(insideSpan, events.slice(open + 1, index), context));
                // Closing.
                (0, $bHIRo.splice)(nextEvents, nextEvents.length, 0, [
                    [
                        'exit',
                        text,
                        context
                    ],
                    [
                        'enter',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        strikethrough,
                        context
                    ]
                ]);
                (0, $bHIRo.splice)(events, open - 1, index - open + 3, nextEvents);
                index = open + nextEvents.length - 2;
                break;
            }
        }
        index = -1;
        while(++index < events.length)if (events[index][1].type === 'strikethroughSequenceTemporary') events[index][1].type = "data";
        return events;
    }
    /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeStrikethrough(effects, ok, nok) {
        const previous = this.previous;
        const events = this.events;
        let size = 0;
        return start;
        /** @type {State} */ function start(code) {
            if (previous === 126 && events[events.length - 1][1].type !== "characterEscape") return nok(code);
            effects.enter('strikethroughSequenceTemporary');
            return more(code);
        }
        /** @type {State} */ function more(code) {
            const before = (0, $0A5sK.classifyCharacter)(previous);
            if (code === 126) {
                // If this is the third marker, exit.
                if (size > 1) return nok(code);
                effects.consume(code);
                size++;
                return more;
            }
            if (size < 2 && !single) return nok(code);
            const token = effects.exit('strikethroughSequenceTemporary');
            const after = (0, $0A5sK.classifyCharacter)(code);
            token._open = !after || after === 2 && Boolean(before);
            token._close = !before || before === 2 && Boolean(after);
            return ok(code);
        }
    }
}


/**
 * @import {Event, Extension, Point, Resolver, State, Token, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ /**
 * @typedef {[number, number, number, number]} Range
 *   Cell info.
 *
 * @typedef {0 | 1 | 2 | 3} RowKind
 *   Where we are: `1` for head row, `2` for delimiter row, `3` for body row.
 */ 
var $5jhd5 = parcelRequire("5jhd5");


var $5RE1E = parcelRequire("5RE1E");

/**
 * @import {Event} from 'micromark-util-types'
 */ // Port of `edit_map.rs` from `markdown-rs`.
// This should move to `markdown-js` later.
// Deal with several changes in events, batching them together.
//
// Preferably, changes should be kept to a minimum.
// Sometimes, it’s needed to change the list of events, because parsing can be
// messy, and it helps to expose a cleaner interface of events to the compiler
// and other users.
// It can also help to merge many adjacent similar events.
// And, in other cases, it’s needed to parse subcontent: pass some events
// through another tokenizer and inject the result.
/**
 * @typedef {[number, number, Array<Event>]} Change
 * @typedef {[number, number, number]} Jump
 */ /**
 * Tracks a bunch of edits.
 */ class $a2a0fd8bc4102094$export$9348908dd4518b4a {
    /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */ add(index, remove, add) {
        $a2a0fd8bc4102094$var$addImplementation(this, index, remove, add);
    }
    // To do: add this when moving to `micromark`.
    // /**
    //  * Create an edit: but insert `add` before existing additions.
    //  *
    //  * @param {number} index
    //  * @param {number} remove
    //  * @param {Array<Event>} add
    //  * @returns {undefined}
    //  */
    // addBefore(index, remove, add) {
    //   addImplementation(this, index, remove, add, true)
    // }
    /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */ consume(events) {
        this.map.sort(function(a, b) {
            return a[0] - b[0];
        });
        /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (this.map.length === 0) return;
        // To do: if links are added in events, like they are in `markdown-rs`,
        // this is needed.
        // // Calculate jumps: where items in the current list move to.
        // /** @type {Array<Jump>} */
        // const jumps = []
        // let index = 0
        // let addAcc = 0
        // let removeAcc = 0
        // while (index < this.map.length) {
        //   const [at, remove, add] = this.map[index]
        //   removeAcc += remove
        //   addAcc += add.length
        //   jumps.push([at, removeAcc, addAcc])
        //   index += 1
        // }
        //
        // . shiftLinks(events, jumps)
        let index = this.map.length;
        /** @type {Array<Array<Event>>} */ const vecs = [];
        while(index > 0){
            index -= 1;
            vecs.push(events.slice(this.map[index][0] + this.map[index][1]), this.map[index][2]);
            // Truncate rest.
            events.length = this.map[index][0];
        }
        vecs.push(events.slice());
        events.length = 0;
        let slice = vecs.pop();
        while(slice){
            for (const element of slice)events.push(element);
            slice = vecs.pop();
        }
        // Truncate everything.
        this.map.length = 0;
    }
    /**
   * Create a new edit map.
   */ constructor(){
        /**
     * Record of changes.
     *
     * @type {Array<Change>}
     */ this.map = [];
    }
}
/**
 * Create an edit.
 *
 * @param {EditMap} editMap
 * @param {number} at
 * @param {number} remove
 * @param {Array<Event>} add
 * @returns {undefined}
 */ function $a2a0fd8bc4102094$var$addImplementation(editMap, at, remove, add) {
    let index = 0;
    /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (remove === 0 && add.length === 0) return;
    while(index < editMap.map.length){
        if (editMap.map[index][0] === at) {
            editMap.map[index][1] += remove;
            // To do: before not used by tables, use when moving to micromark.
            // if (before) {
            //   add.push(...editMap.map[index][2])
            //   editMap.map[index][2] = add
            // } else {
            editMap.map[index][2].push(...add);
            // }
            return;
        }
        index += 1;
    }
    editMap.map.push([
        at,
        remove,
        add
    ]);
} // /**
 //  * Shift `previous` and `next` links according to `jumps`.
 //  *
 //  * This fixes links in case there are events removed or added between them.
 //  *
 //  * @param {Array<Event>} events
 //  * @param {Array<Jump>} jumps
 //  */
 // function shiftLinks(events, jumps) {
 //   let jumpIndex = 0
 //   let index = 0
 //   let add = 0
 //   let rm = 0
 //   while (index < events.length) {
 //     const rmCurr = rm
 //     while (jumpIndex < jumps.length && jumps[jumpIndex][0] <= index) {
 //       add = jumps[jumpIndex][2]
 //       rm = jumps[jumpIndex][1]
 //       jumpIndex += 1
 //     }
 //     // Ignore items that will be removed.
 //     if (rm > rmCurr) {
 //       index += rm - rmCurr
 //     } else {
 //       // ?
 //       // if let Some(link) = &events[index].link {
 //       //     if let Some(next) = link.next {
 //       //         events[next].link.as_mut().unwrap().previous = Some(index + add - rm);
 //       //         while jumpIndex < jumps.len() && jumps[jumpIndex].0 <= next {
 //       //             add = jumps[jumpIndex].2;
 //       //             rm = jumps[jumpIndex].1;
 //       //             jumpIndex += 1;
 //       //         }
 //       //         events[index].link.as_mut().unwrap().next = Some(next + add - rm);
 //       //         index = next;
 //       //         continue;
 //       //     }
 //       // }
 //       index += 1
 //     }
 //   }
 // }


/**
 * @import {Event} from 'micromark-util-types'
 */ /**
 * @typedef {'center' | 'left' | 'none' | 'right'} Align
 */ /**
 * Figure out the alignment of a GFM table.
 *
 * @param {Readonly<Array<Event>>} events
 *   List of events.
 * @param {number} index
 *   Table enter event.
 * @returns {Array<Align>}
 *   List of aligns.
 */ function $ff0184c28ca4d4e4$export$bbf4fe2c547a4878(events, index) {
    let inDelimiterRow = false;
    /** @type {Array<Align>} */ const align = [];
    while(index < events.length){
        const event = events[index];
        if (inDelimiterRow) {
            if (event[0] === 'enter') // Start of alignment value: set a new column.
            // To do: `markdown-rs` uses `tableDelimiterCellValue`.
            {
                if (event[1].type === 'tableContent') align.push(events[index + 1][1].type === 'tableDelimiterMarker' ? 'left' : 'none');
            } else if (event[1].type === 'tableContent') {
                if (events[index - 1][1].type === 'tableDelimiterMarker') {
                    const alignIndex = align.length - 1;
                    align[alignIndex] = align[alignIndex] === 'left' ? 'center' : 'right';
                }
            } else if (event[1].type === 'tableDelimiterRow') break;
        } else if (event[0] === 'enter' && event[1].type === 'tableDelimiterRow') inDelimiterRow = true;
        index += 1;
    }
    return align;
}


function $8e44d98c70bdeefa$export$e36cebda627bf2dd() {
    return {
        flow: {
            null: {
                name: 'table',
                tokenize: $8e44d98c70bdeefa$var$tokenizeTable,
                resolveAll: $8e44d98c70bdeefa$var$resolveTable
            }
        }
    };
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $8e44d98c70bdeefa$var$tokenizeTable(effects, ok, nok) {
    const self = this;
    let size = 0;
    let sizeB = 0;
    /** @type {boolean | undefined} */ let seen;
    return start;
    /**
   * Start of a GFM table.
   *
   * If there is a valid table row or table head before, then we try to parse
   * another row.
   * Otherwise, we try to parse a head.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   * > | | b |
   *     ^
   * ```
   * @type {State}
   */ function start(code) {
        let index = self.events.length - 1;
        while(index > -1){
            const type = self.events[index][1].type;
            if (type === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
            type === "linePrefix") index--;
            else break;
        }
        const tail = index > -1 ? self.events[index][1].type : null;
        const next = tail === 'tableHead' || tail === 'tableRow' ? bodyRowStart : headRowBefore;
        // Don’t allow lazy body rows.
        if (next === bodyRowStart && self.parser.lazy[self.now().line]) return nok(code);
        return next(code);
    }
    /**
   * Before table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBefore(code) {
        effects.enter('tableHead');
        effects.enter('tableRow');
        return headRowStart(code);
    }
    /**
   * Before table head row, after whitespace.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowStart(code) {
        if (code === 124) return headRowBreak(code);
        // To do: micromark-js should let us parse our own whitespace in extensions,
        // like `markdown-rs`:
        //
        // ```js
        // // 4+ spaces.
        // if (markdownSpace(code)) {
        //   return nok(code)
        // }
        // ```
        seen = true;
        // Count the first character, that isn’t a pipe, double.
        sizeB += 1;
        return headRowBreak(code);
    }
    /**
   * At break in table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *       ^
   *         ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBreak(code) {
        if (code === null) // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
        if ((0, $5RE1E.markdownLineEnding)(code)) {
            // If anything other than one pipe (ignoring whitespace) was used, it’s fine.
            if (sizeB > 1) {
                sizeB = 0;
                // To do: check if this works.
                // Feel free to interrupt:
                self.interrupt = true;
                effects.exit('tableRow');
                effects.enter("lineEnding");
                effects.consume(code);
                effects.exit("lineEnding");
                return headDelimiterStart;
            }
            // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
            return nok(code);
        }
        if ((0, $5RE1E.markdownSpace)(code)) // To do: check if this is fine.
        // effects.attempt(State::Next(StateName::GfmTableHeadRowBreak), State::Nok)
        // State::Retry(space_or_tab(tokenizer))
        return (0, $5jhd5.factorySpace)(effects, headRowBreak, "whitespace")(code);
        sizeB += 1;
        if (seen) {
            seen = false;
            // Header cell count.
            size += 1;
        }
        if (code === 124) {
            effects.enter('tableCellDivider');
            effects.consume(code);
            effects.exit('tableCellDivider');
            // Whether a delimiter was seen.
            seen = true;
            return headRowBreak;
        }
        // Anything else is cell data.
        effects.enter("data");
        return headRowData(code);
    }
    /**
   * In table head row data.
   *
   * ```markdown
   * > | | a |
   *       ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowData(code) {
        if (code === null || code === 124 || (0, $5RE1E.markdownLineEndingOrSpace)(code)) {
            effects.exit("data");
            return headRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? headRowEscape : headRowData;
    }
    /**
   * In table head row escape.
   *
   * ```markdown
   * > | | a\-b |
   *         ^
   *   | | ---- |
   *   | | c    |
   * ```
   *
   * @type {State}
   */ function headRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return headRowData;
        }
        return headRowData(code);
    }
    /**
   * Before delimiter row.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterStart(code) {
        // Reset `interrupt`.
        self.interrupt = false;
        // Note: in `markdown-rs`, we need to handle piercing here too.
        if (self.parser.lazy[self.now().line]) return nok(code);
        effects.enter('tableDelimiterRow');
        // Track if we’ve seen a `:` or `|`.
        seen = false;
        if ((0, $5RE1E.markdownSpace)(code)) return (0, $5jhd5.factorySpace)(effects, headDelimiterBefore, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
        return headDelimiterBefore(code);
    }
    /**
   * Before delimiter row, after optional whitespace.
   *
   * Reused when a `|` is found later, to parse another cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterBefore(code) {
        if (code === 45 || code === 58) return headDelimiterValueBefore(code);
        if (code === 124) {
            seen = true;
            // If we start with a pipe, we open a cell marker.
            effects.enter('tableCellDivider');
            effects.consume(code);
            effects.exit('tableCellDivider');
            return headDelimiterCellBefore;
        }
        // More whitespace / empty row not allowed at start.
        return headDelimiterNok(code);
    }
    /**
   * After `|`, before delimiter cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *      ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellBefore(code) {
        if ((0, $5RE1E.markdownSpace)(code)) return (0, $5jhd5.factorySpace)(effects, headDelimiterValueBefore, "whitespace")(code);
        return headDelimiterValueBefore(code);
    }
    /**
   * Before delimiter cell value.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterValueBefore(code) {
        // Align: left.
        if (code === 58) {
            sizeB += 1;
            seen = true;
            effects.enter('tableDelimiterMarker');
            effects.consume(code);
            effects.exit('tableDelimiterMarker');
            return headDelimiterLeftAlignmentAfter;
        }
        // Align: none.
        if (code === 45) {
            sizeB += 1;
            // To do: seems weird that this *isn’t* left aligned, but that state is used?
            return headDelimiterLeftAlignmentAfter(code);
        }
        if (code === null || (0, $5RE1E.markdownLineEnding)(code)) return headDelimiterCellAfter(code);
        return headDelimiterNok(code);
    }
    /**
   * After delimiter cell left alignment marker.
   *
   * ```markdown
   *   | | a  |
   * > | | :- |
   *        ^
   * ```
   *
   * @type {State}
   */ function headDelimiterLeftAlignmentAfter(code) {
        if (code === 45) {
            effects.enter('tableDelimiterFiller');
            return headDelimiterFiller(code);
        }
        // Anything else is not ok after the left-align colon.
        return headDelimiterNok(code);
    }
    /**
   * In delimiter cell filler.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterFiller(code) {
        if (code === 45) {
            effects.consume(code);
            return headDelimiterFiller;
        }
        // Align is `center` if it was `left`, `right` otherwise.
        if (code === 58) {
            seen = true;
            effects.exit('tableDelimiterFiller');
            effects.enter('tableDelimiterMarker');
            effects.consume(code);
            effects.exit('tableDelimiterMarker');
            return headDelimiterRightAlignmentAfter;
        }
        effects.exit('tableDelimiterFiller');
        return headDelimiterRightAlignmentAfter(code);
    }
    /**
   * After delimiter cell right alignment marker.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *         ^
   * ```
   *
   * @type {State}
   */ function headDelimiterRightAlignmentAfter(code) {
        if ((0, $5RE1E.markdownSpace)(code)) return (0, $5jhd5.factorySpace)(effects, headDelimiterCellAfter, "whitespace")(code);
        return headDelimiterCellAfter(code);
    }
    /**
   * After delimiter cell.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *          ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellAfter(code) {
        if (code === 124) return headDelimiterBefore(code);
        if (code === null || (0, $5RE1E.markdownLineEnding)(code)) {
            // Exit when:
            // * there was no `:` or `|` at all (it’s a thematic break or setext
            //   underline instead)
            // * the header cell count is not the delimiter cell count
            if (!seen || size !== sizeB) return headDelimiterNok(code);
            // Note: in markdown-rs`, a reset is needed here.
            effects.exit('tableDelimiterRow');
            effects.exit('tableHead');
            // To do: in `markdown-rs`, resolvers need to be registered manually.
            // effects.register_resolver(ResolveName::GfmTable)
            return ok(code);
        }
        return headDelimiterNok(code);
    }
    /**
   * In delimiter row, at a disallowed byte.
   *
   * ```markdown
   *   | | a |
   * > | | x |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterNok(code) {
        // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
    }
    /**
   * Before table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   * ```
   *
   * @type {State}
   */ function bodyRowStart(code) {
        // Note: in `markdown-rs` we need to manually take care of a prefix,
        // but in `micromark-js` that is done for us, so if we’re here, we’re
        // never at whitespace.
        effects.enter('tableRow');
        return bodyRowBreak(code);
    }
    /**
   * At break in table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   *       ^
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowBreak(code) {
        if (code === 124) {
            effects.enter('tableCellDivider');
            effects.consume(code);
            effects.exit('tableCellDivider');
            return bodyRowBreak;
        }
        if (code === null || (0, $5RE1E.markdownLineEnding)(code)) {
            effects.exit('tableRow');
            return ok(code);
        }
        if ((0, $5RE1E.markdownSpace)(code)) return (0, $5jhd5.factorySpace)(effects, bodyRowBreak, "whitespace")(code);
        // Anything else is cell content.
        effects.enter("data");
        return bodyRowData(code);
    }
    /**
   * In table body row data.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *       ^
   * ```
   *
   * @type {State}
   */ function bodyRowData(code) {
        if (code === null || code === 124 || (0, $5RE1E.markdownLineEndingOrSpace)(code)) {
            effects.exit("data");
            return bodyRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? bodyRowEscape : bodyRowData;
    }
    /**
   * In table body row escape.
   *
   * ```markdown
   *   | | a    |
   *   | | ---- |
   * > | | b\-c |
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return bodyRowData;
        }
        return bodyRowData(code);
    }
}
/** @type {Resolver} */ function $8e44d98c70bdeefa$var$resolveTable(events, context) {
    let index = -1;
    let inFirstCellAwaitingPipe = true;
    /** @type {RowKind} */ let rowKind = 0;
    /** @type {Range} */ let lastCell = [
        0,
        0,
        0,
        0
    ];
    /** @type {Range} */ let cell = [
        0,
        0,
        0,
        0
    ];
    let afterHeadAwaitingFirstBodyRow = false;
    let lastTableEnd = 0;
    /** @type {Token | undefined} */ let currentTable;
    /** @type {Token | undefined} */ let currentBody;
    /** @type {Token | undefined} */ let currentCell;
    const map = new (0, $a2a0fd8bc4102094$export$9348908dd4518b4a)();
    while(++index < events.length){
        const event = events[index];
        const token = event[1];
        if (event[0] === 'enter') {
            // Start of head.
            if (token.type === 'tableHead') {
                afterHeadAwaitingFirstBodyRow = false;
                // Inject previous (body end and) table end.
                if (lastTableEnd !== 0) {
                    $8e44d98c70bdeefa$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
                    currentBody = undefined;
                    lastTableEnd = 0;
                }
                // Inject table start.
                currentTable = {
                    type: 'table',
                    start: Object.assign({}, token.start),
                    // Note: correct end is set later.
                    end: Object.assign({}, token.end)
                };
                map.add(index, 0, [
                    [
                        'enter',
                        currentTable,
                        context
                    ]
                ]);
            } else if (token.type === 'tableRow' || token.type === 'tableDelimiterRow') {
                inFirstCellAwaitingPipe = true;
                currentCell = undefined;
                lastCell = [
                    0,
                    0,
                    0,
                    0
                ];
                cell = [
                    0,
                    index + 1,
                    0,
                    0
                ];
                // Inject table body start.
                if (afterHeadAwaitingFirstBodyRow) {
                    afterHeadAwaitingFirstBodyRow = false;
                    currentBody = {
                        type: 'tableBody',
                        start: Object.assign({}, token.start),
                        // Note: correct end is set later.
                        end: Object.assign({}, token.end)
                    };
                    map.add(index, 0, [
                        [
                            'enter',
                            currentBody,
                            context
                        ]
                    ]);
                }
                rowKind = token.type === 'tableDelimiterRow' ? 2 : currentBody ? 3 : 1;
            } else if (rowKind && (token.type === "data" || token.type === 'tableDelimiterMarker' || token.type === 'tableDelimiterFiller')) {
                inFirstCellAwaitingPipe = false;
                // First value in cell.
                if (cell[2] === 0) {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $8e44d98c70bdeefa$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                        lastCell = [
                            0,
                            0,
                            0,
                            0
                        ];
                    }
                    cell[2] = index;
                }
            } else if (token.type === 'tableCellDivider') {
                if (inFirstCellAwaitingPipe) inFirstCellAwaitingPipe = false;
                else {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $8e44d98c70bdeefa$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                    }
                    lastCell = cell;
                    cell = [
                        lastCell[1],
                        index,
                        0,
                        0
                    ];
                }
            }
        } else if (token.type === 'tableHead') {
            afterHeadAwaitingFirstBodyRow = true;
            lastTableEnd = index;
        } else if (token.type === 'tableRow' || token.type === 'tableDelimiterRow') {
            lastTableEnd = index;
            if (lastCell[1] !== 0) {
                cell[0] = cell[1];
                currentCell = $8e44d98c70bdeefa$var$flushCell(map, context, lastCell, rowKind, index, currentCell);
            } else if (cell[1] !== 0) currentCell = $8e44d98c70bdeefa$var$flushCell(map, context, cell, rowKind, index, currentCell);
            rowKind = 0;
        } else if (rowKind && (token.type === "data" || token.type === 'tableDelimiterMarker' || token.type === 'tableDelimiterFiller')) cell[3] = index;
    }
    if (lastTableEnd !== 0) $8e44d98c70bdeefa$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
    map.consume(context.events);
    // To do: move this into `html`, when events are exposed there.
    // That’s what `markdown-rs` does.
    // That needs updates to `mdast-util-gfm-table`.
    index = -1;
    while(++index < context.events.length){
        const event = context.events[index];
        if (event[0] === 'enter' && event[1].type === 'table') event[1]._align = (0, $ff0184c28ca4d4e4$export$bbf4fe2c547a4878)(context.events, index);
    }
    return events;
}
/**
 * Generate a cell.
 *
 * @param {EditMap} map
 * @param {Readonly<TokenizeContext>} context
 * @param {Readonly<Range>} range
 * @param {RowKind} rowKind
 * @param {number | undefined} rowEnd
 * @param {Token | undefined} previousCell
 * @returns {Token | undefined}
 */ // eslint-disable-next-line max-params
function $8e44d98c70bdeefa$var$flushCell(map, context, range, rowKind, rowEnd, previousCell) {
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCell' : 'tableCell'
    const groupName = rowKind === 1 ? 'tableHeader' : rowKind === 2 ? 'tableDelimiter' : 'tableData';
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCellValue' : 'tableCellText'
    const valueName = 'tableContent';
    // Insert an exit for the previous cell, if there is one.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //          ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[0] !== 0) {
        previousCell.end = Object.assign({}, $8e44d98c70bdeefa$var$getPoint(context.events, range[0]));
        map.add(range[0], 0, [
            [
                'exit',
                previousCell,
                context
            ]
        ]);
    }
    // Insert enter of this cell.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //           ^-- enter
    //           ^^^^-- this cell
    // ```
    const now = $8e44d98c70bdeefa$var$getPoint(context.events, range[1]);
    previousCell = {
        type: groupName,
        start: Object.assign({}, now),
        // Note: correct end is set later.
        end: Object.assign({}, now)
    };
    map.add(range[1], 0, [
        [
            'enter',
            previousCell,
            context
        ]
    ]);
    // Insert text start at first data start and end at last data end, and
    // remove events between.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //            ^-- enter
    //             ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[2] !== 0) {
        const relatedStart = $8e44d98c70bdeefa$var$getPoint(context.events, range[2]);
        const relatedEnd = $8e44d98c70bdeefa$var$getPoint(context.events, range[3]);
        /** @type {Token} */ const valueToken = {
            type: valueName,
            start: Object.assign({}, relatedStart),
            end: Object.assign({}, relatedEnd)
        };
        map.add(range[2], 0, [
            [
                'enter',
                valueToken,
                context
            ]
        ]);
        if (rowKind !== 2) {
            // Fix positional info on remaining events
            const start = context.events[range[2]];
            const end = context.events[range[3]];
            start[1].end = Object.assign({}, end[1].end);
            start[1].type = "chunkText";
            start[1].contentType = "text";
            // Remove if needed.
            if (range[3] > range[2] + 1) {
                const a = range[2] + 1;
                const b = range[3] - range[2] - 1;
                map.add(a, b, []);
            }
        }
        map.add(range[3] + 1, 0, [
            [
                'exit',
                valueToken,
                context
            ]
        ]);
    }
    // Insert an exit for the last cell, if at the row end.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //                    ^-- exit
    //               ^^^^^^-- this cell (the last one contains two “between” parts)
    // ```
    if (rowEnd !== undefined) {
        previousCell.end = Object.assign({}, $8e44d98c70bdeefa$var$getPoint(context.events, rowEnd));
        map.add(rowEnd, 0, [
            [
                'exit',
                previousCell,
                context
            ]
        ]);
        previousCell = undefined;
    }
    return previousCell;
}
/**
 * Generate table end (and table body end).
 *
 * @param {Readonly<EditMap>} map
 * @param {Readonly<TokenizeContext>} context
 * @param {number} index
 * @param {Token} table
 * @param {Token | undefined} tableBody
 */ // eslint-disable-next-line max-params
function $8e44d98c70bdeefa$var$flushTableEnd(map, context, index, table, tableBody) {
    /** @type {Array<Event>} */ const exits = [];
    const related = $8e44d98c70bdeefa$var$getPoint(context.events, index);
    if (tableBody) {
        tableBody.end = Object.assign({}, related);
        exits.push([
            'exit',
            tableBody,
            context
        ]);
    }
    table.end = Object.assign({}, related);
    exits.push([
        'exit',
        table,
        context
    ]);
    map.add(index + 1, 0, exits);
}
/**
 * @param {Readonly<Array<Event>>} events
 * @param {number} index
 * @returns {Readonly<Point>}
 */ function $8e44d98c70bdeefa$var$getPoint(events, index) {
    const event = events[index];
    const side = event[0] === 'enter' ? 'start' : 'end';
    return event[1][side];
}


/**
 * @import {Extension, State, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ 





const $08ac07f643a80ce7$var$tasklistCheck = {
    name: 'tasklistCheck',
    tokenize: $08ac07f643a80ce7$var$tokenizeTasklistCheck
};
function $08ac07f643a80ce7$export$2912e8b2802475ff() {
    return {
        text: {
            [91]: $08ac07f643a80ce7$var$tasklistCheck
        }
    };
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $08ac07f643a80ce7$var$tokenizeTasklistCheck(effects, ok, nok) {
    const self = this;
    return open;
    /**
   * At start of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (// Exit if there’s stuff before.
        self.previous !== null || // Exit if not in the first content that is the first child of a list
        // item.
        !self._gfmTasklistFirstContentOfListItem) return nok(code);
        effects.enter('taskListCheck');
        effects.enter('taskListCheckMarker');
        effects.consume(code);
        effects.exit('taskListCheckMarker');
        return inside;
    }
    /**
   * In task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *        ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // Currently we match how GH works in files.
        // To match how GH works in comments, use `markdownSpace` (`[\t ]`) instead
        // of `markdownLineEndingOrSpace` (`[\t\n\r ]`).
        if ((0, $5RE1E.markdownLineEndingOrSpace)(code)) {
            effects.enter('taskListCheckValueUnchecked');
            effects.consume(code);
            effects.exit('taskListCheckValueUnchecked');
            return close;
        }
        if (code === 88 || code === 120) {
            effects.enter('taskListCheckValueChecked');
            effects.consume(code);
            effects.exit('taskListCheckValueChecked');
            return close;
        }
        return nok(code);
    }
    /**
   * At close of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *         ^
   * ```
   *
   * @type {State}
   */ function close(code) {
        if (code === 93) {
            effects.enter('taskListCheckMarker');
            effects.consume(code);
            effects.exit('taskListCheckMarker');
            effects.exit('taskListCheck');
            return after;
        }
        return nok(code);
    }
    /**
   * @type {State}
   */ function after(code) {
        // EOL in paragraph means there must be something else after it.
        if ((0, $5RE1E.markdownLineEnding)(code)) return ok(code);
        // Space or tab?
        // Check what comes after.
        if ((0, $5RE1E.markdownSpace)(code)) return effects.check({
            tokenize: $08ac07f643a80ce7$var$spaceThenNonSpace
        }, ok, nok)(code);
        // EOF, or non-whitespace, both wrong.
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $08ac07f643a80ce7$var$spaceThenNonSpace(effects, ok, nok) {
    return (0, $5jhd5.factorySpace)(effects, after, "whitespace");
    /**
   * After whitespace, after task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *           ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // EOF means there was nothing, so bad.
        // EOL means there’s content after it, so good.
        // Impossible to have more spaces.
        // Anything else is good.
        return code === null ? nok(code) : ok(code);
    }
}


/**
 * @import {Info, Join, Options, SafeConfig, State} from 'mdast-util-to-markdown'
 * @import {Nodes} from 'mdast'
 * @import {Enter, FlowParents, PhrasingParents, TrackFields} from './types.js'
 */ 
var $hoXSS = parcelRequire("hoXSS");

/**
 * @import {Options, State} from './types.js'
 */ const $b6347ca6f323b0a9$var$own = {}.hasOwnProperty;
function $b6347ca6f323b0a9$export$8d21e34596265fa2(base, extension) {
    let index = -1;
    /** @type {keyof Options} */ let key;
    // First do subextensions.
    if (extension.extensions) while(++index < extension.extensions.length)$b6347ca6f323b0a9$export$8d21e34596265fa2(base, extension.extensions[index]);
    for(key in extension)if ($b6347ca6f323b0a9$var$own.call(extension, key)) switch(key){
        case 'extensions':
            break;
        /* c8 ignore next 4 */ case 'unsafe':
            $b6347ca6f323b0a9$var$list(base[key], extension[key]);
            break;
        case 'join':
            $b6347ca6f323b0a9$var$list(base[key], extension[key]);
            break;
        case 'handlers':
            $b6347ca6f323b0a9$var$map(base[key], extension[key]);
            break;
        default:
            // @ts-expect-error: matches.
            base.options[key] = extension[key];
    }
    return base;
}
/**
 * @template T
 * @param {Array<T>} left
 * @param {Array<T> | null | undefined} right
 */ function $b6347ca6f323b0a9$var$list(left, right) {
    if (right) left.push(...right);
}
/**
 * @template T
 * @param {Record<string, T>} left
 * @param {Record<string, T> | null | undefined} right
 */ function $b6347ca6f323b0a9$var$map(left, right) {
    if (right) Object.assign(left, right);
}



/**
 * @import {Join} from 'mdast-util-to-markdown'
 */ 

const $48f779c5b96327fd$export$f7e2c8231c57a8bd = [
    $48f779c5b96327fd$var$joinDefaults
];
/** @type {Join} */ function $48f779c5b96327fd$var$joinDefaults(left, right, parent, state) {
    // Indented code after list or another indented code.
    if (right.type === 'code' && (0, $f094dc48315fec93$export$8c0df78a8cad9f4b)(right, state) && (left.type === 'list' || left.type === right.type && (0, $f094dc48315fec93$export$8c0df78a8cad9f4b)(left, state))) return false;
    // Join children of a list or an item.
    // In which case, `parent` has a `spread` field.
    if ('spread' in parent && typeof parent.spread === 'boolean') {
        if (left.type === 'paragraph' && // Two paragraphs.
        (left.type === right.type || right.type === 'definition' || // Paragraph followed by a setext heading.
        right.type === 'heading' && (0, $eb35c8f481069a11$export$78863676235adfbc)(right, state))) return;
        return parent.spread ? 1 : 0;
    }
}


/**
 * @import {ConstructName, Unsafe} from 'mdast-util-to-markdown'
 */ /**
 * List of constructs that occur in phrasing (paragraphs, headings), but cannot
 * contain things like attention (emphasis, strong), images, or links.
 * So they sort of cancel each other out.
 * Note: could use a better name.
 *
 * @type {Array<ConstructName>}
 */ const $7d0cf6d929b7d4a1$var$fullPhrasingSpans = [
    'autolink',
    'destinationLiteral',
    'destinationRaw',
    'reference',
    'titleQuote',
    'titleApostrophe'
];
const $7d0cf6d929b7d4a1$export$aa1c11b655786597 = [
    {
        character: '\t',
        after: '[\\r\\n]',
        inConstruct: 'phrasing'
    },
    {
        character: '\t',
        before: '[\\r\\n]',
        inConstruct: 'phrasing'
    },
    {
        character: '\t',
        inConstruct: [
            'codeFencedLangGraveAccent',
            'codeFencedLangTilde'
        ]
    },
    {
        character: '\r',
        inConstruct: [
            'codeFencedLangGraveAccent',
            'codeFencedLangTilde',
            'codeFencedMetaGraveAccent',
            'codeFencedMetaTilde',
            'destinationLiteral',
            'headingAtx'
        ]
    },
    {
        character: '\n',
        inConstruct: [
            'codeFencedLangGraveAccent',
            'codeFencedLangTilde',
            'codeFencedMetaGraveAccent',
            'codeFencedMetaTilde',
            'destinationLiteral',
            'headingAtx'
        ]
    },
    {
        character: ' ',
        after: '[\\r\\n]',
        inConstruct: 'phrasing'
    },
    {
        character: ' ',
        before: '[\\r\\n]',
        inConstruct: 'phrasing'
    },
    {
        character: ' ',
        inConstruct: [
            'codeFencedLangGraveAccent',
            'codeFencedLangTilde'
        ]
    },
    // An exclamation mark can start an image, if it is followed by a link or
    // a link reference.
    {
        character: '!',
        after: '\\[',
        inConstruct: 'phrasing',
        notInConstruct: $7d0cf6d929b7d4a1$var$fullPhrasingSpans
    },
    // A quote can break out of a title.
    {
        character: '"',
        inConstruct: 'titleQuote'
    },
    // A number sign could start an ATX heading if it starts a line.
    {
        atBreak: true,
        character: '#'
    },
    {
        character: '#',
        inConstruct: 'headingAtx',
        after: '(?:[\r\n]|$)'
    },
    // Dollar sign and percentage are not used in markdown.
    // An ampersand could start a character reference.
    {
        character: '&',
        after: '[#A-Za-z]',
        inConstruct: 'phrasing'
    },
    // An apostrophe can break out of a title.
    {
        character: "'",
        inConstruct: 'titleApostrophe'
    },
    // A left paren could break out of a destination raw.
    {
        character: '(',
        inConstruct: 'destinationRaw'
    },
    // A left paren followed by `]` could make something into a link or image.
    {
        before: '\\]',
        character: '(',
        inConstruct: 'phrasing',
        notInConstruct: $7d0cf6d929b7d4a1$var$fullPhrasingSpans
    },
    // A right paren could start a list item or break out of a destination
    // raw.
    {
        atBreak: true,
        before: '\\d+',
        character: ')'
    },
    {
        character: ')',
        inConstruct: 'destinationRaw'
    },
    // An asterisk can start thematic breaks, list items, emphasis, strong.
    {
        atBreak: true,
        character: '*',
        after: '(?:[ \t\r\n*])'
    },
    {
        character: '*',
        inConstruct: 'phrasing',
        notInConstruct: $7d0cf6d929b7d4a1$var$fullPhrasingSpans
    },
    // A plus sign could start a list item.
    {
        atBreak: true,
        character: '+',
        after: '(?:[ \t\r\n])'
    },
    // A dash can start thematic breaks, list items, and setext heading
    // underlines.
    {
        atBreak: true,
        character: '-',
        after: '(?:[ \t\r\n-])'
    },
    // A dot could start a list item.
    {
        atBreak: true,
        before: '\\d+',
        character: '.',
        after: '(?:[ \t\r\n]|$)'
    },
    // Slash, colon, and semicolon are not used in markdown for constructs.
    // A less than can start html (flow or text) or an autolink.
    // HTML could start with an exclamation mark (declaration, cdata, comment),
    // slash (closing tag), question mark (instruction), or a letter (tag).
    // An autolink also starts with a letter.
    // Finally, it could break out of a destination literal.
    {
        atBreak: true,
        character: '<',
        after: '[!/?A-Za-z]'
    },
    {
        character: '<',
        after: '[!/?A-Za-z]',
        inConstruct: 'phrasing',
        notInConstruct: $7d0cf6d929b7d4a1$var$fullPhrasingSpans
    },
    {
        character: '<',
        inConstruct: 'destinationLiteral'
    },
    // An equals to can start setext heading underlines.
    {
        atBreak: true,
        character: '='
    },
    // A greater than can start block quotes and it can break out of a
    // destination literal.
    {
        atBreak: true,
        character: '>'
    },
    {
        character: '>',
        inConstruct: 'destinationLiteral'
    },
    // Question mark and at sign are not used in markdown for constructs.
    // A left bracket can start definitions, references, labels,
    {
        atBreak: true,
        character: '['
    },
    {
        character: '[',
        inConstruct: 'phrasing',
        notInConstruct: $7d0cf6d929b7d4a1$var$fullPhrasingSpans
    },
    {
        character: '[',
        inConstruct: [
            'label',
            'reference'
        ]
    },
    // A backslash can start an escape (when followed by punctuation) or a
    // hard break (when followed by an eol).
    // Note: typical escapes are handled in `safe`!
    {
        character: '\\',
        after: '[\\r\\n]',
        inConstruct: 'phrasing'
    },
    // A right bracket can exit labels.
    {
        character: ']',
        inConstruct: [
            'label',
            'reference'
        ]
    },
    // Caret is not used in markdown for constructs.
    // An underscore can start emphasis, strong, or a thematic break.
    {
        atBreak: true,
        character: '_'
    },
    {
        character: '_',
        inConstruct: 'phrasing',
        notInConstruct: $7d0cf6d929b7d4a1$var$fullPhrasingSpans
    },
    // A grave accent can start code (fenced or text), or it can break out of
    // a grave accent code fence.
    {
        atBreak: true,
        character: '`'
    },
    {
        character: '`',
        inConstruct: [
            'codeFencedLangGraveAccent',
            'codeFencedMetaGraveAccent'
        ]
    },
    {
        character: '`',
        inConstruct: 'phrasing',
        notInConstruct: $7d0cf6d929b7d4a1$var$fullPhrasingSpans
    },
    // Left brace, vertical bar, right brace are not used in markdown for
    // constructs.
    // A tilde can start code (fenced).
    {
        atBreak: true,
        character: '~'
    }
];


/**
 * @import {AssociationId} from '../types.js'
 */ 
function $58ce869ecb320950$export$c4ca1a6065421754(node) {
    if (node.label || !node.identifier) return node.label || '';
    return (0, $6e1bc74b64366ebf$export$a0fb664af7d0cc44)(node.identifier);
}


/**
 * @import {CompilePattern} from '../types.js'
 */ /**
 * @type {CompilePattern}
 */ function $2a3f6176006039b4$export$2db8af076f277cbf(pattern) {
    if (!pattern._compiled) {
        const before = (pattern.atBreak ? '[\\r\\n][\\t ]*' : '') + (pattern.before ? '(?:' + pattern.before + ')' : '');
        pattern._compiled = new RegExp((before ? '(' + before + ')' : '') + (/[|\\{}()[\]^$+*?.-]/.test(pattern.character) ? '\\' : '') + pattern.character + (pattern.after ? '(?:' + pattern.after + ')' : ''), 'g');
    }
    return pattern._compiled;
}


/**
 * @import {Handle, Info, State} from 'mdast-util-to-markdown'
 * @import {PhrasingParents} from '../types.js'
 */ 
function $8270eeb4f35216ef$export$f4090a9439f37631(parent, state, info) {
    const indexStack = state.indexStack;
    const children = parent.children || [];
    /** @type {Array<string>} */ const results = [];
    let index = -1;
    let before = info.before;
    /** @type {string | undefined} */ let encodeAfter;
    indexStack.push(-1);
    let tracker = state.createTracker(info);
    while(++index < children.length){
        const child = children[index];
        /** @type {string} */ let after;
        indexStack[indexStack.length - 1] = index;
        if (index + 1 < children.length) {
            /** @type {Handle} */ // @ts-expect-error: hush, it’s actually a `zwitch`.
            let handle = state.handle.handlers[children[index + 1].type];
            /** @type {Handle} */ // @ts-expect-error: hush, it’s actually a `zwitch`.
            if (handle && handle.peek) handle = handle.peek;
            after = handle ? handle(children[index + 1], parent, state, {
                before: '',
                after: '',
                ...tracker.current()
            }).charAt(0) : '';
        } else after = info.after;
        // In some cases, html (text) can be found in phrasing right after an eol.
        // When we’d serialize that, in most cases that would be seen as html
        // (flow).
        // As we can’t escape or so to prevent it from happening, we take a somewhat
        // reasonable approach: replace that eol with a space.
        // See: <https://github.com/syntax-tree/mdast-util-to-markdown/issues/15>
        if (results.length > 0 && (before === '\r' || before === '\n') && child.type === 'html') {
            results[results.length - 1] = results[results.length - 1].replace(/(\r?\n|\r)$/, ' ');
            before = ' ';
            // To do: does this work to reset tracker?
            tracker = state.createTracker(info);
            tracker.move(results.join(''));
        }
        let value = state.handle(child, parent, state, {
            ...tracker.current(),
            after: after,
            before: before
        });
        // If we had to encode the first character after the previous node and it’s
        // still the same character,
        // encode it.
        if (encodeAfter && encodeAfter === value.slice(0, 1)) value = (0, $99eff785a80d0ced$export$5810cf1e579e9d5b)(encodeAfter.charCodeAt(0)) + value.slice(1);
        const encodingInfo = state.attentionEncodeSurroundingInfo;
        state.attentionEncodeSurroundingInfo = undefined;
        encodeAfter = undefined;
        // If we have to encode the first character before the current node and
        // it’s still the same character,
        // encode it.
        if (encodingInfo) {
            if (results.length > 0 && encodingInfo.before && before === results[results.length - 1].slice(-1)) results[results.length - 1] = results[results.length - 1].slice(0, -1) + (0, $99eff785a80d0ced$export$5810cf1e579e9d5b)(before.charCodeAt(0));
            if (encodingInfo.after) encodeAfter = after;
        }
        tracker.move(value);
        results.push(value);
        before = value.slice(-1);
    }
    indexStack.pop();
    return results.join('');
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {FlowChildren, FlowParents, TrackFields} from '../types.js'
 */ /**
 * @param {FlowParents} parent
 *   Parent of flow nodes.
 * @param {State} state
 *   Info passed around about the current state.
 * @param {TrackFields} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined by (blank) lines.
 */ function $0b01b37275d7c291$export$134f7fdacfea8b16(parent, state, info) {
    const indexStack = state.indexStack;
    const children = parent.children || [];
    const tracker = state.createTracker(info);
    /** @type {Array<string>} */ const results = [];
    let index = -1;
    indexStack.push(-1);
    while(++index < children.length){
        const child = children[index];
        indexStack[indexStack.length - 1] = index;
        results.push(tracker.move(state.handle(child, parent, state, {
            before: '\n',
            after: '\n',
            ...tracker.current()
        })));
        if (child.type !== 'list') state.bulletLastUsed = undefined;
        if (index < children.length - 1) results.push(tracker.move($0b01b37275d7c291$var$between(child, children[index + 1], parent, state)));
    }
    indexStack.pop();
    return results.join('');
}
/**
 * @param {FlowChildren} left
 * @param {FlowChildren} right
 * @param {FlowParents} parent
 * @param {State} state
 * @returns {string}
 */ function $0b01b37275d7c291$var$between(left, right, parent, state) {
    let index = state.join.length;
    while(index--){
        const result = state.join[index](left, right, parent, state);
        if (result === true || result === 1) break;
        if (typeof result === 'number') return '\n'.repeat(1 + result);
        if (result === false) return '\n\n<!---->\n\n';
    }
    return '\n\n';
}


/**
 * @import {IndentLines} from '../types.js'
 */ const $82cc3fc51cd22711$var$eol = /\r?\n|\r/g;
function $82cc3fc51cd22711$export$7c3cf23d514b264a(value, map) {
    /** @type {Array<string>} */ const result = [];
    let start = 0;
    let line = 0;
    /** @type {RegExpExecArray | null} */ let match;
    while(match = $82cc3fc51cd22711$var$eol.exec(value)){
        one(value.slice(start, match.index));
        result.push(match[0]);
        start = match.index + match[0].length;
        line++;
    }
    one(value.slice(start));
    return result.join('');
    /**
   * @param {string} value
   */ function one(value) {
        result.push(map(value, line, !value));
    }
}


/**
 * @import {SafeConfig, State} from 'mdast-util-to-markdown'
 */ 

function $c66837d68120501a$export$170b8c323eee7bec(state, input, config) {
    const value = (config.before || '') + (input || '') + (config.after || '');
    /** @type {Array<number>} */ const positions = [];
    /** @type {Array<string>} */ const result = [];
    /** @type {Record<number, {before: boolean, after: boolean}>} */ const infos = {};
    let index = -1;
    while(++index < state.unsafe.length){
        const pattern = state.unsafe[index];
        if (!(0, $36b9be5098ae8407$export$78221a09424368d)(state.stack, pattern)) continue;
        const expression = state.compilePattern(pattern);
        /** @type {RegExpExecArray | null} */ let match;
        while(match = expression.exec(value)){
            const before = 'before' in pattern || Boolean(pattern.atBreak);
            const after = 'after' in pattern;
            const position = match.index + (before ? match[1].length : 0);
            if (positions.includes(position)) {
                if (infos[position].before && !before) infos[position].before = false;
                if (infos[position].after && !after) infos[position].after = false;
            } else {
                positions.push(position);
                infos[position] = {
                    before: before,
                    after: after
                };
            }
        }
    }
    positions.sort($c66837d68120501a$var$numerical);
    let start = config.before ? config.before.length : 0;
    const end = value.length - (config.after ? config.after.length : 0);
    index = -1;
    while(++index < positions.length){
        const position = positions[index];
        // Character before or after matched:
        if (position < start || position >= end) continue;
        // If this character is supposed to be escaped because it has a condition on
        // the next character, and the next character is definitly being escaped,
        // then skip this escape.
        if (position + 1 < end && positions[index + 1] === position + 1 && infos[position].after && !infos[position + 1].before && !infos[position + 1].after || positions[index - 1] === position - 1 && infos[position].before && !infos[position - 1].before && !infos[position - 1].after) continue;
        if (start !== position) // If we have to use a character reference, an ampersand would be more
        // correct, but as backslashes only care about punctuation, either will
        // do the trick
        result.push($c66837d68120501a$var$escapeBackslashes(value.slice(start, position), '\\'));
        start = position;
        if (/[!-/:-@[-`{-~]/.test(value.charAt(position)) && (!config.encode || !config.encode.includes(value.charAt(position)))) // Character escape.
        result.push('\\');
        else {
            // Character reference.
            result.push((0, $99eff785a80d0ced$export$5810cf1e579e9d5b)(value.charCodeAt(position)));
            start++;
        }
    }
    result.push($c66837d68120501a$var$escapeBackslashes(value.slice(start, end), config.after));
    return result.join('');
}
/**
 * @param {number} a
 * @param {number} b
 * @returns {number}
 */ function $c66837d68120501a$var$numerical(a, b) {
    return a - b;
}
/**
 * @param {string} value
 * @param {string} after
 * @returns {string}
 */ function $c66837d68120501a$var$escapeBackslashes(value, after) {
    const expression = /\\(?=[!-/:-@[-`{-~])/g;
    /** @type {Array<number>} */ const positions = [];
    /** @type {Array<string>} */ const results = [];
    const whole = value + after;
    let index = -1;
    let start = 0;
    /** @type {RegExpExecArray | null} */ let match;
    while(match = expression.exec(whole))positions.push(match.index);
    while(++index < positions.length){
        if (start !== positions[index]) results.push(value.slice(start, positions[index]));
        results.push('\\');
        start = positions[index];
    }
    results.push(value.slice(start));
    return results.join('');
}


/**
 * @import {CreateTracker, TrackCurrent, TrackMove, TrackShift} from '../types.js'
 */ /**
 * Track positional info in the output.
 *
 * @type {CreateTracker}
 */ function $68261882685d1bba$export$6b2a7d5132615086(config) {
    // Defaults are used to prevent crashes when older utilities somehow activate
    // this code.
    /* c8 ignore next 5 */ const options = config || {};
    const now = options.now || {};
    let lineShift = options.lineShift || 0;
    let line = now.line || 1;
    let column = now.column || 1;
    return {
        move: move,
        current: current,
        shift: shift
    };
    /**
   * Get the current tracked info.
   *
   * @type {TrackCurrent}
   */ function current() {
        return {
            now: {
                line: line,
                column: column
            },
            lineShift: lineShift
        };
    }
    /**
   * Define an increased line shift (the typical indent for lines).
   *
   * @type {TrackShift}
   */ function shift(value) {
        lineShift += value;
    }
    /**
   * Move past some generated markdown.
   *
   * @type {TrackMove}
   */ function move(input) {
        // eslint-disable-next-line unicorn/prefer-default-parameters
        const value = input || '';
        const chunks = value.split(/\r?\n|\r/g);
        const tail = chunks[chunks.length - 1];
        line += chunks.length - 1;
        column = chunks.length === 1 ? column + tail.length : 1 + tail.length + lineShift;
        return value;
    }
}


function $1de3130294731997$export$49a1dda9e62e8ae6(tree, options) {
    const settings = options || {};
    /** @type {State} */ const state = {
        associationId: (0, $58ce869ecb320950$export$c4ca1a6065421754),
        containerPhrasing: $1de3130294731997$var$containerPhrasingBound,
        containerFlow: $1de3130294731997$var$containerFlowBound,
        createTracker: (0, $68261882685d1bba$export$6b2a7d5132615086),
        compilePattern: $2a3f6176006039b4$export$2db8af076f277cbf,
        enter: enter,
        // @ts-expect-error: GFM / frontmatter are typed in `mdast` but not defined
        // here.
        handlers: {
            ...(0, $d72bf69742075527$export$8f34ce051745d39e)
        },
        // @ts-expect-error: add `handle` in a second.
        handle: undefined,
        indentLines: $82cc3fc51cd22711$export$7c3cf23d514b264a,
        indexStack: [],
        join: [
            ...(0, $48f779c5b96327fd$export$f7e2c8231c57a8bd)
        ],
        options: {},
        safe: $1de3130294731997$var$safeBound,
        stack: [],
        unsafe: [
            ...(0, $7d0cf6d929b7d4a1$export$aa1c11b655786597)
        ]
    };
    (0, $b6347ca6f323b0a9$export$8d21e34596265fa2)(state, settings);
    if (state.options.tightDefinitions) state.join.push($1de3130294731997$var$joinDefinition);
    state.handle = (0, $hoXSS.zwitch)('type', {
        invalid: $1de3130294731997$var$invalid,
        unknown: $1de3130294731997$var$unknown,
        handlers: state.handlers
    });
    let result = state.handle(tree, undefined, state, {
        before: '\n',
        after: '\n',
        now: {
            line: 1,
            column: 1
        },
        lineShift: 0
    });
    if (result && result.charCodeAt(result.length - 1) !== 10 && result.charCodeAt(result.length - 1) !== 13) result += '\n';
    return result;
    /** @type {Enter} */ function enter(name) {
        state.stack.push(name);
        return exit;
        /**
     * @returns {undefined}
     */ function exit() {
            state.stack.pop();
        }
    }
}
/**
 * @param {unknown} value
 * @returns {never}
 */ function $1de3130294731997$var$invalid(value) {
    throw new Error('Cannot handle value `' + value + '`, expected node');
}
/**
 * @param {unknown} value
 * @returns {never}
 */ function $1de3130294731997$var$unknown(value) {
    // Always a node.
    const node = /** @type {Nodes} */ value;
    throw new Error('Cannot handle unknown node `' + node.type + '`');
}
/** @type {Join} */ function $1de3130294731997$var$joinDefinition(left, right) {
    // No blank line between adjacent definitions.
    if (left.type === 'definition' && left.type === right.type) return 0;
}
/**
 * Serialize the children of a parent that contains phrasing children.
 *
 * These children will be joined flush together.
 *
 * @this {State}
 *   Info passed around about the current state.
 * @param {PhrasingParents} parent
 *   Parent of flow nodes.
 * @param {Info} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined together.
 */ function $1de3130294731997$var$containerPhrasingBound(parent, info) {
    return (0, $8270eeb4f35216ef$export$f4090a9439f37631)(parent, this, info);
}
/**
 * Serialize the children of a parent that contains flow children.
 *
 * These children will typically be joined by blank lines.
 * What they are joined by exactly is defined by `Join` functions.
 *
 * @this {State}
 *   Info passed around about the current state.
 * @param {FlowParents} parent
 *   Parent of flow nodes.
 * @param {TrackFields} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined by (blank) lines.
 */ function $1de3130294731997$var$containerFlowBound(parent, info) {
    return (0, $0b01b37275d7c291$export$134f7fdacfea8b16)(parent, this, info);
}
/**
 * Make a string safe for embedding in markdown constructs.
 *
 * In markdown, almost all punctuation characters can, in certain cases,
 * result in something.
 * Whether they do is highly subjective to where they happen and in what
 * they happen.
 *
 * To solve this, `mdast-util-to-markdown` tracks:
 *
 * * Characters before and after something;
 * * What “constructs” we are in.
 *
 * This information is then used by this function to escape or encode
 * special characters.
 *
 * @this {State}
 *   Info passed around about the current state.
 * @param {string | null | undefined} value
 *   Raw value to make safe.
 * @param {SafeConfig} config
 *   Configuration.
 * @returns {string}
 *   Serialized markdown safe for embedding.
 */ function $1de3130294731997$var$safeBound(value, config) {
    return (0, $c66837d68120501a$export$170b8c323eee7bec)(this, value, config);
}





function $b89a62939662ea40$export$a20071ce53c4b064(node, marks) {
    let result = node;
    for (const mark of marks)switch(mark.type.name){
        case 'strong':
            result = {
                type: 'strong',
                children: [
                    result
                ]
            };
            break;
        case 'em':
            result = {
                type: 'emphasis',
                children: [
                    result
                ]
            };
            break;
        case 'code':
            // Inline code — unwrap text value
            if (result.type === 'text') result = {
                type: 'inlineCode',
                value: result.value
            };
            break;
        case 'link':
            result = {
                type: 'link',
                url: mark.attrs.href ?? '',
                title: mark.attrs.title ?? null,
                children: [
                    result
                ]
            };
            break;
        case 'strike':
        case 'strikethrough':
            // GFM strikethrough ~~text~~ — symmetric with the `delete` handler in to-pm
            result = {
                type: 'delete',
                children: [
                    result
                ]
            };
            break;
        default:
            break;
    }
    return result;
}
function $b89a62939662ea40$export$d157f1daa0528112(node, handlers) {
    const children = [];
    node.forEach((child)=>{
        const handler = handlers[child.type.name];
        if (handler) {
            const result = handler(child);
            if (result) {
                if (Array.isArray(result)) children.push(...result);
                else children.push(result);
            }
        }
    });
    return children;
}
/**
 * Returns a stable key representing the non-annotation marks on a text node,
 * used to determine whether adjacent text nodes can be merged for serialization.
 *
 * Two text nodes are mergeable if they have the same set of non-annotation marks
 * (in the same order — ProseMirror maintains mark order by schema rank).
 * Annotation marks are excluded because they are tracked as character ranges
 * separately from the markdown string and don't affect markdown syntax.
 */ function $b89a62939662ea40$var$nonAnnotationMarkKey(marks) {
    return marks.filter((m)=>m.type.name !== 'annotation').map((m)=>`${m.type.name}:${JSON.stringify(m.attrs)}`).join('|');
}
function $b89a62939662ea40$export$4db834a02b589b8(node, handlers) {
    const merged = [];
    node.forEach((child)=>{
        if (child.isText && child.text) {
            const last = merged[merged.length - 1];
            if (last && 'text' in last && $b89a62939662ea40$var$nonAnnotationMarkKey(last.marks) === $b89a62939662ea40$var$nonAnnotationMarkKey(child.marks)) // Same non-annotation marks — merge text into the previous run.
            last.text += child.text;
            else merged.push({
                text: child.text,
                marks: child.marks
            });
        } else merged.push({
            pmNode: child
        });
    });
    // Second pass: convert merged runs to mdast nodes.
    const children = [];
    for (const item of merged)if ('pmNode' in item) {
        const handler = handlers[item.pmNode.type.name];
        if (handler) {
            const result = handler(item.pmNode);
            if (result) {
                const nodes = Array.isArray(result) ? result : [
                    result
                ];
                children.push(...nodes);
            }
        }
    } else {
        // Use only non-annotation marks for markdown syntax — annotation marks
        // are tracked as character ranges, not embedded in the markdown string.
        const nonAnnotationMarks = item.marks.filter((m)=>m.type.name !== 'annotation');
        const textNode = $b89a62939662ea40$export$a20071ce53c4b064({
            type: 'text',
            value: item.text
        }, nonAnnotationMarks);
        children.push(textNode);
    }
    return children;
}


function $6cf3b1693639abd3$export$9c206ddddb32a9b(node, handlers) {
    const children = (0, $b89a62939662ea40$export$4db834a02b589b8)(node, handlers);
    return {
        type: 'paragraph',
        children: children
    };
}



function $b793a7a10e14064c$export$46e4a324ac90507f(node, handlers) {
    const depth = node.attrs.level ?? 1;
    const children = (0, $b89a62939662ea40$export$4db834a02b589b8)(node, handlers);
    return {
        type: 'heading',
        depth: depth,
        children: children
    };
}


function $5fc317b8e6aaed4e$export$6f093cfa640b7166(node) {
    const value = node.text ?? '';
    return {
        type: 'text',
        value: value
    };
}


function $0495107e87c5df1c$export$371da9dd35aba193() {
    return {
        type: 'break'
    };
}


function $9174e1e4b42d0d7c$export$ba7b13e047416c03() {
    return {
        type: 'thematicBreak'
    };
}


function $aff53c42e8aff7f7$export$5c452ff88e35e47d(node) {
    const url = node.attrs.src ?? '';
    const alt = node.attrs.alt ?? undefined;
    const title = node.attrs.title ?? undefined;
    return {
        type: 'image',
        url: url,
        alt: alt,
        title: title
    };
}


/**
 * Handlers for ADF `mediaSingle` / `media` nodes.
 *
 * Strategy: produce a CommonMark image (`![alt](url)`) so the markdown is
 * portable to external clients (VS Code preview, GitHub, etc.). What goes
 * in `url` depends on the media node's `type`:
 *
 *   - `external` — emit `attrs.url` verbatim. No auth involved.
 *   - `file`     — emit a tenant-scoped Confluence proxy URL
 *                  (`/wiki/download/attachments/{contentId}/{filename}`)
 *                  produced by an injected `serializeFileMedia` callback.
 *                  The proxy resolves with the viewer's Confluence session
 *                  cookie, so no media token / PAT ever lives in the
 *                  markdown text. When no callback is supplied (e.g. the
 *                  default platform handler used outside Confluence) we
 *                  fall back to alt-text-only — never a `blob:` / token
 *                  URL — to keep this safe by default.
 *
 * Caveats deliberately accepted in v1:
 *   - `mediaSingle` layout / width are dropped on serialise. CommonMark
 *     has no representation for them and the round-trip parser
 *     (`@atlaskit/editor-markdown-transformer` + `markdown-it-media`)
 *     re-applies schema defaults on the way back, so the editor will
 *     re-render them sensibly.
 *   - `mediaSingleCaption`, `mediaGroup` and `mediaInline` are filtered
 *     out before they reach this handler (see `filterToMarkdownSafeAdf`
 *     in @confluence/content-markdown-mode). Anything that does reach
 *     us is treated as a single media child.
 */ const $7f53e529d3867c12$var$readString = (value)=>typeof value === 'string' && value.length > 0 ? value : undefined;
const $7f53e529d3867c12$var$readNumber = (value)=>typeof value === 'number' && Number.isFinite(value) ? value : undefined;
/**
 * Convert a single `media` node to an mdast `image`. Returns `undefined`
 * when the node has no representable URL — the caller will skip it.
 */ const $7f53e529d3867c12$var$mediaToImage = (node, serializeFileMedia)=>{
    const attrs = node.attrs ?? {};
    const type = $7f53e529d3867c12$var$readString(attrs.type);
    const alt = $7f53e529d3867c12$var$readString(attrs.alt) ?? '';
    let url;
    if (type === 'external') // External media: URL is public and lives on `attrs.url`.
    url = $7f53e529d3867c12$var$readString(attrs.url);
    else if (type === 'file') {
        // File media: rely on the Confluence-supplied proxy serialiser.
        // Without one, we have no way to express the bytes in valid markdown
        // (we deliberately refuse to embed media tokens or fake `blob:` URLs).
        const id = $7f53e529d3867c12$var$readString(attrs.id);
        if (id && serializeFileMedia) url = serializeFileMedia({
            id: id,
            collection: $7f53e529d3867c12$var$readString(attrs.collection),
            alt: $7f53e529d3867c12$var$readString(attrs.alt),
            width: $7f53e529d3867c12$var$readNumber(attrs.width),
            height: $7f53e529d3867c12$var$readNumber(attrs.height)
        });
    } else // Unknown / future media types — best-effort: pick `url` if present,
    // otherwise drop. This keeps us forward-compatible without inventing
    // behaviour we can't reason about.
    url = $7f53e529d3867c12$var$readString(attrs.url);
    if (!url) {
        // No URL available. Surface the alt text as a plain image node with
        // an empty URL — `filterToMarkdownSafeAdf` should have prevented this
        // for `file` media in production paths, but better to emit
        // `![alt]()` than to throw or silently drop.
        if (!alt) return undefined;
        return {
            type: 'image',
            url: '',
            alt: alt
        };
    }
    return {
        type: 'image',
        url: url,
        alt: alt
    };
};
/**
 * Wrap an `Image` (mdast PhrasingContent — inline) in a `Paragraph` so it
 * can be inserted as a block-level child of the mdast root.
 *
 * Why: ADF's `mediaSingle` is a block-level node (sibling of `paragraph` /
 * `heading`), but CommonMark has no block-level image construct. The
 * closest valid representation is a paragraph containing only the image,
 * which `mdast-util-to-markdown` will surround with blank lines — exactly
 * the visual block effect we want.
 *
 * Skipping this wrapper causes `mdast-util-to-markdown` to concatenate
 * the inline image with neighbouring blocks (and to drop the blank-line
 * separators), which manifests as the entire document compressing onto
 * one line — see EDITOR-6636.
 */ const $7f53e529d3867c12$var$wrapInParagraph = (image)=>image ? {
        type: 'paragraph',
        children: [
            image
        ]
    } : undefined;
const $7f53e529d3867c12$export$987d49ffe1b0900f = (node)=>$7f53e529d3867c12$var$wrapInParagraph($7f53e529d3867c12$var$mediaToImage(node));
const $7f53e529d3867c12$export$969fe3781ca15058 = (node)=>{
    let mediaChild;
    node.forEach((child)=>{
        if (!mediaChild && child.type.name === 'media') mediaChild = child;
    });
    if (!mediaChild) return undefined;
    return $7f53e529d3867c12$var$wrapInParagraph($7f53e529d3867c12$var$mediaToImage(mediaChild));
};
const $7f53e529d3867c12$export$a0da5befa47b223d = ({ serializeFileMedia: serializeFileMedia } = {})=>({
        media: (node)=>$7f53e529d3867c12$var$wrapInParagraph($7f53e529d3867c12$var$mediaToImage(node, serializeFileMedia)),
        mediaSingle: (node)=>{
            let mediaChild;
            node.forEach((child)=>{
                if (!mediaChild && child.type.name === 'media') mediaChild = child;
            });
            return mediaChild ? $7f53e529d3867c12$var$wrapInParagraph($7f53e529d3867c12$var$mediaToImage(mediaChild, serializeFileMedia)) : undefined;
        }
    });


const $ec448e901307d19f$var$getStringAttr = (value)=>typeof value === 'string' && value.length > 0 ? value : undefined;
const $ec448e901307d19f$var$getSmartLinkData = (node)=>typeof node.attrs.data === 'object' && node.attrs.data !== null && !Array.isArray(node.attrs.data) ? node.attrs.data : undefined;
const $ec448e901307d19f$var$getSmartLinkUrl = (node)=>{
    const data = $ec448e901307d19f$var$getSmartLinkData(node);
    return $ec448e901307d19f$var$getStringAttr(node.attrs.url) ?? $ec448e901307d19f$var$getStringAttr(data?.url) ?? $ec448e901307d19f$var$getStringAttr(data?.['@id']) ?? '';
};
const $ec448e901307d19f$var$getSmartLinkTitle = (node, url)=>{
    const data = $ec448e901307d19f$var$getSmartLinkData(node);
    return $ec448e901307d19f$var$getStringAttr(data?.name) ?? $ec448e901307d19f$var$getStringAttr(data?.title) ?? url;
};
function $ec448e901307d19f$export$cbf8224b64e0d942(node) {
    const url = $ec448e901307d19f$var$getSmartLinkUrl(node);
    if (!url) {
        const title = $ec448e901307d19f$var$getSmartLinkTitle(node, url);
        return title ? {
            type: 'text',
            value: title
        } : null;
    }
    return {
        type: 'link',
        url: url,
        title: null,
        children: [
            {
                type: 'text',
                value: $ec448e901307d19f$var$getSmartLinkTitle(node, url)
            }
        ]
    };
}


function $c3b7e779c07260d8$export$7bb0d5c671655cc4(node) {
    let value = '';
    node.forEach((child)=>{
        if (child.isText) value += child.text;
    });
    const result = {
        type: 'code',
        value: value
    };
    const lang = node.attrs.language ?? node.attrs.lang;
    if (lang) result.lang = lang;
    return result;
}



function $ea4d8851563f02a9$export$67dc04e652a298ca(node, handlers) {
    const children = (0, $b89a62939662ea40$export$d157f1daa0528112)(node, handlers);
    return {
        type: 'blockquote',
        children: children
    };
}


function $156dc85fc3d748b5$export$9852986a3ec5f6a0(node, handlers) {
    const rows = [];
    node.forEach((child)=>{
        const handler = handlers[child.type.name];
        if (handler) {
            const result = handler(child);
            if (result && !Array.isArray(result) && result.type === 'tableRow') rows.push(result);
        }
    });
    return {
        type: 'table',
        children: rows
    };
}


function $82472df0e08f5549$export$ce666bf02318c957(node, handlers) {
    const cells = [];
    node.forEach((child)=>{
        const handler = handlers[child.type.name];
        if (handler) {
            const result = handler(child);
            if (result && !Array.isArray(result) && result.type === 'tableCell') cells.push(result);
        }
    });
    return {
        type: 'tableRow',
        children: cells
    };
}



function $e9e8fef366cf91fc$export$e1e720e5f4603e6a(node, handlers) {
    const children = [];
    // Table cells contain paragraphs wrapping inline content; flatten them.
    // Use convertInlineChildren so non-text inline nodes (hard_break, image,
    // inlineCode, etc.) are handled via the handlers map rather than dropped.
    node.forEach((child)=>{
        if (child.type.name === 'paragraph') children.push(...(0, $b89a62939662ea40$export$4db834a02b589b8)(child, handlers));
    });
    return {
        type: 'tableCell',
        children: children
    };
}


function $2636f7444dbb8d88$export$25f0e92ed67918e2(node, ordered, handlers) {
    const children = [];
    node.forEach((child)=>{
        const handler = handlers[child.type.name];
        if (handler) {
            const result = handler(child);
            if (!result || Array.isArray(result)) return;
            if (result.type === 'listItem') children.push(result);
            else if (result.type === 'list' && children.length > 0) {
                const previous = children[children.length - 1];
                previous.children.push(result);
            }
        }
    });
    const start = ordered ? node.attrs.order ?? node.attrs.start ?? 1 : undefined;
    return {
        type: 'list',
        ordered: ordered,
        start: start,
        spread: false,
        children: children
    };
}



// Zero-width space placeholder. mdast's GFM task-list serializer needs a text
// child to emit an empty task marker like `* [ ]`; serializers strip it only
// from the generated empty task item body.
const $67216c924400db67$export$adb8a99c77edd84e = '\u200B';


function $561626e20ef5d58a$var$getChecked(node) {
    const attrs = node.attrs;
    // Support both `checked` attr (standard) and `state` attr (ADF taskItem)
    if (attrs.checked === true) return true;
    if (attrs.checked === false) return false;
    if (attrs.state === 'DONE') return true;
    if (attrs.state === 'TODO') return false;
    return null;
}
function $561626e20ef5d58a$export$da0c48111d4803f(node, handlers) {
    const checked = $561626e20ef5d58a$var$getChecked(node);
    let children = (0, $b89a62939662ea40$export$d157f1daa0528112)(node, handlers);
    if (checked !== null && children.length === 0) children = [
        {
            type: 'paragraph',
            children: [
                {
                    type: 'text',
                    value: (0, $67216c924400db67$export$adb8a99c77edd84e)
                }
            ]
        }
    ];
    return {
        type: 'listItem',
        spread: false,
        checked: checked,
        children: children
    };
}




const $345f5b3d5ff6f33a$export$d58124ced37e5234 = {
    paragraph: (node)=>(0, $6cf3b1693639abd3$export$9c206ddddb32a9b)(node, $345f5b3d5ff6f33a$export$d58124ced37e5234),
    heading: (node)=>(0, $b793a7a10e14064c$export$46e4a324ac90507f)(node, $345f5b3d5ff6f33a$export$d58124ced37e5234),
    text: (node)=>(0, $5fc317b8e6aaed4e$export$6f093cfa640b7166)(node),
    hard_break: (_node)=>(0, $0495107e87c5df1c$export$371da9dd35aba193)(),
    hardBreak: (_node)=>(0, $0495107e87c5df1c$export$371da9dd35aba193)(),
    horizontal_rule: (_node)=>(0, $9174e1e4b42d0d7c$export$ba7b13e047416c03)(),
    rule: (_node)=>(0, $9174e1e4b42d0d7c$export$ba7b13e047416c03)(),
    image: (node)=>(0, $aff53c42e8aff7f7$export$5c452ff88e35e47d)(node),
    inlineCard: (node)=>(0, $ec448e901307d19f$export$cbf8224b64e0d942)(node),
    // `media` and `mediaSingle` map to a CommonMark image. The default
    // handler only knows how to serialise `type: "external"` media (which
    // has a public URL); `type: "file"` media is dropped because we don't
    // know the tenant or content scope here. Use `createMediaHandlers({
    // serializeFileMedia })` from './handlers/media' to opt in to
    // proxy-URL serialisation for file media (e.g. from Confluence).
    media: (node)=>(0, $7f53e529d3867c12$export$987d49ffe1b0900f)(node),
    mediaSingle: (node)=>(0, $7f53e529d3867c12$export$969fe3781ca15058)(node),
    media_single: (node)=>(0, $7f53e529d3867c12$export$969fe3781ca15058)(node),
    code_block: (node)=>(0, $c3b7e779c07260d8$export$7bb0d5c671655cc4)(node),
    codeBlock: (node)=>(0, $c3b7e779c07260d8$export$7bb0d5c671655cc4)(node),
    blockquote: (node)=>(0, $ea4d8851563f02a9$export$67dc04e652a298ca)(node, $345f5b3d5ff6f33a$export$d58124ced37e5234),
    block_quote: (node)=>(0, $ea4d8851563f02a9$export$67dc04e652a298ca)(node, $345f5b3d5ff6f33a$export$d58124ced37e5234),
    table: (node)=>(0, $156dc85fc3d748b5$export$9852986a3ec5f6a0)(node, $345f5b3d5ff6f33a$export$d58124ced37e5234),
    tableRow: (node)=>(0, $82472df0e08f5549$export$ce666bf02318c957)(node, $345f5b3d5ff6f33a$export$d58124ced37e5234),
    tableCell: (node)=>(0, $e9e8fef366cf91fc$export$e1e720e5f4603e6a)(node, $345f5b3d5ff6f33a$export$d58124ced37e5234),
    tableHeader: (node)=>(0, $e9e8fef366cf91fc$export$e1e720e5f4603e6a)(node, $345f5b3d5ff6f33a$export$d58124ced37e5234),
    bullet_list: (node)=>(0, $2636f7444dbb8d88$export$25f0e92ed67918e2)(node, false, $345f5b3d5ff6f33a$export$d58124ced37e5234),
    bulletList: (node)=>(0, $2636f7444dbb8d88$export$25f0e92ed67918e2)(node, false, $345f5b3d5ff6f33a$export$d58124ced37e5234),
    ordered_list: (node)=>(0, $2636f7444dbb8d88$export$25f0e92ed67918e2)(node, true, $345f5b3d5ff6f33a$export$d58124ced37e5234),
    orderedList: (node)=>(0, $2636f7444dbb8d88$export$25f0e92ed67918e2)(node, true, $345f5b3d5ff6f33a$export$d58124ced37e5234),
    task_list: (node)=>(0, $2636f7444dbb8d88$export$25f0e92ed67918e2)(node, false, $345f5b3d5ff6f33a$export$d58124ced37e5234),
    taskList: (node)=>(0, $2636f7444dbb8d88$export$25f0e92ed67918e2)(node, false, $345f5b3d5ff6f33a$export$d58124ced37e5234),
    list_item: (node)=>(0, $561626e20ef5d58a$export$da0c48111d4803f)(node, $345f5b3d5ff6f33a$export$d58124ced37e5234),
    listItem: (node)=>(0, $561626e20ef5d58a$export$da0c48111d4803f)(node, $345f5b3d5ff6f33a$export$d58124ced37e5234),
    // task_item (snake_case ADF) also uses convertTaskItem so checked/state attrs are read
    task_item: (node)=>(0, $561626e20ef5d58a$export$da0c48111d4803f)(node, $345f5b3d5ff6f33a$export$d58124ced37e5234),
    // ADF taskItem has inline content directly (no paragraph wrapper),
    // so we wrap it in a paragraph to satisfy the listItem → block content requirement.
    taskItem: (node)=>{
        const checked = node.attrs.state === 'DONE' ? true : node.attrs.state === 'TODO' ? false : node.attrs.checked ?? null;
        const children = (0, $b89a62939662ea40$export$4db834a02b589b8)(node, $345f5b3d5ff6f33a$export$d58124ced37e5234);
        return {
            type: 'listItem',
            spread: false,
            checked: checked,
            children: [
                {
                    type: 'paragraph',
                    children: children.length > 0 ? children : checked !== null ? [
                        {
                            type: 'text',
                            value: (0, $67216c924400db67$export$adb8a99c77edd84e)
                        }
                    ] : []
                }
            ]
        };
    }
};


/**
 * Extracts annotation mark character ranges from a ProseMirror document by
 * correlating the PM node tree with the serialized markdown string.
 *
 * Strategy
 * --------
 * We walk the PM document in the same order that the markdown serializer does
 * (depth-first, left-to-right), accumulating a character offset counter as we
 * encounter text content. When we enter a text node that carries an annotation
 * mark, we record { id, from, to } where from/to are the character offsets of
 * that text node in the markdown string.
 *
 * For annotation marks that span multiple consecutive text nodes (e.g. when a
 * mark boundary splits a run), we merge adjacent runs with the same annotation
 * ID into a single contiguous range.
 *
 * Limitations
 * -----------
 * The character offset tracking works because the markdown serializer visits
 * nodes in the same depth-first order and emits text content contiguously.
 * However, the serializer also emits structural characters that don't appear
 * in the PM document (e.g. `**` for bold, `##` for headings, `\n\n` between
 * blocks). We account for these by searching for each text run in the markdown
 * string starting from our current offset — this makes the extraction robust
 * to any decorative characters the serializer inserts around text content.
 *
 * The search is always forward-only (we never scan backwards), so it correctly
 * handles repeated text content as long as the PM node order matches the
 * markdown output order — which it does for all standard handlers.
 */ /**
 * Escape a raw PM text string the same way `mdast-util-to-markdown` does, so
 * we can search for it in the serialized markdown when a direct `indexOf` fails.
 *
 * `mdast-util-to-markdown` escapes the following characters with a leading
 * backslash when they appear in plain text content: `*`, `_`, `` ` ``, `[`, `\`.
 * It does this character-by-character, so "hello *world" → "hello \*world".
 *
 * We replicate that transform here so that when `indexOf(rawText)` returns -1
 * (because the serializer inserted backslashes into the text), we can retry
 * with `indexOf(escapedText)` and still find the correct position.
 *
 * Note: this escape is intentionally conservative — we only escape characters
 * that mdast-util-to-markdown is known to escape in plain text nodes. Other
 * transformations (e.g. entity encoding, which we undo in `undoEdgeWhitespaceEncoding`)
 * are handled separately.
 */ function $d1bfc27c17999823$var$escapedForMarkdown(text) {
    return text.replace(/[*_`[\\\]]/gu, (ch)=>`\\${ch}`);
}
function $d1bfc27c17999823$export$1710d999c4016c72(doc, markdown) {
    // Map from annotation ID → { from, to } of the current open range.
    // We merge consecutive text nodes that carry the same annotation ID.
    const openRanges = new Map();
    const completed = [];
    // Current search position in the markdown string.
    // We advance this forward as we encounter text nodes.
    let searchFrom = 0;
    doc.descendants((node)=>{
        if (!node.isText || !node.text) return true; // descend into non-text nodes
        const text = node.text;
        // Find the position of this text run in the markdown string.
        // We search forward from `searchFrom` to handle repeated text correctly.
        let pos = markdown.indexOf(text, searchFrom);
        // The serializer may have escaped special characters (e.g. `*` → `\*`),
        // making the raw PM text no longer a direct substring. Retry with the
        // escaped form as a fallback.
        let matchLength = text.length;
        if (pos === -1) {
            const escaped = $d1bfc27c17999823$var$escapedForMarkdown(text);
            if (escaped !== text) {
                pos = markdown.indexOf(escaped, searchFrom);
                if (pos !== -1) // The match is against the escaped string in the markdown, so
                // the range covers `escaped.length` characters, not `text.length`.
                matchLength = escaped.length;
            }
        }
        if (pos === -1) // Still not found — genuinely untranslateable node (e.g. hard_break).
        // Skip offset tracking for this node without advancing searchFrom.
        return true;
        const nodeFrom = pos;
        const nodeTo = pos + matchLength;
        // Collect the annotation IDs active on this text node.
        const activeIds = new Set();
        for (const mark of node.marks)if (mark.type.name === 'annotation' && mark.attrs.id) activeIds.add(mark.attrs.id);
        // Close any open ranges whose ID is no longer active on this node.
        for (const [id, range] of openRanges)if (!activeIds.has(id)) {
            completed.push({
                id: id,
                from: range.from,
                to: range.to
            });
            openRanges.delete(id);
        }
        // Extend or open ranges for active annotation IDs.
        for (const id of activeIds){
            const existing = openRanges.get(id);
            if (existing) // Extend the existing open range to cover this text node.
            existing.to = nodeTo;
            else // New annotation starting at this text node.
            openRanges.set(id, {
                from: nodeFrom,
                to: nodeTo
            });
        }
        // Advance the search position past this text node.
        searchFrom = nodeTo;
        return true;
    });
    // Close any ranges still open at the end of the document.
    for (const [id, range] of openRanges)completed.push({
        id: id,
        from: range.from,
        to: range.to
    });
    // Sort by start position for deterministic output.
    completed.sort((a, b)=>a.from - b.from || a.id.localeCompare(b.id));
    return completed;
}


/**
 * Strip backslash escapes from markdown that aren't load-bearing under
 * GFM parsing: greedily drop all candidates, re-parse, and compare against
 * the source mdast. If the trees match, the escapes weren't needed; if
 * not, bisect to find the minimal set that must stay.
 *
 * Lets the real GFM parser decide what's load-bearing rather than
 * hand-coding flanking rules per character.
 */ 






/*
 * Match the GFM extensions used by the serializer. Omits
 * gfm-autolink-literal: the serializer doesn't insert escapes to prevent
 * literal autolinking, so including it would cause unrelated verify
 * failures on any doc that mentions a URL.
 */ const $a6d130b37e558cdc$var$PARSE_EXTENSIONS = [
    (0, $8e44d98c70bdeefa$export$e36cebda627bf2dd)(),
    (0, $08ac07f643a80ce7$export$2912e8b2802475ff)(),
    (0, $1fdd2be315857d56$export$8bbec8ea1400a00e)()
];
const $a6d130b37e558cdc$var$PARSE_MDAST_EXTENSIONS = [
    (0, $7838a54ced4bd729$export$8bd0ec8ecf6adb7d)(),
    (0, $4f16eb57f7bc15ef$export$a427a608608b215f)(),
    (0, $4b5736c281b8a126$export$34d64e709dd0b9bb)()
];
// ASCII-punctuation escape set per CommonMark + GFM.
const $a6d130b37e558cdc$var$ESCAPABLE = /[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/u;
/*
 * Index of each `\X` where X is escapable. Consecutive escape pairs
 * (e.g. `\\\\` for two literal backslashes) are reported as separate
 * candidates; the bisect step decides which can be removed.
 */ function $a6d130b37e558cdc$var$findEscapePositions(md) {
    const positions = [];
    for(let i = 0; i < md.length - 1; i++)if (md[i] === '\\' && $a6d130b37e558cdc$var$ESCAPABLE.test(md[i + 1])) {
        positions.push(i);
        // Skip the escaped char so it isn't misread as another escape.
        i += 1;
    }
    return positions;
}
function $a6d130b37e558cdc$var$stripAt(md, drop) {
    if (drop.size === 0) return md;
    const parts = [];
    for(let i = 0; i < md.length; i++)if (!drop.has(i)) parts.push(md[i]);
    return parts.join('');
}
/*
 * Strip `position` so trees from different sources compare structurally.
 * Emit keys in sorted order so the `JSON.stringify`-based comparison
 * doesn't get tripped up if the PM handlers and `fromMarkdown` happen to
 * construct a given node type with different key orderings.
 */ function $a6d130b37e558cdc$var$normalise(value) {
    if (Array.isArray(value)) return value.map($a6d130b37e558cdc$var$normalise);
    if (value && typeof value === 'object') {
        const source = value;
        const out = {};
        for (const k of Object.keys(source).sort()){
            if (k === 'position') continue;
            out[k] = $a6d130b37e558cdc$var$normalise(source[k]);
        }
        return out;
    }
    return value;
}
function $a6d130b37e558cdc$var$treesEqual(a, b) {
    return JSON.stringify($a6d130b37e558cdc$var$normalise(a)) === JSON.stringify($a6d130b37e558cdc$var$normalise(b));
}
function $a6d130b37e558cdc$var$parse(md) {
    return (0, $1f573826a160da4c$export$d744d789c09bfde6)(md, {
        extensions: $a6d130b37e558cdc$var$PARSE_EXTENSIONS,
        mdastExtensions: $a6d130b37e558cdc$var$PARSE_MDAST_EXTENSIONS
    });
}
/**
 * Identify which escapes in `positions` must be kept for `md` to round-trip
 * back to `target`, accumulating them into `kept`.
 *
 * Try removing every position at once; if the result still round-trips,
 * none of these escapes are needed. Otherwise split the candidate set in
 * half and recurse on each half independently — a 1-element set whose
 * trial fails is necessarily load-bearing.
 *
 * This is a delta-debugging-style search (ddmin family: Zeller, "Yesterday,
 * My Program Worked. Today, It Does Not. Why?"). The result is 1-minimal:
 * no single position in `kept` can be removed while preserving round-trip.
 * It is NOT necessarily a globally minimum subset — the defensive verify
 * in `reduceUnnecessaryEscaping` catches the rare case where individual
 * removals don't commute.
 */ function $a6d130b37e558cdc$var$findMinimumEscapeSubset(md, positions, target, kept) {
    if (positions.length === 0) return;
    const trial = $a6d130b37e558cdc$var$stripAt(md, new Set(positions));
    if ($a6d130b37e558cdc$var$treesEqual($a6d130b37e558cdc$var$parse(trial), target)) return;
    if (positions.length === 1) {
        kept.add(positions[0]);
        return;
    }
    const mid = Math.floor(positions.length / 2);
    $a6d130b37e558cdc$var$findMinimumEscapeSubset(md, positions.slice(0, mid), target, kept);
    $a6d130b37e558cdc$var$findMinimumEscapeSubset(md, positions.slice(mid), target, kept);
}
function $a6d130b37e558cdc$export$554dd08306eafa82(md, target) {
    const positions = $a6d130b37e558cdc$var$findEscapePositions(md);
    if (positions.length === 0) return md;
    // Fast path: drop everything at once.
    const allDropped = $a6d130b37e558cdc$var$stripAt(md, new Set(positions));
    if ($a6d130b37e558cdc$var$treesEqual($a6d130b37e558cdc$var$parse(allDropped), target)) return allDropped;
    // Single escape that the fast path already proved is load-bearing.
    if (positions.length === 1) return md;
    /*
	 * Slow path: enter the recursion at the first split. The fast path
	 * already proved removing all positions fails, so re-running that
	 * same trial at the top of findMinimumEscapeSubset would be wasted
	 * work.
	 */ const kept = new Set();
    const mid = Math.floor(positions.length / 2);
    $a6d130b37e558cdc$var$findMinimumEscapeSubset(md, positions.slice(0, mid), target, kept);
    $a6d130b37e558cdc$var$findMinimumEscapeSubset(md, positions.slice(mid), target, kept);
    const candidate = $a6d130b37e558cdc$var$stripAt(md, new Set(positions.filter((p)=>!kept.has(p))));
    /*
	 * The search assumes individual-escape removals commute. If that ever
	 * fails for some input, fall back to the always-safe original rather
	 * than emit something that doesn't round-trip.
	 */ if (!$a6d130b37e558cdc$var$treesEqual($a6d130b37e558cdc$var$parse(candidate), target)) return md;
    return candidate;
}


/**
 * Post-process markdown output to undo the `&#x20;` and `&#x9;` encoding
 * that `mdast-util-to-markdown` applies to leading/trailing whitespace in
 * phrasing contexts. See EDITOR-6558 comment in `fromProseMirror`.
 *
 * The library's `unsafe` configuration only supports *adding* patterns,
 * not removing defaults, so we can't prevent the encoding. Instead we
 * replace the character references back to literal characters after
 * serialisation.
 */ function $7b6de0599580fc69$var$undoEdgeWhitespaceEncoding(md) {
    return md.replace(/&#x20;/gu, ' ').replace(/&#x9;/gu, '\t').replace(/^(\s*(?:[-*+]|\d+\.) \[[ xX]\]) \u200B$/gmu, '$1');
}
function $7b6de0599580fc69$export$ab3fd54df7090dc2(schema, handlers = (0, $345f5b3d5ff6f33a$export$d58124ced37e5234)) {
    return function(doc) {
        let pmDoc;
        if ('type' in doc && typeof doc.type === 'string') // It's a JSON representation — hydrate it
        pmDoc = schema.nodeFromJSON(doc);
        else pmDoc = doc;
        const children = [];
        pmDoc.forEach((child)=>{
            const handler = handlers[child.type.name];
            if (!handler) // Throw on unsupported top-level nodes. Silently dropping at the top level
            // would mean a document with only unknown blocks would serialize to an empty
            // string with no indication something went wrong — a data-loss footgun.
            // Nested unknown nodes are still silently skipped by `convertBlockChildren`
            // so partial-but-meaningful output is still possible for documents whose
            // structure is mostly known.
            throw new Error(`ProseMirror node type "${child.type.name}" is not supported by mdast-util-from-pm. ` + `Either add a handler for this node type, or filter it out of the document before serializing.`);
            const result = handler(child);
            if (result) {
                if (Array.isArray(result)) children.push(...result);
                else children.push(result);
            }
        });
        const mdast = {
            type: 'root',
            children: children
        };
        // EDITOR-6558: `mdast-util-to-markdown` encodes leading/trailing
        // whitespace in phrasing contexts as HTML character references
        // (e.g. `&#x20;`). This is technically correct per CommonMark but
        // undesirable for our use case — it makes the markdown unreadable
        // and breaks round-trip identity in the source view.
        //
        // The library's `unsafe` configuration only supports *adding*
        // patterns, not removing defaults, so we post-process the output
        // to replace the character references back to literal characters.
        const rawMarkdown = (0, $1de3130294731997$export$49a1dda9e62e8ae6)(mdast, {
            bullet: '*',
            listItemIndent: 'one',
            fences: true,
            // Keep link serialization explicit and stable. By default,
            // mdast-util-to-markdown emits `<https://example.com>` whenever link
            // text and href match, including inline cards that degrade to plain
            // Markdown links. The markdown-mode pipeline expects resource links so
            // ADF link marks and inline-card fallbacks share the same `[text](url)`
            // shape.
            resourceLink: true,
            // Both are functions in the ESM version (v1.x) installed in AFM
            extensions: [
                (0, $7838a54ced4bd729$export$dafcad76ea6e0045)(),
                (0, $4f16eb57f7bc15ef$export$9975722e7e834b78)(),
                (0, $4b5736c281b8a126$export$1632835bd2c84956)()
            ]
        });
        const markdown = (0, $a6d130b37e558cdc$export$554dd08306eafa82)($7b6de0599580fc69$var$undoEdgeWhitespaceEncoding(rawMarkdown), mdast);
        // Extract annotation ranges from the source PM document.
        // We do this after serialization so the character offsets we compute
        // are in terms of the *final* markdown string (post-encoding fixup).
        const annotations = (0, $d1bfc27c17999823$export$1710d999c4016c72)(pmDoc, markdown);
        return {
            markdown: markdown,
            annotations: annotations
        };
    };
}
function $7b6de0599580fc69$export$ae379e0a36446b0a(schema, handlers = (0, $345f5b3d5ff6f33a$export$d58124ced37e5234)) {
    const withAnnotations = $7b6de0599580fc69$export$ab3fd54df7090dc2(schema, handlers);
    return function(doc) {
        return withAnnotations(doc).markdown;
    };
}






var $aPdNQ = parcelRequire("aPdNQ");

const $f687f249a3d72c48$var$valueToText = (value)=>typeof value === 'string' ? value : '';
const $f687f249a3d72c48$var$getSourceMarkdownSlice = (node, sourceMarkdown)=>{
    if (!sourceMarkdown) return '';
    const startOffset = node.position?.start?.offset;
    const endOffset = node.position?.end?.offset;
    if (typeof startOffset !== 'number' || typeof endOffset !== 'number' || startOffset < 0 || endOffset <= startOffset || endOffset > sourceMarkdown.length) return '';
    return sourceMarkdown.slice(startOffset, endOffset);
};
const $f687f249a3d72c48$var$childrenToText = (node, sourceMarkdown)=>{
    if (!Array.isArray(node.children)) return '';
    const separator = node.type === 'paragraph' || node.type === 'heading' ? '' : '\n';
    return node.children.map((child)=>$f687f249a3d72c48$var$getUnsupportedMarkdownText(child, sourceMarkdown)).filter(Boolean).join(separator);
};
const $f687f249a3d72c48$var$getUnsupportedMarkdownText = (node, sourceMarkdown)=>{
    const unknownNode = node;
    const sourceText = $f687f249a3d72c48$var$getSourceMarkdownSlice(unknownNode, sourceMarkdown);
    if (sourceText) return sourceText;
    const directText = $f687f249a3d72c48$var$valueToText(unknownNode.value) || $f687f249a3d72c48$var$valueToText(unknownNode.alt) || $f687f249a3d72c48$var$valueToText(unknownNode.label) || $f687f249a3d72c48$var$valueToText(unknownNode.identifier) || $f687f249a3d72c48$var$valueToText(unknownNode.url);
    if (directText) return directText;
    const childText = $f687f249a3d72c48$var$childrenToText(unknownNode, sourceMarkdown);
    return childText;
};
function $f687f249a3d72c48$export$46e4675a653bed25(state, node) {
    const text = $f687f249a3d72c48$var$getUnsupportedMarkdownText(node, state.sourceMarkdown);
    if (!text) return;
    const top = state.top();
    const { paragraph: paragraph } = state.schema.nodes;
    if (!top.type.inlineContent && paragraph && top.type.contentMatch.matchType(paragraph)) {
        state.openNode(paragraph);
        state.addText(text);
        state.closeNode();
        return;
    }
    state.addText(text);
}


function $5b3bf3d319ccc02c$var$maybeMerge(a, b) {
    if (a.isText && b.isText && (0, $aPdNQ.Mark).sameSet(a.marks, b.marks)) return a.withText((a.text ?? '') + (b.text ?? ''));
}
class $5b3bf3d319ccc02c$export$7254cc27399e90bd {
    top() {
        return this.stack[this.stack.length - 1];
    }
    push(node) {
        if (this.stack.length) this.top().content.push(node);
    }
    /**
   * Adds the given text to the current position in the document,
   * using the current marks as styling.
   */ addText(text) {
        if (!text) return;
        const top = this.top(), nodes = top.content, last = nodes[nodes.length - 1], node = this.schema.text(text, top.marks);
        let merged;
        if (last && (merged = $5b3bf3d319ccc02c$var$maybeMerge(last, node))) nodes[nodes.length - 1] = merged;
        else nodes.push(node);
    }
    /** Adds the given mark to the set of active marks. */ openMark(mark) {
        const top = this.top();
        top.marks = mark.addToSet(top.marks);
    }
    /** Removes the given mark from the set of active marks. */ closeMark(mark) {
        const top = this.top();
        top.marks = mark.removeFromSet(top.marks);
    }
    /** Add a node at the current position. */ addNode(type, attrs, content) {
        const top = this.top();
        const node = type.createAndFill(attrs, content, top ? top.marks : []);
        if (!node) return null;
        this.push(node);
        return node;
    }
    /** Wrap subsequent content in a node of the given type. */ openNode(type, attrs = null) {
        this.stack.push({
            type: type,
            attrs: attrs,
            content: [],
            marks: (0, $aPdNQ.Mark).none
        });
    }
    /** Close and return the node that is currently on top of the stack. */ closeNode() {
        const info = this.stack.pop();
        if (!info) throw new Error('No node open at the top of the stack');
        return this.addNode(info.type, info.attrs, info.content);
    }
    parseTokens(nodes) {
        for(let i = 0; i < nodes.length; i++){
            const node = nodes[i];
            const handler = this.handlers[node.type];
            if (!handler) {
                (0, $f687f249a3d72c48$export$46e4675a653bed25)(this, node);
                continue;
            }
            handler(this, node, i);
        }
    }
    constructor(schema, handlers, sourceMarkdown){
        this.schema = schema;
        this.handlers = handlers;
        this.sourceMarkdown = sourceMarkdown;
        this.stack = [];
        this.rowIndex = null;
    }
}


function $0fbbd9daab0ee5df$export$4aad817b79ae84b4(schema, handlers) {
    return function(mdast, options) {
        const state = new (0, $5b3bf3d319ccc02c$export$7254cc27399e90bd)(schema, handlers, options?.sourceMarkdown);
        // Root is not in the Content union in @types/mdast v3 but is a valid entry point.
        state.parseTokens([
            mdast
        ]);
        return state.closeNode();
    };
}


function $6c406f2dcb1e20b3$export$e8e78c978b129247(state, node) {
    state.openNode(state.schema.topNodeType);
    state.parseTokens(node.children);
}


/** Matches `[!NOTE]` (possibly with trailing newline) at the start of a text node. */ const $fb59eaa31ebec1e4$var$alertTextPattern = /^\[!(\w+)\]\n?/u;
/** Matches `[!NOTE]` as the entire value of an html node (as emitted by mdast-util-from-pm). */ const $fb59eaa31ebec1e4$var$alertHtmlPattern = /^\[!(\w+)\]$/u;
/** Map GFM alert types to ADF panel types (inverse of panelTypeToAlert in mdast-util-from-pm). */ const $fb59eaa31ebec1e4$var$ALERT_TO_PANEL = {
    NOTE: 'note',
    TIP: 'success',
    IMPORTANT: 'info',
    WARNING: 'warning',
    CAUTION: 'error'
};
/**
 * Detect a GFM alert tag in the first child of a blockquote.
 *
 * Supports two formats:
 * 1. Legacy / raw GFM: the alert tag is the prefix of the first text node
 *    in the first paragraph,
 *    e.g. `{ type: 'paragraph', children: [{ type: 'text', value: '[!NOTE]\nBody' }] }`
 * 2. Serialised by mdast-util-from-pm: the alert tag is a block-level `html`
 *    node as the first direct child of the blockquote,
 *    e.g. `{ type: 'html', value: '[!NOTE]' }` followed by further block children.
 *
 * Returns `{ alertType, contentChildren }` or `null` if not an alert.
 */ function $fb59eaa31ebec1e4$var$detectAlert(node) {
    const firstChild = node.children[0];
    // Format 2: block-level html node (from mdast-util-from-pm)
    if (firstChild?.type === 'html') {
        const match = $fb59eaa31ebec1e4$var$alertHtmlPattern.exec(firstChild.value);
        if (match) return {
            alertType: match[1].toUpperCase(),
            contentChildren: node.children.slice(1)
        };
    }
    if (firstChild?.type !== 'paragraph') return null;
    // Format 1: alert tag as prefix of first text node
    const firstInline = firstChild.children[0];
    if (firstInline?.type === 'text') {
        const match = $fb59eaa31ebec1e4$var$alertTextPattern.exec(firstInline.value);
        if (match) {
            const remaining = firstInline.value.slice(match[0].length);
            const newFirstChildren = remaining.length > 0 ? [
                {
                    ...firstInline,
                    value: remaining
                },
                ...firstChild.children.slice(1)
            ] : firstChild.children.slice(1);
            const contentChildren = newFirstChildren.length > 0 ? [
                {
                    ...firstChild,
                    children: newFirstChildren
                },
                ...node.children.slice(1)
            ] : node.children.slice(1);
            return {
                alertType: match[1].toUpperCase(),
                contentChildren: contentChildren
            };
        }
    }
    return null;
}
function $fb59eaa31ebec1e4$export$67dc04e652a298ca(state, node) {
    const alert = $fb59eaa31ebec1e4$var$detectAlert(node);
    if (alert) {
        const panelType = $fb59eaa31ebec1e4$var$ALERT_TO_PANEL[alert.alertType];
        const panelNodeType = state.schema.nodes.panel ?? state.schema.nodes.note ?? state.schema.nodes.callout;
        if (panelType && panelNodeType) {
            state.openNode(panelNodeType, {
                panelType: panelType
            });
            state.parseTokens(alert.contentChildren.length > 0 ? alert.contentChildren : node.children.slice(1));
            state.closeNode();
            return;
        }
    }
    // Regular blockquote
    const nodeType = state.schema.nodes.blockquote ?? state.schema.nodes.block_quote;
    if (!nodeType) {
        // Gracefully degrade: schema has no blockquote node — render children directly
        state.parseTokens(node.children);
        return;
    }
    state.openNode(nodeType);
    state.parseTokens(node.children);
    state.closeNode();
}


function $6751f0a19e546654$export$46e4a324ac90507f(state, node) {
    const nodeType = state.schema.nodes.heading;
    if (!nodeType) {
        // Gracefully degrade: render heading content as a paragraph when schema
        // has no heading node. This preserves text content without crashing.
        state.openNode(state.schema.nodes.paragraph);
        state.parseTokens(node.children);
        state.closeNode();
        return;
    }
    state.openNode(nodeType, {
        level: node.depth
    });
    state.parseTokens(node.children);
    state.closeNode();
}



var $4o0zT = parcelRequire("4o0zT");

/**
 * When the schema uses `media` / `mediaSingle` instead of `image` (Confluence
 * markdown preset) and the paragraph is a lone image, emit
 * `mediaSingle > media (type: "external")` so `![alt](url)` round-trips
 * instead of degrading to alt-text only. Mixed-content paragraphs fall
 * through to the generic handler.
 */ const $23e8a660c6c6ff8f$var$tryEmitMediaSingle = (state, node)=>{
    const { mediaSingle: mediaSingle, media: media } = state.schema.nodes;
    if (!mediaSingle || !media) return false;
    if (!$23e8a660c6c6ff8f$var$isLoneImageParagraph(node)) return false;
    const image = node.children[0];
    const url = typeof image.url === 'string' && image.url.length > 0 ? image.url : undefined;
    if (!url) return false;
    state.openNode(mediaSingle);
    state.addNode(media, {
        url: url,
        alt: image.alt ?? null,
        type: 'external'
    }, []);
    state.closeNode();
    return true;
};
function $23e8a660c6c6ff8f$export$9c206ddddb32a9b(state, node) {
    const { paragraph: paragraph } = state.schema.nodes;
    if (!paragraph) {
        // Gracefully degrade: schema has no paragraph node — render inline children directly
        state.parseTokens(node.children);
        return;
    }
    if (!state.schema.nodes.image) {
        if ((0, $4o0zT.isExperimentEnabled)('platform_editor_markdown_conversion_improvements')) {
            $23e8a660c6c6ff8f$var$emitParagraphWithMediaSegments(state, node);
            return;
        } else if ($23e8a660c6c6ff8f$var$isLoneImageParagraph(node)) {
            if ($23e8a660c6c6ff8f$var$tryEmitMediaSingle(state, node)) return;
        }
    }
    state.openNode(paragraph);
    state.parseTokens(node.children);
    state.closeNode();
}
/**
 * Handles mixed-content paragraphs (text + images + linked images) by splitting
 * them into interleaved paragraph and mediaSingle sibling blocks:
 *
 *   "before [![img](url)](link) after"
 *   →  paragraph("before ") + mediaSingle[link] > media + paragraph(" after")
 */ const $23e8a660c6c6ff8f$var$emitParagraphWithMediaSegments = (state, node)=>{
    const paragraphChildren = [];
    // Flush buffered inline children as a paragraph, then clear the buffer.
    const flushParagraph = ()=>{
        if (paragraphChildren.length === 0) return;
        state.openNode(state.schema.nodes.paragraph);
        state.parseTokens(paragraphChildren);
        state.closeNode();
        paragraphChildren.length = 0;
    };
    for (const child of node.children){
        if (child.type === 'image') {
            const url = typeof child.url === 'string' && child.url.length > 0 ? child.url : undefined;
            if (url) {
                // Valid image — flush buffered text then emit as mediaSingle block.
                flushParagraph();
                $23e8a660c6c6ff8f$var$emitMediaSingleNode(state, child);
                continue;
            }
        // No URL — fall through and buffer as inline content.
        } else if ($23e8a660c6c6ff8f$var$isLinkedImageNode(child)) {
            flushParagraph();
            $23e8a660c6c6ff8f$var$emitLinkedImageAsMediaSingle(state, child);
            continue;
        }
        paragraphChildren.push(child);
    }
    flushParagraph();
};
/**
 * Emits a `mediaSingle > media` block. If `linkMark` is provided it is applied
 * to the `media` node by opening the mark inside the mediaSingle node scope
 * before adding `media`.
 */ const $23e8a660c6c6ff8f$var$emitMediaSingleNode = (state, image, linkMark)=>{
    const { media: media, mediaSingle: mediaSingle } = state.schema.nodes;
    if (!media || !mediaSingle) return;
    const url = typeof image.url === 'string' && image.url.length > 0 ? image.url : undefined;
    if (!url) return;
    state.openNode(mediaSingle);
    if (linkMark) state.openMark(linkMark);
    state.addNode(media, {
        url: url,
        alt: image.alt ?? null,
        type: 'external'
    }, []);
    if (linkMark) state.closeMark(linkMark);
    state.closeNode();
};
/** Handles `[![alt](img-url)](link-url)` — extracts the image and link mark, delegates to emitMediaSingleNode. */ const $23e8a660c6c6ff8f$var$emitLinkedImageAsMediaSingle = (state, link)=>{
    const image = $23e8a660c6c6ff8f$var$getLinkedImageNode(link);
    if (!image) return;
    const linkMarkType = state.schema.marks.link;
    const linkMark = typeof link.url === 'string' && link.url.length > 0 && linkMarkType ? linkMarkType.create({
        href: link.url,
        title: link.title ?? null
    }) : undefined;
    $23e8a660c6c6ff8f$var$emitMediaSingleNode(state, image, linkMark);
};
/** Returns true if the node is a link whose only child is an image (`[![alt](img)](link)`). */ const $23e8a660c6c6ff8f$var$isLinkedImageNode = (node)=>Boolean(node.type === 'link' && $23e8a660c6c6ff8f$var$getLinkedImageNode(node));
const $23e8a660c6c6ff8f$var$getLinkedImageNode = (link)=>link.children.length === 1 && link.children[0].type === 'image' ? link.children[0] : undefined;
const $23e8a660c6c6ff8f$var$isLoneImageParagraph = (node)=>node.children.length === 1 && node.children[0].type === 'image';



var $iDrrr = parcelRequire("iDrrr");

// Matches a malformed task checkbox: remark-gfm only recognises `[ ]` / `[x]` / `[X]`
// as a GFM checkbox when it is directly followed by a space and then content. When
// a task item has no content after the checkbox (e.g. `* [ ]` at end-of-line, or
// `* [ ]  ` with a trailing hard-break space), remark-gfm emits checked: null and
// puts the literal `[ ]` / `[x]` string as the paragraph text. This regex detects
// that case so we can treat the item as a task item anyway.
const $20c7b93ada0fe9d1$export$e78f0454b934b730 = /^\[[ xX]\]/u;


function $38567b4568dc85de$export$a032a389809cf53e(node) {
    if (node.children.length === 0) return false;
    const firstChild = node.children[0];
    if (firstChild.type !== 'paragraph' || firstChild.children.length === 0) return false;
    const firstInline = firstChild.children[0];
    return firstInline.type === 'text' && (0, $20c7b93ada0fe9d1$export$e78f0454b934b730).test(firstInline.value);
}


/** Returns true if a list item should be treated as a task item (gate ON assumed). */ function $114969ad66e9d14d$var$isTaskItem(item) {
    return item.checked !== null && item.checked !== undefined || (0, $38567b4568dc85de$export$a032a389809cf53e)(item);
}
function $114969ad66e9d14d$export$8837f4fc672e936d(state, node) {
    // If the schema has a taskList node and ALL items are task items (checked !== null/undefined),
    // use taskList instead of bullet_list.
    const taskListType = state.schema.nodes.taskList ?? state.schema.nodes.task_list;
    // Fast path: all items are task items → emit a single taskList.
    if (!node.ordered && taskListType && node.children.length > 0 && node.children.every((item)=>item.checked !== null && item.checked !== undefined || (0, $38567b4568dc85de$export$a032a389809cf53e)(item) && (0, $iDrrr.fg)('platform_editor_markdown_patch_m3'))) {
        state.openNode(taskListType);
        state.parseTokens(node.children);
        state.closeNode();
        return;
    }
    // Split path: an unordered list that contains task items AND non-task
    // items at the boundaries (e.g. `* []` with no space typed before/after the group).
    // Non-task items at the edges should NOT pull the whole list into a bullet_list;
    // instead we emit consecutive task items as a taskList segment and non-task items
    // as individual bullet_list segments.
    if (!node.ordered && taskListType && (0, $iDrrr.fg)('platform_editor_markdown_patch_m3')) {
        const hasAnyTask = node.children.some((item)=>$114969ad66e9d14d$var$isTaskItem(item));
        if (hasAnyTask) {
            $114969ad66e9d14d$var$emitSegments(state, node, taskListType);
            return;
        }
    }
    const nodeType = node.ordered ? state.schema.nodes.ordered_list ?? state.schema.nodes.orderedList : state.schema.nodes.bullet_list ?? state.schema.nodes.bulletList;
    if (!nodeType) {
        // Gracefully degrade: schema has no list node — render children directly as block content
        state.parseTokens(node.children);
        return;
    }
    const attrs = node.ordered ? {
        order: node.start ?? 1
    } : null;
    state.openNode(nodeType, attrs);
    state.parseTokens(node.children);
    state.closeNode();
}
/**
 * Emits a mixed unordered list as alternating taskList / bullet_list segments.
 * Consecutive task items → taskList, consecutive non-task items → bullet_list.
 */ function $114969ad66e9d14d$var$emitSegments(state, node, taskListType) {
    // Single pass: open a taskList for consecutive task items, emit non-task items
    // as individual bullet_list nodes.
    let inTaskList = false;
    node.children.forEach((item)=>{
        if ($114969ad66e9d14d$var$isTaskItem(item)) {
            if (!inTaskList) {
                state.openNode(taskListType);
                inTaskList = true;
            }
            state.parseTokens([
                item
            ]);
        } else {
            if (inTaskList) {
                state.closeNode();
                inTaskList = false;
            }
            // Non-task item: treat as whatever it is — a plain unordered list item.
            state.openNode(state.schema.nodes.bullet_list ?? state.schema.nodes.bulletList);
            state.parseTokens([
                item
            ]);
            state.closeNode();
        }
    });
    if (inTaskList) state.closeNode();
}







function $c111b81361d1eb59$export$885766675222af99(inlines) {
    const [firstInline, ...rest] = inlines;
    if (!firstInline || firstInline.type !== 'text') return inlines;
    const stripped = firstInline.value.replace((0, $20c7b93ada0fe9d1$export$e78f0454b934b730), '').trimStart();
    return stripped.length > 0 ? [
        {
            ...firstInline,
            value: stripped
        },
        ...rest
    ] : rest;
}


function $bc48f86d27b5c6da$export$76c7e83ecc9cdf05(state, node) {
    // Detects a remark-gfm "malformed" checkbox: checked: null but has a [ ]/[x]/[X] text prefix.
    const isMalformedTask = node.checked === null && (0, $38567b4568dc85de$export$a032a389809cf53e)(node);
    // Gate: malformed items are rescued as unchecked task items when ON.
    const isTask = (0, $iDrrr.fg)('platform_editor_markdown_patch_m3') ? isMalformedTask || node.checked !== null && node.checked !== undefined : node.checked !== null && node.checked !== undefined;
    // If the schema has a dedicated taskItem node (ADF style), use it
    const taskItemType = state.schema.nodes.taskItem ?? state.schema.nodes.task_item;
    if (isTask && taskItemType) {
        const taskAttrs = {};
        const attrSpec = taskItemType.spec.attrs ?? {};
        if ('state' in attrSpec) {
            // ADF convention: state is 'DONE' or 'TODO'.
            if ((0, $iDrrr.fg)('platform_editor_markdown_patch_m3')) taskAttrs.state = isMalformedTask ? 'TODO' : node.checked ? 'DONE' : 'TODO';
            else taskAttrs.state = node.checked ? 'DONE' : 'TODO';
        }
        if ('checked' in attrSpec) {
            if ((0, $iDrrr.fg)('platform_editor_markdown_patch_m3')) taskAttrs.checked = isMalformedTask ? false : node.checked;
            else taskAttrs.checked = node.checked;
        }
        state.openNode(taskItemType, taskAttrs);
        // taskItem is `inline*`; defer block children so they emit as siblings of
        // the taskItem inside the parent taskList (ADF's nested-task-list shape).
        const deferredBlockChildren = [];
        for (const child of node.children)if (child.type === 'paragraph') {
            if ((0, $iDrrr.fg)('platform_editor_markdown_patch_m3')) {
                // Strip the `[ ]` prefix from the first paragraph of a malformed item
                // so it doesn't appear as literal content in the editor.
                if (isMalformedTask && child === node.children[0]) state.parseTokens((0, $c111b81361d1eb59$export$885766675222af99)(child.children));
                else state.parseTokens(child.children);
            } else state.parseTokens(child.children);
        } else deferredBlockChildren.push(child);
        state.closeNode();
        if (deferredBlockChildren.length > 0) state.parseTokens(deferredBlockChildren);
        return;
    }
    // Regular list item (or task item falling back to list_item when no taskItem node)
    const itemType = state.schema.nodes.list_item ?? state.schema.nodes.listItem;
    if (!itemType) {
        // Gracefully degrade: schema has no list item node — render children directly
        state.parseTokens(node.children);
        return;
    }
    const attrs = {};
    if ('checked' in (itemType.spec.attrs ?? {})) // Always write the checked attr when the schema supports it (null for non-task items)
    attrs.checked = isTask ? node.checked : null;
    state.openNode(itemType, attrs);
    if (node.children.length === 0) {
        // Empty list item (e.g. `* ` with no content) — insert an empty paragraph
        // so the ADF listItem node satisfies the schema's content requirement
        // (listItem requires at least one paragraph child). Without this, the
        // empty listItem is dropped during PM node normalization.
        const paragraphType = state.schema.nodes.paragraph;
        if (paragraphType) state.push(paragraphType.create());
    } else state.parseTokens(node.children);
    state.closeNode();
}


function $c813a0d23fab6206$export$9852986a3ec5f6a0(state, node) {
    const nodeType = state.schema.nodes.table;
    if (!nodeType) {
        // Gracefully degrade: schema has no table node — render children directly
        // (tableRow/tableCell handlers will also degrade gracefully)
        state.parseTokens(node.children);
        return;
    }
    state.openNode(nodeType);
    state.parseTokens(node.children);
    state.closeNode();
}


function $0b8bd6170c66bc36$export$ce666bf02318c957(state, node, index) {
    const nodeType = state.schema.nodes.tableRow ?? state.schema.nodes.table_row;
    if (!nodeType) {
        // Gracefully degrade: schema has no tableRow node — render cells directly
        state.rowIndex = index;
        state.parseTokens(node.children);
        state.rowIndex = null;
        return;
    }
    state.openNode(nodeType);
    state.rowIndex = index;
    state.parseTokens(node.children);
    state.rowIndex = null;
    state.closeNode();
}


function $78cd61eceb4226b0$export$e1e720e5f4603e6a(state, node) {
    // rowIndex === 0 is the header row (falsy), subsequent rows are body cells
    const cellTypeName = state.rowIndex ? 'tableCell' : 'tableHeader';
    const cellType = state.schema.nodes[cellTypeName] ?? state.schema.nodes.table_cell ?? state.schema.nodes.td;
    const paragraphType = state.schema.nodes.paragraph;
    if (!cellType) {
        // Gracefully degrade: schema has no table cell node — render paragraph content only
        if (paragraphType) {
            state.openNode(paragraphType);
            state.parseTokens(node.children);
            state.closeNode();
        } else state.parseTokens(node.children);
        return;
    }
    state.openNode(cellType);
    if (paragraphType) {
        state.openNode(paragraphType);
        state.parseTokens(node.children);
        state.closeNode();
    } else state.parseTokens(node.children);
    state.closeNode();
}


function $df57d4f79b3d808e$export$6565f9f03506010b(state, node) {
    const nodeType = state.schema.nodes.code_block ?? state.schema.nodes.codeBlock;
    if (!nodeType) {
        // Gracefully degrade: render code value as a plain text paragraph
        state.openNode(state.schema.nodes.paragraph);
        state.addText(node.value);
        state.closeNode();
        return;
    }
    const attrs = {};
    if (node.lang) attrs.language = node.lang;
    state.addNode(nodeType, attrs, node.value ? [
        state.schema.text(node.value)
    ] : []);
}


function $ad9d2ab74b7dc196$export$ba7b13e047416c03(state, _node) {
    const nodeType = state.schema.nodes.horizontal_rule ?? state.schema.nodes.rule ?? state.schema.nodes.hr;
    if (!nodeType) // Gracefully degrade: schema has no rule node — skip the thematic break
    return;
    state.addNode(nodeType, null, []);
}


function $13440d6a649a0c85$export$371da9dd35aba193(state, _node) {
    const nodeType = state.schema.nodes.hard_break ?? state.schema.nodes.hardBreak;
    if (!nodeType) {
        // Gracefully degrade: no hard break node — add a space instead
        state.addText(' ');
        return;
    }
    state.addNode(nodeType, null, []);
}


function $e1eb91654c110ef7$export$5c452ff88e35e47d(state, node) {
    const nodeType = state.schema.nodes.image;
    if (!nodeType) {
        // Gracefully degrade: schema has no image node — render alt text as plain text
        if (node.alt) state.addText(node.alt);
        return;
    }
    state.addNode(nodeType, {
        src: node.url,
        alt: node.alt ?? null,
        title: node.title ?? null
    }, []);
}



var $6x5cj = parcelRequire("6x5cj");

function $160281cfadd812f7$export$6f093cfa640b7166(state, node) {
    state.addText((0, $6x5cj.trimLines)(String(node.value)));
}


function $0dc376b5a1f71f9f$export$59ae2c325a998f89(state, node) {
    if (!state.schema.marks.strong) {
        // Gracefully degrade: render children as plain text when schema has no strong mark
        state.parseTokens(node.children);
        return;
    }
    const mark = state.schema.marks.strong.create();
    state.openMark(mark);
    state.parseTokens(node.children);
    state.closeMark(mark);
}


function $e17c2c49143ef666$export$bef81ba411953b51(state, node) {
    if (!state.schema.marks.em) {
        // Gracefully degrade: render children as plain text when schema has no em mark
        state.parseTokens(node.children);
        return;
    }
    const mark = state.schema.marks.em.create();
    state.openMark(mark);
    state.parseTokens(node.children);
    state.closeMark(mark);
}


function $d678c9c463669b2f$export$91b9bee19a0d8569(state, node) {
    if (!state.schema.marks.code) {
        // Gracefully degrade: render as plain text when schema has no code mark
        state.addText(node.value);
        return;
    }
    const mark = state.schema.marks.code.create();
    state.openMark(mark);
    state.addText(node.value);
    state.closeMark(mark);
}


function $f329a59950ebf868$export$9c30223ca0a664fb(state, node) {
    if (!state.schema.marks.link) {
        // Gracefully degrade: render children as plain text when schema has no link mark
        state.parseTokens(node.children);
        return;
    }
    const mark = state.schema.marks.link.create({
        href: node.url,
        title: node.title ?? null
    });
    state.openMark(mark);
    state.parseTokens(node.children);
    state.closeMark(mark);
}


function $c2af44e3001e02fe$export$b05da9e94a08038f(state, node) {
    const markType = state.schema.marks.strike ?? state.schema.marks.strikethrough;
    if (markType) {
        const mark = markType.create();
        state.openMark(mark);
        state.parseTokens(node.children);
        state.closeMark(mark);
    } else // Graceful degradation: render content without mark
    state.parseTokens(node.children);
}


// asHandler casts a specific-subtype handler to the generic Handler type.
// This is safe: parseTokens only calls a handler with a node whose `type` matches the key.
// TypeScript cannot express this constraint without a cast due to function parameter
// contravariance — a handler accepting (node: Blockquote) is not assignable to one accepting
// (node: Content) even though we only ever call it with a Blockquote node.
const $58a17d32c0911969$var$asHandler = (fn)=>fn;
const $58a17d32c0911969$export$455ce229eb3d2472 = {
    root: $58a17d32c0911969$var$asHandler((0, $6c406f2dcb1e20b3$export$e8e78c978b129247)),
    blockquote: $58a17d32c0911969$var$asHandler((0, $fb59eaa31ebec1e4$export$67dc04e652a298ca)),
    paragraph: $58a17d32c0911969$var$asHandler((0, $23e8a660c6c6ff8f$export$9c206ddddb32a9b)),
    heading: $58a17d32c0911969$var$asHandler((0, $6751f0a19e546654$export$46e4a324ac90507f)),
    list: $58a17d32c0911969$var$asHandler((0, $114969ad66e9d14d$export$8837f4fc672e936d)),
    listItem: $58a17d32c0911969$var$asHandler((0, $bc48f86d27b5c6da$export$76c7e83ecc9cdf05)),
    table: $58a17d32c0911969$var$asHandler((0, $c813a0d23fab6206$export$9852986a3ec5f6a0)),
    tableRow: $58a17d32c0911969$var$asHandler((0, $0b8bd6170c66bc36$export$ce666bf02318c957)),
    tableCell: $58a17d32c0911969$var$asHandler((0, $78cd61eceb4226b0$export$e1e720e5f4603e6a)),
    code: $58a17d32c0911969$var$asHandler((0, $df57d4f79b3d808e$export$6565f9f03506010b)),
    thematicBreak: $58a17d32c0911969$var$asHandler((0, $ad9d2ab74b7dc196$export$ba7b13e047416c03)),
    break: $58a17d32c0911969$var$asHandler((0, $13440d6a649a0c85$export$371da9dd35aba193)),
    image: $58a17d32c0911969$var$asHandler((0, $e1eb91654c110ef7$export$5c452ff88e35e47d)),
    text: $58a17d32c0911969$var$asHandler((0, $160281cfadd812f7$export$6f093cfa640b7166)),
    strong: $58a17d32c0911969$var$asHandler((0, $0dc376b5a1f71f9f$export$59ae2c325a998f89)),
    emphasis: $58a17d32c0911969$var$asHandler((0, $e17c2c49143ef666$export$bef81ba411953b51)),
    inlineCode: $58a17d32c0911969$var$asHandler((0, $d678c9c463669b2f$export$91b9bee19a0d8569)),
    link: $58a17d32c0911969$var$asHandler((0, $f329a59950ebf868$export$9c30223ca0a664fb)),
    delete: $58a17d32c0911969$var$asHandler((0, $c2af44e3001e02fe$export$b05da9e94a08038f))
};


const $df2be656e8d0c47e$var$emptyTaskListItemPattern = /^(\s*)([-*+]|\d+\.) \[([ xX])\](\r?)$/u;
const $df2be656e8d0c47e$var$fencePattern = /^\s*(`{3,}|~{3,})(.*)$/u;
/**
 * `mdast-util-gfm-task-list-item` only treats `[ ]` / `[x]` as a task marker
 * when there is trailing item content. Users can still create an empty task
 * item in source view as `* [ ]`; normalize that to the equivalent form with
 * invisible placeholder content before parsing so it round-trips as a task item
 * instead of a bullet item containing literal bracket text. The placeholder is
 * stripped from the parsed ProseMirror doc immediately after parsing.
 */ const $df2be656e8d0c47e$var$normalizeEmptyTaskListItems = (markdown)=>{
    let openFence;
    let didNormalize = false;
    const lines = markdown.split('\n');
    const normalizedLines = [];
    for (const line of lines){
        const fenceMatch = $df2be656e8d0c47e$var$fencePattern.exec(line);
        const fence = fenceMatch?.[1];
        if (fence) {
            if (!openFence) {
                openFence = {
                    character: fence[0],
                    length: fence.length
                };
                normalizedLines.push(line);
                continue;
            }
            const fenceSuffix = fenceMatch?.[2] ?? '';
            if (fence[0] === openFence.character && fence.length >= openFence.length && fenceSuffix.trim().length === 0) openFence = undefined;
            normalizedLines.push(line);
            continue;
        }
        if (openFence) {
            normalizedLines.push(line);
            continue;
        }
        const match = $df2be656e8d0c47e$var$emptyTaskListItemPattern.exec(line);
        const normalizedLine = match ? `${match[1]}${match[2]} [${match[3]}] ${0, $67216c924400db67$export$adb8a99c77edd84e}${match[4]}` : line;
        didNormalize || (didNormalize = Boolean(match));
        normalizedLines.push(normalizedLine);
    }
    return {
        didNormalize: didNormalize,
        markdown: didNormalize ? normalizedLines.join('\n') : markdown
    };
};
const $df2be656e8d0c47e$var$removeEmptyTaskListPlaceholders = (doc, schema)=>{
    const strip = (node)=>{
        if (!node || typeof node !== 'object') return node;
        const json = node;
        if (json.type === 'text' && json.text !== undefined) {
            if (json.text === (0, $67216c924400db67$export$adb8a99c77edd84e)) return null;
            return json;
        }
        if (Array.isArray(json.content)) return {
            ...json,
            content: json.content.map(strip).filter(Boolean)
        };
        return json;
    };
    return schema.nodeFromJSON(strip(doc.toJSON()));
};
const $df2be656e8d0c47e$var$markdownToAdfViaMdast = (markdown, schema, options)=>{
    const mdast = (0, $1f573826a160da4c$export$d744d789c09bfde6)(markdown, {
        extensions: [
            (0, $1fdd2be315857d56$export$8bbec8ea1400a00e)(),
            (0, $8e44d98c70bdeefa$export$e36cebda627bf2dd)(),
            (0, $08ac07f643a80ce7$export$2912e8b2802475ff)()
        ],
        mdastExtensions: [
            (0, $4b5736c281b8a126$export$34d64e709dd0b9bb)(),
            (0, $7838a54ced4bd729$export$8bd0ec8ecf6adb7d)(),
            (0, $4f16eb57f7bc15ef$export$a427a608608b215f)()
        ]
    });
    const doc = (0, $0fbbd9daab0ee5df$export$4aad817b79ae84b4)(schema, (0, $58a17d32c0911969$export$455ce229eb3d2472))(mdast, {
        sourceMarkdown: markdown
    });
    if (!doc) throw new Error('[markdownToAdf] mdast-util-to-pm returned null for the given markdown');
    return options?.stripEmptyTaskListPlaceholders ? $df2be656e8d0c47e$var$removeEmptyTaskListPlaceholders(doc, schema) : doc;
};
const $df2be656e8d0c47e$export$3768801c4ab752e6 = (doc, schema, options = {})=>{
    const handlers = options.serializeFileMedia ? {
        ...(0, $345f5b3d5ff6f33a$export$d58124ced37e5234),
        ...(0, $7f53e529d3867c12$export$a0da5befa47b223d)({
            serializeFileMedia: options.serializeFileMedia
        })
    } : (0, $345f5b3d5ff6f33a$export$d58124ced37e5234);
    return (0, $7b6de0599580fc69$export$ab3fd54df7090dc2)(schema, handlers)(doc);
};
const $df2be656e8d0c47e$export$aa0067ded6a6b28d = (markdown, schema)=>{
    const normalized = $df2be656e8d0c47e$var$normalizeEmptyTaskListItems(markdown);
    return $df2be656e8d0c47e$var$markdownToAdfViaMdast(normalized.markdown, schema, {
        stripEmptyTaskListPlaceholders: normalized.didNormalize
    });
};
module.exports["adfToMarkdown"] = $df2be656e8d0c47e$export$3768801c4ab752e6;
module.exports["markdownToAdf"] = $df2be656e8d0c47e$export$aa0067ded6a6b28d;

});

parcelRegister("aMwfi", function(module, exports) {

var $5nazv = parcelRequire("5nazv");

// SECTION: From confluence/next/packages/editor-features/src/utils/smartCardOptions.ts
/**
 * Supported Jira URLs and Jira Roadmap URLs, GDrive and ODFB will become Smart Links
 * (only supports Cloud single-issue URLs right now)
 */ const $dff5f32f186d1f2d$var$SMART_LINKS_BEFORE_MACROS = 'jira,jiraroadmap,google-drive-sheets,google-drive-docs,OneDrive,google-drive-slides'.split(',');
function $dff5f32f186d1f2d$export$6b1ad42d09c74964({ providers: providers }) {
    return {
        cardOptions: {
            provider: providers.cardProvider,
            // SECTION: From confluence/next/packages/editor-features/src/utils/smartCardOptions.ts
            allowBlockCards: true,
            allowDatasource: true,
            allowEmbeds: true,
            resolveBeforeMacros: $dff5f32f186d1f2d$var$SMART_LINKS_BEFORE_MACROS
        },
        sanitizePrivateContent: true,
        isFullPage: true,
        markdownToPmConverter: ({ markdown: markdown, schema: schema })=>(0, $5nazv.markdownToAdf)(markdown, schema).content
    };
}
module.exports["pastePluginOptions"] = $dff5f32f186d1f2d$export$6b1ad42d09c74964;

});

parcelRegister("bslVh", function(module, exports) {

var $aBPpS = parcelRequire("aBPpS");


var $iDrrr = parcelRequire("iDrrr");


var $jkcNT = parcelRequire("jkcNT");


var $kSwu1 = parcelRequire("kSwu1");

const $dafb8934c28d33a1$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    easyMentionsPlaceholder: {
        id: "editor-presets-confluence.placeholder.easy-mentions-placeholder",
        defaultMessage: "Type / for all elements or @ to mention someone."
    },
    aiPlaceholder: {
        id: "editor-presets-confluence.placeholder.ai-placeholder",
        defaultMessage: "Type /ai for Atlassian Intelligence, / to add elements, or @ to mention someone (we'll let them know)."
    },
    defaultPlaceholder: {
        id: "editor-presets-confluence.placeholder.default-placeholder",
        defaultMessage: "Type / to insert elements"
    },
    editorEmptyDocumentPlaceholderAI: {
        id: "editor-presets-confluence.placeholder.default-placeholder-ai",
        defaultMessage: "Use {key}+' to ask AI, or type / to insert elements"
    },
    editorEmptyDocumentSpaceShortcutPlaceholder: {
        id: "editor-presets-confluence.placeholder.space-shortcut-placeholder",
        defaultMessage: "Press space to Ask Rovo or / to insert elements"
    },
    placeholderADF: {
        id: "editor-presets-confluence.placeholderADF",
        defaultMessage: "Press <code>space</code> to Ask Rovo or <code>/</code> to insert elements"
    },
    markdownModePlaceholder: {
        id: "editor-presets-confluence.placeholder.markdown-mode-placeholder",
        defaultMessage: "Type or paste markdown"
    }
});


function $163f0518a77200ef$export$c6841f879d4c8aef({ intl: intl, options: options }) {
    const shouldShowSpaceShortcut = options.isAIEnabled && (0, $iDrrr.fg)('platform_editor_ai_aifc_streaming');
    const isMarkdownModeLivePage = options.isMarkdownMode && options.isLivePage;
    const placeholder = (()=>{
        // SECTION: From confluence/next/packages/full-page-editor/src/FullPageEditorComponent.tsx `const placeholderText = `
        if (options.viewMode === 'view') return undefined;
        // END SECTION
        // In a Markdown Mode Live Doc the document is plain markdown, so the slash /
        // mention / AI discovery hints don't apply. Show a markdown-specific
        // placeholder instead. Scoped to Live Pages only.
        if (isMarkdownModeLivePage) return options.markdownModePlaceholder || intl.formatMessage((0, $dafb8934c28d33a1$export$a7357cdd1f0b0168).markdownModePlaceholder);
        // We disable the placeholder here becuase we want to use the new ADF placeholder, see below.
        if (shouldShowSpaceShortcut) return undefined;
        // SECTION: From confluence/next/packages/full-page-editor/src/FullPageEditorComponent.tsx `_getPlaceholderText()`
        if (!options.isAIEnabled) return intl.formatMessage((0, $dafb8934c28d33a1$export$a7357cdd1f0b0168).editorEmptyDocumentPlaceholderAI);
        if ((0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1')) return intl.formatMessage((0, $dafb8934c28d33a1$export$a7357cdd1f0b0168).defaultPlaceholder);
        return intl.formatMessage((0, $dafb8934c28d33a1$export$a7357cdd1f0b0168).easyMentionsPlaceholder);
    // END SECTION
    })();
    const placeholderADF = (()=>{
        if (options.viewMode === 'view') return undefined;
        // In a Markdown Mode Live Doc we always show the plain markdown placeholder
        // text, never the Rovo space-shortcut ADF placeholder (which would take
        // precedence).
        if (isMarkdownModeLivePage) return undefined;
        if (shouldShowSpaceShortcut) return (0, $aBPpS.createADFFromHTML)(intl.formatMessage((0, $dafb8934c28d33a1$export$a7357cdd1f0b0168).placeholderADF, {
            code: (parts)=>`<code>${parts}</code>`
        }));
        return undefined;
    })();
    return {
        placeholder: placeholder,
        placeholderADF: placeholderADF,
        isPlaceholderHidden: options.isPlaceholderHidden,
        withEmptyParagraph: !isMarkdownModeLivePage && (0, $iDrrr.fg)('platform_editor_ai_aifc_streaming'),
        isRovoLLMEnabled: options.isRovoLLMEnabled,
        enableLoadingSpinner: options.enableLoadingSpinner ?? true
    };
}
module.exports["placeholderPluginOptions"] = $163f0518a77200ef$export$c6841f879d4c8aef;

});

parcelRegister("78oCu", function(module, exports) {
function $206dc13ba5886fc7$export$44901d053a58e418({ options: options }) {
    return {
        contextualFormattingEnabled: options.contextualFormattingEnabled
    };
}
module.exports["primaryToolbarPluginOptions"] = $206dc13ba5886fc7$export$44901d053a58e418;

});

parcelRegister("3rW2U", function(module, exports) {
function $fd656c1cd222df94$export$26cff1f2fe9f781b({ options: options }) {
    return {
        enableElementBrowser: true,
        elementBrowserHelpUrl: '',
        disableDefaultItems: false,
        headless: false,
        emptyStateHandler: options?.emptyStateHandler,
        prioritySortingFn: typeof options.quickInsert === 'object' ? options.quickInsert.prioritySortingFn : undefined,
        onInsert: typeof options.quickInsert === 'object' ? options.quickInsert.onInsert : undefined,
        // EDITOR-6558: forward consumer-supplied item filter (used by Markdown Mode
        // to allowlist GFM-compatible items in the `/` menu).
        itemFilter: typeof options.quickInsert === 'object' ? options.quickInsert.itemFilter : undefined
    };
}
module.exports["quickInsertPluginOptions"] = $fd656c1cd222df94$export$26cff1f2fe9f781b;

});

parcelRegister("8o1oU", function(module, exports) {
function $6a1b601b5e4a419b$export$13a2743c2a93c688({ options: options }) {
    return {
        api: options.referentialityContext.api ?? undefined,
        // A spread operator of the options.referentialityContext.options was previously used here, now they're all explicitly listed out to make the code more readable.
        appearance: options.referentialityContext.options.appearance,
        extensionHandlers: options.referentialityContext.options.extensionHandlers,
        externalObservers: options.referentialityContext.options.externalObservers,
        nodeNameCallback: options.referentialityContext.options.nodeNameCallback,
        nodeFocusCallback: options.referentialityContext.options.nodeFocusCallback,
        editorAnalyticsAPI: options.referentialityContext.options.editorAnalyticsAPI,
        editorView: options.referentialityContext.options.editorView,
        featureFlags: options.referentialityContext.options.featureFlags,
        __livePage: options.referentialityContext.options.__livePage,
        __rendererExtensionOptions: options.referentialityContext.options.__rendererExtensionOptions,
        getExtensionHeight: options.referentialityContext.options.getExtensionHeight
    };
}
module.exports["referentialityPluginOptions"] = $6a1b601b5e4a419b$export$13a2743c2a93c688;

});

parcelRegister("1JkrY", function(module, exports) {
function $62e442d5cfea030d$export$222c5aa4c9fb0805({ options: options }) {
    return options;
}
module.exports["selectionExtensionPluginOptions"] = $62e442d5cfea030d$export$222c5aa4c9fb0805;

});

parcelRegister("gLRz8", function(module, exports) {

var $ieeJu = parcelRequire("ieeJu");

function $79cda04ea30939d7$export$197b78e13e8987d2({ options: options }) {
    // SECTION: From confluence/next/packages/editor-presets/src/full-page/createFullPageEditorPreset.ts `.add(['selectionMarkerPlugin', ...])`
    return {
        hideCursorOnInit: options.__livePage || (0, $ieeJu.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)
    };
// END SECTION
}
module.exports["selectionMarkerPluginOptions"] = $79cda04ea30939d7$export$197b78e13e8987d2;

});

parcelRegister("5S8Qw", function(module, exports) {
function $ee8355711183845c$export$ddc2936355c1da67({ options: options }) {
    return {
        useLongPressSelection: false,
        // @ts-ignore Temporary solution to check for Live Page editor.
        __livePage: options.__livePage
    };
}
module.exports["selectionPluginOptions"] = $ee8355711183845c$export$ddc2936355c1da67;

});

parcelRegister("1cNjj", function(module, exports) {
function $91c7d2c6009f534c$export$bc6dcb3c2a6112e1({ options: options, providers: providers }) {
    return {
        preferenceToolbarAboveSelection: false,
        contextualFormattingEnabled: options.contextualFormattingEnabled,
        userPreferencesProvider: providers.userPreferencesProvider,
        disablePin: options.disablePin
    };
}
module.exports["selectionToolbarPluginOptions"] = $91c7d2c6009f534c$export$bc6dcb3c2a6112e1;

});

parcelRegister("9ph8N", function(module, exports) {
function $cd0022ff6e424209$export$5c1f265f89d46b24({ options: options }) {
    if (!options?.originalDoc || !options?.steps) return undefined;
    return {
        originalDoc: options.originalDoc,
        steps: options.steps,
        colorScheme: options.colorScheme
    };
}
module.exports["showDiffPluginOptions"] = $cd0022ff6e424209$export$5c1f265f89d46b24;

});

parcelRegister("4C8JA", function(module, exports) {
function $407ddb9ddabe5b31$export$3612ff8a6b94af71({}) {
    return undefined;
}
module.exports["submitEditorPluginOptions"] = $407ddb9ddabe5b31$export$3612ff8a6b94af71;

});

parcelRegister("cySgy", function(module, exports) {

var $jkcNT = parcelRequire("jkcNT");

function $04c59ad83d435dc1$export$9868b594778cf535({ options: options }) {
    return {
        __livePage: options.__livePage,
        // value from next/packages/editor-features/src/hooks/useTableOptions.ts
        tableOptions: {
            allowTableResizing: true,
            allowTableAlignment: true,
            allowBackgroundColor: true,
            allowColumnResizing: true,
            allowColumnSorting: true,
            allowDistributeColumns: true,
            allowHeaderColumn: true,
            allowHeaderRow: true,
            allowMergeCells: true,
            allowNumberColumn: true,
            allowNestedTables: true,
            allowControls: true,
            stickyHeaders: true,
            allowAddColumnWithCustomStep: false
        },
        isTableScalingEnabled: true,
        allowContextualMenu: true,
        fullWidthEnabled: options.editorAppearance === 'full-width',
        maxWidthEnabled: options.editorAppearance === 'max',
        wasFullWidthEnabled: options.prevEditorAppearance && options.prevEditorAppearance === 'full-width',
        getEditorFeatureFlags: ()=>({
                // SECTION: From confluence/next/packages/full-page-editor/src/hooks/useEditorFullPageExperiments.ts
                tableSelector: (0, $jkcNT.editorExperiment)('platform_editor_tables_table_selector', true)
            }),
        isCommentEditor: false,
        isChromelessEditor: false,
        allowFixedColumnWidthOption: true
    };
}
module.exports["tablePluginOptions"] = $04c59ad83d435dc1$export$9868b594778cf535;

});

parcelRegister("crhNi", function(module, exports) {
function $d8ceff324dc40ac6$export$1d23e03c42bfc1ac({ options: options, providers: providers }) {
    return {
        allowNestedTasks: true,
        consumeTabs: true,
        useLongPressSelection: false,
        taskDecisionProvider: providers.taskDecisionProvider,
        hasEditPermission: options.hasEditPermission,
        requestToEditContent: options.requestToEditContent,
        hasRequestedEditPermission: options.hasRequestedEditPermission,
        allowBlockTaskItem: true
    };
}
module.exports["tasksAndDecisionsPluginOptions"] = $d8ceff324dc40ac6$export$1d23e03c42bfc1ac;

});

parcelRegister("h9jUa", function(module, exports) {
function $f698d6c6136be97b$export$cb883a3a9320698e({}) {
    return {
        responsiveToolbarMenu: true
    };
}
module.exports["textFormattingPluginOptions"] = $f698d6c6136be97b$export$cb883a3a9320698e;

});

parcelRegister("a5Ohw", function(module, exports) {
function $587f0a47ebcb0984$export$2d206ce8fa0c3d37({ options: options }) {
    return {
        componentFilter: options.componentFilter,
        contextualFormattingEnabled: options.contextualFormattingEnabled
    };
}
module.exports["toolbarPluginOptions"] = $587f0a47ebcb0984$export$2d206ce8fa0c3d37;

});

parcelRegister("7cvtX", function(module, exports) {
function $1aebe55f66fd55ea$export$612ea2d32c3e4c96({}) {
    return {
        isMobile: false
    };
}
module.exports["typeAheadPluginOptions"] = $1aebe55f66fd55ea$export$612ea2d32c3e4c96;

});

parcelRegister("d1OC7", function(module, exports) {
function $8c606f8053d9e8e7$export$abdb0d09187eec69({ providers: providers, options: options }) {
    return {
        userPreferencesProvider: providers.userPreferencesProviderNext,
        // If initialToolbarDockingPosition is set, use it to override any saved user preference
        initialUserPreferences: options.initialToolbarDockingPosition ? {
            toolbarDockingPosition: options.initialToolbarDockingPosition
        } : undefined
    };
}
module.exports["userPreferencesPluginOptions"] = $8c606f8053d9e8e7$export$abdb0d09187eec69;

});

parcelRegister("bveWD", function(module, exports) {
/* markdownModePlugin.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $1hQ0e = parcelRequire("1hQ0e");


var $3k5Tv = parcelRequire("3k5Tv");


var $kpCD8 = parcelRequire("kpCD8");


var $hVLmg = parcelRequire("hVLmg");

var $3nacY = parcelRequire("3nacY");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");





var $kCECX = parcelRequire("kCECX");

const $9e7aa44e1133a0cd$export$160e35dbff8be862 = new (0, $kCECX.PluginKey)('markdownMode');


const $6ac889fd0f465b1a$var$MAC_PLATFORM_REGEX = new RegExp('Mac', 'iu');
const $6ac889fd0f465b1a$var$isMac = typeof navigator !== 'undefined' && $6ac889fd0f465b1a$var$MAC_PLATFORM_REGEX.test(navigator.userAgentData?.platform ?? navigator.platform);
const $6ac889fd0f465b1a$export$2fa7e76a57ca53b0 = (e)=>{
    const modifierMatch = $6ac889fd0f465b1a$var$isMac ? e.metaKey && !e.ctrlKey : e.ctrlKey && !e.metaKey;
    return modifierMatch && !e.altKey && !e.shiftKey && e.code === 'KeyE';
};
/**
 * Selector matching the wrapping container that holds both the ProseMirror
 * editor DOM and any plugin-rendered content (e.g. the markdown source view
 * mounted via `PluginSlot`). Defined in
 * `editor-core/src/ui/Appearance/FullPage/FullPageContentArea.tsx` as
 * `EDITOR_CONTAINER`.
 */ const $6ac889fd0f465b1a$var$EDITOR_CONTAINER_SELECTOR = '[data-editor-container="true"]';
const $6ac889fd0f465b1a$export$f3fcac9ec039b10c = (editorView)=>{
    const activeElement = (0, $1hQ0e.getDocument)()?.activeElement ?? null;
    // No active element / focus on body — fall through and allow toggle.
    // `document.body` is reported as `activeElement` in browsers when nothing
    // else is focused; treat that the same as "no focus".
    const hasMeaningfulFocus = activeElement !== null && activeElement !== (0, $1hQ0e.getDocument)()?.body && activeElement !== (0, $1hQ0e.getDocument)()?.documentElement;
    if (!hasMeaningfulFocus) return true;
    if (editorView.dom.contains(activeElement)) return true;
    const ourContainer = typeof editorView.dom.closest === 'function' ? editorView.dom.closest($6ac889fd0f465b1a$var$EDITOR_CONTAINER_SELECTOR) : null;
    if (ourContainer && ourContainer.contains(activeElement)) return true;
    // Multi-editor safety: if focus is inside SOME OTHER editor container,
    // only that editor should respond — not this one.
    const focusedContainer = typeof activeElement.closest === 'function' ? activeElement.closest($6ac889fd0f465b1a$var$EDITOR_CONTAINER_SELECTOR) : null;
    if (focusedContainer && focusedContainer !== ourContainer) return false;
    // Focus is outside any editor container (e.g. a popup, side panel, an
    // unrelated input). Allow the toggle so the shortcut works from "anywhere
    // on the page" — in particular right after clicking the view-mode toggle
    // button, which moves focus out of the editor.
    return true;
};
const $6ac889fd0f465b1a$export$ed529ff4eb54147f = (api, getEditorView)=>{
    return (e)=>{
        if (!$6ac889fd0f465b1a$export$2fa7e76a57ca53b0(e)) return;
        const editorView = getEditorView();
        if (!editorView || editorView.isDestroyed) return;
        // Multi-editor guard: if focus is inside a DIFFERENT editor, only that
        // one should toggle. When focus is outside any editor (e.g. body, a
        // popup, a button) we still toggle so the shortcut works "anywhere on
        // the page", including immediately after the user clicked the toggle
        // button (which moves focus out of the editor).
        if (!$6ac889fd0f465b1a$export$f3fcac9ec039b10c(editorView)) return;
        const pluginState = (0, $9e7aa44e1133a0cd$export$160e35dbff8be862).getState(editorView.state);
        if (!pluginState?.isMarkdownMode) return;
        const currentView = pluginState.view ?? 'preview';
        // Only syntax and preview participate in the runtime toggle cycle.
        // Any other value is treated as non-toggleable.
        if (currentView !== 'syntax' && currentView !== 'preview') return;
        e.preventDefault();
        // Cycle through available views. When split view is enabled in the
        // future, add 'split-view' to this array.
        const viewCycle = [
            'preview',
            'syntax'
        ];
        const currentIndex = viewCycle.indexOf(currentView);
        const nextView = viewCycle[(currentIndex + 1) % viewCycle.length];
        api?.markdownMode?.actions.setView(nextView);
    };
};



/**
 * @file source-view-utils.ts
 *
 * Foundation utilities for interacting with the CodeMirror 6 source view in
 * markdown mode. Provides two layers:
 *
 *  1. **Context queries** - pure functions over `EditorState` that use the
 *     Lezer syntax tree to answer semantic questions about the current cursor
 *     position / selection (e.g. "is the cursor inside a code block?").
 *
 *  2. **Syntax primitive factories** - functions that return `SourceViewCommand`
 *     values (the standard CM6 command signature) for common markdown text
 *     transformations (e.g. wrapping a selection in `**...**`).
 *
 * These utilities are the shared foundation that toolbar-contributing plugins
 * compose into their own `SourceViewCommand` implementations. All CM6 and
 * Lezer knowledge is centralised here so individual plugins remain ignorant of
 * CodeMirror internals.
 *
 * No React or side-effect imports - this module is pure logic and is safe to
 * import in any context.
 */ 
var $9R6p6 = parcelRequire("9R6p6");


var $4lK5a = parcelRequire("4lK5a");


var $b2ZzE = parcelRequire("b2ZzE");




const $b8e7170495150c53$var$ATX_HEADING_REGEX = /^ATXHeading(\d)$/u;
const $b8e7170495150c53$var$SETEXT_HEADING_REGEX = /^SetextHeading(\d)$/u;
const $b8e7170495150c53$var$TASK_PREFIX_REGEX = /^(\s*)(?:[-*+]|\d+\.)\s+\[[ xX]\]\s+/u;
const $b8e7170495150c53$var$LIST_PREFIX_PATTERN_REGEX = /^(\s*)(?:[-*+]|\d+\.)\s+/u;
const $b8e7170495150c53$var$LIST_MARKER_REGEX = /^(\s*)([-*+]|\d+\.)\s+/u;
const $b8e7170495150c53$var$ORDERED_MARKER_REGEX = /^\d+\.$/u;
const $b8e7170495150c53$var$LEADING_WHITESPACE_REGEX = /^\s*/u;
const $b8e7170495150c53$var$ATX_HEADING_PREFIX_REGEX = /^(#{1,6}) /u;
const $b8e7170495150c53$export$2d73244c2182ac32 = Object.fromEntries((0, $9R6p6.markdownLanguage).parser.nodeSet.types.map((t)=>[
        t.name,
        t.name
    ]));
// ---------------------------------------------------------------------------
// Word counting
//
// Word count is locale-aware: `@codemirror` has no document word-count API
// (only `EditorState.wordAt`, which returns the word at a single position), so
// we segment the document text with `Intl.Segmenter`. Unlike a naive
// whitespace split, the segmenter correctly counts words in scripts that do
// not delimit words with spaces (e.g. Chinese / Japanese / Thai) and ignores
// punctuation-only segments (so markdown syntax like `**`, `#`, `>` is not
// counted as a word).
//
// The segmenter is created with the editor's runtime locale (the caller threads
// it through from `useIntl().locale` / `getIntl().locale`), so word boundaries
// match the user's language. When no locale is supplied we pass `undefined` to
// `Intl.Segmenter`, which uses the host environment's default locale.
// ---------------------------------------------------------------------------
// Lazily-created, reused segmenters keyed by locale (`undefined` = host default
// locale). Constructing an `Intl.Segmenter` is comparatively expensive, so we
// build one per locale and reuse it. A `null` value means `Intl.Segmenter` is
// genuinely unavailable on this runtime and we should use the whitespace
// fallback.
const $b8e7170495150c53$var$wordSegmenters = new Map();
/**
 * Build an `Intl.Segmenter` for `locale`, or return `null` when the runtime has
 * no `Intl.Segmenter` at all.
 *
 * A malformed `locale` (e.g. a bad `intl.locale` such as `"not a valid locale"`)
 * makes the constructor throw `RangeError`. We must NOT degrade to the
 * whitespace fallback in that case — that miscounts scripts without spaces
 * (CJK / Thai). Instead we retry with the host default locale, which still
 * segments correctly, and emit a one-time diagnostic so the bad locale is
 * observable rather than silently wrong.
 */ function $b8e7170495150c53$var$createWordSegmenter(locale) {
    if (typeof Intl === 'undefined' || typeof Intl.Segmenter !== 'function') return null;
    try {
        // `undefined` locale → host environment default.
        return new Intl.Segmenter(locale, {
            granularity: 'word'
        });
    } catch (err) {
        if (locale !== undefined) {
            // eslint-disable-next-line no-console
            console.warn(`[MarkdownSourceView] Intl.Segmenter could not be created for locale "${locale}"; falling back to the host default locale for word counting.`, err);
            try {
                return new Intl.Segmenter(undefined, {
                    granularity: 'word'
                });
            } catch  {
            // Host default also failed (very unlikely) — use whitespace split.
            }
        }
        return null;
    }
}
function $b8e7170495150c53$var$getWordSegmenter(locale) {
    const existing = $b8e7170495150c53$var$wordSegmenters.get(locale);
    if (existing !== undefined) return existing;
    // Cache the resolved segmenter (built from `locale` or the host-default
    // fallback) under the requested key so the throwing construction — and its
    // diagnostic — runs at most once per locale.
    const segmenter = $b8e7170495150c53$var$createWordSegmenter(locale);
    $b8e7170495150c53$var$wordSegmenters.set(locale, segmenter);
    return segmenter;
}
/**
 * Count the number of words in `text` for the given `locale` (or the host
 * default locale when omitted). Prefers `Intl.Segmenter` (locale-aware, counts
 * word-like segments only). Falls back to a whitespace split on runtimes
 * without `Intl.Segmenter`.
 */ function $b8e7170495150c53$var$countWordsInText(text, locale) {
    if (text.length === 0) return 0;
    const segmenter = $b8e7170495150c53$var$getWordSegmenter(locale);
    if (segmenter) {
        let count = 0;
        for (const segment of segmenter.segment(text))if (segment.isWordLike) count++;
        return count;
    }
    // Fallback: count whitespace-delimited tokens.
    const matches = text.match(/\S+/gu);
    return matches ? matches.length : 0;
}
// Cache word counts keyed on the immutable CM6 `Text` document instance. CM6
// reuses the same `Text` object when only the selection changes, so this makes
// selection-only updates O(1) and avoids re-scanning the whole document (which
// would add input latency on large documents). A new `Text` instance is
// created on every document edit, so edits recompute exactly once. The cached
// locale is stored alongside the count so a locale change (rare, mid-session)
// correctly invalidates the entry rather than returning a stale count.
const $b8e7170495150c53$var$wordCountCache = new WeakMap();
function $b8e7170495150c53$export$a063438ffa4b0154(doc, locale) {
    const cached = $b8e7170495150c53$var$wordCountCache.get(doc);
    if (cached !== undefined && cached.locale === locale) return cached.count;
    const count = $b8e7170495150c53$var$countWordsInText(doc.toString(), locale);
    $b8e7170495150c53$var$wordCountCache.set(doc, {
        count: count,
        locale: locale
    });
    return count;
}
// ---------------------------------------------------------------------------
// Internal helpers
// ---------------------------------------------------------------------------
/**
 * Walk the Lezer syntax tree upward from `pos`, returning the names of every
 * ancestor node (inclusive of the node at `pos`).
 */ function $b8e7170495150c53$var$ancestorNames(state, pos) {
    const names = [];
    let node = (0, $4lK5a.syntaxTree)(state).resolveInner(pos, 1);
    while(node.parent){
        names.push(node.type.name);
        node = node.parent;
    }
    return names;
}
/**
 * Return true if any ancestor node at `pos` has one of the given type names.
 */ function $b8e7170495150c53$var$hasAncestor(state, pos, ...typeNames) {
    const names = new Set(typeNames);
    let node = (0, $4lK5a.syntaxTree)(state).resolveInner(pos, 1);
    while(node.parent){
        if (names.has(node.type.name)) return true;
        node = node.parent;
    }
    return false;
}
/**
 * Return true if any Lezer node overlapping [from, to] has one of the given
 * type names. Uses syntaxTree.iterate() for an exact answer - no sampling.
 */ function $b8e7170495150c53$var$rangeOverlapsNodes(state, from, to, ...typeNames) {
    const names = new Set(typeNames);
    let found = false;
    (0, $4lK5a.syntaxTree)(state).iterate({
        from: from,
        to: to,
        enter (node) {
            if (names.has(node.type.name)) {
                found = true;
                return false; // stop iteration early
            }
        }
    });
    return found;
}
/** Canonical wrap syntax for each inline format (used for toggle-on). */ const $b8e7170495150c53$var$INLINE_FORMAT_SYNTAX = {
    bold: '**',
    italic: '*',
    inlineCode: '`',
    strikethrough: '~~'
};
/** Lezer node type for each inline format (used for toggle-off detection). */ const $b8e7170495150c53$var$INLINE_FORMAT_NODE_TYPE = {
    bold: 'StrongEmphasis',
    italic: 'Emphasis',
    inlineCode: 'InlineCode',
    strikethrough: 'Strikethrough'
};
/**
 * The Lezer node types that represent "code contexts" - positions where inline
 * markdown formatting (bold, italic, etc.) is meaningless or invalid.
 */ const $b8e7170495150c53$var$CODE_CONTEXT_NODES = [
    'FencedCode',
    'CodeBlock',
    'InlineCode',
    'CodeText',
    'CodeInfo'
];
function $b8e7170495150c53$export$340f88d26d8d1507(state) {
    const { head: head } = state.selection.main;
    return $b8e7170495150c53$var$hasAncestor(state, head, ...$b8e7170495150c53$var$CODE_CONTEXT_NODES);
}
function $b8e7170495150c53$export$59eae5fcd69a8ca2(state) {
    const { from: from, to: to } = state.selection.main;
    // For a collapsed cursor, use the ancestor walk (faster).
    if (from === to) return $b8e7170495150c53$var$hasAncestor(state, from, ...$b8e7170495150c53$var$CODE_CONTEXT_NODES);
    return $b8e7170495150c53$var$rangeOverlapsNodes(state, from, to, ...$b8e7170495150c53$var$CODE_CONTEXT_NODES);
}
function $b8e7170495150c53$var$isSelectionInBlockCodeContext(state) {
    const { from: from, to: to } = state.selection.main;
    if (from === to) return $b8e7170495150c53$var$hasAncestor(state, from, $b8e7170495150c53$export$2d73244c2182ac32.FencedCode, $b8e7170495150c53$export$2d73244c2182ac32.CodeBlock);
    return $b8e7170495150c53$var$rangeOverlapsNodes(state, from, to, $b8e7170495150c53$export$2d73244c2182ac32.FencedCode, $b8e7170495150c53$export$2d73244c2182ac32.CodeBlock);
}
function $b8e7170495150c53$export$8970a27599376db5(state) {
    const { head: head } = state.selection.main;
    return $b8e7170495150c53$var$hasAncestor(state, head, $b8e7170495150c53$export$2d73244c2182ac32.URL);
}
function $b8e7170495150c53$export$35f4bb6bae3e9d74(state) {
    const { head: head } = state.selection.main;
    const line = state.doc.lineAt(head);
    return {
        columnNumber: head - line.from + 1,
        lineCount: state.doc.lines,
        lineNumber: line.number
    };
}
function $b8e7170495150c53$export$3d308a0a07f3d571(state, locale) {
    return {
        ...$b8e7170495150c53$export$35f4bb6bae3e9d74(state),
        wordCount: $b8e7170495150c53$export$a063438ffa4b0154(state.doc, locale)
    };
}
function $b8e7170495150c53$export$bd3fd8da835721f8(state) {
    return !$b8e7170495150c53$export$340f88d26d8d1507(state) && !$b8e7170495150c53$export$8970a27599376db5(state);
}
function $b8e7170495150c53$export$753a775122b7b63b(state, lezerNodeType) {
    const { head: head } = state.selection.main;
    return $b8e7170495150c53$var$hasAncestor(state, head, lezerNodeType);
}
function $b8e7170495150c53$export$8e72f433f86285(state) {
    // Helper: extract heading level from a list of ancestor node names.
    function levelFromNames(names) {
        for (const name of names){
            const atx = name.match($b8e7170495150c53$var$ATX_HEADING_REGEX);
            if (atx) return parseInt(atx[1], 10);
            const setext = name.match($b8e7170495150c53$var$SETEXT_HEADING_REGEX);
            if (setext) return parseInt(setext[1], 10);
        }
        return null;
    }
    const { head: head } = state.selection.main;
    // First try the cursor position directly.
    const direct = levelFromNames($b8e7170495150c53$var$ancestorNames(state, head));
    if (direct !== null) return direct;
    // When the cursor is at the very end of a line (on the \n character),
    // Lezer places it outside the ATXHeading node boundary. Fall back to
    // the last character of the line to detect the heading correctly.
    const line = state.doc.lineAt(head);
    if (head === line.to && line.to > line.from) return levelFromNames($b8e7170495150c53$var$ancestorNames(state, line.to - 1));
    return null;
}
/**
 * Returns true if the primary selection head is inside `typeName`, including
 * the common CM6 edge case where the cursor sits at the end of a non-empty
 * line and Lezer resolves it onto the trailing newline outside the node.
 */ function $b8e7170495150c53$var$isAtCursorOrLineEnd(state, typeName) {
    const { head: head } = state.selection.main;
    if ($b8e7170495150c53$var$hasAncestor(state, head, typeName)) return true;
    const line = state.doc.lineAt(head);
    return head === line.to && line.to > line.from && $b8e7170495150c53$var$hasAncestor(state, line.to - 1, typeName);
}
function $b8e7170495150c53$export$8533b10fb9ecef78(state) {
    return $b8e7170495150c53$var$isAtCursorOrLineEnd(state, $b8e7170495150c53$export$2d73244c2182ac32.Blockquote);
}
function $b8e7170495150c53$export$857ab4b4af2c663a(state) {
    return $b8e7170495150c53$var$isAtCursorOrLineEnd(state, $b8e7170495150c53$export$2d73244c2182ac32.BulletList);
}
function $b8e7170495150c53$export$bcf034afbca8b7b1(state) {
    return $b8e7170495150c53$var$isAtCursorOrLineEnd(state, $b8e7170495150c53$export$2d73244c2182ac32.OrderedList);
}
function $b8e7170495150c53$export$2ee0ef920e12bb1f(state) {
    return $b8e7170495150c53$var$isAtCursorOrLineEnd(state, $b8e7170495150c53$export$2d73244c2182ac32.Task) || $b8e7170495150c53$var$isAtCursorOrLineEnd(state, $b8e7170495150c53$export$2d73244c2182ac32.TaskMarker);
}
function $b8e7170495150c53$export$b777e8b4e40fe375(state, format) {
    return $b8e7170495150c53$export$753a775122b7b63b(state, $b8e7170495150c53$var$INLINE_FORMAT_NODE_TYPE[format]);
}
function $b8e7170495150c53$export$5069c0cb22ba97e6(state) {
    return {
        boldActive: $b8e7170495150c53$export$b777e8b4e40fe375(state, 'bold'),
        italicActive: $b8e7170495150c53$export$b777e8b4e40fe375(state, 'italic'),
        codeActive: $b8e7170495150c53$export$b777e8b4e40fe375(state, 'inlineCode'),
        strikeActive: $b8e7170495150c53$export$b777e8b4e40fe375(state, 'strikethrough'),
        inlineFormattingAvailable: $b8e7170495150c53$export$bd3fd8da835721f8(state)
    };
}
function $b8e7170495150c53$export$96bc0c55bfc3ec38(state) {
    const { head: head } = state.selection.main;
    return {
        headingLevel: $b8e7170495150c53$export$8e72f433f86285(state),
        inBlockquote: $b8e7170495150c53$export$8533b10fb9ecef78(state),
        inCodeBlock: $b8e7170495150c53$var$hasAncestor(state, head, $b8e7170495150c53$export$2d73244c2182ac32.FencedCode, $b8e7170495150c53$export$2d73244c2182ac32.CodeBlock)
    };
}
function $b8e7170495150c53$export$19f8516089a6ae9b(state) {
    const inTaskList = $b8e7170495150c53$export$2ee0ef920e12bb1f(state);
    if ((0, $iDrrr.fg)('platform_editor_markdown_patch_m3')) {
        // Derive list type from the actual text prefix on the cursor's line.
        // This is the ground truth — whichever marker appears first on the line
        // determines the list type, avoiding ambiguity from Lezer ancestor checks
        // that can overlap (e.g. task list nodes live inside BulletList nodes).
        //
        // Regex groups:
        //   TASK_PREFIX_REGEX   — bullet/ordered marker followed by `[ ]` checkbox
        //   LIST_MARKER_REGEX — any list marker; group 2 distinguishes type:
        //     \d+\. → ordered list
        //     [-*+]  → bullet list
        const { head: head } = state.selection.main;
        const lineText = state.doc.lineAt(head).text;
        if ($b8e7170495150c53$var$TASK_PREFIX_REGEX.test(lineText)) return {
            inBulletList: false,
            inOrderedList: false,
            inTaskList: true
        };
        const listMatch = lineText.match($b8e7170495150c53$var$LIST_MARKER_REGEX);
        if (listMatch) {
            const marker = listMatch[2];
            const isOrdered = $b8e7170495150c53$var$ORDERED_MARKER_REGEX.test(marker);
            return {
                inBulletList: !isOrdered,
                inOrderedList: isOrdered,
                inTaskList: false
            };
        }
        return {
            inBulletList: false,
            inOrderedList: false,
            inTaskList: false
        };
    }
    return {
        inBulletList: !inTaskList && $b8e7170495150c53$export$857ab4b4af2c663a(state),
        inOrderedList: !inTaskList && $b8e7170495150c53$export$bcf034afbca8b7b1(state),
        inTaskList: inTaskList
    };
}
// ---------------------------------------------------------------------------
// Syntax primitive factories - return SourceViewCommand values
// ---------------------------------------------------------------------------
/**
 * The Lezer mark node types used to delimit inline formatting. These are the
 * nodes whose text we remove when toggling off a format.
 */ const $b8e7170495150c53$var$INLINE_MARK_NODE_TYPES = new Set([
    $b8e7170495150c53$export$2d73244c2182ac32.EmphasisMark,
    $b8e7170495150c53$export$2d73244c2182ac32.StrikethroughMark,
    $b8e7170495150c53$export$2d73244c2182ac32.CodeMark
]);
/**
 * Find the innermost enclosing Lezer node of `nodeType` at `pos`, then return
 * the positions of its opening and closing mark child nodes. Returns null if
 * no such node is found or if the marks cannot be located.
 */ function $b8e7170495150c53$var$findEnclosingMarkPositions(state, pos, nodeType) {
    let node = (0, $4lK5a.syntaxTree)(state).resolveInner(pos, 1);
    while(node.parent && node.type.name !== nodeType)node = node.parent;
    if (node.type.name !== nodeType) return null;
    let openMark = node.firstChild;
    while(openMark && !$b8e7170495150c53$var$INLINE_MARK_NODE_TYPES.has(openMark.type.name))openMark = openMark.nextSibling;
    let closeMark = node.lastChild;
    while(closeMark && !$b8e7170495150c53$var$INLINE_MARK_NODE_TYPES.has(closeMark.type.name))closeMark = closeMark.prevSibling;
    if (!openMark || !closeMark || openMark === closeMark) return null;
    return {
        openFrom: openMark.from,
        openTo: openMark.to,
        closeFrom: closeMark.from,
        closeTo: closeMark.to
    };
}
function $b8e7170495150c53$export$a43514489bd58733(format) {
    return (view)=>{
        const { state: state } = view;
        const syntax = $b8e7170495150c53$var$INLINE_FORMAT_SYNTAX[format];
        const lezerNodeType = $b8e7170495150c53$var$INLINE_FORMAT_NODE_TYPE[format];
        if (format !== 'inlineCode' && ($b8e7170495150c53$export$59eae5fcd69a8ca2(state) || $b8e7170495150c53$export$8970a27599376db5(state))) return false;
        const range = state.selection.main;
        const { from: from, to: to } = range;
        // Toggle off via Lezer tree - variant-agnostic, handles combined marks.
        const marks = $b8e7170495150c53$var$findEnclosingMarkPositions(state, range.head, lezerNodeType);
        if (marks) {
            const { openFrom: openFrom, openTo: openTo, closeFrom: closeFrom, closeTo: closeTo } = marks;
            const changes = [
                {
                    from: openFrom,
                    to: openTo,
                    insert: ''
                },
                {
                    from: closeFrom,
                    to: closeTo,
                    insert: ''
                }
            ];
            const changeSet = state.changes(changes);
            const mappedSelection = (0, $b2ZzE.EditorSelection).create(state.selection.ranges.map((range)=>range.map(changeSet, 1)), state.selection.mainIndex);
            view.dispatch(state.update({
                changes: changes,
                selection: mappedSelection
            }));
            return true;
        }
        // No selection - insert pair and place cursor between.
        if (range.empty) {
            view.dispatch(state.update({
                changes: {
                    from: from,
                    insert: syntax + syntax
                },
                selection: {
                    anchor: from + syntax.length
                }
            }));
            return true;
        }
        // Toggle on - wrap selection.
        view.dispatch(state.update({
            changes: [
                {
                    from: from,
                    insert: syntax
                },
                {
                    from: to,
                    insert: syntax
                }
            ],
            selection: {
                anchor: from + syntax.length,
                head: to + syntax.length
            }
        }));
        return true;
    };
}
function $b8e7170495150c53$export$f3072de57f1b974a(prefix, options = {}) {
    const { stripConflictingList: stripConflictingList = false } = options;
    return (view)=>{
        const { state: state } = view;
        const { from: from, to: to } = state.selection.main;
        if ($b8e7170495150c53$var$isSelectionInBlockCodeContext(state)) return false;
        const doc = state.doc;
        const firstLine = doc.lineAt(from);
        const lastLine = doc.lineAt(to === from ? from : to - 1);
        const allHavePrefix = Array.from({
            length: lastLine.number - firstLine.number + 1
        }, (_, i)=>doc.line(firstLine.number + i)).every((line)=>line.text.startsWith(prefix));
        const changes = [];
        // When inserting a prefix on a blank line with a trailing '\n' to preserve
        // CommonMark block separation, we need to explicitly place the cursor after
        // the prefix (not after the '\n'). Track that position here.
        let explicitCursorPos = null;
        for(let n = firstLine.number; n <= lastLine.number; n++){
            const line = doc.line(n);
            if (allHavePrefix) changes.push({
                from: line.from,
                to: line.from + prefix.length,
                insert: ''
            });
            else if (!line.text.startsWith(prefix)) {
                // When switching list types, strip any existing list prefix before
                // inserting the new one so that bullet and ordered lists remain
                // mutually exclusive (fixes: both list types active simultaneously).
                if (stripConflictingList && (0, $iDrrr.fg)('platform_editor_markdown_patch_m3')) {
                    const existingListMatch = line.text.match($b8e7170495150c53$var$LIST_MARKER_REGEX);
                    if (existingListMatch) {
                        changes.push({
                            from: line.from,
                            to: line.from + existingListMatch[0].length,
                            insert: prefix
                        });
                        continue;
                    }
                }
                if (line.text === '' && n === firstLine.number && n === lastLine.number) {
                    // Inserting a list/quote prefix on a blank line between paragraphs.
                    // Without a trailing blank line, the next paragraph would be parsed
                    // as a lazy continuation of this list item by CommonMark. Insert
                    // a blank line after the prefix to keep the blocks separate.
                    const nextLine = n < doc.lines ? doc.line(n + 1) : null;
                    if (nextLine && nextLine.text !== '') {
                        changes.push({
                            from: line.from,
                            insert: prefix + '\n'
                        });
                        // Cursor should land after the prefix, not after the inserted '\n'.
                        if ((0, $iDrrr.fg)('platform_editor_markdown_patch_m3')) explicitCursorPos = line.from + prefix.length;
                    } else changes.push({
                        from: line.from,
                        insert: prefix
                    });
                } else changes.push({
                    from: line.from,
                    insert: prefix
                });
            }
        }
        const changeSet = state.changes(changes);
        // If we inserted "prefix\n" on a blank line, place the cursor explicitly
        // after the prefix so it stays on the same (now prefixed) line.
        // Otherwise, map the selection through the changes. Use assoc=1 so that positions
        // that coincide with an insertion point (e.g. cursor at col 0 when we
        // insert a prefix there) are moved forward rather than left behind.
        const mappedSelection = explicitCursorPos !== null ? (0, $b2ZzE.EditorSelection).cursor(explicitCursorPos) : (0, $b2ZzE.EditorSelection).create(state.selection.ranges.map((range)=>range.map(changeSet, 1)), state.selection.mainIndex);
        const tr = state.update({
            changes: changes,
            selection: mappedSelection
        });
        view.dispatch(tr);
        return true;
    };
}
function $b8e7170495150c53$export$f27293a683e57637() {
    return (view)=>{
        const { state: state } = view;
        const { from: from, to: to } = state.selection.main;
        if ($b8e7170495150c53$var$isSelectionInBlockCodeContext(state)) return false;
        const doc = state.doc;
        const firstLine = doc.lineAt(from);
        const lastLine = doc.lineAt(to === from ? from : to - 1);
        const lines = Array.from({
            length: lastLine.number - firstLine.number + 1
        }, (_, i)=>doc.line(firstLine.number + i));
        const allHaveTaskPrefix = lines.every((line)=>$b8e7170495150c53$var$TASK_PREFIX_REGEX.test(line.text));
        const changes = [];
        for (const line of lines){
            const taskMatch = line.text.match($b8e7170495150c53$var$TASK_PREFIX_REGEX);
            if (allHaveTaskPrefix && taskMatch) {
                changes.push({
                    from: line.from + taskMatch[1].length,
                    to: line.from + taskMatch[0].length,
                    insert: ''
                });
                continue;
            }
            if (taskMatch) continue;
            const listMatch = line.text.match($b8e7170495150c53$var$LIST_PREFIX_PATTERN_REGEX);
            if (listMatch) {
                changes.push({
                    from: line.from + listMatch[1].length,
                    to: line.from + listMatch[0].length,
                    insert: '- [ ] '
                });
                continue;
            }
            const indentation = line.text.match($b8e7170495150c53$var$LEADING_WHITESPACE_REGEX)?.[0] ?? '';
            if (line.text === '' && line.number === firstLine.number && line.number === lastLine.number) {
                const nextLine = line.number < doc.lines ? doc.line(line.number + 1) : null;
                changes.push({
                    from: line.from,
                    insert: nextLine && nextLine.text !== '' ? '- [ ] \n' : '- [ ] '
                });
            } else changes.push({
                from: line.from + indentation.length,
                insert: '- [ ] '
            });
        }
        const changeSet = state.changes(changes);
        const mappedSelection = (0, $b2ZzE.EditorSelection).create(state.selection.ranges.map((range)=>range.map(changeSet, 1)), state.selection.mainIndex);
        view.dispatch(state.update({
            changes: changes,
            selection: mappedSelection
        }));
        return true;
    };
}
function $b8e7170495150c53$export$fdf2c1c8534e927b(level) {
    return (view)=>{
        const { state: state } = view;
        const { head: head } = state.selection.main;
        if ($b8e7170495150c53$var$hasAncestor(state, head, $b8e7170495150c53$export$2d73244c2182ac32.FencedCode, $b8e7170495150c53$export$2d73244c2182ac32.CodeBlock)) return false;
        const line = state.doc.lineAt(head);
        const text = line.text;
        const existingMatch = text.match($b8e7170495150c53$var$ATX_HEADING_PREFIX_REGEX);
        const targetPrefix = '#'.repeat(level) + ' ';
        const existingHeadingLevel = $b8e7170495150c53$export$8e72f433f86285(state);
        if (existingMatch) {
            const existingPrefix = existingMatch[0];
            if (existingPrefix === targetPrefix) view.dispatch(state.update({
                changes: {
                    from: line.from,
                    to: line.from + existingPrefix.length,
                    insert: ''
                }
            }));
            else view.dispatch(state.update({
                changes: {
                    from: line.from,
                    to: line.from + existingPrefix.length,
                    insert: targetPrefix
                }
            }));
        } else if (existingHeadingLevel !== null) return false;
        else view.dispatch(state.update({
            changes: {
                from: line.from,
                insert: targetPrefix
            }
        }));
        return true;
    };
}
function $b8e7170495150c53$export$3b2204dc19d35ba4() {
    return (view)=>{
        const { state: state } = view;
        const { from: from, to: to } = state.selection.main;
        if ($b8e7170495150c53$var$hasAncestor(state, from, $b8e7170495150c53$export$2d73244c2182ac32.FencedCode)) {
            let node = (0, $4lK5a.syntaxTree)(state).resolveInner(from, 1);
            while(node.parent && node.type.name !== $b8e7170495150c53$export$2d73244c2182ac32.FencedCode)node = node.parent;
            if (node.type.name === $b8e7170495150c53$export$2d73244c2182ac32.FencedCode) {
                const fenceText = state.doc.sliceString(node.from, node.to);
                const openFenceEnd = fenceText.indexOf('\n');
                const closeFenceStart = fenceText.lastIndexOf('\n');
                if (openFenceEnd !== -1) {
                    const inner = fenceText.slice(openFenceEnd + 1, closeFenceStart);
                    view.dispatch(state.update({
                        changes: {
                            from: node.from,
                            to: node.to,
                            insert: inner
                        }
                    }));
                    return true;
                }
            }
        }
        if ($b8e7170495150c53$var$isSelectionInBlockCodeContext(state)) return false;
        const doc = state.doc;
        const firstLine = doc.lineAt(from);
        const lastLine = doc.lineAt(to === from ? from : to - 1);
        const selectedText = doc.sliceString(firstLine.from, lastLine.to);
        view.dispatch(state.update({
            changes: {
                from: firstLine.from,
                to: lastLine.to,
                insert: '```\n' + selectedText + '\n```'
            },
            selection: {
                anchor: firstLine.from + 4
            }
        }));
        return true;
    };
}
const $b8e7170495150c53$export$b850a936f66192a3 = $b8e7170495150c53$export$a43514489bd58733('bold');
const $b8e7170495150c53$export$227b5ef404be9031 = $b8e7170495150c53$export$a43514489bd58733('italic');
const $b8e7170495150c53$export$e7d955a85cfe503c = $b8e7170495150c53$export$a43514489bd58733('inlineCode');
const $b8e7170495150c53$export$a46d65f808b4881d = $b8e7170495150c53$export$a43514489bd58733('strikethrough');
const $b8e7170495150c53$export$2cd68375ac1e5429 = $b8e7170495150c53$export$f3072de57f1b974a('> ');
const $b8e7170495150c53$export$71c898cbdfd51c6e = $b8e7170495150c53$export$f3072de57f1b974a('* ', {
    stripConflictingList: true
});
const $b8e7170495150c53$export$744c9722bde8c6b3 = $b8e7170495150c53$export$f3072de57f1b974a('1. ', {
    stripConflictingList: true
});
const $b8e7170495150c53$export$49b8416aa3f9522a = $b8e7170495150c53$export$f27293a683e57637();
const $b8e7170495150c53$export$4e0d444e5782abea = $b8e7170495150c53$export$fdf2c1c8534e927b(1);
const $b8e7170495150c53$export$b8d734de6aecb0a3 = $b8e7170495150c53$export$fdf2c1c8534e927b(2);
const $b8e7170495150c53$export$df05910f74b29e0 = $b8e7170495150c53$export$fdf2c1c8534e927b(3);
const $b8e7170495150c53$export$ca48da5fbbd68542 = $b8e7170495150c53$export$fdf2c1c8534e927b(4);
const $b8e7170495150c53$export$1335885ed6c2d3ac = $b8e7170495150c53$export$fdf2c1c8534e927b(5);
const $b8e7170495150c53$export$8381ca7ddcf8db0d = $b8e7170495150c53$export$fdf2c1c8534e927b(6);
const $b8e7170495150c53$export$b420bd8551521778 = $b8e7170495150c53$export$3b2204dc19d35ba4();
/**
 * Builds a markdown table string with the given number of rows and columns.
 * Row count includes the header row (so rowsCount=3 → 1 header + 2 data rows).
 * Used by `insertSourceTableCommand` to insert tables at the CM cursor.
 */ function $b8e7170495150c53$var$buildMarkdownTable(rowsCount, colsCount) {
    const emptyRow = `| ${Array.from({
        length: colsCount
    }, ()=>' ').join(' | ')} |`;
    const separator = `| ${Array.from({
        length: colsCount
    }, ()=>'-').join(' | ')} |`;
    const dataRows = Array.from({
        length: rowsCount - 1
    }, ()=>emptyRow);
    return [
        emptyRow,
        separator,
        ...dataRows
    ].join('\n');
}
function $b8e7170495150c53$export$feb50cc511a53ca1(rowsCount = 3, colsCount = 3) {
    return (view)=>{
        const markdownTable = $b8e7170495150c53$var$buildMarkdownTable(rowsCount, colsCount);
        const { from: from, to: to } = view.state.selection.main;
        view.dispatch(view.state.update({
            changes: {
                from: from,
                to: to,
                insert: markdownTable
            },
            selection: {
                anchor: from + markdownTable.length
            }
        }));
        return true;
    };
}


/**
 * MarkdownModeContentComponentDiff — writes source-view edits back to the
 * live ProseMirror doc as surgical `Step`s (via `@atlassian/content-reconciler`) instead of a
 * single full-document `replaceWith`.
 *
 * Selected by the plugin as the sole content-writeback component. All other
 * behaviour — snapshot, dispatch tap, source/preview rendering, format-state
 * plumbing — matches the legacy component.
 *
 * Differences vs `MarkdownModeContentComponent`:
 *  - `handleSourceMarkdownChange` and `handleMarkdownCommit` call
 *    `applyDiffSteps(editorView, adfNode)` instead of building a
 *    `replaceWith` transaction.
 *  - Annotations are passed to `@atlassian/content-reconciler` as ignored mark types
 *    (`{ ignoreMarkTypes: ['annotation'] }`). The library then:
 *      · doesn't fork prefix/suffix or similarity decisions on annotations,
 *      · inherits annotation marks into Replace/Insert slices from the old
 *        doc, so text edited inside an annotated span keeps the annotation
 *        without an explicit re-paint,
 *      · never emits `AddMark`/`RemoveMark` for annotation marks.
 *    Cross-boundary edits (an edit that spans two annotations, or partially
 *    overlaps one) are still ambiguous — the inheritance rule picks a side.
 *    Snapshot-time annotation ranges are passed to the source view so
 *    highlights render, and `onAnnotationClick` opens the comment popup.
 *  - Collab-safe. Steps are diffed against `seedPmDocRef` and rebased
 *    through `interveningMappingRef` (non-own txs since the seed). Both
 *    refs reset on snapshot and after every successful writeback.
 */ 






var $eOaGc = parcelRequire("eOaGc");





var $5nazv = parcelRequire("5nazv");

/**
 * Diff `seedDoc` → `newAdfNode` via `@atlassian/content-reconciler` and
 * dispatch the resulting Steps as one `addToHistory: false` tx. Each Step
 * is rebased through `interveningMapping` (non-own txs since the seed)
 * before dispatch, making the writeback safe to interleave with remote
 * collab steps. The tx carries `OWN_WRITEBACK_META` so the orchestrator's
 * dispatch tap can echo-filter it synchronously.
 */ 



var $aPdNQ = parcelRequire("aPdNQ");










function $1b24bfcd447ec548$export$c04a05f66108dc98(content) {
    const out = [];
    let acc = null;
    for(let i = 0; i < content.childCount; i++){
        const child = content.child(i);
        if (child.isText && child.text !== undefined) {
            const text = child.text;
            if (acc === null) acc = {
                kind: 'textRun',
                text: text,
                spans: [
                    {
                        start: 0,
                        end: text.length,
                        marks: child.marks
                    }
                ]
            };
            else {
                const start = acc.text.length;
                acc.text += text;
                acc.spans.push({
                    start: start,
                    end: acc.text.length,
                    marks: child.marks
                });
            }
        } else {
            if (acc) {
                out.push(acc);
                acc = null;
            }
            out.push({
                kind: 'node',
                node: child
            });
        }
    }
    if (acc) out.push(acc);
    return out;
}
function $1b24bfcd447ec548$export$865f3f3e3ebbacd6(run, from, to, mkText, extraMarks = []) {
    if (from >= to) return [];
    const out = [];
    let pos = from;
    while(pos < to){
        const span = $1b24bfcd447ec548$var$spanCovering(run.spans, pos);
        const segEnd = Math.min(span?.end ?? to, to);
        const segText = run.text.slice(pos, segEnd);
        if (segText.length > 0) {
            const baseMarks = span?.marks ?? [];
            const marks = extraMarks.length === 0 ? baseMarks : $1b24bfcd447ec548$var$mergeMarks(baseMarks, extraMarks);
            out.push(mkText(segText, marks));
        }
        pos = segEnd;
    }
    return out;
}
function $1b24bfcd447ec548$export$772de15c541bba1a(run, pos, keep) {
    if (keep.size === 0) return [];
    const span = $1b24bfcd447ec548$var$spanCovering(run.spans, pos);
    if (!span) return [];
    return span.marks.filter((m)=>keep.has(m.type.name));
}
function $1b24bfcd447ec548$var$mergeMarks(a, b) {
    const out = [
        ...a
    ];
    for (const m of b)if (!out.some((existing)=>existing.eq(m))) out.push(m);
    return out;
}
function $1b24bfcd447ec548$var$spanCovering(spans, pos) {
    // Linear scan is fine for the typical case (one or two text runs per paragraph).
    // Switch to binary search if benchmarks show this matters.
    for (const s of spans){
        if (pos >= s.start && pos < s.end) return s;
    }
    return null;
}



/**
 * Hirschberg's LCS algorithm: O(m*n) time, O(min(m,n)) space.
 * Returns matching index pairs (i in xs, j in ys).
 *
 * Ported from `core/lcs/Hirschberg.kt` in adf-content-reconciler.
 *
 * `maxRegions` is a safety cutoff: if the LCS would produce more than this many
 * distinct match runs (heuristically: the number of returned pairs is an upper
 * bound on the number of regions), we bail out and return `null` so the caller
 * can fall back to emitting a single Replace over the whole range. This protects
 * against pathological diffs on large inputs where surgical steps offer no real
 * benefit.
 */ function $c586b7a08c6a9153$export$99056b812f67789a(xs, ys, equal, maxRegions = 0) {
    return $c586b7a08c6a9153$var$hirschbergView(xs, 0, xs.length, ys, 0, ys.length, equal, maxRegions);
}
function $c586b7a08c6a9153$var$hirschbergView(xs, xLo, xHi, ys, yLo, yHi, equal, maxRegions) {
    const xLen = xHi - xLo;
    const yLen = yHi - yLo;
    if (xLen === 0 || yLen === 0) return [];
    if (xLen === 1) {
        for(let j = 0; j < yLen; j++){
            if (equal(xs[xLo], ys[yLo + j])) return [
                [
                    xLo,
                    yLo + j
                ]
            ];
        }
        return [];
    }
    if (yLen === 1) {
        for(let i = 0; i < xLen; i++){
            if (equal(xs[xLo + i], ys[yLo])) return [
                [
                    xLo + i,
                    yLo
                ]
            ];
        }
        return [];
    }
    const midX = xLo + (xLen >> 1);
    const l1 = $c586b7a08c6a9153$var$lcsRow(xs, xLo, midX, ys, yLo, yHi, equal, /*reverse*/ false);
    const l2 = $c586b7a08c6a9153$var$lcsRow(xs, midX, xHi, ys, yLo, yHi, equal, /*reverse*/ true);
    // Find optimal split point in Y (relative offset into ys[yLo..yHi]).
    let bestK = 0;
    let bestSum = -1;
    for(let k = 0; k <= yLen; k++){
        const sum = l1[k] + l2[k];
        if (sum > bestSum) {
            bestSum = sum;
            bestK = k;
        }
    }
    const split = yLo + bestK;
    const left = $c586b7a08c6a9153$var$hirschbergView(xs, xLo, midX, ys, yLo, split, equal, maxRegions);
    if (left === null) return null;
    if (maxRegions > 0 && left.length > maxRegions) return null;
    const right = $c586b7a08c6a9153$var$hirschbergView(xs, midX, xHi, ys, split, yHi, equal, maxRegions);
    if (right === null) return null;
    if (maxRegions > 0 && left.length + right.length > maxRegions) return null;
    // Indices in `right` are already absolute (we passed absolute xs/ys plus bounds).
    return left.concat(right);
}
/**
 * One row of the LCS DP. When `reverse` is true, iterates from the high end
 * backwards, which produces the suffix-LCS lengths needed by the Hirschberg split.
 */ function $c586b7a08c6a9153$var$lcsRow(xs, xLo, xHi, ys, yLo, yHi, equal, reverse) {
    const yLen = yHi - yLo;
    const dp = new Array(yLen + 1).fill(0);
    const xStart = reverse ? xHi - 1 : xLo;
    const xEnd = reverse ? xLo - 1 : xHi;
    const xStep = reverse ? -1 : 1;
    for(let i = xStart; i !== xEnd; i += xStep){
        let prev = 0;
        const yStart = reverse ? yLen - 1 : 0;
        const yEnd = reverse ? -1 : yLen;
        const yStep = reverse ? -1 : 1;
        for(let j = yStart; j !== yEnd; j += yStep){
            // Forward: dp[j+1] = match? prev+1 : max(dp[j+1], dp[j])
            // Reverse: dp[j]   = match? prev+1 : max(dp[j],   dp[j+1])
            const cur = reverse ? j : j + 1;
            const other = reverse ? j + 1 : j;
            const temp = dp[cur];
            dp[cur] = equal(xs[i], ys[yLo + j]) ? prev + 1 : Math.max(dp[cur], dp[other]);
            prev = temp;
        }
    }
    return dp;
}


function $73c8b1fe933177ea$export$268be64a1d1b0703(oldList, newList, emit, similarity = (a, b)=>a === b, maxRegions = 0, strictEqual = similarity) {
    const oldSize = oldList.length;
    const newSize = newList.length;
    // Common prefix
    let prefix = 0;
    while(prefix < Math.min(oldSize, newSize) && strictEqual(oldList[prefix], newList[prefix]))prefix++;
    // Common suffix (only over the part not already consumed by prefix)
    let suffix = 0;
    while(suffix < Math.min(oldSize, newSize) - prefix && strictEqual(oldList[oldSize - 1 - suffix], newList[newSize - 1 - suffix]))suffix++;
    if (prefix > 0) emit({
        kind: 'match',
        oldIndex: 0,
        newIndex: 0,
        length: prefix
    });
    if (suffix > 0) emit({
        kind: 'match',
        oldIndex: oldSize - suffix,
        newIndex: newSize - suffix,
        length: suffix
    });
    if (prefix === oldSize && prefix === newSize) return;
    const oldMidLo = prefix;
    const oldMidHi = oldSize - suffix;
    const newMidLo = prefix;
    const newMidHi = newSize - suffix;
    const oldMid = oldList.slice(oldMidLo, oldMidHi);
    const newMid = newList.slice(newMidLo, newMidHi);
    // Phase 1: lock strict-equal pairs as anchors.
    // If `strictEqual` is the same function reference as `similarity` (the
    // default), the anchor pass is degenerate with the LCS pass below; skip it.
    const anchors = strictEqual === similarity ? [] : (0, $c586b7a08c6a9153$export$99056b812f67789a)(oldMid, newMid, strictEqual, 0) ?? [];
    // Phase 2: run same-type LCS inside each gap between anchors.
    // The result `lcsRelative` is the union of all anchor pairs and gap LCS
    // pairs, in increasing order, in coords relative to oldMid / newMid.
    let lcsRelative = [];
    let lastOldEnd = 0;
    let lastNewEnd = 0;
    const runGap = (oldLo, oldHi, newLo, newHi)=>{
        if (lcsRelative === null) return;
        if (oldHi - oldLo === 0 || newHi - newLo === 0) return;
        const gapPairs = (0, $c586b7a08c6a9153$export$99056b812f67789a)(oldMid.slice(oldLo, oldHi), newMid.slice(newLo, newHi), similarity, maxRegions);
        if (gapPairs === null) {
            lcsRelative = null;
            return;
        }
        for (const [i, j] of gapPairs)lcsRelative.push([
            oldLo + i,
            newLo + j
        ]);
    };
    for (const [aOld, aNew] of anchors){
        runGap(lastOldEnd, aOld, lastNewEnd, aNew);
        if (lcsRelative === null) break;
        lcsRelative.push([
            aOld,
            aNew
        ]);
        lastOldEnd = aOld + 1;
        lastNewEnd = aNew + 1;
    }
    if (lcsRelative !== null) runGap(lastOldEnd, oldMid.length, lastNewEnd, newMid.length);
    // LCS aborted (too many regions in some gap) → collapse to a single replace
    // over the entire middle. Anchors are discarded here on purpose: once we've
    // decided to fall back to wholesale replace, partial anchoring would emit a
    // weird mix of small matches plus a giant replace around them.
    if (lcsRelative === null) {
        emit({
            kind: 'replace',
            replaceFrom: oldMidLo,
            replaceTo: oldMidHi,
            from: newMidLo,
            to: newMidHi
        });
        return;
    }
    // Adjust LCS pairs back to absolute indices.
    const lcs = lcsRelative.map(([i, j])=>[
            i + prefix,
            j + prefix
        ]);
    if (lcs.length === 0) {
        // No matches in the middle - one of insert/delete/replace
        if (oldMidHi - oldMidLo === 0) emit({
            kind: 'insert',
            insertAt: oldMidHi,
            from: newMidLo,
            to: newMidHi
        });
        else if (newMidHi - newMidLo === 0) emit({
            kind: 'delete',
            from: oldMidLo,
            to: oldMidHi
        });
        else emit({
            kind: 'replace',
            replaceFrom: oldMidLo,
            replaceTo: oldMidHi,
            from: newMidLo,
            to: newMidHi
        });
        return;
    }
    // Walk old/new in tandem, emitting Match/Insert/Delete runs based on LCS pairs.
    let oldIdx = prefix;
    let newIdx = prefix;
    let lcsIdx = 0;
    const matched = ()=>lcsIdx < lcs.length && oldIdx === lcs[lcsIdx][0] && newIdx === lcs[lcsIdx][1];
    const shouldInsert = ()=>{
        if (newIdx >= newSize) return false;
        if (lcsIdx < lcs.length) return newIdx < lcs[lcsIdx][1];
        return newSize - newIdx > oldSize - oldIdx;
    };
    const shouldDelete = ()=>{
        if (oldIdx >= oldSize) return false;
        if (lcsIdx < lcs.length) return oldIdx < lcs[lcsIdx][0];
        return oldSize - oldIdx > newSize - newIdx;
    };
    while(oldIdx + suffix < oldSize || newIdx + suffix < newSize){
        if (matched()) {
            const oldStart = oldIdx;
            const newStart = newIdx;
            let len = 0;
            do {
                oldIdx++;
                newIdx++;
                lcsIdx++;
                len++;
            }while (matched());
            emit({
                kind: 'match',
                oldIndex: oldStart,
                newIndex: newStart,
                length: len
            });
        } else if (shouldInsert()) {
            const start = newIdx;
            do newIdx++;
            while (shouldInsert());
            emit({
                kind: 'insert',
                insertAt: oldIdx,
                from: start,
                to: newIdx
            });
        } else {
            const start = oldIdx;
            do oldIdx++;
            while (shouldDelete());
            emit({
                kind: 'delete',
                from: start,
                to: oldIdx
            });
        }
    }
}








function $1cd935bd164bf76f$export$8f0d278bb8862aee(marks, ignore) {
    if (ignore.size === 0) return marks;
    if (!marks.some((m)=>ignore.has(m.type.name))) return marks;
    return marks.filter((m)=>!ignore.has(m.type.name));
}
const $1cd935bd164bf76f$export$499e45ef1aa79998 = (v)=>{
    if (v === null || typeof v !== 'object') return JSON.stringify(v) ?? 'null';
    if (Array.isArray(v)) return `[${v.map($1cd935bd164bf76f$export$499e45ef1aa79998).join(',')}]`;
    const o = v;
    return `{${Object.keys(o).sort().map((k)=>`${JSON.stringify(k)}:${$1cd935bd164bf76f$export$499e45ef1aa79998(o[k])}`).join(',')}}`;
};
function $1cd935bd164bf76f$export$88a30e5386bda853(a, b, ignore) {
    if (ignore.size === 0) return a.eq(b);
    if (a.eq(b)) return true; // fast path; covers the common case
    if (a.type !== b.type) return false;
    if (!$1cd935bd164bf76f$var$sameMarkSet($1cd935bd164bf76f$export$8f0d278bb8862aee(a.marks, ignore), $1cd935bd164bf76f$export$8f0d278bb8862aee(b.marks, ignore))) return false;
    // PM attrs are plain JSON values; compare them independent of object key order.
    if ($1cd935bd164bf76f$export$499e45ef1aa79998(a.attrs ?? {}) !== $1cd935bd164bf76f$export$499e45ef1aa79998(b.attrs ?? {})) return false;
    if (a.isText) return a.text === b.text;
    if (a.type.inlineContent) return $1cd935bd164bf76f$var$inlineContentEqIgnoring(a.content, b.content, ignore);
    if (a.childCount !== b.childCount) return false;
    for(let i = 0; i < a.childCount; i++){
        if (!$1cd935bd164bf76f$export$88a30e5386bda853(a.child(i), b.child(i), ignore)) return false;
    }
    return true;
}
/**
 * Inline-aware equality: walks two inline-content fragments as a character
 * stream + non-text token stream, applying mark filtering per character. This
 * sidesteps PM's text-node auto-merging differences between the two sides.
 */ function $1cd935bd164bf76f$var$inlineContentEqIgnoring(a, b, ignore) {
    const tokens = (frag)=>{
        const out = [];
        for(let i = 0; i < frag.childCount; i++){
            const child = frag.child(i);
            if (child.isText && child.text !== undefined) {
                const marks = $1cd935bd164bf76f$export$8f0d278bb8862aee(child.marks, ignore);
                for (const ch of child.text)out.push({
                    kind: 'char',
                    ch: ch,
                    marks: marks
                });
            } else out.push({
                kind: 'node',
                node: child
            });
        }
        return out;
    };
    const at = tokens(a);
    const bt = tokens(b);
    if (at.length !== bt.length) return false;
    for(let i = 0; i < at.length; i++){
        const x = at[i];
        const y = bt[i];
        if (x.kind !== y.kind) return false;
        if (x.kind === 'char' && y.kind === 'char') {
            if (x.ch !== y.ch) return false;
            if (!$1cd935bd164bf76f$var$sameMarkSet(x.marks, y.marks)) return false;
        } else if (x.kind === 'node' && y.kind === 'node') {
            if (!$1cd935bd164bf76f$export$88a30e5386bda853(x.node, y.node, ignore)) return false;
        }
    }
    return true;
}
function $1cd935bd164bf76f$var$sameMarkSet(a, b) {
    if (a.length !== b.length) return false;
    return a.every((m)=>b.some((n)=>n.eq(m)));
}
function $1cd935bd164bf76f$export$fbd56eac4544ec5f(a, b, ignore) {
    if (a.type.inlineContent || b.type.inlineContent) return $1cd935bd164bf76f$var$inlineContentEqIgnoring(a.content, b.content, ignore);
    if (a.childCount !== b.childCount) return false;
    for(let i = 0; i < a.childCount; i++){
        if (!$1cd935bd164bf76f$export$88a30e5386bda853(a.child(i), b.child(i), ignore)) return false;
    }
    return true;
}
const $1cd935bd164bf76f$export$51d01ce5f35c1d = (i)=>i.kind === 'textRun';


function $1bb2f819ff5b602a$export$6edd5090aa051c73(oldNode, newNode, pos, ctx) {
    if ((0, $1cd935bd164bf76f$export$88a30e5386bda853)(oldNode, newNode, ctx.ignoreMarks)) return null;
    // ---------------------------------------------------------------------------
    // Case 1: same content, different shell (type and/or attrs+marks)
    // ---------------------------------------------------------------------------
    // Same type with different attrs is handled by AttrStep elsewhere, so this
    // pattern is meaningful only when the type itself changes.
    if (oldNode.type !== newNode.type && (0, $1cd935bd164bf76f$export$fbd56eac4544ec5f)(oldNode, newNode, ctx.ignoreMarks)) return $1bb2f819ff5b602a$var$wrapStep(/* from   */ pos, /* to     */ pos + oldNode.nodeSize, /* gapFrom*/ pos + 1, /* gapTo  */ pos + 1 + oldNode.content.size, /* shell  */ newNode.type.create(newNode.attrs, null, newNode.marks), /* insert */ 1);
    // ---------------------------------------------------------------------------
    // Case 2: wrap (newNode has a single child equal to oldNode, modulo ignored marks)
    // ---------------------------------------------------------------------------
    if (newNode.childCount === 1 && (0, $1cd935bd164bf76f$export$88a30e5386bda853)(newNode.firstChild, oldNode, ctx.ignoreMarks)) return $1bb2f819ff5b602a$var$wrapStep(/* from   */ pos, /* to     */ pos + oldNode.nodeSize, /* gapFrom*/ pos, /* gapTo  */ pos + oldNode.nodeSize, /* shell  */ newNode.type.create(newNode.attrs, null, newNode.marks), /* insert */ 1);
    // ---------------------------------------------------------------------------
    // Case 3: unwrap (oldNode has a single child equal to newNode, modulo ignored marks)
    // ---------------------------------------------------------------------------
    if (oldNode.childCount === 1 && (0, $1cd935bd164bf76f$export$88a30e5386bda853)(oldNode.firstChild, newNode, ctx.ignoreMarks)) return new (0, $eOaGc.ReplaceAroundStep)(pos, pos + oldNode.nodeSize, pos + 1, pos + 1 + newNode.nodeSize, (0, $aPdNQ.Slice).empty, 0, /* structure */ true);
    return null;
}
function $1bb2f819ff5b602a$var$wrapStep(from, to, gapFrom, gapTo, shell, insert) {
    return new (0, $eOaGc.ReplaceAroundStep)(from, to, gapFrom, gapTo, new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(shell), 0, 0), insert, /* structure */ true);
}











const $6128bbb40a9f2a1f$var$markKey = (m)=>`${m.type.name}:${(0, $1cd935bd164bf76f$export$499e45ef1aa79998)(m.attrs ?? {})}`;
const $6128bbb40a9f2a1f$export$9171f3c03db619a = (a, b)=>{
    if (a.length !== b.length) return false;
    const bKeys = new Set(b.map($6128bbb40a9f2a1f$var$markKey));
    return a.every((m)=>bKeys.has($6128bbb40a9f2a1f$var$markKey(m)));
};
/**
 * Returns marks present in `as` but not in `bs` (by type + attrs).
 */ function $6128bbb40a9f2a1f$var$subtractMarks(as, bs) {
    const bKeys = new Set(bs.map($6128bbb40a9f2a1f$var$markKey));
    return as.filter((m)=>!bKeys.has($6128bbb40a9f2a1f$var$markKey(m)));
}
function $6128bbb40a9f2a1f$export$95843026304694ba(oldSpans, newSpans) {
    const events = [];
    for (const s of oldSpans){
        events.push({
            pos: s.start,
            isStart: true,
            fromOld: true,
            marks: s.marks
        });
        events.push({
            pos: s.end,
            isStart: false,
            fromOld: true,
            marks: s.marks
        });
    }
    for (const s of newSpans){
        events.push({
            pos: s.start,
            isStart: true,
            fromOld: false,
            marks: s.marks
        });
        events.push({
            pos: s.end,
            isStart: false,
            fromOld: false,
            marks: s.marks
        });
    }
    // Sort by pos; for equal positions, OLD events first so the new state
    // takes effect for any sub-range starting at that boundary.
    events.sort((a, b)=>a.pos - b.pos || (a.fromOld === b.fromOld ? 0 : a.fromOld ? -1 : 1));
    const deltas = [];
    let curOld = [];
    let curNew = [];
    let last = 0;
    for (const ev of events){
        if (!ev.isStart && last < ev.pos) {
            for (const m of $6128bbb40a9f2a1f$var$subtractMarks(curNew, curOld))deltas.push({
                type: 'insert',
                from: last,
                to: ev.pos,
                mark: m
            });
            for (const m of $6128bbb40a9f2a1f$var$subtractMarks(curOld, curNew))deltas.push({
                type: 'delete',
                from: last,
                to: ev.pos,
                mark: m
            });
        }
        if (ev.fromOld) curOld = ev.marks;
        else curNew = ev.marks;
        last = ev.pos;
    }
    return deltas;
}
function $6128bbb40a9f2a1f$export$8c5998c7a945df3e(spans, from, to) {
    if (from >= to) return [];
    const result = [];
    for (const s of spans){
        if (s.end <= from) continue;
        if (s.start >= to) break;
        result.push({
            start: Math.max(s.start, from),
            end: Math.min(s.end, to),
            marks: s.marks
        });
    }
    return result;
}



function $408fdb1e6962a9ee$export$7f227f8ae15d3928(oldRun, newRun, parentPos, ctx) {
    const schema = ctx.schema;
    const ignore = ctx.ignoreMarks;
    const steps = [];
    if (oldRun.text.length === 0 && newRun.text.length === 0) return [];
    if (oldRun.text.length === 0) {
        const nodes = (0, $1b24bfcd447ec548$export$865f3f3e3ebbacd6)(newRun, 0, newRun.text.length, schema.text.bind(schema));
        steps.push(new (0, $eOaGc.ReplaceStep)(parentPos, parentPos, new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(nodes), 0, 0)));
        return steps;
    }
    if (newRun.text.length === 0) {
        steps.push(new (0, $eOaGc.ReplaceStep)(parentPos, parentPos + oldRun.text.length, (0, $aPdNQ.Slice).empty));
        return steps;
    }
    (0, $73c8b1fe933177ea$export$268be64a1d1b0703)(Array.from(oldRun.text), Array.from(newRun.text), (op)=>{
        switch(op.kind){
            case 'match':
                {
                    const oldClipped = $408fdb1e6962a9ee$var$filteredClipped(oldRun.spans, op.oldIndex, op.oldIndex + op.length, op.oldIndex, ignore);
                    const newClipped = $408fdb1e6962a9ee$var$filteredClipped(newRun.spans, op.newIndex, op.newIndex + op.length, op.newIndex, ignore);
                    for (const d of (0, $6128bbb40a9f2a1f$export$95843026304694ba)(oldClipped, newClipped)){
                        const from = parentPos + op.oldIndex + d.from;
                        const to = parentPos + op.oldIndex + d.to;
                        steps.push(d.type === 'insert' ? new (0, $eOaGc.AddMarkStep)(from, to, d.mark) : new (0, $eOaGc.RemoveMarkStep)(from, to, d.mark));
                    }
                    return;
                }
            case 'insert':
                {
                    const insertPos = parentPos + op.insertAt;
                    // Inherit ignored marks from the char just before the insertion point
                    // (or position 0 if we're at the start of the run).
                    const inheritFrom = Math.max(0, op.insertAt - 1);
                    const inherited = (0, $1b24bfcd447ec548$export$772de15c541bba1a)(oldRun, inheritFrom, ignore);
                    const nodes = (0, $1b24bfcd447ec548$export$865f3f3e3ebbacd6)(newRun, op.from, op.to, schema.text.bind(schema), inherited);
                    steps.push(new (0, $eOaGc.ReplaceStep)(insertPos, insertPos, new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(nodes), 0, 0)));
                    return;
                }
            case 'delete':
                steps.push(new (0, $eOaGc.ReplaceStep)(parentPos + op.from, parentPos + op.to, (0, $aPdNQ.Slice).empty));
                return;
            case 'replace':
                {
                    // Inherit ignored marks from the start of the replaced range.
                    // (Crossing an annotation boundary mid-range is an inherent
                    // ambiguity; the start-position rule keeps the typical "edit text
                    // inside one annotation" case correct.)
                    const inherited = (0, $1b24bfcd447ec548$export$772de15c541bba1a)(oldRun, op.replaceFrom, ignore);
                    const nodes = (0, $1b24bfcd447ec548$export$865f3f3e3ebbacd6)(newRun, op.from, op.to, schema.text.bind(schema), inherited);
                    steps.push(new (0, $eOaGc.ReplaceStep)(parentPos + op.replaceFrom, parentPos + op.replaceTo, new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(nodes), 0, 0)));
                    return;
                }
        }
    }, (a, b)=>a === b, ctx.maxTextRegions);
    return steps;
}
/**
 * Clips spans to `[from, to)`, normalises them to range-local coordinates
 * (subtracting `origin`), and strips marks whose type is in `ignore`. Used by
 * the Match handler so mark-delta computation runs on the visible mark set
 * only.
 */ function $408fdb1e6962a9ee$var$filteredClipped(spans, from, to, origin, ignore) {
    return (0, $6128bbb40a9f2a1f$export$8c5998c7a945df3e)(spans, from, to).map((s)=>({
            start: s.start - origin,
            end: s.end - origin,
            marks: (0, $1cd935bd164bf76f$export$8f0d278bb8862aee)(s.marks, ignore)
        }));
}



const $3656d0ee2718f52e$var$MAX_CONTENT_REGIONS = 200;
function $3656d0ee2718f52e$export$b02b9ec391dbf2d0(oldContent, newContent, parentPos, ctx) {
    const oldKids = [];
    for(let i = 0; i < oldContent.childCount; i++)oldKids.push(oldContent.child(i));
    const newKids = [];
    for(let i = 0; i < newContent.childCount; i++)newKids.push(newContent.child(i));
    const positions = $3656d0ee2718f52e$var$childPositions(parentPos, oldKids);
    const steps = [];
    (0, $73c8b1fe933177ea$export$268be64a1d1b0703)(oldKids, newKids, (op)=>{
        switch(op.kind){
            case 'match':
                {
                    let childPos = positions[op.oldIndex];
                    for(let i = 0; i < op.length; i++){
                        steps.push(...(0, $5666e4f591805d8d$export$f8dfe7066e572f15)(oldKids[op.oldIndex + i], newKids[op.newIndex + i], childPos, ctx));
                        childPos += oldKids[op.oldIndex + i].nodeSize;
                    }
                    return;
                }
            case 'insert':
                {
                    const insertPos = positions[op.insertAt];
                    const slice = $3656d0ee2718f52e$var$blockSlice(newKids.slice(op.from, op.to));
                    // structure=true on Insert is safe (the range is empty) and gives
                    // better rebase semantics: a concurrent insert at the same position
                    // won't be silently clobbered.
                    steps.push(new (0, $eOaGc.ReplaceStep)(insertPos, insertPos, slice, true));
                    return;
                }
            case 'delete':
                steps.push(new (0, $eOaGc.ReplaceStep)(positions[op.from], positions[op.to], (0, $aPdNQ.Slice).empty));
                return;
            case 'replace':
                {
                    // Single-node-to-single-node Replace ops are the only shape where a
                    // structural ReplaceAround can apply (type change preserving content,
                    // wrap, or unwrap). Try that first; fall back to a wholesale
                    // ReplaceStep for anything more complex.
                    if (op.replaceTo - op.replaceFrom === 1 && op.to - op.from === 1) {
                        const around = (0, $1bb2f819ff5b602a$export$6edd5090aa051c73)(oldKids[op.replaceFrom], newKids[op.from], positions[op.replaceFrom], ctx);
                        if (around) {
                            steps.push(around);
                            return;
                        }
                    }
                    const slice = $3656d0ee2718f52e$var$blockSlice(newKids.slice(op.from, op.to));
                    steps.push(new (0, $eOaGc.ReplaceStep)(positions[op.replaceFrom], positions[op.replaceTo], slice));
                    return;
                }
        }
    }, $3656d0ee2718f52e$var$nodesMatchable, $3656d0ee2718f52e$var$MAX_CONTENT_REGIONS, (a, b)=>(0, $1cd935bd164bf76f$export$88a30e5386bda853)(a, b, ctx.ignoreMarks));
    return steps;
}
function $3656d0ee2718f52e$export$c0c809a65b2f72dc(oldContent, newContent, parentPos, ctx) {
    const oldItems = (0, $1b24bfcd447ec548$export$c04a05f66108dc98)(oldContent);
    const newItems = (0, $1b24bfcd447ec548$export$c04a05f66108dc98)(newContent);
    const positions = $3656d0ee2718f52e$var$inlineChildPositions(parentPos, oldItems);
    const steps = [];
    (0, $73c8b1fe933177ea$export$268be64a1d1b0703)(oldItems, newItems, (op)=>{
        switch(op.kind){
            case 'match':
                {
                    let childPos = positions[op.oldIndex];
                    for(let i = 0; i < op.length; i++){
                        const a = oldItems[op.oldIndex + i];
                        const b = newItems[op.newIndex + i];
                        if ((0, $1cd935bd164bf76f$export$51d01ce5f35c1d)(a) && (0, $1cd935bd164bf76f$export$51d01ce5f35c1d)(b)) {
                            steps.push(...$3656d0ee2718f52e$var$diffTextRunPair(a, b, childPos, ctx));
                            childPos += a.text.length;
                        } else if (!(0, $1cd935bd164bf76f$export$51d01ce5f35c1d)(a) && !(0, $1cd935bd164bf76f$export$51d01ce5f35c1d)(b)) {
                            steps.push(...(0, $5666e4f591805d8d$export$f8dfe7066e572f15)(a.node, b.node, childPos, ctx));
                            childPos += a.node.nodeSize;
                        } else // Shouldn't happen if `nodesMatchable` worked correctly.
                        throw new Error('inline match between textRun and non-text node');
                    }
                    return;
                }
            case 'insert':
                {
                    const insertPos = positions[op.insertAt];
                    const nodes = $3656d0ee2718f52e$var$inlineNodesFromItems(newItems.slice(op.from, op.to), ctx);
                    steps.push(new (0, $eOaGc.ReplaceStep)(insertPos, insertPos, new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(nodes), 0, 0)));
                    return;
                }
            case 'delete':
                steps.push(new (0, $eOaGc.ReplaceStep)(positions[op.from], positions[op.to], (0, $aPdNQ.Slice).empty));
                return;
            case 'replace':
                {
                    const nodes = $3656d0ee2718f52e$var$inlineNodesFromItems(newItems.slice(op.from, op.to), ctx);
                    steps.push(new (0, $eOaGc.ReplaceStep)(positions[op.replaceFrom], positions[op.replaceTo], new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(nodes), 0, 0)));
                    return;
                }
        }
    }, $3656d0ee2718f52e$var$inlineItemsMatchable, $3656d0ee2718f52e$var$MAX_CONTENT_REGIONS, (a, b)=>$3656d0ee2718f52e$var$inlineItemsStrictEq(a, b, ctx.ignoreMarks));
    return steps;
}
/**
 * Strict equality for inline items, ignoring marks of types in `ignore`. Used
 * by the inline prefix/suffix strip so a TextRun that differs only in ignored
 * marks (e.g. an annotation present in pmBase but absent in pmNew) gets
 * stripped cheaply instead of going through the LCS path.
 */ function $3656d0ee2718f52e$var$inlineItemsStrictEq(a, b, ignore) {
    if ((0, $1cd935bd164bf76f$export$51d01ce5f35c1d)(a) && (0, $1cd935bd164bf76f$export$51d01ce5f35c1d)(b)) {
        if (a.text !== b.text) return false;
        // Per-character mark equality on the filtered mark sets. Span boundaries
        // can differ between sides without that being a real difference, so we
        // compare position-by-position rather than span-by-span.
        let ai = 0;
        let bi = 0;
        for(let p = 0; p < a.text.length; p++){
            while(ai < a.spans.length && a.spans[ai].end <= p)ai++;
            while(bi < b.spans.length && b.spans[bi].end <= p)bi++;
            const aMarks = ai < a.spans.length ? (0, $1cd935bd164bf76f$export$8f0d278bb8862aee)(a.spans[ai].marks, ignore) : [];
            const bMarks = bi < b.spans.length ? (0, $1cd935bd164bf76f$export$8f0d278bb8862aee)(b.spans[bi].marks, ignore) : [];
            if (aMarks.length !== bMarks.length) return false;
            if (!aMarks.every((m)=>bMarks.some((n)=>n.eq(m)))) return false;
        }
        return true;
    }
    if (!(0, $1cd935bd164bf76f$export$51d01ce5f35c1d)(a) && !(0, $1cd935bd164bf76f$export$51d01ce5f35c1d)(b)) return a.node.eq(b.node);
    return false;
}
function $3656d0ee2718f52e$var$diffTextRunPair(a, b, pos, ctx) {
    return (0, $408fdb1e6962a9ee$export$7f227f8ae15d3928)(a, b, pos, ctx);
}
function $3656d0ee2718f52e$var$inlineNodesFromItems(items, ctx) {
    const schema = ctx.schema;
    const out = [];
    for (const it of items)if ((0, $1cd935bd164bf76f$export$51d01ce5f35c1d)(it)) out.push(...(0, $1b24bfcd447ec548$export$865f3f3e3ebbacd6)(it, 0, it.text.length, schema.text.bind(schema)));
    else out.push(it.node);
    return out;
}
function $3656d0ee2718f52e$var$blockSlice(nodes) {
    return new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(nodes), 0, 0);
}
/**
 * "Similar enough to be a match candidate" for the block-level LCS:
 * - both nodes share the same type (attrs may differ; handled in recursion)
 * - text equality lives inside the inline path, not here
 */ function $3656d0ee2718f52e$var$nodesMatchable(a, b) {
    return a.type === b.type;
}
function $3656d0ee2718f52e$var$inlineItemsMatchable(a, b) {
    if ((0, $1cd935bd164bf76f$export$51d01ce5f35c1d)(a) && (0, $1cd935bd164bf76f$export$51d01ce5f35c1d)(b)) return true;
    if (!(0, $1cd935bd164bf76f$export$51d01ce5f35c1d)(a) && !(0, $1cd935bd164bf76f$export$51d01ce5f35c1d)(b)) return a.node.type === b.node.type;
    return false;
}
function $3656d0ee2718f52e$var$childPositions(parentPos, kids) {
    const out = new Array(kids.length + 1);
    out[0] = parentPos + 1;
    for(let i = 0; i < kids.length; i++)out[i + 1] = out[i] + kids[i].nodeSize;
    return out;
}
function $3656d0ee2718f52e$var$inlineChildPositions(parentPos, items) {
    const out = new Array(items.length + 1);
    out[0] = parentPos + 1;
    for(let i = 0; i < items.length; i++){
        const size = (0, $1cd935bd164bf76f$export$51d01ce5f35c1d)(items[i]) ? items[i].text.length : items[i].node.nodeSize;
        out[i + 1] = out[i] + size;
    }
    return out;
}




function $5666e4f591805d8d$export$f8dfe7066e572f15(oldNode, newNode, pos, ctx) {
    if ((0, $1cd935bd164bf76f$export$88a30e5386bda853)(oldNode, newNode, ctx.ignoreMarks)) return [];
    // Text vs text: handled by the inline diff path normally, but if we get here
    // (e.g. a doc whose top-level child IS a text node, unusual but possible in
    // custom schemas) just produce a Replace.
    if (oldNode.isText && newNode.isText) {
        if (oldNode.text === newNode.text) // Same text, different marks - emit mark deltas via add/remove.
        return $5666e4f591805d8d$var$markDeltaSteps(oldNode.marks, newNode.marks, pos, pos + oldNode.nodeSize, /*isInline*/ true, ctx);
        return [
            new (0, $eOaGc.ReplaceStep)(pos, pos + oldNode.nodeSize, new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(newNode), 0, 0))
        ];
    }
    if (oldNode.type !== newNode.type) {
        // Type change → replace the whole node. structure=false because the range
        // contains real content (the old node's body); structure=true would reject.
        if (pos < 0) throw new Error('diffNodes: root doc node type mismatch');
        return [
            new (0, $eOaGc.ReplaceStep)(pos, pos + oldNode.nodeSize, new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(newNode), 0, 0))
        ];
    }
    // Same block type. Three orthogonal concerns:
    //   1. attrs   → AttrStep(s) on this node
    //   2. content → recurse (inline vs block path)
    //   3. marks   → AddNodeMark/RemoveNodeMark on this node
    const steps = [];
    if (pos >= 0) steps.push(...$5666e4f591805d8d$var$attrSteps(oldNode, newNode, pos));
    if (oldNode.type.inlineContent) steps.push(...(0, $3656d0ee2718f52e$export$c0c809a65b2f72dc)(oldNode.content, newNode.content, pos, ctx));
    else steps.push(...(0, $3656d0ee2718f52e$export$b02b9ec391dbf2d0)(oldNode.content, newNode.content, pos, ctx));
    if (pos >= 0) steps.push(...$5666e4f591805d8d$var$nodeMarkDeltaSteps(oldNode.marks, newNode.marks, pos, ctx));
    return steps;
}
function $5666e4f591805d8d$var$attrSteps(oldNode, newNode, pos) {
    const oldAttrs = oldNode.attrs ?? {};
    const newAttrs = newNode.attrs ?? {};
    const changed = [];
    const keys = new Set([
        ...Object.keys(oldAttrs),
        ...Object.keys(newAttrs)
    ]);
    for (const k of keys)if (!$5666e4f591805d8d$var$compareDeep(oldAttrs[k], newAttrs[k])) changed.push([
        k,
        newAttrs[k] ?? null
    ]);
    return changed.map(([k, v])=>new (0, $eOaGc.AttrStep)(pos, k, v));
}
// Mirrors prosemirror-model's compareDeep helper used for attribute equality.
function $5666e4f591805d8d$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a === 'object') || !(b && typeof b === 'object')) return false;
    const isArray = Array.isArray(a);
    if (Array.isArray(b) !== isArray) return false;
    if (isArray) {
        const aArray = a;
        const bArray = b;
        if (aArray.length !== bArray.length) return false;
        for(let i = 0; i < aArray.length; i++){
            if (!$5666e4f591805d8d$var$compareDeep(aArray[i], bArray[i])) return false;
        }
    } else {
        const aObject = a;
        const bObject = b;
        for(const prop in aObject){
            if (!(prop in bObject) || !$5666e4f591805d8d$var$compareDeep(aObject[prop], bObject[prop])) return false;
        }
        for(const prop in bObject){
            if (!(prop in aObject)) return false;
        }
    }
    return true;
}
function $5666e4f591805d8d$var$nodeMarkDeltaSteps(oldMarks, newMarks, pos, ctx) {
    const oldM = (0, $1cd935bd164bf76f$export$8f0d278bb8862aee)(oldMarks, ctx.ignoreMarks);
    const newM = (0, $1cd935bd164bf76f$export$8f0d278bb8862aee)(newMarks, ctx.ignoreMarks);
    if ((0, $6128bbb40a9f2a1f$export$9171f3c03db619a)(oldM, newM)) return [];
    const steps = [];
    for (const m of newM)if (!oldM.some((om)=>om.eq(m))) steps.push(new (0, $eOaGc.AddNodeMarkStep)(pos, m));
    for (const m of oldM)if (!newM.some((nm)=>nm.eq(m))) steps.push(new (0, $eOaGc.RemoveNodeMarkStep)(pos, m));
    return steps;
}
function $5666e4f591805d8d$var$markDeltaSteps(oldMarks, newMarks, from, to, isInline, ctx) {
    const oldM = (0, $1cd935bd164bf76f$export$8f0d278bb8862aee)(oldMarks, ctx.ignoreMarks);
    const newM = (0, $1cd935bd164bf76f$export$8f0d278bb8862aee)(newMarks, ctx.ignoreMarks);
    if ((0, $6128bbb40a9f2a1f$export$9171f3c03db619a)(oldM, newM)) return [];
    const steps = [];
    for (const m of newM)if (!oldM.some((om)=>om.eq(m))) steps.push(isInline ? new (0, $eOaGc.AddMarkStep)(from, to, m) : new (0, $eOaGc.AddNodeMarkStep)(from, m));
    for (const m of oldM)if (!newM.some((nm)=>nm.eq(m))) steps.push(isInline ? new (0, $eOaGc.RemoveMarkStep)(from, to, m) : new (0, $eOaGc.RemoveNodeMarkStep)(from, m));
    return steps;
}








function $d9e579ca8433f3c0$var$isStructural(step) {
    return step.structure === true;
}
function $d9e579ca8433f3c0$export$4a231d1a3b7e81fc(steps) {
    if (steps.length === 0) return [];
    const out = [
        steps[0]
    ];
    for(let i = 1; i < steps.length; i++){
        const next = steps[i];
        const last = out[out.length - 1];
        if (last instanceof (0, $eOaGc.ReplaceStep) && next instanceof (0, $eOaGc.ReplaceStep) && !$d9e579ca8433f3c0$var$isStructural(last) && !$d9e579ca8433f3c0$var$isStructural(next) && last.to === next.from && // All four opens must be 0: the merged slice is built `Slice(_, 0, 0)`,
        // so a non-zero open on either side would either misclaim the outer
        // opens or reinterpret an open-at-junction node as complete.
        last.slice.openStart === 0 && last.slice.openEnd === 0 && next.slice.openStart === 0 && next.slice.openEnd === 0) {
            out[out.length - 1] = new (0, $eOaGc.ReplaceStep)(last.from, next.to, $d9e579ca8433f3c0$var$mergeSlices(last.slice, next.slice));
            continue;
        }
        if (last instanceof (0, $eOaGc.AddMarkStep) && next instanceof (0, $eOaGc.AddMarkStep) && last.mark.eq(next.mark) && last.from <= next.to && last.to >= next.from) {
            out[out.length - 1] = new (0, $eOaGc.AddMarkStep)(Math.min(last.from, next.from), Math.max(last.to, next.to), next.mark);
            continue;
        }
        if (last instanceof (0, $eOaGc.RemoveMarkStep) && next instanceof (0, $eOaGc.RemoveMarkStep) && last.mark.eq(next.mark) && last.from <= next.to && last.to >= next.from) {
            out[out.length - 1] = new (0, $eOaGc.RemoveMarkStep)(Math.min(last.from, next.from), Math.max(last.to, next.to), next.mark);
            continue;
        }
        out.push(next);
    }
    return out;
}
function $d9e579ca8433f3c0$var$mergeSlices(a, b) {
    const aContent = a.content;
    const bContent = b.content;
    if (aContent.size === 0) return new (0, $aPdNQ.Slice)(bContent, 0, 0);
    if (bContent.size === 0) return new (0, $aPdNQ.Slice)(aContent, 0, 0);
    const aLast = aContent.child(aContent.childCount - 1);
    const bFirst = bContent.child(0);
    if (aLast.isText && bFirst.isText && $d9e579ca8433f3c0$var$sameMarkSet(aLast.marks, bFirst.marks)) {
        const merged = aLast.type.schema.text((aLast.text ?? '') + (bFirst.text ?? ''), aLast.marks);
        const aHead = (0, $aPdNQ.Fragment).from($d9e579ca8433f3c0$var$takeAll(aContent, aContent.childCount - 1));
        const bTail = (0, $aPdNQ.Fragment).from($d9e579ca8433f3c0$var$takeAllFrom(bContent, 1));
        return new (0, $aPdNQ.Slice)(aHead.append((0, $aPdNQ.Fragment).from(merged)).append(bTail), 0, 0);
    }
    return new (0, $aPdNQ.Slice)(aContent.append(bContent), 0, 0);
}
function $d9e579ca8433f3c0$var$sameMarkSet(a, b) {
    if (a.length !== b.length) return false;
    return a.every((m)=>b.some((n)=>n.eq(m)));
}
function $d9e579ca8433f3c0$var$takeAll(frag, n) {
    const out = [];
    for(let i = 0; i < n; i++)out.push(frag.child(i));
    return out;
}
function $d9e579ca8433f3c0$var$takeAllFrom(frag, start) {
    const out = [];
    for(let i = start; i < frag.childCount; i++)out.push(frag.child(i));
    return out;
}



const $9621857a1a4fd633$var$DEFAULT_MAX_TEXT_REGIONS = 10;
function $9621857a1a4fd633$var$makeContext(schema, opts) {
    return {
        schema: schema,
        ignoreMarks: new Set(opts?.ignoreMarkTypes ?? []),
        maxTextRegions: opts?.maxTextRegions ?? $9621857a1a4fd633$var$DEFAULT_MAX_TEXT_REGIONS
    };
}
function $9621857a1a4fd633$export$96d86b1e79ab6058(oldDoc, newDoc, opts) {
    if (oldDoc.type.schema !== newDoc.type.schema) throw new Error('diffNodes: schemas differ between old and new doc');
    const ctx = $9621857a1a4fd633$var$makeContext(oldDoc.type.schema, opts);
    if ((0, $1cd935bd164bf76f$export$88a30e5386bda853)(oldDoc, newDoc, ctx.ignoreMarks)) return [];
    return (0, $d9e579ca8433f3c0$export$4a231d1a3b7e81fc)((0, $5666e4f591805d8d$export$f8dfe7066e572f15)(oldDoc, newDoc, -1, ctx));
}


const $68b04ed0ed4951fc$export$372e47604067462f = 'mdMode$ownWriteback';
/*
	The localId attribute is not produced from the markdown source as it has no concept of localIds.
	This can cause steps to be generated setting the localId attr on existing nodes to null.
	We suppress these as we rarely (if ever) want to actually remove or edit localIds of nodes during
	md -> adf reconciliation.
	This prevents unnecessary round-trips and makes markdown editing more stable.
 */ const $68b04ed0ed4951fc$var$shouldIgnoreLocalIdAttrStep = (step)=>step instanceof (0, $eOaGc.AttrStep) && step.attr === 'localId';
const $68b04ed0ed4951fc$export$c0dd7bd7f3654863 = (editorView, seedDoc, newAdfNode, interveningMapping, opts)=>{
    if (editorView.isDestroyed) return null;
    const steps = (0, $9621857a1a4fd633$export$96d86b1e79ab6058)(seedDoc, newAdfNode, opts).filter((step)=>!$68b04ed0ed4951fc$var$shouldIgnoreLocalIdAttrStep(step));
    if (steps.length === 0) return null;
    const tr = editorView.state.tr;
    for (const step of steps){
        const rebased = step.map(interveningMapping);
        if (!rebased) throw new Error('applyDiffSteps: step did not survive rebase');
        const mapped = rebased.map(tr.mapping);
        if (!mapped) throw new Error('applyDiffSteps: step could not be mapped');
        tr.step(mapped);
    }
    tr.setMeta('addToHistory', false);
    tr.setMeta($68b04ed0ed4951fc$export$372e47604067462f, true);
    editorView.dispatch(tr);
    return tr;
};








/**
 * Wire contract for the markdown-mode sync tracer.
 *
 * This file is the **single source of truth** for the trace event schema
 * described in `docs/devtools-tracing-design.md` §3. Both the producer (the
 * in-plugin tracer + instrumentation) and any consumer (Layer 1 console API,
 * Layer 2 in-app panel, Layer 3 external devtools client) import these types
 * so they cannot drift.
 *
 * ## Wire format
 *
 * Every event is **plain JSON** — it survives `structuredClone` /
 * `postMessage` / `JSON.stringify` losslessly. The `DocNode` and serialized
 * `Step[]` fields are already-serialized JSON, never live ProseMirror class
 * instances. This is what lets a Chrome DevTools
 * extension (a separate context, possibly a separate repo) consume the same
 * events the in-page console API sees.
 *
 * ## Portability note (for an out-of-AFM consumer, e.g. a Chrome extension)
 *
 * The imported types below are **type-only** and describe JSON shapes:
 *   - `DocNode` — ADF document JSON (`@atlaskit/adf-schema`)
 * A consumer outside the monorepo can either install that typing or vendor a
 * copy of this file and replace the import with a structural equivalent
 * (`unknown` / `Record<string, unknown>`). The runtime payloads are identical
 * either way.
 */ const $7337a1f3682a2eb7$export$da2ddd70869a7031 = 'atl-md-mode-tracer';
const $7337a1f3682a2eb7$export$435e830eb7c6eb9c = 'atl-md-mode-tracer-client';


var $5e1679443117df1d$var$_MarkdownModeTracer;
const $5e1679443117df1d$var$hasUrlEnableFlag = ()=>{
    if (typeof window === 'undefined') return false;
    try {
        return new URLSearchParams(window.location.search).get('mdModeTracer') === '1';
    } catch  {
        return false;
    }
};
class $5e1679443117df1d$export$de8e565f923f53f9 {
    /**
   * Returns the singleton if the gate is on, else `null`. On first creation it
   * attaches the console API to `window.__markdownModeDebugger__` and installs
   * the postMessage subscribe listener.
   */ static getInstance() {
        if (!(0, $iDrrr.fg)('platform_editor_md_mode_tracer')) {
            // Gate evaluated off. If an instance was created earlier in this session
            // (gate on, then flipped off via a Statsig refresh / bucket change), tear
            // it down so the console API, the message listener, the live subscribers,
            // and any retained doc payloads don't outlive the master switch.
            if ($5e1679443117df1d$export$de8e565f923f53f9.instance) $5e1679443117df1d$export$de8e565f923f53f9.teardown();
            return null;
        }
        if (!$5e1679443117df1d$export$de8e565f923f53f9.instance) {
            $5e1679443117df1d$export$de8e565f923f53f9.instance = new $5e1679443117df1d$export$de8e565f923f53f9();
            $5e1679443117df1d$export$de8e565f923f53f9.instance.attachToWindow();
            $5e1679443117df1d$export$de8e565f923f53f9.instance.installMessageListener();
        }
        return $5e1679443117df1d$export$de8e565f923f53f9.instance;
    }
    /**
   * Opens a bound trace session for one top-level action. Returns `undefined`
   * when the gate is off or recording is disabled, so a callsite's `trace?.`
   * cheaply skips all instrumentation (no payload is ever built). This is the
   * entry point instrumentation should use — it bundles `getInstance()` +
   * `beginTrace()` and removes the need to thread both the tracer and the
   * `TraceContext` through every record call.
   */ static begin(trigger) {
        const tracer = $5e1679443117df1d$export$de8e565f923f53f9.getInstance();
        const ctx = tracer?.beginTrace(trigger);
        if (!tracer || !ctx) return undefined;
        return {
            id: ctx.id,
            sync: (build)=>tracer.recordSync(ctx, build)
        };
    }
    // --- Recording switch ---
    isEnabled() {
        return this.enabled;
    }
    enable() {
        this.enabled = true;
        // An explicit enable is sticky: don't let a later unsubscribe turn it off.
        this.autoEnabledForSubscribers = false;
    }
    disable() {
        this.enabled = false;
        this.autoEnabledForSubscribers = false;
    }
    /**
   * Opens a trace context for one top-level action. Returns `undefined` when
   * recording is disabled so callers cheaply skip all instrumentation.
   */ beginTrace(trigger) {
        if (!this.enabled) return undefined;
        return {
            id: `md-${++this.idCounter}`,
            trigger: trigger
        };
    }
    // --- Recording API (thunk form keeps zero cost when disabled) ---
    /** Record a sync decision. `build` is invoked only when recording is enabled. */ recordSync(ctx, build) {
        if (!this.enabled) return;
        // Observe-only: never let a builder/serialization/store failure escape into
        // the writeback path (a throw here would otherwise be caught by a caller's
        // catch and misread as a parse/rebase failure — see the conversion helpers).
        try {
            const input = build();
            const event = {
                kind: 'sync',
                id: ctx.id,
                trigger: ctx.trigger,
                ts: Date.now(),
                ...input,
                gates: input.gates ?? $5e1679443117df1d$export$de8e565f923f53f9.snapshotGates()
            };
            this.push(event);
        } catch  {
        // Swallow — a tracer bug must not change editor behaviour.
        }
    }
    /**
   * Snapshot the gates whose state is interesting when interpreting a sync
   * decision. `fg()` must be called with a string literal (the
   * static-feature-flags lint rule statically extracts flag keys), so each gate
   * is read explicitly rather than looped. `fg` can throw when a gate isn't
   * registered in this context, so each read is guarded and simply omitted.
   */ static snapshotGates() {
        const gates = {};
        const add = (key, read)=>{
            try {
                gates[key] = read();
            } catch  {
            // Gate not registered in this context — leave it out of the snapshot.
            }
        };
        add('platform_editor_md_source_sync_snapshot', ()=>(0, $iDrrr.fg)('platform_editor_md_source_sync_snapshot'));
        add('platform_editor_markdown_compatible_toolbar', ()=>(0, $iDrrr.fg)('platform_editor_markdown_compatible_toolbar'));
        add('platform_editor_md_mode_rebase_fallback', ()=>(0, $iDrrr.fg)('platform_editor_md_mode_rebase_fallback'));
        add('platform_editor_md_mode_tracer', ()=>(0, $iDrrr.fg)('platform_editor_md_mode_tracer'));
        return gates;
    }
    push(event) {
        this.evictExpired();
        this.events.push(event);
        if (this.events.length > this.maxEvents) this.events.splice(0, this.events.length - this.maxEvents);
        this.emit(event, 'event');
    }
    evictExpired() {
        const now = Date.now();
        const cutoff = now - this.maxAgeMsec;
        // Events are pushed in time order, so drop the expired prefix.
        let firstLive = 0;
        while(firstLive < this.events.length && this.events[firstLive].ts < cutoff)firstLive++;
        if (firstLive > 0) this.events.splice(0, firstLive);
    }
    // --- Query API (exposed on window) ---
    getEvents(filter) {
        this.evictExpired();
        let result = this.events.slice();
        if (filter?.kind) result = result.filter((e)=>e.kind === filter.kind);
        if (filter?.trigger) result = result.filter((e)=>e.trigger === filter.trigger);
        if (filter?.id) result = result.filter((e)=>e.id === filter.id);
        if (filter?.decision) result = result.filter((e)=>e.kind === 'sync' && e.decision === filter.decision);
        return result;
    }
    getLastSync() {
        this.evictExpired();
        for(let i = this.events.length - 1; i >= 0; i--){
            const event = this.events[i];
            if (event.kind === 'sync') return event;
        }
        return undefined;
    }
    getTrace(id) {
        this.evictExpired();
        return this.events.filter((e)=>e.id === id);
    }
    clear() {
        this.events = [];
    }
    /**
   * Registers the active orchestrator's round-trip implementation (which holds
   * the editor schema). `roundTrip()` delegates to it.
   */ registerProbe(probe) {
        this.probe = probe;
    }
    roundTrip(input) {
        if (!this.probe) return {
            error: 'No editor registered. Open markdown mode in an editor first.'
        };
        try {
            return this.probe(input);
        } catch (err) {
            // The probe runs `markdownToAdf`, a "throws on parse error" boundary, so
            // malformed input would otherwise escape the console API as an uncaught
            // throw. Surface it as a structured result, matching the no-probe branch.
            return {
                error: err instanceof Error ? err.message : String(err)
            };
        }
    }
    // --- Layer 3 postMessage bridge (see design doc §5) ---
    installMessageListener() {
        if (typeof window === 'undefined' || this.unbindMessageListener) return;
        const messageListener = (event)=>{
            if (event.origin !== window.location.origin) return;
            const data = event.data;
            if (!data || data.source !== (0, $7337a1f3682a2eb7$export$435e830eb7c6eb9c)) return;
            const source = event.source;
            if (!source) return;
            if (data.type === 'subscribe') {
                const isNewSubscriber = !this.subscribers.has(source);
                this.subscribers.add(source);
                // Opening a devtools client is itself an explicit opt-in, so turn
                // recording on if it isn't already. We remember that we did so in
                // order to restore the prior state when the last client leaves.
                if (!this.enabled) {
                    this.enabled = true;
                    this.autoEnabledForSubscribers = true;
                }
                // Replay the current buffer only to a genuinely new subscriber. The
                // handshake (see design §6) tells an early-loading client to
                // re-subscribe on the `online` ping, so a duplicate `subscribe` from
                // an already-registered window must not replay the buffer twice.
                if (isNewSubscriber) for (const buffered of this.events)this.postTo(source, buffered, 'replay');
            } else if (data.type === 'unsubscribe') {
                this.subscribers.delete(source);
                this.restoreEnabledIfNoSubscribers();
            }
        };
        this.unbindMessageListener = (0, $cbY7C.bind)(window, {
            type: 'message',
            listener: messageListener
        });
        // Announce that the tracer is now listening. A client that loaded before
        // the editor mounted (e.g. a content script injected at document_start)
        // will have sent its `subscribe` into the void; this prompts it to retry.
        this.announceOnline();
    }
    /** Broadcast a one-shot `online` ping so early-loading clients re-subscribe. */ announceOnline() {
        if (typeof window === 'undefined') return;
        const message = {
            source: (0, $7337a1f3682a2eb7$export$da2ddd70869a7031),
            type: 'online'
        };
        try {
            window.postMessage(message, window.location.origin);
        } catch  {
        // Ignore postMessage failures (e.g. opaque origin).
        }
    }
    /**
   * When the last subscriber disconnects, undo a subscribe-driven auto-enable so
   * recording returns to its default-off state once nothing is watching. A
   * manual `enable()` clears the auto flag, so this never overrides the user.
   */ restoreEnabledIfNoSubscribers() {
        if (this.subscribers.size === 0 && this.autoEnabledForSubscribers) {
            this.enabled = false;
            this.autoEnabledForSubscribers = false;
        }
    }
    emit(event, type) {
        if (this.subscribers.size === 0) return;
        // Iterate a snapshot: a failed `postTo` deletes the dead subscriber from the
        // live Set (and may flip the recording switch off) mid-broadcast, so we must
        // not mutate the Set we are iterating.
        for (const subscriber of [
            ...this.subscribers
        ])this.postTo(subscriber, event, type);
    }
    postTo(subscriber, event, type) {
        const message = {
            source: (0, $7337a1f3682a2eb7$export$da2ddd70869a7031),
            type: type,
            event: event
        };
        try {
            subscriber.postMessage(message, window.location.origin);
        } catch  {
            // Subscriber gone / cross-origin — drop it.
            this.subscribers.delete(subscriber);
            this.restoreEnabledIfNoSubscribers();
        }
    }
    attachToWindow() {
        if (typeof window === 'undefined') return;
        try {
            window.__markdownModeDebugger__ = {
                getEvents: (filter)=>this.getEvents(filter),
                getLastSync: ()=>this.getLastSync(),
                getTrace: (id)=>this.getTrace(id),
                roundTrip: (input)=>this.roundTrip(input),
                enable: ()=>this.enable(),
                disable: ()=>this.disable(),
                isEnabled: ()=>this.isEnabled(),
                clear: ()=>this.clear()
            };
        } catch  {
        // Ignore window access errors.
        }
    }
    /**
   * Fully dismantles the singleton: unbinds the message listener, drops all
   * subscribers, clears the buffer and recording flags, removes the `window`
   * global, and nulls the instance. Used both when the gate flips off after
   * creation and by `resetForTesting`, so neither leaves the bridge live.
   */ static teardown() {
        const instance = $5e1679443117df1d$export$de8e565f923f53f9.instance;
        if (instance) {
            instance.unbindMessageListener?.();
            instance.unbindMessageListener = null;
            instance.subscribers.clear();
            instance.probe = null;
            instance.events = [];
            instance.enabled = false;
            instance.autoEnabledForSubscribers = false;
        }
        if (typeof window !== 'undefined') window.__markdownModeDebugger__ = undefined;
        $5e1679443117df1d$export$de8e565f923f53f9.instance = null;
    }
    /**
   * Resets the singleton. Test-only.
   * @internal
   */ static resetForTesting() {
        $5e1679443117df1d$export$de8e565f923f53f9.teardown();
    }
    constructor(maxEvents = 200, maxAgeMsec = 1800000){
        this.events = [];
        this.idCounter = 0;
        this.enabled = void 0;
        /**
     * True when recording was switched on *because* a devtools client subscribed
     * (rather than via the URL flag or a manual `enable()`). We restore the prior
     * state when the last subscriber leaves, so the default-off privacy posture
     * returns once nothing is watching.
     */ this.autoEnabledForSubscribers = false;
        this.probe = null;
        this.subscribers = new Set();
        this.unbindMessageListener = null;
        /** Maximum number of events retained. */ this.maxEvents = void 0;
        /** Maximum age of an event in milliseconds before eviction. */ this.maxAgeMsec = void 0;
        this.maxEvents = maxEvents;
        this.maxAgeMsec = maxAgeMsec;
        this.enabled = $5e1679443117df1d$var$hasUrlEnableFlag();
    }
}
$5e1679443117df1d$var$_MarkdownModeTracer = $5e1679443117df1d$export$de8e565f923f53f9;
$5e1679443117df1d$export$de8e565f923f53f9.instance = null;


/**
 * Confluence appends a trailing empty paragraph to the live PM doc for cursor
 * placement; mdast strips trailing blank lines on round-trip, so without
 * padding the diff emits a wholesale delete of that paragraph on every
 * writeback. Cosmetic non-collab; collides with concurrent end-of-doc appends
 * under collab.
 */ 


const $51eaa0d358e75b0f$var$isEmptyParagraph = (node)=>!!node && node.type.name === 'paragraph' && node.childCount === 0;
const $51eaa0d358e75b0f$export$cecc4bbbdf07f0bc = (oldDoc, newDoc)=>{
    if (!$51eaa0d358e75b0f$var$isEmptyParagraph(oldDoc.lastChild)) return newDoc;
    if ($51eaa0d358e75b0f$var$isEmptyParagraph(newDoc.lastChild)) return newDoc;
    const paragraphType = newDoc.type.schema.nodes.paragraph;
    if (!paragraphType) return newDoc;
    return newDoc.copy(newDoc.content.append((0, $aPdNQ.Fragment).from(paragraphType.create())));
};


/* MarkdownSourceView.tsx generated by @compiled/babel-plugin v3.0.1 */ /**
 * MarkdownSourceView — markdown source editor for Confluence Live Docs in
 * Markdown Mode.
 *
 * Behaviour:
 *  - On mount, convert the live ProseMirror document (`initialAdfDoc`) to
 *    markdown via `@atlassian/mdast-util-from-pm` and seed a CodeMirror 6 editor
 *    with it.
 *  - User edits live in the CodeMirror EditorState; we do NOT push them back
 *    into the ProseMirror editor on every keystroke (too expensive and would
 *    fight the collab provider).
 *  - On unmount (i.e. when the user switches back to WYSIWYG / preview), we
 *    read the editor's current doc, validate it parses back to ADF via
 *    `@atlassian/mdast-util-to-pm`, and hand the markdown string
 *    off to the parent through `onMarkdownCommit`. The parent is responsible
 *    for applying it to the editor.
 *  - If the user did NOT actually edit the markdown buffer
 *    (`finalMarkdown === initialMarkdown`), we skip the commit entirely.
 *    This avoids a lossy ADF→markdown→ADF round-trip on every no-op visit
 *    to source view, which would otherwise reset collab cursors and undo
 *    history and could subtly mutate the doc (the markdown round-trip is
 *    not a strict identity).
 *  - If the markdown can't be parsed we `console.warn` and discard the change
 *    rather than crashing the editor. A user-facing surface for lossy
 *    round-trips is deferred — see TODO below.
 *
 * Re-seeding: callers may pass a `revision` prop. CodeMirror is destroyed
 * and re-mounted whenever `revision` changes, so the parent can force a
 * fresh seed (e.g. when re-entering source view with a new ADF snapshot).
 * The component is a single React tree across re-seeds — only the inner
 * CodeMirror state is recreated.
 *
 * The component intentionally takes a stable, narrow prop interface so other
 * agents (BRAVO's preview view + LivePageComponent plumbing, CHARLIE's tests)
 * can rely on it. Do not change the shape of `MarkdownSourceViewProps` without
 * coordinating with those agents.
 *
 * TODO(EDITOR-6558-source): surface lossy round-trips to the user (flag /
 * inline warning) instead of silently warning to the console.
 *
 * Ticket: https://hello.jira.atlassian.cloud/browse/EDITOR-6558
 * Parent epic: https://hello.jira.atlassian.cloud/browse/EDITOR-6490
 */ 






var $hekY6 = parcelRequire("hekY6");


var $7nRDp = parcelRequire("7nRDp");








var $725xj = parcelRequire("725xj");





var $3e6dc = parcelRequire("3e6dc");


var $kSwu1 = parcelRequire("kSwu1");


var $2VjJa = parcelRequire("2VjJa");





var $IQ4Dz = parcelRequire("IQ4Dz");





// Unclosed link — `[text` without a following `](` on the same line.
const $b5c8870ce01fabc3$var$UNCLOSED_LINK_REGEX = /\[[^\]]*$/u;
// Strip leading list-item marker: unordered (* / - / +) or ordered (N.) followed by at least one space.
const $b5c8870ce01fabc3$var$LIST_PREFIX_REGEX = /^(\s*(?:[*+\-]|\d+\.)\s+)/u;
// Fence delimiter lines.
const $b5c8870ce01fabc3$var$FENCE_DELIMITER_REGEX = /^```/u;
// Thematic break lines (e.g. `***`, `* * *`, `---`, `___`) are block-level syntax.
// Spec: three or more `*`, `-`, or `_`, optionally separated by spaces, with nothing else on the line.
const $b5c8870ce01fabc3$var$THEMATIC_BREAK_REGEX = /^\s{0,3}((\*[ \t]*){3,}|([ \t]*-){3,}|(_[ \t]*){3,})\s*$/u;
/**
 * Returns true if the given pre-processed line (escape sequences and balanced
 * inline code spans already stripped) has unbalanced markdown inline syntax —
 * e.g. the user has typed `*ital` but not yet the closing `*`.
 *
 * Tokens checked (all require balanced pairs on the same line):
 *   - `` ` `` (inline code) — odd count of backticks
 *   - `*` / `**` / `***` (em / strong / bold-italic) — odd count per run-length
 *   - `[` without a matching `](` later on the line (link syntax)
 */ function $b5c8870ce01fabc3$var$lineHasUnbalancedInlineSyntax(strippedLine) {
    // Odd backtick count → unclosed inline code span.
    const backtickCount = (strippedLine.match(/`/gu) ?? []).length;
    if (backtickCount % 2 !== 0) return true;
    // Each distinct asterisk run-length must appear an even number of times.
    // e.g. `**bol` has one `**` token → odd → unbalanced.
    const asteriskRuns = strippedLine.match(/\*+/gu) ?? [];
    const runCounts = new Map();
    for (const run of asteriskRuns){
        const len = run.length;
        runCounts.set(len, (runCounts.get(len) ?? 0) + 1);
    }
    for (const count of runCounts.values()){
        if (count % 2 !== 0) return true;
    }
    // Unclosed link — `[text` without a following `](` on the same line.
    if ($b5c8870ce01fabc3$var$UNCLOSED_LINK_REGEX.test(strippedLine)) return true;
    return false;
}
/**
 * Pre-processes a line for syntax balance checking: strips escape sequences,
 * balanced inline code spans, and leading list-item markers so they don't
 * skew token counts.
 *
 * List-item prefixes (`* `, `- `, `+ `, or `1. ` / `123. `) begin with a
 * `*` or `-` / `+` that is structural (a block-level marker), not inline
 * emphasis syntax. Stripping them before the asterisk-balance check prevents
 * false positives on every bullet-list line.
 */ function $b5c8870ce01fabc3$var$stripLineForBalanceCheck(line) {
    // Strip leading list-item marker: unordered (* / - / +) or ordered (N.)
    // followed by at least one space.
    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- one replace per line, unavoidable
    const withoutListPrefix = line.replace($b5c8870ce01fabc3$var$LIST_PREFIX_REGEX, '');
    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- one replace per line, unavoidable
    return withoutListPrefix.replace(/\\.|`[^`]*`/gu, '');
}
function $b5c8870ce01fabc3$export$cf49bba3d053a321(markdown, cursorPos) {
    // Strip escape sequences first so `\`` doesn't interfere with fence detection.
    const unescaped = markdown.replace(/\\./gu, '');
    // --- Global check: unclosed fenced code block ---
    // Strip complete balanced fenced blocks (``` ... ```) so their content is
    // not counted. An odd number of remaining ``` markers means there is an
    // unclosed fence somewhere in the document.
    const withoutFences = unescaped.replace(RegExp("^```.*?^```", "gmsu"), '');
    const fenceCount = (withoutFences.match(/^```/gmu) ?? []).length;
    if (fenceCount % 2 !== 0) return true;
    // --- Per-line check: inline syntax on the cursor's line only ---
    // Find the line boundaries from the raw markdown (before escape-stripping)
    // so that cursorPos maps correctly to character offsets.
    const lineStart = markdown.lastIndexOf('\n', cursorPos - 1) + 1;
    const lineEndRaw = markdown.indexOf('\n', cursorPos);
    const lineEnd = lineEndRaw === -1 ? markdown.length : lineEndRaw;
    const currentLine = markdown.slice(lineStart, lineEnd);
    // Fence delimiter lines (``` ...) are not inline syntax — skip the check.
    if ($b5c8870ce01fabc3$var$FENCE_DELIMITER_REGEX.test(currentLine)) return false;
    // Thematic break lines (e.g. `***`, `* * *`, `---`, `___`) are block-level
    // syntax, not inline emphasis. A `***` line would otherwise be counted as
    // three unbalanced asterisks of length 1. Detect and skip.
    // Spec: three or more `*`, `-`, or `_`, optionally separated by spaces,
    // with nothing else on the line (except leading/trailing spaces).
    if ($b5c8870ce01fabc3$var$THEMATIC_BREAK_REGEX.test(currentLine)) return false;
    // If the cursor is inside a balanced fence block, the line is code content
    // not markdown syntax — skip the inline check.
    // We detect this by checking whether cursorPos falls within a stripped region.
    // Simple heuristic: count ``` markers before the cursor line in the unescaped
    // string; if the count is odd, we're inside a fence.
    const beforeCursor = unescaped.slice(0, lineStart);
    const fencesBeforeCursor = (beforeCursor.match(/^```/gmu) ?? []).length;
    if (fencesBeforeCursor % 2 !== 0) return false;
    return $b5c8870ce01fabc3$var$lineHasUnbalancedInlineSyntax($b5c8870ce01fabc3$var$stripLineForBalanceCheck(currentLine));
}


/**
 * Text-level diff helpers for the source view's non-clobbering live-refresh
 * path. Pure functions returning CM6-shaped `{from, to, insert}` ops; the
 * source view dispatches them via `view.dispatch({ changes })`.
 */ 
var $28Zil = parcelRequire("28Zil");

const $221c70a2c73ffadc$export$294aa3c46d6af4a5 = (oldText, newText)=>{
    const hunks = [];
    for (const [from, to, insert] of (0, $28Zil.calcPatch)(oldText, newText))hunks.push({
        from: from,
        to: to,
        insert: insert
    });
    return hunks;
};
const $221c70a2c73ffadc$export$e291136b00c395d = (seed, buffer, next)=>{
    const remoteHunks = $221c70a2c73ffadc$export$294aa3c46d6af4a5(seed, next);
    if (remoteHunks.length === 0) return [];
    const userHunks = $221c70a2c73ffadc$export$294aa3c46d6af4a5(seed, buffer);
    if (userHunks.length === 0) return remoteHunks;
    for (const rh of remoteHunks)for (const uh of userHunks){
        if ($221c70a2c73ffadc$var$rangesOverlap(rh, uh)) return null;
    }
    return remoteHunks.map((rh)=>{
        let delta = 0;
        for (const uh of userHunks)if (uh.to <= rh.from) delta += uh.insert.length - (uh.to - uh.from);
        return {
            from: rh.from + delta,
            to: rh.to + delta,
            insert: rh.insert
        };
    });
};
const $221c70a2c73ffadc$var$rangesOverlap = (a, b)=>{
    // Strict interior overlap.
    if (a.from < b.to && b.from < a.to) return true;
    // Concurrent zero-width inserts at the same position: ambiguous order.
    if (a.from === b.from && a.to === a.from && b.to === b.from) return true;
    return false;
};



/**
 * CodeMirror 6 syntax-highlight themes for the markdown source view
 * (EDITOR-7602). Styling is tag-based: `@lezer/markdown` tags its nodes and
 * `@codemirror/lang-markdown` nests embedded grammars (fenced code, raw HTML,
 * etc.), so we only map `@lezer/highlight` tags → styles here — no language is
 * treated specially.
 *
 * The default palette is Bitbucket-inspired (red headings + syntax punctuation,
 * blue code), built from ADS tokens which adapt to the active colour mode.
 * Themes are produced via `getMarkdownHighlightStyle(theme, mode)` with explicit
 * light/dark palettes — the seam for a future theme picker.
 */ 



var $lhXhg = parcelRequire("lhXhg");

// ADS accent tokens (which adapt to colour mode); the per-mode hexes are
// fallbacks. Kept as two definitions so either can diverge later.
const $6480260b9bb6fc4e$var$DEFAULT_PALETTES = {
    light: {
        heading: "var(--ds-text-accent-red, #AE2A19)",
        punctuation: "var(--ds-text-accent-red, #AE2A19)",
        code: "var(--ds-text-accent-blue, #0C66E4)",
        keyword: "var(--ds-text-accent-purple, #5E4DB2)",
        string: "var(--ds-text-accent-green, #216E4E)",
        literal: "var(--ds-text-accent-teal, #206A83)",
        type: "var(--ds-text-accent-blue, #0C66E4)",
        name: "var(--ds-text-accent-purple, #5E4DB2)",
        link: "var(--ds-link, #0C66E4)",
        comment: "var(--ds-text-subtlest, #626F86)",
        text: "var(--ds-text, #172B4D)"
    },
    dark: {
        heading: "var(--ds-text-accent-red, #FD9891)",
        punctuation: "var(--ds-text-accent-red, #FD9891)",
        code: "var(--ds-text-accent-blue, #579DFF)",
        keyword: "var(--ds-text-accent-purple, #9F8FEF)",
        string: "var(--ds-text-accent-green, #7EE2B8)",
        literal: "var(--ds-text-accent-teal, #9DD9EE)",
        type: "var(--ds-text-accent-blue, #579DFF)",
        name: "var(--ds-text-accent-purple, #9F8FEF)",
        link: "var(--ds-link, #579DFF)",
        comment: "var(--ds-text-subtlest, #8C9BAB)",
        text: "var(--ds-text, #C7D1DB)"
    }
};
const $6480260b9bb6fc4e$var$THEME_PALETTES = {
    default: $6480260b9bb6fc4e$var$DEFAULT_PALETTES
};
function $6480260b9bb6fc4e$var$buildHighlightStyle(p) {
    return (0, $4lK5a.HighlightStyle).define([
        {
            tag: (0, $lhXhg.tags).heading,
            color: p.heading,
            fontWeight: "var(--ds-font-weight-bold, 653)"
        },
        // Every syntax mark (`#`, `**`, `` ` ``, `>`, list/table marks) shares
        // `processingInstruction`; `tags.list` is left unstyled so item text
        // stays at the default foreground while the marker is coloured.
        {
            tag: (0, $lhXhg.tags).processingInstruction,
            color: p.punctuation
        },
        {
            tag: (0, $lhXhg.tags).contentSeparator,
            color: p.punctuation
        },
        {
            tag: (0, $lhXhg.tags).emphasis,
            fontStyle: 'italic'
        },
        {
            tag: (0, $lhXhg.tags).strong,
            fontWeight: "var(--ds-font-weight-bold, 653)"
        },
        {
            tag: (0, $lhXhg.tags).strikethrough,
            textDecoration: 'line-through'
        },
        {
            tag: [
                (0, $lhXhg.tags).link,
                (0, $lhXhg.tags).url
            ],
            color: p.link,
            textDecoration: 'underline'
        },
        {
            tag: (0, $lhXhg.tags).monospace,
            color: p.code
        },
        {
            tag: [
                (0, $lhXhg.tags).angleBracket,
                (0, $lhXhg.tags).tagName
            ],
            color: p.punctuation
        },
        {
            tag: (0, $lhXhg.tags).attributeName,
            color: p.name
        },
        {
            tag: (0, $lhXhg.tags).attributeValue,
            color: p.string
        },
        {
            tag: (0, $lhXhg.tags).comment,
            color: p.comment,
            fontStyle: 'italic'
        },
        {
            tag: (0, $lhXhg.tags).keyword,
            color: p.keyword,
            fontWeight: "var(--ds-font-weight-bold, 653)"
        },
        {
            tag: [
                (0, $lhXhg.tags).string,
                (0, $lhXhg.tags).special((0, $lhXhg.tags).string),
                (0, $lhXhg.tags).inserted
            ],
            color: p.string
        },
        {
            tag: [
                (0, $lhXhg.tags).atom,
                (0, $lhXhg.tags).bool,
                (0, $lhXhg.tags).literal,
                (0, $lhXhg.tags).labelName,
                (0, $lhXhg.tags).number
            ],
            color: p.literal
        },
        {
            tag: [
                (0, $lhXhg.tags).typeName,
                (0, $lhXhg.tags).namespace
            ],
            color: p.type
        },
        {
            tag: [
                (0, $lhXhg.tags).className,
                (0, $lhXhg.tags).propertyName
            ],
            color: p.name
        },
        {
            tag: (0, $lhXhg.tags).deleted,
            color: p.punctuation
        },
        {
            tag: [
                (0, $lhXhg.tags).regexp,
                (0, $lhXhg.tags).escape
            ],
            color: p.literal
        },
        {
            tag: (0, $lhXhg.tags).variableName,
            color: p.text
        },
        {
            tag: (0, $lhXhg.tags).invalid,
            color: p.text
        }
    ]);
}
const $6480260b9bb6fc4e$var$themeCache = new Map();
function $6480260b9bb6fc4e$export$eb40053f1fb44ebf(theme = 'default', mode = 'light') {
    const key = `${theme}:${mode}`;
    const cached = $6480260b9bb6fc4e$var$themeCache.get(key);
    if (cached) return cached;
    const palettes = $6480260b9bb6fc4e$var$THEME_PALETTES[theme] ?? $6480260b9bb6fc4e$var$THEME_PALETTES.default;
    const style = $6480260b9bb6fc4e$var$buildHighlightStyle(palettes[mode] ?? palettes.light);
    $6480260b9bb6fc4e$var$themeCache.set(key, style);
    return style;
}
const $6480260b9bb6fc4e$export$83b6926f089ab19a = $6480260b9bb6fc4e$export$eb40053f1fb44ebf('default', 'light');


/* MarkdownSourceViewFooter.tsx generated by @compiled/babel-plugin v3.0.1 */ 












var $2uDbg = parcelRequire("2uDbg");




const $f2806cae53c3f91e$var$footerStyles = {
    footer: "_2sNsIgmnOE _2mHwu85zaO _0hPCNLDIqT _1KhSQW9r67 _4hyvPa6wH8 _0vfIXINvrM _24h04i2Njc _3iDTPbQ4SZ _37wbyuI7V3 _0xmtko2ADO _46hvQm2ADO _03SyCP2ADO _0LQT5E2ADO _39xV02N91d",
    labelText: "_4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC _39HuIbz8Lp _1ANEUSLRg7",
    leftSection: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _2mHwu85zaO _4bt5LAnQyn _2WAcuGnQyn _0hPCNLDIqT _1UtDYzZpcK _3iDTPbQ4SZ _4ouGXIdnbC",
    lineNumbersControl: "_0hPCNLDIqT _3iDTPbQ4SZ _3YEZNOdnbC _1ANEUSLRg7",
    rightSection: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _2mHwu82ADO _0hPCNLDIqT _1UtDYzZpcK _3iDTPbQ4SZ _1ANEUSLRg7",
    countSeparator: "_1UtDYzKGUX",
    wrapCodeControl: "_0hPCNLDIqT _3iDTPbQ4SZ _3YEZNOdnbC _1ANEUSLRg7",
    statusText: "_3YEZNOdnbC _1ANEUSLRg7"
};
const $f2806cae53c3f91e$var$fullWidthFooterStyles = null;
const $f2806cae53c3f91e$var$DEFAULT_SOURCE_POSITION_STATE = {
    columnNumber: 1,
    lineCount: 1,
    lineNumber: 1,
    wordCount: 0
};
const $f2806cae53c3f91e$export$d36ee9c3e47d8d66 = ({ children: children, onShowLineNumbersChange: onShowLineNumbersChange, onWrapCodeChange: onWrapCodeChange, showLineNumbers: showLineNumbers, sourcePositionState: sourcePositionState, wrapCode: wrapCode = true })=>{
    const { columnNumber: columnNumber, lineCount: lineCount, lineNumber: lineNumber, wordCount: // `wordCount` is optional on the type for non-breaking adoption; default
    // it so a consumer-supplied state without a word count still renders.
    wordCount = 0 } = sourcePositionState ?? $f2806cae53c3f91e$var$DEFAULT_SOURCE_POSITION_STATE;
    const cursorPositionValues = (0, $cozmU.useMemo)(()=>({
            columnNumber: columnNumber,
            lineNumber: lineNumber
        }), [
        columnNumber,
        lineNumber
    ]);
    const lineCountValues = (0, $cozmU.useMemo)(()=>({
            lineCount: lineCount
        }), [
        lineCount
    ]);
    const wordCountValues = (0, $cozmU.useMemo)(()=>({
            wordCount: wordCount
        }), [
        wordCount
    ]);
    const handleLineNumbersChange = (0, $cozmU.useCallback)((event)=>{
        onShowLineNumbersChange?.(event.currentTarget.checked);
    }, [
        onShowLineNumbersChange
    ]);
    const handleWrapCodeChange = (0, $cozmU.useCallback)((event)=>{
        onWrapCodeChange?.(event.currentTarget.checked);
    }, [
        onWrapCodeChange
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            "_0KLXrulfZc _3YEZNOdnbC _1EqgXlN91d _4ouGXIdnbC _39xV02N91d"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
            xcss: $f2806cae53c3f91e$var$footerStyles.footer,
            testId: "markdown-source-view-footer",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                    xcss: $f2806cae53c3f91e$var$footerStyles.leftSection,
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                            xcss: $f2806cae53c3f91e$var$footerStyles.lineNumbersControl,
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2uDbg.Checkbox), {
                                isChecked: showLineNumbers,
                                onChange: handleLineNumbersChange,
                                label: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                    id: "content-markdown-mode.footer.line-numbers",
                                    defaultMessage: "Line numbers"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                            xcss: $f2806cae53c3f91e$var$footerStyles.wrapCodeControl,
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2uDbg.Checkbox), {
                                isChecked: wrapCode,
                                onChange: handleWrapCodeChange,
                                label: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                    id: "content-markdown-mode.footer.wrap-code",
                                    defaultMessage: "Wrap code"
                                })
                            })
                        }),
                        children,
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                            xcss: $f2806cae53c3f91e$var$footerStyles.statusText,
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                id: "content-markdown-mode.footer.cursor-position",
                                defaultMessage: "Ln {lineNumber}, Col {columnNumber}",
                                values: cursorPositionValues
                            })
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                            xcss: $f2806cae53c3f91e$var$footerStyles.labelText,
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                id: "content-markdown-mode.footer.cursor-position-label",
                                defaultMessage: "Position of cursor"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                    xcss: $f2806cae53c3f91e$var$footerStyles.rightSection,
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                            as: "span",
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                id: "content-markdown-mode.footer.line-count",
                                defaultMessage: "{lineCount, plural, one {# line} other {# lines}}",
                                values: lineCountValues
                            })
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                            as: "span",
                            xcss: $f2806cae53c3f91e$var$footerStyles.countSeparator,
                            "aria-hidden": true,
                            children: "|"
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                            as: "span",
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                id: "content-markdown-mode.footer.word-count",
                                defaultMessage: "{wordCount, plural, one {# word} other {# words}}",
                                values: wordCountValues
                            })
                        })
                    ]
                })
            ]
        })
    });
};


const $44754940e72df3bb$var$TRAILING_SPACE_REGEX = /[ \t]$/u; // ---------------------------------------------------------------------------
// Annotation decoration support
//
// Annotation marks (inline comments) from the ADF document are surfaced as
// highlighted spans in the CodeMirror source view. These are purely visual —
// the markdown string itself is clean (no annotation syntax). The highlights
// shift correctly as the user edits because CM6's RangeSet maps them through
// document changes via the StateField update function.
// ---------------------------------------------------------------------------
// noinspection JSVoidFunctionReturnValueUsed -- WebStorm seems to incorrectly infer the type of StateEffect as being a DOM thing
/**
 * Debounce window (ms) for recomputing the footer word count. Counting words
 * scans the whole document, so we don't run it on every keystroke — the cursor
 * line/column update live, but the word count refreshes only after the user
 * pauses typing for this long.
 */ const $44754940e72df3bb$var$WORD_COUNT_DEBOUNCE_MS = 400; /** Effect dispatched to replace the annotation decoration set. */ 
const $44754940e72df3bb$var$setAnnotationRangesEffect = (0, $b2ZzE.StateEffect).define();
const $44754940e72df3bb$var$lineNumbersCompartment = new (0, $b2ZzE.Compartment)();
const $44754940e72df3bb$var$getLineNumbersExtension = (showLineNumbers)=>showLineNumbers ? (0, $3e6dc.lineNumbers)() : [];
const $44754940e72df3bb$var$lineWrappingCompartment = new (0, $b2ZzE.Compartment)();
const $44754940e72df3bb$var$getLineWrappingExtension = (wrapCode)=>// When wrapping is on there's no horizontal overflow, so the default fixed
    // (sticky) gutter is fine. When wrapping is off long lines scroll
    // horizontally — `gutters({ fixed: false })` unsets the gutter's
    // `position: sticky` so the line-number gutter scrolls off to the left
    // along with the text instead of staying pinned to the viewport edge.
    wrapCode ? (0, $3e6dc.EditorView).lineWrapping : (0, $3e6dc.gutters)({
        fixed: false
    }); /**
     * Returns a CM6 decoration mark for the given annotation ID.
     * The `id` attribute is set so that `document.getElementById(annotationId)`
     * finds this visible CM6 element (rather than the hidden ProseMirror span)
     * when the inline comment popup calculates its anchor position.
     */ 
function $44754940e72df3bb$var$annotationMarkForId(annotationId) {
    return (0, $3e6dc.Decoration).mark({
        class: 'cm-annotation-highlight',
        attributes: {
            id: annotationId
        }
    });
} /**
   * Extract the current annotation character ranges from a CM6 DecorationSet,
   * matching each decoration back to its original annotation ID.
   *
   * CM6's `StateField` maps decorations through document changes automatically
   * (via `decorations.map(tr.changes)`), so after user edits the positions in
   * the DecorationSet reflect the shifted character offsets. We recover the
   * annotation ID by matching the shifted range against the original snapshot
   * list — first by exact position, then by any overlap (best-effort).
   */ 
function $44754940e72df3bb$var$extractCurrentAnnotationRanges(decorations, originalRanges) {
    const result = [];
    const cursor = decorations.iter();
    while(cursor.value !== null){
        const { from: from, to: to } = cursor; // Try to match to an original annotation by exact position first,
        // then fall back to overlap — the id is what matters for re-application.
        const matched = originalRanges.find((a)=>a.from === from && a.to === to) ?? originalRanges.find((a)=>a.from < to && a.to > from); // Only push if we found a matching annotation — an empty-string ID is
        // meaningless and would corrupt the ranges array passed downstream.
        if (matched) result.push({
            id: matched.id,
            from: from,
            to: to
        });
        cursor.next();
    }
    return result;
} /**
   * Keep the latest value in a stable ref for CodeMirror callbacks that are
   * intentionally created once per source-view mount.
   */ 
function $44754940e72df3bb$var$useReactiveRef(targetValue) {
    const ref = (0, $cozmU.useRef)(targetValue);
    (0, $cozmU.useEffect)(()=>{
        ref.current = targetValue;
    }, [
        targetValue
    ]);
    return ref;
} // noinspection JSVoidFunctionReturnValueUsed -- WebStorm seems to incorrectly infer the type of StateEffect as being a DOM thing
/**
 * CM6 StateField that holds the current annotation DecorationSet.
 *
 * On `setAnnotationRangesEffect`: rebuilds the decoration set from the new
 * ranges. On any other transaction: maps the existing decorations through
 * the document changes so character positions stay correct after edits.
 */ const $44754940e72df3bb$var$annotationDecorationsField = (0, $b2ZzE.StateField).define({
    create () {
        return (0, $3e6dc.Decoration).none;
    },
    update (decorations, tr) {
        // Check for a setAnnotationRangesEffect in this transaction.
        for (const effect of tr.effects)if (effect.is($44754940e72df3bb$var$setAnnotationRangesEffect)) {
            const ranges = effect.value;
            if (ranges.length === 0) return (0, $3e6dc.Decoration).none;
             // Rebuild the decoration set from the new ranges.
            // Ranges must be sorted and non-overlapping for a single decoration
            // type — we sort by `from` and clamp to doc length.
            const docLen = tr.state.doc.length;
            const builder = new (0, $b2ZzE.RangeSetBuilder)();
            const sorted = [
                ...ranges
            ].sort((a, b)=>a.from - b.from);
            for (const { from: from, to: to, id: id } of sorted){
                const clampedFrom = Math.min(Math.max(from, 0), docLen);
                const clampedTo = Math.min(Math.max(to, 0), docLen);
                if (clampedFrom < clampedTo) builder.add(clampedFrom, clampedTo, $44754940e72df3bb$var$annotationMarkForId(id));
            }
            return builder.finish();
        }
         // No range update — map existing decorations through any document changes.
        return tr.docChanged ? decorations.map(tr.changes) : decorations;
    },
    provide (field) {
        return (0, $3e6dc.EditorView).decorations.from(field);
    }
});
const $44754940e72df3bb$var$styles = {
    container: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _3iDTPbQ4SZ _0aFT5vbt8w _0jFU0VN91d _0GTcwRIZbP _2xTnZxIZbP _20H5YkdnbC _39xV02N91d",
    layout: "_0jFU0VN91d _0NUa3rN91d _4ouGXIdnbC _39xV02N91d",
    editor: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _30huDKYbGa _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _4kiQYABfNa _39xV02N91d _20H5YkdnbC _2zzEJX98eZ _0MLwP2YbGa _42yC4ZT6kp _47LZLrN91d _3Qh52pdnbC _1F54yFN91d"
}; /**
    * Stable public prop interface for `MarkdownSourceView`.
    *
    * Other agents depend on this contract — DO NOT change without coordination.
    */ 
const $44754940e72df3bb$export$eb7c1c6ff6845883 = ({ contentId: _contentId, initialAdfDoc: initialAdfDoc, seedMarkdown: seedMarkdown, schema: schema, revision: revision = 0, onMarkdownCommit: onMarkdownCommit, liveAdfDoc: liveAdfDoc, postWritebackAdfDoc: postWritebackAdfDoc, onSourceMarkdownChange: onSourceMarkdownChange, sourceChangeDebounceMs: sourceChangeDebounceMs = 2000, serializeFileMedia: serializeFileMedia, annotationRanges: annotationRanges, onAnnotationRangesChange: onAnnotationRangesChange, onAnnotationClick: onAnnotationClick, onRegisterCommandDispatch: onRegisterCommandDispatch, onSourceFormatStateChange: onSourceFormatStateChange, syntaxHighlightTheme: syntaxHighlightTheme = 'default', onSourcePositionStateChange: onSourcePositionStateChange, onShowLineNumbersChange: onShowLineNumbersChange, showLineNumbers: showLineNumbers = true, onWrapCodeChange: onWrapCodeChange, wrapCode: wrapCode = true })=>{
    const intl = (0, $kSwu1.useIntl)(); // MVP full-page layout: the parent `editor-content-container` owns vertical
    // scrolling, so the source view grows to content height instead of scrolling
    // CodeMirror internally (avoids duplicate scrollbars). Read once — the gate
    // value is stable for the lifetime of the mounted view.
    const [sourcePositionState, setSourcePositionState] = (0, $cozmU.useState)(null); // Stash the file-media serialiser in a ref so changing the function
    // reference does not rebuild CodeMirror or invalidate the live-doc
    // effect. The function is read at call time inside `adfToMarkdown`.
    const serializeFileMediaRef = $44754940e72df3bb$var$useReactiveRef(serializeFileMedia); // Read at mount inside the seed effect; ref so a prop change doesn't rebuild
    // CodeMirror — it applies on the next seed.
    const syntaxHighlightThemeRef = $44754940e72df3bb$var$useReactiveRef(syntaxHighlightTheme); // EDITOR-7602 — active ADS colour mode from the `<html>` theme (the resolved
    // `data-color-mode`, not raw `prefers-color-scheme`). Read at seed time like
    // `syntaxHighlightTheme`; the palette is token-driven so a live toggle
    // re-paints anyway — the mode only picks the fallback-hex per mode.
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const syntaxColorModeRef = $44754940e72df3bb$var$useReactiveRef(colorMode === 'dark' ? 'dark' : 'light'); // Stash the schema + commit callback in refs so the unmount cleanup can
    // keep its dep list narrow (we only want the seed/teardown to run on
    // revision change, not whenever the parent re-renders with a new
    // function ref).
    const schemaRef = $44754940e72df3bb$var$useReactiveRef(schema);
    const onCommitRef = $44754940e72df3bb$var$useReactiveRef(onMarkdownCommit); // EDITOR-6558 Tier 2 — keep the live source-change callback + debounce in
    // refs so the seed effect's CodeMirror extension list (which captures
    // these once at mount) always reads the latest values without rebuilding
    // the editor on every parent re-render.
    const onSourceMarkdownChangeRef = $44754940e72df3bb$var$useReactiveRef(onSourceMarkdownChange);
    const sourceChangeDebounceMsRef = $44754940e72df3bb$var$useReactiveRef(sourceChangeDebounceMs); // Latest ADF doc the parent has handed us, kept in a ref so the seed
    // effect can read the most-recent value without re-running on every
    // `initialAdfDoc` reference change. The seed effect deliberately reads
    // it only when `revision` changes.
    const initialAdfDocRef = $44754940e72df3bb$var$useReactiveRef(initialAdfDoc); // Pre-computed markdown from the parent (sync-snapshot), mirrored to a ref and
    // updated during render so the seed effect reads the value for the current revision.
    const seedMarkdownPropRef = (0, $cozmU.useRef)(seedMarkdown);
    seedMarkdownPropRef.current = seedMarkdown; // Ref to the host element CodeMirror mounts into.
    const hostRef = (0, $cozmU.useRef)(null); // Ref to the live EditorView so the cleanup can read its doc.
    const viewRef = (0, $cozmU.useRef)(null); // The markdown the editor was *seeded* with for the current revision —
    // used to detect no-op commits and skip the writeback round-trip. Also
    // the baseline for the disjoint/overlap analysis in the live-refresh path.
    const seedMarkdownRef = (0, $cozmU.useRef)(''); // Most recently deferred `liveAdfDoc` update. Set when an incoming remote
    // change overlaps the user's unsynced typing. Discarded on next
    // `postWritebackAdfDoc` (its content is already in the post-rebase PM).
    const pendingLiveMarkdownRef = (0, $cozmU.useRef)(null);
    const ariaLabel = intl.formatMessage((0, $2VjJa.markdownModeMessages).sourceAriaLabel);
    const ariaLabelRef = $44754940e72df3bb$var$useReactiveRef(ariaLabel); // Runtime locale for locale-aware word counting in the footer. Stored in a
    // ref so the CM6 updateListener (captured once per seed) reads the latest
    // value without rebuilding the editor when the locale changes.
    const localeRef = $44754940e72df3bb$var$useReactiveRef(intl.locale); // Word count is debounced (see WORD_COUNT_DEBOUNCE_MS): the cursor/line
    // fields update on every change, but the word count — a full-document scan —
    // is recomputed only after the user pauses. `lastWordCountRef` holds the most
    // recently computed count so the immediate (cheap) updates can reuse it
    // instead of re-scanning; `wordCountTimerRef` is the pending debounce timer.
    const lastWordCountRef = (0, $cozmU.useRef)(0);
    const wordCountTimerRef = (0, $cozmU.useRef)(null); // EDITOR-6558 Tier 2 — flag set while we're applying a programmatic
    // `liveAdfDoc` change to CodeMirror, so the resulting `updateListener`
    // fire is recognised as an echo and not pushed back to the parent. The
    // flag is set immediately before `view.dispatch({ changes })` and
    // cleared on the next microtask (CodeMirror's update listeners run
    // synchronously inside `dispatch`). Using a ref so the closure captured
    // inside the extension can read it.
    const suppressSourceChangeRef = (0, $cozmU.useRef)(false); // Debounce timer for `onSourceMarkdownChange` — scoped to the view so
    // teardown cleans it up.
    const sourceChangeTimerRef = (0, $cozmU.useRef)(null); // The line number (1-based) where the last doc change occurred.
    // Used to detect when the cursor has moved to a different line so we can
    // short-circuit the debounce and flush the pending writeback early.
    const lastEditLineRef = (0, $cozmU.useRef)(null); // Stash onAnnotationRangesChange in a ref so the sourceChangeListener
    // (captured once at mount) always reads the latest callback without
    // rebuilding CodeMirror on every parent re-render.
    const onAnnotationRangesChangeRef = $44754940e72df3bb$var$useReactiveRef(onAnnotationRangesChange); // Stash onAnnotationClick in a ref so the CM6 domEventHandlers click
    // extension (captured once at mount) always reads the latest callback.
    const onAnnotationClickRef = $44754940e72df3bb$var$useReactiveRef(onAnnotationClick); // Stash onRegisterCommandDispatch in a ref so the effect below doesn't
    // re-run when the parent re-renders with a new function reference.
    const onRegisterCommandDispatchRef = $44754940e72df3bb$var$useReactiveRef(onRegisterCommandDispatch);
    const onSourceFormatStateChangeRef = $44754940e72df3bb$var$useReactiveRef(onSourceFormatStateChange);
    const onSourcePositionStateChangeRef = $44754940e72df3bb$var$useReactiveRef(onSourcePositionStateChange);
    const showLineNumbersRef = $44754940e72df3bb$var$useReactiveRef(showLineNumbers);
    const wrapCodeRef = $44754940e72df3bb$var$useReactiveRef(wrapCode);
    const handleSourcePositionStateChange = (0, $cozmU.useCallback)((state)=>{
        setSourcePositionState(state);
        onSourcePositionStateChangeRef.current?.(state);
    }, [
        onSourcePositionStateChangeRef
    ]); // Expose a stable dispatcher function via the onRegisterCommandDispatch
    // prop so MarkdownModeContentComponent can register it with the plugin
    // whenever api changes. The function reads viewRef at call time so it
    // always dispatches to the live CM6 EditorView.
    const dispatchCmd = (0, $cozmU.useCallback)((cmd)=>{
        const view = viewRef.current;
        if (!view) return false;
        return cmd(view);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- viewRef is a stable ref — intentionally not in deps.
    []); // Register/unregister the dispatcher via the onRegisterCommandDispatch prop.
    // This fires on mount (register) and unmount (null). Re-registration when
    // the plugin rebuilds is handled by MarkdownModeContentComponent which
    // passes an updated onRegisterCommandDispatch whenever api changes.
    (0, $cozmU.useEffect)(()=>{
        const onRegisterCommandDispatch = onRegisterCommandDispatchRef.current;
        onRegisterCommandDispatch?.(dispatchCmd);
        return ()=>{
            onRegisterCommandDispatch?.(null);
        };
    }, [
        dispatchCmd,
        onRegisterCommandDispatchRef
    ]);
    (0, $cozmU.useEffect)(()=>{
        const view = viewRef.current;
        if (!view) return;
        view.dispatch({
            effects: $44754940e72df3bb$var$lineNumbersCompartment.reconfigure($44754940e72df3bb$var$getLineNumbersExtension(showLineNumbers))
        });
    }, [
        showLineNumbers
    ]);
    (0, $cozmU.useEffect)(()=>{
        const view = viewRef.current;
        if (!view) return;
        view.dispatch({
            effects: $44754940e72df3bb$var$lineWrappingCompartment.reconfigure($44754940e72df3bb$var$getLineWrappingExtension(wrapCode))
        });
    }, [
        wrapCode
    ]); // Annotation ranges — kept in a ref so the CM6 StateField (created once
    // at mount) can always read the latest value. Updated whenever the prop
    // changes (i.e. when the parent re-seeds on revision change or live update).
    const annotationRangesRef = (0, $cozmU.useRef)(annotationRanges ?? []);
    (0, $cozmU.useEffect)(()=>{
        annotationRangesRef.current = annotationRanges ?? []; // If the view is mounted, notify the StateField to recompute decorations.
        const view = viewRef.current;
        if (view) view.dispatch({
            effects: $44754940e72df3bb$var$setAnnotationRangesEffect.of(annotationRanges ?? [])
        });
    }, [
        annotationRanges
    ]); // Mount/seed CodeMirror on every `revision` change. Tear down + commit
    // on cleanup (revision change OR component unmount).
    (0, $cozmU.useEffect)(()=>{
        const host = hostRef.current;
        if (!host) return undefined;
        const schema = schemaRef.current;
        const serializeFileMedia = serializeFileMediaRef.current;
        const onCommit = onCommitRef.current;
        const onAnnotationRangesChange = onAnnotationRangesChangeRef.current;
        const onSourcePositionStateChange = onSourcePositionStateChangeRef.current; // Seed markdown for this revision. Prefer the parent's pre-computed value
        // (sync-snapshot, avoids a second conversion); otherwise convert here.
        let seedMarkdownValue;
        const precomputedSeed = seedMarkdownPropRef.current;
        if (precomputedSeed !== undefined) seedMarkdownValue = precomputedSeed;
        else try {
            const result = (0, $5nazv.adfToMarkdown)(initialAdfDocRef.current, schema, {
                serializeFileMedia: serializeFileMedia
            });
            seedMarkdownValue = result.markdown;
        } catch (err) {
            // eslint-disable-next-line no-console
            console.warn('[MarkdownSourceView] Failed to convert ADF doc to markdown; starting with empty buffer.', err);
            seedMarkdownValue = '';
        }
        seedMarkdownRef.current = seedMarkdownValue; // How long to wait before retrying a flush when the current line has
        // unbalanced syntax (e.g. user typed `*ital` and paused mid-word).
        // Long enough to give the user time to finish their syntax, but short
        // enough to guarantee the doc eventually syncs even if they leave it
        // unfinished (e.g. intentional bare `*` or just navigated away).
        const UNBALANCED_RETRY_MS = 5000; // Shared flush function — reads the current CM6 state and fires the
        // writeback callbacks. If the cursor's current line has unbalanced
        // markdown syntax (e.g. `*ital` mid-word) the flush is deferred by
        // UNBALANCED_RETRY_MS instead of firing immediately, giving the user
        // time to finish the syntax without corrupting the live PM doc.
        // Called both by the debounce timer and by the line-change short-circuit.
        const flushSourceChange = (editorView)=>{
            const markdownNow = editorView.state.doc.toString();
            const cursorPos = editorView.state.selection.main.head;
            const cursorLine = editorView.state.doc.lineAt(cursorPos); // A trailing space at the cursor is usually in-progress typing. Live markdown→ADF
            // writeback can normalize it away and then re-sync the source view without the
            // space, so wait until the user types the next non-space character. The final
            // commit still reads from CodeMirror, so the user's buffer remains authoritative.
            if (cursorPos === cursorLine.to && $44754940e72df3bb$var$TRAILING_SPACE_REGEX.test(cursorLine.text)) return;
             // If the current line has unbalanced syntax, reschedule rather than
            // firing. Writing e.g. `*ital` into the PM editor would round-trip
            // back as `\*ital`, clobbering the source view. We defer instead of
            // suppressing indefinitely — worst case the user leaves a bare `*`
            // and it commits after UNBALANCED_RETRY_MS.
            if ((0, $b5c8870ce01fabc3$export$cf49bba3d053a321)(markdownNow, cursorPos)) {
                sourceChangeTimerRef.current = setTimeout(()=>{
                    sourceChangeTimerRef.current = null;
                    const newEditorView = viewRef.current;
                    if (newEditorView) flushSourceChange(newEditorView);
                }, UNBALANCED_RETRY_MS);
                return;
            } // Fire the annotation ranges change callback FIRST so that
            // currentAnnotationRangesRef is up-to-date before onSourceMarkdownChange
            // reads it to re-apply annotation marks. If onSourceMarkdownChange fired
            // first it would see stale/empty ranges on the first flush, stripping
            // all annotation marks from the live PM doc.
            const onRangesChange = onAnnotationRangesChangeRef.current;
            if (onRangesChange && annotationRangesRef.current.length > 0) {
                const currentRanges = $44754940e72df3bb$var$extractCurrentAnnotationRanges(editorView.state.field($44754940e72df3bb$var$annotationDecorationsField), annotationRangesRef.current);
                onRangesChange(currentRanges);
            }
            const cb = onSourceMarkdownChangeRef.current;
            if (cb) cb(markdownNow);
        }; // Recompute the (expensive) word count and push the full position state.
        // Called on mount and from the debounce timer, never synchronously on a
        // keystroke.
        const flushWordCount = (editorView)=>{
            lastWordCountRef.current = (0, $b8e7170495150c53$export$a063438ffa4b0154)(editorView.state.doc, localeRef.current);
            handleSourcePositionStateChange({
                ...(0, $b8e7170495150c53$export$35f4bb6bae3e9d74)(editorView.state),
                wordCount: lastWordCountRef.current
            });
        };
        const sourceChangeListener = (0, $3e6dc.EditorView).updateListener.of((update)=>{
            if (update.docChanged || update.selectionSet) {
                // Update the cheap cursor/line fields immediately, reusing the last
                // computed word count so the footer stays responsive without
                // re-scanning the document on every change.
                handleSourcePositionStateChange({
                    ...(0, $b8e7170495150c53$export$35f4bb6bae3e9d74)(update.state),
                    wordCount: lastWordCountRef.current
                }); // Only document edits change the word count; debounce the recompute.
                // Selection-only changes reuse the cached count above.
                if (update.docChanged) {
                    if (wordCountTimerRef.current !== null) clearTimeout(wordCountTimerRef.current);
                    wordCountTimerRef.current = setTimeout(()=>{
                        wordCountTimerRef.current = null;
                        const editorView = viewRef.current;
                        if (editorView) flushWordCount(editorView);
                    }, $44754940e72df3bb$var$WORD_COUNT_DEBOUNCE_MS);
                }
            }
            if (suppressSourceChangeRef.current) return;
             // Push format state on every selection or doc change so the toolbar
            // can reflect isActive / isDisabled correctly while in source view.
            if (update.docChanged || update.selectionSet) onSourceFormatStateChangeRef.current?.({
                inline: (0, $b8e7170495150c53$export$5069c0cb22ba97e6)(update.state),
                block: (0, $b8e7170495150c53$export$96bc0c55bfc3ec38)(update.state),
                list: (0, $b8e7170495150c53$export$19f8516089a6ae9b)(update.state)
            });
            if (update.docChanged) {
                // Record which line the edit happened on so we can short-circuit
                // the debounce if the cursor moves away before it fires.
                const headPos = update.state.selection.main.head;
                lastEditLineRef.current = update.state.doc.lineAt(headPos).number;
                if (!onSourceMarkdownChangeRef.current) return;
                 // Reset the debounce timer — 2000ms while the user is actively typing.
                if (sourceChangeTimerRef.current !== null) clearTimeout(sourceChangeTimerRef.current);
                sourceChangeTimerRef.current = setTimeout(()=>{
                    sourceChangeTimerRef.current = null;
                    lastEditLineRef.current = null;
                    const editorView = viewRef.current;
                    if (!editorView) return;
                    flushSourceChange(editorView);
                }, sourceChangeDebounceMsRef.current);
                return;
            } // Doc didn't change — check if the cursor has moved to a different line.
            // If there's a pending debounce timer and the cursor is now on a
            // different line than where the edit happened, short-circuit: cancel
            // the long timer and flush after a short 100ms grace period (to avoid
            // flushing on every arrow-key repeat).
            if (sourceChangeTimerRef.current !== null && lastEditLineRef.current !== null && update.selectionSet) {
                const headPos = update.state.selection.main.head;
                const currentLine = update.state.doc.lineAt(headPos).number;
                if (currentLine !== lastEditLineRef.current) {
                    clearTimeout(sourceChangeTimerRef.current);
                    sourceChangeTimerRef.current = setTimeout(()=>{
                        sourceChangeTimerRef.current = null;
                        lastEditLineRef.current = null;
                        const editorView = viewRef.current;
                        if (!editorView) return;
                        flushSourceChange(editorView);
                    }, 100);
                }
            }
        }); // EDITOR-7602 — highlight fenced code by language (`codeLanguages`) and
        // layer the ADS-token theme above the CM6 default.
        const state = (0, $b2ZzE.EditorState).create({
            doc: seedMarkdownValue,
            extensions: [
                $44754940e72df3bb$var$lineNumbersCompartment.of($44754940e72df3bb$var$getLineNumbersExtension(showLineNumbersRef.current)),
                (0, $3e6dc.highlightActiveLine)(),
                (0, $3e6dc.drawSelection)(),
                (0, $3e6dc.dropCursor)(),
                (0, $7nRDp.history)(),
                (0, $4lK5a.indentOnInput)(),
                (0, $4lK5a.bracketMatching)(),
                (0, $9R6p6.markdown)({
                    base: (0, $9R6p6.markdownLanguage),
                    codeLanguages: (0, $725xj.languages)
                }),
                (0, $4lK5a.syntaxHighlighting)((0, $6480260b9bb6fc4e$export$eb40053f1fb44ebf)(syntaxHighlightThemeRef.current, syntaxColorModeRef.current)),
                // CM6 default — base/fallback layer for tags the theme doesn't cover.
                (0, $4lK5a.syntaxHighlighting)((0, $4lK5a.defaultHighlightStyle), {
                    fallback: true
                }),
                $44754940e72df3bb$var$lineWrappingCompartment.of($44754940e72df3bb$var$getLineWrappingExtension(wrapCodeRef.current)),
                // Formatting shortcuts — mirror the WYSIWYG toolbar shortcuts.
                (0, $3e6dc.keymap).of([
                    // Inline formatting
                    {
                        key: 'Mod-b',
                        run: (0, $b8e7170495150c53$export$b850a936f66192a3)
                    },
                    {
                        key: 'Mod-i',
                        run: (0, $b8e7170495150c53$export$227b5ef404be9031)
                    },
                    {
                        key: 'Mod-Shift-m',
                        run: (0, $b8e7170495150c53$export$e7d955a85cfe503c)
                    },
                    {
                        key: 'Mod-Shift-s',
                        run: (0, $b8e7170495150c53$export$a46d65f808b4881d)
                    },
                    // Headings (Mod-Alt-1 through Mod-Alt-6, matching WYSIWYG)
                    {
                        key: 'Mod-Alt-1',
                        run: (0, $b8e7170495150c53$export$4e0d444e5782abea)
                    },
                    {
                        key: 'Mod-Alt-2',
                        run: (0, $b8e7170495150c53$export$b8d734de6aecb0a3)
                    },
                    {
                        key: 'Mod-Alt-3',
                        run: (0, $b8e7170495150c53$export$df05910f74b29e0)
                    },
                    {
                        key: 'Mod-Alt-4',
                        run: (0, $b8e7170495150c53$export$ca48da5fbbd68542)
                    },
                    {
                        key: 'Mod-Alt-5',
                        run: (0, $b8e7170495150c53$export$1335885ed6c2d3ac)
                    },
                    {
                        key: 'Mod-Alt-6',
                        run: (0, $b8e7170495150c53$export$8381ca7ddcf8db0d)
                    },
                    // Blockquote
                    {
                        key: 'Mod-Shift-9',
                        run: (0, $b8e7170495150c53$export$2cd68375ac1e5429)
                    },
                    // Lists
                    {
                        key: 'Mod-Shift-8',
                        run: (0, $b8e7170495150c53$export$71c898cbdfd51c6e)
                    },
                    {
                        key: 'Mod-Shift-7',
                        run: (0, $b8e7170495150c53$export$744c9722bde8c6b3)
                    }
                ]),
                (0, $3e6dc.keymap).of([
                    ...(0, $7nRDp.defaultKeymap),
                    ...(0, $7nRDp.historyKeymap)
                ]),
                (0, $3e6dc.EditorView).contentAttributes.of({
                    'aria-label': ariaLabelRef.current
                }),
                (0, $3e6dc.EditorView).theme({
                    // The source view is bounded to the viewport and CodeMirror owns its
                    // own scrolling — `.cm-scroller` scrolls both axes natively, so its
                    // horizontal scrollbar sits at the bottom of the viewport, just above
                    // the in-flow footer. The parent `editor-content-container`'s vertical
                    // scroll track is neutralised in markdown mode (see FullPageContentArea)
                    // so there is no second scrollbar.
                    '&': {
                        flex: '1 1 auto',
                        height: '100%',
                        minHeight: 0,
                        width: '100%'
                    },
                    '.cm-scroller': {
                        height: '100%',
                        minHeight: 0,
                        // Keeps the caret clear of the bottom edge when typing at the end of
                        // the document (the scroller is the scroll container again).
                        scrollPaddingBlockEnd: "var(--ds-space-600, 48px)",
                        // Left inset for the editor content (gutter + text). Lives on the
                        // scroller — not `.cm-editor` — so the horizontal scrollbar still
                        // spans the full viewport width (the scrollbar sits on the
                        // scroller's border box, outside this padding).
                        paddingLeft: "var(--ds-space-400, 32px)",
                        // Top inset for the editor content. Lives on the scroller (insets the
                        // gutter + text together, keeping line numbers aligned) rather than on
                        // the `.ak-editor-content-area-region` wrapper — wrapper padding would
                        // push the scroller down and leave a gap above the vertical scrollbar.
                        // The scrollbar sits on the scroller's border box, outside this padding,
                        // so it still spans the full height.
                        paddingTop: "var(--ds-space-500, 40px)",
                        ...(0, $iDrrr.fg)('platform_editor_md_source_sync_snapshot') ? // Token-aligned typography for the source view (ADS typography tokens
                        // instead of raw monospace/14px/1.6 values).
                        {
                            font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                            fontFamily: "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
                        } : {
                            fontFamily: 'monospace',
                            fontSize: '14px',
                            lineHeight: '1.6'
                        }
                    },
                    // Right inset for the text column. Applied to `.cm-content` rather
                    // than the scroller because a scroll container's `padding-inline-end`
                    // is dropped from the scrollable region in some browsers, letting the
                    // last characters sit flush against the right edge when scrolled.
                    '.cm-content': {
                        paddingRight: "var(--ds-space-400, 32px)"
                    },
                    '.cm-gutter': {
                        minHeight: '100%'
                    },
                    '.cm-gutters': {
                        alignSelf: 'stretch',
                        minHeight: '100%',
                        borderRight: 0,
                        marginRight: "var(--ds-space-200, 16px)",
                        backgroundColor: 'transparent'
                    },
                    '.cm-gutters .cm-gutter.cm-lineNumbers .cm-gutterElement': {
                        padding: `0 ${"var(--ds-space-050, 4px)"} 0 ${"var(--ds-space-200, 16px)"}`
                    },
                    // Annotation (inline comment) highlight — subtle background tint
                    // matching the Confluence inline comment highlight colour.
                    // cursor:pointer signals the span is interactive (clickable).
                    '.cm-annotation-highlight': {
                        backgroundColor: 'rgba(255, 196, 0, 0.3)',
                        cursor: 'pointer'
                    },
                    // Token-driven editor chrome. CM6's baseTheme is light by default
                    // (we never mark the view dark), so its selection (#d7d4f0),
                    // active-line (#cceeff44) and caret colours wash out on a dark
                    // surface. Override with ADS tokens (which adapt to the mode);
                    // `!important` is needed because CM's focused-selection selector
                    // (`&light.cm-focused > .cm-scroller > .cm-selectionLayer
                    // .cm-selectionBackground`) is far more specific than ours.
                    '.cm-activeLine': {
                        backgroundColor: `${"var(--ds-background-neutral-subtle-hovered, #0515240F)"} !important`
                    },
                    '.cm-selectionLayer .cm-selectionBackground, & .cm-selectionBackground': {
                        background: `${"var(--ds-background-selected, #E9F2FE)"} !important`
                    },
                    '.cm-cursor, .cm-dropCursor': {
                        borderLeftColor: `${"var(--ds-text, #292A2E)"} !important`
                    }
                }),
                // Annotation decorations — renders inline comment highlights.
                // Only active when annotation ranges are provided. The StateField
                // maps ranges through document changes so highlights shift
                // correctly as the user edits.
                $44754940e72df3bb$var$annotationDecorationsField,
                // Click handler for annotation highlights. When the user clicks
                // inside a `.cm-annotation-highlight` span, we look up which
                // annotation range contains the clicked character position and
                // fire `onAnnotationClick` with its ID. The parent dispatches
                // the appropriate ProseMirror command to open the comment popup
                // or panel — mirroring the click behaviour in the WYSIWYG view.
                (0, $3e6dc.EditorView).domEventHandlers({
                    click (event, view) {
                        const cb = onAnnotationClickRef.current;
                        if (!cb) return false;
                        const ranges = annotationRangesRef.current;
                        if (!ranges.length) return false;
                         // Use CM6's posAtCoords to get the character offset at the
                        // click position, then find the annotation range that contains it.
                        const pos = view.posAtCoords({
                            x: event.clientX,
                            y: event.clientY
                        });
                        if (pos === null) return false;
                         // Read the current (possibly-shifted) decoration positions from
                        // the StateField so clicks work correctly after the user has
                        // edited text around the annotation highlights.
                        const decorationsField = view.state.field($44754940e72df3bb$var$annotationDecorationsField, false);
                        if (!decorationsField) // Fall back to the original snapshot ranges if the field
                        // isn't present (e.g. annotationRanges wasn't provided).
                        return false;
                        const currentRanges = $44754940e72df3bb$var$extractCurrentAnnotationRanges(decorationsField, ranges);
                        const clickedRange = currentRanges.find((range)=>pos >= range.from && pos < range.to);
                        if (!clickedRange) return false;
                        cb(clickedRange.id);
                        return true;
                    }
                }),
                sourceChangeListener
            ]
        });
        const view = new (0, $3e6dc.EditorView)({
            state: state,
            parent: host
        });
        viewRef.current = view;
        onSourceFormatStateChangeRef.current?.({
            inline: (0, $b8e7170495150c53$export$5069c0cb22ba97e6)(view.state),
            block: (0, $b8e7170495150c53$export$96bc0c55bfc3ec38)(view.state),
            list: (0, $b8e7170495150c53$export$19f8516089a6ae9b)(view.state)
        }); // Seed the full position state (including word count) synchronously on
        // mount; subsequent word-count updates are debounced via flushWordCount.
        flushWordCount(view); // Seed the annotation decorations for this revision if ranges were provided.
        // We dispatch immediately after view creation so the initial highlights
        // are visible on mount without waiting for the next render cycle.
        if (annotationRangesRef.current.length > 0) view.dispatch({
            effects: $44754940e72df3bb$var$setAnnotationRangesEffect.of(annotationRangesRef.current)
        });
        return ()=>{
            // Tier 2: drop any pending source-change debounce — we're tearing
            // down the view, the parent will get either the final commit
            // (below) or nothing.
            if (sourceChangeTimerRef.current !== null) {
                clearTimeout(sourceChangeTimerRef.current);
                sourceChangeTimerRef.current = null;
            } // Drop any pending word-count debounce — the view is going away.
            if (wordCountTimerRef.current !== null) {
                clearTimeout(wordCountTimerRef.current);
                wordCountTimerRef.current = null;
            } // Read the final markdown AND annotation ranges BEFORE destroying the view.
            const finalMarkdown = view.state.doc.toString(); // Fire the final annotation ranges to the parent so handleMarkdownCommit
            // has the latest CM6-tracked positions (not the stale snapshot ranges).
            if (onAnnotationRangesChange && annotationRangesRef.current.length > 0) {
                const finalRanges = $44754940e72df3bb$var$extractCurrentAnnotationRanges(view.state.field($44754940e72df3bb$var$annotationDecorationsField), annotationRangesRef.current);
                onAnnotationRangesChange(finalRanges);
            }
            view.destroy();
            viewRef.current = null;
            onSourcePositionStateChange?.(null);
            if (!onCommit) return;
             // No-op guard: if the user didn't change the buffer, don't fire
            // a writeback. The markdown round-trip is lossy in general, so
            // committing the unchanged buffer would still mutate the live
            // doc (and reset collab cursors / undo history).
            if (finalMarkdown === seedMarkdownRef.current) return;
            try {
                // Validate by attempting to parse — if it throws we discard the
                // change. We deliberately do NOT pass the parsed PMNode out;
                // the parent re-parses against its own editor schema (which
                // may differ at the margins from ours) when applying.
                (0, $5nazv.markdownToAdf)(finalMarkdown, schema);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.warn('[MarkdownSourceView] Failed to parse markdown back to ADF on commit; discarding change.', err);
                return;
            }
            onCommit(finalMarkdown);
        }; // `revision` is the only dependency: a bump forces a destroy + re-seed.
    // Schema/commit/aria/initialAdfDoc are all read through refs above so
    // they don't reseed the editor (which would clobber the user's edits).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        revision
    ]);
    // EDITOR-6558 Tier 1 — react to live WYSIWYG → source updates.
    //
    // We diff the new markdown against the current CodeMirror buffer and
    // dispatch a minimal-replace `ChangeSet`, so the user's caret survives
    // updates that don't touch the position they're editing at.
    //
    // `seedMarkdownRef` is updated on every successful diff-apply so a later
    // no-op-guard commit on unmount/revision-change still works correctly
    // (the "seed" for that revision is logically the most-recent live doc,
    // not the doc we mounted with).
    (0, $cozmU.useEffect)(()=>{
        if (liveAdfDoc === undefined) return;
        const schema = schemaRef.current;
        const serializeFileMedia = serializeFileMediaRef.current;
        const view = viewRef.current;
        if (!view) return;
        const trace = (0, $5e1679443117df1d$export$de8e565f923f53f9).begin('live-tap');
        const currentBuffer = view.state.doc.toString();
        let nextMarkdown;
        try {
            const result = (0, $5nazv.adfToMarkdown)(liveAdfDoc, schema, {
                serializeFileMedia: serializeFileMedia
            });
            nextMarkdown = result.markdown;
        } catch (err) {
            // Live doc contains a node that the markdown serialiser can't
            // represent. Don't blow away the user's buffer — just skip.
            trace?.sync(()=>({
                    decision: 'parse-failed',
                    path: null,
                    note: "adf\u2192md serialize failed; live update skipped"
                })); // eslint-disable-next-line no-console
            console.warn('[MarkdownSourceView] Failed to convert live ADF doc to markdown; skipping live update.', err);
            return;
        }
        if (nextMarkdown === currentBuffer) {
            // Echo from our own writeback (or no-op live update). Update the
            // seed reference so the no-op guard on the next commit reflects
            // the latest agreed-on text.
            seedMarkdownRef.current = nextMarkdown;
            trace?.sync(()=>({
                    decision: 'echo-filtered',
                    path: null
                }));
            return;
        } // EDITOR-6558 Option C — "source markdown is canonical".
        //
        // The user is typing in CodeMirror. Their buffer is THE truth. The
        // `liveAdfDoc` we just received may be semantically equal to what
        // the user typed but disagree on the markdown surface form (e.g.
        // `*ital` vs `\*ital` after the round-trip escape, or trailing
        // space → `&#x20;`). In those cases we must skip the diff-apply.
        //
        // Comparison strategy: re-serialise BOTH sides via `adfToMarkdown`
        // and compare the markdown strings. Reasoning:
        //  - JSON.stringify identity fails when plugins assign attrs like
        //    `localId` to the live doc that aren't in the parsed buffer.
        //  - `Node.eq` (with `schema.nodeFromJSON(liveAdfDoc)`) ALSO fails
        //    for the same reason — Node.eq is attr-strict.
        //  - Re-serialising both sides via the same pipeline drops
        //    non-semantic attrs (the markdown serialiser doesn't include
        //    `localId`), so byte-equal markdown ⇒ semantically equivalent
        //    docs. This is the same approach the integration test bed
        //    proved correct.
        try {
            const currentBufferAsAdf = (0, $5nazv.markdownToAdf)(currentBuffer, schema);
            const { markdown: bufferAsMarkdown } = (0, $5nazv.adfToMarkdown)(currentBufferAsAdf, schema, {
                serializeFileMedia: serializeFileMedia
            });
            if (bufferAsMarkdown === nextMarkdown) {
                // Don't bump seedMarkdownRef here — the user's buffer is the
                // authoritative seed for the no-op-commit guard. If they
                // switch back to wysiwyg without further edits, the commit
                // will correctly fire because their buffer differs from the
                // markdown we seeded with at mount.
                trace?.sync(()=>({
                        decision: 'skipped-equivalent',
                        path: null,
                        note: 'buffer already semantically equal to live doc'
                    }));
                return;
            }
        } catch (err) {
        // (e.g. unbalanced syntax). Fall through to the diff-apply
        // path below.
        }
        const changes = (0, $221c70a2c73ffadc$export$e291136b00c395d)(seedMarkdownRef.current, currentBuffer, nextMarkdown);
        if (!changes) {
            // Overlap with user's typing — defer until next postWritebackAdfDoc.
            pendingLiveMarkdownRef.current = nextMarkdown;
            trace?.sync(()=>({
                    decision: 'no-op',
                    path: null,
                    note: "deferred \u2014 live update overlaps the user\u2019s in-progress edit"
                }));
            return;
        }
        if (changes.length > 0) {
            // Suppress the user-edit listener for this programmatic dispatch —
            // CM6 update listeners run synchronously inside `view.dispatch`, so
            // it's safe to clear immediately after.
            suppressSourceChangeRef.current = true;
            try {
                view.dispatch({
                    changes: changes
                });
            } finally{
                suppressSourceChangeRef.current = false;
            }
            trace?.sync(()=>({
                    decision: 'replaced',
                    path: null,
                    note: 'source buffer updated from live doc'
                }));
        } else trace?.sync(()=>({
                decision: 'no-op',
                path: null
            }));
        seedMarkdownRef.current = nextMarkdown;
        pendingLiveMarkdownRef.current = null;
    }, [
        liveAdfDoc,
        schemaRef,
        serializeFileMediaRef
    ]);
    // Re-seed CM6 from the post-rebase PM doc the orchestrator pushed after
    // its own-writeback. Any deferred overlapping liveAdfDoc is already in PM
    // and is discarded.
    (0, $cozmU.useEffect)(()=>{
        if (postWritebackAdfDoc === undefined) return;
        const view = viewRef.current;
        if (!view) return;
        const schema = schemaRef.current;
        let nextMarkdown;
        try {
            nextMarkdown = (0, $5nazv.adfToMarkdown)(postWritebackAdfDoc, schema, {
                serializeFileMedia: serializeFileMediaRef.current
            }).markdown;
        } catch (err) {
            // eslint-disable-next-line no-console
            console.warn('[MarkdownSourceView] Failed to serialise post-writeback ADF; skipping re-seed.', err);
            return;
        }
        const currentBuffer = view.state.doc.toString(); // Minimal-replace via diffHunks instead of a full-buffer overwrite, so the
        // cursor stays put when it's outside any rebased remote hunk. Only the
        // rebased-flush case (post-rebase PM differs from buffer) actually dispatches.
        const hunks = (0, $221c70a2c73ffadc$export$294aa3c46d6af4a5)(currentBuffer, nextMarkdown);
        if (hunks.length > 0) {
            suppressSourceChangeRef.current = true;
            try {
                view.dispatch({
                    changes: hunks
                });
            } finally{
                suppressSourceChangeRef.current = false;
            }
        }
        seedMarkdownRef.current = nextMarkdown;
        pendingLiveMarkdownRef.current = null;
    }, [
        postWritebackAdfDoc,
        schemaRef,
        serializeFileMediaRef
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
        "data-testid": "markdown-source-view",
        className: (0, $hekY6.default)([
            $44754940e72df3bb$var$styles.container,
            $44754940e72df3bb$var$styles.layout
        ]),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                ref: hostRef,
                "data-testid": "markdown-source-view--codemirror",
                className: (0, $hekY6.default)([
                    $44754940e72df3bb$var$styles.editor
                ])
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f2806cae53c3f91e$export$d36ee9c3e47d8d66), {
                onShowLineNumbersChange: onShowLineNumbersChange,
                showLineNumbers: showLineNumbers,
                onWrapCodeChange: onWrapCodeChange,
                wrapCode: wrapCode,
                sourcePositionState: sourcePositionState
            })
        ]
    });
};


const $f351bab582830cfa$var$EMPTY_ADF_DOC = {
    type: 'doc',
    version: 1,
    content: []
};
/**
 * Mark types the reconciler diff ignores. Single source of truth shared by the
 * actual `applyDiffSteps` call and the trace payload, so the trace can never
 * report a stale ignore list if this value changes.
 */ const $f351bab582830cfa$var$RECONCILER_IGNORE_MARK_TYPES = [
    'annotation'
];
/**
 * Builds the `diff-applied` sync payload. Shared by both writeback handlers
 * (source-change and commit) so the reconciler payload shape stays identical
 * across them. Invoke this inside a `trace?.sync(() => …)` thunk so the
 * `toJSON()` calls are skipped when recording is off.
 */ const $f351bab582830cfa$var$buildDiffAppliedSync = (tr, beforeDoc, afterDoc, interveningStepCount)=>({
        decision: 'diff-applied',
        path: 'applyDiffSteps',
        reconciler: {
            steps: tr.steps.map((s)=>s.toJSON()),
            stepCount: tr.steps.length,
            ignoredMarkTypes: $f351bab582830cfa$var$RECONCILER_IGNORE_MARK_TYPES,
            interveningStepCount: interveningStepCount,
            reseedReason: 'post-writeback',
            beforeAdf: beforeDoc.toJSON(),
            afterAdf: afterDoc.toJSON()
        }
    });
const $f351bab582830cfa$var$replaceWithConvertedDoc = (editorView, newAdfNode)=>{
    if (editorView.isDestroyed) return null;
    const { state: state } = editorView;
    const tr = state.tr.replaceWith(0, state.doc.nodeSize - 2, newAdfNode.content).setMeta('addToHistory', false).setMeta('replaceDocument', true).setMeta((0, $68b04ed0ed4951fc$export$372e47604067462f), true);
    editorView.dispatch(tr);
    return tr;
};
const $f351bab582830cfa$export$f6ff746d302c10e = ({ api: api, editorView: editorView, config: config, currentView: currentView, showSourceLineNumbers: showSourceLineNumbers = true, wrapSourceCode: wrapSourceCode = true })=>{
    if (!config.isMarkdownMode) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)($f351bab582830cfa$var$MarkdownModeOrchestratorDiff, {
        api: api,
        markdownView: currentView,
        editorView: editorView,
        config: config,
        showSourceLineNumbers: showSourceLineNumbers,
        wrapSourceCode: wrapSourceCode
    });
};
const $f351bab582830cfa$var$MarkdownModeOrchestratorDiff = ({ api: api, markdownView: markdownView, editorView: editorView, config: config, showSourceLineNumbers: showSourceLineNumbers, wrapSourceCode: wrapSourceCode })=>{
    // ---------------------------------------------------------------
    // State
    // ---------------------------------------------------------------
    const [adfDoc, setAdfDoc] = (0, $cozmU.useState)($f351bab582830cfa$var$EMPTY_ADF_DOC);
    const [snapshotRevision, setSnapshotRevision] = (0, $cozmU.useState)(0);
    const [liveAdfDoc, setLiveAdfDoc] = (0, $cozmU.useState)(undefined);
    // Pre-computed markdown for the snapshot (platform_editor_md_source_sync_snapshot).
    const [seedMarkdown, setSeedMarkdown] = (0, $cozmU.useState)(undefined);
    // Pushed to MarkdownSourceView after every successful own-writeback so CM6
    // can re-seed (absorbs any remote content that was folded in via rebase).
    const [postWritebackAdfDoc, setPostWritebackAdfDoc] = (0, $cozmU.useState)(undefined);
    const liveDocDebounceRef = (0, $cozmU.useRef)(null);
    const dispatchTapInstalledRef = (0, $cozmU.useRef)(false);
    // Collab-safe diff baseline: steps are computed against `seedPmDocRef` and
    // rebased through `interveningMappingRef`. Both reset on snapshot and after
    // every successful writeback.
    const seedPmDocRef = (0, $cozmU.useRef)(null);
    const interveningMappingRef = (0, $cozmU.useRef)(new (0, $eOaGc.Mapping)());
    // Stable ref for serializeFileMedia so effects and callbacks can read the
    // latest value without taking it as a dep (unstable parent references would
    // otherwise re-fire the snapshot effect and wipe the refs above).
    const serializeFileMediaRef = (0, $cozmU.useRef)(config.serializeFileMedia);
    serializeFileMediaRef.current = config.serializeFileMedia;
    // Annotation ranges extracted at snapshot time — passed to the source view
    // purely so highlight decorations render and click-to-open works. The diff
    // writeback path does NOT re-apply annotation marks (see file header).
    const [annotationRanges, setAnnotationRanges] = (0, $cozmU.useState)([]);
    // ---------------------------------------------------------------
    // Snapshot — synchronously read the current doc from PM.
    // ---------------------------------------------------------------
    const snapshotAdf = (0, $cozmU.useCallback)(()=>{
        if (!editorView || editorView.isDestroyed) return null;
        return editorView.state.doc.toJSON();
    }, [
        editorView
    ]);
    // Snapshot whenever the user transitions away from preview (the WYSIWYG editor).
    (0, $cozmU.useEffect)(()=>{
        if (markdownView === 'preview') return;
        const snap = snapshotAdf();
        if (snap && snap.type === 'doc') {
            setAdfDoc(snap);
            setSnapshotRevision((r)=>r + 1);
            setLiveAdfDoc(undefined);
            setPostWritebackAdfDoc(undefined);
            seedPmDocRef.current = editorView.state.doc;
            interveningMappingRef.current = new (0, $eOaGc.Mapping)();
            // Convert the snapshot to markdown a SINGLE time here and reuse for
            // both the source-view seed and annotation ranges.
            try {
                const schema = editorView.state.schema;
                const pmDoc = editorView.state.doc;
                const { markdown: markdown, annotations: annotations } = (0, $5nazv.adfToMarkdown)(pmDoc, schema, {
                    serializeFileMedia: serializeFileMediaRef.current
                });
                if ((0, $iDrrr.fg)('platform_editor_md_source_sync_snapshot')) setSeedMarkdown(markdown);
                setAnnotationRanges(annotations);
            } catch  {
                if ((0, $iDrrr.fg)('platform_editor_md_source_sync_snapshot')) setSeedMarkdown(undefined);
                setAnnotationRanges([]);
            }
        }
    }, [
        markdownView,
        snapshotAdf,
        editorView
    ]);
    // ---------------------------------------------------------------
    // Dispatch tap — push debounced live updates to source/preview.
    // ---------------------------------------------------------------
    (0, $cozmU.useEffect)(()=>{
        if (markdownView === 'preview') return;
        if (!editorView || editorView.isDestroyed) return;
        if (dispatchTapInstalledRef.current) return;
        const original = editorView.props.dispatchTransaction;
        const tap = (tr)=>{
            // Always run the original dispatcher first.
            if (original) original.call(editorView, tr);
            else editorView.updateState(editorView.state.apply(tr));
            if (!tr.docChanged) return;
            if (tr.getMeta((0, $68b04ed0ed4951fc$export$372e47604067462f))) {
                (0, $5e1679443117df1d$export$de8e565f923f53f9).begin('live-tap')?.sync(()=>({
                        decision: 'echo-filtered',
                        path: 'applyDiffSteps'
                    }));
                return; // our writeback — don't accumulate, don't push to source view
            }
            for (const map of tr.mapping.maps)interveningMappingRef.current.appendMap(map);
            // Debounce: coalesce rapid keystrokes.
            if (liveDocDebounceRef.current !== null) clearTimeout(liveDocDebounceRef.current);
            liveDocDebounceRef.current = setTimeout(()=>{
                liveDocDebounceRef.current = null;
                if (!editorView || editorView.isDestroyed) return;
                setLiveAdfDoc(editorView.state.doc.toJSON());
            }, 150);
        };
        editorView.setProps({
            dispatchTransaction: tap
        });
        dispatchTapInstalledRef.current = true;
        return ()=>{
            if (liveDocDebounceRef.current !== null) {
                clearTimeout(liveDocDebounceRef.current);
                liveDocDebounceRef.current = null;
            }
            // Restore the original dispatcher so the tap closure (and the React
            // fiber it captures via setLiveAdfDoc) can be GC'd, and so a future
            // editorView change re-installs cleanly.
            if (!editorView.isDestroyed) editorView.setProps({
                dispatchTransaction: original
            });
            dispatchTapInstalledRef.current = false;
        };
    }, [
        markdownView,
        editorView
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (liveDocDebounceRef.current !== null) {
                clearTimeout(liveDocDebounceRef.current);
                liveDocDebounceRef.current = null;
            }
        };
    }, []);
    // ---------------------------------------------------------------
    // Writeback handlers
    // ---------------------------------------------------------------
    // Same stable-ref pattern for the dev-only step-observer callback.
    const onDiffStepsAppliedRef = (0, $cozmU.useRef)(config.onDiffStepsApplied);
    onDiffStepsAppliedRef.current = config.onDiffStepsApplied;
    const sourceWritebackErrorRef = (0, $cozmU.useRef)(config.onSourceWritebackError);
    sourceWritebackErrorRef.current = config.onSourceWritebackError;
    const reseedAfterRebaseFailure = (0, $cozmU.useCallback)((trace, err)=>{
        trace?.sync(()=>({
                decision: 'reseeded',
                path: 'applyDiffSteps',
                reconciler: {
                    reseedReason: 'rebase-failure',
                    reconcilerError: err instanceof Error ? err.message : String(err)
                }
            }));
        seedPmDocRef.current = editorView.state.doc;
        interveningMappingRef.current = new (0, $eOaGc.Mapping)();
    }, [
        editorView
    ]);
    /**
   * Called when the user clicks an annotation highlight in the CodeMirror
   * source view. Mirrors the click handler in the annotation plugin's
   * inline-comment.ts: checks the annotation is unresolved, then dispatches
   * setSelectedAnnotation (or setPendingSelectedAnnotation when the annotation
   * manager is enabled) on the live ProseMirror editor so that the comment
   * popup / comments panel opens, exactly as in the WYSIWYG view.
   */ const handleAnnotationClick = (0, $cozmU.useCallback)((annotationId)=>{
        if (!editorView || editorView.isDestroyed) return;
        // Read annotation plugin state via api.annotation.sharedState — avoids
        // importing internal annotation plugin utilities directly and works
        // correctly with the pre-built dist in the browser dev environment.
        const annotationPluginState = api?.annotation?.sharedState.currentState();
        if (!annotationPluginState) return;
        const { annotations: annotations, isAnnotationManagerEnabled: isAnnotationManagerEnabled } = annotationPluginState;
        // Only react to unresolved annotations (matches WYSIWYG click handler).
        const isUnresolved = annotations && annotations[annotationId] === false;
        if (!isUnresolved) return;
        if (isAnnotationManagerEnabled) api?.annotation?.actions.setPendingSelectedAnnotation(annotationId)(editorView.state, editorView.dispatch);
        else api?.annotation?.actions.setSelectedAnnotation(annotationId)(editorView.state, editorView.dispatch);
    }, [
        editorView,
        api
    ]);
    /**
   * Forwarded to MarkdownSourceView as `onRegisterCommandDispatch`.
   * Called on mount with a stable dispatcher that routes CM6 commands to
   * the live CodeMirror EditorView, and with `null` on unmount.
   * Registers/unregisters the dispatcher on the markdownMode plugin action
   * so toolbar buttons can call `api.markdownMode.actions.dispatchSourceCommand`.
   * Only wired when `platform_editor_markdown_compatible_toolbar` is enabled.
   */ // Stable ref to the CM6 dispatcher — populated when MarkdownSourceView
    // mounts and cleared when it unmounts.
    const sourceDispatchRef = (0, $cozmU.useRef)(null);
    const handleRegisterCommandDispatch = (0, $cozmU.useCallback)((dispatcher)=>{
        sourceDispatchRef.current = dispatcher;
        api?.markdownMode?.actions.registerSourceCommandDispatch(dispatcher);
        if (dispatcher === null) api?.markdownMode?.actions.setSourceFormatState(null);
    }, [
        api
    ]);
    // Re-register the dispatcher whenever api changes (preset rebuild resets
    // the plugin closure, clearing sourceCommandDispatch to null).
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $iDrrr.fg)('platform_editor_markdown_compatible_toolbar')) return;
        if (sourceDispatchRef.current) api?.markdownMode?.actions.registerSourceCommandDispatch(sourceDispatchRef.current);
    }, [
        api
    ]);
    const handleSourceFormatStateChange = (0, $cozmU.useCallback)((state)=>{
        api?.markdownMode?.actions.setSourceFormatState(state);
    }, [
        api
    ]);
    const handleSourcePositionStateChange = (0, $cozmU.useCallback)((state)=>{
        api?.markdownMode?.actions.setSourcePositionState(state);
    }, [
        api
    ]);
    const handleShowSourceLineNumbersChange = (0, $cozmU.useCallback)((showLineNumbers)=>{
        api?.markdownMode?.actions.setShowSourceLineNumbers(showLineNumbers);
    }, [
        api
    ]);
    const handleWrapCodeChange = (0, $cozmU.useCallback)((wrapCode)=>{
        api?.markdownMode?.actions.setWrapSourceCode(wrapCode);
    }, [
        api
    ]);
    /**
   * Called by MarkdownSourceView on every debounced source change (Tier 2).
   * Parses markdown back to ADF and applies the delta to the live PM doc via
   * surgical `Step`s computed by `@atlassian/content-reconciler`.
   */ const handleSourceMarkdownChange = (0, $cozmU.useCallback)((markdown)=>{
        if (!editorView || editorView.isDestroyed) return;
        const seedDoc = seedPmDocRef.current;
        if (!seedDoc) return;
        const trace = (0, $5e1679443117df1d$export$de8e565f923f53f9).begin('source-change');
        let adfNode;
        try {
            adfNode = (0, $5nazv.markdownToAdf)(markdown, editorView.state.schema);
        } catch (err) {
            // Bound interveningMapping growth while the user iterates on invalid
            // markdown; next valid input diffs against the post-remote baseline.
            trace?.sync(()=>({
                    decision: 'reseeded',
                    path: 'applyDiffSteps',
                    reconciler: {
                        reseedReason: 'parse-error'
                    }
                }));
            if ((0, $iDrrr.fg)('platform_editor_md_mode_rebase_fallback')) sourceWritebackErrorRef.current?.({
                error: err,
                reason: 'parse-error',
                source: 'live'
            });
            seedPmDocRef.current = editorView.state.doc;
            interveningMappingRef.current = new (0, $eOaGc.Mapping)();
            return;
        }
        // Early-out + re-seed: if live PM already serializes to the requested
        // markdown, the diff is a no-op and current PM is the right new seed.
        try {
            const { markdown: liveMarkdown } = (0, $5nazv.adfToMarkdown)(editorView.state.doc, editorView.state.schema, {
                serializeFileMedia: serializeFileMediaRef.current
            });
            if (liveMarkdown === markdown) {
                trace?.sync(()=>({
                        decision: 'reseeded',
                        path: 'applyDiffSteps',
                        reconciler: {
                            reseedReason: 'round-trip-match',
                            interveningStepCount: interveningMappingRef.current.maps.length
                        }
                    }));
                seedPmDocRef.current = editorView.state.doc;
                interveningMappingRef.current = new (0, $eOaGc.Mapping)();
                return;
            }
        } catch (err) {
        // fall through to diff path
        }
        // Capture before dispatch so the dev callback sees the diff baseline.
        const oldDocForCallback = editorView.state.doc;
        const paddedAdfNode = (0, $51eaa0d358e75b0f$export$cecc4bbbdf07f0bc)(oldDocForCallback, adfNode);
        try {
            const interveningStepCount = interveningMappingRef.current.maps.length;
            const tr = (0, $68b04ed0ed4951fc$export$c0dd7bd7f3654863)(editorView, seedDoc, paddedAdfNode, interveningMappingRef.current, {
                ignoreMarkTypes: $f351bab582830cfa$var$RECONCILER_IGNORE_MARK_TYPES
            });
            if (tr) {
                trace?.sync(()=>$f351bab582830cfa$var$buildDiffAppliedSync(tr, oldDocForCallback, editorView.state.doc, interveningStepCount));
                seedPmDocRef.current = editorView.state.doc;
                interveningMappingRef.current = new (0, $eOaGc.Mapping)();
                setPostWritebackAdfDoc(editorView.state.doc.toJSON());
                onDiffStepsAppliedRef.current?.({
                    markdown: markdown,
                    newDoc: paddedAdfNode,
                    oldDoc: oldDocForCallback,
                    source: 'live',
                    steps: tr.steps
                });
            } else trace?.sync(()=>({
                    decision: 'no-op',
                    path: 'applyDiffSteps',
                    reconciler: {
                        stepCount: 0,
                        interveningStepCount: interveningStepCount
                    }
                }));
        } catch (err) {
            if ((0, $iDrrr.fg)('platform_editor_md_mode_rebase_fallback')) {
                // If surgical rebasing fails, keep the user's source edit saveable by
                // falling back to the legacy whole-document writeback for this flush.
                // This can happen after large paste/replace edits where the diff's
                // positional steps no longer map cleanly onto the live PM document.
                try {
                    $f351bab582830cfa$var$replaceWithConvertedDoc(editorView, paddedAdfNode);
                } catch (fallbackErr) {
                    trace?.sync(()=>({
                            decision: 'reseeded',
                            path: 'replaceWith',
                            note: 'fallback-after-rebase-failure-failed',
                            reconciler: {
                                reseedReason: 'rebase-failure',
                                reconcilerError: fallbackErr instanceof Error ? fallbackErr.message : String(fallbackErr)
                            }
                        }));
                    sourceWritebackErrorRef.current?.({
                        error: fallbackErr,
                        reason: 'rebase-fallback-error',
                        source: 'live'
                    });
                    seedPmDocRef.current = editorView.state.doc;
                    interveningMappingRef.current = new (0, $eOaGc.Mapping)();
                    return;
                }
                trace?.sync(()=>({
                        decision: 'replaced',
                        path: 'replaceWith',
                        note: 'fallback-after-rebase-failure',
                        reconciler: {
                            reseedReason: 'rebase-failure',
                            reconcilerError: err instanceof Error ? err.message : String(err)
                        }
                    }));
                seedPmDocRef.current = editorView.state.doc;
                interveningMappingRef.current = new (0, $eOaGc.Mapping)();
                setPostWritebackAdfDoc(editorView.state.doc.toJSON());
                return;
            }
            // Gate off: keep the original recover-by-reseed behavior. The next
            // flush diffs against the live doc; CM6 keeps the user's source text
            // intact and just sees a wider userDiff next round.
            reseedAfterRebaseFailure(trace, err);
        }
    }, [
        editorView,
        reseedAfterRebaseFailure
    ]);
    /**
   * Called by MarkdownSourceView on unmount / revision change when the
   * user actually edited the buffer (Tier 0 — batch commit). Applies the
   * delta as surgical steps via the same path as handleSourceMarkdownChange.
   */ const handleMarkdownCommit = (0, $cozmU.useCallback)((finalMarkdown)=>{
        if (!editorView || editorView.isDestroyed) return;
        const seedDoc = seedPmDocRef.current;
        if (!seedDoc) return;
        const trace = (0, $5e1679443117df1d$export$de8e565f923f53f9).begin('commit');
        let fallbackAdfNode = null;
        try {
            // MarkdownSourceView's per-seed guard only catches open-then-close-
            // without-typing. Live WYSIWYG updates flow into the source buffer via
            // the dispatch tap, so finalMarkdown can differ from the seed yet still
            // round-trip to the current live doc.
            try {
                const { markdown: liveMarkdown } = (0, $5nazv.adfToMarkdown)(editorView.state.doc, editorView.state.schema, {
                    serializeFileMedia: serializeFileMediaRef.current
                });
                if (liveMarkdown === finalMarkdown) {
                    trace?.sync(()=>({
                            decision: 'reseeded',
                            path: 'applyDiffSteps',
                            reconciler: {
                                reseedReason: 'round-trip-match',
                                interveningStepCount: interveningMappingRef.current.maps.length
                            }
                        }));
                    seedPmDocRef.current = editorView.state.doc;
                    interveningMappingRef.current = new (0, $eOaGc.Mapping)();
                    return;
                }
            } catch (err) {
            // fall through to diff path
            }
            let adfNode;
            try {
                adfNode = (0, $5nazv.markdownToAdf)(finalMarkdown, editorView.state.schema);
            } catch (err) {
                // A parse error here is distinct from the positional rebase failure
                // the outer catch handles. Record it as 'parse-error' (mirroring
                // handleSourceMarkdownChange) so sync-level reseedReason filtering is
                // reliable on the commit path too — not just the source-change path.
                trace?.sync(()=>({
                        decision: 'reseeded',
                        path: 'applyDiffSteps',
                        reconciler: {
                            reseedReason: 'parse-error'
                        }
                    }));
                if ((0, $iDrrr.fg)('platform_editor_md_mode_rebase_fallback')) sourceWritebackErrorRef.current?.({
                    error: err,
                    reason: 'parse-error',
                    source: 'commit'
                });
                seedPmDocRef.current = editorView.state.doc;
                interveningMappingRef.current = new (0, $eOaGc.Mapping)();
                // eslint-disable-next-line no-console
                console.warn('[MarkdownModeContentComponentDiff] Failed to parse markdown source edits; discarding change.', err);
                return;
            }
            const oldDocForCallback = editorView.state.doc;
            const paddedAdfNode = (0, $51eaa0d358e75b0f$export$cecc4bbbdf07f0bc)(oldDocForCallback, adfNode);
            fallbackAdfNode = paddedAdfNode;
            const interveningStepCount = interveningMappingRef.current.maps.length;
            const tr = (0, $68b04ed0ed4951fc$export$c0dd7bd7f3654863)(editorView, seedDoc, paddedAdfNode, interveningMappingRef.current, {
                ignoreMarkTypes: $f351bab582830cfa$var$RECONCILER_IGNORE_MARK_TYPES
            });
            if (tr) {
                trace?.sync(()=>$f351bab582830cfa$var$buildDiffAppliedSync(tr, oldDocForCallback, editorView.state.doc, interveningStepCount));
                seedPmDocRef.current = editorView.state.doc;
                interveningMappingRef.current = new (0, $eOaGc.Mapping)();
                setPostWritebackAdfDoc(editorView.state.doc.toJSON());
                onDiffStepsAppliedRef.current?.({
                    markdown: finalMarkdown,
                    newDoc: paddedAdfNode,
                    oldDoc: oldDocForCallback,
                    source: 'commit',
                    steps: tr.steps
                });
            } else trace?.sync(()=>({
                    decision: 'no-op',
                    path: 'applyDiffSteps',
                    reconciler: {
                        stepCount: 0,
                        interveningStepCount: interveningStepCount
                    }
                }));
        } catch (err) {
            // markdownToAdf now has its own parse-error catch above, so reaching
            // here means applyDiffSteps failed to rebase the delta onto the live
            // doc.
            if ((0, $iDrrr.fg)('platform_editor_md_mode_rebase_fallback')) {
                // Gate on: preserve the commit by falling back to a whole-document
                // writeback, matching the non-reconciler markdown mode path.
                if (!fallbackAdfNode) {
                    // The rebase threw before a fallback document was prepared (e.g.
                    // padding failed), so there is nothing to write back. Reseed and
                    // surface the failure instead of discarding it silently, matching
                    // the other terminal branches in this catch.
                    trace?.sync(()=>({
                            decision: 'reseeded',
                            path: 'applyDiffSteps',
                            note: 'rebase-failure-no-fallback-node',
                            reconciler: {
                                reseedReason: 'rebase-failure',
                                reconcilerError: err instanceof Error ? err.message : String(err)
                            }
                        }));
                    sourceWritebackErrorRef.current?.({
                        error: err,
                        reason: 'writeback-error',
                        source: 'commit'
                    });
                    seedPmDocRef.current = editorView.state.doc;
                    interveningMappingRef.current = new (0, $eOaGc.Mapping)();
                    // eslint-disable-next-line no-console
                    console.warn('[MarkdownModeContentComponentDiff] Reconciler writeback failed before a fallback document was prepared; discarding change.', err);
                    return;
                }
                try {
                    $f351bab582830cfa$var$replaceWithConvertedDoc(editorView, fallbackAdfNode);
                } catch (fallbackErr) {
                    trace?.sync(()=>({
                            decision: 'reseeded',
                            path: 'replaceWith',
                            note: 'fallback-after-rebase-failure-failed',
                            reconciler: {
                                reseedReason: 'rebase-failure',
                                reconcilerError: fallbackErr instanceof Error ? fallbackErr.message : String(fallbackErr)
                            }
                        }));
                    sourceWritebackErrorRef.current?.({
                        error: fallbackErr,
                        reason: 'rebase-fallback-error',
                        source: 'commit'
                    });
                    seedPmDocRef.current = editorView.state.doc;
                    interveningMappingRef.current = new (0, $eOaGc.Mapping)();
                    return;
                }
                trace?.sync(()=>({
                        decision: 'replaced',
                        path: 'replaceWith',
                        note: 'fallback-after-rebase-failure',
                        reconciler: {
                            reseedReason: 'rebase-failure',
                            reconcilerError: err instanceof Error ? err.message : String(err)
                        }
                    }));
                seedPmDocRef.current = editorView.state.doc;
                interveningMappingRef.current = new (0, $eOaGc.Mapping)();
                setPostWritebackAdfDoc(editorView.state.doc.toJSON());
                // eslint-disable-next-line no-console
                console.warn('[MarkdownModeContentComponentDiff] Reconciler writeback failed; applied markdown source edits with full-document fallback.', err);
                return;
            }
            // Gate off: keep the original recover-by-reseed behavior. This can
            // discard the current commit, but preserves the pre-existing
            // reconciler behavior while the fallback is gated.
            reseedAfterRebaseFailure(trace, err);
            // eslint-disable-next-line no-console
            console.warn('[MarkdownModeContentComponentDiff] Failed to apply markdown source edits back to the editor; discarding change.', err);
        }
    }, [
        editorView,
        reseedAfterRebaseFailure
    ]);
    // Register a round-trip probe for the console `roundTrip()` helper, which
    // needs the live editor schema. The reconciler orchestrator is the sole
    // content-writeback path, so without this `roundTrip()` would wrongly
    // report "No editor registered". No-op when the tracer gate is off.
    (0, $cozmU.useEffect)(()=>{
        const tracer = (0, $5e1679443117df1d$export$de8e565f923f53f9).getInstance();
        if (!tracer || !editorView || editorView.isDestroyed) return;
        tracer.registerProbe((input)=>{
            if (editorView.isDestroyed) return {
                error: 'editor destroyed'
            };
            const schema = editorView.state.schema;
            if (typeof input === 'string') {
                const adf = (0, $5nazv.markdownToAdf)(input, schema);
                const { markdown: markdown } = (0, $5nazv.adfToMarkdown)(adf, schema, {
                    serializeFileMedia: serializeFileMediaRef.current
                });
                return {
                    adf: adf.toJSON(),
                    markdown: markdown,
                    match: markdown === input
                };
            }
            const node = schema.nodeFromJSON(input);
            const { markdown: markdown } = (0, $5nazv.adfToMarkdown)(node, schema, {
                serializeFileMedia: serializeFileMediaRef.current
            });
            return {
                adf: (0, $5nazv.markdownToAdf)(markdown, schema).toJSON(),
                markdown: markdown
            };
        });
        return ()=>tracer.registerProbe(null);
    }, [
        editorView
    ]);
    // Hide the WYSIWYG ProseMirror DOM in syntax and split-view modes. The
    // platform's `FullPageContentArea` attempts this via
    // `hideEditorContentAreaProsemirrorStyle`, but that style is gated on the
    // `cc-markdown-mode` experiment AND on the plugin's PM state being in sync
    // — either can fail on first paint, leaving both the source CodeMirror
    // and the underlying ProseMirror visible (with floating toolbars leaking
    // through). Scoped to this plugin's `editorView.dom`; original `display`
    // is restored on cleanup. Blur on leaving preview dismisses
    // selection-anchored floating UI (code-block toolbar, table controls).
    (0, $cozmU.useEffect)(()=>{
        if (!editorView || editorView.isDestroyed) return;
        if (markdownView === 'preview') return;
        const dom = editorView.dom;
        const originalDisplay = dom.style.display;
        dom.style.display = 'none';
        // Guard against blur throwing on a destroyed view.
        try {
            if (editorView.hasFocus()) dom.blur();
        } catch  {
        // no-op
        }
        return ()=>{
            if (!editorView.isDestroyed) dom.style.display = originalDisplay;
        };
    }, [
        markdownView,
        editorView
    ]);
    // ---------------------------------------------------------------
    // Render
    // ---------------------------------------------------------------
    const isPreview = markdownView === 'preview';
    if (isPreview) return null;
    const PreviewComponent = config.previewComponent;
    // Resolve the gate once per render so paired props stay consistent and
    // we don't fire duplicate exposures.
    const compatibleToolbarEnabled = (0, $iDrrr.fg)('platform_editor_markdown_compatible_toolbar');
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            markdownView === 'syntax' && (snapshotRevision > 0 || !(0, $iDrrr.fg)('platform_editor_md_source_sync_snapshot')) && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $44754940e72df3bb$export$eb7c1c6ff6845883), {
                contentId: config.contentId,
                initialAdfDoc: adfDoc,
                seedMarkdown: seedMarkdown,
                schema: editorView.state.schema,
                revision: snapshotRevision,
                liveAdfDoc: liveAdfDoc,
                postWritebackAdfDoc: postWritebackAdfDoc,
                onSourceMarkdownChange: handleSourceMarkdownChange,
                onMarkdownCommit: handleMarkdownCommit,
                serializeFileMedia: config.serializeFileMedia,
                sourceChangeDebounceMs: config.sourceChangeDebounceMs,
                annotationRanges: annotationRanges,
                onAnnotationClick: handleAnnotationClick,
                onRegisterCommandDispatch: compatibleToolbarEnabled ? handleRegisterCommandDispatch : undefined,
                onSourceFormatStateChange: compatibleToolbarEnabled ? handleSourceFormatStateChange : undefined,
                onSourcePositionStateChange: handleSourcePositionStateChange,
                onShowLineNumbersChange: handleShowSourceLineNumbersChange,
                showLineNumbers: showSourceLineNumbers,
                onWrapCodeChange: handleWrapCodeChange,
                wrapCode: wrapSourceCode
            }),
            markdownView === 'split-view' && PreviewComponent && /*#__PURE__*/ (0, $8aG6j.jsx)(PreviewComponent, {
                adfDoc: liveAdfDoc ?? adfDoc
            }, `preview-${snapshotRevision}`)
        ]
    });
};


/* MarkdownModeViewToggle.tsx generated by @compiled/babel-plugin v3.0.1 */ 












var $ldqjS = parcelRequire("ldqjS");





var $6t3CY = parcelRequire("6t3CY");

var $cE5a1 = parcelRequire("cE5a1");

var $lslMH = parcelRequire("lslMH");


var $2HIrf = parcelRequire("2HIrf");


var $4R6R9 = parcelRequire("4R6R9");


var $6YkHb = parcelRequire("6YkHb");




const $9945c9978fff44c4$var$styles = {
    wrapper: "_10qCvKrzt2 _0xOCXhNvrM _41OGv76wH8 _41KQCPcM5X"
}; // ---------------------------------------------------------------------------
const $9945c9978fff44c4$export$dfbf3d9b6d36cb67 = ({ view: view, onViewChange: onViewChange })=>{
    const intl = (0, $kSwu1.useIntl)();
    const handleClick = (0, $cozmU.useCallback)((nextView)=>{
        if (nextView === view) return;
        onViewChange(nextView);
    }, [
        view,
        onViewChange
    ]); // Stable per-view click handlers so the IconButtons receive a referentially
    // equal `onClick` prop across renders (avoids breaking memoisation in the
    // IconButton subtree). `handleClick` itself is already memoised on
    // (view, onViewChange).
    const handleSyntaxClick = (0, $cozmU.useCallback)(()=>handleClick('syntax'), [
        handleClick
    ]);
    const handlePreviewClick = (0, $cozmU.useCallback)(()=>handleClick('preview'), [
        handleClick
    ]);
    const handleSplitViewClick = (0, $cozmU.useCallback)(()=>handleClick('split-view'), [
        handleClick
    ]);
    const syntaxLabel = intl.formatMessage((0, $2VjJa.markdownModeMessages).source);
    const previewLabel = intl.formatMessage((0, $2VjJa.markdownModeMessages).wysiwyg); // Note: i18n message keys (`i18n.source`, `i18n.sourceAriaLabel`) are
    // intentionally left as-is to preserve translation memory for the
    // 'Syntax editor' / 'Markdown source' strings already in production.
    const splitViewLabel = intl.formatMessage((0, $2VjJa.markdownModeMessages).preview);
    const groupLabel = intl.formatMessage((0, $2VjJa.markdownModeMessages).groupLabel);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $9945c9978fff44c4$var$styles.wrapper,
        role: "group",
        "aria-label": groupLabel,
        testId: "markdown-mode-view-toggle",
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cE5a1.ToolbarSection), {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
                    content: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
                        description: syntaxLabel,
                        keymap: view === 'preview' ? (0, $ldqjS.toggleMarkdownView) : undefined
                    }),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6t3CY.ToolbarButton), {
                        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))), {
                            size: "small",
                            label: syntaxLabel
                        }),
                        label: syntaxLabel,
                        isSelected: view === 'syntax',
                        onClick: handleSyntaxClick,
                        testId: "markdown-mode-view-toggle--syntax",
                        ariaKeyshortcuts: view === 'preview' ? (0, $ldqjS.toggleMarkdownView).description : undefined
                    })
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
                    content: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
                        description: previewLabel,
                        keymap: view === 'syntax' ? (0, $ldqjS.toggleMarkdownView) : undefined
                    }),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6t3CY.ToolbarButton), {
                        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2HIrf))), {
                            size: "small",
                            label: previewLabel
                        }),
                        label: previewLabel,
                        isSelected: view === 'preview',
                        onClick: handlePreviewClick,
                        testId: "markdown-mode-view-toggle--preview",
                        ariaKeyshortcuts: view === 'syntax' ? (0, $ldqjS.toggleMarkdownView).description : undefined
                    })
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
                    content: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
                        description: splitViewLabel
                    }),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6t3CY.ToolbarButton), {
                        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4R6R9))), {
                            size: "small",
                            label: splitViewLabel
                        }),
                        label: splitViewLabel,
                        isSelected: view === 'split-view',
                        onClick: handleSplitViewClick,
                        testId: "markdown-mode-view-toggle--split-view",
                        isDisabled: true
                    })
                })
            ]
        })
    });
};
const $9945c9978fff44c4$export$aa32935aa228c6fd = ({ api: api })=>{
    const { view: view, isMarkdownMode: isMarkdownMode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'markdownMode'
    ], (states)=>({
            view: states.markdownModeState?.view ?? 'preview',
            isMarkdownMode: states.markdownModeState?.isMarkdownMode ?? false
        }));
    const handleViewChange = (0, $cozmU.useCallback)((nextView)=>{
        api?.markdownMode?.actions.setView(nextView);
    }, [
        api
    ]);
    if (!isMarkdownMode) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)($9945c9978fff44c4$export$dfbf3d9b6d36cb67, {
        view: view,
        onViewChange: handleViewChange
    });
};


const $7021814cb7ec0e06$var$HEADING_SOURCE_VIEW_COMMANDS = {
    1: (0, $b8e7170495150c53$export$4e0d444e5782abea),
    2: (0, $b8e7170495150c53$export$b8d734de6aecb0a3),
    3: (0, $b8e7170495150c53$export$df05910f74b29e0),
    4: (0, $b8e7170495150c53$export$ca48da5fbbd68542),
    5: (0, $b8e7170495150c53$export$1335885ed6c2d3ac),
    6: (0, $b8e7170495150c53$export$8381ca7ddcf8db0d)
};
// so a floating selection toolbar has nothing to anchor to.
const $7021814cb7ec0e06$var$contextualFormattingOverrideForView = (view, isLivePage)=>{
    if ((0, $iDrrr.fg)('platform_editor_markdown_patch_m3')) return view === 'preview' && isLivePage ? 'controlled' : 'always-pinned';
    return view === 'preview' ? 'controlled' : 'always-pinned';
}; // Mirrors `selection-toolbar/PrimaryToolbarComponent`: prefers
// `userPreferences.toolbarDockingPosition` when the new plugin is enabled,
// otherwise falls back to `selectionToolbar.toolbarDocking`. In source /
// preview view the primary toolbar is forcibly pinned via the toolbar
// override (see `setView` below), so we treat the toolbar as docked-to-top
// regardless of the user's saved preference — otherwise the view-switcher
// renders in-content while the toolbar is actually pinned at the top.
const $7021814cb7ec0e06$var$useIsToolbarDockedToTop = (api)=>{
    const { dockingPositionFromPrefs: dockingPositionFromPrefs, dockingFromSelectionToolbar: dockingFromSelectionToolbar, isLivePage: isLivePage, view: view } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'userPreferences',
        'selectionToolbar',
        'markdownMode'
    ], (states)=>({
            dockingPositionFromPrefs: states.userPreferencesState?.preferences?.toolbarDockingPosition,
            dockingFromSelectionToolbar: states.selectionToolbarState?.toolbarDocking,
            isLivePage: states.markdownModeState?.isLivePage,
            view: states.markdownModeState?.view
        }));
    if (view && ((0, $iDrrr.fg)('platform_editor_markdown_patch_m3') ? view !== 'preview' || !isLivePage : view !== 'preview')) return true;
    if ((0, $iDrrr.fg)('platform_editor_use_preferences_plugin')) return dockingPositionFromPrefs === 'top';
    return dockingFromSelectionToolbar === 'top';
};
const $7021814cb7ec0e06$var$MarkdownModeContentComponentDiffWrapper = ({ editorView: editorView, config: config, api: api })=>{
    const hasReconciledPersistedViewRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(false); // Transient fallback: if the shared state hasn't hydrated yet, treat the
    // view as 'preview' so we don't briefly mount the syntax editor over the
    // PM editor. The authoritative initial view (which can be 'syntax') is
    // resolved upstream via `config.viewModePersistence.getInitialView` and
    // will populate `markdownModeState.view` once the plugin initialises.
    const currentView = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'markdownMode'
    ], (states)=>states.markdownModeState?.view ?? 'preview');
    const showSourceLineNumbers = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'markdownMode'
    ], (states)=>states.markdownModeState?.showSourceLineNumbers ?? true);
    const wrapSourceCode = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'markdownMode'
    ], (states)=>states.markdownModeState?.wrapSourceCode ?? true);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (hasReconciledPersistedViewRef.current) return;
        hasReconciledPersistedViewRef.current = true;
        const persistedView = config.viewModePersistence?.getInitialView?.();
        if (!persistedView || persistedView === currentView) return;
        api?.markdownMode?.actions.setView(persistedView);
    }, [
        api,
        config.viewModePersistence,
        currentView
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f351bab582830cfa$export$f6ff746d302c10e), {
                editorView: editorView,
                config: config,
                currentView: currentView,
                showSourceLineNumbers: showSourceLineNumbers,
                wrapSourceCode: wrapSourceCode,
                api: api
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)($7021814cb7ec0e06$export$5a3a24cc1474d9cc, {
                api: api
            })
        ]
    });
};
const $7021814cb7ec0e06$var$styles = {
    trailingSection: "_1mT5xdWVPG _1OKFqY8HPE _2I62gz715P _1VJPcakruI _3iDTPbQ4SZ _0hPCNLDIqT",
    inContentToggleStickyRow: "_1mT5xdy1CL _2I62gz2ADO _1OKFqYNHnM _42Yu6BgtVO _1pp6NdYbGa",
    inContentToggleAnchor: "_0bjKvD8fU6 _4c065U1Y8M _2Y7lL41Y8M _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0hPCNLDIqT _0KLXrulfZc _1pp6NdIZbP"
};
const $7021814cb7ec0e06$var$InToolbarToggle = ({ api: api })=>{
    const isDockedToTop = $7021814cb7ec0e06$var$useIsToolbarDockedToTop(api);
    if (!isDockedToTop) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $7021814cb7ec0e06$var$styles.trailingSection,
        testId: "markdown-mode-view-toggle-section",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9945c9978fff44c4$export$aa32935aa228c6fd), {
            api: api
        })
    });
};
const $7021814cb7ec0e06$export$5a3a24cc1474d9cc = ({ api: api })=>{
    const isDockedToTop = $7021814cb7ec0e06$var$useIsToolbarDockedToTop(api);
    if (isDockedToTop) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $7021814cb7ec0e06$var$styles.inContentToggleStickyRow,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $7021814cb7ec0e06$var$styles.inContentToggleAnchor,
            testId: "markdown-mode-view-toggle-in-content",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9945c9978fff44c4$export$aa32935aa228c6fd), {
                api: api
            })
        })
    });
};
const $7021814cb7ec0e06$var$buildToolbarComponents = (config, api)=>{
    if (!config?.isMarkdownMode) return [];
    return [
        {
            type: (0, $3nacY.VIEW_MODE_TOGGLE_SECTION).type,
            key: (0, $3nacY.VIEW_MODE_TOGGLE_SECTION).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $3nacY.TOOLBARS).PRIMARY_TOOLBAR,
                    rank: (0, $hVLmg.TOOLBAR_RANK)[(0, $3nacY.VIEW_MODE_TOGGLE_SECTION).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)($7021814cb7ec0e06$var$InToolbarToggle, {
                    api: api
                })
        }
    ];
};
const $7021814cb7ec0e06$export$f3055fdbf3cad094 = ({ config: config, api: api })=>{
    let editorView;
    let sourceCommandDispatch = null;
    const dispatchSource = (cmd)=>{
        if (!(0, $iDrrr.fg)('platform_editor_markdown_compatible_toolbar')) return false;
        if (!sourceCommandDispatch) return false;
        return sourceCommandDispatch(cmd);
    };
    const setEditorView = (newEditorView)=>{
        editorView = newEditorView;
    };
    const dispatchSourceFormatState = (formatState)=>{
        if (!editorView) return;
        editorView.dispatch(editorView.state.tr.setMeta((0, $9e7aa44e1133a0cd$export$160e35dbff8be862), {
            sourceBlockFormatState: formatState?.block ?? null,
            sourceInlineFormatState: formatState?.inline ?? null,
            sourceListFormatState: formatState?.list ?? null
        }));
    };
    const dispatchSourcePositionState = (positionState)=>{
        if (!editorView) return;
        editorView.dispatch(editorView.state.tr.setMeta((0, $9e7aa44e1133a0cd$export$160e35dbff8be862), {
            sourcePositionState: positionState
        }));
    };
    const dispatchShowSourceLineNumbers = (showSourceLineNumbers)=>{
        if (!editorView) return;
        editorView.dispatch(editorView.state.tr.setMeta((0, $9e7aa44e1133a0cd$export$160e35dbff8be862), {
            showSourceLineNumbers: showSourceLineNumbers
        }));
    };
    const dispatchWrapSourceCode = (wrapSourceCode)=>{
        if (!editorView) return;
        editorView.dispatch(editorView.state.tr.setMeta((0, $9e7aa44e1133a0cd$export$160e35dbff8be862), {
            wrapSourceCode: wrapSourceCode
        }));
    }; // Resolve the initial view ONCE, at plugin construction time — not in
    // `init()`, which re-runs on `state.reconfigure` and would clobber any
    // in-flight user choice on every preset rebuild.
    //
    // When the initial view is browser-persisted, SSR cannot know the stored
    // value. Keep SSR and the first hydrating client render on the deterministic
    // default, then reconcile the persisted value from the content component's
    // mount effect.
    const initialView = 'syntax';
    api?.toolbar?.actions.registerComponents($7021814cb7ec0e06$var$buildToolbarComponents(config, api));
    return {
        name: 'markdownMode',
        getSharedState (editorState) {
            if (!editorState) return {
                view: initialView,
                isLivePage: config?.isLivePage ?? false,
                isMarkdownMode: config?.isMarkdownMode ?? false,
                showSourceLineNumbers: true,
                wrapSourceCode: true,
                sourceInlineFormatState: null,
                sourceBlockFormatState: null,
                sourceListFormatState: null,
                sourcePositionState: null
            };
            return (0, $9e7aa44e1133a0cd$export$160e35dbff8be862).getState(editorState) ?? {
                view: initialView,
                isLivePage: config?.isLivePage ?? false,
                isMarkdownMode: config?.isMarkdownMode ?? false,
                showSourceLineNumbers: true,
                wrapSourceCode: true,
                sourceInlineFormatState: null,
                sourceBlockFormatState: null,
                sourceListFormatState: null,
                sourcePositionState: null
            };
        },
        actions: {
            setView (view) {
                if (!editorView) return;
                const prevView = (0, $9e7aa44e1133a0cd$export$160e35dbff8be862).getState(editorView.state)?.view ?? initialView;
                if (prevView === view) return;
                const tr = editorView.state.tr;
                api?.toolbar?.commands.setContextualFormattingModeOverride($7021814cb7ec0e06$var$contextualFormattingOverrideForView(view, config?.isLivePage))({
                    tr: tr
                });
                tr.setMeta((0, $9e7aa44e1133a0cd$export$160e35dbff8be862), {
                    view: view
                });
                editorView.dispatch(tr);
                config?.viewModePersistence?.onViewChange?.(view, prevView);
            },
            dispatchSourceCommand: dispatchSource,
            insertSourceTable: (rowsCount, colsCount)=>dispatchSource((0, $b8e7170495150c53$export$feb50cc511a53ca1)(rowsCount, colsCount)),
            toggleSourceBlockquote: ()=>dispatchSource((0, $b8e7170495150c53$export$2cd68375ac1e5429)),
            toggleSourceBulletList: ()=>dispatchSource((0, $b8e7170495150c53$export$71c898cbdfd51c6e)),
            toggleSourceOrderedList: ()=>dispatchSource((0, $b8e7170495150c53$export$744c9722bde8c6b3)),
            toggleSourceTaskList: ()=>dispatchSource((0, $b8e7170495150c53$export$49b8416aa3f9522a)),
            toggleSourceHeading: (level)=>dispatchSource($7021814cb7ec0e06$var$HEADING_SOURCE_VIEW_COMMANDS[level]),
            toggleSourceBold: ()=>dispatchSource((0, $b8e7170495150c53$export$b850a936f66192a3)),
            toggleSourceItalic: ()=>dispatchSource((0, $b8e7170495150c53$export$227b5ef404be9031)),
            toggleSourceInlineCode: ()=>dispatchSource((0, $b8e7170495150c53$export$e7d955a85cfe503c)),
            toggleSourceStrike: ()=>dispatchSource((0, $b8e7170495150c53$export$a46d65f808b4881d)),
            registerSourceCommandDispatch (dispatcher) {
                if (!(0, $iDrrr.fg)('platform_editor_markdown_compatible_toolbar')) return;
                sourceCommandDispatch = dispatcher;
            },
            setSourceBlockFormatState (formatState) {
                if (!(0, $iDrrr.fg)('platform_editor_markdown_compatible_toolbar') || !editorView) return;
                editorView.dispatch(editorView.state.tr.setMeta((0, $9e7aa44e1133a0cd$export$160e35dbff8be862), {
                    sourceBlockFormatState: formatState
                }));
            },
            setSourceFormatState (formatState) {
                if (!(0, $iDrrr.fg)('platform_editor_markdown_compatible_toolbar')) return;
                dispatchSourceFormatState(formatState);
            },
            setSourceInlineFormatState (formatState) {
                if (!(0, $iDrrr.fg)('platform_editor_markdown_compatible_toolbar') || !editorView) return;
                editorView.dispatch(editorView.state.tr.setMeta((0, $9e7aa44e1133a0cd$export$160e35dbff8be862), {
                    sourceInlineFormatState: formatState
                }));
            },
            setSourceListFormatState (formatState) {
                if (!(0, $iDrrr.fg)('platform_editor_markdown_compatible_toolbar') || !editorView) return;
                editorView.dispatch(editorView.state.tr.setMeta((0, $9e7aa44e1133a0cd$export$160e35dbff8be862), {
                    sourceListFormatState: formatState
                }));
            },
            setSourcePositionState (positionState) {
                dispatchSourcePositionState(positionState);
            },
            setShowSourceLineNumbers (showSourceLineNumbers) {
                dispatchShowSourceLineNumbers(showSourceLineNumbers);
            },
            setWrapSourceCode (wrapSourceCode) {
                dispatchWrapSourceCode(wrapSourceCode);
            }
        },
        contentComponent ({ editorView: contentEditorView }) {
            if (!config?.isMarkdownMode || !contentEditorView) return null;
            return /*#__PURE__*/ (0, $8aG6j.jsx)($7021814cb7ec0e06$var$MarkdownModeContentComponentDiffWrapper, {
                editorView: contentEditorView,
                config: config,
                api: api
            });
        },
        pmPlugins () {
            return [
                {
                    name: 'markdownModeState',
                    plugin: ()=>{
                        return new (0, $kpCD8.SafePlugin)({
                            key: (0, $9e7aa44e1133a0cd$export$160e35dbff8be862),
                            state: {
                                init: ()=>({
                                        view: initialView,
                                        isLivePage: config?.isLivePage ?? false,
                                        isMarkdownMode: config?.isMarkdownMode ?? false,
                                        showSourceLineNumbers: true,
                                        wrapSourceCode: true,
                                        sourceInlineFormatState: null,
                                        sourceBlockFormatState: null,
                                        sourceListFormatState: null,
                                        sourcePositionState: null
                                    }),
                                apply (tr, currentState) {
                                    const meta = tr.getMeta((0, $9e7aa44e1133a0cd$export$160e35dbff8be862));
                                    if (meta) return {
                                        ...currentState,
                                        ...meta.view !== undefined ? {
                                            view: meta.view
                                        } : {},
                                        ...meta.showSourceLineNumbers !== undefined ? {
                                            showSourceLineNumbers: meta.showSourceLineNumbers
                                        } : {},
                                        ...meta.wrapSourceCode !== undefined ? {
                                            wrapSourceCode: meta.wrapSourceCode
                                        } : {},
                                        ...meta.sourceInlineFormatState !== undefined ? {
                                            sourceInlineFormatState: meta.sourceInlineFormatState
                                        } : {},
                                        ...meta.sourceBlockFormatState !== undefined ? {
                                            sourceBlockFormatState: meta.sourceBlockFormatState
                                        } : {},
                                        ...meta.sourceListFormatState !== undefined ? {
                                            sourceListFormatState: meta.sourceListFormatState
                                        } : {},
                                        ...meta.sourcePositionState !== undefined ? {
                                            sourcePositionState: meta.sourcePositionState
                                        } : {}
                                    };
                                    return currentState;
                                }
                            },
                            view (newEditorView) {
                                setEditorView(newEditorView);
                                let destroyed = false; // Seed the toolbar override on first mount so a page that
                                // opens straight into source/preview pins the toolbar without
                                // needing a user-triggered `setView`.
                                if (config?.isMarkdownMode) // Deferred to a microtask: dispatching synchronously inside
                                // `view()` is a PM re-entry hazard — the meta can be dropped
                                // before downstream plugins' `apply()` runs. By the next
                                // microtask the editor is fully constructed and dispatch is safe.
                                // The `destroyed` guard prevents dispatching on a torn-down
                                // view if `destroy()` runs before the microtask fires (e.g.
                                // React StrictMode double-mount).
                                Promise.resolve().then(()=>{
                                    if (destroyed) return;
                                    const tr = newEditorView.state.tr;
                                    const viewForOverride = (0, $iDrrr.fg)('platform_editor_markdown_patch_m3') ? // Read the latest markdown view from plugin state at microtask
                                    // time. During page transitions, relying on the static SSR
                                    // default (`initialView`) can briefly seed the wrong override.
                                    (0, $9e7aa44e1133a0cd$export$160e35dbff8be862).getState(newEditorView.state)?.view ?? initialView : initialView;
                                    api?.toolbar?.commands.setContextualFormattingModeOverride($7021814cb7ec0e06$var$contextualFormattingOverrideForView(viewForOverride, config?.isLivePage))({
                                        tr: tr
                                    });
                                    newEditorView.dispatch(tr);
                                });
                                 // Register a global keydown listener for the toggle shortcut.
                                // We use document-level rather than a PM keymap because in
                                // source view the PM editor is hidden/blurred and PM keymaps
                                // never fire.
                                const handler = (0, $6ac889fd0f465b1a$export$ed529ff4eb54147f)(api, ()=>editorView);
                                const doc = (0, $1hQ0e.getDocument)();
                                const unbind = doc ? (0, $cbY7C.bind)(doc, {
                                    type: 'keydown',
                                    listener: handler
                                }) : ()=>{};
                                return {
                                    destroy () {
                                        destroyed = true;
                                        unbind();
                                    }
                                };
                            }
                        });
                    }
                }
            ];
        }
    };
};
module.exports["markdownModePlugin"] = $7021814cb7ec0e06$export$f3055fdbf3cad094;

});

parcelRegister("9ta51", function(module, exports) {
const $da89658923f179a9$export$13f2d1f50f16890a = [
    // Hyperlinks → `[text](url)`
    'hyperlink',
    // Tables → GFM tables
    'table',
    // Headings → `#`/`##`/`###`/...
    'heading1',
    'heading2',
    'heading3',
    'heading4',
    'heading5',
    'heading6',
    // Code blocks → ` ``` `
    'codeblock',
    // Block quote → `>`
    'blockquote',
    // Lists → `-`/`*`/`1.` and task lists → `- [x]`
    'unorderedList',
    'orderedList',
    'action',
    // Horizontal rule → `---`
    'rule',
    // Media — EDITOR-6636: `mediaSingle` + `media` now round-trip cleanly
    // through the markdown pipeline.
    //   - `type: "external"` → `![alt](https://…)` verbatim.
    //   - `type: "file"`     → `![alt](/wiki/download/attachments/{contentId}/{name})`
    //                          (Confluence tenant proxy URL, auth via session cookie).
    //
    // NOTE: Confluence uses `editor-plugin-media-insert` (the newer flow),
    // which registers the quick-insert item with id `'media-insert'` — NOT
    // `'media'` (which is the legacy media plugin's id used when mediaInsert
    // is absent). Both are allowlisted here for compatibility.
    'media-insert',
    'media'
];
const $da89658923f179a9$export$5775271e6e45828a = new Set($da89658923f179a9$export$13f2d1f50f16890a);
const $da89658923f179a9$export$a2dbfb573dc4efa5 = (item)=>{
    if (!item.id) return false;
    return $da89658923f179a9$export$5775271e6e45828a.has(item.id);
};
module.exports["isMarkdownCompatibleQuickInsertItem"] = $da89658923f179a9$export$a2dbfb573dc4efa5;

});

parcelRegister("aqPDM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4546d3e5054497daf7b66a2a9b41db25>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $798463d0df385ce1$var$_react = $798463d0df385ce1$var$_interopRequireDefault((parcelRequire("cozmU")));

var $798463d0df385ce1$var$_iconNew = $798463d0df385ce1$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $798463d0df385ce1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DiagramSymbolAction".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/diagram-symbol-action
 * Usage guidance:
 * Reserved for action diagram symbol.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $798463d0df385ce1$var$DiagramSymbolActionIcon = (props)=>/*#__PURE__*/ $798463d0df385ce1$var$_react.default.createElement($798463d0df385ce1$var$_iconNew.default, Object.assign({
        name: "DiagramSymbolActionIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1.5 12.5h13v-9h-13zm14.5.125c0 .76-.616 1.375-1.375 1.375H1.375C.615 14 0 13.384 0 12.625v-9.25C0 2.615.616 2 1.375 2h13.25C15.385 2 16 2.616 16 3.375z"/>`
    }, props));
$798463d0df385ce1$var$DiagramSymbolActionIcon.displayName = 'DiagramSymbolActionIcon';
var $798463d0df385ce1$var$_default = module.exports.default = $798463d0df385ce1$var$DiagramSymbolActionIcon;

});

parcelRegister("BQuz7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e3b44251382593aa3e479ab021bf6b68>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $071c2ca1beb98528$var$_react = $071c2ca1beb98528$var$_interopRequireDefault((parcelRequire("cozmU")));

var $071c2ca1beb98528$var$_iconNew = $071c2ca1beb98528$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $071c2ca1beb98528$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ImageRatioAuto".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/image-ratio-auto
 * Usage guidance:
 * Known uses: Auto detect ratio in the image generation process
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $071c2ca1beb98528$var$ImageRatioAutoIcon = (props)=>/*#__PURE__*/ $071c2ca1beb98528$var$_react.default.createElement($071c2ca1beb98528$var$_iconNew.default, Object.assign({
        name: "ImageRatioAutoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1.5 12.5H6V8H1.5zm6 .125c0 .76-.616 1.375-1.375 1.375h-4.75C.615 14 0 13.384 0 12.625v-4.75C0 7.115.616 6.5 1.375 6.5h4.75c.76 0 1.375.616 1.375 1.375z"/><path fill="currentcolor" d="M16 12.625c0 .76-.616 1.375-1.375 1.375H9v-1.5h5.5v-9h-13V5H0V3.375C0 2.615.616 2 1.375 2h13.25C15.385 2 16 2.616 16 3.375z"/>`
    }, props));
$071c2ca1beb98528$var$ImageRatioAutoIcon.displayName = 'ImageRatioAutoIcon';
var $071c2ca1beb98528$var$_default = module.exports.default = $071c2ca1beb98528$var$ImageRatioAutoIcon;

});

parcelRegister("9OqiZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53ba51ab01fb54f92a042e3f1ab85fb2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $724d303f4e23bd1c$var$_react = $724d303f4e23bd1c$var$_interopRequireDefault((parcelRequire("cozmU")));

var $724d303f4e23bd1c$var$_iconNew = $724d303f4e23bd1c$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $724d303f4e23bd1c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ImageRatioNarrow".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/image-ratio-narrow
 * Usage guidance:
 * Known uses: Narrow image ratio
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $724d303f4e23bd1c$var$ImageRatioNarrowIcon = (props)=>/*#__PURE__*/ $724d303f4e23bd1c$var$_react.default.createElement($724d303f4e23bd1c$var$_iconNew.default, Object.assign({
        name: "ImageRatioNarrowIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5 14.5h6v-13H5zm7.5.125c0 .76-.616 1.375-1.375 1.375h-6.25c-.76 0-1.375-.616-1.375-1.375V1.375C3.5.615 4.116 0 4.875 0h6.25c.76 0 1.375.616 1.375 1.375z"/>`
    }, props));
$724d303f4e23bd1c$var$ImageRatioNarrowIcon.displayName = 'ImageRatioNarrowIcon';
var $724d303f4e23bd1c$var$_default = module.exports.default = $724d303f4e23bd1c$var$ImageRatioNarrowIcon;

});

parcelRegister("hGZx0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6e7335a32dfd35926c921516f5556e3d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ce1616c4d5baf721$var$_react = $ce1616c4d5baf721$var$_interopRequireDefault((parcelRequire("cozmU")));

var $ce1616c4d5baf721$var$_iconNew = $ce1616c4d5baf721$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $ce1616c4d5baf721$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ImageRatioPortrait".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/image-ratio-portrait
 * Usage guidance:
 * Known uses: Portrait image ratio
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ce1616c4d5baf721$var$ImageRatioPortraitIcon = (props)=>/*#__PURE__*/ $ce1616c4d5baf721$var$_react.default.createElement($ce1616c4d5baf721$var$_iconNew.default, Object.assign({
        name: "ImageRatioPortraitIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M3.5 14.5h9v-13h-9zm10.5.125c0 .76-.616 1.375-1.375 1.375h-9.25C2.615 16 2 15.384 2 14.625V1.375C2 .615 2.616 0 3.375 0h9.25C13.385 0 14 .616 14 1.375z"/>`
    }, props));
$ce1616c4d5baf721$var$ImageRatioPortraitIcon.displayName = 'ImageRatioPortraitIcon';
var $ce1616c4d5baf721$var$_default = module.exports.default = $ce1616c4d5baf721$var$ImageRatioPortraitIcon;

});

parcelRegister("4P0HA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::420bb8ab33e730f674ad3a512c5bab6f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $382c7841319d0f48$var$_react = $382c7841319d0f48$var$_interopRequireDefault((parcelRequire("cozmU")));

var $382c7841319d0f48$var$_iconNew = $382c7841319d0f48$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $382c7841319d0f48$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PaintBrush".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/paint-brush
 * Usage guidance:
 * Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $382c7841319d0f48$var$PaintBrushIcon = (props)=>/*#__PURE__*/ $382c7841319d0f48$var$_react.default.createElement($382c7841319d0f48$var$_iconNew.default, Object.assign({
        name: "PaintBrushIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5.75A.75.75 0 0 1 3.25 0h9.5a.75.75 0 0 1 .75.75V9a2 2 0 0 1-2 2H10v3a2 2 0 1 1-4 0v-3H4.5a2 2 0 0 1-2-2zM7.5 11v3a.5.5 0 0 0 1 0v-3zM4 1.5v5h8v-5h-1.5V4H9V1.5H7V3H5.5V1.5zM12 8H4v1a.5.5 0 0 0 .5.5h7A.5.5 0 0 0 12 9z" clip-rule="evenodd"/>`
    }, props));
$382c7841319d0f48$var$PaintBrushIcon.displayName = 'PaintBrushIcon';
var $382c7841319d0f48$var$_default = module.exports.default = $382c7841319d0f48$var$PaintBrushIcon;

});

parcelRegister("21wWN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df3465be38be39642f2888da784f90b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $17953b6bbab7a07f$var$_react = $17953b6bbab7a07f$var$_interopRequireDefault((parcelRequire("cozmU")));

var $17953b6bbab7a07f$var$_iconNew = $17953b6bbab7a07f$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $17953b6bbab7a07f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShapeRectangle".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/shape-rectangle
 * Usage guidance:
 * Rectangle shape tool in Whiteboards
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $17953b6bbab7a07f$var$ShapeRectangleIcon = (props)=>/*#__PURE__*/ $17953b6bbab7a07f$var$_react.default.createElement($17953b6bbab7a07f$var$_iconNew.default, Object.assign({
        name: "ShapeRectangleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 2.875c0-.76.616-1.375 1.375-1.375h10.25c.76 0 1.375.616 1.375 1.375v10.25c0 .76-.616 1.375-1.375 1.375H2.875c-.76 0-1.375-.616-1.375-1.375zM3 3v10h10V3z" clip-rule="evenodd"/>`
    }, props));
$17953b6bbab7a07f$var$ShapeRectangleIcon.displayName = 'ShapeRectangleIcon';
var $17953b6bbab7a07f$var$_default = module.exports.default = $17953b6bbab7a07f$var$ShapeRectangleIcon;

});

parcelRegister("ll8uR", function(module, exports) {
/**
 * While micromark is a lexer/tokenizer, the common case of going from markdown
 * to html is currently built in as this module, even though the parts can be
 * used separately to build ASTs, CSTs, or many other output formats.
 *
 * Having an HTML compiler built in is useful because it allows us to check for
 * compliancy to CommonMark, the de facto norm of markdown, specified in roughly
 * 600 input/output cases.
 *
 * This module has an interface that accepts lists of events instead of the
 * whole at once, however, because markdown can’t be truly streaming, we buffer
 * events before processing and outputting the final result.
 */ /**
 * @import {
 *   CompileContext,
 *   CompileData,
 *   CompileOptions,
 *   Compile,
 *   Definition,
 *   Event,
 *   Handle,
 *   HtmlExtension,
 *   LineEnding,
 *   NormalizedHtmlExtension,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @typedef Media
 * @property {boolean | undefined} [image]
 * @property {string | undefined} [labelId]
 * @property {string | undefined} [label]
 * @property {string | undefined} [referenceId]
 * @property {string | undefined} [destination]
 * @property {string | undefined} [title]
 */ 
var $cbxPV = parcelRequire("cbxPV");


var $bHIRo = parcelRequire("bHIRo");


var $gaqbL = parcelRequire("gaqbL");


var $eEM9l = parcelRequire("eEM9l");

const $138cecc367c1b75e$var$characterReferences = {
    '"': 'quot',
    '&': 'amp',
    '<': 'lt',
    '>': 'gt'
};
function $138cecc367c1b75e$export$c564cdbbe6da493(value) {
    return value.replace(/["&<>]/g, replace);
    /**
   * @param {string} value
   *   Value to replace.
   * @returns {string}
   *   Encoded value.
   */ function replace(value) {
        return '&' + $138cecc367c1b75e$var$characterReferences[/** @type {keyof typeof characterReferences} */ value] + ';';
    }
}



var $fEgdu = parcelRequire("fEgdu");


var $5RE1E = parcelRequire("5RE1E");


function $14f90a1c08770ea5$export$d130a2d684099e5a(url, protocol) {
    const value = (0, $138cecc367c1b75e$export$c564cdbbe6da493)($14f90a1c08770ea5$export$e42a3e39590d28b5(url || ''));
    if (!protocol) return value;
    const colon = value.indexOf(':');
    const questionMark = value.indexOf('?');
    const numberSign = value.indexOf('#');
    const slash = value.indexOf('/');
    if (// If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))) return value;
    return '';
}
function $14f90a1c08770ea5$export$e42a3e39590d28b5(value) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    let start = 0;
    let skip = 0;
    while(++index < value.length){
        const code = value.charCodeAt(index);
        /** @type {string} */ let replace = '';
        // A correct percent encoded value.
        if (code === 37 && (0, $5RE1E.asciiAlphanumeric)(value.charCodeAt(index + 1)) && (0, $5RE1E.asciiAlphanumeric)(value.charCodeAt(index + 2))) skip = 2;
        else if (code < 128) {
            if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) replace = String.fromCharCode(code);
        } else if (code > 55295 && code < 57344) {
            const next = value.charCodeAt(index + 1);
            // A correct surrogate pair.
            if (code < 56320 && next > 56319 && next < 57344) {
                replace = String.fromCharCode(code, next);
                skip = 1;
            } else replace = "\uFFFD";
        } else replace = String.fromCharCode(code);
        if (replace) {
            result.push(value.slice(start, index), encodeURIComponent(replace));
            start = index + skip + 1;
            replace = '';
        }
        if (skip) {
            index += skip;
            skip = 0;
        }
    }
    return result.join('') + value.slice(start);
}


const $f892267008520ff6$var$hasOwnProperty = {}.hasOwnProperty;
/**
 * These two are allowlists of safe protocols for full URLs in respectively the
 * `href` (on `<a>`) and `src` (on `<img>`) attributes.
 * They are based on what is allowed on GitHub,
 * <https://github.com/syntax-tree/hast-util-sanitize/blob/9275b21/lib/github.json#L31>
 */ const $f892267008520ff6$var$protocolHref = /^(https?|ircs?|mailto|xmpp)$/i;
const $f892267008520ff6$var$protocolSource = /^https?$/i;
function $f892267008520ff6$export$ef7acd7185315e22(options) {
    const settings = options || {};
    /**
   * Tags is needed because according to markdown, links and emphasis and
   * whatnot can exist in images, however, as HTML doesn’t allow content in
   * images, the tags are ignored in the `alt` attribute, but the content
   * remains.
   *
   * @type {boolean | undefined}
   */ let tags = true;
    /**
   * An object to track identifiers to media (URLs and titles) defined with
   * definitions.
   *
   * @type {Record<string, Definition>}
   */ const definitions = {};
    /**
   * A lot of the handlers need to capture some of the output data, modify it
   * somehow, and then deal with it.
   * We do that by tracking a stack of buffers, that can be opened (with
   * `buffer`) and closed (with `resume`) to access them.
   *
   * @type {Array<Array<string>>}
   */ const buffers = [
        []
    ];
    /**
   * As we can have links in images and the other way around, where the deepest
   * ones are closed first, we need to track which one we’re in.
   *
   * @type {Array<Media>}
   */ const mediaStack = [];
    /**
   * Same as `mediaStack` for tightness, which is specific to lists.
   * We need to track if we’re currently in a tight or loose container.
   *
   * @type {Array<boolean>}
   */ const tightStack = [];
    /** @type {HtmlExtension} */ const defaultHandlers = {
        enter: {
            blockQuote: onenterblockquote,
            codeFenced: onentercodefenced,
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: onentercodeindented,
            codeText: onentercodetext,
            content: onentercontent,
            definition: onenterdefinition,
            definitionDestinationString: onenterdefinitiondestinationstring,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: onenteremphasis,
            htmlFlow: onenterhtmlflow,
            htmlText: onenterhtml,
            image: onenterimage,
            label: buffer,
            link: onenterlink,
            listItemMarker: onenterlistitemmarker,
            listItemValue: onenterlistitemvalue,
            listOrdered: onenterlistordered,
            listUnordered: onenterlistunordered,
            paragraph: onenterparagraph,
            reference: buffer,
            resource: onenterresource,
            resourceDestinationString: onenterresourcedestinationstring,
            resourceTitleString: buffer,
            setextHeading: onentersetextheading,
            strong: onenterstrong
        },
        exit: {
            atxHeading: onexitatxheading,
            atxHeadingSequence: onexitatxheadingsequence,
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: onexitblockquote,
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: onexitflowcode,
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onresumedrop,
            codeFlowValue: onexitcodeflowvalue,
            codeIndented: onexitflowcode,
            codeText: onexitcodetext,
            codeTextData: onexitdata,
            data: onexitdata,
            definition: onexitdefinition,
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: onexitemphasis,
            hardBreakEscape: onexithardbreak,
            hardBreakTrailing: onexithardbreak,
            htmlFlow: onexithtml,
            htmlFlowData: onexitdata,
            htmlText: onexithtml,
            htmlTextData: onexitdata,
            image: onexitmedia,
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: onexitmedia,
            listOrdered: onexitlistordered,
            listUnordered: onexitlistunordered,
            paragraph: onexitparagraph,
            reference: onresumedrop,
            referenceString: onexitreferencestring,
            resource: onresumedrop,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            setextHeading: onexitsetextheading,
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: onexitstrong,
            thematicBreak: onexitthematicbreak
        }
    };
    /**
   * Combine the HTML extensions with the default handlers.
   * An HTML extension is an object whose fields are either `enter` or `exit`
   * (reflecting whether a token is entered or exited).
   * The values at such objects are names of tokens mapping to handlers.
   * Handlers are called, respectively when a token is opener or closed, with
   * that token, and a context as `this`.
   */ const handlers = /** @type {NormalizedHtmlExtension} */ (0, $gaqbL.combineHtmlExtensions)([
        defaultHandlers,
        ...settings.htmlExtensions || []
    ]);
    /**
   * Handlers do often need to keep track of some state.
   * That state is provided here as a key-value store (an object).
   *
   * @type {CompileData}
   */ const data = {
        definitions: definitions,
        tightStack: tightStack
    };
    /**
   * The context for handlers references a couple of useful functions.
   * In handlers from extensions, those can be accessed at `this`.
   * For the handlers here, they can be accessed directly.
   *
   * @type {Omit<CompileContext, 'sliceSerialize'>}
   */ const context = {
        buffer: buffer,
        encode: encode,
        getData: getData,
        lineEndingIfNeeded: lineEndingIfNeeded,
        options: settings,
        raw: raw,
        resume: resume,
        setData: setData,
        tag: tag
    };
    /**
   * Generally, micromark copies line endings (`'\r'`, `'\n'`, `'\r\n'`) in the
   * markdown document over to the compiled HTML.
   * In some cases, such as `> a`, CommonMark requires that extra line endings
   * are added: `<blockquote>\n<p>a</p>\n</blockquote>`.
   * This variable hold the default line ending when given (or `undefined`),
   * and in the latter case will be updated to the first found line ending if
   * there is one.
   */ let lineEndingStyle = settings.defaultLineEnding;
    // Return the function that handles a slice of events.
    return compile;
    /**
   * Deal w/ a slice of events.
   * Return either the empty string if there’s nothing of note to return, or the
   * result when done.
   *
   * @param {ReadonlyArray<Event>} events
   * @returns {string}
   */ function compile(events) {
        let index = -1;
        let start = 0;
        /** @type {Array<number>} */ const listStack = [];
        // As definitions can come after references, we need to figure out the media
        // (urls and titles) defined by them before handling the references.
        // So, we do sort of what HTML does: put metadata at the start (in head), and
        // then put content after (`body`).
        /** @type {Array<Event>} */ let head = [];
        /** @type {Array<Event>} */ let body = [];
        while(++index < events.length){
            // Figure out the line ending style used in the document.
            if (!lineEndingStyle && (events[index][1].type === "lineEnding" || events[index][1].type === "lineEndingBlank")) lineEndingStyle = /** @type {LineEnding} */ events[index][2].sliceSerialize(events[index][1]);
            // Preprocess lists to infer whether the list is loose or not.
            if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
                if (events[index][0] === 'enter') listStack.push(index);
                else prepareList(events.slice(listStack.pop(), index));
            }
            // Move definitions to the front.
            if (events[index][1].type === "definition") {
                if (events[index][0] === 'enter') {
                    body = (0, $bHIRo.push)(body, events.slice(start, index));
                    start = index;
                } else {
                    head = (0, $bHIRo.push)(head, events.slice(start, index + 1));
                    start = index + 1;
                }
            }
        }
        head = (0, $bHIRo.push)(head, body);
        head = (0, $bHIRo.push)(head, events.slice(start));
        index = -1;
        const result = head;
        // Handle the start of the document, if defined.
        if (handlers.enter.null) handlers.enter.null.call(context);
        // Handle all events.
        while(++index < events.length){
            const handles = handlers[result[index][0]];
            const kind = result[index][1].type;
            const handle = handles[kind];
            if ($f892267008520ff6$var$hasOwnProperty.call(handles, kind) && handle) handle.call({
                sliceSerialize: result[index][2].sliceSerialize,
                ...context
            }, result[index][1]);
        }
        // Handle the end of the document, if defined.
        if (handlers.exit.null) handlers.exit.null.call(context);
        return buffers[0].join('');
    }
    /**
   * Figure out whether lists are loose or not.
   *
   * @param {ReadonlyArray<Event>} slice
   * @returns {undefined}
   */ function prepareList(slice) {
        const length = slice.length;
        let index = 0; // Skip open.
        let containerBalance = 0;
        let loose = false;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index < length){
            const event = slice[index];
            if (event[1]._container) {
                atMarker = undefined;
                if (event[0] === 'enter') containerBalance++;
                else containerBalance--;
            } else switch(event[1].type){
                case "listItemPrefix":
                    if (event[0] === 'exit') atMarker = true;
                    break;
                case "linePrefix":
                    break;
                case "lineEndingBlank":
                    if (event[0] === 'enter' && !containerBalance) {
                        if (atMarker) atMarker = undefined;
                        else loose = true;
                    }
                    break;
                default:
                    atMarker = undefined;
            }
        }
        slice[0][1]._loose = loose;
    }
    /**
   * @type {CompileContext['setData']}
   */ function setData(key, value) {
        // @ts-expect-error: assume `value` is omitted (`undefined` is passed) only
        // if allowed.
        data[key] = value;
    }
    /**
   * @type {CompileContext['getData']}
   */ function getData(key) {
        return data[key];
    }
    /** @type {CompileContext['buffer']} */ function buffer() {
        buffers.push([]);
    }
    /** @type {CompileContext['resume']} */ function resume() {
        const buf = buffers.pop();
        return buf.join('');
    }
    /** @type {CompileContext['tag']} */ function tag(value) {
        if (!tags) return;
        setData('lastWasTag', true);
        buffers[buffers.length - 1].push(value);
    }
    /** @type {CompileContext['raw']} */ function raw(value) {
        setData('lastWasTag');
        buffers[buffers.length - 1].push(value);
    }
    /**
   * Output an extra line ending.
   *
   * @returns {undefined}
   */ function lineEnding() {
        raw(lineEndingStyle || '\n');
    }
    /** @type {CompileContext['lineEndingIfNeeded']} */ function lineEndingIfNeeded() {
        const buffer = buffers[buffers.length - 1];
        const slice = buffer[buffer.length - 1];
        const previous = slice ? slice.charCodeAt(slice.length - 1) : null;
        if (previous === 10 || previous === 13 || previous === null) return;
        lineEnding();
    }
    /** @type {CompileContext['encode']} */ function encode(value) {
        return getData('ignoreEncode') ? value : (0, $138cecc367c1b75e$export$c564cdbbe6da493)(value);
    }
    //
    // Handlers.
    //
    /**
   * @returns {undefined}
   */ function onresumedrop() {
        resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered(token) {
        tightStack.push(!token._loose);
        lineEndingIfNeeded();
        tag('<ol');
        setData('expectFirstItem', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistunordered(token) {
        tightStack.push(!token._loose);
        lineEndingIfNeeded();
        tag('<ul');
        setData('expectFirstItem', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (getData('expectFirstItem')) {
            const value = Number.parseInt(this.sliceSerialize(token), 10);
            if (value !== 1) tag(' start="' + encode(String(value)) + '"');
        }
    }
    /**
   * @returns {undefined}
   */ function onenterlistitemmarker() {
        if (getData('expectFirstItem')) tag('>');
        else onexitlistitem();
        lineEndingIfNeeded();
        tag('<li>');
        setData('expectFirstItem');
        // “Hack” to prevent a line ending from showing up if the item is empty.
        setData('lastWasTag');
    }
    /**
   * @returns {undefined}
   */ function onexitlistordered() {
        onexitlistitem();
        tightStack.pop();
        lineEnding();
        tag('</ol>');
    }
    /**
   * @returns {undefined}
   */ function onexitlistunordered() {
        onexitlistitem();
        tightStack.pop();
        lineEnding();
        tag('</ul>');
    }
    /**
   * @returns {undefined}
   */ function onexitlistitem() {
        if (getData('lastWasTag') && !getData('slurpAllLineEndings')) lineEndingIfNeeded();
        tag('</li>');
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterblockquote() {
        tightStack.push(false);
        lineEndingIfNeeded();
        tag('<blockquote>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitblockquote() {
        tightStack.pop();
        lineEndingIfNeeded();
        tag('</blockquote>');
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterparagraph() {
        if (!tightStack[tightStack.length - 1]) {
            lineEndingIfNeeded();
            tag('<p>');
        }
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitparagraph() {
        if (tightStack[tightStack.length - 1]) setData('slurpAllLineEndings', true);
        else tag('</p>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercodefenced() {
        lineEndingIfNeeded();
        tag('<pre><code');
        setData('fencesCount', 0);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const value = resume();
        tag(' class="language-' + value + '"');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        const count = getData('fencesCount') || 0;
        if (!count) {
            tag('>');
            setData('slurpOneLineEnding', true);
        }
        setData('fencesCount', count + 1);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercodeindented() {
        lineEndingIfNeeded();
        tag('<pre><code>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitflowcode() {
        const count = getData('fencesCount');
        // One special case is if we are inside a container, and the fenced code was
        // not closed (meaning it runs to the end).
        // In that case, the following line ending, is considered *outside* the
        // fenced code and block quote by micromark, but CM wants to treat that
        // ending as part of the code.
        if (count !== undefined && count < 2 && data.tightStack.length > 0 && !getData('lastWasTag')) lineEnding();
        // But in most cases, it’s simpler: when we’ve seen some data, emit an extra
        // line ending when needed.
        if (getData('flowCodeSeenData')) lineEndingIfNeeded();
        tag('</code></pre>');
        if (count !== undefined && count < 2) lineEndingIfNeeded();
        setData('flowCodeSeenData');
        setData('fencesCount');
        setData('slurpOneLineEnding');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterimage() {
        mediaStack.push({
            image: true
        });
        tags = undefined; // Disallow tags.
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlink() {
        mediaStack.push({});
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        mediaStack[mediaStack.length - 1].label = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        mediaStack[mediaStack.length - 1].referenceId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterresource() {
        buffer(); // We can have line endings in the resource, ignore them.
        mediaStack[mediaStack.length - 1].destination = '';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterresourcedestinationstring() {
        buffer();
        // Ignore encoding the result, as we’ll first percent encode the url and
        // encode manually after.
        setData('ignoreEncode', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        mediaStack[mediaStack.length - 1].destination = resume();
        setData('ignoreEncode');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        mediaStack[mediaStack.length - 1].title = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitmedia() {
        let index = mediaStack.length - 1; // Skip current.
        const media = mediaStack[index];
        const id = media.referenceId || media.labelId;
        const context = media.destination === undefined ? definitions[(0, $fEgdu.normalizeIdentifier)(id)] : media;
        tags = true;
        while(index--)if (mediaStack[index].image) {
            tags = undefined;
            break;
        }
        if (media.image) {
            tag('<img src="' + (0, $14f90a1c08770ea5$export$d130a2d684099e5a)(context.destination, settings.allowDangerousProtocol ? undefined : $f892267008520ff6$var$protocolSource) + '" alt="');
            raw(media.label);
            tag('"');
        } else tag('<a href="' + (0, $14f90a1c08770ea5$export$d130a2d684099e5a)(context.destination, settings.allowDangerousProtocol ? undefined : $f892267008520ff6$var$protocolHref) + '"');
        tag(context.title ? ' title="' + context.title + '"' : '');
        if (media.image) tag(' />');
        else {
            tag('>');
            raw(media.label);
            tag('</a>');
        }
        mediaStack.pop();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdefinition() {
        buffer();
        mediaStack.push({});
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        // Discard label, use the source content instead.
        resume();
        mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdefinitiondestinationstring() {
        buffer();
        setData('ignoreEncode', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        mediaStack[mediaStack.length - 1].destination = resume();
        setData('ignoreEncode');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        mediaStack[mediaStack.length - 1].title = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinition() {
        const media = mediaStack[mediaStack.length - 1];
        const id = (0, $fEgdu.normalizeIdentifier)(media.labelId);
        resume();
        if (!$f892267008520ff6$var$hasOwnProperty.call(definitions, id)) definitions[id] = mediaStack[mediaStack.length - 1];
        mediaStack.pop();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercontent() {
        setData('slurpAllLineEndings', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        // Exit for further sequences.
        if (getData('headingRank')) return;
        setData('headingRank', this.sliceSerialize(token).length);
        lineEndingIfNeeded();
        tag('<h' + getData('headingRank') + '>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentersetextheading() {
        buffer();
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        setData('slurpAllLineEndings', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheading() {
        tag('</h' + getData('headingRank') + '>');
        setData('headingRank');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        setData('headingRank', this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        const value = resume();
        lineEndingIfNeeded();
        tag('<h' + getData('headingRank') + '>');
        raw(value);
        tag('</h' + getData('headingRank') + '>');
        setData('slurpAllLineEndings');
        setData('headingRank');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        raw(encode(this.sliceSerialize(token)));
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        if (getData('slurpAllLineEndings')) return;
        if (getData('slurpOneLineEnding')) {
            setData('slurpOneLineEnding');
            return;
        }
        if (getData('inCodeText')) {
            raw(' ');
            return;
        }
        raw(encode(this.sliceSerialize(token)));
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeflowvalue(token) {
        raw(encode(this.sliceSerialize(token)));
        setData('flowCodeSeenData', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        tag('<br />');
    }
    /**
   * @returns {undefined}
   */ function onenterhtmlflow() {
        lineEndingIfNeeded();
        onenterhtml();
    }
    /**
   * @returns {undefined}
   */ function onexithtml() {
        setData('ignoreEncode');
    }
    /**
   * @returns {undefined}
   */ function onenterhtml() {
        if (settings.allowDangerousHtml) setData('ignoreEncode', true);
    }
    /**
   * @returns {undefined}
   */ function onenteremphasis() {
        tag('<em>');
    }
    /**
   * @returns {undefined}
   */ function onenterstrong() {
        tag('<strong>');
    }
    /**
   * @returns {undefined}
   */ function onentercodetext() {
        setData('inCodeText', true);
        tag('<code>');
    }
    /**
   * @returns {undefined}
   */ function onexitcodetext() {
        setData('inCodeText');
        tag('</code>');
    }
    /**
   * @returns {undefined}
   */ function onexitemphasis() {
        tag('</em>');
    }
    /**
   * @returns {undefined}
   */ function onexitstrong() {
        tag('</strong>');
    }
    /**
   * @returns {undefined}
   */ function onexitthematicbreak() {
        lineEndingIfNeeded();
        tag('<hr />');
    }
    /**
   * @this {CompileContext}
   * @param {Token} token
   * @returns {undefined}
   */ function onexitcharacterreferencemarker(token) {
        setData('characterReferenceType', token.type);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const value = this.sliceSerialize(token);
        const decoded = getData('characterReferenceType') ? (0, $eEM9l.decodeNumericCharacterReference)(value, getData('characterReferenceType') === "characterReferenceMarkerNumeric" ? 10 : 16) : (0, $cbxPV.decodeNamedCharacterReference)(value);
        // `decodeNamedCharacterReference` can return `false` for invalid named
        // character references,
        // but everything we’ve tokenized is valid.
        raw(encode(/** @type {string} */ decoded));
        setData('characterReferenceType');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        const uri = this.sliceSerialize(token);
        tag('<a href="' + (0, $14f90a1c08770ea5$export$d130a2d684099e5a)(uri, settings.allowDangerousProtocol ? undefined : $f892267008520ff6$var$protocolHref) + '">');
        raw(encode(uri));
        tag('</a>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        const uri = this.sliceSerialize(token);
        tag('<a href="' + (0, $14f90a1c08770ea5$export$d130a2d684099e5a)('mailto:' + uri) + '">');
        raw(encode(uri));
        tag('</a>');
    }
}
module.exports["compile"] = $f892267008520ff6$export$ef7acd7185315e22;

});

parcelRegister("9coEp", function(module, exports) {
/**
 * @import {
 *   Create,
 *   FullNormalizedExtension,
 *   InitialConstruct,
 *   ParseContext,
 *   ParseOptions
 * } from 'micromark-util-types'
 */ 
var $gaqbL = parcelRequire("gaqbL");

/**
 * @import {
 *   InitialConstruct,
 *   Initializer,
 *   State,
 *   TokenizeContext,
 *   Token
 * } from 'micromark-util-types'
 */ 
var $5jhd5 = parcelRequire("5jhd5");


var $5RE1E = parcelRequire("5RE1E");

const $29cc61f02ac384bd$export$a7db06668cad9adb = {
    tokenize: $29cc61f02ac384bd$var$initializeContent
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Initializer}
 *   Content.
 */ function $29cc61f02ac384bd$var$initializeContent(effects) {
    const contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    /** @type {Token} */ let previous;
    return contentStart;
    /** @type {State} */ function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $5jhd5.factorySpace)(effects, contentStart, "linePrefix");
    }
    /** @type {State} */ function paragraphInitial(code) {
        effects.enter("paragraph");
        return lineStart(code);
    }
    /** @type {State} */ function lineStart(code) {
        const token = effects.enter("chunkText", {
            contentType: "text",
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    /** @type {State} */ function data(code) {
        if (code === null) {
            effects.exit("chunkText");
            effects.exit("paragraph");
            effects.consume(code);
            return;
        }
        if ((0, $5RE1E.markdownLineEnding)(code)) {
            effects.consume(code);
            effects.exit("chunkText");
            return lineStart;
        }
        // Data.
        effects.consume(code);
        return data;
    }
}


/**
 * @import {
 *   Construct,
 *   ContainerState,
 *   InitialConstruct,
 *   Initializer,
 *   Point,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @typedef {[Construct, ContainerState]} StackItem
 *   Construct and its state.
 */ 






var $bHIRo = parcelRequire("bHIRo");

const $2f209e3256e5dc28$export$5a7bfc01df82fcd1 = {
    tokenize: $2f209e3256e5dc28$var$initializeDocument
};
/** @type {Construct} */ const $2f209e3256e5dc28$var$containerConstruct = {
    tokenize: $2f209e3256e5dc28$var$tokenizeContainer
};
/**
 * @this {TokenizeContext}
 *   Self.
 * @type {Initializer}
 *   Initializer.
 */ function $2f209e3256e5dc28$var$initializeDocument(effects) {
    const self = this;
    /** @type {Array<StackItem>} */ const stack = [];
    let continued = 0;
    /** @type {TokenizeContext | undefined} */ let childFlow;
    /** @type {Token | undefined} */ let childToken;
    /** @type {number} */ let lineStartOffset;
    return start;
    /** @type {State} */ function start(code) {
        // First we iterate through the open blocks, starting with the root
        // document, and descending through last children down to the last open
        // block.
        // Each block imposes a condition that the line must satisfy if the block is
        // to remain open.
        // For example, a block quote requires a `>` character.
        // A paragraph requires a non-blank line.
        // In this phase we may match all or just some of the open blocks.
        // But we cannot close unmatched blocks yet, because we may have a lazy
        // continuation line.
        if (continued < stack.length) {
            const item = stack[continued];
            self.containerState = item[1];
            return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code);
        }
        // Done.
        return checkNewContainers(code);
    }
    /** @type {State} */ function documentContinue(code) {
        continued++;
        // Note: this field is called `_closeFlow` but it also closes containers.
        // Perhaps a good idea to rename it but it’s already used in the wild by
        // extensions.
        if (self.containerState._closeFlow) {
            self.containerState._closeFlow = undefined;
            if (childFlow) closeFlow();
            // Note: this algorithm for moving events around is similar to the
            // algorithm when dealing with lazy lines in `writeToChild`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {Point | undefined} */ let point;
            // Find the flow chunk.
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                point = self.events[indexBeforeFlow][1].end;
                break;
            }
            exitContainers(continued);
            // Fix positions.
            let index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = {
                    ...point
                };
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $bHIRo.splice)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
            return checkNewContainers(code);
        }
        return start(code);
    }
    /** @type {State} */ function checkNewContainers(code) {
        // Next, after consuming the continuation markers for existing blocks, we
        // look for new block starts (e.g. `>` for a block quote).
        // If we encounter a new block start, we close any blocks unmatched in
        // step 1 before creating the new block as a child of the last matched
        // block.
        if (continued === stack.length) {
            // No need to `check` whether there’s a container, of `exitContainers`
            // would be moot.
            // We can instead immediately `attempt` to parse one.
            if (!childFlow) return documentContinued(code);
            // If we have concrete content, such as block HTML or fenced code,
            // we can’t have containers “pierce” into them, so we can immediately
            // start.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) return flowStart(code);
            // If we do have flow, it could still be a blank line,
            // but we’d be interrupting it w/ a new container if there’s a current
            // construct.
            // To do: next major: remove `_gfmTableDynamicInterruptHack` (no longer
            // needed in micromark-extension-gfm-table@1.0.6).
            self.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
        }
        // Check if there is a new container.
        self.containerState = {};
        return effects.check($2f209e3256e5dc28$var$containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code);
    }
    /** @type {State} */ function thereIsANewContainer(code) {
        if (childFlow) closeFlow();
        exitContainers(continued);
        return documentContinued(code);
    }
    /** @type {State} */ function thereIsNoNewContainer(code) {
        self.parser.lazy[self.now().line] = continued !== stack.length;
        lineStartOffset = self.now().offset;
        return flowStart(code);
    }
    /** @type {State} */ function documentContinued(code) {
        // Try new containers.
        self.containerState = {};
        return effects.attempt($2f209e3256e5dc28$var$containerConstruct, containerContinue, flowStart)(code);
    }
    /** @type {State} */ function containerContinue(code) {
        continued++;
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        // Try another.
        return documentContinued(code);
    }
    /** @type {State} */ function flowStart(code) {
        if (code === null) {
            if (childFlow) closeFlow();
            exitContainers(0);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter("chunkFlow", {
            _tokenizer: childFlow,
            contentType: "flow",
            previous: childToken
        });
        return flowContinue(code);
    }
    /** @type {State} */ function flowContinue(code) {
        if (code === null) {
            writeToChild(effects.exit("chunkFlow"), true);
            exitContainers(0);
            effects.consume(code);
            return;
        }
        if ((0, $5RE1E.markdownLineEnding)(code)) {
            effects.consume(code);
            writeToChild(effects.exit("chunkFlow"));
            // Get ready for the next line.
            continued = 0;
            self.interrupt = undefined;
            return start;
        }
        effects.consume(code);
        return flowContinue;
    }
    /**
   * @param {Token} token
   *   Token.
   * @param {boolean | undefined} [endOfFile]
   *   Whether the token is at the end of the file (default: `false`).
   * @returns {undefined}
   *   Nothing.
   */ function writeToChild(token, endOfFile) {
        const stream = self.sliceStream(token);
        if (endOfFile) stream.push(null);
        token.previous = childToken;
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.defineSkip(token.start);
        childFlow.write(stream);
        // Alright, so we just added a lazy line:
        //
        // ```markdown
        // > a
        // b.
        //
        // Or:
        //
        // > ~~~c
        // d
        //
        // Or:
        //
        // > | e |
        // f
        // ```
        //
        // The construct in the second example (fenced code) does not accept lazy
        // lines, so it marked itself as done at the end of its first line, and
        // then the content construct parses `d`.
        // Most constructs in markdown match on the first line: if the first line
        // forms a construct, a non-lazy line can’t “unmake” it.
        //
        // The construct in the third example is potentially a GFM table, and
        // those are *weird*.
        // It *could* be a table, from the first line, if the following line
        // matches a condition.
        // In this case, that second line is lazy, which “unmakes” the first line
        // and turns the whole into one content block.
        //
        // We’ve now parsed the non-lazy and the lazy line, and can figure out
        // whether the lazy line started a new flow block.
        // If it did, we exit the current containers between the two flow blocks.
        if (self.parser.lazy[token.start.line]) {
            let index = childFlow.events.length;
            while(index--){
                if (// The token starts before the line ending…
                childFlow.events[index][1].start.offset < lineStartOffset && // …and either is not ended yet…
                (!childFlow.events[index][1].end || // …or ends after it.
                childFlow.events[index][1].end.offset > lineStartOffset)) // Exit: there’s still something open, which means it’s a lazy line
                // part of something.
                return;
            }
            // Note: this algorithm for moving events around is similar to the
            // algorithm when closing flow in `documentContinue`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {boolean | undefined} */ let seen;
            /** @type {Point | undefined} */ let point;
            // Find the previous chunk (the one before the lazy line).
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                if (seen) {
                    point = self.events[indexBeforeFlow][1].end;
                    break;
                }
                seen = true;
            }
            exitContainers(continued);
            // Fix positions.
            index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = {
                    ...point
                };
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $bHIRo.splice)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
        }
    }
    /**
   * @param {number} size
   *   Size.
   * @returns {undefined}
   *   Nothing.
   */ function exitContainers(size) {
        let index = stack.length;
        // Exit open containers.
        while(index-- > size){
            const entry = stack[index];
            self.containerState = entry[1];
            entry[0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function closeFlow() {
        childFlow.write([
            null
        ]);
        childToken = undefined;
        childFlow = undefined;
        self.containerState._closeFlow = undefined;
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 *   Tokenizer.
 */ function $2f209e3256e5dc28$var$tokenizeContainer(effects, ok, nok) {
    // Always populated by defaults.
    return (0, $5jhd5.factorySpace)(effects, effects.attempt(this.parser.constructs.document, ok, nok), "linePrefix", this.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4);
}


/**
 * @import {
 *   InitialConstruct,
 *   Initializer,
 *   State,
 *   TokenizeContext
 * } from 'micromark-util-types'
 */ /**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 





const $42a0773f37ffce85$export$d50d28ce3ab2a612 = {
    partial: true,
    tokenize: $42a0773f37ffce85$var$tokenizeBlankLine
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $42a0773f37ffce85$var$tokenizeBlankLine(effects, ok, nok) {
    return start;
    /**
   * Start of blank line.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *     ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        return (0, $5RE1E.markdownSpace)(code) ? (0, $5jhd5.factorySpace)(effects, after, "linePrefix")(code) : after(code);
    }
    /**
   * At eof/eol, after optional whitespace.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *       ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return code === null || (0, $5RE1E.markdownLineEnding)(code) ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 






var $lQubg = parcelRequire("lQubg");

const $e014ce9305a9d3d4$export$a7db06668cad9adb = {
    resolve: $e014ce9305a9d3d4$var$resolveContent,
    tokenize: $e014ce9305a9d3d4$var$tokenizeContent
};
/** @type {Construct} */ const $e014ce9305a9d3d4$var$continuationConstruct = {
    partial: true,
    tokenize: $e014ce9305a9d3d4$var$tokenizeContinuation
};
/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */ function $e014ce9305a9d3d4$var$resolveContent(events) {
    (0, $lQubg.subtokenize)(events);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $e014ce9305a9d3d4$var$tokenizeContent(effects, ok) {
    /** @type {Token | undefined} */ let previous;
    return chunkStart;
    /**
   * Before a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^
   * ```
   *
   * @type {State}
   */ function chunkStart(code) {
        effects.enter("content");
        previous = effects.enter("chunkContent", {
            contentType: "content"
        });
        return chunkInside(code);
    }
    /**
   * In a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^^^
   * ```
   *
   * @type {State}
   */ function chunkInside(code) {
        if (code === null) return contentEnd(code);
        // To do: in `markdown-rs`, each line is parsed on its own, and everything
        // is stitched together resolving.
        if ((0, $5RE1E.markdownLineEnding)(code)) return effects.check($e014ce9305a9d3d4$var$continuationConstruct, contentContinue, contentEnd)(code);
        // Data.
        effects.consume(code);
        return chunkInside;
    }
    /**
   *
   *
   * @type {State}
   */ function contentEnd(code) {
        effects.exit("chunkContent");
        effects.exit("content");
        return ok(code);
    }
    /**
   *
   *
   * @type {State}
   */ function contentContinue(code) {
        effects.consume(code);
        effects.exit("chunkContent");
        previous.next = effects.enter("chunkContent", {
            contentType: "content",
            previous: previous
        });
        previous = previous.next;
        return chunkInside;
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $e014ce9305a9d3d4$var$tokenizeContinuation(effects, ok, nok) {
    const self = this;
    return startLookahead;
    /**
   *
   *
   * @type {State}
   */ function startLookahead(code) {
        effects.exit("chunkContent");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $5jhd5.factorySpace)(effects, prefixed, "linePrefix");
    }
    /**
   *
   *
   * @type {State}
   */ function prefixed(code) {
        if (code === null || (0, $5RE1E.markdownLineEnding)(code)) return nok(code);
        // Always populated by defaults.
        const tail = self.events[self.events.length - 1];
        if (!self.parser.constructs.disable.null.includes('codeIndented') && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) return ok(code);
        return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
    }
}






const $86d64d7787f1e7dc$export$ccc7b0636abaffc3 = {
    tokenize: $86d64d7787f1e7dc$var$initializeFlow
};
/**
 * @this {TokenizeContext}
 *   Self.
 * @type {Initializer}
 *   Initializer.
 */ function $86d64d7787f1e7dc$var$initializeFlow(effects) {
    const self = this;
    const initial = effects.attempt(// Try to parse a blank line.
    (0, $42a0773f37ffce85$export$d50d28ce3ab2a612), atBlankEnding, // Try to parse initial flow (essentially, only code).
    effects.attempt(this.parser.constructs.flowInitial, afterConstruct, (0, $5jhd5.factorySpace)(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt((0, $e014ce9305a9d3d4$export$a7db06668cad9adb), afterConstruct)), "linePrefix")));
    return initial;
    /** @type {State} */ function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEndingBlank");
        effects.consume(code);
        effects.exit("lineEndingBlank");
        self.currentConstruct = undefined;
        return initial;
    }
    /** @type {State} */ function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        self.currentConstruct = undefined;
        return initial;
    }
}


/**
 * @import {
 *   Code,
 *   InitialConstruct,
 *   Initializer,
 *   Resolver,
 *   State,
 *   TokenizeContext
 * } from 'micromark-util-types'
 */ const $4e44e4e38c8b8bd7$export$50397835cbfdbc24 = {
    resolveAll: $4e44e4e38c8b8bd7$var$createResolver()
};
const $4e44e4e38c8b8bd7$export$22b082955e083ec3 = $4e44e4e38c8b8bd7$var$initializeFactory('string');
const $4e44e4e38c8b8bd7$export$6f093cfa640b7166 = $4e44e4e38c8b8bd7$var$initializeFactory('text');
/**
 * @param {'string' | 'text'} field
 *   Field.
 * @returns {InitialConstruct}
 *   Construct.
 */ function $4e44e4e38c8b8bd7$var$initializeFactory(field) {
    return {
        resolveAll: $4e44e4e38c8b8bd7$var$createResolver(field === 'text' ? $4e44e4e38c8b8bd7$var$resolveAllLineSuffixes : undefined),
        tokenize: initializeText
    };
    /**
   * @this {TokenizeContext}
   *   Context.
   * @type {Initializer}
   */ function initializeText(effects) {
        const self = this;
        const constructs = this.parser.constructs[field];
        const text = effects.attempt(constructs, start, notText);
        return start;
        /** @type {State} */ function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        /** @type {State} */ function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter("data");
            effects.consume(code);
            return data;
        }
        /** @type {State} */ function data(code) {
            if (atBreak(code)) {
                effects.exit("data");
                return text(code);
            }
            // Data.
            effects.consume(code);
            return data;
        }
        /**
     * @param {Code} code
     *   Code.
     * @returns {boolean}
     *   Whether the code is a break.
     */ function atBreak(code) {
            if (code === null) return true;
            const list = constructs[code];
            let index = -1;
            if (list) // Always populated by defaults.
            while(++index < list.length){
                const item = list[index];
                if (!item.previous || item.previous.call(self, self.previous)) return true;
            }
            return false;
        }
    }
}
/**
 * @param {Resolver | undefined} [extraResolver]
 *   Resolver.
 * @returns {Resolver}
 *   Resolver.
 */ function $4e44e4e38c8b8bd7$var$createResolver(extraResolver) {
    return resolveAllText;
    /** @type {Resolver} */ function resolveAllText(events, context) {
        let index = -1;
        /** @type {number | undefined} */ let enter;
        // A rather boring computation (to merge adjacent `data` events) which
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === "data") {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== "data") {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
}
/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */ function $4e44e4e38c8b8bd7$var$resolveAllLineSuffixes(events, context) {
    let eventIndex = 0; // Skip first.
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === "lineEnding") && events[eventIndex - 1][1].type === "data") {
        const data = events[eventIndex - 1][1];
        const chunks = context.sliceStream(data);
        let index = chunks.length;
        let bufferIndex = -1;
        let size = 0;
        /** @type {boolean | undefined} */ let tabs;
        while(index--){
            const chunk = chunks[index];
            if (typeof chunk === 'string') {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        // Allow final trailing whitespace.
        if (context._contentTypeTextTrailing && eventIndex === events.length) size = 0;
        if (size) {
            const token = {
                type: eventIndex === events.length || tabs || size < 2 ? "lineSuffix" : "hardBreakTrailing",
                start: {
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex,
                    _index: data.start._index + index,
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size
                },
                end: {
                    ...data.end
                }
            };
            data.end = {
                ...token.start
            };
            if (data.start.offset === data.end.offset) Object.assign(data, token);
            else {
                events.splice(eventIndex, 0, [
                    'enter',
                    token,
                    context
                ], [
                    'exit',
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}


var $49d3814fd2c2e4b7$exports = {};
/**
 * @import {Extension} from 'micromark-util-types'
 */ /**
 * @import {
 *   Code,
 *   Construct,
 *   Event,
 *   Point,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 



var $0A5sK = parcelRequire("0A5sK");


var $9CjcD = parcelRequire("9CjcD");

const $f198084f55320520$export$45b92471da762af7 = {
    name: 'attention',
    resolveAll: $f198084f55320520$var$resolveAllAttention,
    tokenize: $f198084f55320520$var$tokenizeAttention
};
/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */ // eslint-disable-next-line complexity
function $f198084f55320520$var$resolveAllAttention(events, context) {
    let index = -1;
    /** @type {number} */ let open;
    /** @type {Token} */ let group;
    /** @type {Token} */ let text;
    /** @type {Token} */ let openingSequence;
    /** @type {Token} */ let closingSequence;
    /** @type {number} */ let use;
    /** @type {Array<Event>} */ let nextEvents;
    /** @type {number} */ let offset;
    // Walk through all events.
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === 'enter' && events[index][1].type === 'attentionSequence' && events[index][1]._close) {
        open = index;
        // Now walk back to find an opener.
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === 'exit' && events[open][1].type === 'attentionSequence' && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
            // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            const start = {
                ...events[open][1].end
            };
            const end = {
                ...events[index][1].start
            };
            $f198084f55320520$var$movePoint(start, -use);
            $f198084f55320520$var$movePoint(end, use);
            openingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: start,
                end: {
                    ...events[open][1].end
                }
            };
            closingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: {
                    ...events[index][1].start
                },
                end: end
            };
            text = {
                type: use > 1 ? "strongText" : "emphasisText",
                start: {
                    ...events[open][1].end
                },
                end: {
                    ...events[index][1].start
                }
            };
            group = {
                type: use > 1 ? "strong" : "emphasis",
                start: {
                    ...openingSequence.start
                },
                end: {
                    ...closingSequence.end
                }
            };
            events[open][1].end = {
                ...openingSequence.start
            };
            events[index][1].start = {
                ...closingSequence.end
            };
            nextEvents = [];
            // If there are more markers in the opening, add them before.
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = (0, $bHIRo.push)(nextEvents, [
                [
                    'enter',
                    events[open][1],
                    context
                ],
                [
                    'exit',
                    events[open][1],
                    context
                ]
            ]);
            // Opening.
            nextEvents = (0, $bHIRo.push)(nextEvents, [
                [
                    'enter',
                    group,
                    context
                ],
                [
                    'enter',
                    openingSequence,
                    context
                ],
                [
                    'exit',
                    openingSequence,
                    context
                ],
                [
                    'enter',
                    text,
                    context
                ]
            ]);
            // Always populated by defaults.
            // Between.
            nextEvents = (0, $bHIRo.push)(nextEvents, (0, $9CjcD.resolveAll)(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));
            // Closing.
            nextEvents = (0, $bHIRo.push)(nextEvents, [
                [
                    'exit',
                    text,
                    context
                ],
                [
                    'enter',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    group,
                    context
                ]
            ]);
            // If there are more markers in the closing, add them after.
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = (0, $bHIRo.push)(nextEvents, [
                    [
                        'enter',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            (0, $bHIRo.splice)(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
    // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === 'attentionSequence') events[index][1].type = 'data';
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $f198084f55320520$var$tokenizeAttention(effects, ok) {
    const attentionMarkers = this.parser.constructs.attentionMarkers.null;
    const previous = this.previous;
    const before = (0, $0A5sK.classifyCharacter)(previous);
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Before a sequence.
   *
   * ```markdown
   * > | **
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        marker = code;
        effects.enter('attentionSequence');
        return inside(code);
    }
    /**
   * In a sequence.
   *
   * ```markdown
   * > | **
   *     ^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        const token = effects.exit('attentionSequence');
        // To do: next major: move this to resolver, just like `markdown-rs`.
        const after = (0, $0A5sK.classifyCharacter)(code);
        // Always populated by defaults.
        const open = !after || after === 2 && before || attentionMarkers.includes(code);
        const close = !before || before === 2 && after || attentionMarkers.includes(previous);
        token._open = Boolean(marker === 42 ? open : open && (before || !close));
        token._close = Boolean(marker === 42 ? close : close && (after || !open));
        return ok(code);
    }
}
/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 *   Point.
 * @param {number} offset
 *   Amount to move.
 * @returns {undefined}
 *   Nothing.
 */ function $f198084f55320520$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 


const $106ec5fc1899d736$export$17ddf85e4c916ad6 = {
    name: 'autolink',
    tokenize: $106ec5fc1899d736$var$tokenizeAutolink
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $106ec5fc1899d736$var$tokenizeAutolink(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of an autolink.
   *
   * ```markdown
   * > | a<https://example.com>b
   *      ^
   * > | a<user@example.com>b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("autolink");
        effects.enter("autolinkMarker");
        effects.consume(code);
        effects.exit("autolinkMarker");
        effects.enter("autolinkProtocol");
        return open;
    }
    /**
   * After `<`, at protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *       ^
   * > | a<user@example.com>b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if ((0, $5RE1E.asciiAlpha)(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        if (code === 64) return nok(code);
        return emailAtext(code);
    }
    /**
   * At second byte of protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeOrEmailAtext(code) {
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if (code === 43 || code === 45 || code === 46 || (0, $5RE1E.asciiAlphanumeric)(code)) {
            // Count the previous alphabetical from `open` too.
            size = 1;
            return schemeInsideOrEmailAtext(code);
        }
        return emailAtext(code);
    }
    /**
   * In ambiguous protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            size = 0;
            return urlInside;
        }
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if ((code === 43 || code === 45 || code === 46 || (0, $5RE1E.asciiAlphanumeric)(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        size = 0;
        return emailAtext(code);
    }
    /**
   * After protocol, in URL.
   *
   * ```markdown
   * > | a<https://example.com>b
   *             ^
   * ```
   *
   * @type {State}
   */ function urlInside(code) {
        if (code === 62) {
            effects.exit("autolinkProtocol");
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        // ASCII control, space, or `<`.
        if (code === null || code === 32 || code === 60 || (0, $5RE1E.asciiControl)(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *              ^
   * ```
   *
   * @type {State}
   */ function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            return emailAtSignOrDot;
        }
        if ((0, $5RE1E.asciiAtext)(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    /**
   * In label, after at-sign or dot.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                 ^       ^
   * ```
   *
   * @type {State}
   */ function emailAtSignOrDot(code) {
        return (0, $5RE1E.asciiAlphanumeric)(code) ? emailLabel(code) : nok(code);
    }
    /**
   * In label, where `.` and `>` are allowed.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                   ^
   * ```
   *
   * @type {State}
   */ function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the token type.
            effects.exit("autolinkProtocol").type = "autolinkEmail";
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        return emailValue(code);
    }
    /**
   * In label, where `.` and `>` are *not* allowed.
   *
   * Though, this is also used in `emailLabel` to parse other values.
   *
   * ```markdown
   * > | a<user.name@ex-ample.com>b
   *                    ^
   * ```
   *
   * @type {State}
   */ function emailValue(code) {
        // ASCII alphanumeric or `-`.
        if ((code === 45 || (0, $5RE1E.asciiAlphanumeric)(code)) && size++ < 63) {
            const next = code === 45 ? emailValue : emailLabel;
            effects.consume(code);
            return next;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Exiter,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 





const $706e130898ca72ec$export$200dcd0a5903c968 = {
    continuation: {
        tokenize: $706e130898ca72ec$var$tokenizeBlockQuoteContinuation
    },
    exit: $706e130898ca72ec$var$exit,
    name: 'blockQuote',
    tokenize: $706e130898ca72ec$var$tokenizeBlockQuoteStart
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $706e130898ca72ec$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of block quote.
   *
   * ```markdown
   * > | > a
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 62) {
            const state = self.containerState;
            if (!state.open) {
                effects.enter("blockQuote", {
                    _container: true
                });
                state.open = true;
            }
            effects.enter("blockQuotePrefix");
            effects.enter("blockQuoteMarker");
            effects.consume(code);
            effects.exit("blockQuoteMarker");
            return after;
        }
        return nok(code);
    }
    /**
   * After `>`, before optional whitespace.
   *
   * ```markdown
   * > | > a
   *      ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if ((0, $5RE1E.markdownSpace)(code)) {
            effects.enter("blockQuotePrefixWhitespace");
            effects.consume(code);
            effects.exit("blockQuotePrefixWhitespace");
            effects.exit("blockQuotePrefix");
            return ok;
        }
        effects.exit("blockQuotePrefix");
        return ok(code);
    }
}
/**
 * Start of block quote continuation.
 *
 * ```markdown
 *   | > a
 * > | > b
 *     ^
 * ```
 *
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $706e130898ca72ec$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    const self = this;
    return contStart;
    /**
   * Start of block quote continuation.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contStart(code) {
        if ((0, $5RE1E.markdownSpace)(code)) // Always populated by defaults.
        return (0, $5jhd5.factorySpace)(effects, contBefore, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
        return contBefore(code);
    }
    /**
   * At `>`, after optional whitespace.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contBefore(code) {
        return effects.attempt($706e130898ca72ec$export$200dcd0a5903c968, ok, nok)(code);
    }
}
/** @type {Exiter} */ function $706e130898ca72ec$var$exit(effects) {
    effects.exit("blockQuote");
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 


const $2d7e6e19d7b01ca5$export$2005478564e78d96 = {
    name: 'characterEscape',
    tokenize: $2d7e6e19d7b01ca5$var$tokenizeCharacterEscape
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $2d7e6e19d7b01ca5$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    /**
   * Start of character escape.
   *
   * ```markdown
   * > | a\*b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterEscape");
        effects.enter("escapeMarker");
        effects.consume(code);
        effects.exit("escapeMarker");
        return inside;
    }
    /**
   * After `\`, at punctuation.
   *
   * ```markdown
   * > | a\*b
   *       ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // ASCII punctuation.
        if ((0, $5RE1E.asciiPunctuation)(code)) {
            effects.enter("characterEscapeValue");
            effects.consume(code);
            effects.exit("characterEscapeValue");
            effects.exit("characterEscape");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
var $cbxPV = parcelRequire("cbxPV");




const $3d956a8d9449dffc$export$e31905600aaf3d8e = {
    name: 'characterReference',
    tokenize: $3d956a8d9449dffc$var$tokenizeCharacterReference
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $3d956a8d9449dffc$var$tokenizeCharacterReference(effects, ok, nok) {
    const self = this;
    let size = 0;
    /** @type {number} */ let max;
    /** @type {(code: Code) => boolean} */ let test;
    return start;
    /**
   * Start of character reference.
   *
   * ```markdown
   * > | a&amp;b
   *      ^
   * > | a&#123;b
   *      ^
   * > | a&#x9;b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterReference");
        effects.enter("characterReferenceMarker");
        effects.consume(code);
        effects.exit("characterReferenceMarker");
        return open;
    }
    /**
   * After `&`, at `#` for numeric references or alphanumeric for named
   * references.
   *
   * ```markdown
   * > | a&amp;b
   *       ^
   * > | a&#123;b
   *       ^
   * > | a&#x9;b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 35) {
            effects.enter("characterReferenceMarkerNumeric");
            effects.consume(code);
            effects.exit("characterReferenceMarkerNumeric");
            return numeric;
        }
        effects.enter("characterReferenceValue");
        max = 31;
        test = (0, $5RE1E.asciiAlphanumeric);
        return value(code);
    }
    /**
   * After `#`, at `x` for hexadecimals or digit for decimals.
   *
   * ```markdown
   * > | a&#123;b
   *        ^
   * > | a&#x9;b
   *        ^
   * ```
   *
   * @type {State}
   */ function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter("characterReferenceMarkerHexadecimal");
            effects.consume(code);
            effects.exit("characterReferenceMarkerHexadecimal");
            effects.enter("characterReferenceValue");
            max = 6;
            test = (0, $5RE1E.asciiHexDigit);
            return value;
        }
        effects.enter("characterReferenceValue");
        max = 7;
        test = (0, $5RE1E.asciiDigit);
        return value(code);
    }
    /**
   * After markers (`&#x`, `&#`, or `&`), in value, before `;`.
   *
   * The character reference kind defines what and how many characters are
   * allowed.
   *
   * ```markdown
   * > | a&amp;b
   *       ^^^
   * > | a&#123;b
   *        ^^^
   * > | a&#x9;b
   *         ^
   * ```
   *
   * @type {State}
   */ function value(code) {
        if (code === 59 && size) {
            const token = effects.exit("characterReferenceValue");
            if (test === (0, $5RE1E.asciiAlphanumeric) && !(0, $cbxPV.decodeNamedCharacterReference)(self.sliceSerialize(token))) return nok(code);
            // To do: `markdown-rs` uses a different name:
            // `CharacterReferenceMarkerSemi`.
            effects.enter("characterReferenceMarker");
            effects.consume(code);
            effects.exit("characterReferenceMarker");
            effects.exit("characterReference");
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 





/** @type {Construct} */ const $40659a24e23c2c4f$var$nonLazyContinuation = {
    partial: true,
    tokenize: $40659a24e23c2c4f$var$tokenizeNonLazyContinuation
};
const $40659a24e23c2c4f$export$c23e4921f8d87e7c = {
    concrete: true,
    name: 'codeFenced',
    tokenize: $40659a24e23c2c4f$var$tokenizeCodeFenced
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $40659a24e23c2c4f$var$tokenizeCodeFenced(effects, ok, nok) {
    const self = this;
    /** @type {Construct} */ const closeStart = {
        partial: true,
        tokenize: tokenizeCloseStart
    };
    let initialPrefix = 0;
    let sizeOpen = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of code.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse whitespace like `markdown-rs`.
        return beforeSequenceOpen(code);
    }
    /**
   * In opening fence, after prefix, at sequence.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeSequenceOpen(code) {
        const tail = self.events[self.events.length - 1];
        initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
        marker = code;
        effects.enter("codeFenced");
        effects.enter("codeFencedFence");
        effects.enter("codeFencedFenceSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening fence sequence.
   *
   * ```markdown
   * > | ~~~js
   *      ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === marker) {
            sizeOpen++;
            effects.consume(code);
            return sequenceOpen;
        }
        if (sizeOpen < 3) return nok(code);
        effects.exit("codeFencedFenceSequence");
        return (0, $5RE1E.markdownSpace)(code) ? (0, $5jhd5.factorySpace)(effects, infoBefore, "whitespace")(code) : infoBefore(code);
    }
    /**
   * In opening fence, after the sequence (and optional whitespace), before info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function infoBefore(code) {
        if (code === null || (0, $5RE1E.markdownLineEnding)(code)) {
            effects.exit("codeFencedFence");
            return self.interrupt ? ok(code) : effects.check($40659a24e23c2c4f$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        }
        effects.enter("codeFencedFenceInfo");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return info(code);
    }
    /**
   * In info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function info(code) {
        if (code === null || (0, $5RE1E.markdownLineEnding)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return infoBefore(code);
        }
        if ((0, $5RE1E.markdownSpace)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return (0, $5jhd5.factorySpace)(effects, metaBefore, "whitespace")(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    /**
   * In opening fence, after info and whitespace, before meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function metaBefore(code) {
        if (code === null || (0, $5RE1E.markdownLineEnding)(code)) return infoBefore(code);
        effects.enter("codeFencedFenceMeta");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return meta(code);
    }
    /**
   * In meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function meta(code) {
        if (code === null || (0, $5RE1E.markdownLineEnding)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceMeta");
            return infoBefore(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    /**
   * At eol/eof in code, before a non-lazy closing fence or content.
   *
   * ```markdown
   * > | ~~~js
   *          ^
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function atNonLazyBreak(code) {
        return effects.attempt(closeStart, after, contentBefore)(code);
    }
    /**
   * Before code content, not a closing fence, at eol.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentBefore(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return contentStart;
    }
    /**
   * Before code content, not a closing fence.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentStart(code) {
        return initialPrefix > 0 && (0, $5RE1E.markdownSpace)(code) ? (0, $5jhd5.factorySpace)(effects, beforeContentChunk, "linePrefix", initialPrefix + 1)(code) : beforeContentChunk(code);
    }
    /**
   * Before code content, after optional prefix.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeContentChunk(code) {
        if (code === null || (0, $5RE1E.markdownLineEnding)(code)) return effects.check($40659a24e23c2c4f$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        effects.enter("codeFlowValue");
        return contentChunk(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^^^^^^^^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentChunk(code) {
        if (code === null || (0, $5RE1E.markdownLineEnding)(code)) {
            effects.exit("codeFlowValue");
            return beforeContentChunk(code);
        }
        effects.consume(code);
        return contentChunk;
    }
    /**
   * After code.
   *
   * ```markdown
   *   | ~~~js
   *   | alert(1)
   * > | ~~~
   *        ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        effects.exit("codeFenced");
        return ok(code);
    }
    /**
   * @this {TokenizeContext}
   *   Context.
   * @type {Tokenizer}
   */ function tokenizeCloseStart(effects, ok, nok) {
        let size = 0;
        return startBefore;
        /**
     *
     *
     * @type {State}
     */ function startBefore(code) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return start;
        }
        /**
     * Before closing fence, at optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function start(code) {
            // Always populated by defaults.
            // To do: `enter` here or in next state?
            effects.enter("codeFencedFence");
            return (0, $5RE1E.markdownSpace)(code) ? (0, $5jhd5.factorySpace)(effects, beforeSequenceClose, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : beforeSequenceClose(code);
        }
        /**
     * In closing fence, after optional whitespace, at sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function beforeSequenceClose(code) {
            if (code === marker) {
                effects.enter("codeFencedFenceSequence");
                return sequenceClose(code);
            }
            return nok(code);
        }
        /**
     * In closing fence sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function sequenceClose(code) {
            if (code === marker) {
                size++;
                effects.consume(code);
                return sequenceClose;
            }
            if (size >= sizeOpen) {
                effects.exit("codeFencedFenceSequence");
                return (0, $5RE1E.markdownSpace)(code) ? (0, $5jhd5.factorySpace)(effects, sequenceCloseAfter, "whitespace")(code) : sequenceCloseAfter(code);
            }
            return nok(code);
        }
        /**
     * After closing fence sequence, after optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *        ^
     * ```
     *
     * @type {State}
     */ function sequenceCloseAfter(code) {
            if (code === null || (0, $5RE1E.markdownLineEnding)(code)) {
                effects.exit("codeFencedFence");
                return ok(code);
            }
            return nok(code);
        }
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $40659a24e23c2c4f$var$tokenizeNonLazyContinuation(effects, ok, nok) {
    const self = this;
    return start;
    /**
   *
   *
   * @type {State}
   */ function start(code) {
        if (code === null) return nok(code);
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineStart;
    }
    /**
   *
   *
   * @type {State}
   */ function lineStart(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 





const $cbe4592c89a34a82$export$47910b7ab28d1853 = {
    name: 'codeIndented',
    tokenize: $cbe4592c89a34a82$var$tokenizeCodeIndented
};
/** @type {Construct} */ const $cbe4592c89a34a82$var$furtherStart = {
    partial: true,
    tokenize: $cbe4592c89a34a82$var$tokenizeFurtherStart
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $cbe4592c89a34a82$var$tokenizeCodeIndented(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of code (indented).
   *
   * > **Parsing note**: it is not needed to check if this first line is a
   * > filled line (that it has a non-whitespace character), because blank lines
   * > are parsed already, so we never run into that.
   *
   * ```markdown
   * > |     aaa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: manually check if interrupting like `markdown-rs`.
        effects.enter("codeIndented");
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $5jhd5.factorySpace)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code) : nok(code);
    }
    /**
   * At a break.
   *
   * ```markdown
   * > |     aaa
   *         ^  ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === null) return after(code);
        if ((0, $5RE1E.markdownLineEnding)(code)) return effects.attempt($cbe4592c89a34a82$var$furtherStart, atBreak, after)(code);
        effects.enter("codeFlowValue");
        return inside(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   * > |     aaa
   *         ^^^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === null || (0, $5RE1E.markdownLineEnding)(code)) {
            effects.exit("codeFlowValue");
            return atBreak(code);
        }
        effects.consume(code);
        return inside;
    }
    /** @type {State} */ function after(code) {
        effects.exit("codeIndented");
        // To do: allow interrupting like `markdown-rs`.
        // Feel free to interrupt.
        // tokenizer.interrupt = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $cbe4592c89a34a82$var$tokenizeFurtherStart(effects, ok, nok) {
    const self = this;
    return furtherStart;
    /**
   * At eol, trying to parse another indent.
   *
   * ```markdown
   * > |     aaa
   *            ^
   *   |     bbb
   * ```
   *
   * @type {State}
   */ function furtherStart(code) {
        // To do: improve `lazy` / `pierce` handling.
        // If this is a lazy line, it can’t be code.
        if (self.parser.lazy[self.now().line]) return nok(code);
        if ((0, $5RE1E.markdownLineEnding)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return furtherStart;
        }
        // To do: the code here in `micromark-js` is a bit different from
        // `markdown-rs` because there it can attempt spaces.
        // We can’t yet.
        //
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $5jhd5.factorySpace)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok(code) : (0, $5RE1E.markdownLineEnding)(code) ? furtherStart(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Previous,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 


const $5484c95cc3a34814$export$d24f93e715f9df88 = {
    name: 'codeText',
    previous: $5484c95cc3a34814$var$previous,
    resolve: $5484c95cc3a34814$var$resolveCodeText,
    tokenize: $5484c95cc3a34814$var$tokenizeCodeText
};
// To do: next major: don’t resolve, like `markdown-rs`.
/** @type {Resolver} */ function $5484c95cc3a34814$var$resolveCodeText(events) {
    let tailExitIndex = events.length - 4;
    let headEnterIndex = 3;
    /** @type {number} */ let index;
    /** @type {number | undefined} */ let enter;
    // If we start and end with an EOL or a space.
    if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === 'space') && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === 'space')) {
        index = headEnterIndex;
        // And we have data.
        while(++index < tailExitIndex)if (events[index][1].type === "codeTextData") {
            // Then we have padding.
            events[headEnterIndex][1].type = "codeTextPadding";
            events[tailExitIndex][1].type = "codeTextPadding";
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    }
    // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== "lineEnding") enter = index;
        } else if (index === tailExitIndex || events[index][1].type === "lineEnding") {
            events[enter][1].type = "codeTextData";
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Previous}
 */ function $5484c95cc3a34814$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $5484c95cc3a34814$var$tokenizeCodeText(effects, ok, nok) {
    const self = this;
    let sizeOpen = 0;
    /** @type {number} */ let size;
    /** @type {Token} */ let token;
    return start;
    /**
   * Start of code (text).
   *
   * ```markdown
   * > | `a`
   *     ^
   * > | \`a`
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("codeText");
        effects.enter("codeTextSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | `a`
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit("codeTextSequence");
        return between(code);
    }
    /**
   * Between something and something else.
   *
   * ```markdown
   * > | `a`
   *      ^^
   * ```
   *
   * @type {State}
   */ function between(code) {
        // EOF.
        if (code === null) return nok(code);
        // To do: next major: don’t do spaces in resolve, but when compiling,
        // like `markdown-rs`.
        // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter('space');
            effects.consume(code);
            effects.exit('space');
            return between;
        }
        // Closing fence? Could also be data.
        if (code === 96) {
            token = effects.enter("codeTextSequence");
            size = 0;
            return sequenceClose(code);
        }
        if ((0, $5RE1E.markdownLineEnding)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return between;
        }
        // Data.
        effects.enter("codeTextData");
        return data(code);
    }
    /**
   * In data.
   *
   * ```markdown
   * > | `a`
   *      ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 32 || code === 96 || (0, $5RE1E.markdownLineEnding)(code)) {
            effects.exit("codeTextData");
            return between(code);
        }
        effects.consume(code);
        return data;
    }
    /**
   * In closing sequence.
   *
   * ```markdown
   * > | `a`
   *       ^
   * ```
   *
   * @type {State}
   */ function sequenceClose(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return sequenceClose;
        }
        // Done!
        if (size === sizeOpen) {
            effects.exit("codeTextSequence");
            effects.exit("codeText");
            return ok(code);
        }
        // More or less accents: mark as data.
        token.type = "codeTextData";
        return data(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ /**
 * @import {Effects, State, TokenType} from 'micromark-util-types'
 */ 


function $966f62c2a545a5b1$export$2e6c8deaa96af245(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    const limit = max || Number.POSITIVE_INFINITY;
    let balance = 0;
    return start;
    /**
   * Start of destination.
   *
   * ```markdown
   * > | <aa>
   *     ^
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return enclosedBefore;
        }
        // ASCII control, space, closing paren.
        if (code === null || code === 32 || code === 41 || (0, $5RE1E.asciiControl)(code)) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return raw(code);
    }
    /**
   * After `<`, at an enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return enclosed(code);
    }
    /**
   * In enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosed(code) {
        if (code === 62) {
            effects.exit("chunkString");
            effects.exit(stringType);
            return enclosedBefore(code);
        }
        if (code === null || code === 60 || (0, $5RE1E.markdownLineEnding)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? enclosedEscape : enclosed;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | <a\*a>
   *        ^
   * ```
   *
   * @type {State}
   */ function enclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return enclosed;
        }
        return enclosed(code);
    }
    /**
   * In raw destination.
   *
   * ```markdown
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function raw(code) {
        if (!balance && (code === null || code === 41 || (0, $5RE1E.markdownLineEndingOrSpace)(code))) {
            effects.exit("chunkString");
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if (balance < limit && code === 40) {
            effects.consume(code);
            balance++;
            return raw;
        }
        if (code === 41) {
            effects.consume(code);
            balance--;
            return raw;
        }
        // ASCII control (but *not* `\0`) and space and `(`.
        // Note: in `markdown-rs`, `\0` exists in codes, in `micromark-js` it
        // doesn’t.
        if (code === null || code === 32 || code === 40 || (0, $5RE1E.asciiControl)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? rawEscape : raw;
    }
    /**
   * After `\`, at special character.
   *
   * ```markdown
   * > | a\*a
   *       ^
   * ```
   *
   * @type {State}
   */ function rawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return raw;
        }
        return raw(code);
    }
}


/**
 * @import {
 *   Effects,
 *   State,
 *   TokenizeContext,
 *   TokenType
 * } from 'micromark-util-types'
 */ 


function $7878baf14d32ac58$export$7b768614d8ba97a7(effects, ok, nok, type, markerType, stringType) {
    const self = this;
    let size = 0;
    /** @type {boolean} */ let seen;
    return start;
    /**
   * Start of label.
   *
   * ```markdown
   * > | [a]
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    /**
   * In label, at something, before something else.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (size > 999 || code === null || code === 91 || code === 93 && !seen || // To do: remove in the future once we’ve switched from
        // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
        // which doesn’t need this.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ code === 94 && !size && '_hiddenFootnoteSupport' in self.parser.constructs) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        // To do: indent? Link chunks and EOLs together?
        if ((0, $5RE1E.markdownLineEnding)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return atBreak;
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return labelInside(code);
    }
    /**
   * In label, in text.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (code === null || code === 91 || code === 93 || (0, $5RE1E.markdownLineEnding)(code) || size++ > 999) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        if (!seen) seen = !(0, $5RE1E.markdownSpace)(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | [a\*a]
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
}





/**
 * @import {
 *   Code,
 *   Effects,
 *   State,
 *   TokenType
 * } from 'micromark-util-types'
 */ 





function $5d634193ab20e30b$export$f970569cc855e483(effects, ok, nok, type, markerType, stringType) {
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of title.
   *
   * ```markdown
   * > | "a"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 34 || code === 39 || code === 40) {
            effects.enter(type);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            marker = code === 40 ? 41 : code;
            return begin;
        }
        return nok(code);
    }
    /**
   * After opening marker.
   *
   * This is also used at the closing marker.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function begin(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atBreak(code);
    }
    /**
   * At something, before something else.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return begin(marker);
        }
        if (code === null) return nok(code);
        // Note: blank lines can’t exist in content.
        if ((0, $5RE1E.markdownLineEnding)(code)) {
            // To do: use `space_or_tab_eol_with_options`, connect.
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return (0, $5jhd5.factorySpace)(effects, atBreak, "linePrefix");
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return inside(code);
    }
    /**
   *
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker || code === null || (0, $5RE1E.markdownLineEnding)(code)) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        return code === 92 ? escape : inside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | "a\*b"
   *      ^
   * ```
   *
   * @type {State}
   */ function escape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return inside;
        }
        return inside(code);
    }
}


/**
 * @import {Effects, State} from 'micromark-util-types'
 */ 





function $e5037cd98ae93105$export$1f27bd1aa33ce173(effects, ok) {
    /** @type {boolean} */ let seen;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $5RE1E.markdownLineEnding)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            seen = true;
            return start;
        }
        if ((0, $5RE1E.markdownSpace)(code)) return (0, $5jhd5.factorySpace)(effects, start, seen ? "linePrefix" : "lineSuffix")(code);
        return ok(code);
    }
}






var $fEgdu = parcelRequire("fEgdu");

const $9c47ccd1b660af72$export$69f215ed977cdb73 = {
    name: 'definition',
    tokenize: $9c47ccd1b660af72$var$tokenizeDefinition
};
/** @type {Construct} */ const $9c47ccd1b660af72$var$titleBefore = {
    partial: true,
    tokenize: $9c47ccd1b660af72$var$tokenizeTitleBefore
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $9c47ccd1b660af72$var$tokenizeDefinition(effects, ok, nok) {
    const self = this;
    /** @type {string} */ let identifier;
    return start;
    /**
   * At start of a definition.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Do not interrupt paragraphs (but do follow definitions).
        // To do: do `interrupt` the way `markdown-rs` does.
        // To do: parse whitespace the way `markdown-rs` does.
        effects.enter("definition");
        return before(code);
    }
    /**
   * After optional whitespace, at `[`.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        // To do: parse whitespace the way `markdown-rs` does.
        return (0, $7878baf14d32ac58$export$7b768614d8ba97a7).call(self, effects, labelAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(code);
    }
    /**
   * After label.
   *
   * ```markdown
   * > | [a]: b "c"
   *        ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        identifier = (0, $fEgdu.normalizeIdentifier)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker");
            return markerAfter;
        }
        return nok(code);
    }
    /**
   * After marker.
   *
   * ```markdown
   * > | [a]: b "c"
   *         ^
   * ```
   *
   * @type {State}
   */ function markerAfter(code) {
        // Note: whitespace is optional.
        return (0, $5RE1E.markdownLineEndingOrSpace)(code) ? (0, $e5037cd98ae93105$export$1f27bd1aa33ce173)(effects, destinationBefore)(code) : destinationBefore(code);
    }
    /**
   * Before destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *          ^
   * ```
   *
   * @type {State}
   */ function destinationBefore(code) {
        return (0, $966f62c2a545a5b1$export$2e6c8deaa96af245)(effects, destinationAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString")(code);
    }
    /**
   * After destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function destinationAfter(code) {
        return effects.attempt($9c47ccd1b660af72$var$titleBefore, after, after)(code);
    }
    /**
   * After definition.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return (0, $5RE1E.markdownSpace)(code) ? (0, $5jhd5.factorySpace)(effects, afterWhitespace, "whitespace")(code) : afterWhitespace(code);
    }
    /**
   * After definition, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function afterWhitespace(code) {
        if (code === null || (0, $5RE1E.markdownLineEnding)(code)) {
            effects.exit("definition");
            // Note: we don’t care about uniqueness.
            // It’s likely that that doesn’t happen very frequently.
            // It is more likely that it wastes precious time.
            self.parser.defined.push(identifier);
            // To do: `markdown-rs` interrupt.
            // // You’d be interrupting.
            // tokenizer.interrupt = true
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $9c47ccd1b660af72$var$tokenizeTitleBefore(effects, ok, nok) {
    return titleBefore;
    /**
   * After destination, at whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function titleBefore(code) {
        return (0, $5RE1E.markdownLineEndingOrSpace)(code) ? (0, $e5037cd98ae93105$export$1f27bd1aa33ce173)(effects, beforeMarker)(code) : nok(code);
    }
    /**
   * At title.
   *
   * ```markdown
   *   | [a]: b
   * > | "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function beforeMarker(code) {
        return (0, $5d634193ab20e30b$export$f970569cc855e483)(effects, titleAfter, nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code);
    }
    /**
   * After title.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfter(code) {
        return (0, $5RE1E.markdownSpace)(code) ? (0, $5jhd5.factorySpace)(effects, titleAfterOptionalWhitespace, "whitespace")(code) : titleAfterOptionalWhitespace(code);
    }
    /**
   * After title, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfterOptionalWhitespace(code) {
        return code === null || (0, $5RE1E.markdownLineEnding)(code) ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 


const $63c1b5bdb9ef13e1$export$86c573ab9e06f418 = {
    name: 'hardBreakEscape',
    tokenize: $63c1b5bdb9ef13e1$var$tokenizeHardBreakEscape
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $63c1b5bdb9ef13e1$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    /**
   * Start of a hard break (escape).
   *
   * ```markdown
   * > | a\
   *      ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("hardBreakEscape");
        effects.consume(code);
        return after;
    }
    /**
   * After `\`, at eol.
   *
   * ```markdown
   * > | a\
   *       ^
   *   | b
   * ```
   *
   *  @type {State}
   */ function after(code) {
        if ((0, $5RE1E.markdownLineEnding)(code)) {
            effects.exit("hardBreakEscape");
            return ok(code);
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 








const $298a7502fec86174$export$3871e9deb360695c = {
    name: 'headingAtx',
    resolve: $298a7502fec86174$var$resolveHeadingAtx,
    tokenize: $298a7502fec86174$var$tokenizeHeadingAtx
};
/** @type {Resolver} */ function $298a7502fec86174$var$resolveHeadingAtx(events, context) {
    let contentEnd = events.length - 2;
    let contentStart = 3;
    /** @type {Token} */ let content;
    /** @type {Token} */ let text;
    // Prefix whitespace, part of the opening.
    if (events[contentStart][1].type === "whitespace") contentStart += 2;
    // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") contentEnd -= 2;
    if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: "atxHeadingText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: "chunkText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: "text"
        };
        (0, $bHIRo.splice)(events, contentStart, contentEnd - contentStart + 1, [
            [
                'enter',
                content,
                context
            ],
            [
                'enter',
                text,
                context
            ],
            [
                'exit',
                text,
                context
            ],
            [
                'exit',
                content,
                context
            ]
        ]);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $298a7502fec86174$var$tokenizeHeadingAtx(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of a heading (atx).
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        effects.enter("atxHeading");
        return before(code);
    }
    /**
   * After optional whitespace, at `#`.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("atxHeadingSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return sequenceOpen;
        }
        // Always at least one `#`.
        if (code === null || (0, $5RE1E.markdownLineEndingOrSpace)(code)) {
            effects.exit("atxHeadingSequence");
            return atBreak(code);
        }
        return nok(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ## aa
   *       ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === 35) {
            effects.enter("atxHeadingSequence");
            return sequenceFurther(code);
        }
        if (code === null || (0, $5RE1E.markdownLineEnding)(code)) {
            effects.exit("atxHeading");
            // To do: interrupt like `markdown-rs`.
            // // Feel free to interrupt.
            // tokenizer.interrupt = false
            return ok(code);
        }
        if ((0, $5RE1E.markdownSpace)(code)) return (0, $5jhd5.factorySpace)(effects, atBreak, "whitespace")(code);
        // To do: generate `data` tokens, add the `text` token later.
        // Needs edit map, see: `markdown.rs`.
        effects.enter("atxHeadingText");
        return data(code);
    }
    /**
   * In further sequence (after whitespace).
   *
   * Could be normal “visible” hashes in the heading or a final sequence.
   *
   * ```markdown
   * > | ## aa ##
   *           ^
   * ```
   *
   * @type {State}
   */ function sequenceFurther(code) {
        if (code === 35) {
            effects.consume(code);
            return sequenceFurther;
        }
        effects.exit("atxHeadingSequence");
        return atBreak(code);
    }
    /**
   * In text.
   *
   * ```markdown
   * > | ## aa
   *        ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 35 || (0, $5RE1E.markdownLineEndingOrSpace)(code)) {
            effects.exit("atxHeadingText");
            return atBreak(code);
        }
        effects.consume(code);
        return data;
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 


/**
 * List of lowercase HTML “block” tag names.
 *
 * The list, when parsing HTML (flow), results in more relaxed rules (condition
 * 6).
 * Because they are known blocks, the HTML-like syntax doesn’t have to be
 * strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `search` was added in `CommonMark@0.31`.
 */ const $02557cd3df86e2d9$export$7364aee1c59d1879 = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'search',
    'section',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];
const $02557cd3df86e2d9$export$948e66da505d080 = [
    'pre',
    'script',
    'style',
    'textarea'
];



const $d70dc97524407fcb$export$476ac411cb7d0d8f = {
    concrete: true,
    name: 'htmlFlow',
    resolveTo: $d70dc97524407fcb$var$resolveToHtmlFlow,
    tokenize: $d70dc97524407fcb$var$tokenizeHtmlFlow
};
/** @type {Construct} */ const $d70dc97524407fcb$var$blankLineBefore = {
    partial: true,
    tokenize: $d70dc97524407fcb$var$tokenizeBlankLineBefore
};
const $d70dc97524407fcb$var$nonLazyContinuationStart = {
    partial: true,
    tokenize: $d70dc97524407fcb$var$tokenizeNonLazyContinuationStart
};
/** @type {Resolver} */ function $d70dc97524407fcb$var$resolveToHtmlFlow(events) {
    let index = events.length;
    while(index--){
        if (events[index][0] === 'enter' && events[index][1].type === "htmlFlow") break;
    }
    if (index > 1 && events[index - 2][1].type === "linePrefix") {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start;
        // Add the prefix start to the HTML line token.
        events[index + 1][1].start = events[index - 2][1].start;
        // Remove the line prefix.
        events.splice(index - 2, 2);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $d70dc97524407fcb$var$tokenizeHtmlFlow(effects, ok, nok) {
    const self = this;
    /** @type {number} */ let marker;
    /** @type {boolean} */ let closingTag;
    /** @type {string} */ let buffer;
    /** @type {number} */ let index;
    /** @type {Code} */ let markerB;
    return start;
    /**
   * Start of HTML (flow).
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * At `<`, after optional whitespace.
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("htmlFlow");
        effects.enter("htmlFlowData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | <x />
   *      ^
   * > | <!doctype>
   *      ^
   * > | <!--xxx-->
   *      ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            closingTag = true;
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            marker = 3;
            // To do:
            // tokenizer.concrete = true
            // To do: use `markdown-rs` style interrupt.
            // While we’re in an instruction instead of a declaration, we’re on a `?`
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        // ASCII alphabetical.
        if ((0, $5RE1E.asciiAlpha)(code)) {
            // Always the case.
            effects.consume(code);
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | <!doctype>
   *       ^
   * > | <!--xxx-->
   *       ^
   * > | <![CDATA[>&<]]>
   *       ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            marker = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            marker = 5;
            index = 0;
            return cdataOpenInside;
        }
        // ASCII alphabetical.
        if ((0, $5RE1E.asciiAlpha)(code)) {
            effects.consume(code);
            marker = 4;
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<!-`, inside a comment, at another `-`.
   *
   * ```markdown
   * > | <!--xxx-->
   *        ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<![`, inside CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *        ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            if (index === value.length) // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
            return cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | </x>
   *       ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        if ((0, $5RE1E.asciiAlpha)(code)) {
            // Always the case.
            effects.consume(code);
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * In tag name.
   *
   * ```markdown
   * > | <ab>
   *      ^^
   * > | </ab>
   *       ^^
   * ```
   *
   * @type {State}
   */ function tagName(code) {
        if (code === null || code === 47 || code === 62 || (0, $5RE1E.markdownLineEndingOrSpace)(code)) {
            const slash = code === 47;
            const name = buffer.toLowerCase();
            if (!slash && !closingTag && (0, $02557cd3df86e2d9$export$948e66da505d080).includes(name)) {
                marker = 1;
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ((0, $02557cd3df86e2d9$export$7364aee1c59d1879).includes(buffer.toLowerCase())) {
                marker = 6;
                if (slash) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            marker = 7;
            // Do not support complete HTML when interrupting.
            return self.interrupt && !self.parser.lazy[self.now().line] ? nok(code) : closingTag ? completeClosingTagAfter(code) : completeAttributeNameBefore(code);
        }
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $5RE1E.asciiAlphanumeric)(code)) {
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After closing slash of a basic tag name.
   *
   * ```markdown
   * > | <div/>
   *          ^
   * ```
   *
   * @type {State}
   */ function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    /**
   * After closing slash of a complete tag name.
   *
   * ```markdown
   * > | <x/>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeClosingTagAfter(code) {
        if ((0, $5RE1E.markdownSpace)(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    /**
   * At an attribute name.
   *
   * At first, this state is used after a complete tag name, after whitespace,
   * where it expects optional attributes or the end of the tag.
   * It is also reused after attributes, when expecting more optional
   * attributes.
   *
   * ```markdown
   * > | <a />
   *        ^
   * > | <a :b>
   *        ^
   * > | <a _b>
   *        ^
   * > | <a b>
   *        ^
   * > | <a >
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        // ASCII alphanumerical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $5RE1E.asciiAlpha)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ((0, $5RE1E.markdownSpace)(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | <a :b>
   *         ^
   * > | <a _b>
   *         ^
   * > | <a b>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeName(code) {
        // ASCII alphanumerical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $5RE1E.asciiAlphanumeric)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    /**
   * After attribute name, at an optional initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | <a b>
   *         ^
   * > | <a b=c>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ((0, $5RE1E.markdownSpace)(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * > | <a b="c">
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            markerB = code;
            return completeAttributeValueQuoted;
        }
        if ((0, $5RE1E.markdownSpace)(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        return completeAttributeValueUnquoted(code);
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | <a b="c">
   *           ^
   * > | <a b='c'>
   *           ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuoted(code) {
        if (code === markerB) {
            effects.consume(code);
            markerB = null;
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || (0, $5RE1E.markdownLineEnding)(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 47 || code === 60 || code === 61 || code === 62 || code === 96 || (0, $5RE1E.markdownLineEndingOrSpace)(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the
   * end of the tag.
   *
   * ```markdown
   * > | <a b="c">
   *            ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $5RE1E.markdownSpace)(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a complete tag where only an `>` is allowed.
   *
   * ```markdown
   * > | <a b="c">
   *             ^
   * ```
   *
   * @type {State}
   */ function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * After `>` in a complete tag.
   *
   * ```markdown
   * > | <x>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAfter(code) {
        if (code === null || (0, $5RE1E.markdownLineEnding)(code)) // // Do not form containers.
        // tokenizer.concrete = true
        return continuation(code);
        if ((0, $5RE1E.markdownSpace)(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * In continuation of any HTML kind.
   *
   * ```markdown
   * > | <!--xxx-->
   *          ^
   * ```
   *
   * @type {State}
   */ function continuation(code) {
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && marker === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && marker === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && marker === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && marker === 5) {
            effects.consume(code);
            return continuationCdataInside;
        }
        if ((0, $5RE1E.markdownLineEnding)(code) && (marker === 6 || marker === 7)) {
            effects.exit("htmlFlowData");
            return effects.check($d70dc97524407fcb$var$blankLineBefore, continuationAfter, continuationStart)(code);
        }
        if (code === null || (0, $5RE1E.markdownLineEnding)(code)) {
            effects.exit("htmlFlowData");
            return continuationStart(code);
        }
        effects.consume(code);
        return continuation;
    }
    /**
   * In continuation, at eol.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStart(code) {
        return effects.check($d70dc97524407fcb$var$nonLazyContinuationStart, continuationStartNonLazy, continuationAfter)(code);
    }
    /**
   * In continuation, at eol, before non-lazy content.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStartNonLazy(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return continuationBefore;
    }
    /**
   * In continuation, before non-lazy content.
   *
   * ```markdown
   *   | <x>
   * > | asd
   *     ^
   * ```
   *
   * @type {State}
   */ function continuationBefore(code) {
        if (code === null || (0, $5RE1E.markdownLineEnding)(code)) return continuationStart(code);
        effects.enter("htmlFlowData");
        return continuation(code);
    }
    /**
   * In comment continuation, after one `-`, expecting another.
   *
   * ```markdown
   * > | <!--xxx-->
   *             ^
   * ```
   *
   * @type {State}
   */ function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `<`, at `/`.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                            ^
   * ```
   *
   * @type {State}
   */ function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = '';
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `</`, in a raw tag name.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                             ^^^^^^
   * ```
   *
   * @type {State}
   */ function continuationRawEndTag(code) {
        if (code === 62) {
            const name = buffer.toLowerCase();
            if ((0, $02557cd3df86e2d9$export$948e66da505d080).includes(name)) {
                effects.consume(code);
                return continuationClose;
            }
            return continuation(code);
        }
        if ((0, $5RE1E.asciiAlpha)(code) && buffer.length < 8) {
            // Always the case.
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In cdata continuation, after `]`, expecting `]>`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *                  ^
   * ```
   *
   * @type {State}
   */ function continuationCdataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In declaration or instruction continuation, at `>`.
   *
   * ```markdown
   * > | <!-->
   *         ^
   * > | <?>
   *       ^
   * > | <!q>
   *        ^
   * > | <!--ab-->
   *             ^
   * > | <![CDATA[>&<]]>
   *                   ^
   * ```
   *
   * @type {State}
   */ function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        // More dashes.
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In closed continuation: everything we get until the eol/eof is part of it.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationClose(code) {
        if (code === null || (0, $5RE1E.markdownLineEnding)(code)) {
            effects.exit("htmlFlowData");
            return continuationAfter(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    /**
   * Done.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationAfter(code) {
        effects.exit("htmlFlow");
        // // Feel free to interrupt.
        // tokenizer.interrupt = false
        // // No longer concrete.
        // tokenizer.concrete = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $d70dc97524407fcb$var$tokenizeNonLazyContinuationStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * At eol, before continuation.
   *
   * ```markdown
   * > | * ```js
   *            ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        if ((0, $5RE1E.markdownLineEnding)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return after;
        }
        return nok(code);
    }
    /**
   * A continuation.
   *
   * ```markdown
   *   | * ```js
   * > | b
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $d70dc97524407fcb$var$tokenizeBlankLineBefore(effects, ok, nok) {
    return start;
    /**
   * Before eol, expecting blank line.
   *
   * ```markdown
   * > | <div>
   *          ^
   *   |
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return effects.attempt((0, $42a0773f37ffce85$export$d50d28ce3ab2a612), ok, nok);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 





const $33ff20bf4faaf9fa$export$398af27f284914fe = {
    name: 'htmlText',
    tokenize: $33ff20bf4faaf9fa$var$tokenizeHtmlText
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $33ff20bf4faaf9fa$var$tokenizeHtmlText(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code> | undefined} */ let marker;
    /** @type {number} */ let index;
    /** @type {State} */ let returnState;
    return start;
    /**
   * Start of HTML (text).
   *
   * ```markdown
   * > | a <b> c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("htmlText");
        effects.enter("htmlTextData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | a <b> c
   *        ^
   * > | a <!doctype> c
   *        ^
   * > | a <!--b--> c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        // ASCII alphabetical.
        if ((0, $5RE1E.asciiAlpha)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | a <!doctype> c
   *         ^
   * > | a <!--b--> c
   *         ^
   * > | a <![CDATA[>&<]]> c
   *         ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            index = 0;
            return cdataOpenInside;
        }
        if ((0, $5RE1E.asciiAlpha)(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    /**
   * In a comment, after `<!-`, at another `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *          ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return nok(code);
    }
    /**
   * In comment.
   *
   * ```markdown
   * > | a <!--b--> c
   *           ^
   * ```
   *
   * @type {State}
   */ function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ((0, $5RE1E.markdownLineEnding)(code)) {
            returnState = comment;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return comment;
    }
    /**
   * In comment, after `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *             ^
   * ```
   *
   * @type {State}
   */ function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return comment(code);
    }
    /**
   * In comment, after `--`.
   *
   * ```markdown
   * > | a <!--b--> c
   *              ^
   * ```
   *
   * @type {State}
   */ function commentEnd(code) {
        return code === 62 ? end(code) : code === 45 ? commentClose(code) : comment(code);
    }
    /**
   * After `<![`, in CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *          ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            return index === value.length ? cdata : cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * In CDATA.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                ^^^
   * ```
   *
   * @type {State}
   */ function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ((0, $5RE1E.markdownLineEnding)(code)) {
            returnState = cdata;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return cdata;
    }
    /**
   * In CDATA, after `]`, at another `]`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                    ^
   * ```
   *
   * @type {State}
   */ function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In CDATA, after `]]`, at `>`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                     ^
   * ```
   *
   * @type {State}
   */ function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In declaration.
   *
   * ```markdown
   * > | a <!b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ((0, $5RE1E.markdownLineEnding)(code)) {
            returnState = declaration;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return declaration;
    }
    /**
   * In instruction.
   *
   * ```markdown
   * > | a <?b?> c
   *         ^
   * ```
   *
   * @type {State}
   */ function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ((0, $5RE1E.markdownLineEnding)(code)) {
            returnState = instruction;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return instruction;
    }
    /**
   * In instruction, after `?`, at `>`.
   *
   * ```markdown
   * > | a <?b?> c
   *           ^
   * ```
   *
   * @type {State}
   */ function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | a </b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        // ASCII alphabetical.
        if ((0, $5RE1E.asciiAlpha)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    /**
   * After `</x`, in a tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagClose(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $5RE1E.asciiAlphanumeric)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    /**
   * In closing tag, after tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagCloseBetween(code) {
        if ((0, $5RE1E.markdownLineEnding)(code)) {
            returnState = tagCloseBetween;
            return lineEndingBefore(code);
        }
        if ((0, $5RE1E.markdownSpace)(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    /**
   * After `<x`, in opening tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpen(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $5RE1E.asciiAlphanumeric)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || (0, $5RE1E.markdownLineEndingOrSpace)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In opening tag, after tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        // ASCII alphabetical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $5RE1E.asciiAlpha)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ((0, $5RE1E.markdownLineEnding)(code)) {
            returnState = tagOpenBetween;
            return lineEndingBefore(code);
        }
        if ((0, $5RE1E.markdownSpace)(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | a <b c> d
   *          ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeName(code) {
        // ASCII alphabetical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $5RE1E.asciiAlphanumeric)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    /**
   * After attribute name, before initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | a <b c> d
   *           ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ((0, $5RE1E.markdownLineEnding)(code)) {
            returnState = tagOpenAttributeNameAfter;
            return lineEndingBefore(code);
        }
        if ((0, $5RE1E.markdownSpace)(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ((0, $5RE1E.markdownLineEnding)(code)) {
            returnState = tagOpenAttributeValueBefore;
            return lineEndingBefore(code);
        }
        if ((0, $5RE1E.markdownSpace)(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | a <b c="d"> e
   *             ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            marker = undefined;
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ((0, $5RE1E.markdownLineEnding)(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 47 || code === 62 || (0, $5RE1E.markdownLineEndingOrSpace)(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the end
   * of the tag.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $5RE1E.markdownLineEndingOrSpace)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a tag where only an `>` is allowed.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit("htmlTextData");
            effects.exit("htmlText");
            return ok;
        }
        return nok(code);
    }
    /**
   * At eol.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   * > | a <!--a
   *            ^
   *   | b-->
   * ```
   *
   * @type {State}
   */ function lineEndingBefore(code) {
        effects.exit("htmlTextData");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineEndingAfter;
    }
    /**
   * After eol, at optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfter(code) {
        // Always populated by defaults.
        return (0, $5RE1E.markdownSpace)(code) ? (0, $5jhd5.factorySpace)(effects, lineEndingAfterPrefix, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : lineEndingAfterPrefix(code);
    }
    /**
   * After eol, after optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfterPrefix(code) {
        effects.enter("htmlTextData");
        return returnState(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Event,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 















const $058ebb3e19abf189$export$470a5dafbbf62654 = {
    name: 'labelEnd',
    resolveAll: $058ebb3e19abf189$var$resolveAllLabelEnd,
    resolveTo: $058ebb3e19abf189$var$resolveToLabelEnd,
    tokenize: $058ebb3e19abf189$var$tokenizeLabelEnd
};
/** @type {Construct} */ const $058ebb3e19abf189$var$resourceConstruct = {
    tokenize: $058ebb3e19abf189$var$tokenizeResource
};
/** @type {Construct} */ const $058ebb3e19abf189$var$referenceFullConstruct = {
    tokenize: $058ebb3e19abf189$var$tokenizeReferenceFull
};
/** @type {Construct} */ const $058ebb3e19abf189$var$referenceCollapsedConstruct = {
    tokenize: $058ebb3e19abf189$var$tokenizeReferenceCollapsed
};
/** @type {Resolver} */ function $058ebb3e19abf189$var$resolveAllLabelEnd(events) {
    let index = -1;
    /** @type {Array<Event>} */ const newEvents = [];
    while(++index < events.length){
        const token = events[index][1];
        newEvents.push(events[index]);
        if (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd") {
            // Remove the marker.
            const offset = token.type === "labelImage" ? 4 : 2;
            token.type = "data";
            index += offset;
        }
    }
    // If the events are equal, we don't have to copy newEvents to events
    if (events.length !== newEvents.length) (0, $bHIRo.splice)(events, 0, events.length, newEvents);
    return events;
}
/** @type {Resolver} */ function $058ebb3e19abf189$var$resolveToLabelEnd(events, context) {
    let index = events.length;
    let offset = 0;
    /** @type {Token} */ let token;
    /** @type {number | undefined} */ let open;
    /** @type {number | undefined} */ let close;
    /** @type {Array<Event>} */ let media;
    // Find an opening.
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === "link" || token.type === "labelLink" && token._inactive) break;
            // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === 'enter' && token.type === "labelLink") token._inactive = true;
        } else if (close) {
            if (events[index][0] === 'enter' && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
                open = index;
                if (token.type !== "labelLink") {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === "labelEnd") close = index;
    }
    const group = {
        type: events[open][1].type === "labelLink" ? "link" : "image",
        start: {
            ...events[open][1].start
        },
        end: {
            ...events[events.length - 1][1].end
        }
    };
    const label = {
        type: "label",
        start: {
            ...events[open][1].start
        },
        end: {
            ...events[close][1].end
        }
    };
    const text = {
        type: "labelText",
        start: {
            ...events[open + offset + 2][1].end
        },
        end: {
            ...events[close - 2][1].start
        }
    };
    media = [
        [
            'enter',
            group,
            context
        ],
        [
            'enter',
            label,
            context
        ]
    ];
    // Opening marker.
    media = (0, $bHIRo.push)(media, events.slice(open + 1, open + offset + 3));
    // Text open.
    media = (0, $bHIRo.push)(media, [
        [
            'enter',
            text,
            context
        ]
    ]);
    // Always populated by defaults.
    // Between.
    media = (0, $bHIRo.push)(media, (0, $9CjcD.resolveAll)(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context));
    // Text close, marker close, label close.
    media = (0, $bHIRo.push)(media, [
        [
            'exit',
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            'exit',
            label,
            context
        ]
    ]);
    // Reference, resource, or so.
    media = (0, $bHIRo.push)(media, events.slice(close + 1));
    // Media close.
    media = (0, $bHIRo.push)(media, [
        [
            'exit',
            group,
            context
        ]
    ]);
    (0, $bHIRo.splice)(events, open, events.length, media);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $058ebb3e19abf189$var$tokenizeLabelEnd(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    /** @type {Token} */ let labelStart;
    /** @type {boolean} */ let defined;
    // Find an opening.
    while(index--)if ((self.events[index][1].type === "labelImage" || self.events[index][1].type === "labelLink") && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    /**
   * Start of label end.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   * ```
   *
   * @type {State}
   */ function start(code) {
        // If there is not an okay opening.
        if (!labelStart) return nok(code);
        // If the corresponding label (link) start is marked as inactive,
        // it means we’d be wrapping a link, like this:
        //
        // ```markdown
        // > | a [b [c](d) e](f) g.
        //                  ^
        // ```
        //
        // We can’t have that, so it’s just balanced brackets.
        if (labelStart._inactive) return labelEndNok(code);
        defined = self.parser.defined.includes((0, $fEgdu.normalizeIdentifier)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        })));
        effects.enter("labelEnd");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelEnd");
        return after;
    }
    /**
   * After `]`.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Note: `markdown-rs` also parses GFM footnotes here, which for us is in
        // an extension.
        // Resource (`[asd](fgh)`)?
        if (code === 40) return effects.attempt($058ebb3e19abf189$var$resourceConstruct, labelEndOk, defined ? labelEndOk : labelEndNok)(code);
        // Full (`[asd][fgh]`) or collapsed (`[asd][]`) reference?
        if (code === 91) return effects.attempt($058ebb3e19abf189$var$referenceFullConstruct, labelEndOk, defined ? referenceNotFull : labelEndNok)(code);
        // Shortcut (`[asd]`) reference?
        return defined ? labelEndOk(code) : labelEndNok(code);
    }
    /**
   * After `]`, at `[`, but not at a full reference.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] b
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceNotFull(code) {
        return effects.attempt($058ebb3e19abf189$var$referenceCollapsedConstruct, labelEndOk, labelEndNok)(code);
    }
    /**
   * Done, we found something.
   *
   * ```markdown
   * > | [a](b) c
   *           ^
   * > | [a][b] c
   *           ^
   * > | [a][] b
   *          ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndOk(code) {
        // Note: `markdown-rs` does a bunch of stuff here.
        return ok(code);
    }
    /**
   * Done, it’s nothing.
   *
   * There was an okay opening, but we didn’t match anything.
   *
   * ```markdown
   * > | [a](b c
   *        ^
   * > | [a][b c
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndNok(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $058ebb3e19abf189$var$tokenizeResource(effects, ok, nok) {
    return resourceStart;
    /**
   * At a resource.
   *
   * ```markdown
   * > | [a](b) c
   *        ^
   * ```
   *
   * @type {State}
   */ function resourceStart(code) {
        effects.enter("resource");
        effects.enter("resourceMarker");
        effects.consume(code);
        effects.exit("resourceMarker");
        return resourceBefore;
    }
    /**
   * In resource, after `(`, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceBefore(code) {
        return (0, $5RE1E.markdownLineEndingOrSpace)(code) ? (0, $e5037cd98ae93105$export$1f27bd1aa33ce173)(effects, resourceOpen)(code) : resourceOpen(code);
    }
    /**
   * In resource, after optional whitespace, at `)` or a destination.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceOpen(code) {
        if (code === 41) return resourceEnd(code);
        return (0, $966f62c2a545a5b1$export$2e6c8deaa96af245)(effects, resourceDestinationAfter, resourceDestinationMissing, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(code);
    }
    /**
   * In resource, after destination, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationAfter(code) {
        return (0, $5RE1E.markdownLineEndingOrSpace)(code) ? (0, $e5037cd98ae93105$export$1f27bd1aa33ce173)(effects, resourceBetween)(code) : resourceEnd(code);
    }
    /**
   * At invalid destination.
   *
   * ```markdown
   * > | [a](<<) b
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationMissing(code) {
        return nok(code);
    }
    /**
   * In resource, after destination and whitespace, at `(` or title.
   *
   * ```markdown
   * > | [a](b ) c
   *           ^
   * ```
   *
   * @type {State}
   */ function resourceBetween(code) {
        if (code === 34 || code === 39 || code === 40) return (0, $5d634193ab20e30b$export$f970569cc855e483)(effects, resourceTitleAfter, nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code);
        return resourceEnd(code);
    }
    /**
   * In resource, after title, at optional whitespace.
   *
   * ```markdown
   * > | [a](b "c") d
   *              ^
   * ```
   *
   * @type {State}
   */ function resourceTitleAfter(code) {
        return (0, $5RE1E.markdownLineEndingOrSpace)(code) ? (0, $e5037cd98ae93105$export$1f27bd1aa33ce173)(effects, resourceEnd)(code) : resourceEnd(code);
    }
    /**
   * In resource, at `)`.
   *
   * ```markdown
   * > | [a](b) d
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceEnd(code) {
        if (code === 41) {
            effects.enter("resourceMarker");
            effects.consume(code);
            effects.exit("resourceMarker");
            effects.exit("resource");
            return ok;
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $058ebb3e19abf189$var$tokenizeReferenceFull(effects, ok, nok) {
    const self = this;
    return referenceFull;
    /**
   * In a reference (full), at the `[`.
   *
   * ```markdown
   * > | [a][b] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFull(code) {
        return (0, $7878baf14d32ac58$export$7b768614d8ba97a7).call(self, effects, referenceFullAfter, referenceFullMissing, "reference", "referenceMarker", "referenceString")(code);
    }
    /**
   * In a reference (full), after `]`.
   *
   * ```markdown
   * > | [a][b] d
   *          ^
   * ```
   *
   * @type {State}
   */ function referenceFullAfter(code) {
        return self.parser.defined.includes((0, $fEgdu.normalizeIdentifier)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) ? ok(code) : nok(code);
    }
    /**
   * In reference (full) that was missing.
   *
   * ```markdown
   * > | [a][b d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFullMissing(code) {
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $058ebb3e19abf189$var$tokenizeReferenceCollapsed(effects, ok, nok) {
    return referenceCollapsedStart;
    /**
   * In reference (collapsed), at `[`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceCollapsedStart(code) {
        // We only attempt a collapsed label if there’s a `[`.
        effects.enter("reference");
        effects.enter("referenceMarker");
        effects.consume(code);
        effects.exit("referenceMarker");
        return referenceCollapsedOpen;
    }
    /**
   * In reference (collapsed), at `]`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *         ^
   * ```
   *
   *  @type {State}
   */ function referenceCollapsedOpen(code) {
        if (code === 93) {
            effects.enter("referenceMarker");
            effects.consume(code);
            effects.exit("referenceMarker");
            effects.exit("reference");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $6990c8952104362a$export$3d754936e25aa5f5 = {
    name: 'labelStartImage',
    resolveAll: (0, $058ebb3e19abf189$export$470a5dafbbf62654).resolveAll,
    tokenize: $6990c8952104362a$var$tokenizeLabelStartImage
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $6990c8952104362a$var$tokenizeLabelStartImage(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (image) start.
   *
   * ```markdown
   * > | a ![b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelImage");
        effects.enter("labelImageMarker");
        effects.consume(code);
        effects.exit("labelImageMarker");
        return open;
    }
    /**
   * After `!`, at `[`.
   *
   * ```markdown
   * > | a ![b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 91) {
            effects.enter("labelMarker");
            effects.consume(code);
            effects.exit("labelMarker");
            effects.exit("labelImage");
            return after;
        }
        return nok(code);
    }
    /**
   * After `![`.
   *
   * ```markdown
   * > | a ![b] c
   *         ^
   * ```
   *
   * This is needed in because, when GFM footnotes are enabled, images never
   * form when started with a `^`.
   * Instead, links form:
   *
   * ```markdown
   * ![^a](b)
   *
   * ![^a][b]
   *
   * [b]: c
   * ```
   *
   * ```html
   * <p>!<a href=\"b\">^a</a></p>
   * <p>!<a href=\"c\">^a</a></p>
   * ```
   *
   * @type {State}
   */ function after(code) {
        // To do: use a new field to do this, this is still needed for
        // `micromark-extension-gfm-footnote`, but the `label-start-link`
        // behavior isn’t.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $a8bc0549ab93727d$export$5c0cee0701a3b584 = {
    name: 'labelStartLink',
    resolveAll: (0, $058ebb3e19abf189$export$470a5dafbbf62654).resolveAll,
    tokenize: $a8bc0549ab93727d$var$tokenizeLabelStartLink
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $a8bc0549ab93727d$var$tokenizeLabelStartLink(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (link) start.
   *
   * ```markdown
   * > | a [b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelLink");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelLink");
        return after;
    }
    /** @type {State} */ function after(code) {
        // To do: this isn’t needed in `micromark-extension-gfm-footnote`,
        // remove.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 



const $b48a43a40b939ab1$export$8e62e0ad51c97b2 = {
    name: 'lineEnding',
    tokenize: $b48a43a40b939ab1$var$tokenizeLineEnding
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $b48a43a40b939ab1$var$tokenizeLineEnding(effects, ok) {
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $5jhd5.factorySpace)(effects, ok, "linePrefix");
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Exiter,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 






/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 





const $919f488fa2543301$export$ba7b13e047416c03 = {
    name: 'thematicBreak',
    tokenize: $919f488fa2543301$var$tokenizeThematicBreak
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $919f488fa2543301$var$tokenizeThematicBreak(effects, ok, nok) {
    let size = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of thematic break.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("thematicBreak");
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * After optional whitespace, at marker.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        marker = code;
        return atBreak(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.enter("thematicBreakSequence");
            return sequence(code);
        }
        if (size >= 3 && (code === null || (0, $5RE1E.markdownLineEnding)(code))) {
            effects.exit("thematicBreak");
            return ok(code);
        }
        return nok(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit("thematicBreakSequence");
        return (0, $5RE1E.markdownSpace)(code) ? (0, $5jhd5.factorySpace)(effects, atBreak, "whitespace")(code) : atBreak(code);
    }
}


const $6741742aac8a0416$export$8837f4fc672e936d = {
    continuation: {
        tokenize: $6741742aac8a0416$var$tokenizeListContinuation
    },
    exit: $6741742aac8a0416$var$tokenizeListEnd,
    name: 'list',
    tokenize: $6741742aac8a0416$var$tokenizeListStart
};
/** @type {Construct} */ const $6741742aac8a0416$var$listItemPrefixWhitespaceConstruct = {
    partial: true,
    tokenize: $6741742aac8a0416$var$tokenizeListItemPrefixWhitespace
};
/** @type {Construct} */ const $6741742aac8a0416$var$indentConstruct = {
    partial: true,
    tokenize: $6741742aac8a0416$var$tokenizeIndent
};
// To do: `markdown-rs` parses list items on their own and later stitches them
// together.
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $6741742aac8a0416$var$tokenizeListStart(effects, ok, nok) {
    const self = this;
    const tail = self.events[self.events.length - 1];
    let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        const kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? "listUnordered" : "listOrdered");
        if (kind === "listUnordered" ? !self.containerState.marker || code === self.containerState.marker : (0, $5RE1E.asciiDigit)(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === "listUnordered") {
                effects.enter("listItemPrefix");
                return code === 42 || code === 45 ? effects.check((0, $919f488fa2543301$export$ba7b13e047416c03), nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter("listItemPrefix");
                effects.enter("listItemValue");
                return inside(code);
            }
        }
        return nok(code);
    }
    /** @type {State} */ function inside(code) {
        if ((0, $5RE1E.asciiDigit)(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit("listItemValue");
            return atMarker(code);
        }
        return nok(code);
    }
    /**
   * @type {State}
   **/ function atMarker(code) {
        effects.enter("listItemMarker");
        effects.consume(code);
        effects.exit("listItemMarker");
        self.containerState.marker = self.containerState.marker || code;
        return effects.check((0, $42a0773f37ffce85$export$d50d28ce3ab2a612), // Can’t be empty when interrupting.
        self.interrupt ? nok : onBlank, effects.attempt($6741742aac8a0416$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    /** @type {State} */ function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    /** @type {State} */ function otherPrefix(code) {
        if ((0, $5RE1E.markdownSpace)(code)) {
            effects.enter("listItemPrefixWhitespace");
            effects.consume(code);
            effects.exit("listItemPrefixWhitespace");
            return endOfPrefix;
        }
        return nok(code);
    }
    /** @type {State} */ function endOfPrefix(code) {
        self.containerState.size = initialSize + self.sliceSerialize(effects.exit("listItemPrefix"), true).length;
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $6741742aac8a0416$var$tokenizeListContinuation(effects, ok, nok) {
    const self = this;
    self.containerState._closeFlow = undefined;
    return effects.check((0, $42a0773f37ffce85$export$d50d28ce3ab2a612), onBlank, notBlank);
    /** @type {State} */ function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine;
        // We have a blank line.
        // Still, try to consume at most the items size.
        return (0, $5jhd5.factorySpace)(effects, ok, "listItemIndent", self.containerState.size + 1)(code);
    }
    /** @type {State} */ function notBlank(code) {
        if (self.containerState.furtherBlankLines || !(0, $5RE1E.markdownSpace)(code)) {
            self.containerState.furtherBlankLines = undefined;
            self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = undefined;
        self.containerState.initialBlankLine = undefined;
        return effects.attempt($6741742aac8a0416$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    /** @type {State} */ function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true;
        // As we’re closing flow, we’re no longer interrupting.
        self.interrupt = undefined;
        // Always populated by defaults.
        return (0, $5jhd5.factorySpace)(effects, effects.attempt($6741742aac8a0416$export$8837f4fc672e936d, ok, nok), "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $6741742aac8a0416$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $5jhd5.factorySpace)(effects, afterPrefix, "listItemIndent", self.containerState.size + 1);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self.containerState.size ? ok(code) : nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Exiter}
 */ function $6741742aac8a0416$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $6741742aac8a0416$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    const self = this;
    // Always populated by defaults.
    return (0, $5jhd5.factorySpace)(effects, afterPrefix, "listItemPrefixWhitespace", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 5);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return !(0, $5RE1E.markdownSpace)(code) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 





const $d9cde5cc64087865$export$e104e2de391dfde9 = {
    name: 'setextUnderline',
    resolveTo: $d9cde5cc64087865$var$resolveToSetextUnderline,
    tokenize: $d9cde5cc64087865$var$tokenizeSetextUnderline
};
/** @type {Resolver} */ function $d9cde5cc64087865$var$resolveToSetextUnderline(events, context) {
    // To do: resolve like `markdown-rs`.
    let index = events.length;
    /** @type {number | undefined} */ let content;
    /** @type {number | undefined} */ let text;
    /** @type {number | undefined} */ let definition;
    // Find the opening of the content.
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === 'enter') {
        if (events[index][1].type === "content") {
            content = index;
            break;
        }
        if (events[index][1].type === "paragraph") text = index;
    } else {
        if (events[index][1].type === "content") // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === "definition") definition = index;
    }
    const heading = {
        type: "setextHeading",
        start: {
            ...events[content][1].start
        },
        end: {
            ...events[events.length - 1][1].end
        }
    };
    // Change the paragraph to setext heading text.
    events[text][1].type = "setextHeadingText";
    // If we have definitions in the content, we’ll keep on having content,
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            'enter',
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            'exit',
            events[content][1],
            context
        ]);
        events[content][1].end = {
            ...events[definition][1].end
        };
    } else events[content][1] = heading;
    // Add the heading exit at the end.
    events.push([
        'exit',
        heading,
        context
    ]);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $d9cde5cc64087865$var$tokenizeSetextUnderline(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * At start of heading (setext) underline.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        let index = self.events.length;
        /** @type {boolean | undefined} */ let paragraph;
        // Find an opening.
        while(index--)// Skip enter/exit of line ending, line prefix, and content.
        // We can now either have a definition or a paragraph.
        if (self.events[index][1].type !== "lineEnding" && self.events[index][1].type !== "linePrefix" && self.events[index][1].type !== "content") {
            paragraph = self.events[index][1].type === "paragraph";
            break;
        }
        // To do: handle lazy/pierce like `markdown-rs`.
        // To do: parse indent like `markdown-rs`.
        if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
            effects.enter("setextHeadingLine");
            marker = code;
            return before(code);
        }
        return nok(code);
    }
    /**
   * After optional whitespace, at `-` or `=`.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("setextHeadingLineSequence");
        return inside(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        effects.exit("setextHeadingLineSequence");
        return (0, $5RE1E.markdownSpace)(code) ? (0, $5jhd5.factorySpace)(effects, after, "lineSuffix")(code) : after(code);
    }
    /**
   * After sequence, after optional whitespace.
   *
   * ```markdown
   *   | aa
   * > | ==
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if (code === null || (0, $5RE1E.markdownLineEnding)(code)) {
            effects.exit("setextHeadingLine");
            return ok(code);
        }
        return nok(code);
    }
}



const $49d3814fd2c2e4b7$export$5a7bfc01df82fcd1 = {
    [42]: (0, $6741742aac8a0416$export$8837f4fc672e936d),
    [43]: (0, $6741742aac8a0416$export$8837f4fc672e936d),
    [45]: (0, $6741742aac8a0416$export$8837f4fc672e936d),
    [48]: (0, $6741742aac8a0416$export$8837f4fc672e936d),
    [49]: (0, $6741742aac8a0416$export$8837f4fc672e936d),
    [50]: (0, $6741742aac8a0416$export$8837f4fc672e936d),
    [51]: (0, $6741742aac8a0416$export$8837f4fc672e936d),
    [52]: (0, $6741742aac8a0416$export$8837f4fc672e936d),
    [53]: (0, $6741742aac8a0416$export$8837f4fc672e936d),
    [54]: (0, $6741742aac8a0416$export$8837f4fc672e936d),
    [55]: (0, $6741742aac8a0416$export$8837f4fc672e936d),
    [56]: (0, $6741742aac8a0416$export$8837f4fc672e936d),
    [57]: (0, $6741742aac8a0416$export$8837f4fc672e936d),
    [62]: (0, $706e130898ca72ec$export$200dcd0a5903c968)
};
const $49d3814fd2c2e4b7$export$5a2181fb44b58173 = {
    [91]: (0, $9c47ccd1b660af72$export$69f215ed977cdb73)
};
const $49d3814fd2c2e4b7$export$cf8bead395eff824 = {
    [-2]: (0, $cbe4592c89a34a82$export$47910b7ab28d1853),
    [-1]: (0, $cbe4592c89a34a82$export$47910b7ab28d1853),
    [32]: (0, $cbe4592c89a34a82$export$47910b7ab28d1853)
};
const $49d3814fd2c2e4b7$export$ccc7b0636abaffc3 = {
    [35]: (0, $298a7502fec86174$export$3871e9deb360695c),
    [42]: (0, $919f488fa2543301$export$ba7b13e047416c03),
    [45]: [
        (0, $d9cde5cc64087865$export$e104e2de391dfde9),
        (0, $919f488fa2543301$export$ba7b13e047416c03)
    ],
    [60]: (0, $d70dc97524407fcb$export$476ac411cb7d0d8f),
    [61]: (0, $d9cde5cc64087865$export$e104e2de391dfde9),
    [95]: (0, $919f488fa2543301$export$ba7b13e047416c03),
    [96]: (0, $40659a24e23c2c4f$export$c23e4921f8d87e7c),
    [126]: (0, $40659a24e23c2c4f$export$c23e4921f8d87e7c)
};
const $49d3814fd2c2e4b7$export$22b082955e083ec3 = {
    [38]: (0, $3d956a8d9449dffc$export$e31905600aaf3d8e),
    [92]: (0, $2d7e6e19d7b01ca5$export$2005478564e78d96)
};
const $49d3814fd2c2e4b7$export$6f093cfa640b7166 = {
    [-5]: (0, $b48a43a40b939ab1$export$8e62e0ad51c97b2),
    [-4]: (0, $b48a43a40b939ab1$export$8e62e0ad51c97b2),
    [-3]: (0, $b48a43a40b939ab1$export$8e62e0ad51c97b2),
    [33]: (0, $6990c8952104362a$export$3d754936e25aa5f5),
    [38]: (0, $3d956a8d9449dffc$export$e31905600aaf3d8e),
    [42]: (0, $f198084f55320520$export$45b92471da762af7),
    [60]: [
        (0, $106ec5fc1899d736$export$17ddf85e4c916ad6),
        (0, $33ff20bf4faaf9fa$export$398af27f284914fe)
    ],
    [91]: (0, $a8bc0549ab93727d$export$5c0cee0701a3b584),
    [92]: [
        (0, $63c1b5bdb9ef13e1$export$86c573ab9e06f418),
        (0, $2d7e6e19d7b01ca5$export$2005478564e78d96)
    ],
    [93]: (0, $058ebb3e19abf189$export$470a5dafbbf62654),
    [95]: (0, $f198084f55320520$export$45b92471da762af7),
    [96]: (0, $5484c95cc3a34814$export$d24f93e715f9df88)
};
const $49d3814fd2c2e4b7$export$d44f260a3f9b69f5 = {
    null: [
        (0, $f198084f55320520$export$45b92471da762af7),
        (0, $4e44e4e38c8b8bd7$export$50397835cbfdbc24)
    ]
};
const $49d3814fd2c2e4b7$export$b9c0b60d74426aea = {
    null: [
        42,
        95
    ]
};
const $49d3814fd2c2e4b7$export$e20fbacbb41798b = {
    null: []
};
$49d3814fd2c2e4b7$exports["document"] = $49d3814fd2c2e4b7$export$5a7bfc01df82fcd1;
$49d3814fd2c2e4b7$exports["contentInitial"] = $49d3814fd2c2e4b7$export$5a2181fb44b58173;
$49d3814fd2c2e4b7$exports["flowInitial"] = $49d3814fd2c2e4b7$export$cf8bead395eff824;
$49d3814fd2c2e4b7$exports["flow"] = $49d3814fd2c2e4b7$export$ccc7b0636abaffc3;
$49d3814fd2c2e4b7$exports["string"] = $49d3814fd2c2e4b7$export$22b082955e083ec3;
$49d3814fd2c2e4b7$exports["text"] = $49d3814fd2c2e4b7$export$6f093cfa640b7166;
$49d3814fd2c2e4b7$exports["insideSpan"] = $49d3814fd2c2e4b7$export$d44f260a3f9b69f5;
$49d3814fd2c2e4b7$exports["attentionMarkers"] = $49d3814fd2c2e4b7$export$b9c0b60d74426aea;
$49d3814fd2c2e4b7$exports["disable"] = $49d3814fd2c2e4b7$export$e20fbacbb41798b;


/**
 * @import {
 *   Chunk,
 *   Code,
 *   ConstructRecord,
 *   Construct,
 *   Effects,
 *   InitialConstruct,
 *   ParseContext,
 *   Point,
 *   State,
 *   TokenizeContext,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @callback Restore
 *   Restore the state.
 * @returns {undefined}
 *   Nothing.
 *
 * @typedef Info
 *   Info.
 * @property {Restore} restore
 *   Restore.
 * @property {number} from
 *   From.
 *
 * @callback ReturnHandle
 *   Handle a successful run.
 * @param {Construct} construct
 *   Construct.
 * @param {Info} info
 *   Info.
 * @returns {undefined}
 *   Nothing.
 */ 








function $5446067fa3a57649$export$ae34f10ee4b29837(parser, initialize, from) {
    /** @type {Point} */ let point = {
        _bufferIndex: -1,
        _index: 0,
        line: from && from.line || 1,
        column: from && from.column || 1,
        offset: from && from.offset || 0
    };
    /** @type {Record<string, number>} */ const columnStart = {};
    /** @type {Array<Construct>} */ const resolveAllConstructs = [];
    /** @type {Array<Chunk>} */ let chunks = [];
    /** @type {Array<Token>} */ let stack = [];
    /** @type {boolean | undefined} */ let consumed = true;
    /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */ const effects = {
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        consume: consume,
        enter: enter,
        exit: exit,
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        })
    };
    /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */ const context = {
        code: null,
        containerState: {},
        defineSkip: defineSkip,
        events: [],
        now: now,
        parser: parser,
        previous: null,
        sliceSerialize: sliceSerialize,
        sliceStream: sliceStream,
        write: write
    };
    /**
   * The state function.
   *
   * @type {State | undefined}
   */ let state = initialize.tokenize.call(context, effects);
    /**
   * Track which character we expect to be consumed, to catch bugs.
   *
   * @type {Code}
   */ let expectedCode;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
    return context;
    /** @type {TokenizeContext['write']} */ function write(slice) {
        chunks = (0, $bHIRo.push)(chunks, slice);
        main();
        // Exit if we’re not done, resolve might change stuff.
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0);
        // Otherwise, resolve, and exit.
        context.events = (0, $9CjcD.resolveAll)(resolveAllConstructs, context.events, context);
        return context.events;
    }
    //
    // Tools.
    //
    /** @type {TokenizeContext['sliceSerialize']} */ function sliceSerialize(token, expandTabs) {
        return $5446067fa3a57649$var$serializeChunks(sliceStream(token), expandTabs);
    }
    /** @type {TokenizeContext['sliceStream']} */ function sliceStream(token) {
        return $5446067fa3a57649$var$sliceChunks(chunks, token);
    }
    /** @type {TokenizeContext['now']} */ function now() {
        // This is a hot path, so we clone manually instead of `Object.assign({}, point)`
        const { _bufferIndex: _bufferIndex, _index: _index, line: line, column: column, offset: offset } = point;
        return {
            _bufferIndex: _bufferIndex,
            _index: _index,
            line: line,
            column: column,
            offset: offset
        };
    }
    /** @type {TokenizeContext['defineSkip']} */ function defineSkip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    }
    //
    // State management.
    //
    /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {undefined}
   *   Nothing.
   */ function main() {
        /** @type {number} */ let chunkIndex;
        while(point._index < chunks.length){
            const chunk = chunks[point._index];
            // If we’re in a buffer chunk, loop through it.
            if (typeof chunk === 'string') {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    }
    /**
   * Deal with one code.
   *
   * @param {Code} code
   *   Code.
   * @returns {undefined}
   *   Nothing.
   */ function go(code) {
        consumed = undefined;
        expectedCode = code;
        state = state(code);
    }
    /** @type {Effects['consume']} */ function consume(code) {
        if ((0, $5RE1E.markdownLineEnding)(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        }
        // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++;
            // At end of string chunk.
            if (point._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
            // strings.
            /** @type {string} */ chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        }
        // Expose the previous character.
        context.previous = code;
        // Mark as consumed.
        consumed = true;
    }
    /** @type {Effects['enter']} */ function enter(type, fields) {
        /** @type {Token} */ // @ts-expect-error Patch instead of assign required fields to help GC.
        const token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            'enter',
            token,
            context
        ]);
        stack.push(token);
        return token;
    }
    /** @type {Effects['exit']} */ function exit(type) {
        const token = stack.pop();
        token.end = now();
        context.events.push([
            'exit',
            token,
            context
        ]);
        return token;
    }
    /**
   * Use results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    }
    /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulcheck(_, info) {
        info.restore();
    }
    /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   *   Callback.
   * @param {{interrupt?: boolean | undefined} | undefined} [fields]
   *   Fields.
   */ function constructFactory(onreturn, fields) {
        return hook;
        /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Array<Construct> | ConstructRecord | Construct} constructs
     *   Constructs.
     * @param {State} returnState
     *   State.
     * @param {State | undefined} [bogusState]
     *   State.
     * @returns {State}
     *   State.
     */ function hook(constructs, returnState, bogusState) {
            /** @type {ReadonlyArray<Construct>} */ let listOfConstructs;
            /** @type {number} */ let constructIndex;
            /** @type {Construct} */ let currentConstruct;
            /** @type {Info} */ let info;
            return Array.isArray(constructs) ? /* c8 ignore next 1 */ handleListOfConstructs(constructs) : 'tokenize' in constructs ? // Looks like a construct.
            handleListOfConstructs([
                /** @type {Construct} */ constructs
            ]) : handleMapOfConstructs(constructs);
            /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       *   Constructs.
       * @returns {State}
       *   State.
       */ function handleMapOfConstructs(map) {
                return start;
                /** @type {State} */ function start(code) {
                    const left = code !== null && map[code];
                    const all = code !== null && map.null;
                    const list = [
                        // To do: add more extension tests.
                        /* c8 ignore next 2 */ ...Array.isArray(left) ? left : left ? [
                            left
                        ] : [],
                        ...Array.isArray(all) ? all : all ? [
                            all
                        ] : []
                    ];
                    return handleListOfConstructs(list)(code);
                }
            }
            /**
       * Handle a list of construct.
       *
       * @param {ReadonlyArray<Construct>} list
       *   Constructs.
       * @returns {State}
       *   State.
       */ function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                if (list.length === 0) return bogusState;
                return handleConstruct(list[constructIndex]);
            }
            /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       *   Construct.
       * @returns {State}
       *   State.
       */ function handleConstruct(construct) {
                return start;
                /** @type {State} */ function start(code) {
                    // To do: not needed to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    // Always populated by defaults.
                    if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) return nok(code);
                    return construct.tokenize.call(// If we do have fields, create an object w/ `context` as its
                    // prototype.
                    // This allows a “live binding”, which is needed for `interrupt`.
                    fields ? Object.assign(Object.create(context), fields) : context, effects, ok, nok)(code);
                }
            }
            /** @type {State} */ function ok(code) {
                consumed = true;
                onreturn(currentConstruct, info);
                return returnState;
            }
            /** @type {State} */ function nok(code) {
                consumed = true;
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    /**
   * @param {Construct} construct
   *   Construct.
   * @param {number} from
   *   From.
   * @returns {undefined}
   *   Nothing.
   */ function addResult(construct, from) {
        if (construct.resolveAll && !resolveAllConstructs.includes(construct)) resolveAllConstructs.push(construct);
        if (construct.resolve) (0, $bHIRo.splice)(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    /**
   * Store state.
   *
   * @returns {Info}
   *   Info.
   */ function store() {
        const startPoint = now();
        const startPrevious = context.previous;
        const startCurrentConstruct = context.currentConstruct;
        const startEventsIndex = context.events.length;
        const startStack = Array.from(stack);
        return {
            from: startEventsIndex,
            restore: restore
        };
        /**
     * Restore state.
     *
     * @returns {undefined}
     *   Nothing.
     */ function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {undefined}
   *   Nothing.
   */ function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {ReadonlyArray<Chunk>} chunks
 *   Chunks.
 * @param {Pick<Token, 'end' | 'start'>} token
 *   Token.
 * @returns {Array<Chunk>}
 *   Chunks.
 */ function $5446067fa3a57649$var$sliceChunks(chunks, token) {
    const startIndex = token.start._index;
    const startBufferIndex = token.start._bufferIndex;
    const endIndex = token.end._index;
    const endBufferIndex = token.end._bufferIndex;
    /** @type {Array<Chunk>} */ let view;
    if (startIndex === endIndex) // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) {
            const head = view[0];
            if (typeof head === 'string') view[0] = head.slice(startBufferIndex);
            else view.shift();
        }
        if (endBufferIndex > 0) // @ts-expect-error `_bufferIndex` is used on string chunks.
        view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
/**
 * Get the string value of a slice of chunks.
 *
 * @param {ReadonlyArray<Chunk>} chunks
 *   Chunks.
 * @param {boolean | undefined} [expandTabs=false]
 *   Whether to expand tabs (default: `false`).
 * @returns {string}
 *   Result.
 */ function $5446067fa3a57649$var$serializeChunks(chunks, expandTabs) {
    let index = -1;
    /** @type {Array<string>} */ const result = [];
    /** @type {boolean | undefined} */ let atTab;
    while(++index < chunks.length){
        const chunk = chunks[index];
        /** @type {string} */ let value;
        if (typeof chunk === 'string') value = chunk;
        else switch(chunk){
            case -5:
                value = "\r";
                break;
            case -4:
                value = "\n";
                break;
            case -3:
                value = "\r\n";
                break;
            case -2:
                value = expandTabs ? " " : "\t";
                break;
            case -1:
                if (!expandTabs && atTab) continue;
                value = " ";
                break;
            default:
                // Currently only replacement character.
                value = String.fromCharCode(chunk);
        }
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join('');
}


function $6b285b2ddbc6fcfe$export$98e6a39c04603d36(options) {
    const settings = options || {};
    const constructs = /** @type {FullNormalizedExtension} */ (0, $gaqbL.combineExtensions)([
        $49d3814fd2c2e4b7$exports,
        ...settings.extensions || []
    ]);
    /** @type {ParseContext} */ const parser = {
        constructs: constructs,
        content: create((0, $29cc61f02ac384bd$export$a7db06668cad9adb)),
        defined: [],
        document: create((0, $2f209e3256e5dc28$export$5a7bfc01df82fcd1)),
        flow: create((0, $86d64d7787f1e7dc$export$ccc7b0636abaffc3)),
        lazy: {},
        string: create((0, $4e44e4e38c8b8bd7$export$22b082955e083ec3)),
        text: create((0, $4e44e4e38c8b8bd7$export$6f093cfa640b7166))
    };
    return parser;
    /**
   * @param {InitialConstruct} initial
   *   Construct to start with.
   * @returns {Create}
   *   Create a tokenizer.
   */ function create(initial) {
        return creator;
        /** @type {Create} */ function creator(from) {
            return (0, $5446067fa3a57649$export$ae34f10ee4b29837)(parser, initial, from);
        }
    }
}
module.exports["parse"] = $6b285b2ddbc6fcfe$export$98e6a39c04603d36;

});

parcelRegister("812u3", function(module, exports) {
/**
 * @import {Event} from 'micromark-util-types'
 */ 
var $lQubg = parcelRequire("lQubg");

function $5d6057f1b1a70d8a$export$bd0e6e1378a871d7(events) {
    while(!(0, $lQubg.subtokenize)(events));
    return events;
}
module.exports["postprocess"] = $5d6057f1b1a70d8a$export$bd0e6e1378a871d7;

});

parcelRegister("3K32B", function(module, exports) {
/**
 * @import {Chunk, Code, Encoding, Value} from 'micromark-util-types'
 */ /**
 * @callback Preprocessor
 *   Preprocess a value.
 * @param {Value} value
 *   Value.
 * @param {Encoding | null | undefined} [encoding]
 *   Encoding when `value` is a typed array (optional).
 * @param {boolean | null | undefined} [end=false]
 *   Whether this is the last chunk (default: `false`).
 * @returns {Array<Chunk>}
 *   Chunks.
 */ const $2b9806de623ea5d6$var$search = /[\0\t\n\r]/g;
function $2b9806de623ea5d6$export$fc37fe19dfda43ee() {
    let column = 1;
    let buffer = '';
    /** @type {boolean | undefined} */ let start = true;
    /** @type {boolean | undefined} */ let atCarriageReturn;
    return preprocessor;
    /** @type {Preprocessor} */ // eslint-disable-next-line complexity
    function preprocessor(value, encoding, end) {
        /** @type {Array<Chunk>} */ const chunks = [];
        /** @type {RegExpMatchArray | null} */ let match;
        /** @type {number} */ let next;
        /** @type {number} */ let startPosition;
        /** @type {number} */ let endPosition;
        /** @type {Code} */ let code;
        value = buffer + (typeof value === 'string' ? value.toString() : new TextDecoder(encoding || undefined).decode(value));
        startPosition = 0;
        buffer = '';
        if (start) {
            // To do: `markdown-rs` actually parses BOMs (byte order mark).
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $2b9806de623ea5d6$var$search.lastIndex = startPosition;
            match = $2b9806de623ea5d6$var$search.exec(value);
            endPosition = match && match.index !== undefined ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                switch(code){
                    case 0:
                        chunks.push(65533);
                        column++;
                        break;
                    case 9:
                        next = Math.ceil(column / 4) * 4;
                        chunks.push(-2);
                        while(column++ < next)chunks.push(-1);
                        break;
                    case 10:
                        chunks.push(-4);
                        column = 1;
                        break;
                    default:
                        atCarriageReturn = true;
                        column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}
module.exports["preprocess"] = $2b9806de623ea5d6$export$fc37fe19dfda43ee;

});

parcelRegister("dPbz3", function(module, exports) {
/**
 * @import {Node as UnistNode, Parent as UnistParent} from 'unist'
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ /**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends ReadonlyArray<infer T>
 *   ? MatchesOne<Value, T>
 *   : Check extends Array<infer T>
 *   ? MatchesOne<Value, T>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {InternalAncestor<InclusiveDescendant<Tree>, Child>} Ancestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {'skip' | boolean} Action
 *   Union of the action types.
 *
 * @typedef {number} Index
 *   Move to the sibling at `index` next (after node itself is completely
 *   traversed).
 *
 *   Useful if mutating the tree, such as removing the node the visitor is
 *   currently on, or any of its previous siblings.
 *   Results less than 0 or greater than or equal to `children.length` stop
 *   traversing the parent.
 *
 * @typedef {[(Action | null | undefined | void)?, (Index | null | undefined)?]} ActionTuple
 *   List with one or two values, the first an action, the second an index.
 *
 * @typedef {Action | ActionTuple | Index | null | undefined | void} VisitorResult
 *   Any value that can be returned from a visitor.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform the parent of node (the last of `ancestors`).
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of an ancestor still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Array<VisitedParents>} ancestors
 *   Ancestors of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [VisitedParents=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Matches<InclusiveDescendant<Tree>, Check>, Ancestor<Tree, Matches<InclusiveDescendant<Tree>, Check>>>} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parents`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Tree type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ 
var $723Ml = parcelRequire("723Ml");

/**
 * @param {string} d
 * @returns {string}
 */ function $dac4c3ba73a4e79a$export$35e9368ef982300f(d) {
    return d;
}


/** @type {Readonly<ActionTuple>} */ const $a109023e9e51ca86$var$empty = [];
const $a109023e9e51ca86$export$f4d8133c446fe484 = true;
const $a109023e9e51ca86$export$7f100f842f565dc9 = false;
const $a109023e9e51ca86$export$8773f85c2fb2c116 = 'skip';
function $a109023e9e51ca86$export$70008a21eb6de899(tree, test, visitor, reverse) {
    /** @type {Test} */ let check;
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test;
    } else // @ts-expect-error visitor given, so `test` isn’t a visitor.
    check = test;
    const is = (0, $723Ml.convert)(check);
    const step = reverse ? -1 : 1;
    factory(tree, undefined, [])();
    /**
   * @param {UnistNode} node
   * @param {number | undefined} index
   * @param {Array<UnistParent>} parents
   */ function factory(node, index, parents) {
        const value = /** @type {Record<string, unknown>} */ node && typeof node === 'object' ? node : {};
        if (typeof value.type === 'string') {
            const name = // `hast`
            typeof value.tagName === 'string' ? value.tagName : typeof value.name === 'string' ? value.name : undefined;
            Object.defineProperty(visit, 'name', {
                value: 'node (' + (0, $dac4c3ba73a4e79a$export$35e9368ef982300f)(node.type + (name ? '<' + name + '>' : '')) + ')'
            });
        }
        return visit;
        function visit() {
            /** @type {Readonly<ActionTuple>} */ let result = $a109023e9e51ca86$var$empty;
            /** @type {Readonly<ActionTuple>} */ let subresult;
            /** @type {number} */ let offset;
            /** @type {Array<UnistParent>} */ let grandparents;
            if (!test || is(node, index, parents[parents.length - 1] || undefined)) {
                // @ts-expect-error: `visitor` is now a visitor.
                result = $a109023e9e51ca86$var$toResult(visitor(node, parents));
                if (result[0] === $a109023e9e51ca86$export$7f100f842f565dc9) return result;
            }
            if ('children' in node && node.children) {
                const nodeAsParent = /** @type {UnistParent} */ node;
                if (nodeAsParent.children && result[0] !== $a109023e9e51ca86$export$8773f85c2fb2c116) {
                    offset = (reverse ? nodeAsParent.children.length : -1) + step;
                    grandparents = parents.concat(nodeAsParent);
                    while(offset > -1 && offset < nodeAsParent.children.length){
                        const child = nodeAsParent.children[offset];
                        subresult = factory(child, offset, grandparents)();
                        if (subresult[0] === $a109023e9e51ca86$export$7f100f842f565dc9) return subresult;
                        offset = typeof subresult[1] === 'number' ? subresult[1] : offset + step;
                    }
                }
            }
            return result;
        }
    }
}
/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {Readonly<ActionTuple>}
 *   Clean result.
 */ function $a109023e9e51ca86$var$toResult(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === 'number') return [
        $a109023e9e51ca86$export$f4d8133c446fe484,
        value
    ];
    return value === null || value === undefined ? $a109023e9e51ca86$var$empty : [
        value
    ];
}
module.exports["EXIT"] = $a109023e9e51ca86$export$7f100f842f565dc9;
module.exports["visitParents"] = $a109023e9e51ca86$export$70008a21eb6de899;

});

parcelRegister("28Zil", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calcSlices = module.exports.applyPatch = module.exports.calcPatch = module.exports.lcs = module.exports.diff = module.exports.diff_core = void 0;
function $18fbe0039b7b1c20$var$diff_internal(state, c) {
    const { b: b, eq: eq, stack_base: stack_base } = state;
    let { i: i, N: N, j: j, M: M, Z: Z, stack_top: stack_top } = state;
    for(;;)switch(c){
        case 0:
            Z_block: while(N > 0 && M > 0){
                b.fill(0, 0, 2 * Z);
                const W = N - M;
                const L = N + M;
                const parity = L & 1;
                const offsetx = i + N - 1;
                const offsety = j + M - 1;
                const hmax = (L + parity) / 2;
                let z;
                h_loop: for(let h = 0; h <= hmax; h++){
                    const kmin = 2 * Math.max(0, h - M) - h;
                    const kmax = h - 2 * Math.max(0, h - N);
                    for(let k = kmin; k <= kmax; k += 2){
                        const gkm = b[k - 1 - Z * Math.floor((k - 1) / Z)];
                        const gkp = b[k + 1 - Z * Math.floor((k + 1) / Z)];
                        const u = k === -h || k !== h && gkm < gkp ? gkp : gkm + 1;
                        const v = u - k;
                        let x = u;
                        let y = v;
                        while(x < N && y < M && eq(i + x, j + y))x++, y++;
                        b[k - Z * Math.floor(k / Z)] = x;
                        if (parity === 1 && (z = W - k) >= 1 - h && z < h && x + b[Z + z - Z * Math.floor(z / Z)] >= N) {
                            if (h > 1 || x !== u) {
                                stack_base[stack_top++] = i + x;
                                stack_base[stack_top++] = N - x;
                                stack_base[stack_top++] = j + y;
                                stack_base[stack_top++] = M - y;
                                N = u;
                                M = v;
                                Z = 2 * (Math.min(N, M) + 1);
                                continue Z_block;
                            } else break h_loop;
                        }
                    }
                    for(let k = kmin; k <= kmax; k += 2){
                        const pkm = b[Z + k - 1 - Z * Math.floor((k - 1) / Z)];
                        const pkp = b[Z + k + 1 - Z * Math.floor((k + 1) / Z)];
                        const u = k === -h || k !== h && pkm < pkp ? pkp : pkm + 1;
                        const v = u - k;
                        let x = u;
                        let y = v;
                        while(x < N && y < M && eq(offsetx - x, offsety - y))x++, y++;
                        b[Z + k - Z * Math.floor(k / Z)] = x;
                        if (parity === 0 && (z = W - k) >= -h && z <= h && x + b[z - Z * Math.floor(z / Z)] >= N) {
                            if (h > 0 || x !== u) {
                                stack_base[stack_top++] = i + N - u;
                                stack_base[stack_top++] = u;
                                stack_base[stack_top++] = j + M - v;
                                stack_base[stack_top++] = v;
                                N = N - x;
                                M = M - y;
                                Z = 2 * (Math.min(N, M) + 1);
                                continue Z_block;
                            } else break h_loop;
                        }
                    }
                }
                if (N === M) continue;
                if (M > N) {
                    i += N;
                    j += N;
                    M -= N;
                    N = 0;
                } else {
                    i += M;
                    j += M;
                    N -= M;
                    M = 0;
                }
                break;
            }
            if (N + M !== 0) {
                if (state.pxe === i || state.pye === j) {
                    state.pxe = i + N;
                    state.pye = j + M;
                } else {
                    const sx = state.pxs;
                    state.oxs = state.pxs;
                    state.oxe = state.pxe;
                    state.oys = state.pys;
                    state.oye = state.pye;
                    state.pxs = i;
                    state.pxe = i + N;
                    state.pys = j;
                    state.pye = j + M;
                    if (sx >= 0) {
                        state.i = i;
                        state.N = N;
                        state.j = j;
                        state.M = M;
                        state.Z = Z;
                        state.stack_top = stack_top;
                        return 1;
                    }
                }
            }
        case 1:
            if (stack_top === 0) return 2;
            M = stack_base[--stack_top];
            j = stack_base[--stack_top];
            N = stack_base[--stack_top];
            i = stack_base[--stack_top];
            Z = 2 * (Math.min(N, M) + 1);
            c = 0;
    }
}
class $18fbe0039b7b1c20$var$DiffGen {
    [Symbol.iterator]() {
        return this;
    }
    next() {
        const { state: state, result: result } = this;
        if (this.c > 1) {
            result.done = true;
            result.value = undefined;
            return result;
        }
        const c = $18fbe0039b7b1c20$var$diff_internal(state, this.c);
        this.c = c;
        if (c === 1) {
            result.value = [
                state.oxs,
                state.oxe,
                state.oys,
                state.oye
            ];
            return result;
        }
        if (state.pxs >= 0) {
            result.value = [
                state.pxs,
                state.pxe,
                state.pys,
                state.pye
            ];
            return result;
        }
        result.done = true;
        result.value = undefined;
        return result;
    }
    constructor(state){
        this.state = state;
        this.c = 0;
        this.result = {
            value: null,
            done: false
        };
    }
}
function $18fbe0039b7b1c20$var$diff_core(i, N, j, M, eq) {
    const Z = (Math.min(N, M) + 1) * 2;
    const L = N + M;
    const b = new (L < 256 ? Uint8Array : L < 65536 ? Uint16Array : Uint32Array)(2 * Z);
    return new $18fbe0039b7b1c20$var$DiffGen({
        i: i,
        N: N,
        j: j,
        M: M,
        Z: Z,
        b: b,
        eq: eq,
        pxs: -1,
        pxe: -1,
        pys: -1,
        pye: -1,
        oxs: -1,
        oxe: -1,
        oys: -1,
        oye: -1,
        stack_top: 0,
        stack_base: []
    });
}
module.exports.diff_core = $18fbe0039b7b1c20$var$diff_core;
function $18fbe0039b7b1c20$var$diff(xs, ys, eq) {
    let [i, N, M] = [
        0,
        xs.length,
        ys.length
    ];
    if (typeof eq === 'function') {
        while(i < N && i < M && eq(i, i))i++;
        if (i === N && i === M) return [][Symbol.iterator]();
        while(eq(--N, --M) && N > i && M > i);
    } else {
        while(i < N && i < M && xs[i] === ys[i])i++;
        if (i === N && i === M) return [][Symbol.iterator]();
        while(xs[--N] === ys[--M] && N > i && M > i);
        eq = (i, j)=>xs[i] === ys[j];
    }
    return $18fbe0039b7b1c20$var$diff_core(i, N + 1 - i, i, M + 1 - i, eq);
}
module.exports.diff = $18fbe0039b7b1c20$var$diff;
class $18fbe0039b7b1c20$var$LCSGen {
    [Symbol.iterator]() {
        return this;
    }
    next() {
        const rec = this.diff.next();
        if (rec.done) {
            const { i: i, j: j, N: N } = this;
            if (i < N) {
                rec.done = false;
                rec.value = [
                    i,
                    j,
                    N - i
                ];
                this.i = N;
            }
            return rec;
        }
        const v = rec.value;
        const sx = v[0];
        const ex = v[1];
        const ey = v[3];
        const { i: i, j: j } = this;
        if (i !== sx) {
            v.length--;
            v[0] = i;
            v[1] = j;
            v[2] = sx - i;
        }
        this.i = ex;
        this.j = ey;
        return rec;
    }
    constructor(diff, N){
        this.diff = diff;
        this.N = N;
        this.i = 0;
        this.j = 0;
    }
}
function $18fbe0039b7b1c20$var$lcs(xs, ys, eq) {
    return new $18fbe0039b7b1c20$var$LCSGen($18fbe0039b7b1c20$var$diff(xs, ys, eq), xs.length);
}
module.exports.lcs = $18fbe0039b7b1c20$var$lcs;
function* $18fbe0039b7b1c20$var$calcPatch(xs, ys, eq) {
    const slice = ArrayBuffer.isView(xs) ? Uint8Array.prototype.subarray : xs.slice;
    for (const v of $18fbe0039b7b1c20$var$diff(xs, ys, eq)){
        v[2] = slice.call(ys, v[2], v[3]);
        yield v;
    }
}
module.exports.calcPatch = $18fbe0039b7b1c20$var$calcPatch;
function* $18fbe0039b7b1c20$var$applyPatch(xs, patch) {
    let i = 0;
    const slice = ArrayBuffer.isView(xs) ? Uint8Array.prototype.subarray : xs.slice;
    for (const [dels, dele, ins] of patch){
        if (i < dels) yield slice.call(xs, i, dels);
        if (ins.length > 0) yield ins;
        i = dele;
    }
    if (i < xs.length) yield slice.call(xs, i);
}
module.exports.applyPatch = $18fbe0039b7b1c20$var$applyPatch;
function* $18fbe0039b7b1c20$var$calcSlices(xs, ys, eq) {
    let i = 0;
    const slice = ArrayBuffer.isView(xs) ? Uint8Array.prototype.subarray : xs.slice;
    for (const [dels, dele, inss, inse] of $18fbe0039b7b1c20$var$diff(xs, ys, eq)){
        if (i < dels) yield [
            0,
            slice.call(xs, i, dels)
        ];
        if (dels < dele) yield [
            -1,
            slice.call(xs, dels, dele)
        ];
        if (inss < inse) yield [
            1,
            slice.call(ys, inss, inse)
        ];
        i = dele;
    }
    if (i < xs.length) yield [
        0,
        xs.slice(i)
    ];
}
module.exports.calcSlices = $18fbe0039b7b1c20$var$calcSlices;

});

parcelRegister("4R6R9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ed1d6b5a60ed31105ef48bd3e2c936d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $38916e32063841ec$var$_react = $38916e32063841ec$var$_interopRequireDefault((parcelRequire("cozmU")));

var $38916e32063841ec$var$_iconNew = $38916e32063841ec$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $38916e32063841ec$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ViewSplit".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/view-split
 * Usage guidance:
 * Reserved for representing a 2 column split view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $38916e32063841ec$var$ViewSplitIcon = (props)=>/*#__PURE__*/ $38916e32063841ec$var$_react.default.createElement($38916e32063841ec$var$_iconNew.default, Object.assign({
        name: "ViewSplitIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 3a.5.5 0 0 0-.5-.5H8.75v11H14a.5.5 0 0 0 .5-.5zm-13 10a.5.5 0 0 0 .5.5h5.25v-11H2a.5.5 0 0 0-.5.5zM16 13a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z"/>`
    }, props));
$38916e32063841ec$var$ViewSplitIcon.displayName = 'ViewSplitIcon';
var $38916e32063841ec$var$_default = module.exports.default = $38916e32063841ec$var$ViewSplitIcon;

});

parcelRegister("bHIRo", function(module, exports) {
/**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {number} start
 *   Index to remove/insert at (can be negative).
 * @param {number} remove
 *   Number of items to remove.
 * @param {Array<T>} items
 *   Items to inject into `list`.
 * @returns {undefined}
 *   Nothing.
 */ function $885682259e869272$export$869882364835d202(list, start, remove, items) {
    const end = list.length;
    let chunkStart = 0;
    /** @type {Array<unknown>} */ let parameters;
    // Make start between zero and `end` (included).
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0;
    // No need to chunk the items if there’s only a couple (10k) items.
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        // @ts-expect-error Hush, it’s fine.
        list.splice(...parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) list.splice(start, remove);
        // Insert the items in chunks to not cause stack overflows.
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            // @ts-expect-error Hush, it’s fine.
            list.splice(...parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
function $885682259e869272$export$4cbf152802aa238(list, items) {
    if (list.length > 0) {
        $885682259e869272$export$869882364835d202(list, list.length, 0, items);
        return list;
    }
    return items;
}
module.exports["splice"] = $885682259e869272$export$869882364835d202;
module.exports["push"] = $885682259e869272$export$4cbf152802aa238;

});

parcelRegister("eEM9l", function(module, exports) {
/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * Sort of like `String.fromCodePoint(Number.parseInt(value, base))`, but makes
 * non-characters and control characters safe.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 *   Character.
 */ function $aaba26a51580bca6$export$15a69557afac2c20(value, base) {
    const code = Number.parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space.
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of C0, and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || /* eslint-disable no-bitwise */ (code & 65535) === 65535 || (code & 65535) === 65534 || /* eslint-enable no-bitwise */ // Out of range
    code > 1114111) return "\uFFFD";
    return String.fromCodePoint(code);
}
module.exports["decodeNumericCharacterReference"] = $aaba26a51580bca6$export$15a69557afac2c20;

});

parcelRegister("fEgdu", function(module, exports) {
/**
 * Normalize an identifier (as found in references, definitions).
 *
 * Collapses markdown whitespace, trim, and then lower- and uppercase.
 *
 * Some characters are considered “uppercase”, such as U+03F4 (`ϴ`), but if their
 * lowercase counterpart (U+03B8 (`θ`)) is uppercased will result in a different
 * uppercase character (U+0398 (`Θ`)).
 * So, to get a canonical form, we perform both lower- and uppercase.
 *
 * Using uppercase last makes sure keys will never interact with default
 * prototypal values (such as `constructor`): nothing in the prototype of
 * `Object` is uppercase.
 *
 * @param {string} value
 *   Identifier to normalize.
 * @returns {string}
 *   Normalized identifier.
 */ function $b6472bb4acffb16c$export$806d55e226cfcd08(value) {
    return value// Collapse markdown whitespace.
    .replace(/[\t\n\r ]+/g, " ")// Trim.
    .replace(/^ | $/g, '')// Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no method is uppercase.
    .toLowerCase().toUpperCase();
}
module.exports["normalizeIdentifier"] = $b6472bb4acffb16c$export$806d55e226cfcd08;

});

parcelRegister("5RE1E", function(module, exports) {
/**
 * @import {Code} from 'micromark-util-types'
 */ /**
 * Check whether the character code represents an ASCII alpha (`a` through `z`,
 * case insensitive).
 *
 * An **ASCII alpha** is an ASCII upper alpha or ASCII lower alpha.
 *
 * An **ASCII upper alpha** is a character in the inclusive range U+0041 (`A`)
 * to U+005A (`Z`).
 *
 * An **ASCII lower alpha** is a character in the inclusive range U+0061 (`a`)
 * to U+007A (`z`).
 *
 * @param code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */ const $4450f34142f5dbc2$export$d65d6b62c24d5436 = $4450f34142f5dbc2$var$regexCheck(/[A-Za-z]/);
const $4450f34142f5dbc2$export$75c76db11865a9f4 = $4450f34142f5dbc2$var$regexCheck(/[\dA-Za-z]/);
const $4450f34142f5dbc2$export$4397998b34fe597d = $4450f34142f5dbc2$var$regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function $4450f34142f5dbc2$export$67dbf494fc8394df(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127));
}
const $4450f34142f5dbc2$export$ca8b5b1a6c320e6e = $4450f34142f5dbc2$var$regexCheck(/\d/);
const $4450f34142f5dbc2$export$eca2752363989806 = $4450f34142f5dbc2$var$regexCheck(/[\dA-Fa-f]/);
const $4450f34142f5dbc2$export$35794a7d1db99380 = $4450f34142f5dbc2$var$regexCheck(/[!-/:-@[-`{-~]/);
function $4450f34142f5dbc2$export$34a1dff1c0936953(code) {
    return code !== null && code < -2;
}
function $4450f34142f5dbc2$export$a30284361b3814b7(code) {
    return code !== null && (code < 0 || code === 32);
}
function $4450f34142f5dbc2$export$2c6cf65c1127992a(code) {
    return code === -2 || code === -1 || code === 32;
}
const $4450f34142f5dbc2$export$aa04114dd888a7a0 = $4450f34142f5dbc2$var$regexCheck(RegExp("\\p{P}|\\p{S}", "u"));
const $4450f34142f5dbc2$export$a0ff789c034ffdf4 = $4450f34142f5dbc2$var$regexCheck(/\s/);
/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 *   Expression.
 * @returns {(code: Code) => boolean}
 *   Check.
 */ function $4450f34142f5dbc2$var$regexCheck(regex) {
    return check;
    /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code
   *   Character code.
   * @returns {boolean}
   *   Whether the character code matches the bound regex.
   */ function check(code) {
        return code !== null && code > -1 && regex.test(String.fromCharCode(code));
    }
}
module.exports["asciiAlpha"] = $4450f34142f5dbc2$export$d65d6b62c24d5436;
module.exports["asciiAlphanumeric"] = $4450f34142f5dbc2$export$75c76db11865a9f4;
module.exports["asciiAtext"] = $4450f34142f5dbc2$export$4397998b34fe597d;
module.exports["asciiControl"] = $4450f34142f5dbc2$export$67dbf494fc8394df;
module.exports["asciiDigit"] = $4450f34142f5dbc2$export$ca8b5b1a6c320e6e;
module.exports["asciiHexDigit"] = $4450f34142f5dbc2$export$eca2752363989806;
module.exports["asciiPunctuation"] = $4450f34142f5dbc2$export$35794a7d1db99380;
module.exports["markdownLineEnding"] = $4450f34142f5dbc2$export$34a1dff1c0936953;
module.exports["markdownLineEndingOrSpace"] = $4450f34142f5dbc2$export$a30284361b3814b7;
module.exports["markdownSpace"] = $4450f34142f5dbc2$export$2c6cf65c1127992a;
module.exports["unicodePunctuation"] = $4450f34142f5dbc2$export$aa04114dd888a7a0;
module.exports["unicodeWhitespace"] = $4450f34142f5dbc2$export$a0ff789c034ffdf4;

});

parcelRegister("gaqbL", function(module, exports) {
/**
 * @import {
 *   Extension,
 *   Handles,
 *   HtmlExtension,
 *   NormalizedExtension
 * } from 'micromark-util-types'
 */ 
var $bHIRo = parcelRequire("bHIRo");

const $bc51e50a4427058d$var$hasOwnProperty = {}.hasOwnProperty;
function $bc51e50a4427058d$export$86a865d89ef3c690(extensions) {
    /** @type {NormalizedExtension} */ const all = {};
    let index = -1;
    while(++index < extensions.length)$bc51e50a4427058d$var$syntaxExtension(all, extensions[index]);
    return all;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all
 *   Extension to merge into.
 * @param {Extension} extension
 *   Extension to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $bc51e50a4427058d$var$syntaxExtension(all, extension) {
    /** @type {keyof Extension} */ let hook;
    for(hook in extension){
        const maybe = $bc51e50a4427058d$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        /** @type {Record<string, unknown>} */ const left = maybe || (all[hook] = {});
        /** @type {Record<string, unknown> | undefined} */ const right = extension[hook];
        /** @type {string} */ let code;
        if (right) for(code in right){
            if (!$bc51e50a4427058d$var$hasOwnProperty.call(left, code)) left[code] = [];
            const value = right[code];
            $bc51e50a4427058d$var$constructs(// @ts-expect-error Looks like a list.
            left[code], Array.isArray(value) ? value : value ? [
                value
            ] : []);
        }
    }
}
/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {Array<unknown>} existing
 *   List of constructs to merge into.
 * @param {Array<unknown>} list
 *   List of constructs to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $bc51e50a4427058d$var$constructs(existing, list) {
    let index = -1;
    /** @type {Array<unknown>} */ const before = [];
    while(++index < list.length)(list[index].add === 'after' ? existing : before).push(list[index]);
    (0, $bHIRo.splice)(existing, 0, 0, before);
}
function $bc51e50a4427058d$export$eaf8c406dfb0a620(htmlExtensions) {
    /** @type {HtmlExtension} */ const handlers = {};
    let index = -1;
    while(++index < htmlExtensions.length)$bc51e50a4427058d$var$htmlExtension(handlers, htmlExtensions[index]);
    return handlers;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all
 *   Extension to merge into.
 * @param {HtmlExtension} extension
 *   Extension to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $bc51e50a4427058d$var$htmlExtension(all, extension) {
    /** @type {keyof HtmlExtension} */ let hook;
    for(hook in extension){
        const maybe = $bc51e50a4427058d$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        const left = maybe || (all[hook] = {});
        const right = extension[hook];
        /** @type {keyof Handles} */ let type;
        if (right) for(type in right)// @ts-expect-error assume document vs regular handler are managed correctly.
        left[type] = right[type];
    }
}
module.exports["combineExtensions"] = $bc51e50a4427058d$export$86a865d89ef3c690;
module.exports["combineHtmlExtensions"] = $bc51e50a4427058d$export$eaf8c406dfb0a620;

});

parcelRegister("5jhd5", function(module, exports) {
/**
 * @import {Effects, State, TokenType} from 'micromark-util-types'
 */ 
var $5RE1E = parcelRequire("5RE1E");

function $3ddc13af34e30466$export$ae105c1eb063a0a2(effects, ok, type, max) {
    const limit = max ? max - 1 : Number.POSITIVE_INFINITY;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $5RE1E.markdownSpace)(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    /** @type {State} */ function prefix(code) {
        if ((0, $5RE1E.markdownSpace)(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}
module.exports["factorySpace"] = $3ddc13af34e30466$export$ae105c1eb063a0a2;

});

parcelRegister("9sEtC", function(module, exports) {
/**
 * Some of the internal operations of micromark do lots of editing
 * operations on very large arrays. This runs into problems with two
 * properties of most circa-2020 JavaScript interpreters:
 *
 *  - Array-length modifications at the high end of an array (push/pop) are
 *    expected to be common and are implemented in (amortized) time
 *    proportional to the number of elements added or removed, whereas
 *    other operations (shift/unshift and splice) are much less efficient.
 *  - Function arguments are passed on the stack, so adding tens of thousands
 *    of elements to an array with `arr.push(...newElements)` will frequently
 *    cause stack overflows. (see <https://stackoverflow.com/questions/22123769/rangeerror-maximum-call-stack-size-exceeded-why>)
 *
 * SpliceBuffers are an implementation of gap buffers, which are a
 * generalization of the "queue made of two stacks" idea. The splice buffer
 * maintains a cursor, and moving the cursor has cost proportional to the
 * distance the cursor moves, but inserting, deleting, or splicing in
 * new information at the cursor is as efficient as the push/pop operation.
 * This allows for an efficient sequence of splices (or pushes, pops, shifts,
 * or unshifts) as long such edits happen at the same part of the array or
 * generally sweep through the array from the beginning to the end.
 *
 * The interface for splice buffers also supports large numbers of inputs by
 * passing a single array argument rather passing multiple arguments on the
 * function call stack.
 *
 * @template T
 *   Item type.
 */ class $6e362063c3f21c21$export$bd596157370df26e {
    /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */ get(index) {
        if (index < 0 || index >= this.left.length + this.right.length) throw new RangeError('Cannot access index `' + index + '` in a splice buffer of size `' + (this.left.length + this.right.length) + '`');
        if (index < this.left.length) return this.left[index];
        return this.right[this.right.length - index + this.left.length - 1];
    }
    /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */ get length() {
        return this.left.length + this.right.length;
    }
    /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */ shift() {
        this.setCursor(0);
        return this.right.pop();
    }
    /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */ slice(start, end) {
        /** @type {number} */ const stop = end === null || end === undefined ? Number.POSITIVE_INFINITY : end;
        if (stop < this.left.length) return this.left.slice(start, stop);
        if (start > this.left.length) return this.right.slice(this.right.length - stop + this.left.length, this.right.length - start + this.left.length).reverse();
        return this.left.slice(start).concat(this.right.slice(this.right.length - stop + this.left.length).reverse());
    }
    /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */ splice(start, deleteCount, items) {
        /** @type {number} */ const count = deleteCount || 0;
        this.setCursor(Math.trunc(start));
        const removed = this.right.splice(this.right.length - count, Number.POSITIVE_INFINITY);
        if (items) $6e362063c3f21c21$var$chunkedPush(this.left, items);
        return removed.reverse();
    }
    /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */ pop() {
        this.setCursor(Number.POSITIVE_INFINITY);
        return this.left.pop();
    }
    /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */ push(item) {
        this.setCursor(Number.POSITIVE_INFINITY);
        this.left.push(item);
    }
    /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */ pushMany(items) {
        this.setCursor(Number.POSITIVE_INFINITY);
        $6e362063c3f21c21$var$chunkedPush(this.left, items);
    }
    /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */ unshift(item) {
        this.setCursor(0);
        this.right.push(item);
    }
    /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */ unshiftMany(items) {
        this.setCursor(0);
        $6e362063c3f21c21$var$chunkedPush(this.right, items.reverse());
    }
    /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */ setCursor(n) {
        if (n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0) return;
        if (n < this.left.length) {
            // Move cursor to the this.left
            const removed = this.left.splice(n, Number.POSITIVE_INFINITY);
            $6e362063c3f21c21$var$chunkedPush(this.right, removed.reverse());
        } else {
            // Move cursor to the this.right
            const removed = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
            $6e362063c3f21c21$var$chunkedPush(this.left, removed.reverse());
        }
    }
    /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */ constructor(initial){
        /** @type {Array<T>} */ this.left = initial ? [
            ...initial
        ] : [];
        /** @type {Array<T>} */ this.right = [];
    }
}
/**
 * Avoid stack overflow by pushing items onto the stack in segments
 *
 * @template T
 *   Item type.
 * @param {Array<T>} list
 *   List to inject into.
 * @param {ReadonlyArray<T>} right
 *   Items to inject.
 * @return {undefined}
 *   Nothing.
 */ function $6e362063c3f21c21$var$chunkedPush(list, right) {
    /** @type {number} */ let chunkStart = 0;
    if (right.length < 10000) list.push(...right);
    else while(chunkStart < right.length){
        list.push(...right.slice(chunkStart, chunkStart + 10000));
        chunkStart += 10000;
    }
}
module.exports["SpliceBuffer"] = $6e362063c3f21c21$export$bd596157370df26e;

});

parcelRegister("0A5sK", function(module, exports) {
/**
 * @import {Code} from 'micromark-util-types'
 */ 
var $5RE1E = parcelRequire("5RE1E");

function $001bfe597d896c8f$export$e3902bc0d835cad0(code) {
    if (code === null || (0, $5RE1E.markdownLineEndingOrSpace)(code) || (0, $5RE1E.unicodeWhitespace)(code)) return 1;
    if ((0, $5RE1E.unicodePunctuation)(code)) return 2;
}
module.exports["classifyCharacter"] = $001bfe597d896c8f$export$e3902bc0d835cad0;

});

parcelRegister("9CjcD", function(module, exports) {
/**
 * @import {Event, Resolver, TokenizeContext} from 'micromark-util-types'
 */ /**
 * Call all `resolveAll`s.
 *
 * @param {ReadonlyArray<{resolveAll?: Resolver | undefined}>} constructs
 *   List of constructs, optionally with `resolveAll`s.
 * @param {Array<Event>} events
 *   List of events.
 * @param {TokenizeContext} context
 *   Context used by `tokenize`.
 * @returns {Array<Event>}
 *   Changed events.
 */ function $70068eec4b46d3c3$export$3ff61ec196ff408b(constructs, events, context) {
    /** @type {Array<Resolver>} */ const called = [];
    let index = -1;
    while(++index < constructs.length){
        const resolve = constructs[index].resolveAll;
        if (resolve && !called.includes(resolve)) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}
module.exports["resolveAll"] = $70068eec4b46d3c3$export$3ff61ec196ff408b;

});

parcelRegister("lQubg", function(module, exports) {
/**
 * @import {Chunk, Event, Token} from 'micromark-util-types'
 */ 
var $bHIRo = parcelRequire("bHIRo");


var $9sEtC = parcelRequire("9sEtC");

function $fe75dd8d1498c42b$export$12949d1dd00fddf4(eventsArray) {
    /** @type {Record<string, number>} */ const jumps = {};
    let index = -1;
    /** @type {Event} */ let event;
    /** @type {number | undefined} */ let lineIndex;
    /** @type {number} */ let otherIndex;
    /** @type {Event} */ let otherEvent;
    /** @type {Array<Event>} */ let parameters;
    /** @type {Array<Event>} */ let subevents;
    /** @type {boolean | undefined} */ let more;
    const events = new (0, $9sEtC.SpliceBuffer)(eventsArray);
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events.get(index);
        // Add a hook for the GFM tasklist extension, which needs to know if text
        // is in the first content of a list item.
        if (index && event[1].type === "chunkFlow" && events.get(index - 1)[1].type === "listItemPrefix") {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === "content") break;
                if (subevents[otherIndex][1].type === "chunkText") {
                    subevents[otherIndex][1]._isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        }
        // Enter.
        if (event[0] === 'enter') {
            if (event[1].contentType) {
                Object.assign(jumps, $fe75dd8d1498c42b$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events.get(otherIndex);
                if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
                    if (otherEvent[0] === 'enter') {
                        if (lineIndex) events.get(lineIndex)[1].type = "lineEndingBlank";
                        otherEvent[1].type = "lineEnding";
                        lineIndex = otherIndex;
                    }
                } else if (otherEvent[1].type === "linePrefix" || otherEvent[1].type === "listItemIndent") ;
                else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = {
                    ...events.get(lineIndex)[1].start
                };
                // Switch container exit w/ line endings.
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                events.splice(lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    // The changes to the `events` buffer must be copied back into the eventsArray
    (0, $bHIRo.splice)(eventsArray, 0, Number.POSITIVE_INFINITY, events.slice(0));
    return !more;
}
/**
 * Tokenize embedded tokens.
 *
 * @param {SpliceBuffer<Event>} events
 *   Events.
 * @param {number} eventIndex
 *   Index.
 * @returns {Record<string, number>}
 *   Gaps.
 */ function $fe75dd8d1498c42b$var$subcontent(events, eventIndex) {
    const token = events.get(eventIndex)[1];
    const context = events.get(eventIndex)[2];
    let startPosition = eventIndex - 1;
    /** @type {Array<number>} */ const startPositions = [];
    let tokenizer = token._tokenizer;
    if (!tokenizer) {
        tokenizer = context.parser[token.contentType](token.start);
        if (token._contentTypeTextTrailing) tokenizer._contentTypeTextTrailing = true;
    }
    const childEvents = tokenizer.events;
    /** @type {Array<[number, number]>} */ const jumps = [];
    /** @type {Record<string, number>} */ const gaps = {};
    /** @type {Array<Chunk>} */ let stream;
    /** @type {Token | undefined} */ let previous;
    let index = -1;
    /** @type {Token | undefined} */ let current = token;
    let adjust = 0;
    let start = 0;
    const breaks = [
        start
    ];
    // Loop forward through the linked tokens to pass them in order to the
    // subtokenizer.
    while(current){
        // Find the position of the event for this token.
        while(events.get(++startPosition)[1] !== current);
        startPositions.push(startPosition);
        if (!current._tokenizer) {
            stream = context.sliceStream(current);
            if (!current.next) stream.push(null);
            if (previous) tokenizer.defineSkip(current.start);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        }
        // Unravel the next token.
        previous = current;
        current = current.next;
    }
    // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    current = token;
    while(++index < childEvents.length)if (// Find a void token that includes a break.
    childEvents[index][0] === 'exit' && childEvents[index - 1][0] === 'enter' && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
        start = index + 1;
        breaks.push(start);
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
        current = current.next;
    }
    // Help GC.
    tokenizer.events = [];
    // If there’s one more token (which is the cases for lines that end in an
    // EOF), that’s perfect: the last point we found starts it.
    // If there isn’t then make sure any remaining content is added to it.
    if (current) {
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
    } else breaks.pop();
    // Now splice the events from the subtokenizer into the current events,
    // moving back to front so that splice indices aren’t affected.
    index = breaks.length;
    while(index--){
        const slice = childEvents.slice(breaks[index], breaks[index + 1]);
        const start = startPositions.pop();
        jumps.push([
            start,
            start + slice.length - 1
        ]);
        events.splice(start, 2, slice);
    }
    jumps.reverse();
    index = -1;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
}
module.exports["subtokenize"] = $fe75dd8d1498c42b$export$12949d1dd00fddf4;

});

parcelRegister("723Ml", function(module, exports) {
/**
 * @import {Node, Parent} from 'unist'
 */ /**
 * @template Fn
 * @template Fallback
 * @typedef {Fn extends (value: any) => value is infer Thing ? Thing : Fallback} Predicate
 */ /**
 * @callback Check
 *   Check that an arbitrary value is a node.
 * @param {unknown} this
 *   The given context.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean}
 *   Whether this is a node and passes a test.
 *
 * @typedef {Record<string, unknown> | Node} Props
 *   Object to check for equivalence.
 *
 *   Note: `Node` is included as it is common but is not indexable.
 *
 * @typedef {Array<Props | TestFunction | string> | ReadonlyArray<Props | TestFunction | string> | Props | TestFunction | string | null | undefined} Test
 *   Check for an arbitrary node.
 *
 * @callback TestFunction
 *   Check if a node passes a test.
 * @param {unknown} this
 *   The given context.
 * @param {Node} node
 *   A node.
 * @param {number | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean | undefined | void}
 *   Whether this node passes the test.
 *
 *   Note: `void` is included until TS sees no return as `undefined`.
 */ /**
 * Check if `node` is a `Node` and whether it passes the given test.
 *
 * @param {unknown} node
 *   Thing to check, typically `Node`.
 * @param {Test} test
 *   A check for a specific node.
 * @param {number | null | undefined} index
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} parent
 *   The node’s parent.
 * @param {unknown} context
 *   Context object (`this`) to pass to `test` functions.
 * @returns {boolean}
 *   Whether `node` is a node and passes a test.
 */ const $51eba6ae1a9528d2$export$226b3eccf92c9ed9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends ReadonlyArray<string>>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition[number]}) &
   *   (<Condition extends Array<string>>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition[number]}) &
   *   (<Condition extends string>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((node?: null | undefined) => false) &
   *   ((node: unknown, test?: null | undefined, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((node: unknown, test?: Test, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => boolean)
   * )}
   */ /**
     * @param {unknown} [node]
     * @param {Test} [test]
     * @param {number | null | undefined} [index]
     * @param {Parent | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */ // eslint-disable-next-line max-params
function(node, test, index, parent, context) {
    const check = $51eba6ae1a9528d2$export$9c68d69a4c5bbcf9(test);
    if (index !== undefined && index !== null && (typeof index !== 'number' || index < 0 || index === Number.POSITIVE_INFINITY)) throw new Error('Expected positive finite index');
    if (parent !== undefined && parent !== null && (!$51eba6ae1a9528d2$export$226b3eccf92c9ed9(parent) || !parent.children)) throw new Error('Expected parent node');
    if ((parent === undefined || parent === null) !== (index === undefined || index === null)) throw new Error('Expected both parent and index');
    return $51eba6ae1a9528d2$var$looksLikeANode(node) ? check.call(context, node, index, parent) : false;
};
const $51eba6ae1a9528d2$export$9c68d69a4c5bbcf9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */ /**
     * @param {Test} [test]
     * @returns {Check}
     */ function(test) {
    if (test === null || test === undefined) return $51eba6ae1a9528d2$var$ok;
    if (typeof test === 'function') return $51eba6ae1a9528d2$var$castFactory(test);
    if (typeof test === 'object') return Array.isArray(test) ? $51eba6ae1a9528d2$var$anyFactory(test) : // narrows to `Array`.
    $51eba6ae1a9528d2$var$propertiesFactory(/** @type {Props} */ test);
    if (typeof test === 'string') return $51eba6ae1a9528d2$var$typeFactory(test);
    throw new Error('Expected function, string, or object as test');
};
/**
 * @param {Array<Props | TestFunction | string>} tests
 * @returns {Check}
 */ function $51eba6ae1a9528d2$var$anyFactory(tests) {
    /** @type {Array<Check>} */ const checks = [];
    let index = -1;
    while(++index < tests.length)checks[index] = $51eba6ae1a9528d2$export$9c68d69a4c5bbcf9(tests[index]);
    return $51eba6ae1a9528d2$var$castFactory(any);
    /**
   * @this {unknown}
   * @type {TestFunction}
   */ function any(...parameters) {
        let index = -1;
        while(++index < checks.length){
            if (checks[index].apply(this, parameters)) return true;
        }
        return false;
    }
}
/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {Check}
 */ function $51eba6ae1a9528d2$var$propertiesFactory(check) {
    const checkAsRecord = /** @type {Record<string, unknown>} */ check;
    return $51eba6ae1a9528d2$var$castFactory(all);
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function all(node) {
        const nodeAsRecord = /** @type {unknown} */ node;
        /** @type {string} */ let key;
        for(key in check){
            if (nodeAsRecord[key] !== checkAsRecord[key]) return false;
        }
        return true;
    }
}
/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {Check}
 */ function $51eba6ae1a9528d2$var$typeFactory(check) {
    return $51eba6ae1a9528d2$var$castFactory(type);
    /**
   * @param {Node} node
   */ function type(node) {
        return node && node.type === check;
    }
}
/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunction} testFunction
 * @returns {Check}
 */ function $51eba6ae1a9528d2$var$castFactory(testFunction) {
    return check;
    /**
   * @this {unknown}
   * @type {Check}
   */ function check(value, index, parent) {
        return Boolean($51eba6ae1a9528d2$var$looksLikeANode(value) && testFunction.call(this, value, typeof index === 'number' ? index : undefined, parent || undefined));
    }
}
function $51eba6ae1a9528d2$var$ok() {
    return true;
}
/**
 * @param {unknown} value
 * @returns {value is Node}
 */ function $51eba6ae1a9528d2$var$looksLikeANode(value) {
    return value !== null && typeof value === 'object' && 'type' in value;
}
module.exports["convert"] = $51eba6ae1a9528d2$export$9c68d69a4c5bbcf9;

});


//# sourceMappingURL=FullPageEditorComponent.5668fc7b.js.map
